export const languageData = {
  en: {
    pdfPreviewUnavailable: "Unable to show preview for PDF.",
    pdfPreviewHint: "If preview doesn't appear, you can still continue.",
    pdfOpenLabel: "Open PDF",
    // Supporting Document step (capture-only). English is the source of truth; other languages
    // fall back to this until the localization pipeline translates the block.
    supportingDocument: {
      headingFallback: "Supporting Document",
      subHeading: "Upload the document below. It is stored for review — nothing is extracted from it.",
      choosePlaceholder: "Choose a file (PNG, JPG or PDF)",
      continue: "Continue",
      uploading: "Uploading...",
      skip: "Skip for now",
      errorInvalidType: "Upload a PNG, JPG or PDF file.",
      errorTooLarge: "File is too large. The limit is 10MB.",
      errorRead: "Could not read that file. Please try another.",
      errorNoFile: "Please choose a file to upload.",
      showMore: "Show more",
      showLess: "Show less",
    },
    header: {
      title: "Let's verify your identity",
      subtitle: "It takes less than 2 minutes",
      havingIssue: "Having issue?"
    },
    onlyIdVerificationHeader: {
      title: "Let's verify your ID",
      subtitle: "This will only take a minute. Just keep your ID document handy",
      instruction1: "Allow Camera Access",
      instruction2: "Scan or Upload Your Document",
      instruction3: "Instant Document Verification"
    },
    subHeading: {
      subHeading1: "Capture your ID document",
      subHeading2: "Verify you're live",
      livenessHeading1: "Find a spot with good lighting",
      livenessHeading2: "Keep your face in the center "
    },
    termsAndCondition: {
      title: "I agree to consent and adhere to the following terms and conditions. ",
      privacyPolicy: "View terms",
      beginBtnText: "Begin",
      beginLiveness: "Starting liveness check",
      startLiveness: "Proceed to liveness check"
    },
    permissionDenied: {
      title: "Camera access denied!",
      subtitle: "Please ensure camera access is allowed in your browser or app settings. ",
      readMore: "Learn More",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or,Continue on Phone",
      buttonText: "Or, Continue on Phone"
    },
    desktopBrowserPermissionDenied: {
      readMore: "Learn More",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or,Continue on Phone",
      buttonText: "Or, Continue on Phone",
      title: "Camera access denied!",
      subtitle: "Check for a blocked camera icon near the browser's address bar and unblock it."
    },
    androidBrowserPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Check for a blocked camera icon near the browser's address bar and unblock it. ",
      readMore: "Learn More",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or,Continue on Phone",
      buttonText: "Or, Continue on Phone"
    },
    androidWebViewPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Camera access might be blocked by app settings. Please check your phone's App Info > Permissions > Camera and allow access. ",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or,Continue on Phone",
      buttonText: "Or, Continue on Phone"
    },
    iosBrowserPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Tap the camera or lock icon near the address bar to allow access, or check your browser settings. ",
      readMore: "Learn More",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or,Continue on Phone",
      buttonText: "Or, Continue on Phone"
    },
    iosWebViewPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Camera access might be blocked by your app settings. Go to Settings, find the app you're using, and enable Camera permission. ",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or,Continue on Phone",
      buttonText: "Or, Continue on Phone"
    },
    documentationList: {
      countryHeading: "Select country",
      docHeading: "Select your document",
      btnText: "Next",
      searchCountry: "Search Country"
    },
    frontDocCapture: {
      heading: "Place front side of ",
      headingBack: " in the rectangle",
      backupHeading: "Having Trouble? Please click the image manually",
      btnText: "Click photo",
      uploadButton: "or, Upload ID"
    },
    backDocCapture: {
      heading: "Place back side of ",
      headingBack: " in the rectangle",
      backupHeading: "Having Trouble? Please click the image manually",
      btnText: "Click photo",
      containerText: "or, upload document",
      text: "Capturing, keep still",
      skipButton: "Skip Back Side",
      uploadButton: "or, Upload ID"
    },
    failedUpload: {
      title: "File Upload Failed",
      text: "Please ensure the file is under 5MB and in .jpg, .jpeg, .png, .heic, .heif, or .pdf format",
      btn: "Try Again",
      pdfNotAllowedIndia: "PDF uploads are not allowed for India. Please upload JPEG, JPG, PNG, HEIC, or HEIF files under 5 MB.",
      pdfNotAllowedIndiaBasic: "PDF uploads are not allowed for India. Please upload JPEG, JPG, or PNG files under 5 MB."
    },
    analyzing: {
      heading: "Analyzing your ID",
      subHeading: "Please wait, this will only take a few seconds"
    },
    imageCheck: {
      heading: "Check your image",
      subHeading: "Please ensure that image is complete, clear and free of blur and glare.",
      button1: "Retake Photo",
      button2: "Good to go",
      frontHeading: "Check front image",
      backHeading: "Check back image"
    },
    errorHandler: {
      heading: "Uh oh:(",
      subHeading1: "We are experiencing some issues,but dont worry! Please try again",
      subHeading2: "If this persists,check back later",
      button: "Try again"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Please remove anything covering your face",
        button: "Try Again"
      },
      eyeClosureDetected: {
        heading: "Please keep your eyes open and look straight into the camera",
        button: "Try Again"
      },
      isMultipleFacesFound: {
        heading: "Multiple faces detected. Ensure only your face is visible in the camera.",
        button: "Try Again"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Try Again"
      },
      faceDetections: {
        heading: "Please remove the",
        button: "Try Again"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Multiple Faces Found",
          button: "Try Again"
        },
        generalMessage: {
          heading: "Please make sure you are live infront of the camera",
          button: "Try Again"
        }
      },
      faceMatch: {
        heading: "Your face does not match with the photo ID",
        button: "Try Again"
      },
      selfieError: {
        heading: "We couldn’t verify your selfie",
        subHeading1: "Just follow these tips and try again",
        instruction1: "Change your spot to a well-lit area and avoid backlight",
        instruction2: "Keep your face fully visible and centered in the frame",
        instruction3: "Remove hats, glasses, or masks for a clear view of your face",
        button: "Try Again"
      },
      activeLivenessOtpFailureMessage: {
        heading: "The OTP didn’t match. Please read the OTP clearly out loud",
        button: "Try Again"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verification failed. Please follow the instructions clearly and try again",
        button: "Try Again"
      }
    },
    unableToProcess: {
      heading: "We were unable to process your ID",
      subHeading: "Either you are uploading wrong ID or the image is not clear",
      buttonBack: "Retry Back-side of ID",
      buttonFront: "Retry Front-side of ID",
      button: "Retry",
      captureFrontSide: "Capture Front Side",
      captureBackSide: "Capture Back Side",
      changeIDButton: "Choose Another Document",
      wrongid: {
        heading: "We were unable to process this document",
        subHeading: "Please verify that you are uploading the correct document and ensure the picture quality is clear"
      },
      expiredid: {
        heading: "ID document Expired!",
        subHeading: "We cannot accept an expired ID document.Please provide a valid document"
      },
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF has too many pages",
        subHeading: "The uploaded PDF exceeds the 2-page limit. Please upload a PDF with no more than 2 pages, or a clear image of your ID."
      },
      minimumage: {
        heading: "Age Requirement Not Met!",
        subHeading: "Your age is below the minimum required age. Please ensure you meet the minimum age criteria"
      },
      mobileAttemptsDone: {
        heading: "Journey resumed on  your previous device",
        subHeading: "This session is now stopped to avoid duplication."
      },
      finished: {
        heading: "The journey has been ended",
        subHeading: "Journey is either completed or terminated"
      },
      invalid: {
        heading: "Journey Unavailable !",
        subHeading: "Either no journeyId found or journey ID is invalid"
      },
      INVALID_PAN_NUMBER: {
        heading: "Invalid PAN Number",
        subHeading: "The PAN number you entered is not valid. Please check and try again"
      },
      INVALID_PAN_STATUS: {
        heading: "Invalid PAN Status",
        subHeading: "The PAN number you entered is not valid. Please check and try again"
      },
      INVALID_DL_NUMBER: {
        heading: "Invalid Driving License Details",
        subHeading: "The driving license number or date of birth you entered is not valid. Please check and try again"
      },
      DL_NOT_FOUND: {
        heading: "Driving License Not Found",
        subHeading: "No driving license was found for the details you entered. Please check the number and date of birth and try again"
      },
      directKyc: {
        heading: "Direct KYC Journey !",
        subHeading: "This is a direct KYC journey. Frontend journey is not allowed."
      },
      DOCTYPE_FALSE: {
        heading: "Wrong Document Provided!",
        subHeading: "Please upload a valid document and ensure the image quality is good."
      },
      ONLY_FRONT: {
        heading: "Back side of the ID missing",
        subHeading: "You provided only the front side. Please flip your ID and provide the back side to proceed"
      },
      ONLY_BACK: {
        heading: "Front side of the ID missing",
        subHeading: "You provided only the back side. Please flip your ID and provide the front side to proceed"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Document Expiring Soon",
        subHeading: "Document is rejected because it will expire soon."
      },
      DOCUMENT_EXPIRED: {
        heading: "Document Expired!",
        subHeading: "Please upload a valid, unexpired document to continue."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Age Requirement Not Met!",
        subHeading: "The document indicates you don’t meet the required age. Please upload a valid document."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Unable to Verify Document!",
        subHeading: "The image quality is too poor for verification. Please retry with a clearer image."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Unable to Verify Document!",
        subHeading: "Some information couldn’t be verified. Please retry with a clearer image."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Unable to Verify Document!",
        subHeading: "Some details couldn’t be verified due to poor image quality. Please retry with a clearer image"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Unable to Verify Document!",
        subHeading: "Some details couldn’t be verified. Please retry with a clearer image."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Issue verifying your photo on the ID",
        subHeading: "We couldn’t verify your photo on the ID card. Please upload a clear photo of your original ID so we can confirm it."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Document security pattern check failed",
        subHeading: "We couldn’t verify the document’s built-in security patterns. Please upload a clear photo of the original ID to help us confirm its authenticity."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Document Liveness Check Failed",
        subHeading: "We found signs that the document may not be genuine. Please avoid using screenshots, printed copies, or displaying the ID on a screen. Upload the original ID with all features clearly visible"
      },
      SECURITY_FALSE: {
        heading: "Issue Detected!",
        subHeading: "The document couldn’t be verified. Please retry with a clearer image"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Poor Image Quality!",
        subHeading: "The image is too blurry or unclear. Please retry with a clearer image"
      },
      FACE_UNDETECTED: {
        heading: "Face Not Detected",
        subHeading: "We couldn’t find a visible face on the document. Please upload a valid ID where the face is clearly visible"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Inter-Document Comparision Failed",
        subHeading: "Inter-document comparison failed due to a mismatch in one or more key fields (Name, Date of Birth, or Face)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker Failure",
        subHeading: "An error occurred during the Digilocker journey. Please try again or use an alternative method to continue."
      },
      LINKAGE_FAILED: {
        heading: "This verification can't be completed",
        subHeading: "The captured details didn't match the records for this check."
      }
    },
    introLiveness: {
      heading: "Ready to take a selfie?",
      subHeading: "You're just one step away",
      instruction1: "Find a spot with good lighting",
      instruction2: "Keep your face clearly visible and in the center of the frame ",
      instruction3: "Remove any accessories like hats, masks, or glasses.",
      button: "Proceed"
    },
    biometricConsent: {
      consentStatement:
        "Before your selfie, we need your consent to capture and process your biometric data (face image and liveness signals) to verify your identity. This data is used only for this verification.",
      privacyPolicy: "Privacy policy",
      consentButton: "I consent — Continue",
      declineButton: "I do not consent",
      confirmTitle: "Proceed without biometric verification?",
      confirmBody:
        "Without biometric verification, we won't capture a selfie. Your verification will be completed using the information you've already provided. This choice is final for this session.",
      goBack: "Go back",
      confirmDecline: "Confirm — do not consent",
      declineComplete:
        "You chose not to proceed with biometric verification. Your verification has been completed using the details you provided."
    },
    livenessAnalyzing: {
      heading: "Analyzing your Face",
      subHeading: "Please wait, this will only take a few seconds"
    },
    phoneSession: {
      heading: "Session continued on phone",
      subheading: "Keep this window open,until finishing on the mobile",
      button: "Continue here"
    },
    continueOnPhone: {
      heading: "Continue on phone",
      subheading: "Scan the QR or copy the link below",
      subheading2: "Scan QR or open the link on your phone",
      text: "Complete the process",
      text1: "Check back here to submit",
      button: "Copy",
      copiedButton: "Copied!",
      copied: "Copied!"
    },
    SsnReview: {
      heading: "Review your details",
      subHeading: "Make any necessary changes and submit the details",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "Details are correct"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Keep your face in the circle"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Come closer to the camera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Don't be shy, step into view"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Centre your face in the frame"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too dark. Find  brighter light"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too bright. Find  optimal light"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Keep your face in the circle"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Stay still"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Turn face against light"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Hold your phone at eye level"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Move a bit away from the camera"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Position your face in the center of the circle"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Move closer and keep your face straight"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Step into view and keep your face straight"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too dark. Find brighter light"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too bright. Find optimal light"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Adjust your face to the center of circle"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Hold steady and look straight ahead"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Face the light and stay steady"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Hold your phone at eye level"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Move a bit away from the camera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perfect !"
      },
      smile1: {
        icon: "mood",
        description: "Smile please , you’re looking great!"
      },
      smile2: {
        icon: "mood",
        description: "Smile for the camera!"
      }
    },
    successful: {
      title: "Thank You!",
      text: "We have collected all necessary information to verify your identity",
      finishBtn: "Finish"
    },
    poweredBy: "Powered by",
    redirect: "Redirecting in",
    error: {
      message: "URL is expired or not valid"
    },
    sessionExpiredError: {
      heading: "Sorry, your session has timed out",
      subHeading1: "You've been inactive for a while. For security concerns, your session has automatically expired",
      subHeading2: "Please try again",
      buttonText: "Try again"
    },
    journeyExpiredError: {
      heading: "Sorry, the link has expired",
      subHeading1: "The link is no longer active. For security concerns, the links have a limited lifespan",
      subHeading2: "Please try with a new link",
      buttonText: "Try again"
    },
    cameraAccessError: {
      alert1: "Camera access was denied. Please enable camera access in your browser settings",
      alert2: "An error occurred while accessing the camera",
      alert3: "Your browser does not support camera access"
    },
    footer: {
      securedBy: "Powered By"
    },
    helpFaq: {
      title: "Help & FAQs",
      subtitle: "We are here to help you",
      cameraText: "To verify your identity, we need to capture images using your device's camera. Follow this link to learn how to grant the required permissions",
      cameraHeading: "Camera permission",
      languageText: "At the beginning of the process, you can choose your preferred language by selecting it from the dropdown menu in the top bar",
      languageHeading: "Language Selection",
      kycText: "KYC, or Know Your Customer, is a process to verify customer identities, ensuring compliance and preventing fraud and other illegal activities",
      kycHeading: "What is KYC?",
      timeText: "Usually, it takes around 60 seconds. However, this can vary depending on the countries",
      timeHeading: "How much time will it take?"
    },
    activeLiveness: {
      instruction: "Keep your face in the circle and follow the instructions",
      permissionDeniedTitle: "Camera or Microphone Access Denied",
      permissionDeniedSubtitle: "Please allow camera and microphone access in your browser settings and try again."
    },
    flipScreen: {
      heading: "Now flip your ID card",
      subHeading: "Please physically flip your ID card to show the back side, then position it in the camera frame.",
      continueButton: "Continue"
    },
    mobileDocCapture: {
      frontSide: "Front Side",
      backSide: "Back Side",
      of: "of",
      upload: "Upload",
      stillNotWorking: "Still not working?",
      clickToCapture: "Try click-to-capture",
      skip: "Skip"
    }
,
    permissionPopUp: {
      title: "Permission required",
      subtitle: "Allow access to use camera",
      decline: "Decline",
      allow: "Allow"
    },
    userDetails: {
      heading: "PAN Verification",
      subHeading: "Please fill in the details to verify",
      panLabel: "PAN Number",
      panRequired: "Please enter your PAN number",
      saveError: "Something went wrong while saving details. Please try again.",
      proceed: "Proceed"
    },
    redirectCta: {
      or: "or",
      clickHere: "click here",
      clickHereStart: "Click here",
      toContinue: "to continue"
    },
    documentCapture: {
      stillNotWorking: "Still not working?",
      clickToCaptureInstead: "Try click-to-capture instead",
      pdfNotAllowedIndia: "PDF uploads are not allowed for India. Please upload JPEG, JPG, or PNG files under 5 MB.",
      pdfNotAllowedIndiaMobile: "PDF uploads are not allowed for India. Please upload JPEG, JPG, PNG, HEIC, or HEIF files under 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png under 5 mb",
      fileFormats: "jpeg, jpg, png, pdf under 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif under 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf under 5 mb"
    },
    mobileCapture: {
      upload: "Upload",
      skip: "Skip",
      stillNotWorking: "Still not working?",
      tryClickToCapture: "Try click-to-capture instead"
    },
    UserDetails: {
      panLabel: "PAN Number",
      proceedBtn: "Proceed",
      panRequired: "Please enter your PAN number",
      saveError: "Something went wrong while saving details. Please try again."
    }
  },
  hi: {
    supportingDocument: {
      headingFallback: "सहायक दस्तावेज़",
      subHeading: "नीचे दस्तावेज़ अपलोड करें। इसे समीक्षा के लिए संग्रहीत किया जाता है — इससे कुछ भी नहीं निकाला जाता।",
      choosePlaceholder: "फ़ाइल चुनें (PNG, JPG या PDF)",
      continue: "जारी रखें",
      uploading: "अपलोड हो रहा है...",
      skip: "अभी के लिए छोड़ें",
      errorInvalidType: "PNG, JPG या PDF फ़ाइल अपलोड करें।",
      errorTooLarge: "फ़ाइल बहुत बड़ी है। सीमा 10MB है।",
      errorRead: "उस फ़ाइल को पढ़ा नहीं जा सका। कृपया दूसरी आज़माएँ।",
      errorNoFile: "कृपया अपलोड करने के लिए एक फ़ाइल चुनें।",
    },
    header: {
      title: "अपनी पहचान की पुष्टि करें",
      subtitle: "इसमें 2 मिनट से भी कम समय लगेगा",
      havingIssue: "समस्या आ रही है?"
    },
    onlyIdVerificationHeader: {
      title: "आइए आपकी पहचान की पुष्टि करें",
      subtitle: "यह केवल एक मिनट का समय लेगा। कृपया अपना पहचान पत्र तैयार रखें।",
      instruction1: "कैमरे की अनुमति दें",
      instruction2: "अपना दस्तावेज़ स्कैन या अपलोड करें",
      instruction3: "त्वरित दस्तावेज़ सत्यापन"
    },
    subHeading: {
      subHeading1: "अपना आईडी दस्तावेज़ कैप्चर करें",
      subHeading2: "सत्यापित करें कि आप लाइव हैं",
      livenessHeading1: "अच्छी रोशनी वाली जगह चुनें",
      livenessHeading2: "अपना चेहरा बीच में रखें"
    },
    termsAndCondition: {
      title: "मैं सहमत हूँ और निम्नलिखित शर्तों और नियमों का पालन करूंगा।",
      privacyPolicy: "नियम देखें",
      beginBtnText: "शुरू करें",
      beginLiveness: "लाइवनेस जांच शुरू कर रहे हैं",
      startLiveness: "लाइवनेस जांच के लिए आगे बढ़ें"
    },
    permissionDenied: {
      title: "कैमरा एक्सेस अस्वीकृत!",
      subtitle: "ब्राउज़र के एड्रेस बार के पास एक अवरुद्ध कैमरा आइकन देखें और उसे अनब्लॉक करें।",
      readMore: "अधिक जानें",
      refreshText: "एक बार कैमरा एक्सेस अनुमति मिलने के बाद, नीचे दिए गए रिफ्रेश बटन पर क्लिक करें।",
      refreshBtn: "रिफ्रेश",
      link: "या, फोन पर जारी रखें",
      buttonText: "या, फोन पर जारी रखें"
    },
    desktopBrowserPermissionDenied: {
      readMore: "अधिक जानें",
      refreshText: "एक बार कैमरा एक्सेस अनुमति मिलने के बाद, नीचे दिए गए रिफ्रेश बटन पर क्लिक करें।",
      refreshBtn: "रिफ्रेश",
      link: "या, फोन पर जारी रखें",
      buttonText: "या, फोन पर जारी रखें",
      title: "कैमरा एक्सेस अस्वीकृत!",
      subtitle: "ब्राउज़र के एड्रेस बार के पास एक अवरुद्ध कैमरा आइकन देखें और उसे अनब्लॉक करें।"
    },
    androidBrowserPermissionDenied: {
      title: "कैमरा एक्सेस अस्वीकृत!",
      subtitle: "ब्राउज़र के एड्रेस बार के पास ब्लॉक्ड कैमरा आइकन देखें और उसे अनब्लॉक करें।",
      readMore: "और जानें",
      refreshText: "एक बार कैमरा एक्सेस अनुमति देने के बाद, नीचे दिए गए रिफ्रेश बटन पर क्लिक करें।",
      refreshBtn: "रिफ्रेश करें",
      link: "या, फोन पर जारी रखें",
      buttonText: "या, फोन पर जारी रखें"
    },
    androidWebViewPermissionDenied: {
      title: "कैमरा एक्सेस अस्वीकृत!",
      subtitle: "कैमरा एक्सेस आपके ऐप सेटिंग्स द्वारा ब्लॉक हो सकता है। कृपया फोन के ऐप जानकारी > अनुमतियाँ > कैमरा में जाकर अनुमति दें।",
      refreshText: "एक बार कैमरा एक्सेस अनुमति देने के बाद, नीचे दिए गए रिफ्रेश बटन पर क्लिक करें।",
      refreshBtn: "रिफ्रेश करें",
      link: "या, फोन पर जारी रखें",
      buttonText: "या, फोन पर जारी रखें"
    },
    iosBrowserPermissionDenied: {
      title: "कैमरा एक्सेस अस्वीकृत!",
      subtitle: "एड्रेस बार के पास कैमरा या लॉक आइकन टैप करें या अपने ब्राउज़र सेटिंग्स जांचें।",
      readMore: "और जानें",
      refreshText: "एक बार कैमरा एक्सेस अनुमति देने के बाद, नीचे दिए गए रिफ्रेश बटन पर क्लिक करें।",
      refreshBtn: "रिफ्रेश करें",
      link: "या, फोन पर जारी रखें",
      buttonText: "या, फोन पर जारी रखें"
    },
    iosWebViewPermissionDenied: {
      title: "कैमरा एक्सेस अस्वीकृत!",
      subtitle: "कैमरा एक्सेस आपके ऐप सेटिंग्स द्वारा ब्लॉक हो सकता है। सेटिंग्स में जाएं, उस ऐप को खोजें जिसे आप उपयोग कर रहे हैं, और कैमरा अनुमति सक्षम करें।",
      refreshText: "एक बार कैमरा एक्सेस अनुमति देने के बाद, नीचे दिए गए रिफ्रेश बटन पर क्लिक करें।",
      refreshBtn: "रिफ्रेश करें",
      link: "या, फोन पर जारी रखें",
      buttonText: "या, फोन पर जारी रखें"
    },
    documentationList: {
      countryHeading: "देश चुनें",
      docHeading: "अपना दस्तावेज़ चुनें",
      btnText: "अगला",
      searchCountry: "देश खोजें"
    },
    frontDocCapture: {
      heading: "आईडी के सामने वाले भाग को आयत में रखें",
      backupHeading: "समस्या हो रही है? कृपया छवि को मैन्युअल रूप से क्लिक करें",
      btnText: "फोटो क्लिक करें",
      headingBack: " आयत के अंदर",
      uploadButton: "या, आईडी अपलोड करें"
    },
    backDocCapture: {
      heading: "आईडी के पीछे वाले भाग को आयत में रखें",
      backupHeading: "समस्या हो रही है? कृपया छवि को मैन्युअल रूप से क्लिक करें",
      btnText: "फोटो क्लिक करें",
      containerText: "या, दस्तावेज़ अपलोड करें",
      text: "कैप्चर कर रहे हैं, कृपया स्थिर रहें",
      skipButton: "पीछे का भाग छोड़ें",
      headingBack: " आयत के अंदर",
      uploadButton: "या, आईडी अपलोड करें"
    },
    analyzing: {
      heading: "आपकी आईडी का विश्लेषण कर रहे हैं",
      subHeading: "कृपया प्रतीक्षा करें, इसमें केवल कुछ सेकंड लगेंगे"
    },
    imageCheck: {
      heading: "अपनी छवि जांचें",
      subHeading: "कृपया सुनिश्चित करें कि छवि पूरी, स्पष्ट और धुंधली या चमकदार नहीं है।",
      button1: "फोटो फिर से लें",
      button2: "ठीक है",
      frontHeading: "सामने की छवि देखें",
      backHeading: "पिछली छवि देखें"
    },
    errorHandler: {
      heading: "अरे अरे :(",
      subHeading1: "हमें कुछ समस्याएं आ रही हैं, लेकिन चिंता न करें! कृपया पुनः प्रयास करें",
      subHeading2: "यदि समस्या बनी रहती है, तो बाद में जांचें",
      button: "फिर से प्रयास करें"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "कृपया अपने चेहरे को ढकने वाली चीज़ें हटाएँ",
        button: "पुनः प्रयास करें"
      },
      eyeClosureDetected: {
        heading: "कृपया अपनी आँखें खुली रखें और सीधे कैमरे की ओर देखें",
        button: "फिर से प्रयास करें"
      },
      isMultipleFacesFound: {
        heading: "कई चेहरे पाए गए। सुनिश्चित करें कि कैमरे में केवल आपका चेहरा दिखाई दे।",
        button: "पुनः प्रयास करें"
      },
      noFacesFound: {
        heading: "कोई चेहरा नहीं मिला। सुनिश्चित करें कि आपका चेहरा कैमरे में दिखाई दे रहा है।",
        button: "पुनः प्रयास करें"
      },
      faceDetections: {
        heading: "कृपया इसे हटाएँ",
        button: "पुनः प्रयास करें"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "एक से अधिक चेहरे पाए गए",
          button: "पुनः प्रयास करें"
        },
        generalMessage: {
          heading: "कृपया सुनिश्चित करें कि आप कैमरे के सामने लाइव हैं",
          button: "पुनः प्रयास करें"
        }
      },
      faceMatch: {
        heading: "आपका चेहरा फ़ोटो आईडी से मेल नहीं खाता",
        button: "पुनः प्रयास करें"
      },
      selfieError: {
        heading: "हम आपके सेल्फी की पुष्टि नहीं कर सके",
        subHeading1: "बस इन युक्तियों का पालन करें और फिर से प्रयास करें",
        instruction1: "किसी अच्छी रोशनी वाली जगह पर जाएं और बैकलाइट से बचें",
        instruction2: "अपना चेहरा पूरी तरह से दिखाएं और फ्रेम के केंद्र में रखें",
        instruction3: "चेहरे को स्पष्ट दिखाने के लिए टोपी, चश्मा या मास्क हटा दें",
        button: "पुनः प्रयास करें"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP मेल नहीं खाया। कृपया OTP को स्पष्ट रूप से ज़ोर से पढ़ें",
        button: "पुनः प्रयास करें"
      },
      activeLivenessGenericFailureMessage: {
        heading: "सत्यापन विफल रहा। कृपया निर्देशों का स्पष्ट रूप से पालन करें और पुनः प्रयास करें",
        button: "पुनः प्रयास करें"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF में बहुत अधिक पृष्ठ हैं",
        subHeading: "अपलोड की गई PDF 2-पृष्ठ की सीमा से अधिक है। कृपया 2 से अधिक पृष्ठों वाली PDF अपलोड न करें, या अपनी ID की स्पष्ट छवि अपलोड करें।"
      },
      heading: "हम आपकी आईडी प्रोसेस नहीं कर सके",
      subHeading: "या तो आप गलत आईडी अपलोड कर रहे हैं या इमेज स्पष्ट नहीं है",
      buttonBack: "आईडी के पिछले हिस्से को फिर से अपलोड करें",
      buttonFront: "आईडी के अग्रभाग को फिर से अपलोड करें",
      button: "पुनः प्रयास करें",
      captureFrontSide: "सामने की ओर कैप्चर करें",
      captureBackSide: "पीछे की ओर कैप्चर करें",
      changeIDButton: "दूसरा दस्तावेज़ चुनें",
      wrongid: {
        heading: "हम इस दस्तावेज़ को प्रोसेस नहीं कर सके",
        subHeading: "कृपया सुनिश्चित करें कि आप सही दस्तावेज़ अपलोड कर रहे हैं और तस्वीर की गुणवत्ता स्पष्ट है"
      },
      expiredid: {
        heading: "आईडी दस्तावेज़ समाप्त हो चुका है!",
        subHeading: "हम समाप्त आईडी दस्तावेज़ को स्वीकार नहीं कर सकते। कृपया एक वैध दस्तावेज़ प्रदान करें"
      },
      minimumage: {
        heading: "आयु आवश्यकता पूरी नहीं हुई!",
        subHeading: "आपकी आयु न्यूनतम आवश्यक आयु से कम है। कृपया सुनिश्चित करें कि आप न्यूनतम आयु मानदंड को पूरा करते हैं"
      },
      mobileAttemptsDone: {
        heading: "यात्रा आपके पिछले डिवाइस पर पुनः शुरू हुई",
        subHeading: "यह सत्र अब डुप्लिकेशन से बचने के लिए बंद कर दिया गया है"
      },
      finished: {
        heading: "यात्रा समाप्त हो गई है",
        subHeading: "यात्रा पूरी हो गई है या समाप्त कर दी गई है"
      },
      invalid: {
        heading: "यात्रा उपलब्ध नहीं है!",
        subHeading: "या तो यात्रा आईडी नहीं मिली है या यात्रा आईडी अमान्य है"
      },
      DOCTYPE_FALSE: {
        heading: "दस्तावेज़ पहचाना नहीं गया!",
        subHeading: "कृपया एक वैध दस्तावेज़ अपलोड करें और सुनिश्चित करें कि इमेज गुणवत्ता अच्छी हो।"
      },
      ONLY_FRONT: {
        heading: "आईडी का पिछला हिस्सा गायब है",
        subHeading: "आपने केवल सामने वाला हिस्सा प्रदान किया है। कृपया अपनी आईडी पलटें और आगे बढ़ने के लिए पिछला हिस्सा प्रदान करें"
      },
      ONLY_BACK: {
        heading: "आईडी का अगला हिस्सा गायब है",
        subHeading: "आपने केवल पिछला हिस्सा प्रदान किया है। कृपया अपनी आईडी पलटें और आगे बढ़ने के लिए अगला हिस्सा प्रदान करें"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "दस्तावेज़ जल्द ही समाप्त होने वाला है!",
        subHeading: "दस्तावेज़ जल्द ही समाप्त होने के कारण इसे अस्वीकृत किया गया है।"
      },
      DOCUMENT_EXPIRED: {
        heading: "दस्तावेज़ समाप्त हो गया है!",
        subHeading: "कृपया एक वैध, अविभाजित दस्तावेज़ अपलोड करें।"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "आयु आवश्यकताएँ पूरी नहीं हुई!",
        subHeading: "दस्तावेज़ से पता चलता है कि आप आवश्यक आयु सीमा से मेल नहीं खाते। कृपया एक वैध दस्तावेज़ अपलोड करें।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "इमेज गुणवत्ता बहुत खराब है। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ जानकारी सत्यापित नहीं हो सकी। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ विवरण खराब इमेज गुणवत्ता के कारण सत्यापित नहीं हो सके। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ विवरण सत्यापित नहीं हो सके। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "पहचान पत्र पर आपकी फोटो सत्यापित करने में समस्या",
        subHeading: "हम पहचान पत्र पर आपकी फोटो को सत्यापित नहीं कर सके। कृपया मूल पहचान पत्र की स्पष्ट फोटो अपलोड करें ताकि हम इसकी पुष्टि कर सकें।"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "दस्तावेज़ सुरक्षा पैटर्न जाँच विफल हुई",
        subHeading: "हम दस्तावेज़ के अंतर्निहित सुरक्षा पैटर्न को सत्यापित नहीं कर सके। कृपया मूल पहचान पत्र की स्पष्ट फोटो अपलोड करें ताकि हम इसकी प्रामाणिकता की पुष्टि कर सकें।"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "दस्तावेज़ की जीवंतता जांच विफल हुई",
        subHeading: "हमें संकेत मिले हैं कि दस्तावेज़ असली नहीं हो सकता। कृपया स्क्रीनशॉट, प्रिंट की हुई कॉपी या स्क्रीन पर दिखाई गई आईडी का उपयोग न करें। मूल आईडी अपलोड करें जिसमें सभी विशेषताएँ स्पष्ट रूप से दिखें।"
      },
      SECURITY_FALSE: {
        heading: "समस्या पाई गई!",
        subHeading: "दस्तावेज़ सत्यापित नहीं हो सका। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "खराब इमेज गुणवत्ता!",
        subHeading: "इमेज बहुत धुंधली या अस्पष्ट है। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      FACE_UNDETECTED: {
        heading: "चेहरा नहीं मिला",
        subHeading: "हम दस्तावेज़ पर कोई स्पष्ट चेहरा नहीं देख सके। कृपया ऐसा वैध पहचान पत्र अपलोड करें, जिसमें चेहरा साफ़ दिखाई दे।"
      },
      INVALID_PAN_NUMBER: {
        heading: "अमान्य PAN नंबर",
        subHeading: "आपके द्वारा दर्ज किया गया PAN नंबर मान्य नहीं है। कृपया जांचें और पुनः प्रयास करें"
      },
      INVALID_PAN_STATUS: {
        heading: "अमान्य PAN स्थिति",
        subHeading: "आपके द्वारा दर्ज किया गया PAN नंबर मान्य नहीं है। कृपया जांचें और पुनः प्रयास करें"
      },
      directKyc: {
        heading: "डायरेक्ट KYC यात्रा !",
        subHeading: "यह एक डायरेक्ट KYC यात्रा है। फ्रंटएंड यात्रा की अनुमति नहीं है।"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "दस्तावेज़ों के बीच तुलना विफल",
        subHeading: "एक या अधिक मुख्य फ़ील्ड (नाम, जन्म तिथि, या चेहरा) में बेमेल के कारण दस्तावेज़ों के बीच तुलना विफल रही"
      },
      DIGILOCKER_FAILURE: {
        heading: "डिजिलॉकर विफलता",
        subHeading: "डिजिलॉकर यात्रा के दौरान एक त्रुटि हुई। कृपया पुनः प्रयास करें या जारी रखने के लिए कोई वैकल्पिक तरीका उपयोग करें।"
      },
      LINKAGE_FAILED: {
        heading: "यह सत्यापन पूरा नहीं हो सका",
        subHeading: "इस जाँच के लिए दर्ज विवरण रिकॉर्ड से मेल नहीं खाए।"
      }
    },
    biometricConsent: {
      consentStatement: "अपनी सेल्फ़ी से पहले, आपकी पहचान सत्यापित करने के लिए हमें आपके बायोमेट्रिक डेटा (चेहरे की छवि और लाइवनेस संकेत) को कैप्चर और प्रोसेस करने की आपकी सहमति चाहिए। इस डेटा का उपयोग केवल इसी सत्यापन के लिए किया जाता है।",
      privacyPolicy: "गोपनीयता नीति",
      consentButton: "मैं सहमत हूँ — जारी रखें",
      declineButton: "मैं सहमत नहीं हूँ",
      confirmTitle: "बायोमेट्रिक सत्यापन के बिना आगे बढ़ें?",
      confirmBody: "बायोमेट्रिक सत्यापन के बिना, हम सेल्फ़ी कैप्चर नहीं करेंगे। आपका सत्यापन आपके द्वारा पहले से दी गई जानकारी का उपयोग करके पूरा किया जाएगा। यह चयन इस सत्र के लिए अंतिम है।",
      goBack: "वापस जाएँ",
      confirmDecline: "पुष्टि करें — सहमत नहीं",
      declineComplete: "आपने बायोमेट्रिक सत्यापन के साथ आगे न बढ़ने का विकल्प चुना है। आपकी पहचान का सत्यापन आपके द्वारा सबमिट किए गए दस्तावेज़ों का उपयोग करके पूरा कर लिया गया है।"
    },
    introLiveness: {
      heading: "यहाँ पुष्टि करें कि आप लाइव हैं",
      instruction1: "सुनिश्चित करें कि पर्याप्त रोशनी हो",
      instruction2: "आवश्यक अनुमतियों की अनुमति दें",
      instruction3: "बस निर्देशों का पालन करें",
      button: "आगे बढ़ें",
      subHeading: "आप बस एक कदम दूर हैं"
    },
    phoneSession: {
      heading: "फोन पर सत्र जारी है",
      subheading: "इस विंडो को खुला रखें, मोबाइल पर समाप्त होने तक",
      button: "यहाँ जारी रखें"
    },
    continueOnPhone: {
      heading: "फोन पर जारी रखें",
      subheading: "नीचे दिए गए लिंक को स्कैन करें या कॉपी करें",
      subheading2: "फोन पर लिंक खोलें या QR स्कैन करें",
      text: "प्रक्रिया पूरी करें",
      text1: "यहाँ वापस जांचें और सबमिट करें",
      button: "कॉपी करें",
      copiedButton: "कॉपी किया गया!",
      copied: "कॉपी हो गया!"
    },
    SsnReview: {
      heading: "अपने विवरण की समीक्षा करें",
      subHeading: "आवश्यक परिवर्तन करें और विवरण सबमिट करें",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "विवरण सही हैं"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "अपना चेहरा गोले में रखें"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "कैमरे के पास आएं"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "संकोच न करें, सामने आएं"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत अंधेरा है, ज़्यादा रोशनी में जाएं"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत तेज़ रोशनी है, हल्की रोशनी में जाएं"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "अपना चेहरा गोले में रखें"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर रहें"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "रोशनी की ओर चेहरा करें"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "फ़ोन को आंखों के स्तर पर रखें"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कैमरे से थोड़ा दूर हटें"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "अपना चेहरा फ्रेम के बीच में रखें"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "अपना चेहरा गोले के बीच में रखें"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "करीब आएं और अपना चेहरा सीधा रखें"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "दृश्य में आएं और अपना चेहरा सीधा रखें"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत अंधेरा। अधिक प्रकाश खोजें"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत उज्ज्वल। उपयुक्त प्रकाश खोजें"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "अपना चेहरा गोले के बीच में समायोजित करें"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर रहें और सीधे आगे देखें"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "प्रकाश की ओर चेहरा करें और स्थिर रहें"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "अपने फोन को आंखों के स्तर पर रखें"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कैमरा से थोड़ा दूर जाएं"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "परफेक्ट!"
      },
      smile1: {
        icon: "mood",
        description: "मुस्कुराएं कृपया, आप शानदार लग रहे हैं!"
      },
      smile2: {
        icon: "mood",
        description: "कैमरा के लिए मुस्कुराएं!"
      }
    },
    successful: {
      title: "धन्यवाद!",
      text: "हमने आपकी पहचान की पुष्टि के लिए सभी आवश्यक जानकारी एकत्र की है",
      finishBtn: "समाप्त करें"
    },
    poweredBy: "Powered by",
    redirect: "पुनः निर्देशित किया जा रहा है",
    error: {
      message: "यूआरएल समाप्त हो गया या मान्य नहीं है"
    },
    sessionExpiredError: {
      heading: "माफ करें, आपकी सत्र समाप्त हो गया है",
      subHeading1: "आप कुछ समय के लिए निष्क्रिय रहे हैं। सुरक्षा कारणों से, आपकी सत्र स्वचालित रूप से समाप्त हो गई है",
      subHeading2: "कृपया पुनः प्रयास करें",
      buttonText: "फिर से प्रयास करें"
    },
    journeyExpiredError: {
      heading: "माफ करें, लिंक समाप्त हो गया है",
      subHeading1: "लिंक अब सक्रिय नहीं है। सुरक्षा कारणों से, लिंक की एक सीमित अवधि होती है",
      subHeading2: "कृपया नए लिंक के साथ प्रयास करें",
      buttonText: "फिर से प्रयास करें"
    },
    cameraAccessError: {
      alert1: "कैमरा एक्सेस अस्वीकृत किया गया। कृपया अपने ब्राउज़र सेटिंग्स में कैमरा एक्सेस सक्षम करें",
      alert2: "कैमरा एक्सेस करते समय एक त्रुटि हुई",
      alert3: "आपका ब्राउज़र कैमरा एक्सेस का समर्थन नहीं करता"
    },
    footer: {
      securedBy: "Powered By"
    },
    helpFaq: {
      title: "सहायता और सामान्य प्रश्न",
      subtitle: "हम आपकी मदद के लिए यहां हैं",
      cameraText: "आपकी पहचान सत्यापित करने के लिए, हमें आपके डिवाइस के कैमरे का उपयोग करके चित्र कैप्चर करने की आवश्यकता है। आवश्यक अनुमतियाँ देने के लिए इस link पर क्लिक करें",
      cameraHeading: "कैमरा अनुमति",
      languageText: "प्रक्रिया की शुरुआत में आप टॉप बार में ड्रॉपडाउन मेनू से अपनी पसंदीदा भाषा चुन सकते हैं",
      languageHeading: "भाषा चयन",
      kycText: "केवाईसी, या अपने ग्राहक को जानें, एक प्रक्रिया है जो ग्राहक की पहचान सत्यापित करती है",
      kycHeading: "केवाईसी क्या है",
      timeText: "आमतौर पर इसमें लगभग 60 सेकंड लगते हैं",
      timeHeading: "इसमें कितना समय लगेगा"
    },
    pdfPreviewUnavailable: "PDF का पूर्वावलोकन दिखाने में असमर्थ।",
    pdfPreviewHint: "यदि पूर्वावलोकन दिखाई न दे, तो भी आप आगे बढ़ सकते हैं।",
    pdfOpenLabel: "PDF खोलें",
    failedUpload: {
      title: "फ़ाइल अपलोड विफल",
      text: "कृपया सुनिश्चित करें कि फ़ाइल 5MB से कम और .jpg, .jpeg, .png, .heic, .heif या .pdf प्रारूप में है",
      btn: "पुनः प्रयास करें",
      pdfNotAllowedIndia: "भारत के लिए PDF अपलोड की अनुमति नहीं है। कृपया 5 MB से कम की JPEG, JPG, PNG, HEIC, या HEIF फ़ाइलें अपलोड करें।",
      pdfNotAllowedIndiaBasic: "भारत के लिए PDF अपलोड की अनुमति नहीं है। कृपया 5 MB से कम की JPEG, JPG, या PNG फ़ाइलें अपलोड करें।"
    },
    livenessAnalyzing: {
      heading: "आपके चेहरे का विश्लेषण किया जा रहा है",
      subHeading: "कृपया प्रतीक्षा करें, इसमें केवल कुछ सेकंड लगेंगे"
    },
    activeLiveness: {
      instruction: "अपना चेहरा गोले में रखें और निर्देशों का पालन करें",
      permissionDeniedTitle: "कैमरा या माइक्रोफ़ोन एक्सेस अस्वीकृत",
      permissionDeniedSubtitle: "कृपया अपनी ब्राउज़र सेटिंग्स में कैमरा और माइक्रोफ़ोन एक्सेस की अनुमति दें और पुनः प्रयास करें।"
    },
    flipScreen: {
      heading: "अब अपना आईडी कार्ड पलटें",
      subHeading: "कृपया पिछला हिस्सा दिखाने के लिए अपना आईडी कार्ड भौतिक रूप से पलटें, फिर इसे कैमरा फ्रेम में रखें।",
      continueButton: "जारी रखें"
    },
    mobileDocCapture: {
      frontSide: "सामने का भाग",
      backSide: "पीछे का भाग",
      of: "का",
      upload: "अपलोड करें",
      stillNotWorking: "अब भी काम नहीं कर रहा?",
      clickToCapture: "क्लिक-टू-कैप्चर आज़माएँ",
      skip: "छोड़ें"
    }
,
    permissionPopUp: {
      title: "अनुमति आवश्यक है",
      subtitle: "कैमरा उपयोग करने के लिए पहुँच की अनुमति दें",
      decline: "अस्वीकार करें",
      allow: "अनुमति दें"
    },
    userDetails: {
      heading: "PAN सत्यापन",
      subHeading: "सत्यापन के लिए कृपया विवरण भरें",
      panLabel: "PAN नंबर",
      panRequired: "कृपया अपना PAN नंबर दर्ज करें",
      saveError: "विवरण सहेजते समय कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
      proceed: "आगे बढ़ें"
    },
    redirectCta: {
      or: "या",
      clickHere: "यहाँ क्लिक करें",
      clickHereStart: "यहाँ क्लिक करें",
      toContinue: "जारी रखने के लिए"
    },
    documentCapture: {
      stillNotWorking: "अभी भी काम नहीं कर रहा?",
      clickToCaptureInstead: "इसके बजाय क्लिक-टू-कैप्चर आज़माएँ",
      pdfNotAllowedIndia: "भारत के लिए PDF अपलोड की अनुमति नहीं है। कृपया 5 MB से कम के JPEG, JPG, या PNG फ़ाइलें अपलोड करें।",
      pdfNotAllowedIndiaMobile: "भारत के लिए PDF अपलोड की अनुमति नहीं है। कृपया 5 MB से कम के JPEG, JPG, PNG, HEIC, या HEIF फ़ाइलें अपलोड करें।",
      fileFormatsIndia: "jpeg, jpg, png 5 mb से कम",
      fileFormats: "jpeg, jpg, png, pdf 5 mb से कम",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb से कम",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb से कम"
    },
    mobileCapture: {
      upload: "अपलोड करें",
      skip: "छोड़ें",
      stillNotWorking: "फिर भी काम नहीं कर रहा?",
      tryClickToCapture: "टैप करके फोटो खींचें"
    },
    UserDetails: {
      panLabel: "PAN नंबर",
      proceedBtn: "आगे बढ़ें",
      panRequired: "कृपया अपना PAN नंबर दर्ज करें",
      saveError: "विवरण सहेजते समय कुछ गलत हो गया। कृपया पुनः प्रयास करें।"
    }
  },
  es: {
    supportingDocument: {
      headingFallback: "Documento de respaldo",
      subHeading: "Suba el documento a continuación. Se almacena para revisión — no se extrae nada de él.",
      choosePlaceholder: "Elija un archivo (PNG, JPG o PDF)",
      continue: "Continuar",
      uploading: "Subiendo...",
      skip: "Omitir por ahora",
      errorInvalidType: "Suba un archivo PNG, JPG o PDF.",
      errorTooLarge: "El archivo es demasiado grande. El límite es 10MB.",
      errorRead: "No se pudo leer ese archivo. Intente con otro.",
      errorNoFile: "Elija un archivo para subir.",
    },
    header: {
      title: "Verifiquemos tu identidad",
      subtitle: "Toma menos de 2 minutos",
      havingIssue: "¿Tienes algún problema?"
    },
    onlyIdVerificationHeader: {
      title: "Verifiquemos tu identidad",
      subtitle: "Solo tomará un minuto. Ten tu documento de identificación a mano",
      instruction1: "Permite el acceso a la cámara",
      instruction2: "Escanea o sube tu documento",
      instruction3: "Verificación instantánea"
    },
    subHeading: {
      subHeading1: "Captura tu documento de identificación",
      subHeading2: "Verifica que estás en vivo",
      livenessHeading1: "Busca un lugar con buena iluminación",
      livenessHeading2: "Mantén tu rostro en el centro"
    },
    termsAndCondition: {
      title: "Acepto consentir y adherirme a los siguientes términos y condiciones.",
      privacyPolicy: "Ver términos",
      beginBtnText: "Comenzar",
      beginLiveness: "Iniciando la verificación de presencia",
      startLiveness: "Proceder a la verificación de presencia"
    },
    permissionDenied: {
      title: "¡Acceso a la cámara denegado!",
      subtitle: "Verifique si hay un ícono de cámara bloqueada cerca de la barra de direcciones del navegador y desbloquéelo.",
      readMore: "Aprender más",
      refreshText: "Una vez que se permita el acceso a la cámara, haga clic en el botón de actualización a continuación.",
      refreshBtn: "Actualizar",
      link: "O, continúa en el teléfono",
      buttonText: "O, continúa en el teléfono"
    },
    desktopBrowserPermissionDenied: {
      readMore: "Aprender más",
      refreshText: "Una vez que se permita el acceso a la cámara, haga clic en el botón de actualización a continuación.",
      refreshBtn: "Actualizar",
      link: "O, continúa en el teléfono",
      buttonText: "O, continúa en el teléfono",
      title: "¡Acceso a la cámara denegado!",
      subtitle: "Verifique si hay un ícono de cámara bloqueada cerca de la barra de direcciones del navegador y desbloquéelo."
    },
    androidBrowserPermissionDenied: {
      title: "¡Acceso a la cámara denegado!",
      subtitle: "Verifique si hay un ícono de cámara bloqueada cerca de la barra de direcciones del navegador y desbloquéelo.",
      readMore: "Aprender más",
      refreshText: "Una vez que se permita el acceso a la cámara, haga clic en el botón de actualización a continuación.",
      refreshBtn: "Actualizar",
      link: "O, continúa en el teléfono",
      buttonText: "O, continúa en el teléfono"
    },
    androidWebViewPermissionDenied: {
      title: "¡Acceso a la cámara denegado!",
      subtitle: "El acceso a la cámara puede estar bloqueado por la configuración de la aplicación. Por favor, revise la información de la aplicación en su teléfono > Permisos > Cámara y permita el acceso.",
      refreshText: "Una vez que se permita el acceso a la cámara, haga clic en el botón de actualización a continuación.",
      refreshBtn: "Actualizar",
      link: "O, continúa en el teléfono",
      buttonText: "O, continúa en el teléfono"
    },
    iosBrowserPermissionDenied: {
      title: "¡Acceso a la cámara denegado!",
      subtitle: "Toque el ícono de cámara o candado cerca de la barra de direcciones para permitir el acceso, o revise la configuración del navegador.",
      readMore: "Aprender más",
      refreshText: "Una vez que se permita el acceso a la cámara, haga clic en el botón de actualización a continuación.",
      refreshBtn: "Actualizar",
      link: "O, continúa en el teléfono",
      buttonText: "O, continúa en el teléfono"
    },
    iosWebViewPermissionDenied: {
      title: "¡Acceso a la cámara denegado!",
      subtitle: "El acceso a la cámara puede estar bloqueado por la configuración de su aplicación. Vaya a Configuración, busque la aplicación que está usando y habilite el permiso de cámara.",
      refreshText: "Una vez que se permita el acceso a la cámara, haga clic en el botón de actualización a continuación.",
      refreshBtn: "Actualizar",
      link: "O, continúa en el teléfono",
      buttonText: "O, continúa en el teléfono"
    },
    documentationList: {
      countryHeading: "Selecciona el país",
      docHeading: "Selecciona tu documento",
      btnText: "Siguiente",
      searchCountry: "Buscar país"
    },
    frontDocCapture: {
      heading: "Coloca el lado frontal del ID en el rectángulo",
      backupHeading: "¿Problemas? Por favor, haz clic en la imagen manualmente",
      btnText: "Tomar foto",
      headingBack: " dentro del rectángulo",
      uploadButton: "o, sube tu documento"
    },
    backDocCapture: {
      heading: "Coloca el lado posterior del ID en el rectángulo",
      backupHeading: "¿Problemas? Por favor, haz clic en la imagen manualmente",
      btnText: "Tomar foto",
      containerText: "o, carga el documento",
      text: "Capturando, mantén la posición",
      skipButton: "Omitir lado posterior",
      headingBack: " dentro del rectángulo",
      uploadButton: "o, sube tu documento"
    },
    analyzing: {
      heading: "Analizando tu ID",
      subHeading: "Por favor, espera, esto solo tomará unos segundos"
    },
    imageCheck: {
      heading: "Verifica tu imagen",
      subHeading: "Asegúrate de que la imagen esté completa, clara y libre de desenfoque y reflejos.",
      button1: "Volver a tomar foto",
      button2: "Todo listo",
      frontHeading: "Ver imagen frontal",
      backHeading: "Verificar imagen posterior"
    },
    errorHandler: {
      heading: "Uh oh:(",
      subHeading1: "Estamos experimentando algunos problemas, ¡pero no te preocupes! Por favor, intenta de nuevo",
      subHeading2: "Si persiste, revisa más tarde",
      button: "Intentar de nuevo"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Por favor, retira cualquier cosa que cubra tu rostro",
        button: "Intentar de nuevo"
      },
      eyeClosureDetected: {
        heading: "Por favor, mantén los ojos abiertos y mira directamente a la cámara",
        button: "Intentar de nuevo"
      },
      isMultipleFacesFound: {
        heading: "Se detectaron múltiples rostros. Asegúrate de que solo tu rostro sea visible en la cámara.",
        button: "Intentar de nuevo"
      },
      noFacesFound: {
        heading: "No se detectó ningún rostro. Asegúrate de que tu rostro sea visible en la cámara.",
        button: "Intentar de nuevo"
      },
      faceDetections: {
        heading: "Por favor, retíralo",
        button: "Intentar de nuevo"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Se detectaron múltiples rostros",
          button: "Intentar de nuevo"
        },
        generalMessage: {
          heading: "Asegúrate de estar frente a la cámara en vivo",
          button: "Intentar de nuevo"
        }
      },
      faceMatch: {
        heading: "Tu rostro no coincide con el de la identificación",
        button: "Intentar de nuevo"
      },
      selfieError: {
        heading: "No pudimos verificar tu selfie",
        subHeading1: "Solo sigue estos consejos e inténtalo nuevamente",
        instruction1: "Busca un lugar bien iluminado y evita la luz de fondo",
        instruction2: "Asegúrate de que tu rostro esté completamente visible y centrado en el encuadre",
        instruction3: "Quítate gorros, gafas o mascarillas para una vista clara de tu rostro",
        button: "Intentar de nuevo"
      },
      activeLivenessOtpFailureMessage: {
        heading: "El OTP no coincidió. Por favor, lee el OTP en voz alta con claridad",
        button: "Intentar de nuevo"
      },
      activeLivenessGenericFailureMessage: {
        heading: "La verificación falló. Por favor, sigue las instrucciones con claridad e inténtalo de nuevo",
        button: "Intentar de nuevo"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "El PDF tiene demasiadas páginas",
        subHeading: "El PDF cargado supera el límite de 2 páginas. Suba un PDF de máximo 2 páginas o una imagen clara de su identificación."
      },
      heading: "No pudimos procesar tu ID",
      subHeading: "O estás subiendo una ID incorrecta o la imagen no está clara",
      buttonBack: "Volver a intentar el reverso de la ID",
      buttonFront: "Volver a intentar el frente de la ID",
      button: "Reintentar",
      captureFrontSide: "Capturar el anverso",
      captureBackSide: "Capturar el reverso",
      changeIDButton: "Elige otro documento",
      wrongid: {
        heading: "No pudimos procesar este documento",
        subHeading: "Por favor, asegúrate de que estás subiendo el documento correcto y que la calidad de la imagen sea clara"
      },
      expiredid: {
        heading: "¡Documento de ID Expirado!",
        subHeading: "No podemos aceptar un documento de ID expirado. Por favor proporciona un documento válido"
      },
      minimumage: {
        heading: "¡Requisito de Edad No Cumplido!",
        subHeading: "Tu edad está por debajo de la edad mínima requerida. Asegúrate de cumplir con el criterio de edad mínima"
      },
      mobileAttemptsDone: {
        heading: "El viaje se reanudó en tu dispositivo anterior",
        subHeading: "Esta sesión se detuvo para evitar duplicados"
      },
      finished: {
        heading: "El viaje ha finalizado",
        subHeading: "El viaje ha sido completado o terminado"
      },
      invalid: {
        heading: "¡Viaje no disponible!",
        subHeading: "No se encontró un journeyId o el journeyId es inválido"
      },
      DOCTYPE_FALSE: {
        heading: "¡Documento no reconocido!",
        subHeading: "Por favor sube un documento válido y asegúrate de que la calidad de la imagen sea buena."
      },
      ONLY_FRONT: {
        heading: "Falta el reverso de la identificación",
        subHeading: "Has proporcionado solo el anverso. Por favor, da la vuelta a tu identificación y proporciona el reverso para continuar"
      },
      ONLY_BACK: {
        heading: "Falta el anverso de la identificación",
        subHeading: "Has proporcionado solo el reverso. Por favor, da la vuelta a tu identificación y proporciona el anverso para continuar"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "¡El documento está por expirar!",
        subHeading: "El documento ha sido rechazado porque está a punto de expirar."
      },
      DOCUMENT_EXPIRED: {
        heading: "¡Documento expirado!",
        subHeading: "Por favor sube un documento válido y no expirado para continuar."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "¡Requisito de edad no cumplido!",
        subHeading: "El documento indica que no cumples con la edad requerida. Por favor sube un documento válido."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "¡No se puede verificar el documento!",
        subHeading: "La calidad de la imagen es demasiado baja para la verificación. Por favor intenta nuevamente con una imagen más clara."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "¡No se puede verificar el documento!",
        subHeading: "Algunos datos no pudieron ser verificados. Por favor intenta nuevamente con una imagen más clara."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "¡No se puede verificar el documento!",
        subHeading: "Algunos detalles no pudieron ser verificados debido a la mala calidad de la imagen. Por favor intenta nuevamente con una imagen más clara."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "¡No se puede verificar el documento!",
        subHeading: "Algunos detalles no pudieron ser verificados. Por favor intenta nuevamente con una imagen más clara."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problema al verificar tu foto en el documento",
        subHeading: "No pudimos verificar tu foto en la tarjeta de identificación. Por favor, sube una foto clara de tu documento original para que podamos confirmarlo."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "La verificación del patrón de seguridad del documento falló",
        subHeading: "No pudimos verificar los patrones de seguridad integrados del documento. Por favor, sube una foto clara del documento original para ayudarnos a confirmar su autenticidad."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Fallo en la verificación de vitalidad del documento",
        subHeading: "Detectamos señales de que el documento puede no ser genuino. Por favor, evita usar capturas de pantalla, copias impresas o mostrar la identificación en una pantalla. Sube el documento original con todas las características claramente visibles."
      },
      SECURITY_FALSE: {
        heading: "¡Problema detectado!",
        subHeading: "El documento no pudo ser verificado. Por favor intenta nuevamente con una imagen más clara."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "¡Calidad de imagen pobre!",
        subHeading: "La imagen está demasiado borrosa o poco clara. Por favor intenta nuevamente con una imagen más clara."
      },
      FACE_UNDETECTED: {
        heading: "Rostro no detectado",
        subHeading: "No pudimos encontrar un rostro visible en el documento. Por favor, sube una identificación válida donde el rostro sea claramente visible."
      },
      INVALID_PAN_NUMBER: {
        heading: "Número PAN inválido",
        subHeading: "El número PAN que ingresaste no es válido. Por favor, verifícalo e inténtalo de nuevo"
      },
      INVALID_PAN_STATUS: {
        heading: "Estado de PAN inválido",
        subHeading: "El número PAN que ingresaste no es válido. Por favor, verifícalo e inténtalo de nuevo"
      },
      directKyc: {
        heading: "¡Proceso KYC directo!",
        subHeading: "Este es un proceso KYC directo. No se permite el recorrido desde el frontend."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Comparación entre documentos fallida",
        subHeading: "La comparación entre documentos falló debido a una discrepancia en uno o más campos clave (nombre, fecha de nacimiento o rostro)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Fallo de Digilocker",
        subHeading: "Ocurrió un error durante el proceso de Digilocker. Por favor, inténtalo de nuevo o usa un método alternativo para continuar."
      },
      LINKAGE_FAILED: {
        heading: "No se puede completar esta verificación",
        subHeading: "Los datos capturados no coincidieron con los registros de esta comprobación."
      }
    },
    biometricConsent: {
      consentStatement: "Antes de tu selfi, necesitamos tu consentimiento para capturar y procesar tus datos biométricos (imagen facial y señales de vitalidad) para verificar tu identidad. Estos datos se utilizan únicamente para esta verificación.",
      privacyPolicy: "Política de privacidad",
      consentButton: "Doy mi consentimiento — Continuar",
      declineButton: "No doy mi consentimiento",
      confirmTitle: "¿Continuar sin verificación biométrica?",
      confirmBody: "Sin verificación biométrica, no capturaremos un selfi. Tu verificación se completará con la información que ya has proporcionado. Esta elección es definitiva para esta sesión.",
      goBack: "Volver",
      confirmDecline: "Confirmar — no doy mi consentimiento",
      declineComplete: "Has elegido no continuar con la verificación biométrica. Tu verificación de identidad se ha completado con los documentos que enviaste."
    },
    introLiveness: {
      heading: "Confirma que estás en vivo aquí",
      instruction1: "Asegúrate de que haya suficiente luz",
      instruction2: "Permite los permisos necesarios",
      instruction3: "Simplemente sigue las instrucciones",
      button: "Proceder",
      subHeading: "Estás a solo un paso"
    },
    phoneSession: {
      heading: "Sesión continuada en el teléfono",
      subheading: "Mantén esta ventana abierta, hasta terminar en el móvil",
      button: "Continuar aquí"
    },
    continueOnPhone: {
      heading: "Continúa en el teléfono",
      subheading: "Escanea el QR o copia el enlace a continuación",
      subheading2: "Escanea el QR o abre el enlace en tu teléfono",
      text: "Completa el proceso",
      text1: "Revisa aquí para enviar",
      button: "Copiar",
      copiedButton: "¡Copiado!",
      copied: "¡Copiado!"
    },
    SsnReview: {
      heading: "Revisa tus detalles",
      subHeading: "Haz los cambios necesarios y envía los detalles",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "Los detalles son correctos"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Mantén tu rostro en el círculo"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Acércate a la cámara"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "No seas tímido, ponte a la vista"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Muy oscuro. Busca más luz"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Demasiada luz. Busca luz más suave"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Mantén tu rostro en el círculo"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Quédate quieto"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Gira el rostro hacia la luz"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Sostén el teléfono a la altura de los ojos"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Aléjate un poco de la cámara"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Centra tu rostro en el marco"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Coloca tu rostro en el centro del círculo"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Acércate y mantén tu rostro recto"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Entra en la vista y mantén tu rostro recto"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Demasiado oscuro. Busca una luz más brillante"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Demasiado brillante. Busca una luz óptima"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Ajusta tu rostro al centro del círculo"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Mantente firme y mira hacia adelante"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Mira hacia la luz y mantente firme"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Sostén tu teléfono a nivel de los ojos"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Aléjate un poco de la cámara"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "¡Perfecto!"
      },
      smile1: {
        icon: "mood",
        description: "¡Sonríe, te ves genial!"
      },
      smile2: {
        icon: "mood",
        description: "¡Sonríe para la cámara!"
      }
    },
    successful: {
      title: "¡Gracias!",
      text: "Hemos recopilado toda la información necesaria para verificar tu identidad",
      finishBtn: "Finalizar"
    },
    poweredBy: "Impulsado por",
    redirect: "Redirigiendo en",
    error: {
      message: "La URL ha expirado o no es válida"
    },
    sessionExpiredError: {
      heading: "Lo siento, tu sesión ha expirado",
      subHeading1: "Has estado inactivo por un tiempo. Por razones de seguridad, tu sesión ha expirado automáticamente",
      subHeading2: "Por favor, intenta de nuevo",
      buttonText: "Intentar de nuevo"
    },
    journeyExpiredError: {
      heading: "Lo siento, el enlace ha expirado",
      subHeading1: "El enlace ya no está activo. Por razones de seguridad, los enlaces tienen una vida útil limitada",
      subHeading2: "Por favor, intenta con un nuevo enlace",
      buttonText: "Intentar de nuevo"
    },
    cameraAccessError: {
      alert1: "El acceso a la cámara fue denegado. Por favor, habilita el acceso a la cámara en la configuración de tu navegador",
      alert2: "Ocurrió un error al acceder a la cámara",
      alert3: "Tu navegador no soporta el acceso a la cámara"
    },
    footer: {
      securedBy: "Impulsado por"
    },
    helpFaq: {
      title: "Ayuda y Preguntas Frecuentes",
      subtitle: "Estamos aquí para ayudarte",
      cameraText: "Para verificar tu identidad, necesitamos capturar imágenes usando la cámara de tu dispositivo",
      cameraHeading: "Permiso de cámara",
      languageText: "Al inicio del proceso, puedes elegir tu idioma preferido seleccionándolo en el menú desplegable de la barra superior",
      languageHeading: "Selección de idioma",
      kycText: "KYC, o Conoce a tu Cliente, es un proceso para verificar las identidades de los clientes",
      kycHeading: "¿Qué es KYC?",
      timeText: "Por lo general, toma alrededor de 60 segundos",
      timeHeading: "¿Cuánto tiempo tomará?"
    },
    pdfPreviewUnavailable: "No se puede mostrar la vista previa del PDF.",
    pdfPreviewHint: "Si la vista previa no aparece, aún puedes continuar.",
    pdfOpenLabel: "Abrir PDF",
    failedUpload: {
      title: "Error al subir el archivo",
      text: "Asegúrate de que el archivo sea menor de 5MB y esté en formato .jpg, .jpeg, .png, .heic, .heif o .pdf",
      btn: "Intentar de nuevo",
      pdfNotAllowedIndia: "No se permite subir PDF para India. Sube archivos JPEG, JPG, PNG, HEIC o HEIF de menos de 5 MB.",
      pdfNotAllowedIndiaBasic: "No se permite subir PDF para India. Sube archivos JPEG, JPG o PNG de menos de 5 MB."
    },
    livenessAnalyzing: {
      heading: "Analizando tu rostro",
      subHeading: "Espera por favor, esto solo tomará unos segundos"
    },
    activeLiveness: {
      instruction: "Mantén tu rostro dentro del círculo y sigue las instrucciones",
      permissionDeniedTitle: "Acceso a la cámara o al micrófono denegado",
      permissionDeniedSubtitle: "Permite el acceso a la cámara y al micrófono en la configuración de tu navegador e inténtalo de nuevo."
    },
    flipScreen: {
      heading: "Ahora voltea tu documento de identidad",
      subHeading: "Por favor, voltea físicamente tu documento de identidad para mostrar el reverso y colócalo dentro del marco de la cámara.",
      continueButton: "Continuar"
    },
    mobileDocCapture: {
      frontSide: "Lado frontal",
      backSide: "Lado posterior",
      of: "de",
      upload: "Subir",
      stillNotWorking: "¿Aún no funciona?",
      clickToCapture: "Prueba clic para capturar",
      skip: "Omitir"
    }
,
    permissionPopUp: {
      title: "Permiso requerido",
      subtitle: "Permitir el acceso para usar la cámara",
      decline: "Rechazar",
      allow: "Permitir"
    },
    userDetails: {
      heading: "Verificación de PAN",
      subHeading: "Por favor complete los datos para verificar",
      panLabel: "Número de PAN",
      panRequired: "Por favor ingrese su número de PAN",
      saveError: "Algo salió mal al guardar los datos. Por favor inténtelo de nuevo.",
      proceed: "Continuar"
    },
    redirectCta: {
      or: "o",
      clickHere: "haga clic aquí",
      clickHereStart: "Haga clic aquí",
      toContinue: "para continuar"
    },
    documentCapture: {
      stillNotWorking: "¿Sigue sin funcionar?",
      clickToCaptureInstead: "Pruebe la captura con un clic en su lugar",
      pdfNotAllowedIndia: "No se permiten cargas de PDF para India. Por favor cargue archivos JPEG, JPG o PNG de menos de 5 MB.",
      pdfNotAllowedIndiaMobile: "No se permiten cargas de PDF para India. Por favor cargue archivos JPEG, JPG, PNG, HEIC o HEIF de menos de 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png menos de 5 mb",
      fileFormats: "jpeg, jpg, png, pdf menos de 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif menos de 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf menos de 5 mb"
    },
    mobileCapture: {
      upload: "Subir",
      skip: "Omitir",
      stillNotWorking: "¿Sigue sin funcionar?",
      tryClickToCapture: "Captura manualmente"
    },
    UserDetails: {
      panLabel: "Número PAN",
      proceedBtn: "Continuar",
      panRequired: "Por favor, ingresa tu número PAN",
      saveError: "Algo salió mal al guardar los datos. Inténtalo de nuevo."
    }
  },
  fr: {
    supportingDocument: {
      headingFallback: "Document justificatif",
      subHeading: "Téléchargez le document ci-dessous. Il est conservé pour vérification — rien n'en est extrait.",
      choosePlaceholder: "Choisir un fichier (PNG, JPG ou PDF)",
      continue: "Continuer",
      uploading: "Téléchargement...",
      skip: "Ignorer pour l'instant",
      errorInvalidType: "Téléchargez un fichier PNG, JPG ou PDF.",
      errorTooLarge: "Le fichier est trop volumineux. La limite est de 10 Mo.",
      errorRead: "Impossible de lire ce fichier. Veuillez en essayer un autre.",
      errorNoFile: "Veuillez choisir un fichier à télécharger.",
    },
    header: {
      title: "Vérifions votre identité",
      subtitle: "Cela prend moins de 2 minutes",
      havingIssue: "Un problème ?"
    },
    onlyIdVerificationHeader: {
      title: "Vérifions votre identité",
      subtitle: "Cela ne prendra qu'une minute. Ayez simplement votre pièce d'identité à portée de main",
      instruction1: "Autoriser l'accès à la caméra",
      instruction2: "Scanner ou télécharger votre document",
      instruction3: "Vérification instantanée du document"
    },
    subHeading: {
      subHeading1: "Capturez votre document d'identité",
      subHeading2: "Vérifiez que vous êtes en direct",
      livenessHeading1: "Trouvez un endroit bien éclairé",
      livenessHeading2: "Gardez votre visage au centre"
    },
    termsAndCondition: {
      title: "J'accepte de consentir et d'adhérer aux termes et conditions suivants.",
      privacyPolicy: "Voir les conditions",
      beginBtnText: "Commencer",
      beginLiveness: "Démarrage de la vérification de vivacité",
      startLiveness: "Procéder à la vérification de vivacité"
    },
    permissionDenied: {
      title: "Accès à la caméra refusé !",
      subtitle: "Vérifiez la présence d'un icône de caméra bloquée près de la barre d'adresse du navigateur et débloquez-le.",
      readMore: "En savoir plus",
      refreshText: "Une fois l'accès à la caméra autorisé, cliquez sur le bouton de rafraîchissement ci-dessous.",
      refreshBtn: "Rafraîchir",
      link: "Ou, continuez sur le téléphone",
      buttonText: "Ou, continuez sur le téléphone"
    },
    desktopBrowserPermissionDenied: {
      readMore: "En savoir plus",
      refreshText: "Une fois l'accès à la caméra autorisé, cliquez sur le bouton de rafraîchissement ci-dessous.",
      refreshBtn: "Rafraîchir",
      link: "Ou, continuez sur le téléphone",
      buttonText: "Ou, continuez sur le téléphone",
      title: "Accès à la caméra refusé !",
      subtitle: "Vérifiez la présence d'un icône de caméra bloquée près de la barre d'adresse du navigateur et débloquez-le."
    },
    androidBrowserPermissionDenied: {
      title: "Accès à la caméra refusé !",
      subtitle: "Vérifiez la présence d'une icône de caméra bloquée près de la barre d'adresse du navigateur et débloquez-la.",
      readMore: "En savoir plus",
      refreshText: "Une fois que l'accès à la caméra est autorisé, cliquez sur le bouton Actualiser ci-dessous.",
      refreshBtn: "Actualiser",
      link: "Ou, continuez sur le téléphone",
      buttonText: "Ou, continuez sur le téléphone"
    },
    androidWebViewPermissionDenied: {
      title: "Accès à la caméra refusé !",
      subtitle: "L'accès à la caméra peut être bloqué par les paramètres de l'application. Veuillez vérifier dans les infos de l'application > Autorisations > Caméra et autoriser l'accès.",
      refreshText: "Une fois que l'accès à la caméra est autorisé, cliquez sur le bouton Actualiser ci-dessous.",
      refreshBtn: "Actualiser",
      link: "Ou, continuez sur le téléphone",
      buttonText: "Ou, continuez sur le téléphone"
    },
    iosBrowserPermissionDenied: {
      title: "Accès à la caméra refusé !",
      subtitle: "Touchez l'icône de la caméra ou du cadenas près de la barre d'adresse pour autoriser l'accès, ou vérifiez les paramètres de votre navigateur.",
      readMore: "En savoir plus",
      refreshText: "Une fois que l'accès à la caméra est autorisé, cliquez sur le bouton Actualiser ci-dessous.",
      refreshBtn: "Actualiser",
      link: "Ou, continuez sur le téléphone",
      buttonText: "Ou, continuez sur le téléphone"
    },
    iosWebViewPermissionDenied: {
      title: "Accès à la caméra refusé !",
      subtitle: "L'accès à la caméra peut être bloqué par les paramètres de votre application. Allez dans Paramètres, trouvez l'application que vous utilisez et activez l'autorisation de la caméra.",
      refreshText: "Une fois que l'accès à la caméra est autorisé, cliquez sur le bouton Actualiser ci-dessous.",
      refreshBtn: "Actualiser",
      link: "Ou, continuez sur le téléphone",
      buttonText: "Ou, continuez sur le téléphone"
    },
    documentationList: {
      countryHeading: "Sélectionnez le pays",
      docHeading: "Sélectionnez votre document",
      btnText: "Suivant",
      searchCountry: "Rechercher un pays"
    },
    frontDocCapture: {
      heading: "Placez le côté avant de l'identité dans le rectangle",
      backupHeading: "Des difficultés ? Veuillez cliquer manuellement sur l'image",
      btnText: "Prendre une photo",
      headingBack: " dans le rectangle",
      uploadButton: "ou, téléverser la pièce d'identité"
    },
    backDocCapture: {
      heading: "Placez le côté arrière de l'identité dans le rectangle",
      backupHeading: "Des difficultés ? Veuillez cliquer manuellement sur l'image",
      btnText: "Prendre une photo",
      containerText: "ou, téléchargez le document",
      text: "Capture en cours, ne bougez pas",
      skipButton: "Passer le côté arrière",
      headingBack: " dans le rectangle",
      uploadButton: "ou, téléverser la pièce d'identité"
    },
    analyzing: {
      heading: "Analyse de votre identité",
      subHeading: "Veuillez patienter, cela ne prendra que quelques secondes"
    },
    imageCheck: {
      heading: "Vérifiez votre image",
      subHeading: "Veuillez vous assurer que l'image est complète, claire et sans flou ni reflet.",
      button1: "Reprendre la photo",
      button2: "C'est bon",
      frontHeading: "Vérifiez votre image avant",
      backHeading: "Vérifiez votre image arrière"
    },
    errorHandler: {
      heading: "Oh non :(",
      subHeading1: "Nous rencontrons quelques problèmes, mais ne vous inquiétez pas ! Veuillez réessayer",
      subHeading2: "Si cela persiste, revenez plus tard",
      button: "Réessayer"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Veuillez retirer tout ce qui couvre votre visage",
        button: "Réessayer"
      },
      eyeClosureDetected: {
        heading: "Veuillez garder les yeux ouverts et regarder droit dans la caméra",
        button: "Réessayer"
      },
      isMultipleFacesFound: {
        heading: "Plusieurs visages détectés. Assurez-vous que seul votre visage soit visible dans la caméra.",
        button: "Réessayer"
      },
      noFacesFound: {
        heading: "Aucun visage détecté. Assurez-vous que votre visage soit visible dans la caméra.",
        button: "Réessayer"
      },
      faceDetections: {
        heading: "Veuillez le retirer",
        button: "Réessayer"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Plusieurs visages détectés",
          button: "Réessayer"
        },
        generalMessage: {
          heading: "Veuillez vous assurer d'être bien en face de la caméra",
          button: "Réessayer"
        }
      },
      faceMatch: {
        heading: "Votre visage ne correspond pas à celui de la pièce d’identité",
        button: "Réessayer"
      },
      selfieError: {
        heading: "Nous n'avons pas pu vérifier votre selfie",
        subHeading1: "Suivez simplement ces conseils et réessayez",
        instruction1: "Placez-vous dans un endroit bien éclairé et évitez le contre-jour",
        instruction2: "Gardez votre visage bien visible et centré dans le cadre",
        instruction3: "Retirez chapeaux, lunettes ou masques pour une vue claire de votre visage",
        button: "Réessayer"
      },
      activeLivenessOtpFailureMessage: {
        heading: "Le code OTP ne correspond pas. Veuillez lire le code OTP clairement à voix haute",
        button: "Réessayer"
      },
      activeLivenessGenericFailureMessage: {
        heading: "La vérification a échoué. Veuillez suivre les instructions clairement et réessayer",
        button: "Réessayer"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "Le PDF contient trop de pages",
        subHeading: "Le PDF téléchargé dépasse la limite de 2 pages. Veuillez téléverser un PDF de 2 pages maximum ou une image nette de votre pièce d'identité."
      },
      heading: "Nous n'avons pas pu traiter votre ID",
      subHeading: "Soit vous téléchargez un mauvais document, soit l'image n'est pas claire",
      buttonBack: "Réessayer le verso de l'ID",
      buttonFront: "Réessayer le recto de l'ID",
      button: "Réessayer",
      captureFrontSide: "Capturer le recto",
      captureBackSide: "Capturer le verso",
      changeIDButton: "Choisissez un autre document",
      wrongid: {
        heading: "Nous n'avons pas pu traiter ce document",
        subHeading: "Veuillez vous assurer que vous téléchargez le bon document et que la qualité de l'image est claire"
      },
      expiredid: {
        heading: "Document ID Expiré!",
        subHeading: "Nous ne pouvons pas accepter un document d'ID expiré. Veuillez fournir un document valide"
      },
      minimumage: {
        heading: "Âge Non Conforme!",
        subHeading: "Votre âge est inférieur à l'âge minimum requis. Veuillez vous assurer que vous répondez au critère d'âge minimum"
      },
      mobileAttemptsDone: {
        heading: "Le voyage a repris sur votre appareil précédent",
        subHeading: "Cette session a été arrêtée pour éviter les doublons"
      },
      finished: {
        heading: "Le voyage est terminé",
        subHeading: "Le voyage est soit terminé, soit annulé"
      },
      invalid: {
        heading: "Voyage Indisponible!",
        subHeading: "Aucun journeyId trouvé ou le journeyId est invalide"
      },
      DOCTYPE_FALSE: {
        heading: "Document non reconnu!",
        subHeading: "Veuillez télécharger un document valide et assurez-vous que la qualité de l'image est bonne."
      },
      ONLY_FRONT: {
        heading: "Verso de la pièce d'identité manquant",
        subHeading: "Vous avez seulement fourni le recto. Veuillez retourner votre pièce d'identité et fournir le verso pour continuer"
      },
      ONLY_BACK: {
        heading: "Recto de la pièce d'identité manquant",
        subHeading: "Vous avez seulement fourni le verso. Veuillez retourner votre pièce d'identité et fournir le recto pour continuer"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Document sur le point d’expirer !",
        subHeading: "Le document a été rejeté car il est sur le point d’expirer."
      },
      DOCUMENT_EXPIRED: {
        heading: "Document Expiré!",
        subHeading: "Veuillez télécharger un document valide et non expiré pour continuer."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Âge Non Conforme!",
        subHeading: "Le document indique que vous ne répondez pas à l'âge requis. Veuillez télécharger un document valide."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Impossible de vérifier le document!",
        subHeading: "La qualité de l'image est trop basse pour la vérification. Veuillez essayer à nouveau avec une image plus claire."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Impossible de vérifier le document!",
        subHeading: "Certaines informations n'ont pas pu être vérifiées. Veuillez essayer à nouveau avec une image plus claire."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Impossible de vérifier le document!",
        subHeading: "Certains détails n'ont pas pu être vérifiés en raison de la mauvaise qualité de l'image. Veuillez essayer à nouveau avec une image plus claire."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Impossible de vérifier le document!",
        subHeading: "Certains détails n'ont pas pu être vérifiés. Veuillez essayer à nouveau avec une image plus claire."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problème de vérification de votre photo sur la pièce d'identité",
        subHeading: "Nous n'avons pas pu vérifier votre photo sur la carte d'identité. Veuillez télécharger une photo claire de votre pièce d'identité originale afin que nous puissions la confirmer."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Échec de la vérification du motif de sécurité du document",
        subHeading: "Nous n'avons pas pu vérifier les motifs de sécurité intégrés du document. Veuillez télécharger une photo claire de la pièce d'identité originale pour nous aider à confirmer son authenticité."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Échec de la vérification de vitalité du document",
        subHeading: "Nous avons détecté que le document pourrait ne pas être authentique. Veuillez éviter d’utiliser des captures d’écran, des copies imprimées ou d’afficher la pièce d’identité sur un écran. Téléversez le document original avec toutes ses caractéristiques bien visibles."
      },
      SECURITY_FALSE: {
        heading: "Problème détecté!",
        subHeading: "Le document n'a pas pu être vérifié. Veuillez essayer à nouveau avec une image plus claire."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Qualité d'image médiocre!",
        subHeading: "L'image est trop floue ou peu claire. Veuillez essayer à nouveau avec une image plus claire."
      },
      FACE_UNDETECTED: {
        heading: "Visage non détecté",
        subHeading: "Nous n'avons pas pu trouver un visage visible sur le document. Veuillez télécharger une pièce d'identité valide où le visage est clairement visible."
      },
      INVALID_PAN_NUMBER: {
        heading: "Numéro PAN invalide",
        subHeading: "Le numéro PAN que vous avez saisi n'est pas valide. Veuillez vérifier et réessayer"
      },
      INVALID_PAN_STATUS: {
        heading: "Statut PAN invalide",
        subHeading: "Le numéro PAN que vous avez saisi n'est pas valide. Veuillez vérifier et réessayer"
      },
      directKyc: {
        heading: "Parcours KYC direct !",
        subHeading: "Ceci est un parcours KYC direct. Le parcours frontend n'est pas autorisé."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Échec de la comparaison entre documents",
        subHeading: "La comparaison entre documents a échoué en raison d'une incohérence dans un ou plusieurs champs clés (nom, date de naissance ou visage)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Échec de Digilocker",
        subHeading: "Une erreur s'est produite lors du parcours Digilocker. Veuillez réessayer ou utiliser une autre méthode pour continuer."
      },
      LINKAGE_FAILED: {
        heading: "Cette vérification ne peut pas être effectuée",
        subHeading: "Les informations saisies ne correspondent pas aux enregistrements pour cette vérification."
      }
    },
    biometricConsent: {
      consentStatement: "Avant votre selfie, nous avons besoin de votre consentement pour capturer et traiter vos données biométriques (image du visage et signaux de vivacité) afin de vérifier votre identité. Ces données sont utilisées uniquement pour cette vérification.",
      privacyPolicy: "Politique de confidentialité",
      consentButton: "Je consens — Continuer",
      declineButton: "Je ne consens pas",
      confirmTitle: "Continuer sans vérification biométrique ?",
      confirmBody: "Sans vérification biométrique, nous ne prendrons pas de selfie. Votre vérification sera complétée à partir des informations que vous avez déjà fournies. Ce choix est définitif pour cette session.",
      goBack: "Retour",
      confirmDecline: "Confirmer — je ne consens pas",
      declineComplete: "Vous avez choisi de ne pas procéder à la vérification biométrique. Votre vérification d'identité a été complétée à l'aide des documents que vous avez fournis."
    },
    introLiveness: {
      heading: "Confirmez que vous êtes en direct ici",
      instruction1: "Assurez-vous qu'il y a suffisamment de lumière",
      instruction2: "Accordez les permissions nécessaires",
      instruction3: "Suivez simplement les instructions",
      button: "Continuer",
      subHeading: "Vous n'êtes plus qu'à une étape"
    },
    phoneSession: {
      heading: "Session continuée sur le téléphone",
      subheading: "Gardez cette fenêtre ouverte jusqu'à ce que vous ayez terminé sur le mobile",
      button: "Continuer ici"
    },
    continueOnPhone: {
      heading: "Continuer sur le téléphone",
      subheading: "Scannez le QR ou copiez le lien ci-dessous",
      subheading2: "Scannez le QR ou ouvrez le lien sur votre téléphone",
      text: "Complétez le processus",
      text1: "Revenez ici pour soumettre",
      button: "Copier",
      copiedButton: "Copié !",
      copied: "Copié !"
    },
    SsnReview: {
      heading: "Revoyez vos informations",
      subHeading: "Apportez les modifications nécessaires et soumettez les informations",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "Les détails sont corrects"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Gardez votre visage dans le cercle"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Rapprochez-vous de la caméra"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "N'ayez pas peur, montrez-vous"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Trop sombre. Cherchez plus de lumière"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Trop lumineux. Cherchez une lumière douce"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Gardez votre visage dans le cercle"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Restez immobile"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Tournez le visage vers la lumière"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Tenez le téléphone à hauteur des yeux"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Éloignez-vous un peu de la caméra"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Centrez votre visage dans le cadre"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Placez votre visage au centre du cercle"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Rapprochez-vous et gardez votre visage droit"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Entrez dans le cadre et gardez votre visage droit"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Trop sombre. Trouvez une lumière plus brillante"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Trop lumineux. Trouvez une lumière optimale"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Ajustez votre visage au centre du cercle"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Restez immobile et regardez droit devant"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Faites face à la lumière et restez immobile"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Tenez votre téléphone à hauteur des yeux"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Reculez un peu de la caméra"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Parfait !"
      },
      smile1: {
        icon: "mood",
        description: "Souriez s'il vous plaît, vous êtes superbe!"
      },
      smile2: {
        icon: "mood",
        description: "Souriez pour la caméra!"
      }
    },
    successful: {
      title: "Merci !",
      text: "Nous avons collecté toutes les informations nécessaires pour vérifier votre identité",
      finishBtn: "Terminer"
    },
    poweredBy: "Propulsé par",
    redirect: "Redirection dans",
    error: {
      message: "L'URL a expiré ou n'est pas valide"
    },
    sessionExpiredError: {
      heading: "Désolé, votre session a expiré",
      subHeading1: "Vous êtes inactif depuis un certain temps. Pour des raisons de sécurité, votre session a automatiquement expiré",
      subHeading2: "Veuillez réessayer",
      buttonText: "Réessayer"
    },
    journeyExpiredError: {
      heading: "Désolé, le lien a expiré",
      subHeading1: "Le lien n'est plus actif. Pour des raisons de sécurité, les liens ont une durée de vie limitée",
      subHeading2: "Veuillez essayer avec un nouveau lien",
      buttonText: "Réessayer"
    },
    cameraAccessError: {
      alert1: "L'accès à la caméra a été refusé. Veuillez activer l'accès à la caméra dans les paramètres de votre navigateur",
      alert2: "Une erreur s'est produite lors de l'accès à la caméra",
      alert3: "Votre navigateur ne prend pas en charge l'accès à la caméra"
    },
    footer: {
      securedBy: "Propulsé par"
    },
    helpFaq: {
      title: "Aide et FAQ",
      subtitle: "Nous sommes là pour vous aider",
      cameraText: "Pour vérifier votre identité, nous devons capturer des images en utilisant la caméra de votre appareil. Suivez ce link pour apprendre comment accorder les permissions nécessaires",
      cameraHeading: "Autorisation de la caméra",
      languageText: "Au début du processus, vous pouvez choisir votre langue préférée en la sélectionnant dans le menu déroulant de la barre supérieure",
      languageHeading: "Sélection de la langue",
      kycText: "KYC, ou Know Your Customer, est un processus de vérification de l'identité des clients, garantissant la conformité et prévenant la fraude et d'autres activités illégales",
      kycHeading: "Qu'est-ce que le KYC ?",
      timeText: "Généralement, cela prend environ 60 secondes. Cependant, cela peut varier selon les pays",
      timeHeading: "Combien de temps cela prendra-t-il ?"
    },
    pdfPreviewUnavailable: "Impossible d'afficher l'aperçu du PDF.",
    pdfPreviewHint: "Si l'aperçu ne s'affiche pas, vous pouvez quand même continuer.",
    pdfOpenLabel: "Ouvrir le PDF",
    failedUpload: {
      title: "Échec du téléversement du fichier",
      text: "Veuillez vous assurer que le fichier fait moins de 5 Mo et est au format .jpg, .jpeg, .png, .heic, .heif ou .pdf",
      btn: "Réessayer",
      pdfNotAllowedIndia: "Le téléversement de PDF n'est pas autorisé pour l'Inde. Téléversez des fichiers JPEG, JPG, PNG, HEIC ou HEIF de moins de 5 Mo.",
      pdfNotAllowedIndiaBasic: "Le téléversement de PDF n'est pas autorisé pour l'Inde. Téléversez des fichiers JPEG, JPG ou PNG de moins de 5 Mo."
    },
    livenessAnalyzing: {
      heading: "Analyse de votre visage",
      subHeading: "Veuillez patienter, cela ne prendra que quelques secondes"
    },
    activeLiveness: {
      instruction: "Gardez votre visage dans le cercle et suivez les instructions",
      permissionDeniedTitle: "Accès à la caméra ou au microphone refusé",
      permissionDeniedSubtitle: "Veuillez autoriser l'accès à la caméra et au microphone dans les paramètres de votre navigateur et réessayer."
    },
    flipScreen: {
      heading: "Retournez maintenant votre pièce d'identité",
      subHeading: "Veuillez retourner physiquement votre pièce d'identité pour montrer le verso, puis placez-la dans le cadre de la caméra.",
      continueButton: "Continuer"
    },
    mobileDocCapture: {
      frontSide: "Recto",
      backSide: "Verso",
      of: "de",
      upload: "Téléverser",
      stillNotWorking: "Toujours pas de fonctionnement ?",
      clickToCapture: "Essayez le clic pour capturer",
      skip: "Ignorer"
    }
,
    permissionPopUp: {
      title: "Autorisation requise",
      subtitle: "Autoriser l'accès pour utiliser la caméra",
      decline: "Refuser",
      allow: "Autoriser"
    },
    userDetails: {
      heading: "Vérification PAN",
      subHeading: "Veuillez remplir les détails pour vérifier",
      panLabel: "Numéro PAN",
      panRequired: "Veuillez saisir votre numéro PAN",
      saveError: "Une erreur s'est produite lors de l'enregistrement des détails. Veuillez réessayer.",
      proceed: "Continuer"
    },
    redirectCta: {
      or: "ou",
      clickHere: "cliquez ici",
      clickHereStart: "Cliquez ici",
      toContinue: "pour continuer"
    },
    documentCapture: {
      stillNotWorking: "Toujours pas de fonctionnement ?",
      clickToCaptureInstead: "Essayez plutôt la capture par clic",
      pdfNotAllowedIndia: "Les téléchargements PDF ne sont pas autorisés pour l'Inde. Veuillez télécharger des fichiers JPEG, JPG ou PNG de moins de 5 MB.",
      pdfNotAllowedIndiaMobile: "Les téléchargements PDF ne sont pas autorisés pour l'Inde. Veuillez télécharger des fichiers JPEG, JPG, PNG, HEIC ou HEIF de moins de 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png moins de 5 mb",
      fileFormats: "jpeg, jpg, png, pdf moins de 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif moins de 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf moins de 5 mb"
    },
    mobileCapture: {
      upload: "Téléverser",
      skip: "Passer",
      stillNotWorking: "Toujours pas ?",
      tryClickToCapture: "Capturez manuellement"
    },
    UserDetails: {
      panLabel: "Numéro PAN",
      proceedBtn: "Continuer",
      panRequired: "Veuillez saisir votre numéro PAN",
      saveError: "Une erreur s'est produite lors de l'enregistrement. Veuillez réessayer."
    }
  },
  ru: {
    supportingDocument: {
      headingFallback: "Подтверждающий документ",
      subHeading: "Загрузите документ ниже. Он сохраняется для проверки — из него ничего не извлекается.",
      choosePlaceholder: "Выберите файл (PNG, JPG или PDF)",
      continue: "Продолжить",
      uploading: "Загрузка...",
      skip: "Пропустить пока",
      errorInvalidType: "Загрузите файл PNG, JPG или PDF.",
      errorTooLarge: "Файл слишком большой. Ограничение — 10 МБ.",
      errorRead: "Не удалось прочитать этот файл. Попробуйте другой.",
      errorNoFile: "Выберите файл для загрузки.",
    },
    header: {
      title: "Пожалуйста, подтвердите вашу личность",
      subtitle: "Это займет менее 2 минут",
      havingIssue: "Возникли проблемы?"
    },
    onlyIdVerificationHeader: {
      title: "Давайте проверим ваш документ",
      subtitle: "Это займет менее 2 минут. Просто подготовьте ваш документ",
      instruction1: "Разрешите доступ к камере",
      instruction2: "Сканируйте или загрузите документ",
      instruction3: "Мгновенная проверка документа"
    },
    subHeading: {
      subHeading1: "Сфотографируйте ваш документ",
      subHeading2: "Подтвердите, что вы живы",
      livenessHeading1: "Найдите место с хорошим освещением",
      livenessHeading2: "Держите лицо по центру"
    },
    termsAndCondition: {
      title: "Я согласен с условиями и правилами",
      privacyPolicy: "Просмотреть условия",
      beginBtnText: "Начать",
      beginLiveness: "Начало проверки",
      startLiveness: "Перейти к проверке"
    },
    permissionDenied: {
      title: "Доступ к камере отклонен!",
      subtitle: "Проверьте наличие заблокированного значка камеры рядом с адресной строкой браузера и разблокируйте его.",
      readMore: "Узнать больше",
      refreshText: "Как только доступ к камере будет разрешен, нажмите кнопку обновления ниже.",
      refreshBtn: "Обновить",
      link: "Или продолжите на телефоне",
      buttonText: "Или продолжите на телефоне"
    },
    desktopBrowserPermissionDenied: {
      readMore: "Узнать больше",
      refreshText: "Как только доступ к камере будет разрешен, нажмите кнопку обновления ниже.",
      refreshBtn: "Обновить",
      link: "Или продолжите на телефоне",
      buttonText: "Или продолжите на телефоне",
      title: "Доступ к камере отклонен!",
      subtitle: "Проверьте наличие заблокированного значка камеры рядом с адресной строкой браузера и разблокируйте его."
    },
    androidBrowserPermissionDenied: {
      title: "Доступ к камере отклонен!",
      subtitle: "Проверьте наличие заблокированного значка камеры рядом с адресной строкой браузера и разблокируйте его.",
      readMore: "Узнать больше",
      refreshText: "После предоставления доступа к камере нажмите кнопку обновления ниже.",
      refreshBtn: "Обновить",
      link: "Или продолжите на телефоне",
      buttonText: "Или продолжите на телефоне"
    },
    androidWebViewPermissionDenied: {
      title: "Доступ к камере отклонен!",
      subtitle: "Доступ к камере может быть заблокирован настройками приложения. Пожалуйста, проверьте Информацию о приложении > Разрешения > Камера и разрешите доступ.",
      refreshText: "После предоставления доступа к камере нажмите кнопку обновления ниже.",
      refreshBtn: "Обновить",
      link: "Или продолжите на телефоне",
      buttonText: "Или продолжите на телефоне"
    },
    iosBrowserPermissionDenied: {
      title: "Доступ к камере отклонен!",
      subtitle: "Нажмите на значок камеры или замка рядом с адресной строкой, чтобы разрешить доступ, или проверьте настройки браузера.",
      readMore: "Узнать больше",
      refreshText: "После предоставления доступа к камере нажмите кнопку обновления ниже.",
      refreshBtn: "Обновить",
      link: "Или продолжите на телефоне",
      buttonText: "Или продолжите на телефоне"
    },
    iosWebViewPermissionDenied: {
      title: "Доступ к камере отклонен!",
      subtitle: "Доступ к камере может быть заблокирован настройками приложения. Перейдите в Настройки, найдите используемое приложение и включите разрешение для камеры.",
      refreshText: "После предоставления доступа к камере нажмите кнопку обновления ниже.",
      refreshBtn: "Обновить",
      link: "Или продолжите на телефоне",
      buttonText: "Или продолжите на телефоне"
    },
    documentationList: {
      countryHeading: "Выберите страну",
      docHeading: "Выберите ваш документ",
      btnText: "Далее",
      searchCountry: "Поиск страны"
    },
    frontDocCapture: {
      heading: "Поместите лицевую сторону документа в прямоугольник",
      backupHeading: "Есть проблемы? Пожалуйста, сфотографируйте вручную",
      btnText: "Сделать фото",
      headingBack: " в прямоугольнике",
      uploadButton: "или загрузите удостоверение"
    },
    backDocCapture: {
      heading: "Поместите обратную сторону документа в прямоугольник",
      backupHeading: "Есть проблемы? Пожалуйста, сфотографируйте вручную",
      btnText: "Сделать фото",
      containerText: "или загрузите документ",
      text: "Съемка, оставайтесь неподвижным",
      skipButton: "Пропустить обратную сторону",
      headingBack: " в прямоугольнике",
      uploadButton: "или загрузите удостоверение"
    },
    analyzing: {
      heading: "Анализируем ваш документ",
      subHeading: "Пожалуйста, подождите, это займет всего несколько секунд"
    },
    imageCheck: {
      heading: "Проверьте ваше изображение",
      subHeading: "Пожалуйста, убедитесь, что изображение полное, четкое и без размытостей и бликов.",
      button1: "Переснять фото",
      button2: "Хорошо",
      frontHeading: "Проверьте изображение спереди",
      backHeading: "Проверьте изображение"
    },
    errorHandler: {
      heading: "Упс:(",
      subHeading1: "Возникли проблемы, но не переживайте! Пожалуйста, попробуйте снова",
      subHeading2: "Если проблема не исчезнет, попробуйте позже",
      button: "Попробовать снова"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Пожалуйста, уберите всё, что закрывает ваше лицо",
        button: "Попробовать снова"
      },
      eyeClosureDetected: {
        heading: "Пожалуйста, держите глаза открытыми и смотрите прямо в камеру",
        button: "Попробовать снова"
      },
      isMultipleFacesFound: {
        heading: "Обнаружено несколько лиц. Убедитесь, что в камере видно только ваше лицо.",
        button: "Попробовать снова"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Попробовать снова"
      },
      faceDetections: {
        heading: "Пожалуйста, уберите это",
        button: "Попробовать снова"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Обнаружено несколько лиц",
          button: "Попробовать снова"
        },
        generalMessage: {
          heading: "Убедитесь, что вы находитесь перед камерой в реальном времени",
          button: "Попробовать снова"
        }
      },
      faceMatch: {
        heading: "Ваше лицо не совпадает с фотографией в удостоверении личности",
        button: "Попробовать снова"
      },
      selfieError: {
        heading: "Мы не смогли проверить ваше селфи",
        subHeading1: "Просто следуйте этим советам и попробуйте снова",
        instruction1: "Выберите место с хорошим освещением и избегайте подсветки сзади",
        instruction2: "Держите лицо полностью видимым и по центру кадра",
        instruction3: "Снимите головные уборы, очки или маски для четкого обзора лица",
        button: "Попробовать снова"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP не совпал. Пожалуйста, чётко произнесите OTP вслух",
        button: "Попробовать снова"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Проверка не удалась. Пожалуйста, чётко следуйте инструкциям и попробуйте снова",
        button: "Попробовать снова"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "В PDF слишком много страниц",
        subHeading: "Загруженный PDF превышает лимит в 2 страницы. Загрузите PDF не более 2 страниц или чёткое изображение вашего удостоверения."
      },
      heading: "Мы не смогли обработать ваш ID",
      subHeading: "Либо вы загружаете неверный документ, либо изображение нечеткое",
      buttonBack: "Повторить загрузку задней стороны ID",
      buttonFront: "Повторить загрузку передней стороны ID",
      button: "Попробовать снова",
      captureFrontSide: "Снять лицевую сторону",
      captureBackSide: "Снять обратную сторону",
      changeIDButton: "Выберите другой документ",
      wrongid: {
        heading: "Мы не смогли обработать этот документ",
        subHeading: "Пожалуйста, убедитесь, что вы загружаете правильный документ и что качество изображения четкое"
      },
      expiredid: {
        heading: "Документ ID истек!",
        subHeading: "Мы не можем принять истекший документ ID. Пожалуйста, предоставьте действительный документ"
      },
      minimumage: {
        heading: "Возрастные требования не выполнены!",
        subHeading: "Ваш возраст ниже минимального требуемого возраста. Пожалуйста, убедитесь, что вы соответствуете минимальным возрастным критериям"
      },
      mobileAttemptsDone: {
        heading: "Путешествие продолжилось на вашем предыдущем устройстве",
        subHeading: "Эта сессия была остановлена, чтобы избежать дублирования"
      },
      finished: {
        heading: "Путешествие завершено",
        subHeading: "Путешествие завершено или отменено"
      },
      invalid: {
        heading: "Путешествие недоступно!",
        subHeading: "Не найден journeyId или journeyId недействителен"
      },
      DOCTYPE_FALSE: {
        heading: "Документ не распознан!",
        subHeading: "Пожалуйста, загрузите действительный документ и убедитесь, что качество изображения хорошее."
      },
      ONLY_FRONT: {
        heading: "Отсутствует обратная сторона удостоверения",
        subHeading: "Вы загрузили только лицевую сторону. Пожалуйста, переверните удостоверение и загрузите обратную сторону для продолжения"
      },
      ONLY_BACK: {
        heading: "Отсутствует лицевая сторона удостоверения",
        subHeading: "Вы загрузили только обратную сторону. Пожалуйста, переверните удостоверение и загрузите лицевую сторону для продолжения"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Документ скоро истекает!",
        subHeading: "Документ отклонён, так как срок его действия скоро истекает."
      },
      DOCUMENT_EXPIRED: {
        heading: "Документ истек!",
        subHeading: "Пожалуйста, загрузите действительный документ, не истекший."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Возрастные требования не выполнены!",
        subHeading: "Документ указывает, что вы не соответствуете возрастным требованиям. Пожалуйста, загрузите действительный документ."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Не удалось проверить документ!",
        subHeading: "Качество изображения слишком низкое для проверки. Пожалуйста, попробуйте снова с более четким изображением."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Не удалось проверить документ!",
        subHeading: "Некоторые данные не были проверены. Пожалуйста, попробуйте снова с более четким изображением."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Не удалось проверить документ!",
        subHeading: "Некоторые детали не были проверены из-за плохого качества изображения. Пожалуйста, попробуйте снова с более четким изображением."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Не удалось проверить документ!",
        subHeading: "Некоторые детали не были проверены. Пожалуйста, попробуйте снова с более четким изображением."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Проблема с проверкой вашей фотографии на удостоверении",
        subHeading: "Мы не смогли проверить вашу фотографию на удостоверении личности. Пожалуйста, загрузите чёткую фотографию оригинального документа, чтобы мы могли подтвердить его подлинность."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Не удалось проверить защитный шаблон документа",
        subHeading: "Мы не смогли проверить встроенные защитные шаблоны документа. Пожалуйста, загрузите чёткую фотографию оригинального удостоверения личности, чтобы мы могли подтвердить его подлинность."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Проверка подлинности документа не пройдена",
        subHeading: "Мы обнаружили признаки того, что документ может быть недействительным. Пожалуйста, не используйте скриншоты, распечатанные копии или отображение удостоверения на экране. Загрузите оригинал документа с чётко видимыми всеми элементами."
      },
      SECURITY_FALSE: {
        heading: "Обнаружена проблема!",
        subHeading: "Документ не был проверен. Пожалуйста, попробуйте снова с более четким изображением."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Плохое качество изображения!",
        subHeading: "Изображение слишком размытое или нечеткое. Пожалуйста, попробуйте снова с более четким изображением."
      },
      FACE_UNDETECTED: {
        heading: "Лицо не обнаружено",
        subHeading: "Мы не смогли найти видимое лицо на документе. Пожалуйста, загрузите действительное удостоверение личности, на котором лицо ясно видно."
      },
      INVALID_PAN_NUMBER: {
        heading: "Недействительный номер PAN",
        subHeading: "Введённый вами номер PAN недействителен. Пожалуйста, проверьте и попробуйте снова"
      },
      INVALID_PAN_STATUS: {
        heading: "Недействительный статус PAN",
        subHeading: "Введённый вами номер PAN недействителен. Пожалуйста, проверьте и попробуйте снова"
      },
      directKyc: {
        heading: "Прямой путь KYC !",
        subHeading: "Это прямой путь KYC. Прохождение через интерфейс не разрешено."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Сравнение документов не удалось",
        subHeading: "Сравнение документов не удалось из-за несоответствия в одном или нескольких ключевых полях (имя, дата рождения или лицо)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Сбой Digilocker",
        subHeading: "Произошла ошибка во время прохождения Digilocker. Пожалуйста, попробуйте снова или используйте другой способ для продолжения."
      },
      LINKAGE_FAILED: {
        heading: "Эту проверку не удалось завершить",
        subHeading: "Полученные данные не совпали с записями для этой проверки."
      }
    },
    biometricConsent: {
      consentStatement: "Перед селфи нам необходимо ваше согласие на сбор и обработку ваших биометрических данных (изображение лица и сигналы живости) для подтверждения вашей личности. Эти данные используются только для этой проверки.",
      privacyPolicy: "Политика конфиденциальности",
      consentButton: "Я согласен(на) — Продолжить",
      declineButton: "Я не согласен(на)",
      confirmTitle: "Продолжить без биометрической проверки?",
      confirmBody: "Без биометрической проверки мы не будем делать селфи. Ваша проверка будет завершена на основе уже предоставленной вами информации. Этот выбор окончателен для данной сессии.",
      goBack: "Назад",
      confirmDecline: "Подтвердить — не согласен(на)",
      declineComplete: "Вы решили не проходить биометрическую проверку. Проверка вашей личности завершена на основе предоставленных вами документов."
    },
    introLiveness: {
      heading: "Подтвердите, что вы живы",
      instruction1: "Убедитесь, что есть достаточное освещение",
      instruction2: "Разрешите необходимые разрешения",
      instruction3: "Следуйте инструкциям",
      button: "Продолжить",
      subHeading: "Вам остался всего один шаг"
    },
    phoneSession: {
      heading: "Сессия продолжена на телефоне",
      subheading: "Оставьте это окно открытым, пока не завершите на мобильном",
      button: "Продолжить здесь"
    },
    continueOnPhone: {
      heading: "Продолжите на телефоне",
      subheading: "Сканируйте QR-код или скопируйте ссылку ниже",
      subheading2: "Сканируйте QR-код или откройте ссылку на вашем телефоне",
      text: "Завершите процесс",
      text1: "Вернитесь сюда для отправки",
      button: "Скопировать",
      copiedButton: "Скопировано!",
      copied: "Скопировано!"
    },
    SsnReview: {
      heading: "Проверьте ваши данные",
      subHeading: "Внесите необходимые изменения и отправьте данные",
      field1: "DL",
      field2: "EXP",
      field3: "DOB",
      field4: "Class",
      field5: "RSTR",
      field6: "Country",
      field7: "Address",
      button: "Данные верны",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Держите лицо в круге"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Подойдите ближе к камере"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Не стесняйтесь, покажитесь"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Слишком темно. Найдите больше света"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Слишком ярко. Найдите мягкий свет"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Держите лицо в круге"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Не двигайтесь"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Поверните лицо к свету"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Держите телефон на уровне глаз"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Отодвиньтесь немного от камеры"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Расположите лицо по центру кадра"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Расположите лицо в центре круга"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Подойдите ближе и держите лицо прямо"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Войдите в кадр и держите лицо прямо"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Слишком темно. Найдите более яркий свет"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Слишком ярко. Найдите оптимальное освещение"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Отрегулируйте положение лица к центру круга"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Держитесь ровно и смотрите прямо"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Повернитесь к свету и не двигайтесь"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Держите телефон на уровне глаз"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Отодвиньтесь немного от камеры"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Отлично!"
      },
      smile1: {
        icon: "mood",
        description: "Улыбнитесь, вы выглядите отлично!"
      },
      smile2: {
        icon: "mood",
        description: "Улыбнитесь для камеры!"
      }
    },
    successful: {
      title: "Спасибо!",
      text: "Мы собрали всю необходимую информацию для подтверждения вашей личности",
      finishBtn: "Завершить"
    },
    poweredBy: "Powered by",
    redirect: "Перенаправление через",
    error: {
      message: "URL истек или недействителен"
    },
    sessionExpiredError: {
      heading: "Извините, ваша сессия истекла",
      subHeading1: "Вы не были активны некоторое время. По соображениям безопасности ваша сессия автоматически истекла",
      subHeading2: "Пожалуйста, попробуйте снова",
      buttonText: "Попробовать снова"
    },
    journeyExpiredError: {
      heading: "Извините, ссылка истекла",
      subHeading1: "Ссылка больше не активна. По соображениям безопасности ссылки имеют ограниченный срок действия",
      subHeading2: "Пожалуйста, попробуйте с новой ссылкой",
      buttonText: "Попробовать снова"
    },
    cameraAccessError: {
      alert1: "Доступ к камере был отклонен. Пожалуйста, включите доступ к камере в настройках браузера",
      alert2: "Произошла ошибка при доступе к камере",
      alert3: "Ваш браузер не поддерживает доступ к камере"
    },
    footer: {
      securedBy: "Powered By"
    },
    helpFaq: {
      title: "Помощь и Часто Задаваемые Вопросы",
      subtitle: "Мы здесь, чтобы помочь вам",
      cameraText: "Чтобы подтвердить вашу личность, нам нужно сделать снимки с помощью камеры вашего устройства. Перейдите по этому link, чтобы узнать, как предоставить необходимые разрешения",
      cameraHeading: "Разрешение на использование камеры",
      languageText: "В начале процесса вы можете выбрать предпочитаемый язык, выбрав его из выпадающего меню в верхней панели",
      languageHeading: "Выбор языка",
      kycText: "KYC, или Знай своего клиента, это процесс проверки личности клиентов для обеспечения соответствия и предотвращения мошенничества и других незаконных действий",
      kycHeading: "Что такое KYC?",
      timeText: "Обычно это занимает около 60 секунд. Однако это может варьироваться в зависимости от страны",
      timeHeading: "Сколько времени это займет?"
    },
    pdfPreviewUnavailable: "Не удаётся показать предпросмотр PDF.",
    pdfPreviewHint: "Если предпросмотр не появляется, вы всё равно можете продолжить.",
    pdfOpenLabel: "Открыть PDF",
    failedUpload: {
      title: "Не удалось загрузить файл",
      text: "Убедитесь, что файл меньше 5 МБ и в формате .jpg, .jpeg, .png, .heic, .heif или .pdf",
      btn: "Попробовать снова",
      pdfNotAllowedIndia: "Загрузка PDF для Индии не разрешена. Загрузите файлы JPEG, JPG, PNG, HEIC или HEIF размером менее 5 МБ.",
      pdfNotAllowedIndiaBasic: "Загрузка PDF для Индии не разрешена. Загрузите файлы JPEG, JPG или PNG размером менее 5 МБ."
    },
    livenessAnalyzing: {
      heading: "Анализ вашего лица",
      subHeading: "Пожалуйста, подождите, это займёт всего несколько секунд"
    },
    activeLiveness: {
      instruction: "Держите лицо в круге и следуйте инструкциям",
      permissionDeniedTitle: "Доступ к камере или микрофону запрещён",
      permissionDeniedSubtitle: "Пожалуйста, разрешите доступ к камере и микрофону в настройках браузера и попробуйте снова."
    },
    flipScreen: {
      heading: "Теперь переверните удостоверение личности",
      subHeading: "Пожалуйста, физически переверните удостоверение личности, чтобы показать обратную сторону, затем поместите его в рамку камеры.",
      continueButton: "Продолжить"
    },
    mobileDocCapture: {
      frontSide: "Лицевая сторона",
      backSide: "Обратная сторона",
      of: "документа",
      upload: "Загрузить",
      stillNotWorking: "Всё ещё не работает?",
      clickToCapture: "Попробуйте съёмку по клику",
      skip: "Пропустить"
    }
,
    permissionPopUp: {
      title: "Требуется разрешение",
      subtitle: "Разрешите доступ для использования камеры",
      decline: "Отклонить",
      allow: "Разрешить"
    },
    userDetails: {
      heading: "Проверка PAN",
      subHeading: "Пожалуйста, заполните данные для проверки",
      panLabel: "Номер PAN",
      panRequired: "Пожалуйста, введите ваш номер PAN",
      saveError: "При сохранении данных произошла ошибка. Пожалуйста, попробуйте снова.",
      proceed: "Продолжить"
    },
    redirectCta: {
      or: "или",
      clickHere: "нажмите здесь",
      clickHereStart: "Нажмите здесь",
      toContinue: "чтобы продолжить"
    },
    documentCapture: {
      stillNotWorking: "Всё ещё не работает?",
      clickToCaptureInstead: "Попробуйте захват по клику",
      pdfNotAllowedIndia: "Загрузка PDF не разрешена для Индии. Пожалуйста, загрузите файлы JPEG, JPG или PNG размером менее 5 MB.",
      pdfNotAllowedIndiaMobile: "Загрузка PDF не разрешена для Индии. Пожалуйста, загрузите файлы JPEG, JPG, PNG, HEIC или HEIF размером менее 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png менее 5 mb",
      fileFormats: "jpeg, jpg, png, pdf менее 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif менее 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf менее 5 mb"
    },
    mobileCapture: {
      upload: "Загрузить",
      skip: "Пропустить",
      stillNotWorking: "Всё ещё не работает?",
      tryClickToCapture: "Снимите вручную"
    },
    UserDetails: {
      panLabel: "Номер PAN",
      proceedBtn: "Продолжить",
      panRequired: "Пожалуйста, введите номер PAN",
      saveError: "Не удалось сохранить данные. Пожалуйста, попробуйте снова."
    }
  },
  zh: {
    supportingDocument: {
      headingFallback: "辅助文件",
      subHeading: "请在下方上传文件。该文件仅用于存档审核 — 不会从中提取任何信息。",
      choosePlaceholder: "选择文件（PNG、JPG 或 PDF）",
      continue: "继续",
      uploading: "上传中...",
      skip: "暂时跳过",
      errorInvalidType: "请上传 PNG、JPG 或 PDF 文件。",
      errorTooLarge: "文件过大，上限为 10MB。",
      errorRead: "无法读取该文件，请尝试其他文件。",
      errorNoFile: "请选择要上传的文件。",
    },
    header: {
      title: "验证您的身份",
      subtitle: "这需要不到2分钟",
      havingIssue: "遇到问题了？"
    },
    onlyIdVerificationHeader: {
      title: "验证您的身份",
      subtitle: "只需一分钟，请准备好您的身份证件",
      instruction1: "允许相机访问",
      instruction2: "扫描或上传您的证件",
      instruction3: "即时证件验证"
    },
    subHeading: {
      subHeading1: "拍摄您的身份证件",
      subHeading2: "确认您在直播",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    termsAndCondition: {
      title: "我同意并遵守以下条款和条件。",
      privacyPolicy: "查看条款",
      beginBtnText: "开始",
      beginLiveness: "开始活体检测",
      startLiveness: "继续活体检测"
    },
    permissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "检查浏览器地址栏附近是否有被阻止的摄像头图标，并解除阻止。",
      readMore: "了解更多",
      refreshText: "一旦允许摄像头访问，请点击下面的刷新按钮。",
      refreshBtn: "刷新",
      link: "或者，继续在手机上",
      buttonText: "或者，继续在手机上"
    },
    desktopBrowserPermissionDenied: {
      readMore: "了解更多",
      refreshText: "一旦允许摄像头访问，请点击下面的刷新按钮。",
      refreshBtn: "刷新",
      link: "或者，继续在手机上",
      buttonText: "或者，继续在手机上",
      title: "摄像头访问被拒绝！",
      subtitle: "检查浏览器地址栏附近是否有被阻止的摄像头图标，并解除阻止。"
    },
    androidBrowserPermissionDenied: {
      title: "摄像头访问被拒绝",
      subtitle: "请检查浏览器地址栏附近是否有被阻止的摄像头图标，并解除阻止。",
      readMore: "了解更多",
      refreshText: "一旦允许摄像头访问，请点击下面的刷新按钮。",
      refreshBtn: "刷新",
      link: "或者，在手机上继续",
      buttonText: "或者，在手机上继续"
    },
    androidWebViewPermissionDenied: {
      title: "摄像头访问被拒绝",
      subtitle: "摄像头访问可能被应用设置阻止。请检查手机的应用信息 > 权限 > 摄像头并允许访问。",
      refreshText: "一旦允许摄像头访问，请点击下面的刷新按钮。",
      refreshBtn: "刷新",
      link: "或者，在手机上继续",
      buttonText: "或者，在手机上继续"
    },
    iosBrowserPermissionDenied: {
      title: "摄像头访问被拒绝",
      subtitle: "请点击地址栏附近的摄像头或锁图标以允许访问，或者检查浏览器设置。",
      readMore: "了解更多",
      refreshText: "一旦允许摄像头访问，请点击下面的刷新按钮。",
      refreshBtn: "刷新",
      link: "或者，在手机上继续",
      buttonText: "或者，在手机上继续"
    },
    iosWebViewPermissionDenied: {
      title: "摄像头访问被拒绝",
      subtitle: "摄像头访问可能被您的应用设置阻止。请进入设置，找到您正在使用的应用，启用摄像头权限。",
      refreshText: "一旦允许摄像头访问，请点击下面的刷新按钮。",
      refreshBtn: "刷新",
      link: "或者，在手机上继续",
      buttonText: "或者，在手机上继续"
    },
    documentationList: {
      countryHeading: "选择国家",
      docHeading: "选择您的文档",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "将身份证正面放入矩形中",
      backupHeading: "遇到问题？请手动点击图片",
      btnText: "点击拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "将身份证背面放入矩形中",
      backupHeading: "遇到问题？请手动点击图片",
      btnText: "点击拍照",
      containerText: "或者，上传文档",
      text: "正在拍摄，请保持静止",
      skipButton: "跳过背面",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "正在分析您的身份证",
      subHeading: "请稍等，这只需几秒钟"
    },
    imageCheck: {
      heading: "检查您的图像",
      subHeading: "请确保图像完整、清晰，并且没有模糊和眩光。",
      button1: "重新拍照",
      button2: "可以继续",
      frontHeading: "检查您的正面图像",
      backHeading: "检查您的背面图像"
    },
    errorHandler: {
      heading: "哎呀:(",
      subHeading1: "我们遇到了一些问题，但不要担心！请再试一次",
      subHeading2: "如果问题持续，请稍后再试",
      button: "再试一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "请移除遮挡您面部的物品",
        button: "再试一次"
      },
      eyeClosureDetected: {
        heading: "请保持眼睛睁开，并直视摄像头",
        button: "重试"
      },
      isMultipleFacesFound: {
        heading: "检测到多个面孔。请确保摄像头中只显示您的面孔。",
        button: "再试一次"
      },
      noFacesFound: {
        heading: "未检测到面部。请确保您的面部在摄像头中可见。",
        button: "再试一次"
      },
      faceDetections: {
        heading: "请移除它",
        button: "再试一次"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "检测到多个面部",
          button: "再试一次"
        },
        generalMessage: {
          heading: "请确保您在摄像头前是实时的",
          button: "再试一次"
        }
      },
      faceMatch: {
        heading: "您的面部与身份证照片不匹配",
        button: "再试一次"
      },
      selfieError: {
        heading: "我们无法验证您的自拍照",
        subHeading1: "只需按照这些提示操作并再次尝试",
        instruction1: "选择一个光线良好的地方并避免背光",
        instruction2: "确保您的面部完全可见并居中于画面",
        instruction3: "移除帽子、眼镜或口罩，以便清晰显示您的面部",
        button: "再试一次"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "验证失败。请清晰地按照说明操作并重试",
        button: "再试一次"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 页数过多",
        subHeading: "上传的 PDF 超过 2 页限制。请上传不超过 2 页的 PDF，或清晰的证件图片。"
      },
      heading: "我们无法处理您的身份证件",
      subHeading: "您上传的可能是错误的身份证件，或者图像不清晰",
      buttonBack: "重试身份证背面",
      buttonFront: "重试身份证正面",
      button: "重试",
      captureFrontSide: "拍摄正面",
      captureBackSide: "拍摄背面",
      changeIDButton: "选择另一个文档",
      wrongid: {
        heading: "我们无法处理此文档",
        subHeading: "请确保您上传的是正确的文档，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证件已过期！",
        subHeading: "我们不能接受过期的身份证件，请提供有效的文档"
      },
      minimumage: {
        heading: "年龄要求不符合！",
        subHeading: "您的年龄未达到最低要求，请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "您的旅程已在之前的设备上恢复",
        subHeading: "此会话已停止，以避免重复操作"
      },
      finished: {
        heading: "旅程已结束",
        subHeading: "旅程已完成或终止"
      },
      invalid: {
        heading: "旅程不可用！",
        subHeading: "未找到旅程ID或旅程ID无效"
      },
      DOCTYPE_FALSE: {
        heading: "无法识别文档！",
        subHeading: "请上传有效的文档，并确保图像质量良好"
      },
      ONLY_FRONT: {
        heading: "缺少身份证背面",
        subHeading: "您只上传了身份证正面。请翻转您的身份证并上传背面以继续操作"
      },
      ONLY_BACK: {
        heading: "缺少身份证正面",
        subHeading: "您只上传了身份证背面。请翻转您的身份证并上传正面以继续操作"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期！",
        subHeading: "由于文档即将过期，因此已被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年龄要求未达标！",
        subHeading: "文档显示您的年龄未达到要求，请上传有效的文档"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法进行验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "无法验证您在身份证上的照片",
        subHeading: "我们无法验证您在身份证上的照片。请上传一张原始身份证的清晰照片，以便我们进行确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案验证失败",
        subHeading: "我们无法验证文档内置的安全图案。请上传原始身份证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文件活体检测失败",
        subHeading: "我们发现该文件可能不是真实的。请不要使用屏幕截图、打印件或在屏幕上展示的身份证明。请上传所有特征清晰可见的原始证件。"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "文档无法验证，请重新上传更清晰的图像"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像模糊或不清晰，请重新上传更清晰的图像"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档中找到清晰可见的面部。请上传一张面部清晰可见的有效身份证件。"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "确认您在此直播",
      instruction1: "确保有足够的光线",
      instruction2: "允许必要的权限",
      instruction3: "只需按照说明操作",
      button: "继续",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "会话继续在手机上",
      subheading: "保持此窗口打开，直到在移动设备上完成",
      button: "在这里继续"
    },
    continueOnPhone: {
      heading: "在手机上继续",
      subheading: "扫描二维码或复制下面的链接",
      subheading2: "扫描二维码或在手机上打开链接",
      text: "完成过程",
      text1: "返回此处提交",
      button: "复制",
      copiedButton: "已复制！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "查看您的详细信息",
      subHeading: "进行必要的更改并提交详细信息",
      field1: "DL",
      field2: "EXP",
      field3: "DOB",
      field4: "Class",
      field5: "RSTR",
      field6: "Country",
      field7: "Address",
      button: "详细信息正确",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "将脸部放在圆圈中心"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近一些并保持脸部正对"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "进入画面并保持脸部正对"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了。找一个更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了。找一个最佳的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将脸部调整到圆圈中心"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动，目视前方"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光源并保持不动"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机保持在眼睛水平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "离相机稍微远一点"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美！"
      },
      smile1: {
        icon: "mood",
        description: "请微笑，您看起来很棒！"
      },
      smile2: {
        icon: "mood",
        description: "对着相机微笑！"
      }
    },
    successful: {
      title: "谢谢！",
      text: "我们已收集到验证您身份所需的所有信息",
      finishBtn: "完成"
    },
    poweredBy: "提供技术支持",
    redirect: "重定向中",
    error: {
      message: "URL 已过期或无效"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已经一段时间没有操作。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接具有有限的有效期",
      subHeading2: "请使用新的链接尝试",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "相机访问被拒绝。请在浏览器设置中启用相机访问",
      alert2: "访问相机时发生错误",
      alert3: "您的浏览器不支持相机访问"
    },
    footer: {
      securedBy: "提供技术支持"
    },
    helpFaq: {
      title: "帮助与常见问题",
      subtitle: "我们在这里为您提供帮助",
      cameraText: "为了验证您的身份，我们需要使用您设备的相机拍摄照片。点击此 link 学习如何授予所需的权限",
      cameraHeading: "相机权限",
      languageText: "在流程开始时，您可以从顶部栏的下拉菜单中选择您的首选语言",
      languageHeading: "语言选择",
      kycText: "KYC，即了解您的客户，是一个验证客户身份的过程，用于确保合规并防止欺诈和其他非法活动",
      kycHeading: "什么是 KYC？",
      timeText: "通常需要大约 60 秒。不过，根据不同的国家，这可能有所不同",
      timeHeading: "需要多长时间？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "的",
      upload: "上传",
      stillNotWorking: "仍然无法使用？",
      clickToCapture: "尝试点击拍摄",
      skip: "跳过"
    }
,
    permissionPopUp: {
      title: "需要权限",
      subtitle: "允许访问以使用摄像头",
      decline: "拒绝",
      allow: "允许"
    },
    userDetails: {
      heading: "PAN 验证",
      subHeading: "请填写详细信息以进行验证",
      panLabel: "PAN 号码",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详细信息时出现问题。请重试。",
      proceed: "继续"
    },
    redirectCta: {
      or: "或",
      clickHere: "点击这里",
      clickHereStart: "点击这里",
      toContinue: "以继续"
    },
    documentCapture: {
      stillNotWorking: "仍然无法使用？",
      clickToCaptureInstead: "改为尝试点击拍摄",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。",
      pdfNotAllowedIndiaMobile: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      fileFormatsIndia: "jpeg、jpg、png 小于 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 小于 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 小于 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 小于 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  },
  ar: {
    supportingDocument: {
      headingFallback: "مستند داعم",
      subHeading: "قم بتحميل المستند أدناه. يتم تخزينه للمراجعة — لا يتم استخراج أي شيء منه.",
      choosePlaceholder: "اختر ملفًا (PNG أو JPG أو PDF)",
      continue: "متابعة",
      uploading: "جارٍ التحميل...",
      skip: "تخطّي الآن",
      errorInvalidType: "قم بتحميل ملف PNG أو JPG أو PDF.",
      errorTooLarge: "الملف كبير جدًا. الحد الأقصى هو 10 ميغابايت.",
      errorRead: "تعذّر قراءة هذا الملف. يرجى تجربة ملف آخر.",
      errorNoFile: "يرجى اختيار ملف للتحميل.",
    },
    header: {
      title: "لنقم بالتحقق من هويتك",
      subtitle: "يستغرق أقل من دقيقتين",
      havingIssue: "هل تواجه مشكلة؟"
    },
    onlyIdVerificationHeader: {
      title: "لنقم بالتحقق من هويتك",
      subtitle: "سيستغرق هذا دقيقة واحدة فقط. يُرجى إحضار وثيقة الهوية الخاصة بك",
      instruction1: "السماح بالوصول إلى الكاميرا",
      instruction2: "مسح أو تحميل الوثيقة",
      instruction3: "التحقق الفوري من الوثيقة"
    },
    subHeading: {
      subHeading1: "التقط صورة لوثيقة الهوية الخاصة بك",
      subHeading2: "تحقق من أنك نشط",
      livenessHeading1: "ابحث عن مكان ذي إضاءة جيدة",
      livenessHeading2: "حافظ على وجهك في المنتصف"
    },
    termsAndCondition: {
      title: "أوافق على الموافقة والالتزام بالشروط والأحكام التالية.",
      privacyPolicy: "عرض الشروط",
      beginBtnText: "ابدأ",
      beginLiveness: "بدء التحقق من النشاط",
      startLiveness: "الانتقال إلى التحقق من النشاط"
    },
    permissionDenied: {
      title: "تم رفض الوصول إلى الكاميرا!",
      subtitle: "تحقق من وجود أيقونة كاميرا محجوبة بالقرب من شريط عنوان المتصفح وفك حظرها.",
      readMore: "تعرف أكثر",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر التحديث أدناه.",
      refreshBtn: "تحديث",
      link: "أو، استمر على الهاتف",
      buttonText: "أو، استمر على الهاتف"
    },
    desktopBrowserPermissionDenied: {
      readMore: "تعرف أكثر",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر التحديث أدناه.",
      refreshBtn: "تحديث",
      link: "أو، استمر على الهاتف",
      buttonText: "أو، استمر على الهاتف",
      title: "تم رفض الوصول إلى الكاميرا!",
      subtitle: "تحقق من وجود أيقونة كاميرا محجوبة بالقرب من شريط عنوان المتصفح وفك حظرها."
    },
    androidBrowserPermissionDenied: {
      title: "تم رفض الوصول إلى الكاميرا!",
      subtitle: "تحقق من وجود أيقونة كاميرا محجوبة بالقرب من شريط عنوان المتصفح وقم بإلغاء حظرها.",
      readMore: "اقرأ المزيد",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر التحديث أدناه.",
      refreshBtn: "تحديث",
      link: "أو، استمر على الهاتف",
      buttonText: "أو، استمر على الهاتف"
    },
    androidWebViewPermissionDenied: {
      title: "تم رفض الوصول إلى الكاميرا!",
      subtitle: "قد يكون وصول الكاميرا محظورًا من إعدادات التطبيق. يرجى التحقق من معلومات التطبيق > الأذونات > الكاميرا والسماح بالوصول.",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر التحديث أدناه.",
      refreshBtn: "تحديث",
      link: "أو، استمر على الهاتف",
      buttonText: "أو، استمر على الهاتف"
    },
    iosBrowserPermissionDenied: {
      title: "تم رفض الوصول إلى الكاميرا!",
      subtitle: "انقر على أيقونة الكاميرا أو القفل بالقرب من شريط العنوان للسماح بالوصول، أو تحقق من إعدادات المتصفح.",
      readMore: "اقرأ المزيد",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر التحديث أدناه.",
      refreshBtn: "تحديث",
      link: "أو، استمر على الهاتف",
      buttonText: "أو، استمر على الهاتف"
    },
    iosWebViewPermissionDenied: {
      title: "تم رفض الوصول إلى الكاميرا!",
      subtitle: "قد يكون وصول الكاميرا محظورًا من إعدادات التطبيق الخاص بك. انتقل إلى الإعدادات، وابحث عن التطبيق الذي تستخدمه، وقم بتمكين إذن الكاميرا.",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر التحديث أدناه.",
      refreshBtn: "تحديث",
      link: "أو، استمر على الهاتف",
      buttonText: "أو، استمر على الهاتف"
    },
    documentationList: {
      countryHeading: "اختر البلد",
      docHeading: "اختر وثيقتك",
      btnText: "التالي",
      searchCountry: "ابحث عن دولة"
    },
    frontDocCapture: {
      heading: "ضع الوجه الأمامي من الهوية في المستطيل",
      backupHeading: "تواجه مشكلة؟ يرجى النقر على الصورة يدويًا",
      btnText: "التقط صورة",
      headingBack: " داخل المستطيل",
      uploadButton: "أو قم بتحميل الهوية"
    },
    backDocCapture: {
      heading: "ضع الوجه الخلفي من الهوية في المستطيل",
      backupHeading: "تواجه مشكلة؟ يرجى النقر على الصورة يدويًا",
      btnText: "التقط صورة",
      containerText: "أو، قم بتحميل الوثيقة",
      text: "جاري الالتقاط، ابقَ ثابتًا",
      skipButton: "تخطي الوجه الخلفي",
      headingBack: " داخل المستطيل",
      uploadButton: "أو قم بتحميل الهوية"
    },
    analyzing: {
      heading: "تحليل هويتك",
      subHeading: "يرجى الانتظار، سيستغرق هذا بضع ثوانٍ فقط"
    },
    imageCheck: {
      heading: "تحقق من صورتك",
      subHeading: "يرجى التأكد من أن الصورة كاملة وواضحة وخالية من التشويش والتوهج.",
      button1: "إعادة التقاط الصورة",
      button2: "مناسب",
      frontHeading: "التحقق من الصورة الأمامية",
      backHeading: "التحقق من الصورة مرة أخرى"
    },
    errorHandler: {
      heading: "أوه لا :(",
      subHeading1: "نواجه بعض المشاكل، ولكن لا تقلق! يرجى المحاولة مرة أخرى",
      subHeading2: "إذا استمرت المشكلة، تحقق لاحقًا",
      button: "حاول مرة أخرى"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "يرجى إزالة أي شيء يغطي وجهك",
        button: "حاول مرة أخرى"
      },
      eyeClosureDetected: {
        heading: "يرجى إبقاء عينيك مفتوحتين والنظر مباشرة إلى الكاميرا",
        button: "حاول مرة أخرى"
      },
      isMultipleFacesFound: {
        heading: "تم اكتشاف وجوه متعددة. تأكد من أن وجهك فقط هو الظاهر في الكاميرا.",
        button: "حاول مرة أخرى"
      },
      noFacesFound: {
        heading: "لم يتم اكتشاف أي وجه. تأكد من أن وجهك ظاهر في الكاميرا.",
        button: "حاول مرة أخرى"
      },
      faceDetections: {
        heading: "يرجى إزالة ذلك",
        button: "حاول مرة أخرى"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "تم العثور على وجوه متعددة",
          button: "حاول مرة أخرى"
        },
        generalMessage: {
          heading: "يرجى التأكد من أنك أمام الكاميرا بشكل حي",
          button: "حاول مرة أخرى"
        }
      },
      faceMatch: {
        heading: "وجهك لا يتطابق مع صورة الهوية",
        button: "حاول مرة أخرى"
      },
      selfieError: {
        heading: "لم نتمكن من التحقق من صورتك الشخصية",
        subHeading1: "فقط اتبع هذه النصائح وحاول مرة أخرى",
        instruction1: "انتقل إلى مكان مضيء وتجنب الإضاءة الخلفية",
        instruction2: "تأكد من أن وجهك مرئي تمامًا وفي منتصف الإطار",
        instruction3: "إزالة القبعات أو النظارات أو الأقنعة للحصول على رؤية واضحة لوجهك",
        button: "حاول مرة أخرى"
      },
      activeLivenessOtpFailureMessage: {
        heading: "رمز OTP غير مطابق. يرجى قراءة رمز OTP بوضوح وبصوت عالٍ",
        button: "حاول مرة أخرى"
      },
      activeLivenessGenericFailureMessage: {
        heading: "فشل التحقق. يرجى اتباع التعليمات بوضوح والمحاولة مرة أخرى",
        button: "حاول مرة أخرى"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "يحتوي ملف PDF على صفحات كثيرة جدًا",
        subHeading: "يتجاوز ملف PDF المُحمَّل الحد الأقصى وهو صفحتان. يُرجى تحميل ملف PDF لا يزيد عن صفحتين، أو صورة واضحة لهويتك."
      },
      heading: "لم نتمكن من معالجة هويتك",
      subHeading: "إما أنك تقوم بتحميل هوية خاطئة أو أن الصورة غير واضحة",
      buttonBack: "إعادة تحميل الجهة الخلفية للهوية",
      buttonFront: "إعادة تحميل الجهة الأمامية للهوية",
      button: "إعادة المحاولة",
      captureFrontSide: "التقاط الوجه الأمامي",
      captureBackSide: "التقاط الوجه الخلفي",
      changeIDButton: "اختر مستندًا آخر",
      wrongid: {
        heading: "لم نتمكن من معالجة هذا المستند",
        subHeading: "يرجى التأكد من أنك تقوم بتحميل المستند الصحيح والتأكد من وضوح الصورة"
      },
      expiredid: {
        heading: "هوية منتهية الصلاحية!",
        subHeading: "لا يمكننا قبول هوية منتهية الصلاحية. يرجى تقديم مستند صالح"
      },
      minimumage: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "عمرك أقل من الحد الأدنى المطلوب. يرجى التأكد من أنك تلبي متطلبات العمر الأدنى"
      },
      mobileAttemptsDone: {
        heading: "تم استئناف الرحلة على جهازك السابق",
        subHeading: "تم إيقاف هذه الجلسة لتجنب التكرار"
      },
      finished: {
        heading: "انتهت الرحلة",
        subHeading: "تم إكمال الرحلة أو إنهاؤها"
      },
      invalid: {
        heading: "الرحلة غير متاحة!",
        subHeading: "لم يتم العثور على journeyId أو أن journeyId غير صالح"
      },
      DOCTYPE_FALSE: {
        heading: "المستند غير معترف به!",
        subHeading: "يرجى تحميل مستند صالح والتأكد من جودة الصورة."
      },
      ONLY_FRONT: {
        heading: "الجهة الخلفية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الأمامية فقط. يرجى قلب الهوية وتحميل الجهة الخلفية للمتابعة"
      },
      ONLY_BACK: {
        heading: "الجهة الأمامية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الخلفية فقط. يرجى قلب الهوية وتحميل الجهة الأمامية للمتابعة"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "المستند على وشك الانتهاء!",
        subHeading: "تم رفض المستند لأنه على وشك انتهاء الصلاحية."
      },
      DOCUMENT_EXPIRED: {
        heading: "المستند منتهي الصلاحية!",
        subHeading: "يرجى تحميل مستند صالح وغير منتهي الصلاحية للاستمرار."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "المستند يشير إلى أنك لا تستوفي العمر المطلوب. يرجى تحميل مستند صالح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "جودة الصورة منخفضة جدًا للتحقق. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "بعض المعلومات لم تتمكن من التحقق منها. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل بسبب ضعف جودة الصورة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "مشكلة في التحقق من صورتك على بطاقة الهوية",
        subHeading: "لم نتمكن من التحقق من صورتك على بطاقة الهوية. يرجى تحميل صورة واضحة لبطاقة الهوية الأصلية حتى نتمكن من تأكيدها."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "فشل التحقق من نمط الأمان في الوثيقة",
        subHeading: "لم نتمكن من التحقق من أنماط الأمان المدمجة في الوثيقة. يرجى تحميل صورة واضحة للهوية الأصلية لمساعدتنا في تأكيد صحتها."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "فشل التحقق من حيوية المستند",
        subHeading: "لقد وجدنا مؤشرات على أن المستند قد لا يكون أصليًا. يرجى تجنب استخدام لقطات الشاشة أو النسخ المطبوعة أو عرض الهوية على الشاشة. قم بتحميل المستند الأصلي مع إظهار جميع الميزات بوضوح."
      },
      SECURITY_FALSE: {
        heading: "تم اكتشاف مشكلة!",
        subHeading: "لم يتم التحقق من المستند. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "جودة صورة ضعيفة!",
        subHeading: "الصورة ضبابية جدًا أو غير واضحة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      FACE_UNDETECTED: {
        heading: "لم يتم اكتشاف الوجه",
        subHeading: "لم نتمكن من العثور على وجه مرئي في الوثيقة. يرجى تحميل هوية صالحة حيث يكون الوجه مرئيًا بوضوح."
      },
      INVALID_PAN_NUMBER: {
        heading: "رقم PAN غير صالح",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      INVALID_PAN_STATUS: {
        heading: "حالة PAN غير صالحة",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      directKyc: {
        heading: "رحلة KYC مباشرة !",
        subHeading: "هذه رحلة KYC مباشرة. رحلة الواجهة الأمامية غير مسموح بها."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "فشل المقارنة بين المستندات",
        subHeading: "فشلت المقارنة بين المستندات بسبب عدم تطابق في حقل أو أكثر من الحقول الرئيسية (الاسم أو تاريخ الميلاد أو الوجه)"
      },
      DIGILOCKER_FAILURE: {
        heading: "فشل Digilocker",
        subHeading: "حدث خطأ أثناء رحلة Digilocker. يرجى المحاولة مرة أخرى أو استخدام طريقة بديلة للمتابعة."
      },
      LINKAGE_FAILED: {
        heading: "تعذّر إكمال هذا التحقق",
        subHeading: "لم تتطابق البيانات المُلتقطة مع السجلات الخاصة بهذا الفحص."
      }
    },
    biometricConsent: {
      consentStatement: "قبل التقاط صورتك الشخصية، نحتاج إلى موافقتك على التقاط ومعالجة بياناتك البيومترية (صورة الوجه وإشارات الحيوية) للتحقق من هويتك. تُستخدم هذه البيانات لهذا التحقق فقط.",
      privacyPolicy: "سياسة الخصوصية",
      consentButton: "أوافق — متابعة",
      declineButton: "لا أوافق",
      confirmTitle: "المتابعة دون التحقق البيومتري؟",
      confirmBody: "بدون التحقق البيومتري، لن نلتقط صورة شخصية. سيتم إكمال التحقق باستخدام المعلومات التي قدمتها بالفعل. هذا الاختيار نهائي لهذه الجلسة.",
      goBack: "رجوع",
      confirmDecline: "تأكيد — لا أوافق",
      declineComplete: "لقد اخترت عدم المتابعة بالتحقق البيومتري. تم إكمال التحقق من هويتك باستخدام المستندات التي قدمتها."
    },
    introLiveness: {
      heading: "أكد أنك نشط هنا",
      instruction1: "تأكد من وجود إضاءة كافية",
      instruction2: "منح الأذونات اللازمة",
      instruction3: "اتبع التعليمات فقط",
      button: "انتقال",
      subHeading: "أنت على بُعد خطوة واحدة فقط"
    },
    phoneSession: {
      heading: "استمرار الجلسة على الهاتف",
      subheading: "ابقَ هذه النافذة مفتوحة حتى الانتهاء على الهاتف",
      button: "متابعة هنا"
    },
    continueOnPhone: {
      heading: "تابع على الهاتف",
      subheading: "امسح رمز الاستجابة السريعة أو انسخ الرابط أدناه",
      subheading2: "امسح رمز الاستجابة السريعة أو افتح الرابط على هاتفك",
      text: "أكمل العملية",
      text1: "تحقق هنا للإرسال",
      button: "نسخ",
      copiedButton: "تم النسخ!",
      copied: "تم النسخ!"
    },
    SsnReview: {
      heading: "راجع تفاصيلك",
      subHeading: "قم بإجراء أي تغييرات ضرورية وقدم التفاصيل",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "التفاصيل صحيحة"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "اقترب من الكاميرا"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "لا تخجل، اظهر أمام الكاميرا"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم جدًا. ابحث عن إضاءة أفضل"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ساطع جدًا. ابحث عن إضاءة أخف"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقَ ثابتًا"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "أدر وجهك نحو الضوء"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "أمسك الهاتف على مستوى عينيك"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ابتعد قليلًا عن الكاميرا"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ضع وجهك في منتصف الإطار"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "ضع وجهك في منتصف الدائرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "اقترب أكثر وحافظ على وجهك مستقيماً"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ادخل في المنظر وحافظ على وجهك مستقيماً"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم جدًا. ابحث عن إضاءة أكثر سطوعًا"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ساطع جدًا. ابحث عن إضاءة مثالية"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "اضبط وجهك في منتصف الدائرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقَ ثابتاً وانظر للأمام مباشرة"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "واجه الضوء وابقَ ثابتاً"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "امسك هاتفك عند مستوى العين"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ابتعد قليلاً عن الكاميرا"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "مثالي!"
      },
      smile1: {
        icon: "mood",
        description: "ابتسم من فضلك، تبدو رائعًا!"
      },
      smile2: {
        icon: "mood",
        description: "ابتسم للكاميرا!"
      }
    },
    successful: {
      title: "شكرًا!",
      text: "لقد جمعنا جميع المعلومات اللازمة للتحقق من هويتك",
      finishBtn: "انتهاء"
    },
    poweredBy: "مدعوم بواسطة",
    redirect: "إعادة التوجيه في",
    error: {
      message: "الرابط منتهي الصلاحية أو غير صالح"
    },
    sessionExpiredError: {
      heading: "عذرًا، انتهت صلاحية جلستك",
      subHeading1: "كنت غير نشط لفترة، ولأسباب أمنية، انتهت جلستك تلقائيًا",
      subHeading2: "يرجى المحاولة مرة أخرى",
      buttonText: "حاول مرة أخرى"
    },
    journeyExpiredError: {
      heading: "عذرًا، الرابط منتهي الصلاحية",
      subHeading1: "الرابط لم يعد نشطًا. لأسباب أمنية، الروابط لها فترة صلاحية محدودة",
      subHeading2: "يرجى المحاولة برابط جديد",
      buttonText: "حاول مرة أخرى"
    },
    cameraAccessError: {
      alert1: "تم رفض الوصول إلى الكاميرا. يرجى تمكين الوصول إلى الكاميرا في إعدادات متصفحك",
      alert2: "حدث خطأ أثناء الوصول إلى الكاميرا",
      alert3: "متصفحك لا يدعم الوصول إلى الكاميرا"
    },
    footer: {
      securedBy: "مدعوم بواسطة"
    },
    helpFaq: {
      title: "المساعدة والأسئلة الشائعة",
      subtitle: "نحن هنا لمساعدتك",
      cameraText: "للتحقق من هويتك، نحتاج إلى التقاط صور باستخدام كاميرا جهازك. اتبع هذا link لتعلم كيفية منح الأذونات المطلوبة",
      cameraHeading: "إذن الكاميرا",
      languageText: "في بداية العملية، يمكنك اختيار لغتك المفضلة من القائمة المنسدلة في الشريط العلوي",
      languageHeading: "اختيار اللغة",
      kycText: "KYC، أو اعرف عميلك، هو عملية للتحقق من هويات العملاء لضمان الامتثال ومنع الاحتيال والأنشطة غير القانونية الأخرى",
      kycHeading: "ما هو KYC؟",
      timeText: "عادةً ما يستغرق حوالي 60 ثانية. ومع ذلك، قد يختلف ذلك حسب البلدان",
      timeHeading: "كم من الوقت سيستغرق؟"
    },
    pdfPreviewUnavailable: "تعذّر عرض معاينة ملف PDF.",
    pdfPreviewHint: "إذا لم تظهر المعاينة، لا يزال بإمكانك المتابعة.",
    pdfOpenLabel: "فتح ملف PDF",
    failedUpload: {
      title: "فشل تحميل الملف",
      text: "يرجى التأكد من أن حجم الملف أقل من 5 ميغابايت وبصيغة ‎.jpg أو ‎.jpeg أو ‎.png أو ‎.heic أو ‎.heif أو ‎.pdf",
      btn: "حاول مرة أخرى",
      pdfNotAllowedIndia: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 ميغابايت.",
      pdfNotAllowedIndiaBasic: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أقل من 5 ميغابايت."
    },
    livenessAnalyzing: {
      heading: "جارٍ تحليل وجهك",
      subHeading: "يرجى الانتظار، لن يستغرق هذا سوى بضع ثوانٍ"
    },
    activeLiveness: {
      instruction: "أبقِ وجهك داخل الدائرة واتبع التعليمات",
      permissionDeniedTitle: "تم رفض الوصول إلى الكاميرا أو الميكروفون",
      permissionDeniedSubtitle: "يرجى السماح بالوصول إلى الكاميرا والميكروفون في إعدادات متصفحك والمحاولة مرة أخرى."
    },
    flipScreen: {
      heading: "اقلب بطاقة هويتك الآن",
      subHeading: "يرجى قلب بطاقة هويتك فعليًا لإظهار الجهة الخلفية، ثم ضعها داخل إطار الكاميرا.",
      continueButton: "متابعة"
    },
    mobileDocCapture: {
      frontSide: "الوجه الأمامي",
      backSide: "الوجه الخلفي",
      of: "لـ",
      upload: "رفع",
      stillNotWorking: "لا يزال لا يعمل؟",
      clickToCapture: "جرّب الالتقاط بالنقر",
      skip: "تخطّي"
    }
,
    permissionPopUp: {
      title: "الإذن مطلوب",
      subtitle: "اسمح بالوصول لاستخدام الكاميرا",
      decline: "رفض",
      allow: "السماح"
    },
    userDetails: {
      heading: "التحقق من PAN",
      subHeading: "يرجى ملء التفاصيل للتحقق",
      panLabel: "رقم PAN",
      panRequired: "يرجى إدخال رقم PAN الخاص بك",
      saveError: "حدث خطأ أثناء حفظ التفاصيل. يرجى المحاولة مرة أخرى.",
      proceed: "متابعة"
    },
    redirectCta: {
      or: "أو",
      clickHere: "انقر هنا",
      clickHereStart: "انقر هنا",
      toContinue: "للمتابعة"
    },
    documentCapture: {
      stillNotWorking: "لا يزال لا يعمل؟",
      clickToCaptureInstead: "جرّب الالتقاط بالنقر بدلاً من ذلك",
      pdfNotAllowedIndia: "تحميل ملفات PDF غير مسموح به للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أقل من 5 MB.",
      pdfNotAllowedIndiaMobile: "تحميل ملفات PDF غير مسموح به للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png أقل من 5 mb",
      fileFormats: "jpeg, jpg, png, pdf أقل من 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif أقل من 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf أقل من 5 mb"
    },
    mobileCapture: {
      upload: "تحميل",
      skip: "تخطي",
      stillNotWorking: "لا يزال لا يعمل؟",
      tryClickToCapture: "التقط الصورة يدويًا"
    },
    UserDetails: {
      panLabel: "رقم PAN",
      proceedBtn: "متابعة",
      panRequired: "يرجى إدخال رقم PAN الخاص بك",
      saveError: "حدث خطأ أثناء حفظ التفاصيل. يرجى المحاولة مرة أخرى."
    }
  },
  bn: {
    supportingDocument: {
      headingFallback: "সহায়ক নথি",
      subHeading: "নিচে নথিটি আপলোড করুন। এটি পর্যালোচনার জন্য সংরক্ষণ করা হয় — এ থেকে কিছুই বের করা হয় না।",
      choosePlaceholder: "একটি ফাইল নির্বাচন করুন (PNG, JPG বা PDF)",
      continue: "চালিয়ে যান",
      uploading: "আপলোড হচ্ছে...",
      skip: "আপাতত এড়িয়ে যান",
      errorInvalidType: "একটি PNG, JPG বা PDF ফাইল আপলোড করুন।",
      errorTooLarge: "ফাইলটি খুব বড়। সীমা 10MB।",
      errorRead: "সেই ফাইলটি পড়া যায়নি। অনুগ্রহ করে অন্যটি চেষ্টা করুন।",
      errorNoFile: "আপলোড করার জন্য একটি ফাইল নির্বাচন করুন।",
    },
    header: {
      title: "আপনার পরিচয় যাচাই করুন",
      subtitle: "এটি ২ মিনিটেরও কম সময় নিবে",
      havingIssue: "সমস্যা হচ্ছে?"
    },
    onlyIdVerificationHeader: {
      title: "আপনার পরিচয়পত্র যাচাই করুন",
      subtitle: "এটি মাত্র এক মিনিট সময় নেবে। আপনার আইডি ডকুমেন্ট প্রস্তুত রাখুন",
      instruction1: "ক্যামেরা অ্যাক্সেস অনুমতি দিন",
      instruction2: "ডকুমেন্ট স্ক্যান বা আপলোড করুন",
      instruction3: "তাত্ক্ষণিক ডকুমেন্ট যাচাইকরণ"
    },
    subHeading: {
      subHeading1: "আপনার আইডি ডকুমেন্ট ক্যাপচার করুন",
      subHeading2: "আপনি লাইভ কি না যাচাই করুন",
      livenessHeading1: "ভালো আলো আছে এমন জায়গা বেছে নিন",
      livenessHeading2: "আপনার মুখ মাঝখানে রাখুন"
    },
    termsAndCondition: {
      title: "আমি সম্মত হই এবং নিম্নলিখিত শর্তাবলী মেনে চলব।",
      privacyPolicy: "শর্তাবলী দেখুন",
      beginBtnText: "শুরু করুন",
      beginLiveness: "লাইভনেস চেক শুরু হচ্ছে",
      startLiveness: "লাইভনেস চেক করতে এগিয়ে যান"
    },
    permissionDenied: {
      title: "ক্যামেরা অ্যাক্সেস অস্বীকার!",
      subtitle: "ব্রাউজারের ঠিকানা বারের কাছে একটি ব্লকড ক্যামেরা আইকন চেক করুন এবং এটি আনব্লক করুন।",
      readMore: "আরও জানুন",
      refreshText: "একবার ক্যামেরা অ্যাক্সেস অনুমোদিত হলে, নিচের রিফ্রেশ বাটনে ক্লিক করুন।",
      refreshBtn: "রিফ্রেশ",
      link: "অথবা, ফোনে চালিয়ে যান",
      buttonText: "অথবা, ফোনে চালিয়ে যান"
    },
    desktopBrowserPermissionDenied: {
      readMore: "আরও জানুন",
      refreshText: "একবার ক্যামেরা অ্যাক্সেস অনুমোদিত হলে, নিচের রিফ্রেশ বাটনে ক্লিক করুন।",
      refreshBtn: "রিফ্রেশ",
      link: "অথবা, ফোনে চালিয়ে যান",
      buttonText: "অথবা, ফোনে চালিয়ে যান",
      title: "ক্যামেরা অ্যাক্সেস অস্বীকার!",
      subtitle: "ব্রাউজারের ঠিকানা বারের কাছে একটি ব্লকড ক্যামেরা আইকন চেক করুন এবং এটি আনব্লক করুন।"
    },
    androidBrowserPermissionDenied: {
      title: "ক্যামেরা অ্যাক্সেস অস্বীকার!",
      subtitle: "ব্রাউজারের ঠিকানা বারের কাছে একটি ব্লকড ক্যামেরা আইকন চেক করুন এবং এটি আনব্লক করুন।",
      readMore: "আরো জানুন",
      refreshText: "ক্যামেরা অ্যাক্সেস অনুমোদিত হলে নিচের রিফ্রেশ বাটনে ক্লিক করুন।",
      refreshBtn: "রিফ্রেশ",
      link: "অথবা, ফোনে চালিয়ে যান",
      buttonText: "অথবা, ফোনে চালিয়ে যান"
    },
    androidWebViewPermissionDenied: {
      title: "ক্যামেরা অ্যাক্সেস অস্বীকার!",
      subtitle: "অ্যাপ সেটিংস দ্বারা ক্যামেরা অ্যাক্সেস ব্লক হতে পারে। ফোনের অ্যাপ ইনফো > পারমিশন > ক্যামেরা চেক করুন এবং অনুমতি দিন।",
      refreshText: "ক্যামেরা অ্যাক্সেস অনুমোদিত হলে নিচের রিফ্রেশ বাটনে ক্লিক করুন।",
      refreshBtn: "রিফ্রেশ",
      link: "অথবা, ফোনে চালিয়ে যান",
      buttonText: "অথবা, ফোনে চালিয়ে যান"
    },
    iosBrowserPermissionDenied: {
      title: "ক্যামেরা অ্যাক্সেস অস্বীকার!",
      subtitle: "অ্যাড্রেস বারের কাছে ক্যামেরা বা লক আইকনে ট্যাপ করে অ্যাক্সেস অনুমতি দিন অথবা ব্রাউজার সেটিংস চেক করুন।",
      readMore: "আরো জানুন",
      refreshText: "ক্যামেরা অ্যাক্সেস অনুমোদিত হলে নিচের রিফ্রেশ বাটনে ক্লিক করুন।",
      refreshBtn: "রিফ্রেশ",
      link: "অথবা, ফোনে চালিয়ে যান",
      buttonText: "অথবা, ফোনে চালিয়ে যান"
    },
    iosWebViewPermissionDenied: {
      title: "ক্যামেরা অ্যাক্সেস অস্বীকার!",
      subtitle: "অ্যাপ সেটিংস দ্বারা ক্যামেরা অ্যাক্সেস ব্লক হতে পারে। সেটিংসে যান, আপনার অ্যাপটি খুঁজুন এবং ক্যামেরা পারমিশন চালু করুন।",
      refreshText: "ক্যামেরা অ্যাক্সেস অনুমোদিত হলে নিচের রিফ্রেশ বাটনে ক্লিক করুন।",
      refreshBtn: "রিফ্রেশ",
      link: "অথবা, ফোনে চালিয়ে যান",
      buttonText: "অথবা, ফোনে চালিয়ে যান"
    },
    documentationList: {
      countryHeading: "দেশ নির্বাচন করুন",
      docHeading: "আপনার ডকুমেন্ট নির্বাচন করুন",
      btnText: "পরবর্তী",
      searchCountry: "দেশ খুঁজুন"
    },
    frontDocCapture: {
      heading: "আইডির সামনের দিকটি আয়তক্ষেত্রে রাখুন",
      backupHeading: "সমস্যা হচ্ছে? দয়া করে ছবিটি ম্যানুয়ালি ক্লিক করুন",
      btnText: "ছবি তোলা",
      headingBack: " আয়তক্ষেত্রের ভিতরে",
      uploadButton: "অথবা, আইডি আপলোড করুন"
    },
    backDocCapture: {
      heading: "আইডির পিছনের দিকটি আয়তক্ষেত্রে রাখুন",
      backupHeading: "সমস্যা হচ্ছে? দয়া করে ছবিটি ম্যানুয়ালি ক্লিক করুন",
      btnText: "ছবি তোলা",
      containerText: "অথবা, ডকুমেন্ট আপলোড করুন",
      text: "ধরা হচ্ছে, স্থির থাকুন",
      skipButton: "পিছনের দিক স্কিপ করুন",
      headingBack: " আয়তক্ষেত্রের ভিতরে",
      uploadButton: "অথবা, আইডি আপলোড করুন"
    },
    analyzing: {
      heading: "আপনার আইডি বিশ্লেষণ করা হচ্ছে",
      subHeading: "দয়া করে অপেক্ষা করুন, এটি কয়েক সেকেন্ডের বেশি সময় নিবে না"
    },
    imageCheck: {
      heading: "আপনার চিত্র চেক করুন",
      subHeading: "দয়া করে নিশ্চিত করুন যে চিত্র সম্পূর্ণ, পরিষ্কার এবং ব্লার ও গ্লেয়ার মুক্ত।",
      button1: "ছবি পুনরায় তুলুন",
      button2: "ঠিক আছে",
      frontHeading: "সামনের চিত্র চেক করুন",
      backHeading: "পেছনের চিত্র চেক করুন"
    },
    errorHandler: {
      heading: "আহ, সমস্যা হয়েছে :(",
      subHeading1: "আমরা কিছু সমস্যার সম্মুখীন হচ্ছি, কিন্তু চিন্তা করবেন না! দয়া করে আবার চেষ্টা করুন",
      subHeading2: "যদি সমস্যা চলতে থাকে, পরে আবার চেক করুন",
      button: "পুনরায় চেষ্টা করুন"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "দয়া করে আপনার মুখ ঢাকার জিনিসপত্র সরান",
        button: "পুনরায় চেষ্টা করুন"
      },
      eyeClosureDetected: {
        heading: "দয়া করে চোখ খোলা রাখুন এবং সোজা ক্যামেরার দিকে তাকান",
        button: "আবার চেষ্টা করুন"
      },
      isMultipleFacesFound: {
        heading: "একাধিক মুখ শনাক্ত করা হয়েছে। নিশ্চিত করুন যে ক্যামেরায় শুধুমাত্র আপনার মুখ দৃশ্যমান।",
        button: "পুনরায় চেষ্টা করুন"
      },
      noFacesFound: {
        heading: "কোন মুখ শনাক্ত করা যায়নি। নিশ্চিত করুন যে আপনার মুখ ক্যামেরায় দৃশ্যমান।",
        button: "পুনরায় চেষ্টা করুন"
      },
      faceDetections: {
        heading: "দয়া করে এটি সরান",
        button: "পুনরায় চেষ্টা করুন"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "একাধিক মুখ পাওয়া গেছে",
          button: "পুনরায় চেষ্টা করুন"
        },
        generalMessage: {
          heading: "দয়া করে নিশ্চিত করুন যে আপনি ক্যামেরার সামনে লাইভ আছেন",
          button: "পুনরায় চেষ্টা করুন"
        }
      },
      faceMatch: {
        heading: "আপনার মুখ পরিচয়পত্রের ছবির সাথে মেলে না",
        button: "পুনরায় চেষ্টা করুন"
      },
      selfieError: {
        heading: "আমরা আপনার সেলফি যাচাই করতে পারিনি",
        subHeading1: "কেবল এই নির্দেশিকা অনুসরণ করুন এবং আবার চেষ্টা করুন",
        instruction1: "ভাল আলোযুক্ত স্থানে যান এবং পেছনের আলো এড়িয়ে চলুন",
        instruction2: "আপনার মুখ পুরোপুরি দৃশ্যমান এবং ফ্রেমের কেন্দ্রে রাখুন",
        instruction3: "আপনার মুখের পরিষ্কার দৃশ্যের জন্য টুপি, চশমা বা মাস্ক সরান",
        button: "পুনরায় চেষ্টা করুন"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP মেলেনি। অনুগ্রহ করে OTP স্পষ্টভাবে জোরে পড়ুন",
        button: "পুনরায় চেষ্টা করুন"
      },
      activeLivenessGenericFailureMessage: {
        heading: "যাচাইকরণ ব্যর্থ হয়েছে। অনুগ্রহ করে নির্দেশাবলী স্পষ্টভাবে অনুসরণ করুন এবং পুনরায় চেষ্টা করুন",
        button: "পুনরায় চেষ্টা করুন"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF-এ অনেক বেশি পৃষ্ঠা আছে",
        subHeading: "আপলোড করা PDF ২ পৃষ্ঠার সীমা ছাড়িয়ে গেছে। অনুগ্রহ করে ২ পৃষ্ঠার বেশি নয় এমন PDF, বা আপনার আইডির স্পষ্ট ছবি আপলোড করুন।"
      },
      heading: "আমরা আপনার আইডি প্রক্রিয়া করতে পারিনি",
      subHeading: "আপনি হয় ভুল আইডি আপলোড করছেন বা ছবি স্পষ্ট নয়",
      buttonBack: "আইডির পেছনের দিক আবার চেষ্টা করুন",
      buttonFront: "আইডির সামনের দিক আবার চেষ্টা করুন",
      button: "পুনরায় চেষ্টা করুন",
      captureFrontSide: "সামনের দিক ক্যাপচার করুন",
      captureBackSide: "পিছনের দিক ক্যাপচার করুন",
      changeIDButton: "আরেকটি ডকুমেন্ট নির্বাচন করুন",
      wrongid: {
        heading: "আমরা এই ডকুমেন্ট প্রক্রিয়া করতে পারিনি",
        subHeading: "অনুগ্রহ করে নিশ্চিত করুন আপনি সঠিক ডকুমেন্ট আপলোড করছেন এবং ছবির গুণগত মান স্পষ্ট"
      },
      expiredid: {
        heading: "আইডি ডকুমেন্ট মেয়াদোত্তীর্ণ!",
        subHeading: "আমরা একটি মেয়াদোত্তীর্ণ আইডি গ্রহণ করতে পারি না। অনুগ্রহ করে একটি বৈধ ডকুমেন্ট প্রদান করুন"
      },
      minimumage: {
        heading: "বয়সের শর্ত পূর্ণ হয়নি!",
        subHeading: "আপনার বয়স ন্যূনতম প্রয়োজনীয় বয়সের নিচে। অনুগ্রহ করে নিশ্চিত করুন আপনি ন্যূনতম বয়স শর্ত পূর্ণ করেন"
      },
      mobileAttemptsDone: {
        heading: "ভ্রমণ আপনার পূর্ববর্তী ডিভাইসে পুনরায় শুরু হয়েছে",
        subHeading: "ডুপ্লিকেশন রোধ করতে এই সেশন বন্ধ করা হয়েছে"
      },
      finished: {
        heading: "ভ্রমণ শেষ হয়েছে",
        subHeading: "ভ্রমণ সম্পন্ন বা বাতিল করা হয়েছে"
      },
      invalid: {
        heading: "ভ্রমণ উপলব্ধ নয়!",
        subHeading: "যাত্রা আইডি পাওয়া যায়নি বা যাত্রা আইডি অবৈধ"
      },
      DOCTYPE_FALSE: {
        heading: "ডকুমেন্ট চিনহিত হয়নি!",
        subHeading: "দয়া করে একটি বৈধ ডকুমেন্ট আপলোড করুন এবং নিশ্চিত করুন ছবির গুণগত মান ভাল।"
      },
      ONLY_FRONT: {
        heading: "আইডি কার্ডের পেছনের দিক অনুপস্থিত",
        subHeading: "আপনি শুধুমাত্র সামনের দিক আপলোড করেছেন। অনুগ্রহ করে আইডি কার্ডটি উল্টে পেছনের দিকটি আপলোড করুন যেন প্রক্রিয়া চালিয়ে যেতে পারেন"
      },
      ONLY_BACK: {
        heading: "আইডি কার্ডের সামনের দিক অনুপস্থিত",
        subHeading: "আপনি শুধুমাত্র পেছনের দিক আপলোড করেছেন। অনুগ্রহ করে আইডি কার্ডটি উল্টে সামনের দিকটি আপলোড করুন যেন প্রক্রিয়া চালিয়ে যেতে পারেন"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "ডকুমেন্ট শীঘ্রই মেয়াদোত্তীর্ণ হতে যাচ্ছে!",
        subHeading: "ডকুমেন্টটি খুব শীঘ্রই মেয়াদোত্তীর্ণ হবে বলে এটি প্রত্যাখ্যান করা হয়েছে।"
      },
      DOCUMENT_EXPIRED: {
        heading: "ডকুমেন্ট মেয়াদোত্তীর্ণ!",
        subHeading: "অনুগ্রহ করে একটি বৈধ, মেয়াদোত্তীর্ণ ডকুমেন্ট আপলোড করুন।"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "বয়সের শর্ত পূর্ণ হয়নি!",
        subHeading: "ডকুমেন্ট থেকে জানা যাচ্ছে যে আপনি প্রয়োজনীয় বয়স পূর্ণ করেননি। অনুগ্রহ করে একটি বৈধ ডকুমেন্ট আপলোড করুন।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ডকুমেন্ট যাচাই করতে পারিনি!",
        subHeading: "ছবির গুণগত মান খুব খারাপ। স্পষ্ট ছবি দিয়ে আবার চেষ্টা করুন।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ডকুমেন্ট যাচাই করতে পারিনি!",
        subHeading: "কিছু তথ্য যাচাই করা যায়নি। স্পষ্ট ছবি দিয়ে আবার চেষ্টা করুন।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ডকুমেন্ট যাচাই করতে পারিনি!",
        subHeading: "কিছু বিস্তারিত খারাপ ছবির গুণগত মানের কারণে যাচাই করা যায়নি। স্পষ্ট ছবি দিয়ে আবার চেষ্টা করুন।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ডকুমেন্ট যাচাই করতে পারিনি!",
        subHeading: "কিছু বিস্তারিত যাচাই করা যায়নি। স্পষ্ট ছবি দিয়ে আবার চেষ্টা করুন।"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "আইডিতে আপনার ছবি যাচাই করতে সমস্যা হয়েছে",
        subHeading: "আমরা আপনার আইডি কার্ডে থাকা ছবিটি যাচাই করতে পারিনি। অনুগ্রহ করে আপনার মূল আইডির একটি পরিষ্কার ছবি আপলোড করুন যাতে আমরা এটি নিশ্চিত করতে পারি।"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "নথির সুরক্ষা প্যাটার্ন যাচাই ব্যর্থ হয়েছে",
        subHeading: "আমরা নথির অন্তর্নিহিত সুরক্ষা প্যাটার্ন যাচাই করতে পারিনি। অনুগ্রহ করে মূল পরিচয়পত্রের একটি পরিষ্কার ছবি আপলোড করুন যাতে আমরা এর যথার্থতা নিশ্চিত করতে পারি।"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "ডকুমেন্ট লাইভনেস যাচাই ব্যর্থ হয়েছে",
        subHeading: "আমরা দেখেছি যে ডকুমেন্টটি প্রকৃত নাও হতে পারে। স্ক্রিনশট, প্রিন্ট কপি বা স্ক্রিনে প্রদর্শিত আইডি ব্যবহার করা থেকে বিরত থাকুন। অনুগ্রহ করে সমস্ত বৈশিষ্ট্য স্পষ্টভাবে দৃশ্যমান এমন মূল ডকুমেন্টটি আপলোড করুন।"
      },
      SECURITY_FALSE: {
        heading: "সমস্যা সনাক্ত হয়েছে!",
        subHeading: "ডকুমেন্ট যাচাই করা যায়নি। স্পষ্ট ছবি দিয়ে আবার চেষ্টা করুন।"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "খারাপ ছবি গুণগত মান!",
        subHeading: "ছবি খুব ঝাপসা বা অস্পষ্ট। স্পষ্ট ছবি দিয়ে আবার চেষ্টা করুন।"
      },
      FACE_UNDETECTED: {
        heading: "মুখ সনাক্ত করা হয়নি",
        subHeading: "আমরা ডকুমেন্টে কোনো স্পষ্ট মুখ খুঁজে পাইনি। দয়া করে একটি বৈধ আইডি আপলোড করুন যেখানে মুখ স্পষ্টভাবে দৃশ্যমান।"
      },
      INVALID_PAN_NUMBER: {
        heading: "অবৈধ PAN নম্বর",
        subHeading: "আপনি যে PAN নম্বরটি দিয়েছেন তা বৈধ নয়। অনুগ্রহ করে যাচাই করে আবার চেষ্টা করুন"
      },
      INVALID_PAN_STATUS: {
        heading: "অবৈধ PAN স্ট্যাটাস",
        subHeading: "আপনি যে PAN নম্বরটি দিয়েছেন তা বৈধ নয়। অনুগ্রহ করে যাচাই করে আবার চেষ্টা করুন"
      },
      directKyc: {
        heading: "সরাসরি KYC যাত্রা !",
        subHeading: "এটি একটি সরাসরি KYC যাত্রা। ফ্রন্টএন্ড যাত্রা অনুমোদিত নয়।"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "নথির মধ্যে তুলনা ব্যর্থ হয়েছে",
        subHeading: "এক বা একাধিক মূল ক্ষেত্রে (নাম, জন্ম তারিখ, বা মুখ) অমিলের কারণে নথির মধ্যে তুলনা ব্যর্থ হয়েছে"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker ব্যর্থতা",
        subHeading: "Digilocker যাত্রার সময় একটি ত্রুটি ঘটেছে। অনুগ্রহ করে আবার চেষ্টা করুন অথবা চালিয়ে যেতে বিকল্প পদ্ধতি ব্যবহার করুন।"
      },
      LINKAGE_FAILED: {
        heading: "এই যাচাইকরণ সম্পূর্ণ করা যায়নি",
        subHeading: "এই যাচাইয়ের জন্য সংগৃহীত তথ্য রেকর্ডের সঙ্গে মেলেনি।"
      }
    },
    biometricConsent: {
      consentStatement: "আপনার সেলফির আগে, আপনার পরিচয় যাচাই করতে আমাদের আপনার বায়োমেট্রিক ডেটা (মুখের ছবি ও লাইভনেস সংকেত) ক্যাপচার ও প্রক্রিয়া করার সম্মতি প্রয়োজন। এই ডেটা শুধুমাত্র এই যাচাইয়ের জন্যই ব্যবহার করা হয়।",
      privacyPolicy: "গোপনীয়তা নীতি",
      consentButton: "আমি সম্মত — চালিয়ে যান",
      declineButton: "আমি সম্মত নই",
      confirmTitle: "বায়োমেট্রিক যাচাই ছাড়াই এগিয়ে যাবেন?",
      confirmBody: "বায়োমেট্রিক যাচাই ছাড়া আমরা কোনো সেলফি নেব না। আপনি ইতিমধ্যে যে তথ্য দিয়েছেন তা ব্যবহার করে আপনার যাচাই সম্পন্ন হবে। এই সিদ্ধান্ত এই সেশনের জন্য চূড়ান্ত।",
      goBack: "ফিরে যান",
      confirmDecline: "নিশ্চিত করুন — সম্মত নই",
      declineComplete: "আপনি বায়োমেট্রিক যাচাই না করার সিদ্ধান্ত নিয়েছেন। আপনার জমা দেওয়া নথিপত্র ব্যবহার করে আপনার পরিচয় যাচাই সম্পন্ন হয়েছে।"
    },
    introLiveness: {
      heading: "নিশ্চিত করুন আপনি এখানে লাইভ আছেন",
      instruction1: "যাচাই করুন পর্যাপ্ত আলো আছে কিনা",
      instruction2: "প্রয়োজনীয় অনুমতি দিন",
      instruction3: "নির্দেশনা অনুসরণ করুন",
      button: "অগ্রসর হোন",
      subHeading: "আপনি মাত্র এক ধাপ দূরে"
    },
    phoneSession: {
      heading: "ফোনে সেশন চলেছে",
      subheading: "এই উইন্ডোটি খোলা রাখুন, মোবাইলে শেষ না হওয়া পর্যন্ত",
      button: "এখানে চালিয়ে যান"
    },
    continueOnPhone: {
      heading: "ফোনে চালিয়ে যান",
      subheading: "কিউআর স্ক্যান করুন অথবা নিচের লিংক কপি করুন",
      subheading2: "আপনার ফোনে কিউআর স্ক্যান করুন অথবা লিংক খুলুন",
      text: "প্রক্রিয়া সম্পূর্ণ করুন",
      text1: "জমা দেওয়ার জন্য এখানে চেক করুন",
      button: "কপি করুন",
      copiedButton: "কপি করা হয়েছে!",
      copied: "কপি হয়েছে!"
    },
    SsnReview: {
      heading: "আপনার বিবরণ পর্যালোচনা করুন",
      subHeading: "যেকোন প্রয়োজনীয় পরিবর্তন করুন এবং বিবরণ জমা দিন",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "বিবরণ সঠিক"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "আপনার মুখ বৃত্তের মধ্যে রাখুন"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ক্যামেরার কাছে আসুন"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "লজ্জা পাবেন না, সামনে আসুন"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "খুব অন্ধকার। বেশি আলোতে যান"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "খুব উজ্জ্বল। নরম আলোতে যান"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "আপনার মুখ বৃত্তের মধ্যে রাখুন"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "স্থির থাকুন"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "আলোর দিকে মুখ ফেরান"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ফোন চোখের সমান উচ্চতায় ধরুন"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ক্যামেরা থেকে একটু দূরে সরুন"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "আপনার মুখ ফ্রেমের মাঝখানে রাখুন"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "আপনার মুখ বৃত্তের কেন্দ্রে রাখুন"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "কাছে আসুন এবং আপনার মুখ সোজা রাখুন"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "দৃশ্যে আসুন এবং আপনার মুখ সোজা রাখুন"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "খুব অন্ধকার। আরো উজ্জ্বল আলো খুঁজুন"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "খুব উজ্জ্বল। উপযুক্ত আলো খুঁজুন"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "আপনার মুখ বৃত্তের কেন্দ্রে সামঞ্জস্য করুন"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "স্থির থাকুন এবং সোজা সামনে তাকান"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "আলোর দিকে মুখ করুন এবং স্থির থাকুন"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "আপনার ফোনটি চোখের স্তরে রাখুন"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ক্যামেরা থেকে কিছুটা দূরে চলে যান"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "পারফেক্ট!"
      },
      smile1: {
        icon: "mood",
        description: "মুচকি হোন, আপনি দারুণ দেখাচ্ছেন!"
      },
      smile2: {
        icon: "mood",
        description: "ক্যামেরার জন্য মুচকি হোন!"
      }
    },
    successful: {
      title: "ধন্যবাদ!",
      text: "আমরা আপনার পরিচয় যাচাই করার জন্য সমস্ত প্রয়োজনীয় তথ্য সংগ্রহ করেছি",
      finishBtn: "শেষ"
    },
    poweredBy: "চালিত",
    redirect: "পুনঃনির্দেশিত হচ্ছে",
    error: {
      message: "ইউআরএল মেয়াদোত্তীর্ণ অথবা বৈধ নয়"
    },
    sessionExpiredError: {
      heading: "দুঃখিত, আপনার সেশন মেয়াদোত্তীর্ণ হয়েছে",
      subHeading1: "আপনি কিছু সময়ের জন্য সক্রিয় ছিলেন না। নিরাপত্তা উদ্বেগের জন্য, আপনার সেশন স্বয়ংক্রিয়ভাবে মেয়াদোত্তীর্ণ হয়েছে",
      subHeading2: "দয়া করে আবার চেষ্টা করুন",
      buttonText: "পুনরায় চেষ্টা করুন"
    },
    journeyExpiredError: {
      heading: "দুঃখিত, লিংক মেয়াদোত্তীর্ণ হয়েছে",
      subHeading1: "লিংকটি আর সক্রিয় নেই। নিরাপত্তা উদ্বেগের জন্য, লিংকগুলির একটি সীমিত জীবনকাল রয়েছে",
      subHeading2: "দয়া করে নতুন লিংক দিয়ে চেষ্টা করুন",
      buttonText: "পুনরায় চেষ্টা করুন"
    },
    cameraAccessError: {
      alert1: "ক্যামেরা অ্যাক্সেস অস্বীকার করা হয়েছে। দয়া করে আপনার ব্রাউজার সেটিংসে ক্যামেরা অ্যাক্সেস সক্ষম করুন",
      alert2: "ক্যামেরা অ্যাক্সেস করতে একটি ত্রুটি ঘটেছে",
      alert3: "আপনার ব্রাউজার ক্যামেরা অ্যাক্সেস সমর্থন করে না"
    },
    footer: {
      securedBy: "চালিত"
    },
    helpFaq: {
      title: "সাহায্য এবং প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী",
      subtitle: "আমরা এখানে আপনাকে সাহায্য করতে এসেছি",
      cameraText: "আপনার পরিচয় যাচাই করতে, আমাদের আপনার ডিভাইসের ক্যামেরা ব্যবহার করে ছবি তোলা দরকার। প্রয়োজনীয় অনুমতি দেওয়ার উপায় জানতে এই link অনুসরণ করুন",
      cameraHeading: "ক্যামেরার অনুমতি",
      languageText: "প্রক্রিয়ার শুরুতে, আপনি উপরের বারের ড্রপডাউন মেনু থেকে আপনার পছন্দের ভাষা নির্বাচন করতে পারেন",
      languageHeading: "ভাষা নির্বাচন",
      kycText: "KYC, বা আপনার গ্রাহককে জানুন, এটি গ্রাহকের পরিচয় যাচাই করার একটি প্রক্রিয়া যা সম্মতি নিশ্চিত করতে এবং জালিয়াতি ও অন্যান্য বেআইনি কার্যকলাপ প্রতিরোধ করতে সহায়তা করে",
      kycHeading: "KYC কী?",
      timeText: "সাধারণত এটি প্রায় ৬০ সেকেন্ড সময় নেয়। তবে, এটি বিভিন্ন দেশের উপর নির্ভর করে পরিবর্তিত হতে পারে",
      timeHeading: "এটি কতক্ষণ সময় নেবে?"
    },
    pdfPreviewUnavailable: "PDF-এর প্রিভিউ দেখানো যাচ্ছে না।",
    pdfPreviewHint: "প্রিভিউ না দেখা গেলেও আপনি এগিয়ে যেতে পারেন।",
    pdfOpenLabel: "PDF খুলুন",
    failedUpload: {
      title: "ফাইল আপলোড ব্যর্থ হয়েছে",
      text: "অনুগ্রহ করে নিশ্চিত করুন ফাইলটি 5MB-এর কম এবং .jpg, .jpeg, .png, .heic, .heif বা .pdf ফরম্যাটে আছে",
      btn: "পুনরায় চেষ্টা করুন",
      pdfNotAllowedIndia: "ভারতের জন্য PDF আপলোড করার অনুমতি নেই। অনুগ্রহ করে 5 MB-এর কম JPEG, JPG, PNG, HEIC, বা HEIF ফাইল আপলোড করুন।",
      pdfNotAllowedIndiaBasic: "ভারতের জন্য PDF আপলোড করার অনুমতি নেই। অনুগ্রহ করে 5 MB-এর কম JPEG, JPG, বা PNG ফাইল আপলোড করুন।"
    },
    livenessAnalyzing: {
      heading: "আপনার মুখ বিশ্লেষণ করা হচ্ছে",
      subHeading: "অনুগ্রহ করে অপেক্ষা করুন, এতে মাত্র কয়েক সেকেন্ড লাগবে"
    },
    activeLiveness: {
      instruction: "আপনার মুখ বৃত্তের মধ্যে রাখুন এবং নির্দেশাবলী অনুসরণ করুন",
      permissionDeniedTitle: "ক্যামেরা বা মাইক্রোফোন অ্যাক্সেস অস্বীকৃত",
      permissionDeniedSubtitle: "অনুগ্রহ করে আপনার ব্রাউজার সেটিংসে ক্যামেরা এবং মাইক্রোফোন অ্যাক্সেসের অনুমতি দিন এবং আবার চেষ্টা করুন।"
    },
    flipScreen: {
      heading: "এখন আপনার আইডি কার্ড উল্টান",
      subHeading: "অনুগ্রহ করে পিছনের দিকটি দেখাতে আপনার আইডি কার্ডটি শারীরিকভাবে উল্টান, তারপর এটি ক্যামেরা ফ্রেমে রাখুন।",
      continueButton: "চালিয়ে যান"
    },
    mobileDocCapture: {
      frontSide: "সামনের দিক",
      backSide: "পেছনের দিক",
      of: "এর",
      upload: "আপলোড করুন",
      stillNotWorking: "এখনও কাজ করছে না?",
      clickToCapture: "ক্লিক-টু-ক্যাপচার চেষ্টা করুন",
      skip: "এড়িয়ে যান"
    }
,
    permissionPopUp: {
      title: "অনুমতি প্রয়োজন",
      subtitle: "ক্যামেরা ব্যবহার করতে অ্যাক্সেসের অনুমতি দিন",
      decline: "প্রত্যাখ্যান করুন",
      allow: "অনুমতি দিন"
    },
    userDetails: {
      heading: "PAN যাচাইকরণ",
      subHeading: "যাচাই করতে অনুগ্রহ করে বিবরণ পূরণ করুন",
      panLabel: "PAN নম্বর",
      panRequired: "অনুগ্রহ করে আপনার PAN নম্বর লিখুন",
      saveError: "বিবরণ সংরক্ষণের সময় কিছু ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
      proceed: "এগিয়ে যান"
    },
    redirectCta: {
      or: "অথবা",
      clickHere: "এখানে ক্লিক করুন",
      clickHereStart: "এখানে ক্লিক করুন",
      toContinue: "চালিয়ে যেতে"
    },
    documentCapture: {
      stillNotWorking: "এখনও কাজ করছে না?",
      clickToCaptureInstead: "পরিবর্তে ক্লিক-টু-ক্যাপচার চেষ্টা করুন",
      pdfNotAllowedIndia: "ভারতের জন্য PDF আপলোডের অনুমতি নেই। অনুগ্রহ করে 5 MB-এর কম JPEG, JPG, বা PNG ফাইল আপলোড করুন।",
      pdfNotAllowedIndiaMobile: "ভারতের জন্য PDF আপলোডের অনুমতি নেই। অনুগ্রহ করে 5 MB-এর কম JPEG, JPG, PNG, HEIC, বা HEIF ফাইল আপলোড করুন।",
      fileFormatsIndia: "jpeg, jpg, png 5 mb-এর কম",
      fileFormats: "jpeg, jpg, png, pdf 5 mb-এর কম",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb-এর কম",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb-এর কম"
    },
    mobileCapture: {
      upload: "আপলোড করুন",
      skip: "এড়িয়ে যান",
      stillNotWorking: "এখনও কাজ করছে না?",
      tryClickToCapture: "ট্যাপ করে ছবি তুলুন"
    },
    UserDetails: {
      panLabel: "PAN নম্বর",
      proceedBtn: "এগিয়ে যান",
      panRequired: "অনুগ্রহ করে আপনার PAN নম্বর লিখুন",
      saveError: "বিবরণ সংরক্ষণ করার সময় কিছু সমস্যা হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।"
    }
  },
  pt: {
    supportingDocument: {
      headingFallback: "Documento de apoio",
      subHeading: "Envie o documento abaixo. Ele é armazenado para revisão — nada é extraído dele.",
      choosePlaceholder: "Escolha um arquivo (PNG, JPG ou PDF)",
      continue: "Continuar",
      uploading: "Enviando...",
      skip: "Pular por enquanto",
      errorInvalidType: "Envie um arquivo PNG, JPG ou PDF.",
      errorTooLarge: "O arquivo é muito grande. O limite é 10MB.",
      errorRead: "Não foi possível ler esse arquivo. Tente outro.",
      errorNoFile: "Escolha um arquivo para enviar.",
    },
    header: {
      title: "Vamos verificar sua identidade",
      subtitle: "Leva menos de 2 minutos",
      havingIssue: "Está com problemas?"
    },
    onlyIdVerificationHeader: {
      title: "Vamos verificar seu documento de identidade",
      subtitle: "Isso só levará um minuto. Tenha seu documento em mãos",
      instruction1: "Permitir acesso à câmera",
      instruction2: "Digitalizar ou enviar seu documento",
      instruction3: "Verificação instantânea do documento"
    },
    subHeading: {
      subHeading1: "Capture seu documento de ID",
      subHeading2: "Verifique se você está ao vivo",
      livenessHeading1: "Encontre um local com boa iluminação",
      livenessHeading2: "Mantenha o seu rosto no centro"
    },
    termsAndCondition: {
      title: "Eu concordo em consentir e aderir aos seguintes termos e condições.",
      privacyPolicy: "Ver termos",
      beginBtnText: "Começar",
      beginLiveness: "Iniciando verificação de vida",
      startLiveness: "Prosseguir para verificação de vida"
    },
    permissionDenied: {
      title: "Acesso à câmera negado!",
      subtitle: "Verifique se há um ícone de câmera bloqueada próximo à barra de endereços do navegador e desbloqueie-o.",
      readMore: "Saiba mais",
      refreshText: "Uma vez que o acesso à câmera seja permitido, clique no botão de atualização abaixo.",
      refreshBtn: "Atualizar",
      link: "Ou, continue no telefone",
      buttonText: "Ou, continue no telefone"
    },
    desktopBrowserPermissionDenied: {
      readMore: "Saiba mais",
      refreshText: "Uma vez que o acesso à câmera seja permitido, clique no botão de atualização abaixo.",
      refreshBtn: "Atualizar",
      link: "Ou, continue no telefone",
      buttonText: "Ou, continue no telefone",
      title: "Acesso à câmera negado!",
      subtitle: "Verifique se há um ícone de câmera bloqueada próximo à barra de endereços do navegador e desbloqueie-o."
    },
    androidBrowserPermissionDenied: {
      title: "Acesso à câmera negado!",
      subtitle: "Verifique se há um ícone de câmera bloqueada próximo à barra de endereços do navegador e desbloqueie-o.",
      readMore: "Saiba mais",
      refreshText: "Uma vez que o acesso à câmera seja permitido, clique no botão de atualização abaixo.",
      refreshBtn: "Atualizar",
      link: "Ou, continue no telefone",
      buttonText: "Ou, continue no telefone"
    },
    androidWebViewPermissionDenied: {
      title: "Acesso à câmera negado!",
      subtitle: "O acesso à câmera pode estar bloqueado pelas configurações do aplicativo. Verifique em Informações do aplicativo > Permissões > Câmera e permita o acesso.",
      refreshText: "Uma vez que o acesso à câmera seja permitido, clique no botão de atualização abaixo.",
      refreshBtn: "Atualizar",
      link: "Ou, continue no telefone",
      buttonText: "Ou, continue no telefone"
    },
    iosBrowserPermissionDenied: {
      title: "Acesso à câmera negado!",
      subtitle: "Toque no ícone da câmera ou do cadeado próximo à barra de endereços para permitir o acesso ou verifique as configurações do navegador.",
      readMore: "Saiba mais",
      refreshText: "Uma vez que o acesso à câmera seja permitido, clique no botão de atualização abaixo.",
      refreshBtn: "Atualizar",
      link: "Ou, continue no telefone",
      buttonText: "Ou, continue no telefone"
    },
    iosWebViewPermissionDenied: {
      title: "Acesso à câmera negado!",
      subtitle: "O acesso à câmera pode estar bloqueado pelas configurações do seu aplicativo. Vá para Configurações, encontre o aplicativo que está usando e ative a permissão para a câmera.",
      refreshText: "Uma vez que o acesso à câmera seja permitido, clique no botão de atualização abaixo.",
      refreshBtn: "Atualizar",
      link: "Ou, continue no telefone",
      buttonText: "Ou, continue no telefone"
    },
    documentationList: {
      countryHeading: "Selecione o país",
      docHeading: "Selecione seu documento",
      btnText: "Próximo",
      searchCountry: "Pesquisar país"
    },
    frontDocCapture: {
      heading: "Coloque o lado frontal do ID no retângulo",
      backupHeading: "Tendo problemas? Clique na imagem manualmente",
      btnText: "Tirar foto",
      headingBack: " dentro do retângulo",
      uploadButton: "ou, envie o documento"
    },
    backDocCapture: {
      heading: "Coloque o verso do ID no retângulo",
      backupHeading: "Tendo problemas? Clique na imagem manualmente",
      btnText: "Tirar foto",
      containerText: "ou, faça o upload do documento",
      text: "Capturando, mantenha-se imóvel",
      skipButton: "Pular verso",
      headingBack: " dentro do retângulo",
      uploadButton: "ou, envie o documento"
    },
    analyzing: {
      heading: "Analisando seu ID",
      subHeading: "Por favor, aguarde, isso levará apenas alguns segundos"
    },
    imageCheck: {
      heading: "Verifique sua imagem",
      subHeading: "Certifique-se de que a imagem está completa, clara e sem borrões ou reflexos.",
      button1: "Re-tirar foto",
      button2: "Tudo certo",
      frontHeading: "Verifique sua imagem frontal",
      backHeading: "Verifique sua imagem traseira"
    },
    errorHandler: {
      heading: "Ops:(",
      subHeading1: "Estamos enfrentando alguns problemas, mas não se preocupe! Por favor, tente novamente",
      subHeading2: "Se isso persistir, verifique novamente mais tarde",
      button: "Tentar novamente"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Por favor, remova qualquer coisa cobrindo seu rosto",
        button: "Tentar novamente"
      },
      eyeClosureDetected: {
        heading: "Por favor, mantenha os olhos abertos e olhe diretamente para a câmera",
        button: "Tentar novamente"
      },
      isMultipleFacesFound: {
        heading: "Vários rostos detectados. Certifique-se de que apenas o seu rosto esteja visível na câmera.",
        button: "Tentar novamente"
      },
      noFacesFound: {
        heading: "Nenhum rosto detectado. Certifique-se de que seu rosto esteja visível na câmera.",
        button: "Tentar novamente"
      },
      faceDetections: {
        heading: "Por favor, remova isso",
        button: "Tentar novamente"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Múltiplos rostos encontrados",
          button: "Tentar novamente"
        },
        generalMessage: {
          heading: "Por favor, certifique-se de estar ao vivo na frente da câmera",
          button: "Tentar novamente"
        }
      },
      faceMatch: {
        heading: "Seu rosto não corresponde à foto do documento de identidade",
        button: "Tentar novamente"
      },
      selfieError: {
        heading: "Não conseguimos verificar sua selfie",
        subHeading1: "Basta seguir essas dicas e tentar novamente",
        instruction1: "Vá para um local bem iluminado e evite luz contra o rosto",
        instruction2: "Mantenha seu rosto totalmente visível e centralizado no quadro",
        instruction3: "Remova chapéus, óculos ou máscaras para uma visão clara do seu rosto",
        button: "Tentar novamente"
      },
      activeLivenessOtpFailureMessage: {
        heading: "O OTP não corresponde. Por favor, leia o OTP em voz alta e com clareza",
        button: "Tentar novamente"
      },
      activeLivenessGenericFailureMessage: {
        heading: "A verificação falhou. Por favor, siga as instruções com clareza e tente novamente",
        button: "Tentar novamente"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "O PDF tem páginas demais",
        subHeading: "O PDF enviado excede o limite de 2 páginas. Envie um PDF com no máximo 2 páginas ou uma imagem nítida do seu documento."
      },
      heading: "Não conseguimos processar sua ID",
      subHeading: "Ou você está carregando um documento errado ou a imagem não está clara",
      buttonBack: "Tentar novamente o verso da ID",
      buttonFront: "Tentar novamente a frente da ID",
      button: "Tentar novamente",
      captureFrontSide: "Capturar a frente",
      captureBackSide: "Capturar o verso",
      changeIDButton: "Escolha outro documento",
      wrongid: {
        heading: "Não conseguimos processar este documento",
        subHeading: "Por favor, verifique se está carregando o documento correto e que a qualidade da imagem está boa"
      },
      expiredid: {
        heading: "Documento de ID Expirado!",
        subHeading: "Não podemos aceitar um documento de ID expirado. Por favor, forneça um documento válido"
      },
      minimumage: {
        heading: "Requisito de Idade Não Cumprido!",
        subHeading: "Sua idade está abaixo da idade mínima exigida. Por favor, garanta que você atende ao critério de idade mínima"
      },
      mobileAttemptsDone: {
        heading: "A jornada foi retomada no seu dispositivo anterior",
        subHeading: "Esta sessão foi interrompida para evitar duplicação"
      },
      finished: {
        heading: "A jornada terminou",
        subHeading: "A jornada foi concluída ou encerrada"
      },
      invalid: {
        heading: "Jornada Indisponível!",
        subHeading: "Nenhum journeyId encontrado ou journeyId inválido"
      },
      DOCTYPE_FALSE: {
        heading: "Documento não reconhecido!",
        subHeading: "Por favor, envie um documento válido e garanta que a qualidade da imagem está boa."
      },
      ONLY_FRONT: {
        heading: "Verso do documento de identidade ausente",
        subHeading: "Você enviou apenas o lado frontal. Por favor, vire seu documento e envie o verso para continuar"
      },
      ONLY_BACK: {
        heading: "Frente do documento de identidade ausente",
        subHeading: "Você enviou apenas o verso. Por favor, vire seu documento e envie o lado frontal para continuar"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Documento prestes a expirar!",
        subHeading: "O documento foi rejeitado porque está prestes a expirar."
      },
      DOCUMENT_EXPIRED: {
        heading: "Documento Expirado!",
        subHeading: "Por favor, envie um documento válido e não expirado para continuar."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Requisito de Idade Não Cumprido!",
        subHeading: "O documento indica que você não atende à idade exigida. Por favor, envie um documento válido."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Não foi possível verificar o documento!",
        subHeading: "A qualidade da imagem está muito baixa para verificação. Por favor, tente novamente com uma imagem mais clara."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Não foi possível verificar o documento!",
        subHeading: "Algumas informações não puderam ser verificadas. Por favor, tente novamente com uma imagem mais clara."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Não foi possível verificar o documento!",
        subHeading: "Alguns detalhes não puderam ser verificados devido à baixa qualidade da imagem. Por favor, tente novamente com uma imagem mais clara."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Não foi possível verificar o documento!",
        subHeading: "Alguns detalhes não puderam ser verificados. Por favor, tente novamente com uma imagem mais clara."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problema ao verificar sua foto no documento",
        subHeading: "Não conseguimos verificar sua foto no documento de identidade. Por favor, envie uma foto clara do seu documento original para que possamos confirmá-lo."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Falha na verificação do padrão de segurança do documento",
        subHeading: "Não conseguimos verificar os padrões de segurança incorporados do documento. Por favor, envie uma foto nítida do documento original para nos ajudar a confirmar sua autenticidade."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Falha na verificação de vitalidade do documento",
        subHeading: "Detectamos que o documento pode não ser genuíno. Evite usar capturas de tela, cópias impressas ou mostrar o documento em uma tela. Faça upload do documento original com todos os elementos claramente visíveis."
      },
      SECURITY_FALSE: {
        heading: "Problema Detectado!",
        subHeading: "Não foi possível verificar o documento. Por favor, tente novamente com uma imagem mais clara."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Qualidade da Imagem Ruim!",
        subHeading: "A imagem está muito borrada ou pouco clara. Por favor, tente novamente com uma imagem mais clara."
      },
      FACE_UNDETECTED: {
        heading: "Rosto não detectado",
        subHeading: "Não conseguimos encontrar um rosto visível no documento. Por favor, faça o upload de um documento de identidade válido onde o rosto esteja claramente visível."
      },
      INVALID_PAN_NUMBER: {
        heading: "Número PAN inválido",
        subHeading: "O número PAN que você inseriu não é válido. Por favor, verifique e tente novamente"
      },
      INVALID_PAN_STATUS: {
        heading: "Status de PAN inválido",
        subHeading: "O número PAN que você inseriu não é válido. Por favor, verifique e tente novamente"
      },
      directKyc: {
        heading: "Jornada KYC direta !",
        subHeading: "Esta é uma jornada KYC direta. A jornada de frontend não é permitida."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Falha na comparação entre documentos",
        subHeading: "A comparação entre documentos falhou devido a uma divergência em um ou mais campos principais (nome, data de nascimento ou rosto)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Falha no Digilocker",
        subHeading: "Ocorreu um erro durante a jornada do Digilocker. Por favor, tente novamente ou use um método alternativo para continuar."
      },
      LINKAGE_FAILED: {
        heading: "Não foi possível concluir esta verificação",
        subHeading: "Os dados capturados não corresponderam aos registros desta verificação."
      }
    },
    biometricConsent: {
      consentStatement: "Antes da sua selfie, precisamos do seu consentimento para capturar e processar os seus dados biométricos (imagem facial e sinais de vivacidade) para verificar a sua identidade. Estes dados são usados apenas para esta verificação.",
      privacyPolicy: "Política de privacidade",
      consentButton: "Eu consinto — Continuar",
      declineButton: "Não consinto",
      confirmTitle: "Continuar sem verificação biométrica?",
      confirmBody: "Sem verificação biométrica, não capturaremos uma selfie. A sua verificação será concluída com as informações que já forneceu. Esta escolha é definitiva para esta sessão.",
      goBack: "Voltar",
      confirmDecline: "Confirmar — não consinto",
      declineComplete: "Optou por não prosseguir com a verificação biométrica. A verificação da sua identidade foi concluída com os documentos que enviou."
    },
    introLiveness: {
      heading: "Confirme que você está ao vivo aqui",
      instruction1: "Certifique-se de que há luz suficiente",
      instruction2: "Permita as permissões necessárias",
      instruction3: "Apenas siga as instruções",
      button: "Prosseguir",
      subHeading: "Você está a apenas um passo"
    },
    phoneSession: {
      heading: "Sessão continuada no telefone",
      subheading: "Mantenha esta janela aberta, até terminar no mobile",
      button: "Continuar aqui"
    },
    continueOnPhone: {
      heading: "Continue no telefone",
      subheading: "Escaneie o QR ou copie o link abaixo",
      subheading2: "Escaneie o QR ou abra o link no seu telefone",
      text: "Complete o processo",
      text1: "Volte aqui para enviar",
      button: "Copiar",
      copiedButton: "Copiado!",
      copied: "Copiado!"
    },
    SsnReview: {
      heading: "Revise seus detalhes",
      subHeading: "Faça quaisquer alterações necessárias e envie os detalhes",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "Detalhes estão corretos"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Mantenha o rosto no círculo"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Aproxime-se da câmera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Não tenha vergonha, apareça"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Muito escuro. Procure mais luz"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Muito claro. Procure luz suave"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Mantenha o rosto no círculo"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Fique parado"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Vire o rosto para a luz"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Segure o telefone na altura dos olhos"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Afaste-se um pouco da câmera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Centralize o rosto no quadro"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Posicione seu rosto no centro do círculo"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Aproxime-se e mantenha o rosto reto"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Entre na visão e mantenha o rosto reto"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Muito escuro. Encontre uma luz mais brilhante"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Muito brilhante. Encontre uma luz ideal"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Ajuste seu rosto ao centro do círculo"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Fique firme e olhe para frente"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Fique de frente para a luz e mantenha-se firme"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Segure o telefone ao nível dos olhos"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Afaste-se um pouco da câmera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perfeito!"
      },
      smile1: {
        icon: "mood",
        description: "Sorria, você está ótimo!"
      },
      smile2: {
        icon: "mood",
        description: "Sorria para a câmera!"
      }
    },
    successful: {
      title: "Obrigado!",
      text: "Coletamos todas as informações necessárias para verificar sua identidade",
      finishBtn: "Concluir"
    },
    poweredBy: "Desenvolvido por",
    redirect: "Redirecionando em",
    error: {
      message: "URL expirado ou não válido"
    },
    sessionExpiredError: {
      heading: "Desculpe, sua sessão expirou",
      subHeading1: "Você esteve inativo por um tempo. Por questões de segurança, sua sessão expirou automaticamente",
      subHeading2: "Por favor, tente novamente",
      buttonText: "Tentar novamente"
    },
    journeyExpiredError: {
      heading: "Desculpe, o link expirou",
      subHeading1: "O link não está mais ativo. Por questões de segurança, os links têm uma vida útil limitada",
      subHeading2: "Por favor, tente com um novo link",
      buttonText: "Tentar novamente"
    },
    cameraAccessError: {
      alert1: "O acesso à câmera foi negado. Por favor, habilite o acesso à câmera nas configurações do seu navegador",
      alert2: "Ocorreu um erro ao acessar a câmera",
      alert3: "Seu navegador não suporta acesso à câmera"
    },
    footer: {
      securedBy: "Desenvolvido por"
    },
    helpFaq: {
      title: "Ajuda e Perguntas Frequentes",
      subtitle: "Estamos aqui para ajudar você",
      cameraText: "Para verificar sua identidade, precisamos capturar imagens usando a câmera do seu dispositivo. Siga este link para aprender como conceder as permissões necessárias",
      cameraHeading: "Permissão da câmera",
      languageText: "No início do processo, você pode escolher seu idioma preferido selecionando-o no menu suspenso na barra superior",
      languageHeading: "Seleção de idioma",
      kycText: "KYC, ou Conheça Seu Cliente, é um processo para verificar as identidades dos clientes, garantindo conformidade e prevenindo fraudes e outras atividades ilegais",
      kycHeading: "O que é KYC?",
      timeText: "Normalmente, leva cerca de 60 segundos. No entanto, isso pode variar dependendo dos países",
      timeHeading: "Quanto tempo vai levar?"
    },
    pdfPreviewUnavailable: "Não é possível mostrar a pré-visualização do PDF.",
    pdfPreviewHint: "Se a pré-visualização não aparecer, você ainda pode continuar.",
    pdfOpenLabel: "Abrir PDF",
    failedUpload: {
      title: "Falha no envio do arquivo",
      text: "Certifique-se de que o arquivo tenha menos de 5MB e esteja no formato .jpg, .jpeg, .png, .heic, .heif ou .pdf",
      btn: "Tentar novamente",
      pdfNotAllowedIndia: "Não é permitido enviar PDF para a Índia. Envie arquivos JPEG, JPG, PNG, HEIC ou HEIF com menos de 5 MB.",
      pdfNotAllowedIndiaBasic: "Não é permitido enviar PDF para a Índia. Envie arquivos JPEG, JPG ou PNG com menos de 5 MB."
    },
    livenessAnalyzing: {
      heading: "Analisando o seu rosto",
      subHeading: "Aguarde, isso levará apenas alguns segundos"
    },
    activeLiveness: {
      instruction: "Mantenha o seu rosto dentro do círculo e siga as instruções",
      permissionDeniedTitle: "Acesso à câmera ou ao microfone negado",
      permissionDeniedSubtitle: "Permita o acesso à câmera e ao microfone nas configurações do seu navegador e tente novamente."
    },
    flipScreen: {
      heading: "Agora vire o seu documento de identidade",
      subHeading: "Por favor, vire fisicamente o seu documento de identidade para mostrar o verso e posicione-o dentro do quadro da câmera.",
      continueButton: "Continuar"
    },
    mobileDocCapture: {
      frontSide: "Frente",
      backSide: "Verso",
      of: "de",
      upload: "Carregar",
      stillNotWorking: "Ainda não funciona?",
      clickToCapture: "Tente clicar para capturar",
      skip: "Pular"
    }
,
    permissionPopUp: {
      title: "Permissão necessária",
      subtitle: "Permitir acesso para usar a câmera",
      decline: "Recusar",
      allow: "Permitir"
    },
    userDetails: {
      heading: "Verificação de PAN",
      subHeading: "Por favor preencha os detalhes para verificar",
      panLabel: "Número PAN",
      panRequired: "Por favor insira o seu número PAN",
      saveError: "Algo deu errado ao salvar os detalhes. Por favor tente novamente.",
      proceed: "Continuar"
    },
    redirectCta: {
      or: "ou",
      clickHere: "clique aqui",
      clickHereStart: "Clique aqui",
      toContinue: "para continuar"
    },
    documentCapture: {
      stillNotWorking: "Ainda não está funcionando?",
      clickToCaptureInstead: "Tente a captura por clique",
      pdfNotAllowedIndia: "Uploads de PDF não são permitidos para a Índia. Por favor envie arquivos JPEG, JPG ou PNG com menos de 5 MB.",
      pdfNotAllowedIndiaMobile: "Uploads de PDF não são permitidos para a Índia. Por favor envie arquivos JPEG, JPG, PNG, HEIC ou HEIF com menos de 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png menos de 5 mb",
      fileFormats: "jpeg, jpg, png, pdf menos de 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif menos de 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf menos de 5 mb"
    },
    mobileCapture: {
      upload: "Enviar",
      skip: "Pular",
      stillNotWorking: "Ainda não funciona?",
      tryClickToCapture: "Capture manualmente"
    },
    UserDetails: {
      panLabel: "Número PAN",
      proceedBtn: "Continuar",
      panRequired: "Por favor, insira o seu número PAN",
      saveError: "Algo deu errado ao salvar os dados. Tente novamente."
    }
  },
  ur: {
    supportingDocument: {
      headingFallback: "معاون دستاویز",
      subHeading: "نیچے دستاویز اپ لوڈ کریں۔ اسے جائزے کے لیے محفوظ کیا جاتا ہے — اس سے کچھ اخذ نہیں کیا جاتا۔",
      choosePlaceholder: "ایک فائل منتخب کریں (PNG، JPG یا PDF)",
      continue: "جاری رکھیں",
      uploading: "اپ لوڈ ہو رہا ہے...",
      skip: "ابھی کے لیے چھوڑ دیں",
      errorInvalidType: "PNG، JPG یا PDF فائل اپ لوڈ کریں۔",
      errorTooLarge: "فائل بہت بڑی ہے۔ حد 10MB ہے۔",
      errorRead: "وہ فائل پڑھی نہیں جا سکی۔ براہ کرم دوسری آزمائیں۔",
      errorNoFile: "براہ کرم اپ لوڈ کرنے کے لیے ایک فائل منتخب کریں۔",
    },
    header: {
      title: "آپ کی شناخت کی تصدیق کریں",
      subtitle: "اس میں دو منٹ سے کم وقت لگے گا",
      havingIssue: "کوئی مسئلہ ہے؟"
    },
    onlyIdVerificationHeader: {
      title: "آئیے آپ کے شناختی دستاویز کی تصدیق کریں",
      subtitle: "یہ صرف ایک منٹ لے گا۔ بس اپنا شناختی دستاویز تیار رکھیں",
      instruction1: "کیمرے تک رسائی کی اجازت دیں",
      instruction2: "دستاویز اسکین کریں یا اپ لوڈ کریں",
      instruction3: "فوری دستاویز کی تصدیق"
    },
    subHeading: {
      subHeading1: "اپنی شناختی دستاویز کو پکڑیں",
      subHeading2: "یقین کریں کہ آپ زندہ ہیں",
      livenessHeading1: "اچھی روشنی والی جگہ تلاش کریں",
      livenessHeading2: "اپنا چہرہ درمیان میں رکھیں"
    },
    termsAndCondition: {
      title: "میں درج ذیل شرائط و ضوابط پر رضامندی دیتا ہوں اور ان کی پابندی کروں گا۔",
      privacyPolicy: "شرائط دیکھیں",
      beginBtnText: "شروع کریں",
      beginLiveness: "زندگی کی جانچ شروع ہو رہی ہے",
      startLiveness: "زندگی کی جانچ کے لیے آگے بڑھیں"
    },
    permissionDenied: {
      title: "کیمرہ تک رسائی مسترد کر دی گئی!",
      subtitle: "براؤزر کے ایڈریس بار کے قریب ایک بلاک شدہ کیمرہ آئیکن چیک کریں اور اسے ان بلاک کریں۔",
      readMore: "مزید معلومات حاصل کریں",
      refreshText: "ایک بار کیمرہ تک رسائی کی اجازت مل جانے کے بعد، نیچے دیے گئے ریفریش بٹن پر کلک کریں۔",
      refreshBtn: "ریفریش",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں"
    },
    desktopBrowserPermissionDenied: {
      readMore: "مزید معلومات حاصل کریں",
      refreshText: "ایک بار کیمرہ تک رسائی کی اجازت مل جانے کے بعد، نیچے دیے گئے ریفریش بٹن پر کلک کریں۔",
      refreshBtn: "ریفریش",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں",
      title: "کیمرہ تک رسائی مسترد کر دی گئی!",
      subtitle: "براؤزر کے ایڈریس بار کے قریب ایک بلاک شدہ کیمرہ آئیکن چیک کریں اور اسے ان بلاک کریں۔"
    },
    androidBrowserPermissionDenied: {
      title: "کیمرہ تک رسائی مسترد کر دی گئی!",
      subtitle: "براہ کرم براؤزر کے ایڈریس بار کے قریب بلاک شدہ کیمرہ آئیکن کو چیک کریں اور اسے ان بلاک کریں۔",
      readMore: "مزید جانیں",
      refreshText: "جب کیمرہ تک رسائی کی اجازت دے دی جائے، تو نیچے ریفریش بٹن پر کلک کریں۔",
      refreshBtn: "ریفریش کریں",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں"
    },
    androidWebViewPermissionDenied: {
      title: "کیمرہ تک رسائی مسترد کر دی گئی!",
      subtitle: "کیمرہ کی رسائی آپ کے ایپ کی سیٹنگز کی وجہ سے بند ہو سکتی ہے۔ براہ کرم فون کی ایپ انفارمیشن > اجازتیں > کیمرہ چیک کریں اور رسائی کی اجازت دیں۔",
      refreshText: "جب کیمرہ تک رسائی کی اجازت دے دی جائے، تو نیچے ریفریش بٹن پر کلک کریں۔",
      refreshBtn: "ریفریش کریں",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں"
    },
    iosBrowserPermissionDenied: {
      title: "کیمرہ تک رسائی مسترد کر دی گئی!",
      subtitle: "براؤزر کے ایڈریس بار کے قریب کیمرہ یا لاک آئیکن پر ٹیپ کریں تاکہ رسائی کی اجازت دی جا سکے، یا براؤزر کی سیٹنگز چیک کریں۔",
      readMore: "مزید جانیں",
      refreshText: "جب کیمرہ تک رسائی کی اجازت دے دی جائے، تو نیچے ریفریش بٹن پر کلک کریں۔",
      refreshBtn: "ریفریش کریں",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں"
    },
    iosWebViewPermissionDenied: {
      title: "کیمرہ تک رسائی مسترد کر دی گئی!",
      subtitle: "کیمرہ کی رسائی آپ کے ایپ کی سیٹنگز کی وجہ سے بند ہو سکتی ہے۔ سیٹنگز میں جائیں، استعمال ہونے والی ایپ تلاش کریں اور کیمرہ کی اجازت فعال کریں۔",
      refreshText: "جب کیمرہ تک رسائی کی اجازت دے دی جائے، تو نیچے ریفریش بٹن پر کلک کریں۔",
      refreshBtn: "ریفریش کریں",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں"
    },
    documentationList: {
      countryHeading: "ملک منتخب کریں",
      docHeading: "اپنی دستاویز منتخب کریں",
      btnText: "اگلا",
      searchCountry: "ملک تلاش کریں"
    },
    frontDocCapture: {
      heading: "شناختی کارڈ کے سامنے والے حصے کو مستطیل میں رکھیں",
      backupHeading: "مسئلہ ہو رہا ہے؟ براہ کرم تصویر دستی طور پر کلک کریں",
      btnText: "تصویر لیں",
      headingBack: " مستطیل کے اندر",
      uploadButton: "یا، شناختی کارڈ اپ لوڈ کریں"
    },
    backDocCapture: {
      heading: "شناختی کارڈ کے پچھلے حصے کو مستطیل میں رکھیں",
      backupHeading: "مسئلہ ہو رہا ہے؟ براہ کرم تصویر دستی طور پر کلک کریں",
      btnText: "تصویر لیں",
      containerText: "یا، دستاویز اپ لوڈ کریں",
      text: "تصویر لے رہے ہیں، خاموش رہیں",
      skipButton: "پچھلے حصے کو چھوڑیں",
      headingBack: " مستطیل کے اندر",
      uploadButton: "یا، شناختی کارڈ اپ لوڈ کریں"
    },
    analyzing: {
      heading: "آپ کی شناخت کا تجزیہ کیا جا رہا ہے",
      subHeading: "براہ کرم انتظار کریں، اس میں صرف چند سیکنڈ لگیں گے"
    },
    imageCheck: {
      heading: "اپنی تصویر چیک کریں",
      subHeading: "براہ کرم یقینی بنائیں کہ تصویر مکمل، واضح اور دھندلی اور چمک سے پاک ہو۔",
      button1: "دوبارہ تصویر لیں",
      button2: "ٹھیک ہے",
      frontHeading: "سامنے کی تصویر چیک کریں",
      backHeading: "پیچھے کی تصویر چیک کریں"
    },
    errorHandler: {
      heading: "اوہ، افسوس:(",
      subHeading1: "ہم کچھ مسائل کا سامنا کر رہے ہیں، لیکن فکر نہ کریں! براہ کرم دوبارہ کوشش کریں",
      subHeading2: "اگر یہ برقرار رہے تو بعد میں چیک کریں",
      button: "دوبارہ کوشش کریں"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "براہ کرم اپنے چہرے کو ڈھانپنے والی کوئی بھی چیز ہٹا دیں",
        button: "دوبارہ کوشش کریں"
      },
      eyeClosureDetected: {
        heading: "براہ کرم اپنی آنکھیں کھلی رکھیں اور سیدھا کیمرے کی طرف دیکھیں",
        button: "دوبارہ کوشش کریں"
      },
      isMultipleFacesFound: {
        heading: "متعدد چہرے پائے گئے ہیں۔ براہ کرم یقین دہانی کریں کہ کیمرے میں صرف آپ کا چہرہ نظر آئے۔",
        button: "دوبارہ کوشش کریں"
      },
      noFacesFound: {
        heading: "کوئی چہرہ نہیں ملا۔ براہ کرم یقین دہانی کریں کہ آپ کا چہرہ کیمرے میں نظر آ رہا ہے۔",
        button: "دوبارہ کوشش کریں"
      },
      faceDetections: {
        heading: "براہ کرم اسے ہٹا دیں",
        button: "دوبارہ کوشش کریں"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "کئی چہرے پائے گئے",
          button: "دوبارہ کوشش کریں"
        },
        generalMessage: {
          heading: "براہ کرم اس بات کو یقینی بنائیں کہ آپ کیمرے کے سامنے زندہ ہیں",
          button: "دوبارہ کوشش کریں"
        }
      },
      faceMatch: {
        heading: "آپ کا چہرہ شناختی کارڈ کی تصویر سے میل نہیں کھاتا",
        button: "دوبارہ کوشش کریں"
      },
      selfieError: {
        heading: "ہم آپ کی سیلفی کی تصدیق نہیں کر سکے",
        subHeading1: "صرف ان ہدایات پر عمل کریں اور دوبارہ کوشش کریں",
        instruction1: "اچھی روشنی والی جگہ پر جائیں اور بیک لائٹ سے بچیں",
        instruction2: "اپنے چہرے کو مکمل طور پر دکھائیں اور فریم کے وسط میں رکھیں",
        instruction3: "چہرے کی صاف نظر کے لیے ٹوپی، چشمے یا ماسک ہٹا دیں",
        button: "دوبارہ کوشش کریں"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP میل نہیں کھایا۔ براہ کرم OTP کو واضح طور پر بلند آواز میں پڑھیں",
        button: "دوبارہ کوشش کریں"
      },
      activeLivenessGenericFailureMessage: {
        heading: "تصدیق ناکام ہوگئی۔ براہ کرم ہدایات پر واضح طور پر عمل کریں اور دوبارہ کوشش کریں",
        button: "دوبارہ کوشش کریں"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF میں بہت زیادہ صفحات ہیں",
        subHeading: "اپ لوڈ کردہ PDF 2 صفحات کی حد سے زیادہ ہے۔ براہ کرم 2 سے زیادہ صفحات والی PDF نہ، یا اپنی شناخت کی واضح تصویر اپ لوڈ کریں۔"
      },
      heading: "ہم آپ کی شناختی کارڈ کو پروسیس نہیں کر سکے",
      subHeading: "یا تو آپ غلط شناختی کارڈ اپلوڈ کر رہے ہیں یا تصویر صاف نہیں ہے",
      buttonBack: "شناختی کارڈ کے پچھلے حصے کو دوبارہ اپلوڈ کریں",
      buttonFront: "شناختی کارڈ کے سامنے والے حصے کو دوبارہ اپلوڈ کریں",
      button: "دوبارہ کوشش کریں",
      captureFrontSide: "سامنے کا رخ کیپچر کریں",
      captureBackSide: "پچھلا رخ کیپچر کریں",
      changeIDButton: "دوسرا دستاویز منتخب کریں",
      wrongid: {
        heading: "ہم اس دستاویز کو پروسیس نہیں کر سکے",
        subHeading: "براہ کرم اس بات کو یقینی بنائیں کہ آپ درست دستاویز اپلوڈ کر رہے ہیں اور تصویر کی معیار صاف ہے"
      },
      expiredid: {
        heading: "شناختی کارڈ کی میعاد ختم ہو گئی ہے!",
        subHeading: "ہم ایک میعاد ختم ہونے والا شناختی کارڈ قبول نہیں کر سکتے۔ براہ کرم ایک درست دستاویز فراہم کریں"
      },
      minimumage: {
        heading: "عمر کی ضروریات پوری نہیں ہوئیں!",
        subHeading: "آپ کی عمر کم از کم ضروری عمر سے کم ہے۔ براہ کرم اس بات کو یقینی بنائیں کہ آپ کم از کم عمر کی شرائط پوری کرتے ہیں"
      },
      mobileAttemptsDone: {
        heading: "سفر آپ کے پچھلے ڈیوائس پر دوبارہ شروع ہو چکا ہے",
        subHeading: "یہ سیشن اب نقل سے بچنے کے لیے بند کر دیا گیا ہے"
      },
      finished: {
        heading: "سفر مکمل ہو چکا ہے",
        subHeading: "سفر مکمل یا منسوخ کر دیا گیا ہے"
      },
      invalid: {
        heading: "سفر دستیاب نہیں!",
        subHeading: "journeyId نہیں ملا یا journeyId غلط ہے"
      },
      DOCTYPE_FALSE: {
        heading: "دستاویز شناخت نہیں کی جا سکی!",
        subHeading: "براہ کرم ایک درست دستاویز اپلوڈ کریں اور تصویر کی معیار اچھی ہو"
      },
      ONLY_FRONT: {
        heading: "شناختی دستاویز کا پچھلا رخ غائب ہے",
        subHeading: "آپ نے صرف سامنے کا رخ اپلوڈ کیا ہے۔ براہ کرم شناختی دستاویز کو پلٹیں اور جاری رکھنے کے لیے پچھلا رخ اپلوڈ کریں"
      },
      ONLY_BACK: {
        heading: "شناختی دستاویز کا سامنے والا رخ غائب ہے",
        subHeading: "آپ نے صرف پچھلا رخ اپلوڈ کیا ہے۔ براہ کرم شناختی دستاویز کو پلٹیں اور جاری رکھنے کے لیے سامنے والا رخ اپلوڈ کریں"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "دستاویز جلد میعاد ختم ہونے والی ہے!",
        subHeading: "دستاویز کو مسترد کر دیا گیا ہے کیونکہ اس کی میعاد جلد ختم ہونے والی ہے۔"
      },
      DOCUMENT_EXPIRED: {
        heading: "دستاویز کی میعاد ختم ہو گئی ہے!",
        subHeading: "براہ کرم ایک درست اور غیر منسوخ دستاویز اپلوڈ کریں"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "عمر کی ضروریات پوری نہیں ہوئیں!",
        subHeading: "دستاویز بتاتی ہے کہ آپ کی عمر مطلوبہ عمر سے کم ہے۔ براہ کرم ایک درست دستاویز اپلوڈ کریں"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "تصویر کا معیار بہت کم ہے۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "کچھ معلومات کی تصدیق نہیں کی جا سکی۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "کچھ تفصیلات خراب تصویر کے معیار کی وجہ سے تصدیق نہیں ہو سکیں۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "کچھ تفصیلات تصدیق نہیں ہو سکیں۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "شناختی کارڈ پر آپ کی تصویر کی تصدیق میں مسئلہ",
        subHeading: "ہم شناختی کارڈ پر موجود آپ کی تصویر کی تصدیق نہیں کر سکے۔ براہ کرم اصل شناختی دستاویز کی واضح تصویر اپلوڈ کریں تاکہ ہم اس کی تصدیق کر سکیں۔"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "دستاویز کے سیکیورٹی پیٹرن کی تصدیق ناکام ہوگئی",
        subHeading: "ہم دستاویز میں موجود بلٹ ان سیکیورٹی پیٹرنز کی تصدیق نہیں کر سکے۔ براہ کرم اصل شناختی دستاویز کی واضح تصویر اپلوڈ کریں تاکہ ہم اس کی صداقت کی تصدیق کر سکیں۔"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "دستاویز کی زندگی کی جانچ ناکام ہو گئی",
        subHeading: "ہمیں ایسے شواہد ملے ہیں کہ یہ دستاویز اصلی نہیں ہو سکتی۔ براہ کرم اسکرین شاٹس، پرنٹ شدہ کاپیاں یا اسکرین پر دکھائی گئی شناختی دستاویزات استعمال نہ کریں۔ اصل دستاویز اپ لوڈ کریں جس میں تمام خصوصیات واضح طور پر نظر آئیں۔"
      },
      SECURITY_FALSE: {
        heading: "مسئلہ دریافت ہوا ہے!",
        subHeading: "دستاویز کی تصدیق نہیں کی جا سکی۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "تصویر کا معیار خراب ہے!",
        subHeading: "تصویر بہت دھندلی یا غیر واضح ہے۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      FACE_UNDETECTED: {
        heading: "چہرہ دریافت نہیں ہوا",
        subHeading: "ہم دستاویز میں کوئی واضح چہرہ نہیں ڈھونڈ سکے۔ براہ کرم ایک درست شناختی کارڈ اپ لوڈ کریں جس میں چہرہ واضح طور پر دکھائی دے۔"
      },
      INVALID_PAN_NUMBER: {
        heading: "غلط PAN نمبر",
        subHeading: "آپ نے جو PAN نمبر درج کیا وہ درست نہیں ہے۔ براہ کرم جانچیں اور دوبارہ کوشش کریں"
      },
      INVALID_PAN_STATUS: {
        heading: "غلط PAN اسٹیٹس",
        subHeading: "آپ نے جو PAN نمبر درج کیا وہ درست نہیں ہے۔ براہ کرم جانچیں اور دوبارہ کوشش کریں"
      },
      directKyc: {
        heading: "ڈائریکٹ KYC سفر !",
        subHeading: "یہ ایک ڈائریکٹ KYC سفر ہے۔ فرنٹ اینڈ سفر کی اجازت نہیں ہے۔"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "دستاویزات کے درمیان موازنہ ناکام",
        subHeading: "ایک یا زیادہ اہم خانوں (نام، تاریخ پیدائش، یا چہرہ) میں عدم مطابقت کی وجہ سے دستاویزات کے درمیان موازنہ ناکام ہوا"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker ناکامی",
        subHeading: "Digilocker کے سفر کے دوران ایک خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں یا جاری رکھنے کے لیے کوئی متبادل طریقہ استعمال کریں۔"
      },
      LINKAGE_FAILED: {
        heading: "یہ تصدیق مکمل نہیں ہو سکی",
        subHeading: "اس جانچ کے لیے حاصل کردہ تفصیلات ریکارڈ سے میل نہیں کھاتیں۔"
      }
    },
    biometricConsent: {
      consentStatement: "اپنی سیلفی سے پہلے، آپ کی شناخت کی تصدیق کے لیے ہمیں آپ کے بائیو میٹرک ڈیٹا (چہرے کی تصویر اور لائیونیس سگنلز) کو کیپچر اور پروسیس کرنے کی آپ کی رضامندی درکار ہے۔ یہ ڈیٹا صرف اسی تصدیق کے لیے استعمال ہوتا ہے۔",
      privacyPolicy: "رازداری کی پالیسی",
      consentButton: "میں رضامند ہوں — جاری رکھیں",
      declineButton: "میں رضامند نہیں ہوں",
      confirmTitle: "بائیو میٹرک تصدیق کے بغیر آگے بڑھیں؟",
      confirmBody: "بائیو میٹرک تصدیق کے بغیر، ہم سیلفی نہیں لیں گے۔ آپ کی تصدیق آپ کی پہلے سے فراہم کردہ معلومات کے ذریعے مکمل کی جائے گی۔ یہ انتخاب اس سیشن کے لیے حتمی ہے۔",
      goBack: "واپس جائیں",
      confirmDecline: "تصدیق کریں — رضامند نہیں",
      declineComplete: "آپ نے بائیو میٹرک تصدیق کے ساتھ آگے نہ بڑھنے کا انتخاب کیا ہے۔ آپ کی شناخت کی تصدیق آپ کے جمع کردہ دستاویزات کے ذریعے مکمل کر دی گئی ہے۔"
    },
    introLiveness: {
      heading: "یقین کریں کہ آپ یہاں زندہ ہیں",
      instruction1: "یقین کریں کہ کافی روشنی ہے",
      instruction2: "ضروری اجازتیں دیں",
      instruction3: "بس ہدایات پر عمل کریں",
      button: "آگے بڑھیں",
      subHeading: "آپ بس ایک قدم کی دوری پر ہیں"
    },
    phoneSession: {
      heading: "سیشن فون پر جاری رہا",
      subheading: "اس ونڈو کو کھلا رکھیں، جب تک موبائل پر مکمل نہ ہو جائے",
      button: "یہاں جاری رکھیں"
    },
    continueOnPhone: {
      heading: "فون پر جاری رکھیں",
      subheading: "QR اسکین کریں یا نیچے دی گئی لنک کو کاپی کریں",
      subheading2: "QR اسکین کریں یا اپنے فون پر لنک کھولیں",
      text: "عمل مکمل کریں",
      text1: "یہاں چیک کریں تاکہ جمع کر سکیں",
      button: "کاپی کریں",
      copiedButton: "کاپی ہو گیا!",
      copied: "کاپی ہو گیا!"
    },
    SsnReview: {
      heading: "اپنے تفصیلات کا جائزہ لیں",
      subHeading: "کوئی ضروری تبدیلیاں کریں اور تفصیلات جمع کریں",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "تفصیلات درست ہیں"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ دائرے میں رکھیں"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "کیمرے کے قریب آئیں"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "شرمائیں نہیں، سامنے آئیں"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت اندھیرا ہے۔ زیادہ روشنی میں جائیں"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت روشن ہے۔ ہلکی روشنی میں جائیں"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ دائرے میں رکھیں"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ساکن رہیں"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "روشنی کی طرف چہرہ کریں"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "فون کو آنکھوں کی سطح پر رکھیں"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "کیمرے سے تھوڑا دور ہوں"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ فریم کے درمیان رکھیں"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "اپنا چہرا دائرے کے بیچ میں رکھیں"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "قریب آئیں اور اپنا چہرا سیدھا رکھیں"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "نظر میں آئیں اور اپنا چہرا سیدھا رکھیں"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت اندھیرا ہے۔ زیادہ روشن روشنی تلاش کریں"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت زیادہ روشن ہے۔ مناسب روشنی تلاش کریں"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "اپنا چہرا دائرے کے بیچ میں ایڈجسٹ کریں"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "مستحکم رہیں اور سیدھے آگے دیکھیں"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "روشنی کی طرف منہ کریں اور مستحکم رہیں"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "اپنی فون کو آنکھ کی سطح پر رکھیں"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "کیمرے سے تھوڑا دور ہٹیں"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "شاندار!"
      },
      smile1: {
        icon: "mood",
        description: "مسکراہٹ برائے مہربانی، آپ بہت اچھے لگ رہے ہیں!"
      },
      smile2: {
        icon: "mood",
        description: "کیمرے کے لیے مسکراہٹ!"
      }
    },
    successful: {
      title: "شکریہ!",
      text: "ہم نے آپ کی شناخت کی تصدیق کے لیے تمام ضروری معلومات جمع کر لی ہیں",
      finishBtn: "ختم کریں"
    },
    poweredBy: "پاورڈ بائی",
    redirect: "ری ڈائریکٹ ہو رہا ہے",
    error: {
      message: "لنک کی مدت ختم ہو گئی ہے یا یہ درست نہیں ہے"
    },
    sessionExpiredError: {
      heading: "معذرت، آپ کا سیشن ختم ہو گیا ہے",
      subHeading1: "آپ کچھ وقت کے لیے غیر فعال رہے ہیں۔ سیکیورٹی کی تشویشات کی وجہ سے، آپ کا سیشن خودبخود ختم ہو گیا ہے",
      subHeading2: "براہ کرم دوبارہ کوشش کریں",
      buttonText: "دوبارہ کوشش کریں"
    },
    journeyExpiredError: {
      heading: "معذرت، لنک کی مدت ختم ہو گئی ہے",
      subHeading1: "لنک اب فعال نہیں ہے۔ سیکیورٹی کی تشویشات کی وجہ سے، لنکس کی محدود مدت ہوتی ہے",
      subHeading2: "براہ کرم نئے لنک کے ساتھ کوشش کریں",
      buttonText: "دوبارہ کوشش کریں"
    },
    cameraAccessError: {
      alert1: "کیمرے کی رسائی مسترد کر دی گئی ہے۔ براہ کرم اپنے براؤزر کی ترتیبات میں کیمرے کی رسائی کو فعال کریں",
      alert2: "کیمرے تک رسائی کے دوران ایک خرابی پیش آئی",
      alert3: "آپ کا براؤزر کیمرے کی رسائی کی حمایت نہیں کرتا"
    },
    footer: {
      securedBy: "پاورڈ بائی"
    },
    helpFaq: {
      title: "مدد اور عمومی سوالات",
      subtitle: "ہم یہاں آپ کی مدد کے لیے موجود ہیں",
      cameraText: "آپ کی شناخت کی تصدیق کے لیے، ہمیں آپ کے ڈیوائس کے کیمرے کا استعمال کرتے ہوئے تصاویر لینے کی ضرورت ہے۔ ضروری اجازت دینے کا طریقہ سیکھنے کے لیے اس link کو فالو کریں",
      cameraHeading: "کیمرہ اجازت",
      languageText: "عمل کے آغاز میں، آپ اوپر کی بار میں موجود ڈراپ ڈاؤن مینو سے اپنی پسندیدہ زبان منتخب کر سکتے ہیں",
      languageHeading: "زبان کا انتخاب",
      kycText: "KYC، یا اپنے گاہک کو جانیے، ایک ایسا عمل ہے جو گاہکوں کی شناخت کی تصدیق کے لیے کیا جاتا ہے تاکہ تعمیل کو یقینی بنایا جا سکے اور دھوکہ دہی اور دیگر غیر قانونی سرگرمیوں کو روکا جا سکے",
      kycHeading: "KYC کیا ہے؟",
      timeText: "عام طور پر، اس میں تقریباً 60 سیکنڈ لگتے ہیں۔ تاہم، یہ ممالک کے لحاظ سے مختلف ہو سکتا ہے",
      timeHeading: "اس میں کتنا وقت لگے گا؟"
    },
    pdfPreviewUnavailable: "PDF کا پیش منظر دکھانے سے قاصر۔",
    pdfPreviewHint: "اگر پیش منظر ظاہر نہ ہو، تب بھی آپ جاری رکھ سکتے ہیں۔",
    pdfOpenLabel: "PDF کھولیں",
    failedUpload: {
      title: "فائل اپ لوڈ ناکام",
      text: "براہ کرم یقینی بنائیں کہ فائل 5MB سے کم اور .jpg، .jpeg، .png، .heic، .heif یا .pdf فارمیٹ میں ہے",
      btn: "دوبارہ کوشش کریں",
      pdfNotAllowedIndia: "بھارت کے لیے PDF اپ لوڈ کی اجازت نہیں ہے۔ براہ کرم 5 MB سے کم کی JPEG، JPG، PNG، HEIC، یا HEIF فائلیں اپ لوڈ کریں۔",
      pdfNotAllowedIndiaBasic: "بھارت کے لیے PDF اپ لوڈ کی اجازت نہیں ہے۔ براہ کرم 5 MB سے کم کی JPEG، JPG، یا PNG فائلیں اپ لوڈ کریں۔"
    },
    livenessAnalyzing: {
      heading: "آپ کے چہرے کا تجزیہ کیا جا رہا ہے",
      subHeading: "براہ کرم انتظار کریں، اس میں صرف چند سیکنڈ لگیں گے"
    },
    activeLiveness: {
      instruction: "اپنے چہرے کو دائرے میں رکھیں اور ہدایات پر عمل کریں",
      permissionDeniedTitle: "کیمرا یا مائیکروفون تک رسائی مسترد",
      permissionDeniedSubtitle: "براہ کرم اپنی براؤزر سیٹنگز میں کیمرا اور مائیکروفون تک رسائی کی اجازت دیں اور دوبارہ کوشش کریں۔"
    },
    flipScreen: {
      heading: "اب اپنا شناختی کارڈ پلٹیں",
      subHeading: "براہ کرم پچھلی طرف دکھانے کے لیے اپنا شناختی کارڈ جسمانی طور پر پلٹیں، پھر اسے کیمرہ فریم میں رکھیں۔",
      continueButton: "جاری رکھیں"
    },
    mobileDocCapture: {
      frontSide: "سامنے کی طرف",
      backSide: "پیچھے کی طرف",
      of: "کا",
      upload: "اپ لوڈ کریں",
      stillNotWorking: "اب بھی کام نہیں کر رہا؟",
      clickToCapture: "کلک ٹو کیپچر آزمائیں",
      skip: "چھوڑ دیں"
    }
,
    permissionPopUp: {
      title: "اجازت درکار ہے",
      subtitle: "کیمرہ استعمال کرنے کے لیے رسائی کی اجازت دیں",
      decline: "انکار کریں",
      allow: "اجازت دیں"
    },
    userDetails: {
      heading: "PAN تصدیق",
      subHeading: "تصدیق کے لیے براہ کرم تفصیلات پُر کریں",
      panLabel: "PAN نمبر",
      panRequired: "براہ کرم اپنا PAN نمبر درج کریں",
      saveError: "تفصیلات محفوظ کرتے وقت کچھ غلط ہو گیا۔ براہ کرم دوبارہ کوشش کریں۔",
      proceed: "آگے بڑھیں"
    },
    redirectCta: {
      or: "یا",
      clickHere: "یہاں کلک کریں",
      clickHereStart: "یہاں کلک کریں",
      toContinue: "جاری رکھنے کے لیے"
    },
    documentCapture: {
      stillNotWorking: "اب بھی کام نہیں کر رہا؟",
      clickToCaptureInstead: "اس کے بجائے کلک ٹو کیپچر آزمائیں",
      pdfNotAllowedIndia: "بھارت کے لیے PDF اپ لوڈ کی اجازت نہیں ہے۔ براہ کرم 5 MB سے کم کی JPEG, JPG, یا PNG فائلیں اپ لوڈ کریں۔",
      pdfNotAllowedIndiaMobile: "بھارت کے لیے PDF اپ لوڈ کی اجازت نہیں ہے۔ براہ کرم 5 MB سے کم کی JPEG, JPG, PNG, HEIC, یا HEIF فائلیں اپ لوڈ کریں۔",
      fileFormatsIndia: "jpeg, jpg, png 5 mb سے کم",
      fileFormats: "jpeg, jpg, png, pdf 5 mb سے کم",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb سے کم",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb سے کم"
    },
    mobileCapture: {
      upload: "اپ لوڈ کریں",
      skip: "چھوڑیں",
      stillNotWorking: "پھر بھی کام نہیں کر رہا؟",
      tryClickToCapture: "ٹیپ کرکے تصویر لیں"
    },
    UserDetails: {
      panLabel: "PAN نمبر",
      proceedBtn: "آگے بڑھیں",
      panRequired: "براہ کرم اپنا PAN نمبر درج کریں",
      saveError: "تفصیلات محفوظ کرتے وقت کچھ غلط ہو گیا۔ براہ کرم دوبارہ کوشش کریں۔"
    }
  },
  id: {
    supportingDocument: {
      headingFallback: "Dokumen pendukung",
      subHeading: "Unggah dokumen di bawah ini. Dokumen disimpan untuk ditinjau — tidak ada yang diekstrak darinya.",
      choosePlaceholder: "Pilih file (PNG, JPG, atau PDF)",
      continue: "Lanjutkan",
      uploading: "Mengunggah...",
      skip: "Lewati untuk sekarang",
      errorInvalidType: "Unggah file PNG, JPG, atau PDF.",
      errorTooLarge: "File terlalu besar. Batasnya 10MB.",
      errorRead: "Tidak dapat membaca file itu. Silakan coba yang lain.",
      errorNoFile: "Silakan pilih file untuk diunggah.",
    },
    header: {
      title: "Verifikasi identitas Anda",
      subtitle: "Ini membutuhkan waktu kurang dari 2 menit",
      havingIssue: "Ada masalah?"
    },
    subHeading: {
      subHeading1: "Ambil dokumen ID Anda",
      subHeading2: "Verifikasi Anda sedang aktif",
      livenessHeading1: "Cari tempat dengan pencahayaan yang baik",
      livenessHeading2: "Jaga wajah Anda tetap di tengah"
    },
    onlyIdVerificationHeader: {
      title: "Verifikasi Identitas Anda",
      subtitle: "Proses ini hanya membutuhkan waktu satu menit. Siapkan dokumen ID Anda",
      instruction1: "Izinkan Akses Kamera",
      instruction2: "Pindai atau Unggah Dokumen Anda",
      instruction3: "Verifikasi Dokumen Instan"
    },
    termsAndCondition: {
      title: "Saya setuju untuk memberikan persetujuan dan mematuhi syarat dan ketentuan berikut.",
      privacyPolicy: "Lihat syarat",
      beginBtnText: "Mulai",
      beginLiveness: "Memulai pemeriksaan keaktifan",
      startLiveness: "Lanjutkan ke pemeriksaan keaktifan"
    },
    permissionDenied: {
      title: "Akses kamera ditolak!",
      subtitle: "Periksa ikon kamera yang diblokir di dekat bilah alamat browser dan buka blokirnya.",
      readMore: "Pelajari lebih lanjut",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Refresh di bawah ini.",
      refreshBtn: "Segarkan",
      link: "Atau, Lanjutkan di Telepon",
      buttonText: "Atau, Lanjutkan di Telepon"
    },
    desktopBrowserPermissionDenied: {
      readMore: "Pelajari lebih lanjut",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Refresh di bawah ini.",
      refreshBtn: "Segarkan",
      link: "Atau, Lanjutkan di Telepon",
      buttonText: "Atau, Lanjutkan di Telepon",
      title: "Akses kamera ditolak!",
      subtitle: "Periksa ikon kamera yang diblokir di dekat bilah alamat browser dan buka blokirnya."
    },
    androidBrowserPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Periksa ikon kamera yang diblokir di dekat bilah alamat browser dan buka blokirnya.",
      readMore: "Pelajari lebih lanjut",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Segarkan di bawah.",
      refreshBtn: "Segarkan",
      link: "Atau, lanjutkan di ponsel",
      buttonText: "Atau, lanjutkan di ponsel"
    },
    androidWebViewPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Akses kamera mungkin diblokir oleh pengaturan aplikasi. Silakan periksa Info Aplikasi > Izin > Kamera dan izinkan akses.",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Segarkan di bawah.",
      refreshBtn: "Segarkan",
      link: "Atau, lanjutkan di ponsel",
      buttonText: "Atau, lanjutkan di ponsel"
    },
    iosBrowserPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Ketuk ikon kamera atau kunci di dekat bilah alamat untuk mengizinkan akses, atau periksa pengaturan browser.",
      readMore: "Pelajari lebih lanjut",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Segarkan di bawah.",
      refreshBtn: "Segarkan",
      link: "Atau, lanjutkan di ponsel",
      buttonText: "Atau, lanjutkan di ponsel"
    },
    iosWebViewPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Akses kamera mungkin diblokir oleh pengaturan aplikasi Anda. Buka Pengaturan, temukan aplikasi yang Anda gunakan, dan aktifkan izin Kamera.",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Segarkan di bawah.",
      refreshBtn: "Segarkan",
      link: "Atau, lanjutkan di ponsel",
      buttonText: "Atau, lanjutkan di ponsel"
    },
    documentationList: {
      countryHeading: "Pilih negara",
      docHeading: "Pilih dokumen Anda",
      btnText: "Selanjutnya",
      searchCountry: "Cari negara"
    },
    frontDocCapture: {
      heading: "Letakkan sisi depan ID di dalam kotak",
      backupHeading: "Mengalami Kesulitan? Silakan klik gambar secara manual",
      btnText: "Ambil foto",
      headingBack: " di dalam persegi panjang",
      uploadButton: "atau, unggah ID"
    },
    backDocCapture: {
      heading: "Letakkan sisi belakang ID di dalam kotak",
      backupHeading: "Mengalami Kesulitan? Silakan klik gambar secara manual",
      btnText: "Ambil foto",
      containerText: "atau, unggah dokumen",
      text: "Mengambil, tetap diam",
      skipButton: "Lewati Sisi Belakang",
      headingBack: " di dalam persegi panjang",
      uploadButton: "atau, unggah ID"
    },
    analyzing: {
      heading: "Menganalisis ID Anda",
      subHeading: "Harap tunggu, ini hanya akan memakan waktu beberapa detik"
    },
    imageCheck: {
      heading: "Periksa gambar Anda",
      subHeading: "Pastikan gambar lengkap, jelas, dan bebas dari blur serta silau.",
      button1: "Ambil Foto Lagi",
      button2: "Bagus untuk dilanjutkan",
      frontHeading: "Periksa gambar depan Anda",
      backHeading: "Periksa gambar belakang Anda"
    },
    errorHandler: {
      heading: "Oh tidak:(",
      subHeading1: "Kami mengalami beberapa masalah, tapi jangan khawatir! Silakan coba lagi",
      subHeading2: "Jika ini berlanjut, periksa kembali nanti",
      button: "Coba lagi"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Silakan lepaskan apa pun yang menutupi wajah Anda",
        button: "Coba lagi"
      },
      eyeClosureDetected: {
        heading: "Silakan buka mata Anda dan lihat langsung ke kamera",
        button: "Coba lagi"
      },
      isMultipleFacesFound: {
        heading: "Terdeteksi beberapa wajah. Pastikan hanya wajah Anda yang terlihat di kamera.",
        button: "Coba lagi"
      },
      noFacesFound: {
        heading: "Tidak ada wajah yang terdeteksi. Pastikan wajah Anda terlihat di kamera.",
        button: "Coba lagi"
      },
      faceDetections: {
        heading: "Silakan lepaskan ini",
        button: "Coba lagi"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Beberapa wajah terdeteksi",
          button: "Coba lagi"
        },
        generalMessage: {
          heading: "Pastikan Anda berada di depan kamera secara langsung",
          button: "Coba lagi"
        }
      },
      faceMatch: {
        heading: "Wajah Anda tidak cocok dengan foto ID",
        button: "Coba lagi"
      },
      selfieError: {
        heading: "Kami tidak dapat memverifikasi selfie Anda",
        subHeading1: "Ikuti tips ini dan coba lagi",
        instruction1: "Cari tempat yang terang dan hindari cahaya latar",
        instruction2: "Pastikan wajah Anda sepenuhnya terlihat dan berada di tengah bingkai",
        instruction3: "Lepaskan topi, kacamata, atau masker untuk tampilan wajah yang jelas",
        button: "Coba lagi"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP tidak cocok. Silakan baca OTP dengan jelas dan lantang",
        button: "Coba Lagi"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verifikasi gagal. Silakan ikuti instruksi dengan jelas dan coba lagi",
        button: "Coba lagi"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF memiliki terlalu banyak halaman",
        subHeading: "PDF yang diunggah melebihi batas 2 halaman. Silakan unggah PDF maksimal 2 halaman, atau gambar identitas yang jelas."
      },
      heading: "Kami tidak dapat memproses ID Anda",
      subHeading: "Entah Anda mengunggah ID yang salah atau gambar tidak jelas",
      buttonBack: "Ulangi Sisi Belakang ID",
      buttonFront: "Ulangi Sisi Depan ID",
      button: "Ulangi",
      captureFrontSide: "Ambil Sisi Depan",
      captureBackSide: "Ambil Sisi Belakang",
      changeIDButton: "Pilih dokumen lain",
      wrongid: {
        heading: "Kami tidak dapat memproses dokumen ini",
        subHeading: "Harap pastikan Anda mengunggah dokumen yang benar dan pastikan kualitas gambar jelas"
      },
      expiredid: {
        heading: "Dokumen ID Kadaluarsa!",
        subHeading: "Kami tidak dapat menerima dokumen ID yang kadaluarsa. Harap berikan dokumen yang valid"
      },
      minimumage: {
        heading: "Persyaratan Usia Tidak Terpenuhi!",
        subHeading: "Usia Anda di bawah usia minimum yang dibutuhkan. Harap pastikan Anda memenuhi kriteria usia minimum"
      },
      mobileAttemptsDone: {
        heading: "Perjalanan dilanjutkan di perangkat Anda sebelumnya",
        subHeading: "Sesi ini sekarang dihentikan untuk menghindari duplikasi."
      },
      finished: {
        heading: "Perjalanan telah berakhir",
        subHeading: "Perjalanan telah selesai atau dihentikan"
      },
      invalid: {
        heading: "Perjalanan Tidak Tersedia !",
        subHeading: "journeyId tidak ditemukan atau ID perjalanan tidak valid"
      },
      INVALID_PAN_NUMBER: {
        heading: "Nomor PAN Tidak Valid",
        subHeading: "Nomor PAN yang Anda masukkan tidak valid. Silakan periksa dan coba lagi"
      },
      INVALID_PAN_STATUS: {
        heading: "Status PAN Tidak Valid",
        subHeading: "Nomor PAN yang Anda masukkan tidak valid. Silakan periksa dan coba lagi"
      },
      directKyc: {
        heading: "Perjalanan KYC Langsung !",
        subHeading: "Ini adalah perjalanan KYC langsung. Perjalanan frontend tidak diizinkan."
      },
      DOCTYPE_FALSE: {
        heading: "Dokumen Salah Diberikan!",
        subHeading: "Silakan unggah dokumen yang valid dan pastikan kualitas gambar baik."
      },
      ONLY_FRONT: {
        heading: "Bagian belakang ID hilang",
        subHeading: "Anda hanya memberikan bagian depan. Silakan balik ID Anda dan berikan bagian belakang untuk melanjutkan"
      },
      ONLY_BACK: {
        heading: "Bagian depan ID hilang",
        subHeading: "Anda hanya memberikan bagian belakang. Silakan balik ID Anda dan berikan bagian depan untuk melanjutkan"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Dokumen Segera Kedaluwarsa",
        subHeading: "Dokumen ditolak karena akan segera kedaluwarsa."
      },
      DOCUMENT_EXPIRED: {
        heading: "Dokumen Kedaluwarsa!",
        subHeading: "Silakan unggah dokumen yang valid dan belum kedaluwarsa untuk melanjutkan."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Persyaratan Usia Tidak Terpenuhi!",
        subHeading: "Dokumen menunjukkan bahwa Anda tidak memenuhi usia yang disyaratkan. Silakan unggah dokumen yang valid."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Tidak Dapat Memverifikasi Dokumen!",
        subHeading: "Kualitas gambar terlalu buruk untuk verifikasi. Silakan coba lagi dengan gambar yang lebih jelas."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Tidak Dapat Memverifikasi Dokumen!",
        subHeading: "Beberapa informasi tidak dapat diverifikasi. Silakan coba lagi dengan gambar yang lebih jelas."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Tidak Dapat Memverifikasi Dokumen!",
        subHeading: "Beberapa detail tidak dapat diverifikasi karena kualitas gambar yang buruk. Silakan coba lagi dengan gambar yang lebih jelas"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Tidak Dapat Memverifikasi Dokumen!",
        subHeading: "Beberapa detail tidak dapat diverifikasi. Silakan coba lagi dengan gambar yang lebih jelas."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Masalah memverifikasi foto Anda pada ID",
        subHeading: "Kami tidak dapat memverifikasi foto Anda pada kartu ID. Silakan unggah foto yang jelas dari ID asli Anda agar kami dapat mengonfirmasinya."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Pemeriksaan pola keamanan dokumen gagal",
        subHeading: "Kami tidak dapat memverifikasi pola keamanan bawaan dokumen. Silakan unggah foto yang jelas dari ID asli untuk membantu kami mengonfirmasi keasliannya."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Pemeriksaan Keaslian Dokumen Gagal",
        subHeading: "Kami menemukan tanda-tanda bahwa dokumen mungkin tidak asli. Harap hindari penggunaan tangkapan layar, salinan cetak, atau menampilkan ID di layar. Unggah ID asli dengan semua fitur terlihat jelas"
      },
      SECURITY_FALSE: {
        heading: "Masalah Terdeteksi!",
        subHeading: "Dokumen tidak dapat diverifikasi. Silakan coba lagi dengan gambar yang lebih jelas"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Kualitas Gambar Buruk!",
        subHeading: "Gambar terlalu buram atau tidak jelas. Silakan coba lagi dengan gambar yang lebih jelas"
      },
      FACE_UNDETECTED: {
        heading: "Wajah Tidak Terdeteksi",
        subHeading: "Kami tidak dapat menemukan wajah yang terlihat pada dokumen. Silakan unggah ID yang valid di mana wajah terlihat jelas"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Perbandingan Antar-Dokumen Gagal",
        subHeading: "Perbandingan antar-dokumen gagal karena ketidaksesuaian pada satu atau beberapa bidang utama (Nama, Tanggal Lahir, atau Wajah)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Kegagalan Digilocker",
        subHeading: "Terjadi kesalahan selama perjalanan Digilocker. Silakan coba lagi atau gunakan metode alternatif untuk melanjutkan."
      },
      LINKAGE_FAILED: {
        heading: "Verifikasi ini tidak dapat diselesaikan",
        subHeading: "Data yang diambil tidak cocok dengan catatan untuk pemeriksaan ini."
      }
    },
    biometricConsent: {
      consentStatement: "Sebelum swafoto Anda, kami memerlukan persetujuan Anda untuk menangkap dan memproses data biometrik Anda (gambar wajah dan sinyal keaktifan) guna memverifikasi identitas Anda. Data ini hanya digunakan untuk verifikasi ini.",
      privacyPolicy: "Kebijakan privasi",
      consentButton: "Saya setuju — Lanjutkan",
      declineButton: "Saya tidak setuju",
      confirmTitle: "Lanjutkan tanpa verifikasi biometrik?",
      confirmBody: "Tanpa verifikasi biometrik, kami tidak akan mengambil swafoto. Verifikasi Anda akan diselesaikan menggunakan informasi yang telah Anda berikan. Pilihan ini bersifat final untuk sesi ini.",
      goBack: "Kembali",
      confirmDecline: "Konfirmasi — tidak setuju",
      declineComplete: "Anda memilih untuk tidak melanjutkan verifikasi biometrik. Verifikasi identitas Anda telah diselesaikan menggunakan dokumen yang Anda kirimkan."
    },
    introLiveness: {
      heading: "Konfirmasi Anda sedang aktif di sini",
      instruction1: "Pastikan ada cukup cahaya",
      instruction2: "Izinkan izin yang diperlukan",
      instruction3: "Ikuti instruksi dengan baik",
      button: "Lanjutkan",
      subHeading: "Anda tinggal satu langkah lagi"
    },
    phoneSession: {
      heading: "Sesi dilanjutkan di telepon",
      subheading: "Biarkan jendela ini terbuka, hingga selesai di ponsel",
      button: "Lanjutkan di sini"
    },
    continueOnPhone: {
      heading: "Lanjutkan di ponsel",
      subheading: "Pindai QR atau salin tautan di bawah",
      subheading2: "Pindai QR atau buka tautan di ponsel Anda",
      text: "Selesaikan proses",
      text1: "Periksa kembali di sini untuk mengirim",
      button: "Salin",
      copiedButton: "Tersalin!",
      copied: "Disalin!"
    },
    SsnReview: {
      heading: "Tinjau detail Anda",
      subHeading: "Lakukan perubahan yang diperlukan dan kirimkan detailnya",
      button: "Detail sudah benar",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Jaga wajah Anda di dalam lingkaran"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Mendekatlah ke kamera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Jangan malu, tampil ke depan"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Terlalu gelap. Cari cahaya lebih terang"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Terlalu terang. Cari cahaya lebih lembut"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Jaga wajah Anda di dalam lingkaran"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Tetap diam"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Hadapkan wajah ke cahaya"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Pegang ponsel setinggi mata"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Menjauhlah sedikit dari kamera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Posisikan wajah di tengah bingkai"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Posisikan wajah Anda di tengah lingkaran"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Mendekat dan jaga wajah Anda tetap lurus"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Masuk ke dalam tampilan dan jaga wajah Anda tetap lurus"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Terlalu gelap. Temukan cahaya yang lebih terang"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Terlalu terang. Temukan cahaya yang optimal"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Sesuaikan wajah Anda ke tengah lingkaran"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Tetap diam dan pandang lurus ke depan"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Hadapkan wajah ke cahaya dan tetap diam"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Pegang ponsel Anda sejajar dengan mata"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Jauhkan sedikit dari kamera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Sempurna!"
      },
      smile1: {
        icon: "mood",
        description: "Tersenyumlah, Anda terlihat hebat!"
      },
      smile2: {
        icon: "mood",
        description: "Tersenyumlah untuk kamera!"
      }
    },
    successful: {
      title: "Terima Kasih!",
      text: "Kami telah mengumpulkan semua informasi yang diperlukan untuk memverifikasi identitas Anda",
      finishBtn: "Selesai"
    },
    poweredBy: "Didukung oleh",
    redirect: "Pengalihan dalam",
    error: {
      message: "URL telah kedaluwarsa atau tidak valid"
    },
    sessionExpiredError: {
      heading: "Maaf, sesi Anda telah kedaluwarsa",
      subHeading1: "Anda telah tidak aktif untuk sementara waktu. Untuk keamanan, sesi Anda secara otomatis telah kedaluwarsa",
      subHeading2: "Harap coba lagi",
      buttonText: "Coba lagi"
    },
    journeyExpiredError: {
      heading: "Maaf, tautan telah kedaluwarsa",
      subHeading1: "Tautan ini tidak lagi aktif. Untuk keamanan, tautan memiliki masa berlaku terbatas",
      subHeading2: "Harap coba dengan tautan baru",
      buttonText: "Coba lagi"
    },
    cameraAccessError: {
      alert1: "Akses kamera ditolak. Harap aktifkan akses kamera di pengaturan browser Anda",
      alert2: "Terjadi kesalahan saat mengakses kamera",
      alert3: "Browser Anda tidak mendukung akses kamera"
    },
    footer: {
      securedBy: "Didukung oleh"
    },
    helpFaq: {
      title: "Bantuan & Pertanyaan Umum",
      subtitle: "Kami di sini untuk membantu Anda",
      cameraText: "Untuk memverifikasi identitas Anda, kami perlu mengambil gambar menggunakan kamera perangkat Anda. Ikuti link ini untuk mempelajari cara memberikan izin yang diperlukan",
      cameraHeading: "Izin Kamera",
      languageText: "Di awal proses, Anda dapat memilih bahasa pilihan Anda dengan memilihnya dari menu dropdown di bilah atas",
      languageHeading: "Pilihan Bahasa",
      kycText: "KYC, atau Kenali Pelanggan Anda, adalah proses untuk memverifikasi identitas pelanggan, memastikan kepatuhan, dan mencegah penipuan serta aktivitas ilegal lainnya",
      kycHeading: "Apa itu KYC?",
      timeText: "Biasanya, ini memakan waktu sekitar 60 detik. Namun, waktu dapat bervariasi tergantung pada negara",
      timeHeading: "Berapa lama waktu yang dibutuhkan?"
    },
    pdfPreviewUnavailable: "Tidak dapat menampilkan pratinjau PDF.",
    pdfPreviewHint: "Jika pratinjau tidak muncul, Anda tetap dapat melanjutkan.",
    pdfOpenLabel: "Buka PDF",
    failedUpload: {
      title: "Unggah File Gagal",
      text: "Pastikan file berukuran di bawah 5MB dan dalam format .jpg, .jpeg, .png, .heic, .heif, atau .pdf",
      btn: "Coba Lagi",
      pdfNotAllowedIndia: "Unggahan PDF tidak diizinkan untuk India. Unggah file JPEG, JPG, PNG, HEIC, atau HEIF di bawah 5 MB.",
      pdfNotAllowedIndiaBasic: "Unggahan PDF tidak diizinkan untuk India. Unggah file JPEG, JPG, atau PNG di bawah 5 MB."
    },
    livenessAnalyzing: {
      heading: "Menganalisis Wajah Anda",
      subHeading: "Harap tunggu, ini hanya membutuhkan beberapa detik"
    },
    activeLiveness: {
      instruction: "Jaga wajah Anda di dalam lingkaran dan ikuti instruksi",
      permissionDeniedTitle: "Akses Kamera atau Mikrofon Ditolak",
      permissionDeniedSubtitle: "Harap izinkan akses kamera dan mikrofon di pengaturan browser Anda dan coba lagi."
    },
    flipScreen: {
      heading: "Sekarang balik kartu identitas Anda",
      subHeading: "Silakan balik kartu identitas Anda secara fisik untuk menampilkan sisi belakang, lalu posisikan di dalam bingkai kamera.",
      continueButton: "Lanjutkan"
    },
    mobileDocCapture: {
      frontSide: "Sisi Depan",
      backSide: "Sisi Belakang",
      of: "dari",
      upload: "Unggah",
      stillNotWorking: "Masih tidak berfungsi?",
      clickToCapture: "Coba klik untuk mengambil",
      skip: "Lewati"
    }
,
    permissionPopUp: {
      title: "Izin diperlukan",
      subtitle: "Izinkan akses untuk menggunakan kamera",
      decline: "Tolak",
      allow: "Izinkan"
    },
    userDetails: {
      heading: "Verifikasi PAN",
      subHeading: "Silakan isi detail untuk verifikasi",
      panLabel: "Nomor PAN",
      panRequired: "Silakan masukkan nomor PAN Anda",
      saveError: "Terjadi kesalahan saat menyimpan detail. Silakan coba lagi.",
      proceed: "Lanjutkan"
    },
    redirectCta: {
      or: "atau",
      clickHere: "klik di sini",
      clickHereStart: "Klik di sini",
      toContinue: "untuk melanjutkan"
    },
    documentCapture: {
      stillNotWorking: "Masih tidak berfungsi?",
      clickToCaptureInstead: "Coba klik-untuk-mengambil sebagai gantinya",
      pdfNotAllowedIndia: "Unggahan PDF tidak diizinkan untuk India. Silakan unggah file JPEG, JPG, atau PNG di bawah 5 MB.",
      pdfNotAllowedIndiaMobile: "Unggahan PDF tidak diizinkan untuk India. Silakan unggah file JPEG, JPG, PNG, HEIC, atau HEIF di bawah 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png di bawah 5 mb",
      fileFormats: "jpeg, jpg, png, pdf di bawah 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif di bawah 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf di bawah 5 mb"
    },
    mobileCapture: {
      upload: "Unggah",
      skip: "Lewati",
      stillNotWorking: "Masih tidak berfungsi?",
      tryClickToCapture: "Ambil foto secara manual"
    },
    UserDetails: {
      panLabel: "Nomor PAN",
      proceedBtn: "Lanjutkan",
      panRequired: "Silakan masukkan nomor PAN Anda",
      saveError: "Terjadi kesalahan saat menyimpan detail. Silakan coba lagi."
    }
  },
  de: {
    supportingDocument: {
      headingFallback: "Ergänzendes Dokument",
      subHeading: "Laden Sie das Dokument unten hoch. Es wird zur Prüfung gespeichert — es werden keine Daten daraus extrahiert.",
      choosePlaceholder: "Datei auswählen (PNG, JPG oder PDF)",
      continue: "Weiter",
      uploading: "Wird hochgeladen...",
      skip: "Vorerst überspringen",
      errorInvalidType: "Laden Sie eine PNG-, JPG- oder PDF-Datei hoch.",
      errorTooLarge: "Die Datei ist zu groß. Das Limit beträgt 10 MB.",
      errorRead: "Diese Datei konnte nicht gelesen werden. Bitte versuchen Sie eine andere.",
      errorNoFile: "Bitte wählen Sie eine Datei zum Hochladen aus.",
    },
    header: {
      title: "Lass uns deine Identität überprüfen",
      subtitle: "Es dauert weniger als 2 Minuten",
      havingIssue: "Probleme?"
    },
    subHeading: {
      subHeading1: "Fange dein Ausweisdokument ein",
      subHeading2: "Bestätige, dass du live bist",
      livenessHeading1: "Suchen Sie einen Ort mit guter Beleuchtung",
      livenessHeading2: "Halten Sie Ihr Gesicht in der Mitte"
    },
    onlyIdVerificationHeader: {
      title: "Lass uns dein Ausweisdokument prüfen",
      subtitle: "Das dauert nur eine Minute. Halte dein Dokument bereit",
      instruction1: "Erlaube Kamera-Zugriff",
      instruction2: "Scanne oder lade dein Dokument hoch",
      instruction3: "Sofortige Dokumentenprüfung"
    },
    termsAndCondition: {
      title: "Ich stimme zu, die folgenden Bedingungen zu akzeptieren und einzuhalten.",
      privacyPolicy: "Bedingungen ansehen",
      beginBtnText: "Beginnen",
      beginLiveness: "Liveness-Überprüfung starten",
      startLiveness: "Zur Liveness-Überprüfung fortfahren"
    },
    permissionDenied: {
      title: "Kamerazugriff verweigert!",
      subtitle: "Überprüfen Sie, ob ein blockiertes Kamera-Symbol in der Nähe der Adressleiste des Browsers vorhanden ist und entsperren Sie es.",
      readMore: "Mehr erfahren",
      refreshText: "Sobald der Kamerazugriff erlaubt ist, klicken Sie auf die Schaltfläche „Aktualisieren“ unten.",
      refreshBtn: "Aktualisieren",
      link: "Oder, fahre auf dem Handy fort",
      buttonText: "Oder, fahre auf dem Handy fort"
    },
    androidBrowserPermissionDenied: {
      title: "Kamerazugriff verweigert!",
      subtitle: "Überprüfen Sie, ob sich in der Nähe der Adressleiste des Browsers ein blockiertes Kamera-Symbol befindet, und entsperren Sie es.",
      readMore: "Mehr erfahren",
      refreshText: "Sobald der Kamerazugriff erlaubt ist, klicken Sie unten auf die Schaltfläche „Aktualisieren“.",
      refreshBtn: "Aktualisieren",
      link: "Oder, fahren Sie auf dem Handy fort",
      buttonText: "Oder, fahren Sie auf dem Handy fort"
    },
    androidWebViewPermissionDenied: {
      title: "Kamerazugriff verweigert!",
      subtitle: "Der Kamerazugriff kann durch App-Einstellungen blockiert sein. Bitte überprüfen Sie App-Info > Berechtigungen > Kamera und erlauben Sie den Zugriff.",
      refreshText: "Sobald der Kamerazugriff erlaubt ist, klicken Sie unten auf die Schaltfläche „Aktualisieren“.",
      refreshBtn: "Aktualisieren",
      link: "Oder, fahren Sie auf dem Handy fort",
      buttonText: "Oder, fahren Sie auf dem Handy fort"
    },
    iosBrowserPermissionDenied: {
      title: "Kamerazugriff verweigert!",
      subtitle: "Tippen Sie auf das Kamera- oder Schlosssymbol in der Nähe der Adressleiste, um den Zugriff zu erlauben, oder prüfen Sie Ihre Browsereinstellungen.",
      readMore: "Mehr erfahren",
      refreshText: "Sobald der Kamerazugriff erlaubt ist, klicken Sie unten auf die Schaltfläche „Aktualisieren“.",
      refreshBtn: "Aktualisieren",
      link: "Oder, fahren Sie auf dem Handy fort",
      buttonText: "Oder, fahren Sie auf dem Handy fort"
    },
    iosWebViewPermissionDenied: {
      title: "Kamerazugriff verweigert!",
      subtitle: "Der Kamerazugriff kann durch Ihre App-Einstellungen blockiert sein. Gehen Sie zu den Einstellungen, suchen Sie die verwendete App und aktivieren Sie die Kameraberechtigung.",
      refreshText: "Sobald der Kamerazugriff erlaubt ist, klicken Sie unten auf die Schaltfläche „Aktualisieren“.",
      refreshBtn: "Aktualisieren",
      link: "Oder, fahren Sie auf dem Handy fort",
      buttonText: "Oder, fahren Sie auf dem Handy fort"
    },
    documentationList: {
      countryHeading: "Land auswählen",
      docHeading: "Dokument auswählen",
      btnText: "Weiter",
      searchCountry: "Land suchen"
    },
    frontDocCapture: {
      heading: "Vorderseite des Ausweises im Rechteck platzieren",
      backupHeading: "Probleme? Bitte klicken Sie das Bild manuell",
      btnText: "Foto machen",
      headingBack: " im Rechteck",
      uploadButton: "oder Ausweis hochladen"
    },
    backDocCapture: {
      heading: "Rückseite des Ausweises im Rechteck platzieren",
      backupHeading: "Probleme? Bitte klicken Sie das Bild manuell",
      btnText: "Foto machen",
      containerText: "oder, Dokument hochladen",
      text: "Aufnahme, still halten",
      skipButton: "Rückseite überspringen",
      headingBack: " im Rechteck",
      uploadButton: "oder Ausweis hochladen"
    },
    analyzing: {
      heading: "Deinen Ausweis analysieren",
      subHeading: "Bitte warten, das dauert nur wenige Sekunden"
    },
    imageCheck: {
      heading: "Überprüfe dein Bild",
      subHeading: "Bitte sicherstellen, dass das Bild vollständig, klar und frei von Unschärfe und Blendung ist.",
      button1: "Foto erneut machen",
      button2: "In Ordnung",
      frontHeading: "Überprüfe dein Vorderbild",
      backHeading: "Überprüfe dein Rückbild"
    },
    errorHandler: {
      heading: "Oh nein:(",
      subHeading1: "Wir haben einige Probleme, aber keine Sorge! Bitte versuche es erneut",
      subHeading2: "Wenn das Problem weiterhin besteht, später erneut prüfen",
      button: "Erneut versuchen"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Bitte entfernen Sie alles, was Ihr Gesicht verdeckt",
        button: "Versuchen Sie es erneut"
      },
      eyeClosureDetected: {
        heading: "Bitte halten Sie die Augen offen und schauen Sie direkt in die Kamera",
        button: "Erneut versuchen"
      },
      isMultipleFacesFound: {
        heading: "Mehrere Gesichter erkannt. Stellen Sie sicher, dass nur Ihr Gesicht in der Kamera sichtbar ist.",
        button: "Versuchen Sie es erneut"
      },
      noFacesFound: {
        heading: "Kein Gesicht erkannt. Stellen Sie sicher, dass Ihr Gesicht in der Kamera sichtbar ist.",
        button: "Versuchen Sie es erneut"
      },
      faceDetections: {
        heading: "Bitte entfernen Sie dies",
        button: "Versuchen Sie es erneut"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Mehrere Gesichter erkannt",
          button: "Versuchen Sie es erneut"
        },
        generalMessage: {
          heading: "Bitte stellen Sie sicher, dass Sie vor der Kamera live sind",
          button: "Versuchen Sie es erneut"
        }
      },
      faceMatch: {
        heading: "Ihr Gesicht stimmt nicht mit dem Ausweisfoto überein",
        button: "Versuchen Sie es erneut"
      },
      selfieError: {
        heading: "Wir konnten Ihr Selfie nicht verifizieren",
        subHeading1: "Befolgen Sie einfach diese Tipps und versuchen Sie es erneut",
        instruction1: "Begeben Sie sich an einen gut beleuchteten Ort und vermeiden Sie Gegenlicht",
        instruction2: "Halten Sie Ihr Gesicht vollständig sichtbar und zentriert im Bild",
        instruction3: "Entfernen Sie Hüte, Brillen oder Masken, um Ihr Gesicht klar sichtbar zu machen",
        button: "Versuchen Sie es erneut"
      },
      activeLivenessOtpFailureMessage: {
        heading: "Das OTP stimmt nicht überein. Bitte lesen Sie das OTP deutlich und laut vor",
        button: "Erneut versuchen"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Die Verifizierung ist fehlgeschlagen. Bitte befolgen Sie die Anweisungen deutlich und versuchen Sie es erneut",
        button: "Versuchen Sie es erneut"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF hat zu viele Seiten",
        subHeading: "Das hochgeladene PDF überschreitet das Limit von 2 Seiten. Bitte laden Sie ein PDF mit höchstens 2 Seiten oder ein klares Bild Ihres Ausweises hoch."
      },
      heading: "Wir konnten deinen Ausweis nicht verarbeiten",
      subHeading: "Entweder lädst du einen falschen Ausweis hoch oder das Bild ist nicht klar",
      buttonBack: "Rückseite des Ausweises erneut versuchen",
      buttonFront: "Vorderseite des Ausweises erneut versuchen",
      button: "Erneut versuchen",
      captureFrontSide: "Vorderseite aufnehmen",
      captureBackSide: "Rückseite aufnehmen",
      changeIDButton: "Wählen Sie ein anderes Dokument",
      wrongid: {
        heading: "Wir konnten dieses Dokument nicht verarbeiten",
        subHeading: "Bitte stelle sicher, dass du das richtige Dokument hochlädst und dass die Bildqualität klar ist"
      },
      expiredid: {
        heading: "Ausweisdokument abgelaufen!",
        subHeading: "Wir können ein abgelaufenes Ausweisdokument nicht akzeptieren. Bitte stelle ein gültiges Dokument zur Verfügung"
      },
      minimumage: {
        heading: "Altersanforderung nicht erfüllt!",
        subHeading: "Dein Alter liegt unter dem Mindestalter. Bitte stelle sicher, dass du die Altersanforderung erfüllst"
      },
      mobileAttemptsDone: {
        heading: "Reise auf Ihrem vorherigen Gerät fortgesetzt",
        subHeading: "Diese Sitzung wurde gestoppt, um Duplikate zu vermeiden."
      },
      finished: {
        heading: "Die Reise wurde beendet",
        subHeading: "Die Reise ist entweder abgeschlossen oder beendet"
      },
      invalid: {
        heading: "Reise nicht verfügbar !",
        subHeading: "Es wurde keine journeyId gefunden oder die Journey-ID ist ungültig"
      },
      INVALID_PAN_NUMBER: {
        heading: "Ungültige PAN-Nummer",
        subHeading: "Die eingegebene PAN-Nummer ist ungültig. Bitte überprüfen Sie sie und versuchen Sie es erneut"
      },
      INVALID_PAN_STATUS: {
        heading: "Ungültiger PAN-Status",
        subHeading: "Die eingegebene PAN-Nummer ist ungültig. Bitte überprüfen Sie sie und versuchen Sie es erneut"
      },
      directKyc: {
        heading: "Direkte KYC-Reise !",
        subHeading: "Dies ist eine direkte KYC-Reise. Eine Frontend-Reise ist nicht erlaubt."
      },
      DOCTYPE_FALSE: {
        heading: "Falsches Dokument bereitgestellt!",
        subHeading: "Bitte laden Sie ein gültiges Dokument hoch und stellen Sie sicher, dass die Bildqualität gut ist."
      },
      ONLY_FRONT: {
        heading: "Rückseite des Ausweises fehlt",
        subHeading: "Sie haben nur die Vorderseite bereitgestellt. Bitte drehen Sie Ihren Ausweis um und stellen Sie die Rückseite bereit, um fortzufahren"
      },
      ONLY_BACK: {
        heading: "Vorderseite des Ausweises fehlt",
        subHeading: "Sie haben nur die Rückseite bereitgestellt. Bitte drehen Sie Ihren Ausweis um und stellen Sie die Vorderseite bereit, um fortzufahren"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Dokument läuft bald ab",
        subHeading: "Das Dokument wird abgelehnt, da es bald abläuft."
      },
      DOCUMENT_EXPIRED: {
        heading: "Dokument abgelaufen!",
        subHeading: "Bitte laden Sie ein gültiges, nicht abgelaufenes Dokument hoch, um fortzufahren."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Altersanforderung nicht erfüllt!",
        subHeading: "Das Dokument weist darauf hin, dass Sie das erforderliche Alter nicht erfüllen. Bitte laden Sie ein gültiges Dokument hoch."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Dokument konnte nicht überprüft werden!",
        subHeading: "Die Bildqualität ist zu schlecht für die Überprüfung. Bitte versuchen Sie es erneut mit einem klareren Bild."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Dokument konnte nicht überprüft werden!",
        subHeading: "Einige Informationen konnten nicht überprüft werden. Bitte versuchen Sie es erneut mit einem klareren Bild."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Dokument konnte nicht überprüft werden!",
        subHeading: "Einige Details konnten aufgrund schlechter Bildqualität nicht überprüft werden. Bitte versuchen Sie es erneut mit einem klareren Bild"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Dokument konnte nicht überprüft werden!",
        subHeading: "Einige Details konnten nicht überprüft werden. Bitte versuchen Sie es erneut mit einem klareren Bild."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problem bei der Überprüfung Ihres Fotos auf dem Ausweis",
        subHeading: "Wir konnten Ihr Foto auf dem Ausweis nicht überprüfen. Bitte laden Sie ein klares Foto Ihres Originalausweises hoch, damit wir es bestätigen können."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Prüfung des Sicherheitsmusters des Dokuments fehlgeschlagen",
        subHeading: "Wir konnten die integrierten Sicherheitsmuster des Dokuments nicht überprüfen. Bitte laden Sie ein klares Foto des Originalausweises hoch, damit wir seine Echtheit bestätigen können."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Echtheitsprüfung des Dokuments fehlgeschlagen",
        subHeading: "Wir haben Anzeichen dafür gefunden, dass das Dokument möglicherweise nicht echt ist. Bitte vermeiden Sie Screenshots, gedruckte Kopien oder das Anzeigen des Ausweises auf einem Bildschirm. Laden Sie den Originalausweis mit allen deutlich sichtbaren Merkmalen hoch"
      },
      SECURITY_FALSE: {
        heading: "Problem erkannt!",
        subHeading: "Das Dokument konnte nicht überprüft werden. Bitte versuchen Sie es erneut mit einem klareren Bild"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Schlechte Bildqualität!",
        subHeading: "Das Bild ist zu unscharf oder undeutlich. Bitte versuchen Sie es erneut mit einem klareren Bild"
      },
      FACE_UNDETECTED: {
        heading: "Gesicht nicht erkannt",
        subHeading: "Wir konnten kein sichtbares Gesicht auf dem Dokument finden. Bitte laden Sie einen gültigen Ausweis hoch, auf dem das Gesicht deutlich sichtbar ist"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Dokumentenvergleich fehlgeschlagen",
        subHeading: "Der Vergleich zwischen den Dokumenten ist aufgrund einer Abweichung in einem oder mehreren Schlüsselfeldern (Name, Geburtsdatum oder Gesicht) fehlgeschlagen"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker-Fehler",
        subHeading: "Während der Digilocker-Reise ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder verwenden Sie eine alternative Methode, um fortzufahren."
      },
      LINKAGE_FAILED: {
        heading: "Diese Überprüfung kann nicht abgeschlossen werden",
        subHeading: "Die erfassten Daten stimmen nicht mit den Datensätzen für diese Prüfung überein."
      }
    },
    biometricConsent: {
      consentStatement: "Vor Ihrem Selfie benötigen wir Ihre Einwilligung, Ihre biometrischen Daten (Gesichtsbild und Lebendigkeitssignale) zu erfassen und zu verarbeiten, um Ihre Identität zu überprüfen. Diese Daten werden ausschließlich für diese Überprüfung verwendet.",
      privacyPolicy: "Datenschutzrichtlinie",
      consentButton: "Ich stimme zu — Weiter",
      declineButton: "Ich stimme nicht zu",
      confirmTitle: "Ohne biometrische Überprüfung fortfahren?",
      confirmBody: "Ohne biometrische Überprüfung nehmen wir kein Selfie auf. Ihre Überprüfung wird mit den bereits von Ihnen angegebenen Informationen abgeschlossen. Diese Wahl ist für diese Sitzung endgültig.",
      goBack: "Zurück",
      confirmDecline: "Bestätigen — nicht zustimmen",
      declineComplete: "Sie haben sich gegen die biometrische Überprüfung entschieden. Ihre Identitätsprüfung wurde mit den von Ihnen eingereichten Dokumenten abgeschlossen."
    },
    introLiveness: {
      heading: "Bestätige, dass du hier live bist",
      instruction1: "Stelle sicher, dass ausreichend Licht vorhanden ist",
      instruction2: "Erlaube die notwendigen Berechtigungen",
      instruction3: "Folge einfach den Anweisungen",
      button: "Fortfahren",
      subHeading: "Sie sind nur noch einen Schritt entfernt"
    },
    phoneSession: {
      heading: "Sitzung auf dem Handy fortsetzen",
      subheading: "Dieses Fenster offen lassen, bis du auf dem Handy fertig bist",
      button: "Hier fortfahren"
    },
    continueOnPhone: {
      heading: "Auf dem Handy fortfahren",
      subheading: "Scanne den QR-Code oder kopiere den Link unten",
      subheading2: "QR-Code scannen oder Link auf deinem Handy öffnen",
      text: "Den Prozess abschließen",
      text1: "Hier zurückkehren, um abzusenden",
      button: "Kopieren",
      copiedButton: "Kopiert!",
      copied: "Kopiert!"
    },
    SsnReview: {
      heading: "Überprüfe deine Angaben",
      subHeading: "Mache alle notwendigen Änderungen und reiche die Angaben ein",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "Angaben sind korrekt"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Halten Sie Ihr Gesicht im Kreis"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Kommen Sie näher an die Kamera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Keine Scheu, zeigen Sie sich"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Zu dunkel. Suchen Sie mehr Licht"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Zu hell. Suchen Sie weicheres Licht"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Halten Sie Ihr Gesicht im Kreis"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Halten Sie still"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Drehen Sie das Gesicht zum Licht"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Halten Sie das Telefon auf Augenhöhe"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Gehen Sie etwas von der Kamera weg"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Zentrieren Sie Ihr Gesicht im Rahmen"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Positioniere dein Gesicht in der Mitte des Kreises"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Komm näher und halte dein Gesicht gerade"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Tritt ins Bild und halte dein Gesicht gerade"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Zu dunkel. Finde besseres Licht"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Zu hell. Finde optimales Licht"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Passe dein Gesicht zur Mitte des Kreises an"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Bleib ruhig und schau geradeaus"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Schau ins Licht und bleib ruhig"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Halte dein Handy auf Augenhöhe"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Weg von der Kamera bewegen"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perfekt!"
      },
      smile1: {
        icon: "mood",
        description: "Lächle bitte, du siehst großartig aus!"
      },
      smile2: {
        icon: "mood",
        description: "Lächle für die Kamera!"
      }
    },
    successful: {
      title: "Danke!",
      text: "Wir haben alle notwendigen Informationen gesammelt, um deine Identität zu überprüfen",
      finishBtn: "Fertig"
    },
    poweredBy: "Bereitgestellt von",
    redirect: "Weiterleitung in",
    error: {
      message: "URL ist abgelaufen oder nicht gültig"
    },
    sessionExpiredError: {
      heading: "Entschuldigung, deine Sitzung ist abgelaufen",
      subHeading1: "Du warst eine Weile inaktiv. Aus Sicherheitsgründen ist deine Sitzung automatisch abgelaufen",
      subHeading2: "Bitte versuche es erneut",
      buttonText: "Erneut versuchen"
    },
    journeyExpiredError: {
      heading: "Entschuldigung, der Link ist abgelaufen",
      subHeading1: "Der Link ist nicht mehr aktiv. Aus Sicherheitsgründen haben Links eine begrenzte Lebensdauer",
      subHeading2: "Bitte versuche es mit einem neuen Link",
      buttonText: "Erneut versuchen"
    },
    cameraAccessError: {
      alert1: "Zugriff auf die Kamera wurde verweigert. Bitte aktiviere den Kamerazugang in den Browsereinstellungen",
      alert2: "Ein Fehler ist beim Zugriff auf die Kamera aufgetreten",
      alert3: "Dein Browser unterstützt den Kamerazugang nicht"
    },
    footer: {
      securedBy: "Bereitgestellt von"
    },
    helpFaq: {
      title: "Hilfe & FAQs",
      subtitle: "Wir sind hier, um Ihnen zu helfen",
      cameraText: "Um Ihre Identität zu überprüfen, müssen wir Bilder mit der Kamera Ihres Geräts aufnehmen. Folgen Sie diesem link, um zu erfahren, wie Sie die erforderlichen Berechtigungen erteilen können",
      cameraHeading: "Kameraberechtigung",
      languageText: "Zu Beginn des Prozesses können Sie Ihre bevorzugte Sprache auswählen, indem Sie sie im Dropdown-Menü in der oberen Leiste auswählen",
      languageHeading: "Sprachauswahl",
      kycText: "KYC, oder 'Kenne deinen Kunden', ist ein Prozess zur Überprüfung der Identität von Kunden, um die Einhaltung zu gewährleisten und Betrug sowie andere illegale Aktivitäten zu verhindern",
      kycHeading: "Was ist KYC?",
      timeText: "In der Regel dauert es etwa 60 Sekunden. Dies kann jedoch je nach Land variieren",
      timeHeading: "Wie lange dauert es?"
    },
    pdfPreviewUnavailable: "Vorschau für PDF kann nicht angezeigt werden.",
    pdfPreviewHint: "Falls die Vorschau nicht erscheint, können Sie trotzdem fortfahren.",
    pdfOpenLabel: "PDF öffnen",
    desktopBrowserPermissionDenied: {
      readMore: "Mehr erfahren",
      refreshText: "Sobald der Kamerazugriff erlaubt ist, klicken Sie unten auf die Schaltfläche „Aktualisieren“.",
      refreshBtn: "Aktualisieren",
      link: "Oder auf dem Telefon fortfahren",
      buttonText: "Oder auf dem Telefon fortfahren",
      title: "Kamerazugriff verweigert!",
      subtitle: "Achten Sie auf ein Symbol für eine blockierte Kamera in der Nähe der Adressleiste des Browsers und entsperren Sie es."
    },
    failedUpload: {
      title: "Datei-Upload fehlgeschlagen",
      text: "Bitte stellen Sie sicher, dass die Datei unter 5 MB groß und im Format .jpg, .jpeg, .png, .heic, .heif oder .pdf ist",
      btn: "Erneut versuchen",
      pdfNotAllowedIndia: "PDF-Uploads sind für Indien nicht erlaubt. Laden Sie JPEG-, JPG-, PNG-, HEIC- oder HEIF-Dateien unter 5 MB hoch.",
      pdfNotAllowedIndiaBasic: "PDF-Uploads sind für Indien nicht erlaubt. Laden Sie JPEG-, JPG- oder PNG-Dateien unter 5 MB hoch."
    },
    livenessAnalyzing: {
      heading: "Ihr Gesicht wird analysiert",
      subHeading: "Bitte warten Sie, dies dauert nur wenige Sekunden"
    },
    activeLiveness: {
      instruction: "Halten Sie Ihr Gesicht im Kreis und befolgen Sie die Anweisungen",
      permissionDeniedTitle: "Kamera- oder Mikrofonzugriff verweigert",
      permissionDeniedSubtitle: "Bitte erlauben Sie den Kamera- und Mikrofonzugriff in Ihren Browsereinstellungen und versuchen Sie es erneut."
    },
    flipScreen: {
      heading: "Drehen Sie nun Ihren Ausweis um",
      subHeading: "Bitte drehen Sie Ihren Ausweis physisch um, um die Rückseite zu zeigen, und positionieren Sie ihn im Kamerarahmen.",
      continueButton: "Weiter"
    },
    mobileDocCapture: {
      frontSide: "Vorderseite",
      backSide: "Rückseite",
      of: "von",
      upload: "Hochladen",
      stillNotWorking: "Funktioniert immer noch nicht?",
      clickToCapture: "Klick-zum-Erfassen versuchen",
      skip: "Überspringen"
    }
,
    permissionPopUp: {
      title: "Berechtigung erforderlich",
      subtitle: "Zugriff erlauben, um die Kamera zu verwenden",
      decline: "Ablehnen",
      allow: "Erlauben"
    },
    userDetails: {
      heading: "PAN-Verifizierung",
      subHeading: "Bitte füllen Sie die Angaben zur Verifizierung aus",
      panLabel: "PAN-Nummer",
      panRequired: "Bitte geben Sie Ihre PAN-Nummer ein",
      saveError: "Beim Speichern der Angaben ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      proceed: "Fortfahren"
    },
    redirectCta: {
      or: "oder",
      clickHere: "hier klicken",
      clickHereStart: "Hier klicken",
      toContinue: "um fortzufahren"
    },
    documentCapture: {
      stillNotWorking: "Funktioniert immer noch nicht?",
      clickToCaptureInstead: "Versuchen Sie stattdessen die Klick-Aufnahme",
      pdfNotAllowedIndia: "PDF-Uploads sind für Indien nicht erlaubt. Bitte laden Sie JPEG-, JPG- oder PNG-Dateien unter 5 MB hoch.",
      pdfNotAllowedIndiaMobile: "PDF-Uploads sind für Indien nicht erlaubt. Bitte laden Sie JPEG-, JPG-, PNG-, HEIC- oder HEIF-Dateien unter 5 MB hoch.",
      fileFormatsIndia: "jpeg, jpg, png unter 5 mb",
      fileFormats: "jpeg, jpg, png, pdf unter 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif unter 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf unter 5 mb"
    },
    mobileCapture: {
      upload: "Hochladen",
      skip: "Überspringen",
      stillNotWorking: "Funktioniert immer noch nicht?",
      tryClickToCapture: "Manuell aufnehmen"
    },
    UserDetails: {
      panLabel: "PAN-Nummer",
      proceedBtn: "Weiter",
      panRequired: "Bitte geben Sie Ihre PAN-Nummer ein",
      saveError: "Beim Speichern der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
    }
  },
  ja: {
    supportingDocument: {
      headingFallback: "補足書類",
      subHeading: "以下に書類をアップロードしてください。確認のために保存され、内容の抽出は行われません。",
      choosePlaceholder: "ファイルを選択（PNG、JPG、PDF）",
      continue: "続行",
      uploading: "アップロード中...",
      skip: "今はスキップ",
      errorInvalidType: "PNG、JPG、または PDF ファイルをアップロードしてください。",
      errorTooLarge: "ファイルが大きすぎます。上限は 10MB です。",
      errorRead: "そのファイルを読み込めませんでした。別のファイルをお試しください。",
      errorNoFile: "アップロードするファイルを選択してください。",
    },
    header: {
      title: "あなたの身分を確認しましょう",
      subtitle: "2分以内に完了します",
      havingIssue: "問題がありますか？"
    },
    subHeading: {
      subHeading1: "ID文書を撮影してください",
      subHeading2: "ライブであることを確認してください",
      livenessHeading1: "明るい場所を見つけてください",
      livenessHeading2: "顔を中央に保ってください"
    },
    onlyIdVerificationHeader: {
      title: "本人確認書類を確認しましょう",
      subtitle: "2分以内に完了します。本人確認書類を手元にご準備ください",
      instruction1: "カメラへのアクセスを許可",
      instruction2: "書類をスキャンまたはアップロード",
      instruction3: "即時書類確認"
    },
    termsAndCondition: {
      title: "以下の利用規約に同意し、従うことに同意します。",
      privacyPolicy: "利用規約を見る",
      beginBtnText: "開始",
      beginLiveness: "ライブチェックを開始します",
      startLiveness: "ライブチェックを進める"
    },
    permissionDenied: {
      title: "カメラアクセスが拒否されました！",
      subtitle: "ブラウザのアドレスバー近くにブロックされたカメラアイコンがあるか確認し、それをアンブロックしてください。",
      readMore: "さらに詳しく",
      refreshText: "カメラアクセスが許可された後、下の更新ボタンをクリックしてください。",
      refreshBtn: "更新",
      link: "または、電話で続ける",
      buttonText: "または、電話で続ける"
    },
    desktopBrowserPermissionDenied: {
      readMore: "さらに詳しく",
      refreshText: "カメラアクセスが許可された後、下の更新ボタンをクリックしてください。",
      refreshBtn: "更新",
      link: "または、電話で続ける",
      buttonText: "または、電話で続ける",
      title: "カメラアクセスが拒否されました！",
      subtitle: "ブラウザのアドレスバー近くにブロックされたカメラアイコンがあるか確認し、それをアンブロックしてください。"
    },
    androidBrowserPermissionDenied: {
      title: "カメラアクセスが拒否されました！",
      subtitle: "ブラウザのアドレスバー近くにブロックされたカメラアイコンがないか確認し、アンブロックしてください。",
      readMore: "さらに詳しく",
      refreshText: "カメラアクセスが許可されたら、下の更新ボタンをクリックしてください。",
      refreshBtn: "更新",
      link: "または、電話で続ける",
      buttonText: "または、電話で続ける"
    },
    androidWebViewPermissionDenied: {
      title: "カメラアクセスが拒否されました！",
      subtitle: "カメラアクセスはアプリの設定でブロックされている可能性があります。アプリ情報 > 許可 > カメラ設定を確認して許可してください。",
      refreshText: "カメラアクセスが許可されたら、下の更新ボタンをクリックしてください。",
      refreshBtn: "更新",
      link: "または、電話で続ける",
      buttonText: "または、電話で続ける"
    },
    iosBrowserPermissionDenied: {
      title: "カメラアクセスが拒否されました！",
      subtitle: "アドレスバー近くのカメラまたはロックのアイコンをタップしてアクセスを許可するか、ブラウザの設定を確認してください。",
      readMore: "さらに詳しく",
      refreshText: "カメラアクセスが許可されたら、下の更新ボタンをクリックしてください。",
      refreshBtn: "更新",
      link: "または、電話で続ける",
      buttonText: "または、電話で続ける"
    },
    iosWebViewPermissionDenied: {
      title: "カメラアクセスが拒否されました！",
      subtitle: "カメラアクセスはアプリの設定でブロックされている可能性があります。設定に進み、使用中のアプリを見つけてカメラの許可を有効にしてください。",
      refreshText: "カメラアクセスが許可されたら、下の更新ボタンをクリックしてください。",
      refreshBtn: "更新",
      link: "または、電話で続ける",
      buttonText: "または、電話で続ける"
    },
    documentationList: {
      countryHeading: "国を選択",
      docHeading: "書類を選択",
      btnText: "次へ",
      searchCountry: "国を検索"
    },
    frontDocCapture: {
      heading: "IDの表面を矩形内に置いてください",
      backupHeading: "問題が発生していますか？手動で画像をクリックしてください",
      btnText: "写真を撮る",
      headingBack: "長方形の中に",
      uploadButton: "または、IDをアップロード"
    },
    backDocCapture: {
      heading: "IDの裏面を矩形内に置いてください",
      backupHeading: "問題が発生していますか？手動で画像をクリックしてください",
      btnText: "写真を撮る",
      containerText: "または、書類をアップロード",
      text: "キャプチャ中、静止してください",
      skipButton: "裏面をスキップ",
      headingBack: "長方形の中に",
      uploadButton: "または、IDをアップロード"
    },
    analyzing: {
      heading: "IDを分析しています",
      subHeading: "少々お待ちください。すぐに終わります"
    },
    imageCheck: {
      heading: "画像を確認してください",
      subHeading: "画像が完全で、鮮明で、ぼやけや反射がないことを確認してください。",
      button1: "写真を再撮影",
      button2: "問題ありません",
      frontHeading: "表面の画像を確認してください",
      backHeading: "裏面の画像を確認してください"
    },
    errorHandler: {
      heading: "ああ、問題が発生しました:(",
      subHeading1: "問題が発生していますが、心配しないでください！再試行してください",
      subHeading2: "問題が続く場合は、後で再試行してください",
      button: "再試行"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "顔を覆っているものを取り除いてください",
        button: "もう一度試す"
      },
      eyeClosureDetected: {
        heading: "目を開けて、カメラをまっすぐ見てください",
        button: "もう一度試す"
      },
      isMultipleFacesFound: {
        heading: "複数の顔が検出されました。カメラには自分の顔だけが映るようにしてください。",
        button: "もう一度試す"
      },
      noFacesFound: {
        heading: "顔が検出されませんでした。カメラに顔が表示されていることを確認してください。",
        button: "再試行"
      },
      faceDetections: {
        heading: "これを取り除いてください",
        button: "もう一度試す"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "複数の顔が検出されました",
          button: "もう一度試す"
        },
        generalMessage: {
          heading: "カメラの前でライブであることを確認してください",
          button: "もう一度試す"
        }
      },
      faceMatch: {
        heading: "顔がID写真と一致しません",
        button: "もう一度試す"
      },
      selfieError: {
        heading: "セルフィーの確認ができませんでした",
        subHeading1: "以下のヒントに従ってもう一度試してください",
        instruction1: "十分に照明がある場所に移動し、逆光を避けてください",
        instruction2: "顔が完全に見えるようにし、フレームの中心に合わせてください",
        instruction3: "顔をはっきり見せるために帽子、メガネ、マスクを外してください",
        button: "もう一度試す"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTPが一致しませんでした。OTPをはっきりと声に出して読んでください",
        button: "もう一度試す"
      },
      activeLivenessGenericFailureMessage: {
        heading: "認証に失敗しました。指示にはっきりと従って、もう一度お試しください",
        button: "もう一度試す"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF のページ数が多すぎます",
        subHeading: "アップロードされた PDF は 2 ページの上限を超えています。2 ページ以内の PDF、または身分証の鮮明な画像をアップロードしてください。"
      },
      heading: "IDを処理できませんでした",
      subHeading: "IDが間違っているか、画像が鮮明ではありません",
      buttonBack: "IDの裏面を再試行",
      buttonFront: "IDの表面を再試行",
      button: "再試行",
      captureFrontSide: "表面を撮影",
      captureBackSide: "裏面を撮影",
      changeIDButton: "別の書類を選択",
      wrongid: {
        heading: "この文書を処理できませんでした",
        subHeading: "正しい文書をアップロードしていることを確認し、画像の品質が鮮明であることを確認してください"
      },
      expiredid: {
        heading: "ID文書が期限切れです！",
        subHeading: "期限切れのID文書は受け付けられません。正しい文書を提供してください"
      },
      minimumage: {
        heading: "年齢要件を満たしていません！",
        subHeading: "年齢が最低必要年齢を下回っています。最低年齢基準を満たしていることを確認してください"
      },
      mobileAttemptsDone: {
        heading: "以前のデバイスでジャーニーが再開されました",
        subHeading: "重複を避けるため、このセッションは停止されました。"
      },
      finished: {
        heading: "ジャーニーが終了しました",
        subHeading: "ジャーニーは完了したか、終了されました"
      },
      invalid: {
        heading: "ジャーニーは利用できません !",
        subHeading: "journeyIdが見つからないか、ジャーニーIDが無効です"
      },
      INVALID_PAN_NUMBER: {
        heading: "無効なPAN番号",
        subHeading: "入力されたPAN番号は有効ではありません。確認してもう一度お試しください"
      },
      INVALID_PAN_STATUS: {
        heading: "無効なPANステータス",
        subHeading: "入力されたPAN番号は有効ではありません。確認してもう一度お試しください"
      },
      directKyc: {
        heading: "ダイレクトKYCジャーニー !",
        subHeading: "これはダイレクトKYCジャーニーです。フロントエンドのジャーニーは許可されていません。"
      },
      DOCTYPE_FALSE: {
        heading: "間違った書類が提供されました！",
        subHeading: "有効な書類をアップロードし、画質が良好であることを確認してください。"
      },
      ONLY_FRONT: {
        heading: "身分証明書の裏面がありません",
        subHeading: "表面のみが提供されました。続行するには、身分証明書を裏返して裏面を提供してください"
      },
      ONLY_BACK: {
        heading: "身分証明書の表面がありません",
        subHeading: "裏面のみが提供されました。続行するには、身分証明書を裏返して表面を提供してください"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "書類はまもなく有効期限が切れます",
        subHeading: "書類はまもなく有効期限が切れるため拒否されました。"
      },
      DOCUMENT_EXPIRED: {
        heading: "書類の有効期限が切れています！",
        subHeading: "続行するには、有効期限内の有効な書類をアップロードしてください。"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年齢要件を満たしていません！",
        subHeading: "書類は、必要な年齢を満たしていないことを示しています。有効な書類をアップロードしてください。"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "書類を確認できません！",
        subHeading: "画質が悪すぎて確認できません。より鮮明な画像でもう一度お試しください。"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "書類を確認できません！",
        subHeading: "一部の情報を確認できませんでした。より鮮明な画像でもう一度お試しください。"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "書類を確認できません！",
        subHeading: "画質が悪いため、一部の詳細を確認できませんでした。より鮮明な画像でもう一度お試しください"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "書類を確認できません！",
        subHeading: "一部の詳細を確認できませんでした。より鮮明な画像でもう一度お試しください。"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "身分証明書の写真の確認に問題があります",
        subHeading: "身分証明書の写真を確認できませんでした。確認できるよう、元の身分証明書の鮮明な写真をアップロードしてください。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "書類のセキュリティパターンチェックに失敗しました",
        subHeading: "書類の組み込みセキュリティパターンを確認できませんでした。真正性を確認できるよう、元の身分証明書の鮮明な写真をアップロードしてください。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "書類の真正性チェックに失敗しました",
        subHeading: "書類が本物でない可能性を示す兆候が見つかりました。スクリーンショット、印刷物の使用、または画面上での身分証明書の表示は避けてください。すべての特徴がはっきりと見える元の身分証明書をアップロードしてください"
      },
      SECURITY_FALSE: {
        heading: "問題が検出されました！",
        subHeading: "書類を確認できませんでした。より鮮明な画像でもう一度お試しください"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "画質が悪いです！",
        subHeading: "画像がぼやけているか不鮮明です。より鮮明な画像でもう一度お試しください"
      },
      FACE_UNDETECTED: {
        heading: "顔が検出されませんでした",
        subHeading: "書類上に見える顔が見つかりませんでした。顔がはっきりと見える有効な身分証明書をアップロードしてください"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "書類間の照合に失敗しました",
        subHeading: "1つ以上の重要な項目（氏名、生年月日、または顔）の不一致により、書類間の照合に失敗しました"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilockerの失敗",
        subHeading: "Digilockerジャーニー中にエラーが発生しました。もう一度お試しいただくか、別の方法で続行してください。"
      },
      LINKAGE_FAILED: {
        heading: "この確認を完了できません",
        subHeading: "取得した情報がこのチェックの記録と一致しませんでした。"
      }
    },
    biometricConsent: {
      consentStatement: "自撮りの前に、本人確認のためお客様の生体認証データ（顔画像とライブネス信号）を取得・処理することへの同意が必要です。このデータはこの確認にのみ使用されます。",
      privacyPolicy: "プライバシーポリシー",
      consentButton: "同意します — 続ける",
      declineButton: "同意しません",
      confirmTitle: "生体認証なしで続行しますか？",
      confirmBody: "生体認証を行わない場合、自撮りは取得されません。確認はすでにご提供いただいた情報を使用して完了します。この選択はこのセッションでは最終的なものです。",
      goBack: "戻る",
      confirmDecline: "確認 — 同意しません",
      declineComplete: "生体認証に進まないことを選択されました。ご提出いただいた書類を使用して本人確認が完了しました。"
    },
    introLiveness: {
      heading: "ここでライブであることを確認してください",
      instruction1: "十分な光があることを確認してください",
      instruction2: "必要な権限を許可してください",
      instruction3: "指示に従ってください",
      button: "進む",
      subHeading: "あと一歩です"
    },
    phoneSession: {
      heading: "電話でセッションを継続",
      subheading: "このウィンドウを開いたままにして、モバイルで終了してください",
      button: "ここで続行"
    },
    continueOnPhone: {
      heading: "電話で続行",
      subheading: "QRをスキャンするか、下のリンクをコピーしてください",
      subheading2: "QRをスキャンするか、リンクを電話で開いてください",
      text: "プロセスを完了する",
      text1: "ここで確認して送信",
      button: "コピー",
      copiedButton: "コピーしました！",
      copied: "コピーしました！"
    },
    SsnReview: {
      heading: "詳細を確認してください",
      subHeading: "必要な変更を行い、詳細を送信してください",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "クラス",
      feild5: "RSTR",
      feild6: "国",
      feild7: "住所",
      button: "詳細は正しい"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "顔を円の中に保ってください"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "カメラに近づいてください"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "恥ずかしがらずに映ってください"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "暗すぎます。明るい場所へ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "明るすぎます。柔らかい光の場所へ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "顔を円の中に保ってください"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "動かないでください"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "顔を光の方へ向けてください"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "スマホを目の高さに持ってください"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "カメラから少し離れてください"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "顔をフレームの中央に合わせてください"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "顔を円の中心に合わせてください"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "近づいて顔をまっすぐにしてください"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "画面に入り、顔をまっすぐにしてください"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "暗すぎます。より明るい光を見つけてください"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "明るすぎます。最適な光を見つけてください"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "顔を円の中心に調整してください"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "じっとして正面を見てください"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "光に向かい、じっとしていてください"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "携帯電話を目の高さに保ってください"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "カメラから少し離れてください"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完璧です！"
      },
      smile1: {
        icon: "mood",
        description: "笑ってください、素晴らしいです！"
      },
      smile2: {
        icon: "mood",
        description: "カメラに向かって笑ってください！"
      }
    },
    successful: {
      title: "ありがとうございました！",
      text: "身分確認に必要な情報はすべて収集しました",
      finishBtn: "終了"
    },
    poweredBy: "提供元",
    redirect: "リダイレクト中",
    error: {
      message: "URLが期限切れまたは無効です"
    },
    sessionExpiredError: {
      heading: "申し訳ありませんが、セッションが期限切れです",
      subHeading1: "しばらくアクティブでなかったため、セキュリティ上の理由でセッションが自動的に期限切れとなりました",
      subHeading2: "再試行してください",
      buttonText: "再試行"
    },
    journeyExpiredError: {
      heading: "申し訳ありませんが、リンクが期限切れです",
      subHeading1: "リンクがアクティブでなくなりました。セキュリティ上の理由から、リンクには限られた寿命があります",
      subHeading2: "新しいリンクで再試行してください",
      buttonText: "再試行"
    },
    cameraAccessError: {
      alert1: "カメラアクセスが拒否されました。ブラウザの設定でカメラアクセスを有効にしてください",
      alert2: "カメラにアクセス中にエラーが発生しました",
      alert3: "ブラウザがカメラアクセスをサポートしていません"
    },
    footer: {
      securedBy: "提供元"
    },
    helpFaq: {
      title: "ヘルプとよくある質問",
      subtitle: "私たちはあなたをサポートするためにここにいます",
      cameraText: "身分を確認するために、デバイスのカメラを使用して画像を撮影する必要があります。この link をクリックして、必要な権限を許可する方法を学んでください",
      cameraHeading: "カメラの許可",
      languageText: "プロセスの開始時に、トップバーのドロップダウンメニューから希望の言語を選択できます",
      languageHeading: "言語選択",
      kycText: "KYC、またはお客様を知ることは、顧客の身元を確認し、コンプライアンスを確保し、不正行為やその他の違法行為を防止するプロセスです",
      kycHeading: "KYCとは何ですか？",
      timeText: "通常、約60秒かかります。ただし、国によって異なる場合があります",
      timeHeading: "どのくらい時間がかかりますか？"
    },
    pdfPreviewUnavailable: "PDFのプレビューを表示できません。",
    pdfPreviewHint: "プレビューが表示されない場合でも、続行できます。",
    pdfOpenLabel: "PDFを開く",
    failedUpload: {
      title: "ファイルのアップロードに失敗しました",
      text: "ファイルが5MB未満で、.jpg、.jpeg、.png、.heic、.heif、または.pdf形式であることを確認してください",
      btn: "もう一度試す",
      pdfNotAllowedIndia: "インドではPDFのアップロードはできません。5 MB未満のJPEG、JPG、PNG、HEIC、またはHEIFファイルをアップロードしてください。",
      pdfNotAllowedIndiaBasic: "インドではPDFのアップロードはできません。5 MB未満のJPEG、JPG、またはPNGファイルをアップロードしてください。"
    },
    livenessAnalyzing: {
      heading: "顔を分析しています",
      subHeading: "お待ちください。数秒で完了します"
    },
    activeLiveness: {
      instruction: "顔を円の中に保ち、指示に従ってください",
      permissionDeniedTitle: "カメラまたはマイクへのアクセスが拒否されました",
      permissionDeniedSubtitle: "ブラウザの設定でカメラとマイクへのアクセスを許可して、もう一度お試しください。"
    },
    flipScreen: {
      heading: "次に身分証明書を裏返してください",
      subHeading: "裏面を表示するために身分証明書を実際に裏返し、カメラのフレーム内に配置してください。",
      continueButton: "続行"
    },
    mobileDocCapture: {
      frontSide: "表面",
      backSide: "裏面",
      of: "の",
      upload: "アップロード",
      stillNotWorking: "まだ動作しませんか？",
      clickToCapture: "クリックでキャプチャを試す",
      skip: "スキップ"
    }
,
    permissionPopUp: {
      title: "許可が必要です",
      subtitle: "カメラを使用するためにアクセスを許可してください",
      decline: "拒否",
      allow: "許可"
    },
    userDetails: {
      heading: "PAN 認証",
      subHeading: "確認のため詳細を入力してください",
      panLabel: "PAN 番号",
      panRequired: "PAN 番号を入力してください",
      saveError: "詳細の保存中に問題が発生しました。もう一度お試しください。",
      proceed: "続行"
    },
    redirectCta: {
      or: "または",
      clickHere: "ここをクリック",
      clickHereStart: "ここをクリック",
      toContinue: "して続行"
    },
    documentCapture: {
      stillNotWorking: "まだ機能しませんか？",
      clickToCaptureInstead: "代わりにクリックで撮影をお試しください",
      pdfNotAllowedIndia: "インドでは PDF のアップロードは許可されていません。5 MB 未満の JPEG、JPG、または PNG ファイルをアップロードしてください。",
      pdfNotAllowedIndiaMobile: "インドでは PDF のアップロードは許可されていません。5 MB 未満の JPEG、JPG、PNG、HEIC、または HEIF ファイルをアップロードしてください。",
      fileFormatsIndia: "jpeg、jpg、png 5 mb 未満",
      fileFormats: "jpeg、jpg、png、pdf 5 mb 未満",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 5 mb 未満",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 5 mb 未満"
    },
    mobileCapture: {
      upload: "アップロード",
      skip: "スキップ",
      stillNotWorking: "まだうまくいきませんか？",
      tryClickToCapture: "タップして撮影"
    },
    UserDetails: {
      panLabel: "PAN番号",
      proceedBtn: "次へ進む",
      panRequired: "PAN番号を入力してください",
      saveError: "詳細の保存中にエラーが発生しました。もう一度お試しください。"
    }
  },
  mr: {
    supportingDocument: {
      headingFallback: "सहाय्यक दस्तऐवज",
      subHeading: "खालील दस्तऐवज अपलोड करा. तो पुनरावलोकनासाठी संग्रहित केला जातो — त्यातून काहीही काढले जात नाही.",
      choosePlaceholder: "फाइल निवडा (PNG, JPG किंवा PDF)",
      continue: "सुरू ठेवा",
      uploading: "अपलोड होत आहे...",
      skip: "आत्ता वगळा",
      errorInvalidType: "PNG, JPG किंवा PDF फाइल अपलोड करा.",
      errorTooLarge: "फाइल खूप मोठी आहे. मर्यादा 10MB आहे.",
      errorRead: "ती फाइल वाचता आली नाही. कृपया दुसरी वापरून पहा.",
      errorNoFile: "कृपया अपलोड करण्यासाठी फाइल निवडा.",
    },
    header: {
      title: "आपली ओळख सत्यापित करूया",
      subtitle: "हे 2 मिनिटांपेक्षा कमी वेळ लागतो",
      havingIssue: "अडचण येत आहे?"
    },
    onlyIdVerificationHeader: {
      title: "आपली ओळख सत्यापित करूया",
      subtitle: "हे फक्त एका मिनिटात पूर्ण होईल. फक्त आपला ओळखपत्र दस्तऐवज तयार ठेवा",
      instruction1: "कॅमेरा प्रवेश परवानगी द्या",
      instruction2: "दस्तऐवज स्कॅन करा किंवा अपलोड करा",
      instruction3: "त्वरित दस्तऐवज सत्यापन"
    },
    subHeading: {
      subHeading1: "आपला ओळखपत्र दस्तऐवज कॅप्चर करा",
      subHeading2: "आपण जिवंत असल्याचे सत्यापित करा",
      livenessHeading1: "चांगला प्रकाश असलेली जागा शोधा",
      livenessHeading2: "तुमचा चेहरा मध्यभागी ठेवा"
    },
    termsAndCondition: {
      title: "मी खालील अटी आणि शर्ती मान्य करतो.",
      privacyPolicy: "अटी पहा",
      beginBtnText: "सुरू करा",
      beginLiveness: "लाइव्हनेस तपासणी सुरू",
      startLiveness: "लाइव्हनेस तपासणीसाठी पुढे जा"
    },
    permissionDenied: {
      title: "कॅमेरा प्रवेश नाकारला!",
      subtitle: "ब्राउझरच्या पत्त्याच्या पट्टीजवळ एक अवरोधित कॅमेरा आयकॉन तपासा आणि ते अनब्लॉक करा.",
      readMore: "आधिक जाणून घ्या",
      refreshText: "कॅमेरा प्रवेश अनुमती दिल्यावर, खालील रिफ्रेश बटणावर क्लिक करा.",
      refreshBtn: "रिफ्रेश",
      link: "किंवा, फोनवर चालू ठेवा",
      buttonText: "किंवा, फोनवर चालू ठेवा"
    },
    desktopBrowserPermissionDenied: {
      readMore: "आधिक जाणून घ्या",
      refreshText: "कॅमेरा प्रवेश अनुमती दिल्यावर, खालील रिफ्रेश बटणावर क्लिक करा.",
      refreshBtn: "रिफ्रेश",
      link: "किंवा, फोनवर चालू ठेवा",
      buttonText: "किंवा, फोनवर चालू ठेवा",
      title: "कॅमेरा प्रवेश नाकारला!",
      subtitle: "ब्राउझरच्या पत्त्याच्या पट्टीजवळ एक अवरोधित कॅमेरा आयकॉन तपासा आणि ते अनब्लॉक करा."
    },
    androidBrowserPermissionDenied: {
      title: "कॅमेरा प्रवेश नाकारला!",
      subtitle: "ब्राउझरच्या पत्त्याच्या पट्टीजवळ ब्लॉक केलेला कॅमेरा आयकॉन तपासा आणि अनब्लॉक करा.",
      readMore: "अधिक जाणून घ्या",
      refreshText: "एकदा कॅमेरा प्रवेशाला परवानगी दिली की, खालील रिफ्रेश बटणावर क्लिक करा.",
      refreshBtn: "रिफ्रेश करा",
      link: "किंवा, फोनवर पुढे चला",
      buttonText: "किंवा, फोनवर पुढे चला"
    },
    androidWebViewPermissionDenied: {
      title: "कॅमेरा प्रवेश नाकारला!",
      subtitle: "कॅमेरा प्रवेश तुमच्या अॅपच्या सेटिंगमुळे बंद असू शकतो. कृपया फोनच्या अॅप माहिती > परवानग्या > कॅमेरा तपासा आणि प्रवेश द्या.",
      refreshText: "एकदा कॅमेरा प्रवेशाला परवानगी दिली की, खालील रिफ्रेश बटणावर क्लिक करा.",
      refreshBtn: "रिफ्रेश करा",
      link: "किंवा, फोनवर पुढे चला",
      buttonText: "किंवा, फोनवर पुढे चला"
    },
    iosBrowserPermissionDenied: {
      title: "कॅमेरा प्रवेश नाकारला!",
      subtitle: "पत्त्याच्या पट्टीजवळील कॅमेरा किंवा लॉक आयकॉन वर टॅप करा जेणेकरून प्रवेश दिला जाईल, किंवा ब्राउझरच्या सेटिंगची तपासणी करा.",
      readMore: "अधिक जाणून घ्या",
      refreshText: "एकदा कॅमेरा प्रवेशाला परवानगी दिली की, खालील रिफ्रेश बटणावर क्लिक करा.",
      refreshBtn: "रिफ्रेश करा",
      link: "किंवा, फोनवर पुढे चला",
      buttonText: "किंवा, फोनवर पुढे चला"
    },
    iosWebViewPermissionDenied: {
      title: "कॅमेरा प्रवेश नाकारला!",
      subtitle: "कॅमेरा प्रवेश तुमच्या अॅपच्या सेटिंगमुळे बंद असू शकतो. सेटिंग्जमध्ये जा, वापरल्या जाणाऱ्या अॅपला शोधा आणि कॅमेरा परवानगी सक्रिय करा.",
      refreshText: "एकदा कॅमेरा प्रवेशाला परवानगी दिली की, खालील रिफ्रेश बटणावर क्लिक करा.",
      refreshBtn: "रिफ्रेश करा",
      link: "किंवा, फोनवर पुढे चला",
      buttonText: "किंवा, फोनवर पुढे चला"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "कृपया तुमचा चेहरा झाकणारी कोणतीही वस्तू काढा",
        button: "पुन्हा प्रयत्न करा"
      },
      eyeClosureDetected: {
        heading: "कृपया आपली डोळे उघडी ठेवा आणि थेट कॅमेऱ्याकडे बघा",
        button: "पुन्हा प्रयत्न करा"
      },
      isMultipleFacesFound: {
        heading: "एकापेक्षा जास्त चेहरे आढळले. खात्री करा की कॅमेऱ्यात फक्त तुमचा चेहरा दिसत आहे.",
        button: "पुन्हा प्रयत्न करा"
      },
      noFacesFound: {
        heading: "कोणतेही चेहरे आढळले नाहीत. कृपया तुमचे चेहरे कॅमेरामध्ये दृश्यमान आहे याची खात्री करा.",
        button: "पुन्हा प्रयत्न करा"
      },
      faceDetections: {
        heading: "कृपया हे काढा",
        button: "पुन्हा प्रयत्न करा"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "एकाधिक चेहरे आढळले",
          button: "पुन्हा प्रयत्न करा"
        },
        generalMessage: {
          heading: "कृपया खात्री करा की तुम्ही कॅमेराच्या समोर लाईव्ह आहात",
          button: "पुन्हा प्रयत्न करा"
        }
      },
      faceMatch: {
        heading: "तुमचे चेहरा ओळखपत्राच्या फोटोशी जुळत नाही",
        button: "पुन्हा प्रयत्न करा"
      },
      selfieError: {
        heading: "आम्ही तुमचा सेल्फी तपासू शकले नाही",
        subHeading1: "हे टिप्स फॉलो करा आणि पुन्हा प्रयत्न करा",
        instruction1: "चांगल्या प्रकाशात जाऊन बॅकलाईट टाळा",
        instruction2: "तुमचा चेहरा पूर्णपणे दिसला पाहिजे आणि फ्रेमच्या मध्यभागी ठेवा",
        instruction3: "तुमच्या चेहऱ्याचा स्पष्ट दृश्य मिळवण्यासाठी टोपी, चष्मा किंवा मास्क काढा",
        button: "पुन्हा प्रयत्न करा"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP जुळला नाही. कृपया OTP स्पष्टपणे मोठ्याने वाचा",
        button: "पुन्हा प्रयत्न करा"
      },
      activeLivenessGenericFailureMessage: {
        heading: "पडताळणी अयशस्वी झाली. कृपया सूचनांचे स्पष्टपणे पालन करा आणि पुन्हा प्रयत्न करा",
        button: "पुन्हा प्रयत्न करा"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF मध्ये खूप जास्त पृष्ठे आहेत",
        subHeading: "अपलोड केलेली PDF 2-पृष्ठांची मर्यादा ओलांडते. कृपया 2 पेक्षा जास्त पृष्ठे नसलेली PDF, किंवा तुमच्या ओळखपत्राची स्पष्ट प्रतिमा अपलोड करा."
      },
      heading: "आम्ही तुमचा ID प्रक्रिया करू शकले नाही",
      subHeading: "किंवा तुम्ही चुकीचा ID अपलोड करत आहात किंवा प्रतिमा अस्पष्ट आहे",
      buttonBack: "ID च्या मागील बाजूस पुन्हा प्रयत्न करा",
      buttonFront: "ID च्या पुढील बाजूस पुन्हा प्रयत्न करा",
      button: "पुन्हा प्रयत्न करा",
      captureFrontSide: "पुढील बाजू कॅप्चर करा",
      captureBackSide: "मागील बाजू कॅप्चर करा",
      changeIDButton: "दुसरा दस्तऐवज निवडा",
      wrongid: {
        heading: "आम्ही हा दस्तऐवज प्रक्रिया करू शकले नाही",
        subHeading: "कृपया तपासा की तुम्ही योग्य दस्तऐवज अपलोड करत आहात आणि प्रतिमेची गुणवत्ता स्पष्ट आहे की नाही"
      },
      expiredid: {
        heading: "ID दस्तऐवज कालबाह्य आहे!",
        subHeading: "आम्ही कालबाह्य ID दस्तऐवज स्वीकारू शकत नाही. कृपया वैध दस्तऐवज प्रदान करा"
      },
      minimumage: {
        heading: "किमान वयाची आवश्यकता पूर्ण झाली नाही!",
        subHeading: "तुमचं वय किमान आवश्यक वयापेक्षा कमी आहे. कृपया किमान वयाची अटी पूर्ण केल्याची खात्री करा"
      },
      mobileAttemptsDone: {
        heading: "यात्रा तुमच्या मागील डिव्हाइसवर पुन्हा सुरू झाली",
        subHeading: "हा सत्र आता डुप्लिकेशन टाळण्यासाठी थांबवला आहे."
      },
      finished: {
        heading: "यात्रा समाप्त झाली",
        subHeading: "यात्रा पूर्ण झाली आहे किंवा रद्द केली आहे"
      },
      invalid: {
        heading: "यात्रा उपलब्ध नाही!",
        subHeading: "किंवा यात्राId सापडला नाही किंवा यात्राId चुकीचा आहे"
      },
      DOCTYPE_FALSE: {
        heading: "दस्तऐवज ओळखला गेला नाही!",
        subHeading: "कृपया वैध दस्तऐवज अपलोड करा आणि प्रतिमेची गुणवत्ता चांगली आहे याची खात्री करा."
      },
      ONLY_FRONT: {
        heading: "आयडीचा मागील भाग गहाळ आहे",
        subHeading: "तुम्ही फक्त पुढील भाग अपलोड केला आहे. कृपया तुमचा आयडी उलटा करा आणि पुढे जाण्यासाठी मागील भाग अपलोड करा"
      },
      ONLY_BACK: {
        heading: "आयडीचा पुढील भाग गहाळ आहे",
        subHeading: "तुम्ही फक्त मागील भाग अपलोड केला आहे. कृपया तुमचा आयडी उलटा करा आणि पुढे जाण्यासाठी पुढील भाग अपलोड करा"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "दस्तऐवज लवकरच कालबाह्य होणार आहे!",
        subHeading: "दस्तऐवज लवकरच कालबाह्य होत असल्यामुळे तो नाकारण्यात आला आहे."
      },
      DOCUMENT_EXPIRED: {
        heading: "दस्तऐवज कालबाह्य आहे!",
        subHeading: "कृपया वैध, कालबाह्य नसलेला दस्तऐवज अपलोड करा."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "किमान वयाची आवश्यकता पूर्ण झाली नाही!",
        subHeading: "दस्तऐवज दर्शवितो की तुम्ही आवश्यक वय पूर्ण करत नाही. कृपया वैध दस्तऐवज अपलोड करा."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तऐवज सत्यापित करू शकले नाही!",
        subHeading: "प्रतिमेची गुणवत्ता खूप खराब आहे सत्यापनासाठी. कृपया स्पष्ट प्रतिमेसह पुन्हा प्रयत्न करा."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तऐवज सत्यापित करू शकले नाही!",
        subHeading: "काही माहिती सत्यापित केली जाऊ शकली नाही. कृपया स्पष्ट प्रतिमेसह पुन्हा प्रयत्न करा."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तऐवज सत्यापित करू शकले नाही!",
        subHeading: "काही तपशील प्रतिमा गुणवत्ता खराब असल्यामुळे सत्यापित केली जाऊ शकली नाही. कृपया स्पष्ट प्रतिमेसह पुन्हा प्रयत्न करा"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तऐवज सत्यापित करू शकले नाही!",
        subHeading: "काही तपशील सत्यापित केली जाऊ शकली नाही. कृपया स्पष्ट प्रतिमेसह पुन्हा प्रयत्न करा."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "दस्तऐवजाची सजीवता तपासणी अयशस्वी झाली",
        subHeading: "आम्हाला असे संकेत मिळाले आहेत की दस्तऐवज खरा नसू शकतो. कृपया स्क्रीनशॉट, प्रिंट केलेल्या प्रती किंवा स्क्रीनवर दाखवलेली ओळखपत्रे वापरणे टाळा. सर्व वैशिष्ट्ये स्पष्टपणे दिसणारा मूळ दस्तऐवज अपलोड करा."
      },
      SECURITY_FALSE: {
        heading: "समस्या आढळली!",
        subHeading: "दस्तऐवज सत्यापित केला जाऊ शकला नाही. कृपया स्पष्ट प्रतिमेसह पुन्हा प्रयत्न करा"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "प्रतिमेची गुणवत्ता खराब आहे!",
        subHeading: "प्रतिमा खूप धूसर किंवा अस्पष्ट आहे. कृपया स्पष्ट प्रतिमेसह पुन्हा प्रयत्न करा"
      },
      FACE_UNDETECTED: {
        heading: "चेहरा शोधला गेला नाही",
        subHeading: "आम्ही दस्तऐवजात स्पष्ट चेहरा शोधू शकलो नाही. कृपया एक वैध ओळखपत्र अपलोड करा ज्यात चेहरा स्पष्टपणे दिसत असेल."
      },
      INVALID_PAN_NUMBER: {
        heading: "अवैध PAN क्रमांक",
        subHeading: "तुम्ही टाकलेला PAN क्रमांक वैध नाही. कृपया तपासा आणि पुन्हा प्रयत्न करा"
      },
      INVALID_PAN_STATUS: {
        heading: "अवैध PAN स्थिती",
        subHeading: "तुम्ही टाकलेला PAN क्रमांक वैध नाही. कृपया तपासा आणि पुन्हा प्रयत्न करा"
      },
      directKyc: {
        heading: "थेट KYC प्रवास !",
        subHeading: "हा एक थेट KYC प्रवास आहे. फ्रंटएंड प्रवासाची परवानगी नाही."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "ओळखपत्रावरील तुमचा फोटो सत्यापित करताना समस्या",
        subHeading: "आम्ही ओळखपत्रावरील तुमचा फोटो सत्यापित करू शकलो नाही. कृपया तुमच्या मूळ ओळखपत्राचा स्पष्ट फोटो अपलोड करा जेणेकरून आम्ही त्याची खात्री करू शकू."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "दस्तऐवज सुरक्षा नमुना तपासणी अयशस्वी",
        subHeading: "आम्ही दस्तऐवजाचे अंगभूत सुरक्षा नमुने सत्यापित करू शकलो नाही. कृपया त्याची सत्यता निश्चित करण्यात मदत करण्यासाठी मूळ ओळखपत्राचा स्पष्ट फोटो अपलोड करा."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "दस्तऐवजांमधील तुलना अयशस्वी",
        subHeading: "एक किंवा अधिक प्रमुख क्षेत्रांमध्ये (नाव, जन्मतारीख किंवा चेहरा) जुळत नसल्यामुळे दस्तऐवजांमधील तुलना अयशस्वी झाली"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker अपयश",
        subHeading: "Digilocker प्रवासादरम्यान एक त्रुटी आली. कृपया पुन्हा प्रयत्न करा किंवा पुढे जाण्यासाठी पर्यायी पद्धत वापरा."
      },
      LINKAGE_FAILED: {
        heading: "हे सत्यापन पूर्ण होऊ शकले नाही",
        subHeading: "या तपासणीसाठी घेतलेली माहिती नोंदींशी जुळली नाही."
      }
    },
    documentationList: {
      countryHeading: "देश निवडा",
      docHeading: "आपला दस्तऐवज निवडा",
      btnText: "पुढे",
      searchCountry: "देश शोधा"
    },
    frontDocCapture: {
      heading: "आयडीच्या पुढील बाजूस चौकोनात ठेवा",
      backupHeading: "काही समस्या आहेत? कृपया प्रतिमा मॅन्युअली क्लिक करा",
      btnText: "फोटो घ्या",
      headingBack: " आयतामध्ये",
      uploadButton: "किंवा, आयडी अपलोड करा"
    },
    backDocCapture: {
      heading: "आयडीच्या मागील बाजूस चौकोनात ठेवा",
      backupHeading: "काही समस्या आहेत? कृपया प्रतिमा मॅन्युअली क्लिक करा",
      btnText: "फोटो घ्या",
      containerText: "किंवा, दस्तऐवज अपलोड करा",
      text: "कॅप्चर करत आहे, स्थिर रहा",
      headingBack: " आयतामध्ये",
      skipButton: "मागील बाजू वगळा",
      uploadButton: "किंवा, आयडी अपलोड करा"
    },
    analyzing: {
      heading: "आपला आयडी विश्लेषण करत आहे...",
      subHeading: "कृपया पुढील स्क्रीनवर आपल्या कार्डच्या तपशीलाची तपासणी करा आणि आवश्यक असल्यास संपादन करा"
    },
    imageCheck: {
      heading: "आपली प्रतिमा तपासा",
      subHeading: "कृपया सुनिश्चित करा की प्रतिमा संपूर्ण, स्पष्ट आणि ब्लर आणि झगमगाट मुक्त आहे.",
      button1: "फोटो पुन्हा घ्या",
      button2: "ठीक आहे",
      frontHeading: "समोरील प्रतिमा तपासा",
      backHeading: "मागील प्रतिमा तपासा"
    },
    errorHandler: {
      heading: "अरेरे :(",
      subHeading1: "आम्हाला काही समस्या येत आहेत, परंतु काळजी करू नका! कृपया पुन्हा प्रयत्न करा",
      subHeading2: "जर हे कायम राहिले, तर नंतर पुन्हा तपासा",
      button: "पुन्हा प्रयत्न करा"
    },
    biometricConsent: {
      consentStatement: "तुमच्या सेल्फीपूर्वी, तुमची ओळख पडताळण्यासाठी आम्हाला तुमचा बायोमेट्रिक डेटा (चेहऱ्याची प्रतिमा आणि लाइव्हनेस सिग्नल) कॅप्चर व प्रक्रिया करण्याची तुमची संमती आवश्यक आहे. हा डेटा केवळ याच पडताळणीसाठी वापरला जातो.",
      privacyPolicy: "गोपनीयता धोरण",
      consentButton: "मी संमती देतो — पुढे चला",
      declineButton: "मी संमती देत नाही",
      confirmTitle: "बायोमेट्रिक पडताळणीशिवाय पुढे जायचे?",
      confirmBody: "बायोमेट्रिक पडताळणीशिवाय आम्ही सेल्फी घेणार नाही. तुम्ही आधीच दिलेल्या माहितीचा वापर करून तुमची पडताळणी पूर्ण केली जाईल. ही निवड या सत्रासाठी अंतिम आहे.",
      goBack: "मागे जा",
      confirmDecline: "निश्चित करा — संमती नाही",
      declineComplete: "तुम्ही बायोमेट्रिक पडताळणी न करण्याचे निवडले आहे. तुम्ही सादर केलेल्या कागदपत्रांचा वापर करून तुमची ओळख पडताळणी पूर्ण झाली आहे."
    },
    introLiveness: {
      heading: "येथे आपण जिवंत असल्याचे सत्यापित करा",
      instruction1: "पुरेशी प्रकाश व्यवस्था सुनिश्चित करा",
      instruction2: "आवश्यक परवानग्या द्या",
      instruction3: "फक्त सूचनांचे अनुसरण करा",
      button: "पुढे जा",
      subHeading: "तुम्ही फक्त एक पाऊल दूर आहात"
    },
    phoneSession: {
      heading: "सत्र फोनवर सुरू आहे",
      subheading: "मोबाइलवर समाप्त होईपर्यंत ही विंडो उघडी ठेवा",
      button: "येथे सुरू ठेवा"
    },
    continueOnPhone: {
      heading: "फोनवर सुरू ठेवा",
      subheading: "QR स्कॅन करा किंवा खालील लिंक कॉपी करा",
      subheading2: "QR स्कॅन करा किंवा आपल्या फोनवर लिंक उघडा",
      text: "प्रक्रिया पूर्ण करा",
      text1: "सबमिट करण्यासाठी येथे परत तपासा",
      button: "कॉपी करा",
      copiedButton: "कॉपी केले!",
      copied: "कॉपी झाले!"
    },
    SsnReview: {
      heading: "आपल्या तपशीलांचे पुनरावलोकन करा",
      subHeading: "आवश्यक बदल करा आणि तपशील सबमिट करा",
      feild1: "ड्रायव्हिंग लायसन्स",
      feild2: "एक्सपी",
      feild3: "जन्मतारीख",
      feild4: "श्रेणी",
      feild5: "मर्यादा",
      feild6: "देश",
      feild7: "पत्ता",
      button: "तपशील बरोबर आहेत"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "तुमचा चेहरा वर्तुळात ठेवा"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "कॅमेऱ्याजवळ या"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "लाजू नका, समोर या"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "खूप अंधार आहे. जास्त उजेडात जा"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "खूप प्रकाश आहे. मऊ उजेडात जा"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "तुमचा चेहरा वर्तुळात ठेवा"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर राहा"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "प्रकाशाकडे चेहरा करा"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "फोन डोळ्यांच्या उंचीवर धरा"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कॅमेऱ्यापासून थोडे दूर व्हा"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "तुमचा चेहरा फ्रेमच्या मध्यभागी ठेवा"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "आपला चेहरा वर्तुळाच्या मध्यभागी ठेवा"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "जवळ या आणि चेहरा सरळ ठेवा"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "दृश्यात या आणि चेहरा सरळ ठेवा"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "खूप अंधार. उजळ प्रकाश शोधा"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "खूप तेज. योग्य प्रकाश शोधा"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "आपला चेहरा वर्तुळाच्या मध्यभागी समायोजित करा"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर राहा आणि सरळ पुढे पहा"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "प्रकाशाकडे तोंड करा आणि स्थिर राहा"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "आपला फोन डोळ्याच्या उंचीवर ठेवा"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कॅमेऱ्यापासून थोडे दूर रहा"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "परफेक्ट!"
      },
      smile1: {
        icon: "mood",
        description: "हसा, तुम्ही छान दिसत आहात!"
      },
      smile2: {
        icon: "mood",
        description: "कॅमेऱ्यासाठी हसा!"
      }
    },
    successful: {
      title: "सत्यापन पूर्ण झाले",
      text: "आपण आता विंडो बंद करू शकता",
      finishBtn: "समाप्त"
    },
    poweredBy: "द्वारे समर्थित",
    redirect: "पुन्हा दिशा बदलत आहे",
    error: {
      message: "URL कालबाह्य झाला आहे किंवा वैध नाही"
    },
    footer: {
      securedBy: "द्वारे समर्थित"
    },
    helpFaq: {
      title: "सहाय्य आणि वारंवार विचारले जाणारे प्रश्न",
      subtitle: "आम्ही तुम्हाला मदत करण्यासाठी येथे आहोत",
      cameraText: "तुमची ओळख सत्यापित करण्यासाठी, आम्हाला तुमच्या डिव्हाइसच्या कॅमेऱ्याचा वापर करून चित्रे काढायची आहेत. आवश्यक परवानगी देण्यासाठी हा link फॉलो करा",
      cameraHeading: "कॅमेरा परवानगी",
      languageText: "प्रक्रियेच्या प्रारंभात, तुम्ही वरच्या बारमधील ड्रॉपडाऊन मेनूमधून तुमची इच्छित भाषा निवडू शकता",
      languageHeading: "भाषेचा पर्याय",
      kycText: "KYC, किंवा 'तुम्हाला ओळखा', हा एक प्रक्रिया आहे ज्याद्वारे ग्राहकांची ओळख पडताळली जाते, तसेच नियमांचे पालन आणि फसवणूक आणि इतर बेकायदेशीर क्रिया टाळण्यासाठी मदत केली जाते",
      kycHeading: "KYC काय आहे?",
      timeText: "साधारणपणे, यामध्ये साधारणत: 60 सेकंद लागतात. तथापि, हे देशानुसार बदलू शकते",
      timeHeading: "हे किती वेळ घेतं?"
    },
    pdfPreviewUnavailable: "PDF चे पूर्वावलोकन दाखवता आले नाही.",
    pdfPreviewHint: "पूर्वावलोकन दिसले नाही तरी तुम्ही पुढे जाऊ शकता.",
    pdfOpenLabel: "PDF उघडा",
    failedUpload: {
      title: "फाइल अपलोड अयशस्वी",
      text: "कृपया फाइल 5MB पेक्षा कमी आणि .jpg, .jpeg, .png, .heic, .heif किंवा .pdf स्वरूपात असल्याची खात्री करा",
      btn: "पुन्हा प्रयत्न करा",
      pdfNotAllowedIndia: "भारतासाठी PDF अपलोड करण्याची परवानगी नाही. कृपया 5 MB पेक्षा कमी JPEG, JPG, PNG, HEIC, किंवा HEIF फाइल्स अपलोड करा.",
      pdfNotAllowedIndiaBasic: "भारतासाठी PDF अपलोड करण्याची परवानगी नाही. कृपया 5 MB पेक्षा कमी JPEG, JPG, किंवा PNG फाइल्स अपलोड करा."
    },
    livenessAnalyzing: {
      heading: "तुमच्या चेहऱ्याचे विश्लेषण करत आहे",
      subHeading: "कृपया प्रतीक्षा करा, यास फक्त काही सेकंद लागतील"
    },
    sessionExpiredError: {
      heading: "क्षमस्व, तुमचे सत्र कालबाह्य झाले",
      subHeading1: "तुम्ही काही काळ निष्क्रिय होता. सुरक्षेच्या कारणास्तव, तुमचे सत्र आपोआप कालबाह्य झाले",
      subHeading2: "कृपया पुन्हा प्रयत्न करा",
      buttonText: "पुन्हा प्रयत्न करा"
    },
    journeyExpiredError: {
      heading: "क्षमस्व, लिंक कालबाह्य झाली",
      subHeading1: "लिंक यापुढे सक्रिय नाही. सुरक्षेच्या कारणास्तव, लिंकचे आयुष्य मर्यादित असते",
      subHeading2: "कृपया नवीन लिंकसह प्रयत्न करा",
      buttonText: "पुन्हा प्रयत्न करा"
    },
    cameraAccessError: {
      alert1: "कॅमेरा प्रवेश नाकारला गेला. कृपया तुमच्या ब्राउझर सेटिंग्जमध्ये कॅमेरा प्रवेश सक्षम करा",
      alert2: "कॅमेरा प्रवेश करताना त्रुटी आली",
      alert3: "तुमचा ब्राउझर कॅमेरा प्रवेशास समर्थन देत नाही"
    },
    activeLiveness: {
      instruction: "तुमचा चेहरा वर्तुळात ठेवा आणि सूचनांचे पालन करा",
      permissionDeniedTitle: "कॅमेरा किंवा मायक्रोफोन प्रवेश नाकारला",
      permissionDeniedSubtitle: "कृपया तुमच्या ब्राउझर सेटिंग्जमध्ये कॅमेरा आणि मायक्रोफोन प्रवेशास परवानगी द्या आणि पुन्हा प्रयत्न करा."
    },
    flipScreen: {
      heading: "आता तुमचे ओळखपत्र पलटा",
      subHeading: "कृपया मागील बाजू दाखवण्यासाठी तुमचे ओळखपत्र प्रत्यक्ष पलटा, नंतर ते कॅमेरा फ्रेममध्ये ठेवा.",
      continueButton: "सुरू ठेवा"
    },
    mobileDocCapture: {
      frontSide: "समोरील बाजू",
      backSide: "मागील बाजू",
      of: "ची",
      upload: "अपलोड करा",
      stillNotWorking: "अजूनही काम करत नाही?",
      clickToCapture: "क्लिक-टू-कॅप्चर वापरून पहा",
      skip: "वगळा"
    }
,
    permissionPopUp: {
      title: "परवानगी आवश्यक आहे",
      subtitle: "कॅमेरा वापरण्यासाठी प्रवेशास परवानगी द्या",
      decline: "नाकारा",
      allow: "परवानगी द्या"
    },
    userDetails: {
      heading: "PAN पडताळणी",
      subHeading: "पडताळणीसाठी कृपया तपशील भरा",
      panLabel: "PAN क्रमांक",
      panRequired: "कृपया तुमचा PAN क्रमांक प्रविष्ट करा",
      saveError: "तपशील जतन करताना काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.",
      proceed: "पुढे जा"
    },
    redirectCta: {
      or: "किंवा",
      clickHere: "येथे क्लिक करा",
      clickHereStart: "येथे क्लिक करा",
      toContinue: "सुरू ठेवण्यासाठी"
    },
    documentCapture: {
      stillNotWorking: "अजूनही काम करत नाही?",
      clickToCaptureInstead: "त्याऐवजी क्लिक-टू-कॅप्चर वापरून पहा",
      pdfNotAllowedIndia: "भारतासाठी PDF अपलोडला परवानगी नाही. कृपया 5 MB पेक्षा कमी JPEG, JPG, किंवा PNG फायली अपलोड करा.",
      pdfNotAllowedIndiaMobile: "भारतासाठी PDF अपलोडला परवानगी नाही. कृपया 5 MB पेक्षा कमी JPEG, JPG, PNG, HEIC, किंवा HEIF फायली अपलोड करा.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb पेक्षा कमी",
      fileFormats: "jpeg, jpg, png, pdf 5 mb पेक्षा कमी",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb पेक्षा कमी",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb पेक्षा कमी"
    },
    mobileCapture: {
      upload: "अपलोड करा",
      skip: "वगळा",
      stillNotWorking: "तरीही काम करत नाही?",
      tryClickToCapture: "टॅप करून फोटो काढा"
    },
    UserDetails: {
      panLabel: "PAN क्रमांक",
      proceedBtn: "पुढे जा",
      panRequired: "कृपया तुमचा PAN क्रमांक प्रविष्ट करा",
      saveError: "तपशील जतन करताना काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा."
    }
  },
  te: {
    supportingDocument: {
      headingFallback: "సహాయక పత్రం",
      subHeading: "క్రింద పత్రాన్ని అప్‌లోడ్ చేయండి. ఇది సమీక్ష కోసం నిల్వ చేయబడుతుంది — దీని నుండి ఏదీ సంగ్రహించబడదు.",
      choosePlaceholder: "ఫైల్‌ను ఎంచుకోండి (PNG, JPG లేదా PDF)",
      continue: "కొనసాగించండి",
      uploading: "అప్‌లోడ్ అవుతోంది...",
      skip: "ప్రస్తుతానికి దాటవేయి",
      errorInvalidType: "PNG, JPG లేదా PDF ఫైల్‌ను అప్‌లోడ్ చేయండి.",
      errorTooLarge: "ఫైల్ చాలా పెద్దది. పరిమితి 10MB.",
      errorRead: "ఆ ఫైల్‌ను చదవలేకపోయాం. దయచేసి మరొకటి ప్రయత్నించండి.",
      errorNoFile: "అప్‌లోడ్ చేయడానికి ఒక ఫైల్‌ను ఎంచుకోండి.",
    },
    header: {
      title: "మీ గుర్తింపును ధృవీకరించండి",
      subtitle: "ఇది 2 నిమిషాల కంటే తక్కువ సమయం పడుతుంది",
      havingIssue: "సమస్య ఉందా?"
    },
    onlyIdVerificationHeader: {
      title: "మీ గుర్తింపు పత్రాన్ని ధృవీకరిద్దాం",
      subtitle: "ఇది కేవలం ఒక నిమిషం పడుతుంది. మీ గుర్తింపు పత్రాన్ని సిద్ధంగా ఉంచండి",
      instruction1: "కెమెరా ప్రాప్యతను అనుమతించండి",
      instruction2: "మీ పత్రాన్ని స్కాన్ చేయండి లేదా అప్లోడ్ చేయండి",
      instruction3: "తక్షణ పత్ర ధృవీకరణ"
    },
    subHeading: {
      subHeading1: "మీ ఐడీ పత్రాన్ని తీసుకోండి",
      subHeading2: "మీరు సజీవంగా ఉన్నారని నిర్ధారించండి",
      livenessHeading1: "మంచి వెలుతురు ఉన్న ప్రదేశాన్ని కనుగొనండి",
      livenessHeading2: "మీ ముఖాన్ని మధ్యలో ఉంచండి"
    },
    termsAndCondition: {
      title: "నేను కింద పేర్కొన్న నిబంధనలు మరియు షరతులను అంగీకరిస్తున్నాను.",
      privacyPolicy: "నిబంధనలు చూడండి",
      beginBtnText: "ప్రారంభించండి",
      beginLiveness: "సజీవత తనిఖీ ప్రారంభిస్తోంది",
      startLiveness: "సజీవత తనిఖీకి కొనసాగండి"
    },
    permissionDenied: {
      title: "కెమెరా యాక్సెస్ నిరాకరించబడింది!",
      subtitle: "బ్రౌజర్ అడ్రస్ బార్ వద్ద బ్లాక్ చేయబడిన కెమెరా చిహ్నం ఉందేమో తనిఖీ చేయండి మరియు దాన్ని అన్‌బ్లాక్ చేయండి.",
      readMore: "మరింత చదవండి",
      refreshText: "కెమెరా యాక్సెస్ అనుమతించిన తర్వాత, దిగువ ఉన్న రిఫ్రెష్ బటన్‌పై క్లిక్ చేయండి.",
      refreshBtn: "రిఫ్రెష్",
      link: "లేదా, ఫోన్‌లో కొనసాగండి",
      buttonText: "లేదా, ఫోన్‌లో కొనసాగండి"
    },
    desktopBrowserPermissionDenied: {
      title: "దయచేసి కెమెరా యాక్సెస్‌ను అనుమతించండి",
      subtitle: "బ్రౌజర్ అనుమతులను కోరవచ్చు. దయచేసి 'అనుమతించు' పై క్లిక్ చేయండి.",
      readMore: "మరింత చదవండి",
      refreshText: "అనుమతులు ఇచ్చిన తర్వాత రిఫ్రెష్ చేయండి",
      refreshBtn: "రిఫ్రెష్",
      link: "లేదా, ఫోన్‌లో కొనసాగండి",
      buttonText: "లేదా, ఫోన్‌లో కొనసాగండి"
    },
    androidBrowserPermissionDenied: {
      title: "కెమెరా యాక్సెస్ నిరాకరించబడింది!",
      subtitle: "బ్రౌజర్ అడ్రస్ బార్ సమీపంలో బ్లాక్ చేసిన కెమెరా ఐకాన్ ఉన్నదేనా తనిఖీ చేసి అన్లాక్ చేయండి.",
      readMore: "మరింత చదవండి",
      refreshText: "కెమెరా యాక్సెస్ అనుమతించిన తర్వాత దిగువ రిఫ్రెష్ బటన్ నొక్కండి.",
      refreshBtn: "రిఫ్రెష్",
      link: "లేదా, ఫోన్‌లో కొనసాగండి",
      buttonText: "లేదా, ఫోన్‌లో కొనసాగండి"
    },
    androidWebViewPermissionDenied: {
      title: "కెమెరా యాక్సెస్ నిరాకరించబడింది!",
      subtitle: "కెమెరా యాక్సెస్ యాప్ సెట్టింగ్స్ వల్ల బ్లాక్ అయ్యి ఉండవచ్చు. మీ ఫోన్ లో యాప్ ఇన్ఫో > అనుమతులు > కెమెరా చూడండి, యాక్సెస్ ఇస్తుంది.",
      refreshText: "కెమెరా యాక్సెస్ అనుమతించిన తర్వాత దిగువ రిఫ్రెష్ బటన్ నొక్కండి.",
      refreshBtn: "రిఫ్రెష్",
      link: "లేదా, ఫోన్‌లో కొనసాగండి",
      buttonText: "లేదా, ఫోన్‌లో కొనసాగండి"
    },
    iosBrowserPermissionDenied: {
      title: "కెమెరా యాక్సెస్ నిరాకరించబడింది!",
      subtitle: "అడ్రస్ బార్ సమీపంలోని కెమెరా లేదా లాక్ ఐకాన్‌పై ట్యాప్ చేసి యాక్సెస్ అనుమతించండి లేదా బ్రౌజర్ సెట్టింగ్స్ చెక్ చేయండి.",
      readMore: "మరింత చదవండి",
      refreshText: "కెమెరా యాక్సెస్ అనుమతించిన తర్వాత దిగువ రిఫ్రెష్ బటన్ నొక్కండి.",
      refreshBtn: "రిఫ్రెష్",
      link: "లేదా, ఫోన్‌లో కొనసాగండి",
      buttonText: "లేదా, ఫోన్‌లో కొనసాగండి"
    },
    iosWebViewPermissionDenied: {
      title: "కెమెరా యాక్సెస్ నిరాకరించబడింది!",
      subtitle: "కెమెరా యాక్సెస్ మీ యాప్ సెట్టింగ్స్ వల్ల బ్లాక్ అయి ఉండొచ్చు. సెట్టింగ్స్‌లోకి వెళ్లి, మీరు ఉపయోగిస్తున్న యాప్ కోసం కెమెరా అనుమతిని యాక్టివేట్ చేయండి.",
      refreshText: "కెమెరా యాక్సెస్ అనుమతించిన తర్వాత దిగువ రిఫ్రెష్ బటన్ నొక్కండి.",
      refreshBtn: "రిఫ్రెష్",
      link: "లేదా, ఫోన్‌లో కొనసాగండి",
      buttonText: "లేదా, ఫోన్‌లో కొనసాగండి"
    },
    documentationList: {
      countryHeading: "దేశాన్ని ఎంచుకోండి",
      docHeading: "మీ పత్రాన్ని ఎంచుకోండి",
      btnText: "తర్వాత",
      searchCountry: "దేశాన్ని వెతకండి"
    },
    frontDocCapture: {
      heading: "ఐడీ యొక్క ముందు వైపు చతురస్రంలో ఉంచండి",
      backupHeading: "ఇబ్బందిగా ఉందా? దయచేసి చిత్రాన్ని మాన్యువల్‌గా క్లిక్ చేయండి",
      btnText: "ఫోటో తీసుకోండి",
      headingBack: " దీర్ఘచతురస్రంలో",
      uploadButton: "లేదా, ఐడిని అప్‌లోడ్ చేయండి"
    },
    backDocCapture: {
      heading: "ఐడీ యొక్క వెనుక వైపు చతురస్రంలో ఉంచండి",
      backupHeading: "ఇబ్బందిగా ఉందా? దయచేసి చిత్రాన్ని మాన్యువల్‌గా క్లిక్ చేయండి",
      btnText: "ఫోటో తీసుకోండి",
      containerText: "లేదా, పత్రాన్ని అప్‌లోడ్ చేయండి",
      text: "క్యాప్చర్ చేస్తోంది, స్థిరంగా ఉండండి",
      headingBack: " దీర్ఘచతురస్రంలో",
      skipButton: "వెనుక వైపు దాటవేయండి",
      uploadButton: "లేదా, ఐడిని అప్‌లోడ్ చేయండి"
    },
    analyzing: {
      heading: "మీ ఐడీని విశ్లేషిస్తోంది...",
      subHeading: "దయచేసి తదుపరి స్క్రీన్‌లో మీ కార్డ్ వివరాలను తనిఖీ చేయండి మరియు అవసరమైతే సవరించండి"
    },
    imageCheck: {
      heading: "మీ చిత్రాన్ని తనిఖీ చేయండి",
      subHeading: "దయచేసి చిత్రాన్ని పూర్తిగా, స్పష్టంగా మరియు మరకలు మరియు కాంతి లేకుండా నిర్ధారించండి.",
      button1: "మళ్లీ ఫోటో తీసుకోండి",
      button2: "సరే",
      frontHeading: "ముందు చిత్రాన్ని తనిఖీ చేయండి",
      backHeading: "వెనుక చిత్రాన్ని తనిఖీ చేయండి"
    },
    errorHandler: {
      heading: "అయ్యో :(",
      subHeading1: "మేము కొన్ని సమస్యలను ఎదుర్కొంటున్నాము, కానీ ఆందోళన చెందకండి! దయచేసి మళ్లీ ప్రయత్నించండి",
      subHeading2: "ఇది కొనసాగితే, తర్వాత చెక్ చేయండి",
      button: "మళ్లీ ప్రయత్నించండి"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "దయచేసి మీ ముఖాన్ని కప్పిన ఏదైనా తీసి వేయండి",
        button: "మరలా ప్రయత్నించండి"
      },
      eyeClosureDetected: {
        heading: "దయచేసి మీ కన్నాలు తెరిచి ఉంచి కెమెరాకు నేరుగా చూడండి",
        button: "మళ్లీ ప్రయత్నించండి"
      },
      isMultipleFacesFound: {
        heading: "అनेक ముఖాలు గుర్తించబడ్డాయి. కెమెరాలో మీ ముఖం మాత్రమే కనిపిస్తున్నదని నిర్ధారించండి.",
        button: "మరలా ప్రయత్నించండి"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "మరలా ప్రయత్నించండి"
      },
      faceDetections: {
        heading: "దయచేసి దీన్ని తీసి వేయండి",
        button: "మరలా ప్రయత్నించండి"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "బహుళ ముఖాలు కనుగొనబడ్డాయి",
          button: "మరలా ప్రయత్నించండి"
        },
        generalMessage: {
          heading: "దయచేసి మీరు కెమెరా ముందు ప్రత్యక్షంగా ఉన్నారు కాబట్టి నిర్ధారించుకోండి",
          button: "మరలా ప్రయత్నించండి"
        }
      },
      faceMatch: {
        heading: "మీ ముఖం ఐడీ ఫోటోతో సరిపోదు",
        button: "మరలా ప్రయత్నించండి"
      },
      selfieError: {
        heading: "మేము మీ సెల్ఫీని ధృవీకరించలేకపోయాము",
        subHeading1: "ఈ సూచనలను అనుసరించి మళ్లీ ప్రయత్నించండి",
        instruction1: "బాగా వెలుతురు ఉన్న ప్రదేశంలోకి వెళ్ళి బ్యాక్‌లైట్‌ని నివారించండి",
        instruction2: "మీ ముఖం పూర్తి గా కనబడేలా మరియు ఫ్రేమ్‌లో మధ్యలో ఉంచండి",
        instruction3: "మీ ముఖం స్పష్టంగా కనిపించేలా టోపీ, గోచులు లేదా మాస్క్ తీసి వేయండి",
        button: "మరలా ప్రయత్నించండి"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP సరిపోలలేదు. దయచేసి OTPని స్పష్టంగా బిగ్గరగా చదవండి",
        button: "మళ్లీ ప్రయత్నించండి"
      },
      activeLivenessGenericFailureMessage: {
        heading: "ధృవీకరణ విఫలమైంది. దయచేసి సూచనలను స్పష్టంగా అనుసరించి మళ్లీ ప్రయత్నించండి",
        button: "మరలా ప్రయత్నించండి"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDFలో చాలా ఎక్కువ పేజీలు ఉన్నాయి",
        subHeading: "అప్‌లోడ్ చేసిన PDF 2-పేజీల పరిమితిని మించింది. దయచేసి 2 పేజీలకు మించని PDF, లేదా మీ IDకి సంబంధించిన స్పష్టమైన చిత్రాన్ని అప్‌లోడ్ చేయండి."
      },
      heading: "మీ ఐడీని ప్రాసెస్ చేయలేకపోయాము",
      subHeading: "మీరు తప్పు ఐడీని అప్‌లోడ్ చేస్తున్నారు లేదా చిత్రాన్ని స్పష్టంగా ఉండడం లేదు",
      buttonBack: "ఐడీ వెనుక వైపు మళ్లీ ప్రయత్నించండి",
      buttonFront: "ఐడీ ముందు వైపు మళ్లీ ప్రయత్నించండి",
      button: "మళ్లీ ప్రయత్నించండి",
      captureFrontSide: "ముందు వైపు క్యాప్చర్ చేయండి",
      captureBackSide: "వెనుక వైపు క్యాప్చర్ చేయండి",
      changeIDButton: "మరో పత్రాన్ని ఎంచుకోండి",
      wrongid: {
        heading: "మేము ఈ పత్రాన్ని ప్రాసెస్ చేయలేకపోయాం",
        subHeading: "దయచేసి మీరు సరైన పత్రాన్ని అప్‌లోడ్ చేస్తున్నారని నిర్ధారించుకోండి మరియు చిత్ర నాణ్యత స్పష్టంగా ఉందని నిర్ధారించుకోండి"
      },
      expiredid: {
        heading: "గుర్తింపు పత్రం గడువు ముగిసింది!",
        subHeading: "మేము గడువు ముగిసిన గుర్తింపు పత్రాన్ని అంగీకరించలేము. దయచేసి చెల్లుబాటు అయ్యే పత్రాన్ని అందించండి"
      },
      minimumage: {
        heading: "వయస్సు అవసరం నెరవేరలేదు!",
        subHeading: "మీ వయస్సు కనీస అవసరమైన వయస్సు కంటే తక్కువగా ఉంది. దయచేసి మీరు కనీస వయస్సు ప్రమాణాన్ని చేరుకుంటున్నారని నిర్ధారించుకోండి"
      },
      mobileAttemptsDone: {
        heading: "మీ మునుపటి పరికరంలో ప్రయాణం పునఃప్రారంభమైంది",
        subHeading: "నకిలీని నివారించడానికి ఈ సెషన్ ఇప్పుడు ఆపివేయబడింది."
      },
      finished: {
        heading: "ప్రయాణం ముగిసింది",
        subHeading: "ప్రయాణం పూర్తయింది లేదా రద్దు చేయబడింది"
      },
      invalid: {
        heading: "ప్రయాణం అందుబాటులో లేదు !",
        subHeading: "journeyId కనుగొనబడలేదు లేదా ప్రయాణ ID చెల్లదు"
      },
      INVALID_PAN_NUMBER: {
        heading: "చెల్లని PAN నంబర్",
        subHeading: "మీరు నమోదు చేసిన PAN నంబర్ చెల్లదు. దయచేసి తనిఖీ చేసి మళ్లీ ప్రయత్నించండి"
      },
      INVALID_PAN_STATUS: {
        heading: "చెల్లని PAN స్థితి",
        subHeading: "మీరు నమోదు చేసిన PAN నంబర్ చెల్లదు. దయచేసి తనిఖీ చేసి మళ్లీ ప్రయత్నించండి"
      },
      directKyc: {
        heading: "ప్రత్యక్ష KYC ప్రయాణం !",
        subHeading: "ఇది ప్రత్యక్ష KYC ప్రయాణం. ఫ్రంటెండ్ ప్రయాణానికి అనుమతి లేదు."
      },
      DOCTYPE_FALSE: {
        heading: "తప్పు పత్రం అందించబడింది!",
        subHeading: "దయచేసి చెల్లుబాటు అయ్యే పత్రాన్ని అప్‌లోడ్ చేయండి మరియు చిత్ర నాణ్యత బాగుందని నిర్ధారించుకోండి."
      },
      ONLY_FRONT: {
        heading: "గుర్తింపు కార్డు వెనుక వైపు లేదు",
        subHeading: "మీరు ముందు వైపు మాత్రమే అందించారు. దయచేసి మీ గుర్తింపు కార్డును తిప్పి కొనసాగడానికి వెనుక వైపు అందించండి"
      },
      ONLY_BACK: {
        heading: "గుర్తింపు కార్డు ముందు వైపు లేదు",
        subHeading: "మీరు వెనుక వైపు మాత్రమే అందించారు. దయచేసి మీ గుర్తింపు కార్డును తిప్పి కొనసాగడానికి ముందు వైపు అందించండి"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "పత్రం త్వరలో గడువు ముగియనుంది",
        subHeading: "పత్రం త్వరలో గడువు ముగియనున్నందున తిరస్కరించబడింది."
      },
      DOCUMENT_EXPIRED: {
        heading: "పత్రం గడువు ముగిసింది!",
        subHeading: "దయచేసి కొనసాగడానికి చెల్లుబాటు అయ్యే, గడువు ముగియని పత్రాన్ని అప్‌లోడ్ చేయండి."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "వయస్సు అవసరం నెరవేరలేదు!",
        subHeading: "మీరు అవసరమైన వయస్సును చేరుకోలేదని పత్రం సూచిస్తోంది. దయచేసి చెల్లుబాటు అయ్యే పత్రాన్ని అప్‌లోడ్ చేయండి."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "పత్రాన్ని ధృవీకరించలేకపోయాం!",
        subHeading: "ధృవీకరణ కోసం చిత్ర నాణ్యత చాలా తక్కువగా ఉంది. దయచేసి స్పష్టమైన చిత్రంతో మళ్లీ ప్రయత్నించండి."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "పత్రాన్ని ధృవీకరించలేకపోయాం!",
        subHeading: "కొంత సమాచారాన్ని ధృవీకరించలేకపోయాం. దయచేసి స్పష్టమైన చిత్రంతో మళ్లీ ప్రయత్నించండి."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "పత్రాన్ని ధృవీకరించలేకపోయాం!",
        subHeading: "తక్కువ చిత్ర నాణ్యత కారణంగా కొన్ని వివరాలను ధృవీకరించలేకపోయాం. దయచేసి స్పష్టమైన చిత్రంతో మళ్లీ ప్రయత్నించండి"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "పత్రాన్ని ధృవీకరించలేకపోయాం!",
        subHeading: "కొన్ని వివరాలను ధృవీకరించలేకపోయాం. దయచేసి స్పష్టమైన చిత్రంతో మళ్లీ ప్రయత్నించండి."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "గుర్తింపు కార్డుపై మీ ఫోటోను ధృవీకరించడంలో సమస్య",
        subHeading: "గుర్తింపు కార్డుపై మీ ఫోటోను మేము ధృవీకరించలేకపోయాం. దయచేసి మీ అసలు గుర్తింపు కార్డు యొక్క స్పష్టమైన ఫోటోను అప్‌లోడ్ చేయండి, తద్వారా మేము దానిని నిర్ధారించగలం."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "పత్ర భద్రతా నమూనా తనిఖీ విఫలమైంది",
        subHeading: "పత్రం యొక్క అంతర్నిర్మిత భద్రతా నమూనాలను మేము ధృవీకరించలేకపోయాం. దాని ప్రామాణికతను నిర్ధారించడంలో సహాయపడటానికి దయచేసి అసలు గుర్తింపు కార్డు యొక్క స్పష్టమైన ఫోటోను అప్‌లోడ్ చేయండి."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "పత్ర సజీవత తనిఖీ విఫలమైంది",
        subHeading: "పత్రం నిజమైనది కాకపోవచ్చని సంకేతాలను మేము కనుగొన్నాం. దయచేసి స్క్రీన్‌షాట్‌లు, ముద్రిత ప్రతులు లేదా స్క్రీన్‌పై గుర్తింపు కార్డును చూపించడం నివారించండి. అన్ని లక్షణాలు స్పష్టంగా కనిపించే అసలు గుర్తింపు కార్డును అప్‌లోడ్ చేయండి"
      },
      SECURITY_FALSE: {
        heading: "సమస్య గుర్తించబడింది!",
        subHeading: "పత్రాన్ని ధృవీకరించలేకపోయాం. దయచేసి స్పష్టమైన చిత్రంతో మళ్లీ ప్రయత్నించండి"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "తక్కువ చిత్ర నాణ్యత!",
        subHeading: "చిత్రం చాలా అస్పష్టంగా ఉంది. దయచేసి స్పష్టమైన చిత్రంతో మళ్లీ ప్రయత్నించండి"
      },
      FACE_UNDETECTED: {
        heading: "ముఖం గుర్తించబడలేదు",
        subHeading: "పత్రంపై కనిపించే ముఖాన్ని మేము కనుగొనలేకపోయాం. దయచేసి ముఖం స్పష్టంగా కనిపించే చెల్లుబాటు అయ్యే గుర్తింపు కార్డును అప్‌లోడ్ చేయండి"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "పత్రాల మధ్య పోలిక విఫలమైంది",
        subHeading: "ఒకటి లేదా అంతకంటే ఎక్కువ ముఖ్య క్షేత్రాలలో (పేరు, పుట్టిన తేదీ లేదా ముఖం) సరిపోలకపోవడం వల్ల పత్రాల మధ్య పోలిక విఫలమైంది"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker వైఫల్యం",
        subHeading: "Digilocker ప్రయాణంలో లోపం సంభవించింది. దయచేసి మళ్లీ ప్రయత్నించండి లేదా కొనసాగడానికి ప్రత్యామ్నాయ పద్ధతిని ఉపయోగించండి."
      },
      LINKAGE_FAILED: {
        heading: "ఈ ధృవీకరణను పూర్తి చేయలేకపోయాము",
        subHeading: "ఈ తనిఖీ కోసం సేకరించిన వివరాలు రికార్డులతో సరిపోలలేదు."
      }
    },
    biometricConsent: {
      consentStatement: "మీ సెల్ఫీకి ముందు, మీ గుర్తింపును ధృవీకరించడానికి మీ బయోమెట్రిక్ డేటా (ముఖ చిత్రం మరియు లైవ్‌నెస్ సిగ్నల్స్) సేకరించి ప్రాసెస్ చేయడానికి మీ సమ్మతి అవసరం. ఈ డేటా ఈ ధృవీకరణ కోసం మాత్రమే ఉపయోగించబడుతుంది.",
      privacyPolicy: "గోప్యతా విధానం",
      consentButton: "నేను అంగీకరిస్తున్నాను — కొనసాగండి",
      declineButton: "నేను అంగీకరించను",
      confirmTitle: "బయోమెట్రిక్ ధృవీకరణ లేకుండా కొనసాగాలా?",
      confirmBody: "బయోమెట్రిక్ ధృవీకరణ లేకుండా, మేము సెల్ఫీ తీసుకోము. మీరు ఇప్పటికే అందించిన సమాచారంతో మీ ధృవీకరణ పూర్తవుతుంది. ఈ ఎంపిక ఈ సెషన్‌కు తుది నిర్ణయం.",
      goBack: "వెనుకకు",
      confirmDecline: "నిర్ధారించండి — అంగీకరించను",
      declineComplete: "మీరు బయోమెట్రిక్ ధృవీకరణతో కొనసాగకూడదని ఎంచుకున్నారు. మీరు సమర్పించిన పత్రాలతో మీ గుర్తింపు ధృవీకరణ పూర్తయింది."
    },
    introLiveness: {
      heading: "ఇక్కడ మీరు సజీవంగా ఉన్నారని నిర్ధారించండి",
      instruction1: "తగినంత కాంతి ఉందని నిర్ధారించండి",
      instruction2: "అవసరమైన అనుమతులను ఇవ్వండి",
      instruction3: "వీక్షణలను పాటించండి",
      button: "కొనసాగండి",
      subHeading: "మీరు కేవలం ఒక అడుగు దూరంలో ఉన్నారు"
    },
    phoneSession: {
      heading: "సెషన్ ఫోన్‌లో కొనసాగుతోంది",
      subheading: "మొబైల్‌లో పూర్తవ్వడానికి ఈ విండోను తెరిచి ఉంచండి",
      button: "ఇక్కడ కొనసాగండి"
    },
    continueOnPhone: {
      heading: "ఫోన్‌లో కొనసాగించండి",
      subheading: "QR స్కాన్ చేయండి లేదా క్రింద ఉన్న లింక్‌ను కాపీ చేయండి",
      subheading2: "QR స్కాన్ చేయండి లేదా లింక్‌ను మీ ఫోన్‌లో తెరవండి",
      text: "ప్రక్రియను పూర్తిచేయండి",
      text1: "సబ్మిట్ చేయడానికి ఇక్కడ చెక్ చేయండి",
      button: "కాపీ చేయండి",
      copiedButton: "కాపీ చేయబడింది!",
      copied: "కాపీ చేయబడింది!"
    },
    SsnReview: {
      heading: "మీ వివరాలను సమీక్షించండి",
      subHeading: "అవసరమైన మార్పులను చేయండి మరియు వివరాలను సమర్పించండి",
      feild1: "డ్రైవింగ్ లైసెన్స్",
      feild2: "గడువు తేది",
      feild3: "పుట్టిన తేదీ",
      feild4: "తరగతి",
      feild5: "పరిమితి",
      feild6: "దేశం",
      feild7: "చిరునామా",
      button: "వివరాలు సరిగానే ఉన్నాయి"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "మీ ముఖాన్ని వృత్తంలో ఉంచండి"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "కెమెరాకు దగ్గరగా రండి"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "సిగ్గుపడకండి, ముందుకు రండి"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "చాలా చీకటిగా ఉంది. ఎక్కువ వెలుతురులోకి వెళ్లండి"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "చాలా ప్రకాశంగా ఉంది. మృదువైన వెలుతురులోకి వెళ్లండి"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "మీ ముఖాన్ని వృత్తంలో ఉంచండి"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "కదలకుండా ఉండండి"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ముఖాన్ని వెలుతురు వైపు తిప్పండి"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ఫోన్‌ను కళ్ల ఎత్తులో పట్టుకోండి"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "కెమెరా నుండి కొంచెం దూరంగా జరగండి"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "మీ ముఖాన్ని ఫ్రేమ్ మధ్యలో ఉంచండి"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "మీ ముఖాన్ని వృత్తం మధ్యలో ఉంచండి"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "దగ్గరగా రండి మరియు మీ ముఖాన్ని సరిగ్గా ఉంచండి"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "దృశ్యంలోకి రండి మరియు మీ ముఖాన్ని సరిగ్గా ఉంచండి"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "చాలా చీకటి ఉంది. ప్రకాశవంతమైన కాంతిని కనుగొనండి"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "చాలా ప్రకాశవంతం. సరైన కాంతిని కనుగొనండి"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "మీ ముఖాన్ని వృత్తం మధ్యకు సర్దుకోండి"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "చలించకుండా ఉండండి మరియు నేరుగా ముందుకు చూడండి"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "కాంతి వైపు ముఖం చేయండి మరియు స్థిరంగా ఉండండి"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "మీ ఫోన్‌ను కంటి స్థాయిలో ఉంచండి"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "కెమెరా నుండి కొంచెం దూరంగా నిలవండి"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "పర్ఫెక్ట్!"
      },
      smile1: {
        icon: "mood",
        description: "స్మైల్ ప్లీజ్, మీరు బాగున్నారండి!"
      },
      smile2: {
        icon: "mood",
        description: "కెమెరా కోసం స్మైల్ చేయండి!"
      }
    },
    successful: {
      title: "ధృవీకరణ పూర్తయింది",
      text: "ఇప్పుడు మీరు విండోను మూసివేయవచ్చు",
      finishBtn: "ముగించు"
    },
    poweredBy: "ద్వారా సరఫరా",
    redirect: "రీడైరెక్ట్ అవుతోంది",
    error: {
      message: "URL గడువు ముగిసింది లేదా చెల్లదు"
    },
    footer: {
      securedBy: "ద్వారా సరఫరా"
    },
    helpFaq: {
      title: "సహాయం & తరచుగా అడిగే ప్రశ్నలు",
      subtitle: "మేము మీకు సహాయం చేయడానికి ఇక్కడ ఉన్నాము",
      cameraText: "మీ గుర్తింపును ధృవీకరించడానికి, మాకు మీ డివైస్ కెమెరాను ఉపయోగించి చిత్రాలు తీసుకోవాలి. అవసరమైన అనుమతులను ఇవ్వడమెలా చేసుకోవాలో తెలుసుకోవడానికి ఈ link ను అనుసరించండి",
      cameraHeading: "కెమెరా అనుమతి",
      languageText: "ప్రక్రియ ప్రారంభంలో, మీరు పై బార్‌లో ఉన్న డ్రాప్‌డౌన్ మెనూలో నుండి మీ ఇష్టమైన భాషను ఎంపిక చేసుకోగలరు",
      languageHeading: "భాష ఎంపిక",
      kycText: "KYC, లేదా 'మీ కస్టమర్‌ను తెలుసుకోండి', ఇది కస్టమర్ల గుర్తింపును ధృవీకరించే ఒక ప్రక్రియ, ఇది అనుగుణతను నిర్ధారిస్తుంది మరియు మోసాలు మరియు ఇతర అక్రమ కార్యకలాపాలను నివారించడంలో సహాయపడుతుంది",
      kycHeading: "KYC అంటే ఏమిటి?",
      timeText: "సాధారణంగా, ఇది సుమారు 60 సెకన్లు తీసుకుంటుంది. అయితే, ఇది దేశాల ఆధారంగా మారవచ్చు",
      timeHeading: "ఇది ఎంత సమయం పడుతుంది?"
    },
    pdfPreviewUnavailable: "PDF పూర్వావలోకనాన్ని చూపించలేకపోతున్నాం.",
    pdfPreviewHint: "పూర్వావలోకనం కనిపించకపోయినా, మీరు కొనసాగవచ్చు.",
    pdfOpenLabel: "PDF తెరవండి",
    failedUpload: {
      title: "ఫైల్ అప్‌లోడ్ విఫలమైంది",
      text: "దయచేసి ఫైల్ 5MB కంటే తక్కువ మరియు .jpg, .jpeg, .png, .heic, .heif లేదా .pdf ఫార్మాట్‌లో ఉందని నిర్ధారించుకోండి",
      btn: "మళ్లీ ప్రయత్నించండి",
      pdfNotAllowedIndia: "భారతదేశానికి PDF అప్‌లోడ్‌లు అనుమతించబడవు. దయచేసి 5 MB కంటే తక్కువ JPEG, JPG, PNG, HEIC, లేదా HEIF ఫైల్‌లను అప్‌లోడ్ చేయండి.",
      pdfNotAllowedIndiaBasic: "భారతదేశానికి PDF అప్‌లోడ్‌లు అనుమతించబడవు. దయచేసి 5 MB కంటే తక్కువ JPEG, JPG, లేదా PNG ఫైల్‌లను అప్‌లోడ్ చేయండి."
    },
    livenessAnalyzing: {
      heading: "మీ ముఖాన్ని విశ్లేషిస్తోంది",
      subHeading: "దయచేసి వేచి ఉండండి, దీనికి కొన్ని సెకన్లు మాత్రమే పడుతుంది"
    },
    sessionExpiredError: {
      heading: "క్షమించండి, మీ సెషన్ గడువు ముగిసింది",
      subHeading1: "మీరు కొంత సేపు నిష్క్రియంగా ఉన్నారు. భద్రతా కారణాల వల్ల, మీ సెషన్ స్వయంచాలకంగా ముగిసింది",
      subHeading2: "దయచేసి మళ్లీ ప్రయత్నించండి",
      buttonText: "మళ్లీ ప్రయత్నించండి"
    },
    journeyExpiredError: {
      heading: "క్షమించండి, లింక్ గడువు ముగిసింది",
      subHeading1: "లింక్ ఇకపై సక్రియంగా లేదు. భద్రతా కారణాల వల్ల, లింక్‌లకు పరిమిత జీవితకాలం ఉంటుంది",
      subHeading2: "దయచేసి కొత్త లింక్‌తో ప్రయత్నించండి",
      buttonText: "మళ్లీ ప్రయత్నించండి"
    },
    cameraAccessError: {
      alert1: "కెమెరా యాక్సెస్ నిరాకరించబడింది. దయచేసి మీ బ్రౌజర్ సెట్టింగ్‌లలో కెమెరా యాక్సెస్‌ను ప్రారంభించండి",
      alert2: "కెమెరాను యాక్సెస్ చేస్తున్నప్పుడు లోపం సంభవించింది",
      alert3: "మీ బ్రౌజర్ కెమెరా యాక్సెస్‌కు మద్దతు ఇవ్వదు"
    },
    activeLiveness: {
      instruction: "మీ ముఖాన్ని వృత్తంలో ఉంచి సూచనలను అనుసరించండి",
      permissionDeniedTitle: "కెమెరా లేదా మైక్రోఫోన్ యాక్సెస్ నిరాకరించబడింది",
      permissionDeniedSubtitle: "దయచేసి మీ బ్రౌజర్ సెట్టింగ్‌లలో కెమెరా మరియు మైక్రోఫోన్ యాక్సెస్‌ను అనుమతించి మళ్లీ ప్రయత్నించండి."
    },
    flipScreen: {
      heading: "ఇప్పుడు మీ ఐడి కార్డును తిప్పండి",
      subHeading: "దయచేసి వెనుక వైపు చూపించడానికి మీ ఐడి కార్డును భౌతికంగా తిప్పి, దానిని కెమెరా ఫ్రేమ్‌లో ఉంచండి.",
      continueButton: "కొనసాగించండి"
    },
    mobileDocCapture: {
      frontSide: "ముందు వైపు",
      backSide: "వెనుక వైపు",
      of: "యొక్క",
      upload: "అప్‌లోడ్ చేయండి",
      stillNotWorking: "ఇంకా పని చేయడం లేదా?",
      clickToCapture: "క్లిక్-టు-క్యాప్చర్ ప్రయత్నించండి",
      skip: "దాటవేయి"
    }
,
    permissionPopUp: {
      title: "అనుమతి అవసరం",
      subtitle: "కెమెరా ఉపయోగించడానికి యాక్సెస్‌ను అనుమతించండి",
      decline: "తిరస్కరించండి",
      allow: "అనుమతించండి"
    },
    userDetails: {
      heading: "PAN ధృవీకరణ",
      subHeading: "ధృవీకరించడానికి దయచేసి వివరాలు పూరించండి",
      panLabel: "PAN నంబర్",
      panRequired: "దయచేసి మీ PAN నంబర్‌ను నమోదు చేయండి",
      saveError: "వివరాలను సేవ్ చేస్తున్నప్పుడు ఏదో తప్పు జరిగింది. దయచేసి మళ్లీ ప్రయత్నించండి.",
      proceed: "కొనసాగండి"
    },
    redirectCta: {
      or: "లేదా",
      clickHere: "ఇక్కడ క్లిక్ చేయండి",
      clickHereStart: "ఇక్కడ క్లిక్ చేయండి",
      toContinue: "కొనసాగించడానికి"
    },
    documentCapture: {
      stillNotWorking: "ఇంకా పని చేయడం లేదా?",
      clickToCaptureInstead: "బదులుగా క్లిక్-టు-క్యాప్చర్ ప్రయత్నించండి",
      pdfNotAllowedIndia: "భారతదేశానికి PDF అప్‌లోడ్‌లు అనుమతించబడవు. దయచేసి 5 MB కంటే తక్కువ JPEG, JPG, లేదా PNG ఫైళ్లను అప్‌లోడ్ చేయండి.",
      pdfNotAllowedIndiaMobile: "భారతదేశానికి PDF అప్‌లోడ్‌లు అనుమతించబడవు. దయచేసి 5 MB కంటే తక్కువ JPEG, JPG, PNG, HEIC, లేదా HEIF ఫైళ్లను అప్‌లోడ్ చేయండి.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb కంటే తక్కువ",
      fileFormats: "jpeg, jpg, png, pdf 5 mb కంటే తక్కువ",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb కంటే తక్కువ",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb కంటే తక్కువ"
    },
    mobileCapture: {
      upload: "అప్‌లోడ్ చేయండి",
      skip: "దాటవేయండి",
      stillNotWorking: "ఇంకా పని చేయడం లేదా?",
      tryClickToCapture: "ట్యాప్ చేసి ఫోటో తీయండి"
    },
    UserDetails: {
      panLabel: "PAN నంబర్",
      proceedBtn: "కొనసాగించండి",
      panRequired: "దయచేసి మీ PAN నంబర్‌ను నమోదు చేయండి",
      saveError: "వివరాలను సేవ్ చేస్తున్నప్పుడు ఏదో తప్పు జరిగింది. దయచేసి మళ్లీ ప్రయత్నించండి."
    }
  },
  ta: {
    supportingDocument: {
      headingFallback: "துணை ஆவணம்",
      subHeading: "கீழே ஆவணத்தைப் பதிவேற்றவும். இது மதிப்பாய்வுக்காக சேமிக்கப்படுகிறது — இதிலிருந்து எதுவும் பிரித்தெடுக்கப்படாது.",
      choosePlaceholder: "ஒரு கோப்பைத் தேர்ந்தெடுக்கவும் (PNG, JPG அல்லது PDF)",
      continue: "தொடரவும்",
      uploading: "பதிவேற்றுகிறது...",
      skip: "இப்போதைக்கு தவிர்",
      errorInvalidType: "PNG, JPG அல்லது PDF கோப்பைப் பதிவேற்றவும்.",
      errorTooLarge: "கோப்பு மிகப் பெரியது. வரம்பு 10MB.",
      errorRead: "அந்தக் கோப்பைப் படிக்க முடியவில்லை. வேறு ஒன்றை முயற்சிக்கவும்.",
      errorNoFile: "பதிவேற்ற ஒரு கோப்பைத் தேர்ந்தெடுக்கவும்.",
    },
    header: {
      title: "உங்கள் அடையாளத்தை சரிபார்க்கலாம்",
      subtitle: "இது 2 நிமிடங்களுக்கு குறைவான நேரம் ஆகும்",
      havingIssue: "சிக்கல் உள்ளதா?"
    },
    subHeading: {
      subHeading1: "உங்கள் ஐடி ஆவணத்தை படம் பிடியுங்கள்",
      subHeading2: "நீங்கள் வாழ்ந்து இருப்பதை சரிபார்க்கவும்",
      livenessHeading1: "நல்ல வெளிச்சம் உள்ள இடத்தைக் கண்டறியவும்",
      livenessHeading2: "உங்கள் முகத்தை மையத்தில் வைக்கவும்"
    },
    onlyIdVerificationHeader: {
      title: "உங்கள் அடையாள ஆவணத்தை சரிபார்க்கலாம்",
      subtitle: "இது ஒரு நிமிடம் மட்டுமே எடுக்கும். உங்கள் அடையாள ஆவணத்தை தயாராக வைத்திருங்கள்",
      instruction1: "கேமரா அணுகலை அனுமதிக்கவும்",
      instruction2: "ஆவணத்தை ஸ்கேன் செய்யவும் அல்லது பதிவேற்றவும்",
      instruction3: "உடனடி ஆவண சரிபார்ப்பு"
    },
    termsAndCondition: {
      title: "நான் கீழ்க்கண்ட விதிமுறைகள் மற்றும் நிபந்தனைகளை ஒப்புக்கொள்கிறேன் மற்றும் அனுசரிக்கிறேன்.",
      privacyPolicy: "விதிமுறைகளைப் பார்க்க",
      beginBtnText: "தொடங்கு",
      beginLiveness: "உணர்தன்மை சரிபார்ப்பு தொடங்குகிறது",
      startLiveness: "உணர்தன்மை சரிபார்ப்புக்குச் செல்லவும்"
    },
    permissionDenied: {
      title: "கேமரா அணுகல் நிராகரிக்கப்பட்டது!",
      subtitle: "உலாவியின் முகவரிப் பட்டையருகில் தடைசெய்யப்பட்ட கேமரா ஐகானைச் சரிபார்த்து அதை அனுப்பவிடவும்.",
      readMore: "மேலும் படிக்க",
      refreshText: "கேமரா அனுமதி வழங்கப்பட்ட பிறகு கீழே உள்ள புதுப்பிக்கவும் பொத்தானை அழுத்தவும்.",
      refreshBtn: "புதுப்பிக்கவும்",
      link: "அல்லது, தொலைபேசியில் தொடரவும்",
      buttonText: "அல்லது, தொலைபேசியில் தொடரவும்"
    },
    desktopBrowserPermissionDenied: {
      title: "கேமரா அணுகலை அனுமதிக்கவும்",
      subtitle: "உலாவி அனுமதிகளை கேட்டுக்கொள்ளலாம். தயவுசெய்து 'அனுமதி' என்பதைக் கிளிக் செய்யவும்.",
      readMore: "மேலும் படிக்க",
      refreshText: "அனுமதிகளை வழங்கிய பிறகு புதுப்பிக்கவும்",
      refreshBtn: "புதுப்பிக்கவும்",
      link: "அல்லது, தொலைபேசியில் தொடரவும்",
      buttonText: "அல்லது, தொலைபேசியில் தொடரவும்"
    },
    androidBrowserPermissionDenied: {
      title: "கேமரா அணுகல் நிராகரிக்கப்பட்டது",
      subtitle: "உலாவியின் முகவரி பட்டியலுக்கு அருகே தடைசெய்யப்பட்ட கேமரா ஐகானை சரிபார்த்து, அதை திறக்கவும்.",
      readMore: "மேலும் படிக்க",
      refreshText: "கேமரா அணுகல் அனுமதிக்கப்பட்டதும் கீழே உள்ள புதுப்பிக்க பொத்தானை கிளிக் செய்யவும்.",
      refreshBtn: "புதுப்பிக்கவும்",
      link: "அல்லது, தொலைபேசியில் தொடரவும்",
      buttonText: "அல்லது, தொலைபேசியில் தொடரவும்"
    },
    androidWebViewPermissionDenied: {
      title: "கேமரா அணுகல் நிராகரிக்கப்பட்டது",
      subtitle: "கேமரா அணுகல் உங்கள் பயன்பாட்டின் அமைப்புகளில் தடைசெய்யப்பட்டிருக்கலாம். உங்கள் கைபேசி அமைப்புகளில் ‘App Info > Permissions > Camera’ சென்று அனுமதிக்கவும்.",
      refreshText: "கேமரா அணுகல் அனுமதிக்கப்பட்டதும் கீழே உள்ள புதுப்பிக்க பொத்தானை கிளிக் செய்யவும்.",
      refreshBtn: "புதுப்பிக்கவும்",
      link: "அல்லது, தொலைபேசியில் தொடரவும்",
      buttonText: "அல்லது, தொலைபேசியில் தொடரவும்"
    },
    iosBrowserPermissionDenied: {
      title: "கேமரா அணுகல் நிராகரிக்கப்பட்டது",
      subtitle: "முகவரி பட்டியலுக்கு அருகே உள்ள கேமரா அல்லது பூட்டு ஐகானைத் தொட்டு அணுகலை அனுமதிக்கவும் அல்லது உலாவி அமைப்புகளை சரிபார்க்கவும்.",
      readMore: "மேலும் படிக்க",
      refreshText: "கேமரா அணுகல் அனுமதிக்கப்பட்டதும் கீழே உள்ள புதுப்பிக்க பொத்தானை கிளிக் செய்யவும்.",
      refreshBtn: "புதுப்பிக்கவும்",
      link: "அல்லது, தொலைபேசியில் தொடரவும்",
      buttonText: "அல்லது, தொலைபேசியில் தொடரவும்"
    },
    iosWebViewPermissionDenied: {
      title: "கேமரா அணுகல் நிராகரிக்கப்பட்டது",
      subtitle: "கேமரா அணுகல் உங்கள் பயன்பாட்டின் அமைப்புகளில் தடைசெய்யப்பட்டிருக்கலாம். அமைப்புகளில் சென்று நீங்கள் பயன்படுத்தும் பயன்பாட்டுக்கு சென்று கேமரா அனுமதியை இயக்கவும்.",
      refreshText: "கேமரா அணுகல் அனுமதிக்கப்பட்டதும் கீழே உள்ள புதுப்பிக்க பொத்தானை கிளிக் செய்யவும்.",
      refreshBtn: "புதுப்பிக்கவும்",
      link: "அல்லது, தொலைபேசியில் தொடரவும்",
      buttonText: "அல்லது, தொலைபேசியில் தொடரவும்"
    },
    documentationList: {
      countryHeading: "நாட்டைத் தேர்ந்தெடுக்கவும்",
      docHeading: "உங்கள் ஆவணத்தைத் தேர்ந்தெடுக்கவும்",
      btnText: "அடுத்தது",
      searchCountry: "நாட்டைத் தேடுங்கள்"
    },
    frontDocCapture: {
      heading: "ஐடியின் முன்னர் பகுதியை சதுரத்துக்குள் வைக்கவும்",
      backupHeading: "சிரமமாக உள்ளதா? தயவுசெய்து படத்தை கையால் கிளிக் செய்யவும்",
      btnText: "புகைப்படம் எடுக்கவும்",
      headingBack: " செவ்வகத்திற்குள்",
      uploadButton: "அல்லது, அடையாள அட்டையைப் பதிவேற்றவும்"
    },
    backDocCapture: {
      heading: "ஐடியின் பின்புறத்தை சதுரத்துக்குள் வைக்கவும்",
      backupHeading: "சிரமமாக உள்ளதா? தயவுசெய்து படத்தை கையால் கிளிக் செய்யவும்",
      btnText: "புகைப்படம் எடுக்கவும்",
      containerText: "அல்லது, ஆவணத்தை பதிவேற்றவும்",
      text: "பிடிக்கிறது, நிசப்தமாக இருங்கள்",
      headingBack: " செவ்வகத்திற்குள்",
      skipButton: "பின்பக்கத்தைத் தவிர்க்கவும்",
      uploadButton: "அல்லது, அடையாள அட்டையைப் பதிவேற்றவும்"
    },
    analyzing: {
      heading: "உங்கள் ஐடியை பகுப்பாய்வு செய்யிறது...",
      subHeading: "அடுத்த திரையில் உங்கள் கார்டு விவரங்களை சரிபார்க்கவும் மற்றும் தேவையென்றால் திருத்தவும்"
    },
    imageCheck: {
      heading: "உங்கள் படத்தை சரிபார்க்கவும்",
      subHeading: "படம் முழுமையாகவும், தெளிவாகவும், மங்கல் மற்றும் பிரகாசம் இல்லாமல் இருப்பதை உறுதிப்படுத்தவும்.",
      button1: "மீண்டும் புகைப்படம் எடுக்கவும்",
      button2: "சரி",
      frontHeading: "முன்புற படத்தை சரிபார்க்கவும்",
      backHeading: "பின்புற படத்தை சரிபார்க்கவும்"
    },
    errorHandler: {
      heading: "அச்சு! :(",
      subHeading1: "நாம் சில பிரச்சினைகளை எதிர்கொண்டோம், ஆனால் கவலைப்படாதீர்கள்! தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
      subHeading2: "இது தொடருமானால், பின்னர் சரிபார்க்கவும்",
      button: "மீண்டும் முயற்சிக்கவும்"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "தயவுசெய்து உங்கள் முகத்தை மூடிய எதையும் அகற்றவும்",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      eyeClosureDetected: {
        heading: "தயவுசெய்து உங்கள் கண்களைத் திறந்து வைத்து நேராக கேமராவை நோக்கி பாருங்கள்",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      isMultipleFacesFound: {
        heading: "பல முகங்கள் கண்டுபிடிக்கப்பட்டன. உங்கள் முகமே கேமராவில் தெரிந்திருப்பதை உறுதிப்படுத்தவும்.",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      noFacesFound: {
        heading: "முகம் கண்டறியப்படவில்லை. உங்கள் முகம் கேமராவில் தெரியும் என்பதை உறுதிப்படுத்தவும்.",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      faceDetections: {
        heading: "இதனை அகற்றவும்",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "பல முகங்கள் கண்டறியப்பட்டுள்ளன",
          button: "மீண்டும் முயற்சிக்கவும்"
        },
        generalMessage: {
          heading: "உங்கள் முகம் கேமரா முன் நேரடி நிலையில் இருக்கிறதை உறுதிப்படுத்தவும்",
          button: "மீண்டும் முயற்சிக்கவும்"
        }
      },
      faceMatch: {
        heading: "உங்கள் முகம் ஐடிஃப் படத்துடன் பொருந்தவில்லை",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      selfieError: {
        heading: "நாங்கள் உங்கள் செல்வி சரிபார்க்க முடியவில்லை",
        subHeading1: "இந்தக் குறிப்புகளை பின்பற்றவும் மற்றும் மீண்டும் முயற்சிக்கவும்",
        instruction1: "பிரகாசமான இடத்தில் செல்லவும் மற்றும் பின்புற ஒளியைக் குறைக்கவும்",
        instruction2: "உங்கள் முகம் முழுமையாக காட்சியளிக்கவும் மற்றும் ஃபிரேமின் மையத்தில் வைக்கவும்",
        instruction3: "உங்கள் முகம் தெளிவாக காட்சியளிக்க தலைக்கவசம், கண்ணாடிகள் அல்லது முகமூடி அகற்றவும்",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP பொருந்தவில்லை. தயவுசெய்து OTPஐ தெளிவாக சத்தமாக படியுங்கள்",
        button: "மீண்டும் முயற்சிக்கவும்"
      },
      activeLivenessGenericFailureMessage: {
        heading: "சரிபார்ப்பு தோல்வியடைந்தது. தயவுசெய்து வழிமுறைகளைத் தெளிவாகப் பின்பற்றி மீண்டும் முயற்சிக்கவும்",
        button: "மீண்டும் முயற்சிக்கவும்"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF இல் மிக அதிக பக்கங்கள் உள்ளன",
        subHeading: "பதிவேற்றிய PDF 2-பக்க வரம்பை மீறுகிறது. தயவுசெய்து 2 பக்கங்களுக்கு மேல் இல்லாத PDF, அல்லது உங்கள் அடையாள அட்டையின் தெளிவான படத்தைப் பதிவேற்றவும்."
      },
      heading: "உங்கள் ஐடியை செயலாக்க முடியவில்லை",
      subHeading: "நீங்கள் தவறான ஐடியை பதிவேற்றுகிறீர்கள் அல்லது படம் தெளிவாக இல்லை",
      buttonBack: "ஐடியின் பின்புறத்தை மீண்டும் முயற்சிக்கவும்",
      buttonFront: "ஐடியின் முன்னர் பகுதியை மீண்டும் முயற்சிக்கவும்",
      button: "மீண்டும் முயற்சிக்கவும்",
      captureFrontSide: "முன் பக்கத்தைப் படமெடுக்கவும்",
      captureBackSide: "பின் பக்கத்தைப் படமெடுக்கவும்",
      changeIDButton: "வேறு ஆவணத்தைத் தேர்ந்தெடுக்கவும்",
      wrongid: {
        heading: "இந்த ஆவணத்தை எங்களால் செயலாக்க முடியவில்லை",
        subHeading: "நீங்கள் சரியான ஆவணத்தைப் பதிவேற்றுகிறீர்கள் என்பதை உறுதிசெய்து, படத்தின் தரம் தெளிவாக இருப்பதை உறுதிசெய்யவும்"
      },
      expiredid: {
        heading: "அடையாள ஆவணம் காலாவதியானது!",
        subHeading: "காலாவதியான அடையாள ஆவணத்தை எங்களால் ஏற்க முடியாது. செல்லுபடியாகும் ஆவணத்தை வழங்கவும்"
      },
      minimumage: {
        heading: "வயது தேவை பூர்த்தி செய்யப்படவில்லை!",
        subHeading: "உங்கள் வயது தேவையான குறைந்தபட்ச வயதை விட குறைவாக உள்ளது. நீங்கள் குறைந்தபட்ச வயது அளவுகோலை பூர்த்தி செய்கிறீர்கள் என்பதை உறுதிசெய்யவும்"
      },
      mobileAttemptsDone: {
        heading: "உங்கள் முந்தைய சாதனத்தில் பயணம் மீண்டும் தொடங்கியது",
        subHeading: "நகலெடுப்பதைத் தவிர்க்க இந்த அமர்வு இப்போது நிறுத்தப்பட்டது."
      },
      finished: {
        heading: "பயணம் முடிந்தது",
        subHeading: "பயணம் முடிக்கப்பட்டது அல்லது நிறுத்தப்பட்டது"
      },
      invalid: {
        heading: "பயணம் கிடைக்கவில்லை !",
        subHeading: "journeyId கண்டறியப்படவில்லை அல்லது பயண ID செல்லுபடியாகாது"
      },
      INVALID_PAN_NUMBER: {
        heading: "தவறான PAN எண்",
        subHeading: "நீங்கள் உள்ளிட்ட PAN எண் செல்லுபடியாகாது. சரிபார்த்து மீண்டும் முயற்சிக்கவும்"
      },
      INVALID_PAN_STATUS: {
        heading: "தவறான PAN நிலை",
        subHeading: "நீங்கள் உள்ளிட்ட PAN எண் செல்லுபடியாகாது. சரிபார்த்து மீண்டும் முயற்சிக்கவும்"
      },
      directKyc: {
        heading: "நேரடி KYC பயணம் !",
        subHeading: "இது ஒரு நேரடி KYC பயணம். முன்பக்க பயணம் அனுமதிக்கப்படவில்லை."
      },
      DOCTYPE_FALSE: {
        heading: "தவறான ஆவணம் வழங்கப்பட்டது!",
        subHeading: "செல்லுபடியாகும் ஆவணத்தைப் பதிவேற்றவும், படத்தின் தரம் நன்றாக இருப்பதை உறுதிசெய்யவும்."
      },
      ONLY_FRONT: {
        heading: "அடையாள அட்டையின் பின்பக்கம் இல்லை",
        subHeading: "நீங்கள் முன்பக்கத்தை மட்டுமே வழங்கினீர்கள். தொடர உங்கள் அடையாள அட்டையைத் திருப்பி பின்பக்கத்தை வழங்கவும்"
      },
      ONLY_BACK: {
        heading: "அடையாள அட்டையின் முன்பக்கம் இல்லை",
        subHeading: "நீங்கள் பின்பக்கத்தை மட்டுமே வழங்கினீர்கள். தொடர உங்கள் அடையாள அட்டையைத் திருப்பி முன்பக்கத்தை வழங்கவும்"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "ஆவணம் விரைவில் காலாவதியாகிறது",
        subHeading: "ஆவணம் விரைவில் காலாவதியாகும் என்பதால் நிராகரிக்கப்பட்டது."
      },
      DOCUMENT_EXPIRED: {
        heading: "ஆவணம் காலாவதியானது!",
        subHeading: "தொடர செல்லுபடியாகும், காலாவதியாகாத ஆவணத்தைப் பதிவேற்றவும்."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "வயது தேவை பூர்த்தி செய்யப்படவில்லை!",
        subHeading: "நீங்கள் தேவையான வயதை பூர்த்தி செய்யவில்லை என்று ஆவணம் குறிக்கிறது. செல்லுபடியாகும் ஆவணத்தைப் பதிவேற்றவும்."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ஆவணத்தைச் சரிபார்க்க முடியவில்லை!",
        subHeading: "சரிபார்ப்புக்கு படத்தின் தரம் மிகவும் மோசமாக உள்ளது. தெளிவான படத்துடன் மீண்டும் முயற்சிக்கவும்."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ஆவணத்தைச் சரிபார்க்க முடியவில்லை!",
        subHeading: "சில தகவல்களைச் சரிபார்க்க முடியவில்லை. தெளிவான படத்துடன் மீண்டும் முயற்சிக்கவும்."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ஆவணத்தைச் சரிபார்க்க முடியவில்லை!",
        subHeading: "மோசமான பட தரத்தால் சில விவரங்களைச் சரிபார்க்க முடியவில்லை. தெளிவான படத்துடன் மீண்டும் முயற்சிக்கவும்"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ஆவணத்தைச் சரிபார்க்க முடியவில்லை!",
        subHeading: "சில விவரங்களைச் சரிபார்க்க முடியவில்லை. தெளிவான படத்துடன் மீண்டும் முயற்சிக்கவும்."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "அடையாள அட்டையில் உங்கள் புகைப்படத்தைச் சரிபார்ப்பதில் சிக்கல்",
        subHeading: "அடையாள அட்டையில் உங்கள் புகைப்படத்தை எங்களால் சரிபார்க்க முடியவில்லை. நாங்கள் அதை உறுதிப்படுத்த உங்கள் அசல் அடையாள அட்டையின் தெளிவான புகைப்படத்தைப் பதிவேற்றவும்."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "ஆவண பாதுகாப்பு வடிவ சரிபார்ப்பு தோல்வியடைந்தது",
        subHeading: "ஆவணத்தின் உள்ளமைந்த பாதுகாப்பு வடிவங்களை எங்களால் சரிபார்க்க முடியவில்லை. அதன் நம்பகத்தன்மையை உறுதிப்படுத்த உதவ அசல் அடையாள அட்டையின் தெளிவான புகைப்படத்தைப் பதிவேற்றவும்."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "ஆவண நேரடித்தன்மை சரிபார்ப்பு தோல்வியடைந்தது",
        subHeading: "ஆவணம் உண்மையானதாக இல்லாமல் இருக்கலாம் என்பதற்கான அறிகுறிகளைக் கண்டோம். ஸ்கிரீன்ஷாட்கள், அச்சிடப்பட்ட நகல்கள் அல்லது திரையில் அடையாள அட்டையைக் காண்பிப்பதைத் தவிர்க்கவும். அனைத்து அம்சங்களும் தெளிவாகத் தெரியும் அசல் அடையாள அட்டையைப் பதிவேற்றவும்"
      },
      SECURITY_FALSE: {
        heading: "சிக்கல் கண்டறியப்பட்டது!",
        subHeading: "ஆவணத்தைச் சரிபார்க்க முடியவில்லை. தெளிவான படத்துடன் மீண்டும் முயற்சிக்கவும்"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "மோசமான பட தரம்!",
        subHeading: "படம் மிகவும் மங்கலாக அல்லது தெளிவில்லாமல் உள்ளது. தெளிவான படத்துடன் மீண்டும் முயற்சிக்கவும்"
      },
      FACE_UNDETECTED: {
        heading: "முகம் கண்டறியப்படவில்லை",
        subHeading: "ஆவணத்தில் தெரியும் முகத்தை எங்களால் கண்டறிய முடியவில்லை. முகம் தெளிவாகத் தெரியும் செல்லுபடியாகும் அடையாள அட்டையைப் பதிவேற்றவும்"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "ஆவணங்களுக்கு இடையேயான ஒப்பீடு தோல்வியடைந்தது",
        subHeading: "ஒன்று அல்லது அதற்கு மேற்பட்ட முக்கிய புலங்களில் (பெயர், பிறந்த தேதி அல்லது முகம்) பொருந்தாததால் ஆவணங்களுக்கு இடையேயான ஒப்பீடு தோல்வியடைந்தது"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker தோல்வி",
        subHeading: "Digilocker பயணத்தின் போது பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும் அல்லது தொடர மாற்று முறையைப் பயன்படுத்தவும்."
      },
      LINKAGE_FAILED: {
        heading: "இந்தச் சரிபார்ப்பை முடிக்க முடியவில்லை",
        subHeading: "இந்தச் சரிபார்ப்புக்கான பதிவுகளுடன் பெறப்பட்ட விவரங்கள் பொருந்தவில்லை."
      }
    },
    biometricConsent: {
      consentStatement: "உங்கள் செல்ஃபிக்கு முன், உங்கள் அடையாளத்தைச் சரிபார்க்க உங்கள் பயோமெட்ரிக் தரவை (முக படம் மற்றும் லைவ்னஸ் சிக்னல்கள்) படம்பிடித்து செயலாக்க உங்கள் ஒப்புதல் தேவை. இந்தத் தரவு இந்தச் சரிபார்ப்புக்கு மட்டுமே பயன்படுத்தப்படுகிறது.",
      privacyPolicy: "தனியுரிமைக் கொள்கை",
      consentButton: "நான் ஒப்புக்கொள்கிறேன் — தொடரவும்",
      declineButton: "நான் ஒப்புக்கொள்ளவில்லை",
      confirmTitle: "பயோமெட்ரிக் சரிபார்ப்பு இல்லாமல் தொடரவா?",
      confirmBody: "பயோமெட்ரிக் சரிபார்ப்பு இல்லாமல், நாங்கள் செல்ஃபி எடுக்க மாட்டோம். நீங்கள் ஏற்கனவே வழங்கிய தகவலைப் பயன்படுத்தி உங்கள் சரிபார்ப்பு முடிக்கப்படும். இந்தத் தேர்வு இந்த அமர்வுக்கு இறுதியானது.",
      goBack: "பின்செல்",
      confirmDecline: "உறுதிப்படுத்து — ஒப்புக்கொள்ளவில்லை",
      declineComplete: "பயோமெட்ரிக் சரிபார்ப்புடன் தொடராமல் இருக்க நீங்கள் தேர்வுசெய்துள்ளீர்கள். நீங்கள் சமர்ப்பித்த ஆவணங்களைப் பயன்படுத்தி உங்கள் அடையாளச் சரிபார்ப்பு முடிக்கப்பட்டது."
    },
    introLiveness: {
      heading: "இங்கே நீங்கள் வாழ்ந்து இருப்பதை உறுதிப்படுத்துங்கள்",
      instruction1: "போதுமான வெளிச்சம் இருப்பதை உறுதிப்படுத்துங்கள்",
      instruction2: "தேவையான அனுமதிகளை வழங்குங்கள்",
      instruction3: "வழிமுறைகளை பின்பற்றுங்கள்",
      button: "தொடரவும்",
      subHeading: "நீங்கள் ஒரே ஒரு படி தூரத்தில் இருக்கிறீர்கள்"
    },
    phoneSession: {
      heading: "அமர்வு தொலைபேசியில் தொடர்கிறது",
      subheading: "மொபைலில் முடிக்கும் வரை இந்த சாளரத்தை திறந்திருங்கள்",
      button: "இங்கே தொடரவும்"
    },
    continueOnPhone: {
      heading: "தொலைபேசியில் தொடரவும்",
      subheading: "QR குறியீட்டை ஸ்கேன் செய்யவும் அல்லது கீழே உள்ள இணைப்பை நகலெடுக்கவும்",
      subheading2: "QR குறியீட்டை ஸ்கேன் செய்யவும் அல்லது இணைப்பை உங்கள் தொலைபேசியில் திறக்கவும்",
      text: "செயல்முறையை முடிக்கவும்",
      text1: "சமர்ப்பிக்க இங்கே சரிபார்க்கவும்",
      button: "நகலெடுக்கவும்",
      copiedButton: "நகலெடுக்கப்பட்டது!",
      copied: "நகலெடுக்கப்பட்டது!"
    },
    SsnReview: {
      heading: "உங்கள் விவரங்களைப் பரிசீலிக்கவும்",
      subHeading: "தேவையான மாற்றங்களைச் செய்து விவரங்களைச் சமர்ப்பிக்கவும்",
      feild1: "ஓட்டுநர் உரிமம்",
      feild2: "EXP",
      feild3: "பிறந்த தேதி",
      feild4: "வகுப்பு",
      feild5: "கட்டுப்பாடுகள்",
      feild6: "நாடு",
      feild7: "முகவரி",
      button: "விவரங்கள் சரியாக உள்ளன"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "உங்கள் முகத்தை வட்டத்தில் வைக்கவும்"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "கேமராவுக்கு அருகில் வாருங்கள்"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "வெட்கப்படாதீர்கள், முன்னே வாருங்கள்"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "மிகவும் இருட்டாக உள்ளது. அதிக ஒளியில் செல்லுங்கள்"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "மிகவும் பிரகாசமாக உள்ளது. மென்மையான ஒளியில் செல்லுங்கள்"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "உங்கள் முகத்தை வட்டத்தில் வைக்கவும்"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "அசையாமல் இருங்கள்"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "முகத்தை ஒளியை நோக்கி திருப்புங்கள்"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "தொலைபேசியை கண் மட்டத்தில் பிடியுங்கள்"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "கேமராவிலிருந்து சிறிது விலகுங்கள்"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "உங்கள் முகத்தை சட்டகத்தின் மையத்தில் வைக்கவும்"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "உங்கள் முகத்தை வட்டத்தின் மையத்தில் வைக்கவும்"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "நெருக்கமாக வாருங்கள், முகத்தை நேராக வைக்கவும்"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "காட்சிக்கு வாருங்கள், முகத்தை நேராக வைக்கவும்"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "மிகவும் இருண்டது. பிரகாசமான வெளிச்சத்தைத் தேடுங்கள்"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "மிகவும் பிரகாசமானது. சிறந்த வெளிச்சத்தைத் தேடுங்கள்"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "உங்கள் முகத்தை வட்டத்தின் மையத்திற்கு சரிசெய்யவும்"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "நிலையாக இருங்கள், நேராக முன்னோக்கி பாருங்கள்"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ஒளியை நோக்கி முகம் காட்டுங்கள், நிலையாக இருங்கள்"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "உங்கள் தொலைபேசியை கண் அளவில் பிடிக்கவும்"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "கேமராவில் இருந்து கொஞ்சம் விலகி இருங்கள்"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "சரியானது!"
      },
      smile1: {
        icon: "mood",
        description: "சிரிக்கவும், நீங்கள் அருமையாக இருக்கிறீர்கள்!"
      },
      smile2: {
        icon: "mood",
        description: "கேமராவிற்காக சிரிக்கவும்!"
      }
    },
    successful: {
      title: "சரிபார்ப்பு முடிந்தது",
      text: "நீங்கள் இப்போது சாளரத்தை மூடலாம்",
      finishBtn: "முடிக்கவும்"
    },
    poweredBy: "நிறுவனம்",
    redirect: "மாற்றுகிறது",
    error: {
      message: "URL காலாவதியாகி அல்லது தவறானது"
    },
    footer: {
      securedBy: "நிறுவனம்"
    },
    helpFaq: {
      title: "உதவி & பொதுவான கேள்விகள்",
      subtitle: "நாம் உங்களுக்கு உதவ இங்கே உள்ளோம்",
      cameraText: "உங்கள் அடையாளத்தை சரிபார்க்க, நாங்கள் உங்கள் சாதனத்தின் கேமராவை பயன்படுத்தி படங்களை எடுக்க வேண்டும். தேவையான அனுமதிகளை எப்படி வழங்குவது என்பதை தெரிந்து கொள்ள இந்த link ஐ பின்பற்றவும்",
      cameraHeading: "கேமரா அனுமதி",
      languageText: "ப்ரொசஸின் தொடக்கத்தில், நீங்கள் மேல்நிலை பட்டியலில் உள்ள டிராப்-டவுன் மெனுவிலிருந்து உங்கள் விருப்பமான மொழியைத் தேர்வு செய்யலாம்",
      languageHeading: "மொழி தேர்வு",
      kycText: "KYC, அல்லது 'நீங்கள் அறிந்துகொள்ளும் வாடிக்கையாளர்', என்பது வாடிக்கையாளர் அடையாளங்களை சரிபார்க்கும் ஒரு செயல்முறை ஆகும், இது ஒப்புதல் பெறுவதையும் மோசடிகள் மற்றும் பிற சட்டவிரோத நடவடிக்கைகளைக் கட்டுப்படுத்த உதவுகிறது",
      kycHeading: "KYC என்பது என்ன?",
      timeText: "பொதுவாக, இது சுமார் 60 விநாடிகள் நேரம் எடுக்கும். எனினும், இது நாடுகளின் அடிப்படையில் மாறலாம்",
      timeHeading: "இதில் எவ்வளவு நேரம் எடுக்கும்?"
    },
    pdfPreviewUnavailable: "PDF இன் முன்னோட்டத்தைக் காட்ட முடியவில்லை.",
    pdfPreviewHint: "முன்னோட்டம் தோன்றவில்லை என்றாலும், நீங்கள் தொடரலாம்.",
    pdfOpenLabel: "PDF திறக்கவும்",
    failedUpload: {
      title: "கோப்பு பதிவேற்றம் தோல்வியடைந்தது",
      text: "கோப்பு 5MB க்கும் குறைவாகவும் .jpg, .jpeg, .png, .heic, .heif அல்லது .pdf வடிவத்திலும் இருப்பதை உறுதிசெய்யவும்",
      btn: "மீண்டும் முயற்சிக்கவும்",
      pdfNotAllowedIndia: "இந்தியாவிற்கு PDF பதிவேற்றம் அனுமதிக்கப்படவில்லை. 5 MB க்கும் குறைவான JPEG, JPG, PNG, HEIC, அல்லது HEIF கோப்புகளைப் பதிவேற்றவும்.",
      pdfNotAllowedIndiaBasic: "இந்தியாவிற்கு PDF பதிவேற்றம் அனுமதிக்கப்படவில்லை. 5 MB க்கும் குறைவான JPEG, JPG, அல்லது PNG கோப்புகளைப் பதிவேற்றவும்."
    },
    livenessAnalyzing: {
      heading: "உங்கள் முகத்தை பகுப்பாய்வு செய்கிறது",
      subHeading: "தயவுசெய்து காத்திருங்கள், இதற்கு சில வினாடிகள் மட்டுமே ஆகும்"
    },
    sessionExpiredError: {
      heading: "மன்னிக்கவும், உங்கள் அமர்வு காலாவதியானது",
      subHeading1: "நீங்கள் சிறிது நேரம் செயலற்று இருந்தீர்கள். பாதுகாப்பு காரணங்களுக்காக, உங்கள் அமர்வு தானாகவே காலாவதியானது",
      subHeading2: "மீண்டும் முயற்சிக்கவும்",
      buttonText: "மீண்டும் முயற்சிக்கவும்"
    },
    journeyExpiredError: {
      heading: "மன்னிக்கவும், இணைப்பு காலாவதியானது",
      subHeading1: "இணைப்பு இனி செயலில் இல்லை. பாதுகாப்பு காரணங்களுக்காக, இணைப்புகளுக்கு வரம்புக்குட்பட்ட ஆயுட்காலம் உள்ளது",
      subHeading2: "புதிய இணைப்புடன் முயற்சிக்கவும்",
      buttonText: "மீண்டும் முயற்சிக்கவும்"
    },
    cameraAccessError: {
      alert1: "கேமரா அணுகல் மறுக்கப்பட்டது. உங்கள் உலாவி அமைப்புகளில் கேமரா அணுகலை இயக்கவும்",
      alert2: "கேமராவை அணுகும்போது பிழை ஏற்பட்டது",
      alert3: "உங்கள் உலாவி கேமரா அணுகலை ஆதரிக்கவில்லை"
    },
    activeLiveness: {
      instruction: "உங்கள் முகத்தை வட்டத்திற்குள் வைத்து வழிமுறைகளைப் பின்பற்றவும்",
      permissionDeniedTitle: "கேமரா அல்லது மைக்ரோஃபோன் அணுகல் மறுக்கப்பட்டது",
      permissionDeniedSubtitle: "உங்கள் உலாவி அமைப்புகளில் கேமரா மற்றும் மைக்ரோஃபோன் அணுகலை அனுமதித்து மீண்டும் முயற்சிக்கவும்."
    },
    flipScreen: {
      heading: "இப்போது உங்கள் அடையாள அட்டையைத் திருப்பவும்",
      subHeading: "பின்புறத்தைக் காட்ட உங்கள் அடையாள அட்டையை நேரடியாகத் திருப்பி, பின்னர் அதை கேமரா சட்டகத்தில் வைக்கவும்.",
      continueButton: "தொடரவும்"
    },
    mobileDocCapture: {
      frontSide: "முன் பக்கம்",
      backSide: "பின் பக்கம்",
      of: "இன்",
      upload: "பதிவேற்று",
      stillNotWorking: "இன்னும் வேலை செய்யவில்லையா?",
      clickToCapture: "கிளிக்-டு-கேப்சர் முயற்சிக்கவும்",
      skip: "தவிர்"
    }
,
    permissionPopUp: {
      title: "அனுமதி தேவை",
      subtitle: "கேமராவைப் பயன்படுத்த அணுகலை அனுமதிக்கவும்",
      decline: "நிராகரி",
      allow: "அனுமதி"
    },
    userDetails: {
      heading: "PAN சரிபார்ப்பு",
      subHeading: "சரிபார்க்க விவரங்களை நிரப்பவும்",
      panLabel: "PAN எண்",
      panRequired: "உங்கள் PAN எண்ணை உள்ளிடவும்",
      saveError: "விவரங்களைச் சேமிக்கும்போது ஏதோ தவறு ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
      proceed: "தொடரவும்"
    },
    redirectCta: {
      or: "அல்லது",
      clickHere: "இங்கே கிளிக் செய்யவும்",
      clickHereStart: "இங்கே கிளிக் செய்யவும்",
      toContinue: "தொடர"
    },
    documentCapture: {
      stillNotWorking: "இன்னும் வேலை செய்யவில்லையா?",
      clickToCaptureInstead: "அதற்குப் பதிலாக கிளிக்-டு-கேப்சர் முயற்சிக்கவும்",
      pdfNotAllowedIndia: "இந்தியாவிற்கு PDF பதிவேற்றங்கள் அனுமதிக்கப்படவில்லை. 5 MB-க்கு குறைவான JPEG, JPG, அல்லது PNG கோப்புகளை பதிவேற்றவும்.",
      pdfNotAllowedIndiaMobile: "இந்தியாவிற்கு PDF பதிவேற்றங்கள் அனுமதிக்கப்படவில்லை. 5 MB-க்கு குறைவான JPEG, JPG, PNG, HEIC, அல்லது HEIF கோப்புகளை பதிவேற்றவும்.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb-க்கு குறைவாக",
      fileFormats: "jpeg, jpg, png, pdf 5 mb-க்கு குறைவாக",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb-க்கு குறைவாக",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb-க்கு குறைவாக"
    },
    mobileCapture: {
      upload: "பதிவேற்று",
      skip: "தவிர்",
      stillNotWorking: "இன்னும் வேலை செய்யவில்லையா?",
      tryClickToCapture: "தட்டி படம் எடுக்கவும்"
    },
    UserDetails: {
      panLabel: "PAN எண்",
      proceedBtn: "தொடரவும்",
      panRequired: "உங்கள் PAN எண்ணை உள்ளிடவும்",
      saveError: "விவரங்களைச் சேமிக்கும்போது ஏதோ தவறு ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்."
    }
  },
  tr: {
    supportingDocument: {
      headingFallback: "Destekleyici belge",
      subHeading: "Belgeyi aşağıya yükleyin. İnceleme için saklanır — içinden hiçbir bilgi çıkarılmaz.",
      choosePlaceholder: "Bir dosya seçin (PNG, JPG veya PDF)",
      continue: "Devam et",
      uploading: "Yükleniyor...",
      skip: "Şimdilik atla",
      errorInvalidType: "PNG, JPG veya PDF dosyası yükleyin.",
      errorTooLarge: "Dosya çok büyük. Sınır 10MB.",
      errorRead: "Bu dosya okunamadı. Lütfen başka bir tane deneyin.",
      errorNoFile: "Lütfen yüklemek için bir dosya seçin.",
    },
    header: {
      title: "Kimliğinizi doğrulayalım",
      subtitle: "Bu 2 dakikadan az sürer",
      havingIssue: "Sorun mu var?"
    },
    subHeading: {
      subHeading1: "Kimlik belgenizi yakalayın",
      subHeading2: "Canlı olduğunuzu doğrulayın",
      livenessHeading1: "İyi ışıklandırılmış bir yer bulun",
      livenessHeading2: "Yüzünüzü ortada tutun"
    },
    onlyIdVerificationHeader: {
      title: "Kimliğinizi doğrulayalım",
      subtitle: "Bu işlem yalnızca bir dakika sürer. Kimlik belgenizi hazır bulundurun.",
      instruction1: "Kamera Erişimine İzin Verin",
      instruction2: "Belgeyi Tara veya Yükle",
      instruction3: "Anında Belge Doğrulama"
    },
    termsAndCondition: {
      title: "Aşağıdaki şartları ve koşulları kabul ediyorum.",
      privacyPolicy: "Şartları görüntüle",
      beginBtnText: "Başla",
      beginLiveness: "Canlılık kontrolü başlıyor",
      startLiveness: "Canlılık kontrolüne geç"
    },
    permissionDenied: {
      title: "Kamera erişimi reddedildi!",
      subtitle: "Tarayıcı adres çubuğunun yakınında engellenmiş bir kamera simgesi olup olmadığını kontrol edin ve engellemeyi kaldırın.",
      readMore: "Daha fazla oku",
      refreshText: "Kamera erişimine izin verdikten sonra, aşağıdaki yenile düğmesine tıklayın.",
      refreshBtn: "Yenile",
      link: "Veya, telefonda devam et",
      buttonText: "Veya, telefonda devam et"
    },
    desktopBrowserPermissionDenied: {
      title: "Lütfen kamera erişimine izin verin",
      subtitle: "Tarayıcı izin isteyebilir. Devam etmek için 'izin ver' seçeneğine tıklayın.",
      readMore: "Daha fazla oku",
      refreshText: "İzin verdikten sonra yenileyin",
      refreshBtn: "Yenile",
      link: "Veya, telefonda devam et",
      buttonText: "Veya, Telefonda Devam Edin"
    },
    androidBrowserPermissionDenied: {
      title: "Kamera erişimi reddedildi",
      subtitle: "Tarayıcı adres çubuğunun yakınında engellenmiş bir kamera simgesi olup olmadığını kontrol edin ve engelini kaldırın.",
      readMore: "Daha fazla bilgi",
      refreshText: "Kamera erişimine izin verildikten sonra aşağıdaki Yenile düğmesine tıklayın.",
      refreshBtn: "Yenile",
      link: "Ya da, telefonda devam et",
      buttonText: "Ya da, telefonda devam et"
    },
    androidWebViewPermissionDenied: {
      title: "Kamera erişimi reddedildi",
      subtitle: "Kamera erişimi uygulama ayarları tarafından engellenmiş olabilir. Lütfen telefonunuzdaki Uygulama Bilgisi > İzinler > Kamera bölümünü kontrol edin ve erişime izin verin.",
      refreshText: "Kamera erişimine izin verildikten sonra aşağıdaki Yenile düğmesine tıklayın.",
      refreshBtn: "Yenile",
      link: "Ya da, telefonda devam et",
      buttonText: "Ya da, telefonda devam et"
    },
    iosBrowserPermissionDenied: {
      title: "Kamera erişimi reddedildi",
      subtitle: "Adres çubuğunun yakınındaki kamera veya kilit simgesine dokunarak erişime izin verin veya tarayıcı ayarlarını kontrol edin.",
      readMore: "Daha fazla bilgi",
      refreshText: "Kamera erişimine izin verildikten sonra aşağıdaki Yenile düğmesine tıklayın.",
      refreshBtn: "Yenile",
      link: "Ya da, telefonda devam et",
      buttonText: "Ya da, telefonda devam et"
    },
    iosWebViewPermissionDenied: {
      title: "Kamera erişimi reddedildi",
      subtitle: "Kamera erişimi uygulama ayarlarınız tarafından engellenmiş olabilir. Ayarlara gidip kullandığınız uygulama için Kamera iznini etkinleştirin.",
      refreshText: "Kamera erişimine izin verildikten sonra aşağıdaki Yenile düğmesine tıklayın.",
      refreshBtn: "Yenile",
      link: "Ya da, telefonda devam et",
      buttonText: "Ya da, telefonda devam et"
    },
    documentationList: {
      countryHeading: "Ülkeyi seçin",
      docHeading: "Belgenizi seçin",
      btnText: "İleri",
      searchCountry: "Ülke ara"
    },
    frontDocCapture: {
      heading: "Kimliğin ön yüzünü dikdörtgen içine yerleştirin",
      backupHeading: "Sorun mu yaşıyorsunuz? Lütfen resmi manuel olarak tıklayın",
      btnText: "Fotoğraf çek",
      headingBack: " dikdörtgenin içinde",
      uploadButton: "veya kimliği yükleyin"
    },
    backDocCapture: {
      heading: "Kimliğin arka yüzünü dikdörtgen içine yerleştirin",
      backupHeading: "Sorun mu yaşıyorsunuz? Lütfen resmi manuel olarak tıklayın",
      btnText: "Fotoğraf çek",
      containerText: "veya belgeyi yükleyin",
      text: "Yakalanıyor, lütfen sabit kalın",
      headingBack: " dikdörtgenin içinde",
      skipButton: "Arka Yüzü Atla",
      uploadButton: "veya kimliği yükleyin"
    },
    analyzing: {
      heading: "Kimliğiniz analiz ediliyor...",
      subHeading: "Lütfen bir sonraki ekranda kart bilgilerinizi kontrol edin ve gerekirse düzenleyin"
    },
    imageCheck: {
      heading: "Resminizi kontrol edin",
      subHeading: "Lütfen resmin eksiksiz, net ve bulanıklık ve parlama olmadan olduğundan emin olun.",
      button1: "Fotoğrafı yeniden çek",
      button2: "Tamam",
      frontHeading: "Ön resminizi kontrol edin",
      backHeading: "Arka resminizi kontrol edin"
    },
    errorHandler: {
      heading: "Üzgünüz :(",
      subHeading1: "Bazı sorunlar yaşıyoruz ama endişelenmeyin! Lütfen tekrar deneyin",
      subHeading2: "Bu devam ederse, daha sonra kontrol edin",
      button: "Tekrar deneyin"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Lütfen yüzünüzü kapatan herhangi bir şeyi çıkarın",
        button: "Tekrar deneyin"
      },
      eyeClosureDetected: {
        heading: "Lütfen gözlerinizi açık tutun ve doğrudan kameraya bakın",
        button: "Tekrar dene"
      },
      isMultipleFacesFound: {
        heading: "Birden fazla yüz tespit edildi. Kamerada yalnızca yüzünüzün göründüğünden emin olun.",
        button: "Tekrar deneyin"
      },
      noFacesFound: {
        heading: "Yüz tespit edilmedi. Yüzünüzün kamerada göründüğünden emin olun.",
        button: "Tekrar deneyin"
      },
      faceDetections: {
        heading: "Lütfen bunu çıkarın",
        button: "Tekrar deneyin"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Birden fazla yüz tespit edildi",
          button: "Tekrar deneyin"
        },
        generalMessage: {
          heading: "Kameranın önünde canlı olduğunuzdan emin olun",
          button: "Tekrar deneyin"
        }
      },
      faceMatch: {
        heading: "Yüzünüz kimlik fotoğrafınızla eşleşmiyor",
        button: "Tekrar deneyin"
      },
      selfieError: {
        heading: "Selfienizi doğrulayamadık",
        subHeading1: "Bu ipuçlarını izleyin ve tekrar deneyin",
        instruction1: "Işığın iyi olduğu bir yere geçin ve arka ışık kullanmamaya özen gösterin",
        instruction2: "Yüzünüzün tamamen görünür ve çerçevenin ortasında olduğundan emin olun",
        instruction3: "Yüzünüzün net bir şekilde görünmesi için şapka, gözlük veya maske çıkarın",
        button: "Tekrar deneyin"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP eşleşmedi. Lütfen OTP'yi açık bir şekilde yüksek sesle okuyun",
        button: "Tekrar Deneyin"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Doğrulama başarısız oldu. Lütfen talimatları net bir şekilde izleyin ve tekrar deneyin",
        button: "Tekrar deneyin"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF çok fazla sayfa içeriyor",
        subHeading: "Yüklenen PDF 2 sayfa sınırını aşıyor. Lütfen en fazla 2 sayfalık bir PDF veya kimliğinizin net bir görüntüsünü yükleyin."
      },
      heading: "Kimliğinizi işleyemedik",
      subHeading: "Yanlış kimlik yüklüyor olabilirsiniz veya resim net değil",
      buttonBack: "Kimliğin arka yüzünü tekrar deneyin",
      buttonFront: "Kimliğin ön yüzünü tekrar deneyin",
      button: "Tekrar deneyin",
      captureFrontSide: "Ön Yüzü Çek",
      captureBackSide: "Arka Yüzü Çek",
      changeIDButton: "Başka Belge Seç",
      wrongid: {
        heading: "Bu belgeyi işleyemedik",
        subHeading: "Lütfen doğru belgeyi yüklediğinizi doğrulayın ve resim kalitesinin net olduğundan emin olun"
      },
      expiredid: {
        heading: "Kimlik Belgesinin Süresi Doldu!",
        subHeading: "Süresi dolmuş bir kimlik belgesini kabul edemeyiz. Lütfen geçerli bir belge sağlayın"
      },
      minimumage: {
        heading: "Yaş Şartı Karşılanmadı!",
        subHeading: "Yaşınız gereken minimum yaşın altında. Lütfen minimum yaş kriterini karşıladığınızdan emin olun"
      },
      mobileAttemptsDone: {
        heading: "Yolculuk önceki cihazınızda devam ettirildi",
        subHeading: "Yinelemeyi önlemek için bu oturum şimdi durduruldu."
      },
      finished: {
        heading: "Yolculuk sona erdi",
        subHeading: "Yolculuk ya tamamlandı ya da sonlandırıldı"
      },
      invalid: {
        heading: "Yolculuk Kullanılamıyor !",
        subHeading: "journeyId bulunamadı veya yolculuk kimliği geçersiz"
      },
      INVALID_PAN_NUMBER: {
        heading: "Geçersiz PAN Numarası",
        subHeading: "Girdiğiniz PAN numarası geçerli değil. Lütfen kontrol edip tekrar deneyin"
      },
      INVALID_PAN_STATUS: {
        heading: "Geçersiz PAN Durumu",
        subHeading: "Girdiğiniz PAN numarası geçerli değil. Lütfen kontrol edip tekrar deneyin"
      },
      directKyc: {
        heading: "Doğrudan KYC Yolculuğu !",
        subHeading: "Bu doğrudan bir KYC yolculuğudur. Ön uç yolculuğuna izin verilmez."
      },
      DOCTYPE_FALSE: {
        heading: "Yanlış Belge Sağlandı!",
        subHeading: "Lütfen geçerli bir belge yükleyin ve görüntü kalitesinin iyi olduğundan emin olun."
      },
      ONLY_FRONT: {
        heading: "Kimliğin arka yüzü eksik",
        subHeading: "Yalnızca ön yüzü sağladınız. Devam etmek için lütfen kimliğinizi çevirin ve arka yüzü sağlayın"
      },
      ONLY_BACK: {
        heading: "Kimliğin ön yüzü eksik",
        subHeading: "Yalnızca arka yüzü sağladınız. Devam etmek için lütfen kimliğinizi çevirin ve ön yüzü sağlayın"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Belgenin Süresi Yakında Doluyor",
        subHeading: "Belge yakında süresi dolacağı için reddedildi."
      },
      DOCUMENT_EXPIRED: {
        heading: "Belgenin Süresi Doldu!",
        subHeading: "Devam etmek için lütfen geçerli, süresi dolmamış bir belge yükleyin."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Yaş Şartı Karşılanmadı!",
        subHeading: "Belge, gerekli yaşı karşılamadığınızı gösteriyor. Lütfen geçerli bir belge yükleyin."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Belge Doğrulanamadı!",
        subHeading: "Görüntü kalitesi doğrulama için çok düşük. Lütfen daha net bir görüntüyle tekrar deneyin."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Belge Doğrulanamadı!",
        subHeading: "Bazı bilgiler doğrulanamadı. Lütfen daha net bir görüntüyle tekrar deneyin."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Belge Doğrulanamadı!",
        subHeading: "Düşük görüntü kalitesi nedeniyle bazı ayrıntılar doğrulanamadı. Lütfen daha net bir görüntüyle tekrar deneyin"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Belge Doğrulanamadı!",
        subHeading: "Bazı ayrıntılar doğrulanamadı. Lütfen daha net bir görüntüyle tekrar deneyin."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Kimlikteki fotoğrafınız doğrulanırken sorun oluştu",
        subHeading: "Kimlik kartındaki fotoğrafınızı doğrulayamadık. Lütfen onaylayabilmemiz için orijinal kimliğinizin net bir fotoğrafını yükleyin."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Belge güvenlik deseni kontrolü başarısız oldu",
        subHeading: "Belgenin yerleşik güvenlik desenlerini doğrulayamadık. Gerçekliğini onaylamamıza yardımcı olmak için lütfen orijinal kimliğin net bir fotoğrafını yükleyin."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Belge Canlılık Kontrolü Başarısız",
        subHeading: "Belgenin gerçek olmayabileceğine dair işaretler bulduk. Lütfen ekran görüntüleri, basılı kopyalar kullanmaktan veya kimliği bir ekranda göstermekten kaçının. Tüm özellikleri açıkça görünen orijinal kimliği yükleyin"
      },
      SECURITY_FALSE: {
        heading: "Sorun Tespit Edildi!",
        subHeading: "Belge doğrulanamadı. Lütfen daha net bir görüntüyle tekrar deneyin"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Düşük Görüntü Kalitesi!",
        subHeading: "Görüntü çok bulanık veya belirsiz. Lütfen daha net bir görüntüyle tekrar deneyin"
      },
      FACE_UNDETECTED: {
        heading: "Yüz Algılanmadı",
        subHeading: "Belgede görünür bir yüz bulamadık. Lütfen yüzün açıkça göründüğü geçerli bir kimlik yükleyin"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Belgeler Arası Karşılaştırma Başarısız",
        subHeading: "Bir veya daha fazla önemli alandaki (Ad, Doğum Tarihi veya Yüz) uyumsuzluk nedeniyle belgeler arası karşılaştırma başarısız oldu"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker Hatası",
        subHeading: "Digilocker yolculuğu sırasında bir hata oluştu. Lütfen tekrar deneyin veya devam etmek için alternatif bir yöntem kullanın."
      },
      LINKAGE_FAILED: {
        heading: "Bu doğrulama tamamlanamıyor",
        subHeading: "Alınan bilgiler bu kontrole ait kayıtlarla eşleşmedi."
      }
    },
    biometricConsent: {
      consentStatement: "Selfie'nizden önce, kimliğinizi doğrulamak için biyometrik verilerinizi (yüz görüntüsü ve canlılık sinyalleri) yakalayıp işlememize izin vermeniz gerekir. Bu veriler yalnızca bu doğrulama için kullanılır.",
      privacyPolicy: "Gizlilik politikası",
      consentButton: "Onaylıyorum — Devam et",
      declineButton: "Onaylamıyorum",
      confirmTitle: "Biyometrik doğrulama olmadan devam edilsin mi?",
      confirmBody: "Biyometrik doğrulama olmadan selfie çekmeyeceğiz. Doğrulamanız, daha önce verdiğiniz bilgilerle tamamlanacaktır. Bu seçim bu oturum için nihaidir.",
      goBack: "Geri dön",
      confirmDecline: "Onayla — onaylamıyorum",
      declineComplete: "Biyometrik doğrulamaya devam etmemeyi seçtiniz. Kimlik doğrulamanız, gönderdiğiniz belgeler kullanılarak tamamlandı."
    },
    introLiveness: {
      heading: "Burada canlı olduğunuzu doğrulayın",
      instruction1: "Yeterli ışık olduğundan emin olun",
      instruction2: "Gerekli izinleri verin",
      instruction3: "Yönergeleri izleyin",
      button: "Devam et",
      subHeading: "Yalnızca bir adım uzaktasınız"
    },
    phoneSession: {
      heading: "Oturum telefonda devam ediyor",
      subheading: "Bu pencereyi mobilde bitene kadar açık tutun",
      button: "Burada devam et"
    },
    continueOnPhone: {
      heading: "Telefonda devam et",
      subheading: "QR kodu tarayın veya aşağıdaki bağlantıyı kopyalayın",
      subheading2: "QR kodu tarayın veya bağlantıyı telefonunuzda açın",
      text: "İşlemi tamamlayın",
      text1: "Göndermek için buraya tekrar bakın",
      button: "Kopyala",
      copiedButton: "Kopyalandı!",
      copied: "Kopyalandı!"
    },
    SsnReview: {
      heading: "Bilgilerinizi gözden geçirin",
      subHeading: "Gerekli değişiklikleri yapın ve bilgileri gönderin",
      feild1: "Sürücü Belgesi",
      feild2: "EXP",
      feild3: "Doğum Tarihi",
      feild4: "Sınıf",
      feild5: "Kısıtlamalar",
      feild6: "Ülke",
      feild7: "Adres",
      button: "Bilgiler doğru"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Yüzünüzü dairenin içinde tutun"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Kameraya yaklaşın"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Çekinmeyin, görüntüye girin"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Çok karanlık. Daha aydınlık bir yer bulun"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Çok parlak. Daha yumuşak ışık bulun"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Yüzünüzü dairenin içinde tutun"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Hareketsiz durun"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Yüzünüzü ışığa çevirin"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Telefonu göz hizasında tutun"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Kameradan biraz uzaklaşın"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Yüzünüzü çerçevenin ortasına getirin"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Yüzünüzü dairenin ortasına konumlandırın"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Yaklaşın ve yüzünüzü düz tutun"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Görünüme girin ve yüzünüzü düz tutun"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Çok karanlık. Daha parlak bir ışık bulun"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Çok parlak. Uygun bir ışık bulun"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Yüzünüzü dairenin ortasına ayarlayın"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Sabit durun ve düz ileriye bakın"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Işığa dönün ve sabit durun"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Telefonunuzu göz hizasında tutun"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Kameradan biraz uzaklaşın"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Mükemmel!"
      },
      smile1: {
        icon: "mood",
        description: "Gülümseyin, harika görünüyorsunuz!"
      },
      smile2: {
        icon: "mood",
        description: "Kameraya gülümseyin!"
      }
    },
    successful: {
      title: "Doğrulama Tamamlandı",
      text: "Şimdi pencereyi kapatabilirsiniz",
      finishBtn: "Bitir"
    },
    poweredBy: "Tarafından sağlanmıştır",
    redirect: "Yönlendiriliyor",
    error: {
      message: "URL süresi dolmuş veya geçersiz"
    },
    footer: {
      securedBy: "Tarafından sağlanmıştır"
    },
    helpFaq: {
      title: "Yardım & Sık Sorulan Sorular",
      subtitle: "Size yardımcı olmak için buradayız",
      cameraText: "Kimliğinizi doğrulamak için cihazınızın kamerasını kullanarak fotoğraflar çekmemiz gerekecek. Gerekli izinleri nasıl vereceğinizi öğrenmek için bu linki takip edin",
      cameraHeading: "Kamera İzni",
      languageText: "İşleme başlarken, üst çubuktaki açılır menüden tercih ettiğiniz dili seçebilirsiniz",
      languageHeading: "Dil Seçimi",
      kycText: "KYC veya Müşterinizi Tanıyın, müşteri kimliğini doğrulamak için yapılan bir süreçtir, bu süreç uyumu sağlamaya ve dolandırıcılığı ve diğer yasa dışı faaliyetleri önlemeye yardımcı olur",
      kycHeading: "KYC nedir?",
      timeText: "Genellikle yaklaşık 60 saniye sürer. Ancak, bu ülkeler arasında farklılık gösterebilir",
      timeHeading: "Ne kadar zaman alacak?"
    },
    pdfPreviewUnavailable: "PDF önizlemesi gösterilemiyor.",
    pdfPreviewHint: "Önizleme görünmezse yine de devam edebilirsiniz.",
    pdfOpenLabel: "PDF'yi Aç",
    failedUpload: {
      title: "Dosya Yükleme Başarısız",
      text: "Lütfen dosyanın 5MB'tan küçük ve .jpg, .jpeg, .png, .heic, .heif veya .pdf biçiminde olduğundan emin olun",
      btn: "Tekrar Deneyin",
      pdfNotAllowedIndia: "Hindistan için PDF yüklemeye izin verilmez. Lütfen 5 MB'tan küçük JPEG, JPG, PNG, HEIC veya HEIF dosyaları yükleyin.",
      pdfNotAllowedIndiaBasic: "Hindistan için PDF yüklemeye izin verilmez. Lütfen 5 MB'tan küçük JPEG, JPG veya PNG dosyaları yükleyin."
    },
    livenessAnalyzing: {
      heading: "Yüzünüz Analiz Ediliyor",
      subHeading: "Lütfen bekleyin, bu yalnızca birkaç saniye sürecek"
    },
    sessionExpiredError: {
      heading: "Üzgünüz, oturumunuzun süresi doldu",
      subHeading1: "Bir süredir hareketsizdiniz. Güvenlik nedeniyle oturumunuzun süresi otomatik olarak doldu",
      subHeading2: "Lütfen tekrar deneyin",
      buttonText: "Tekrar deneyin"
    },
    journeyExpiredError: {
      heading: "Üzgünüz, bağlantının süresi doldu",
      subHeading1: "Bağlantı artık etkin değil. Güvenlik nedeniyle bağlantıların sınırlı bir ömrü vardır",
      subHeading2: "Lütfen yeni bir bağlantıyla deneyin",
      buttonText: "Tekrar deneyin"
    },
    cameraAccessError: {
      alert1: "Kamera erişimi reddedildi. Lütfen tarayıcı ayarlarınızda kamera erişimini etkinleştirin",
      alert2: "Kameraya erişilirken bir hata oluştu",
      alert3: "Tarayıcınız kamera erişimini desteklemiyor"
    },
    activeLiveness: {
      instruction: "Yüzünüzü dairenin içinde tutun ve talimatları izleyin",
      permissionDeniedTitle: "Kamera veya Mikrofon Erişimi Reddedildi",
      permissionDeniedSubtitle: "Lütfen tarayıcı ayarlarınızda kamera ve mikrofon erişimine izin verin ve tekrar deneyin."
    },
    flipScreen: {
      heading: "Şimdi kimliğinizi çevirin",
      subHeading: "Lütfen arka yüzünü göstermek için kimliğinizi fiziksel olarak çevirin, ardından kamera çerçevesine yerleştirin.",
      continueButton: "Devam et"
    },
    mobileDocCapture: {
      frontSide: "Ön Yüz",
      backSide: "Arka Yüz",
      of: "-",
      upload: "Yükle",
      stillNotWorking: "Hâlâ çalışmıyor mu?",
      clickToCapture: "Tıkla-yakala'yı deneyin",
      skip: "Atla"
    }
,
    permissionPopUp: {
      title: "İzin gerekli",
      subtitle: "Kamerayı kullanmak için erişime izin verin",
      decline: "Reddet",
      allow: "İzin ver"
    },
    userDetails: {
      heading: "PAN Doğrulama",
      subHeading: "Doğrulamak için lütfen ayrıntıları doldurun",
      panLabel: "PAN Numarası",
      panRequired: "Lütfen PAN numaranızı girin",
      saveError: "Ayrıntılar kaydedilirken bir şeyler ters gitti. Lütfen tekrar deneyin.",
      proceed: "Devam et"
    },
    redirectCta: {
      or: "veya",
      clickHere: "buraya tıklayın",
      clickHereStart: "Buraya tıklayın",
      toContinue: "devam etmek için"
    },
    documentCapture: {
      stillNotWorking: "Hâlâ çalışmıyor mu?",
      clickToCaptureInstead: "Bunun yerine tıkla-yakala'yı deneyin",
      pdfNotAllowedIndia: "Hindistan için PDF yüklemelerine izin verilmez. Lütfen 5 MB altında JPEG, JPG veya PNG dosyaları yükleyin.",
      pdfNotAllowedIndiaMobile: "Hindistan için PDF yüklemelerine izin verilmez. Lütfen 5 MB altında JPEG, JPG, PNG, HEIC veya HEIF dosyaları yükleyin.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb altında",
      fileFormats: "jpeg, jpg, png, pdf 5 mb altında",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb altında",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb altında"
    },
    mobileCapture: {
      upload: "Yükle",
      skip: "Atla",
      stillNotWorking: "Hâlâ çalışmıyor mu?",
      tryClickToCapture: "Dokunarak çekin"
    },
    UserDetails: {
      panLabel: "PAN Numarası",
      proceedBtn: "Devam et",
      panRequired: "Lütfen PAN numaranızı girin",
      saveError: "Bilgiler kaydedilirken bir hata oluştu. Lütfen tekrar deneyin."
    }
  },
  ko: {
    supportingDocument: {
      headingFallback: "증빙 서류",
      subHeading: "아래에 서류를 업로드하세요. 검토를 위해 저장되며 — 내용은 추출되지 않습니다.",
      choosePlaceholder: "파일 선택 (PNG, JPG 또는 PDF)",
      continue: "계속",
      uploading: "업로드 중...",
      skip: "나중에 하기",
      errorInvalidType: "PNG, JPG 또는 PDF 파일을 업로드하세요.",
      errorTooLarge: "파일이 너무 큽니다. 제한은 10MB입니다.",
      errorRead: "해당 파일을 읽을 수 없습니다. 다른 파일을 시도하세요.",
      errorNoFile: "업로드할 파일을 선택하세요.",
    },
    header: {
      title: "신원을 확인해 주세요",
      subtitle: "2분도 채 걸리지 않습니다",
      havingIssue: "문제가 있나요?"
    },
    subHeading: {
      subHeading1: "신분증을 촬영하세요",
      subHeading2: "실시간 확인을 하세요",
      livenessHeading1: "조명이 좋은 곳을 찾으세요",
      livenessHeading2: "얼굴을 중앙에 유지하세요"
    },
    onlyIdVerificationHeader: {
      title: "신원을 확인해 주세요",
      subtitle: "1분 이내로 완료됩니다. 신분증을 준비해 주세요.",
      instruction1: "카메라 접근 허용",
      instruction2: "문서 스캔 또는 업로드",
      instruction3: "즉시 문서 확인"
    },
    termsAndCondition: {
      title: "다음의 이용 약관에 동의합니다.",
      privacyPolicy: "약관 보기",
      beginBtnText: "시작",
      beginLiveness: "실시간 확인 시작",
      startLiveness: "실시간 확인 진행"
    },
    permissionDenied: {
      title: "카메라 접근이 거부되었습니다!",
      subtitle: "브라우저 주소창 근처에 차단된 카메라 아이콘이 있는지 확인하고 차단을 해제해 주세요.",
      readMore: "자세히 보기",
      refreshText: "카메라 접근을 허용한 후 아래 새로 고침 버튼을 클릭해 주세요.",
      refreshBtn: "새로 고침",
      link: "또는, 휴대폰에서 계속 진행",
      buttonText: "또는, 휴대폰에서 계속 진행"
    },
    desktopBrowserPermissionDenied: {
      title: "카메라 접근을 허용해 주세요",
      subtitle: "브라우저에서 권한을 요청할 수 있습니다. '허용'을 클릭해 주세요.",
      readMore: "자세히 보기",
      refreshText: "권한을 부여한 후 새로 고침",
      refreshBtn: "새로 고침",
      link: "또는, 휴대폰에서 계속 진행",
      buttonText: "또는, 휴대폰에서 계속하기"
    },
    androidBrowserPermissionDenied: {
      title: "카메라 접근이 거부되었습니다",
      subtitle: "브라우저 주소 표시줄 근처에 차단된 카메라 아이콘이 있는지 확인하고 차단을 해제하세요.",
      readMore: "자세히 알아보기",
      refreshText: "카메라 접근 권한을 허용한 후 아래 새로 고침 버튼을 클릭하세요.",
      refreshBtn: "새로 고침",
      link: "또는, 휴대폰에서 계속하기",
      buttonText: "또는, 휴대폰에서 계속하기"
    },
    androidWebViewPermissionDenied: {
      title: "카메라 접근이 거부되었습니다",
      subtitle: "앱 설정에서 카메라 접근이 차단되었을 수 있습니다. 휴대폰 설정 > 앱 정보 > 권한 > 카메라에서 허용해 주세요.",
      refreshText: "카메라 접근 권한을 허용한 후 아래 새로 고침 버튼을 클릭하세요.",
      refreshBtn: "새로 고침",
      link: "또는, 휴대폰에서 계속하기",
      buttonText: "또는, 휴대폰에서 계속하기"
    },
    iosBrowserPermissionDenied: {
      title: "카메라 접근이 거부되었습니다",
      subtitle: "주소 표시줄 근처의 카메라 또는 잠금 아이콘을 눌러 접근을 허용하거나 브라우저 설정을 확인하세요.",
      readMore: "자세히 알아보기",
      refreshText: "카메라 접근 권한을 허용한 후 아래 새로 고침 버튼을 클릭하세요.",
      refreshBtn: "새로 고침",
      link: "또는, 휴대폰에서 계속하기",
      buttonText: "또는, 휴대폰에서 계속하기"
    },
    iosWebViewPermissionDenied: {
      title: "카메라 접근이 거부되었습니다",
      subtitle: "앱 설정에서 카메라 접근이 차단되었을 수 있습니다. 설정에서 해당 앱을 찾아 카메라 권한을 활성화하세요.",
      refreshText: "카메라 접근 권한을 허용한 후 아래 새로 고침 버튼을 클릭하세요.",
      refreshBtn: "새로 고침",
      link: "또는, 휴대폰에서 계속하기",
      buttonText: "또는, 휴대폰에서 계속하기"
    },
    documentationList: {
      countryHeading: "국가 선택",
      docHeading: "문서 선택",
      btnText: "다음",
      searchCountry: "국가 검색"
    },
    frontDocCapture: {
      heading: "신분증의 앞면을 사각형 안에 배치하세요",
      backupHeading: "문제가 있나요? 이미지를 수동으로 클릭하세요",
      btnText: "사진 찍기",
      headingBack: " 사각형 안에",
      uploadButton: "또는 신분증 업로드"
    },
    backDocCapture: {
      heading: "신분증의 뒷면을 사각형 안에 배치하세요",
      backupHeading: "문제가 있나요? 이미지를 수동으로 클릭하세요",
      btnText: "사진 찍기",
      containerText: "또는, 문서 업로드",
      text: "촬영 중, 가만히 계세요",
      skipButton: "뒷면 건너뛰기",
      headingBack: " 사각형 안에",
      uploadButton: "또는 신분증 업로드"
    },
    analyzing: {
      heading: "신분증 분석 중",
      subHeading: "잠시만 기다려 주세요, 몇 초면 완료됩니다"
    },
    imageCheck: {
      heading: "이미지 확인",
      subHeading: "이미지가 완전하고 선명하며 흐림과 반사가 없는지 확인해 주세요.",
      button1: "사진 다시 찍기",
      button2: "문제 없음",
      frontHeading: "앞면 이미지 확인",
      backHeading: "뒷면 이미지 확인"
    },
    errorHandler: {
      heading: "오류 발생 :(",
      subHeading1: "문제가 발생했습니다. 걱정하지 마세요! 다시 시도해 주세요.",
      subHeading2: "문제가 지속되면 나중에 다시 확인해 주세요.",
      button: "다시 시도"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "얼굴을 가리는 물건을 제거해 주세요",
        button: "다시 시도하기"
      },
      eyeClosureDetected: {
        heading: "눈을 뜨고 카메라를 똑바로 봐주세요",
        button: "다시 시도하기"
      },
      isMultipleFacesFound: {
        heading: "여러 얼굴이 감지되었습니다. 카메라에는 본인 얼굴만 보이도록 해주세요.",
        button: "다시 시도하기"
      },
      noFacesFound: {
        heading: "얼굴이 감지되지 않았습니다. 카메라에 얼굴이 보이는지 확인하세요.",
        button: "다시 시도"
      },
      faceDetections: {
        heading: "이것을 제거해 주세요",
        button: "다시 시도하기"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "여러 얼굴이 감지되었습니다",
          button: "다시 시도하기"
        },
        generalMessage: {
          heading: "카메라 앞에서 실시간으로 있는지 확인해 주세요",
          button: "다시 시도하기"
        }
      },
      faceMatch: {
        heading: "얼굴이 신분증 사진과 일치하지 않습니다",
        button: "다시 시도하기"
      },
      selfieError: {
        heading: "셀카를 확인할 수 없습니다",
        subHeading1: "이 팁을 따라하고 다시 시도해 주세요",
        instruction1: "조명이 좋은 곳으로 이동하고 역광을 피하세요",
        instruction2: "얼굴이 완전히 보이도록 하고 프레임 중앙에 맞추세요",
        instruction3: "얼굴을 선명하게 보기 위해 모자, 안경, 마스크를 제거하세요",
        button: "다시 시도하기"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP가 일치하지 않습니다. OTP를 또렷하게 소리 내어 읽어 주세요",
        button: "다시 시도"
      },
      activeLivenessGenericFailureMessage: {
        heading: "인증에 실패했습니다. 안내에 따라 명확하게 진행한 후 다시 시도해 주세요",
        button: "다시 시도하기"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 페이지가 너무 많습니다",
        subHeading: "업로드한 PDF가 2페이지 제한을 초과했습니다. 2페이지 이하의 PDF 또는 신분증의 선명한 이미지를 업로드하세요."
      },
      heading: "신분증을 처리할 수 없습니다",
      subHeading: "잘못된 신분증을 업로드했거나 이미지가 선명하지 않습니다.",
      buttonBack: "신분증 뒷면 다시 시도",
      buttonFront: "신분증 앞면 다시 시도",
      button: "다시 시도",
      captureFrontSide: "앞면 촬영",
      captureBackSide: "뒷면 촬영",
      changeIDButton: "신분증 유형 변경",
      wrongid: {
        heading: "이 문서를 처리할 수 없습니다",
        subHeading: "정확한 문서를 업로드하고 사진 품질이 선명한지 확인해 주세요."
      },
      expiredid: {
        heading: "신분증이 만료되었습니다!",
        subHeading: "만료된 신분증은 수용할 수 없습니다. 유효한 문서를 제공해 주세요."
      },
      minimumage: {
        heading: "연령 요구 사항 미충족!",
        subHeading: "연령이 최소 요구 연령 이하입니다. 최소 연령 기준을 충족하는지 확인해 주세요."
      },
      mobileAttemptsDone: {
        heading: "이전 기기에서 여정이 재개되었습니다",
        subHeading: "중복을 방지하기 위해 이 세션은 이제 중지되었습니다."
      },
      finished: {
        heading: "여정이 종료되었습니다",
        subHeading: "여정이 완료되었거나 종료되었습니다"
      },
      invalid: {
        heading: "여정을 사용할 수 없습니다 !",
        subHeading: "journeyId를 찾을 수 없거나 여정 ID가 유효하지 않습니다"
      },
      INVALID_PAN_NUMBER: {
        heading: "유효하지 않은 PAN 번호",
        subHeading: "입력하신 PAN 번호가 유효하지 않습니다. 확인 후 다시 시도해 주세요"
      },
      INVALID_PAN_STATUS: {
        heading: "유효하지 않은 PAN 상태",
        subHeading: "입력하신 PAN 번호가 유효하지 않습니다. 확인 후 다시 시도해 주세요"
      },
      directKyc: {
        heading: "다이렉트 KYC 여정 !",
        subHeading: "이것은 다이렉트 KYC 여정입니다. 프런트엔드 여정은 허용되지 않습니다."
      },
      DOCTYPE_FALSE: {
        heading: "잘못된 문서가 제공되었습니다!",
        subHeading: "유효한 문서를 업로드하고 이미지 품질이 좋은지 확인하세요."
      },
      ONLY_FRONT: {
        heading: "신분증 뒷면이 없습니다",
        subHeading: "앞면만 제공하셨습니다. 계속하려면 신분증을 뒤집어 뒷면을 제공해 주세요"
      },
      ONLY_BACK: {
        heading: "신분증 앞면이 없습니다",
        subHeading: "뒷면만 제공하셨습니다. 계속하려면 신분증을 뒤집어 앞면을 제공해 주세요"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "문서가 곧 만료됩니다",
        subHeading: "문서가 곧 만료되어 거부되었습니다."
      },
      DOCUMENT_EXPIRED: {
        heading: "문서가 만료되었습니다!",
        subHeading: "계속하려면 만료되지 않은 유효한 문서를 업로드하세요."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "연령 요건이 충족되지 않았습니다!",
        subHeading: "문서에 따르면 필요한 연령을 충족하지 않습니다. 유효한 문서를 업로드하세요."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "문서를 확인할 수 없습니다!",
        subHeading: "이미지 품질이 너무 낮아 확인할 수 없습니다. 더 선명한 이미지로 다시 시도하세요."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "문서를 확인할 수 없습니다!",
        subHeading: "일부 정보를 확인할 수 없습니다. 더 선명한 이미지로 다시 시도하세요."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "문서를 확인할 수 없습니다!",
        subHeading: "이미지 품질이 좋지 않아 일부 세부 정보를 확인할 수 없습니다. 더 선명한 이미지로 다시 시도하세요"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "문서를 확인할 수 없습니다!",
        subHeading: "일부 세부 정보를 확인할 수 없습니다. 더 선명한 이미지로 다시 시도하세요."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "신분증의 사진 확인에 문제가 있습니다",
        subHeading: "신분증의 사진을 확인할 수 없습니다. 확인할 수 있도록 원본 신분증의 선명한 사진을 업로드해 주세요."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "문서 보안 패턴 검사 실패",
        subHeading: "문서의 내장 보안 패턴을 확인할 수 없습니다. 진위 여부를 확인할 수 있도록 원본 신분증의 선명한 사진을 업로드해 주세요."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "문서 진위 검사 실패",
        subHeading: "문서가 진본이 아닐 수 있다는 징후를 발견했습니다. 스크린샷, 인쇄본 또는 화면에 신분증을 표시하는 것을 피해 주세요. 모든 특징이 명확하게 보이는 원본 신분증을 업로드하세요"
      },
      SECURITY_FALSE: {
        heading: "문제가 감지되었습니다!",
        subHeading: "문서를 확인할 수 없습니다. 더 선명한 이미지로 다시 시도하세요"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "이미지 품질이 좋지 않습니다!",
        subHeading: "이미지가 너무 흐리거나 불명확합니다. 더 선명한 이미지로 다시 시도하세요"
      },
      FACE_UNDETECTED: {
        heading: "얼굴이 감지되지 않았습니다",
        subHeading: "문서에서 보이는 얼굴을 찾을 수 없습니다. 얼굴이 명확하게 보이는 유효한 신분증을 업로드하세요"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "문서 간 비교 실패",
        subHeading: "하나 이상의 주요 필드(이름, 생년월일 또는 얼굴)의 불일치로 인해 문서 간 비교에 실패했습니다"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 실패",
        subHeading: "Digilocker 여정 중 오류가 발생했습니다. 다시 시도하거나 다른 방법을 사용하여 계속하세요."
      },
      LINKAGE_FAILED: {
        heading: "이 확인을 완료할 수 없습니다",
        subHeading: "입력된 정보가 이 확인의 기록과 일치하지 않았습니다."
      }
    },
    biometricConsent: {
      consentStatement: "셀카 촬영 전, 신원 확인을 위해 생체 인식 데이터(얼굴 이미지 및 라이브니스 신호)를 수집하고 처리하는 데 동의가 필요합니다. 이 데이터는 이 확인에만 사용됩니다.",
      privacyPolicy: "개인정보 처리방침",
      consentButton: "동의합니다 — 계속",
      declineButton: "동의하지 않습니다",
      confirmTitle: "생체 인식 확인 없이 진행하시겠습니까?",
      confirmBody: "생체 인식 확인 없이는 셀카를 촬영하지 않습니다. 이미 제공하신 정보를 사용하여 확인이 완료됩니다. 이 선택은 이 세션에서 최종입니다.",
      goBack: "뒤로",
      confirmDecline: "확인 — 동의하지 않음",
      declineComplete: "생체 인식 확인을 진행하지 않기로 선택하셨습니다. 제출하신 서류를 사용하여 신원 확인이 완료되었습니다."
    },
    introLiveness: {
      heading: "여기서 실시간 확인을 해주세요",
      instruction1: "충분한 조명이 있는지 확인해 주세요",
      instruction2: "필요한 권한을 허용해 주세요",
      instruction3: "지침을 따르세요",
      button: "진행",
      subHeading: "이제 한 단계만 남았습니다"
    },
    phoneSession: {
      heading: "휴대폰에서 세션 계속",
      subheading: "휴대폰에서 완료할 때까지 이 창을 열어 두세요",
      button: "여기서 계속"
    },
    continueOnPhone: {
      heading: "휴대폰에서 계속 진행",
      subheading: "QR 코드를 스캔하거나 아래 링크를 복사하세요",
      subheading2: "QR 코드를 스캔하거나 휴대폰에서 링크를 여세요",
      text: "프로세스 완료",
      text1: "여기서 다시 확인하여 제출하세요",
      button: "복사",
      copiedButton: "복사되었습니다!",
      copied: "복사됨!"
    },
    SsnReview: {
      heading: "세부 사항 검토",
      subHeading: "필요한 변경 사항을 수정하고 세부 사항을 제출하세요",
      button: "세부 사항이 정확합니다",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "얼굴을 원 안에 유지하세요"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "카메라에 가까이 오세요"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "부끄러워 말고 화면에 들어오세요"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "너무 어두워요. 더 밝은 곳으로 가세요"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "너무 밝아요. 부드러운 빛으로 가세요"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "얼굴을 원 안에 유지하세요"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "움직이지 마세요"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "얼굴을 빛 쪽으로 돌리세요"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "휴대폰을 눈높이에 드세요"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "카메라에서 조금 떨어지세요"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "얼굴을 화면 중앙에 맞추세요"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "원 중앙에 얼굴을 위치시키세요"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "가까이 오고 얼굴을 정면으로 유지하세요"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "화면에 들어와서 얼굴을 정면으로 유지하세요"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "너무 어두워요. 더 밝은 조명을 찾아주세요"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "너무 밝아요. 최적의 조명을 찾아주세요"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "얼굴을 원의 중앙에 맞추세요"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "가만히 있고 정면을 바라보세요"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "빛을 향하고 가만히 있으세요"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "휴대폰을 눈 높이로 유지하세요"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "카메라에서 조금 떨어지세요"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "완벽해요!"
      },
      smile1: {
        icon: "mood",
        description: "웃어주세요, 정말 멋지세요!"
      },
      smile2: {
        icon: "mood",
        description: "카메라를 위해 웃어주세요!"
      }
    },
    successful: {
      title: "감사합니다!",
      text: "신원 확인에 필요한 모든 정보를 수집했습니다",
      finishBtn: "완료"
    },
    poweredBy: "제공",
    redirect: "리디렉션 중",
    error: {
      message: "URL이 만료되었거나 유효하지 않습니다"
    },
    sessionExpiredError: {
      heading: "죄송합니다, 세션이 만료되었습니다",
      subHeading1: "잠시 동안 비활성 상태였습니다. 보안상의 이유로 세션이 자동으로 만료되었습니다",
      subHeading2: "다시 시도해 주세요",
      buttonText: "다시 시도"
    },
    journeyExpiredError: {
      heading: "죄송합니다, 링크가 만료되었습니다",
      subHeading1: "링크가 더 이상 활성화되지 않았습니다. 보안상의 이유로 링크의 유효 기간이 제한되어 있습니다",
      subHeading2: "새 링크로 다시 시도해 주세요",
      buttonText: "다시 시도"
    },
    cameraAccessError: {
      alert1: "카메라 접근이 거부되었습니다. 브라우저 설정에서 카메라 접근을 허용해 주세요",
      alert2: "카메라 접근 중 오류가 발생했습니다",
      alert3: "브라우저가 카메라 접근을 지원하지 않습니다"
    },
    footer: {
      securedBy: "제공"
    },
    helpFaq: {
      title: "도움말 & 자주 묻는 질문",
      subtitle: "우리는 당신을 돕기 위해 여기 있습니다",
      cameraText: "귀하의 신원을 확인하려면, 귀하의 장치 카메라를 사용하여 사진을 찍어야 합니다. 필요한 권한을 부여하는 방법을 배우려면 이 link를 따라가세요",
      cameraHeading: "카메라 권한",
      languageText: "프로세스 시작 시, 상단 바의 드롭다운 메뉴에서 원하는 언어를 선택할 수 있습니다",
      languageHeading: "언어 선택",
      kycText: "KYC 또는 '고객 알기'는 고객의 신원을 확인하는 과정으로, 준수 보장 및 사기 및 기타 불법 활동을 방지하는 데 도움을 줍니다",
      kycHeading: "KYC란 무엇인가요?",
      timeText: "보통 약 60초 정도 걸립니다. 그러나 이는 국가에 따라 다를 수 있습니다",
      timeHeading: "얼마나 시간이 걸리나요?"
    },
    pdfPreviewUnavailable: "PDF 미리보기를 표시할 수 없습니다.",
    pdfPreviewHint: "미리보기가 나타나지 않아도 계속 진행할 수 있습니다.",
    pdfOpenLabel: "PDF 열기",
    failedUpload: {
      title: "파일 업로드 실패",
      text: "파일이 5MB 미만이고 .jpg, .jpeg, .png, .heic, .heif 또는 .pdf 형식인지 확인하세요",
      btn: "다시 시도",
      pdfNotAllowedIndia: "인도에서는 PDF 업로드가 허용되지 않습니다. 5 MB 미만의 JPEG, JPG, PNG, HEIC 또는 HEIF 파일을 업로드해 주세요.",
      pdfNotAllowedIndiaBasic: "인도에서는 PDF 업로드가 허용되지 않습니다. 5 MB 미만의 JPEG, JPG 또는 PNG 파일을 업로드해 주세요."
    },
    livenessAnalyzing: {
      heading: "얼굴을 분석하는 중입니다",
      subHeading: "잠시 기다려 주세요. 몇 초밖에 걸리지 않습니다"
    },
    activeLiveness: {
      instruction: "얼굴을 원 안에 유지하고 안내에 따라 주세요",
      permissionDeniedTitle: "카메라 또는 마이크 접근이 거부되었습니다",
      permissionDeniedSubtitle: "브라우저 설정에서 카메라와 마이크 접근을 허용한 후 다시 시도해 주세요."
    },
    flipScreen: {
      heading: "이제 신분증을 뒤집어 주세요",
      subHeading: "뒷면을 보여주기 위해 신분증을 실제로 뒤집은 후 카메라 프레임 안에 맞춰 주세요.",
      continueButton: "계속"
    },
    mobileDocCapture: {
      frontSide: "앞면",
      backSide: "뒷면",
      of: "의",
      upload: "업로드",
      stillNotWorking: "여전히 작동하지 않나요?",
      clickToCapture: "클릭하여 캡처 시도",
      skip: "건너뛰기"
    }
,
    permissionPopUp: {
      title: "권한 필요",
      subtitle: "카메라를 사용하려면 액세스를 허용하세요",
      decline: "거부",
      allow: "허용"
    },
    userDetails: {
      heading: "PAN 인증",
      subHeading: "인증하려면 세부 정보를 입력하세요",
      panLabel: "PAN 번호",
      panRequired: "PAN 번호를 입력하세요",
      saveError: "세부 정보를 저장하는 중 문제가 발생했습니다. 다시 시도하세요.",
      proceed: "계속"
    },
    redirectCta: {
      or: "또는",
      clickHere: "여기를 클릭하세요",
      clickHereStart: "여기를 클릭하세요",
      toContinue: "계속하려면"
    },
    documentCapture: {
      stillNotWorking: "여전히 작동하지 않나요?",
      clickToCaptureInstead: "대신 클릭하여 캡처를 시도하세요",
      pdfNotAllowedIndia: "인도에서는 PDF 업로드가 허용되지 않습니다. 5 MB 미만의 JPEG, JPG 또는 PNG 파일을 업로드하세요.",
      pdfNotAllowedIndiaMobile: "인도에서는 PDF 업로드가 허용되지 않습니다. 5 MB 미만의 JPEG, JPG, PNG, HEIC 또는 HEIF 파일을 업로드하세요.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb 미만",
      fileFormats: "jpeg, jpg, png, pdf 5 mb 미만",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb 미만",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb 미만"
    },
    mobileCapture: {
      upload: "업로드",
      skip: "건너뛰기",
      stillNotWorking: "여전히 작동하지 않나요?",
      tryClickToCapture: "탭하여 촬영하기"
    },
    UserDetails: {
      panLabel: "PAN 번호",
      proceedBtn: "계속",
      panRequired: "PAN 번호를 입력해 주세요",
      saveError: "정보를 저장하는 중 오류가 발생했습니다. 다시 시도해 주세요."
    }
  },
  vi: {
    supportingDocument: {
      headingFallback: "Tài liệu bổ sung",
      subHeading: "Tải tài liệu lên bên dưới. Tài liệu được lưu để xem xét — không có gì được trích xuất từ đó.",
      choosePlaceholder: "Chọn một tệp (PNG, JPG hoặc PDF)",
      continue: "Tiếp tục",
      uploading: "Đang tải lên...",
      skip: "Bỏ qua bây giờ",
      errorInvalidType: "Tải lên tệp PNG, JPG hoặc PDF.",
      errorTooLarge: "Tệp quá lớn. Giới hạn là 10MB.",
      errorRead: "Không thể đọc tệp đó. Vui lòng thử tệp khác.",
      errorNoFile: "Vui lòng chọn một tệp để tải lên.",
    },
    header: {
      title: "Xác thực danh tính của bạn",
      subtitle: "Chỉ mất chưa đầy 2 phút",
      havingIssue: "Gặp sự cố?"
    },
    subHeading: {
      subHeading1: "Chụp tài liệu ID của bạn",
      subHeading2: "Xác thực bạn đang trực tiếp",
      livenessHeading1: "Tìm nơi có ánh sáng tốt",
      livenessHeading2: "Giữ khuôn mặt của bạn ở giữa"
    },
    onlyIdVerificationHeader: {
      title: "Xác thực danh tính của bạn",
      subtitle: "Quá trình này chỉ mất một phút. Hãy chuẩn bị sẵn giấy tờ tùy thân của bạn",
      instruction1: "Cho phép truy cập camera",
      instruction2: "Quét hoặc tải lên giấy tờ của bạn",
      instruction3: "Xác minh tài liệu ngay lập tức"
    },
    termsAndCondition: {
      title: "Tôi đồng ý với các điều khoản và điều kiện sau.",
      privacyPolicy: "Xem điều khoản",
      beginBtnText: "Bắt đầu",
      beginLiveness: "Bắt đầu kiểm tra sự sống",
      startLiveness: "Tiến hành kiểm tra sự sống"
    },
    permissionDenied: {
      title: "Đã từ chối quyền truy cập camera!",
      subtitle: "Hãy kiểm tra biểu tượng camera bị chặn gần thanh địa chỉ của trình duyệt và bỏ chặn nó.",
      readMore: "Đọc thêm",
      refreshText: "Sau khi cấp quyền truy cập camera, hãy nhấn nút Tải lại bên dưới.",
      refreshBtn: "Tải lại",
      link: "Hoặc, Tiếp tục trên điện thoại",
      buttonText: "Hoặc, Tiếp tục trên điện thoại"
    },
    desktopBrowserPermissionDenied: {
      title: "Vui lòng cấp quyền truy cập camera",
      subtitle: "Trình duyệt có thể yêu cầu cấp quyền. Vui lòng “cho phép” để tiếp tục.",
      readMore: "Đọc thêm",
      refreshText: "Tải lại sau khi cấp quyền",
      refreshBtn: "Tải lại",
      link: "Hoặc, Tiếp tục trên điện thoại",
      buttonText: "Hoặc, Tiếp tục trên Điện thoại"
    },
    androidBrowserPermissionDenied: {
      title: "Đã từ chối quyền truy cập camera",
      subtitle: "Kiểm tra xem có biểu tượng camera bị chặn gần thanh địa chỉ trình duyệt không và mở khóa nó.",
      readMore: "Tìm hiểu thêm",
      refreshText: "Sau khi cho phép truy cập camera, hãy nhấn nút Làm mới bên dưới.",
      refreshBtn: "Làm mới",
      link: "Hoặc, tiếp tục trên điện thoại",
      buttonText: "Hoặc, tiếp tục trên điện thoại"
    },
    androidWebViewPermissionDenied: {
      title: "Đã từ chối quyền truy cập camera",
      subtitle: "Truy cập camera có thể bị chặn bởi cài đặt ứng dụng. Vui lòng kiểm tra Cài đặt ứng dụng > Quyền > Camera trên điện thoại của bạn và cho phép truy cập.",
      refreshText: "Sau khi cho phép truy cập camera, hãy nhấn nút Làm mới bên dưới.",
      refreshBtn: "Làm mới",
      link: "Hoặc, tiếp tục trên điện thoại",
      buttonText: "Hoặc, tiếp tục trên điện thoại"
    },
    iosBrowserPermissionDenied: {
      title: "Đã từ chối quyền truy cập camera",
      subtitle: "Chạm vào biểu tượng camera hoặc khóa gần thanh địa chỉ để cho phép truy cập, hoặc kiểm tra cài đặt trình duyệt của bạn.",
      readMore: "Tìm hiểu thêm",
      refreshText: "Sau khi cho phép truy cập camera, hãy nhấn nút Làm mới bên dưới.",
      refreshBtn: "Làm mới",
      link: "Hoặc, tiếp tục trên điện thoại",
      buttonText: "Hoặc, tiếp tục trên điện thoại"
    },
    iosWebViewPermissionDenied: {
      title: "Đã từ chối quyền truy cập camera",
      subtitle: "Truy cập camera có thể bị chặn bởi cài đặt ứng dụng của bạn. Vui lòng vào Cài đặt, tìm ứng dụng bạn đang sử dụng và bật quyền Camera.",
      refreshText: "Sau khi cho phép truy cập camera, hãy nhấn nút Làm mới bên dưới.",
      refreshBtn: "Làm mới",
      link: "Hoặc, tiếp tục trên điện thoại",
      buttonText: "Hoặc, tiếp tục trên điện thoại"
    },
    documentationList: {
      countryHeading: "Chọn quốc gia",
      docHeading: "Chọn tài liệu của bạn",
      btnText: "Tiếp theo",
      searchCountry: "Tìm quốc gia"
    },
    frontDocCapture: {
      heading: "Đặt mặt trước của ID vào hình chữ nhật",
      backupHeading: "Gặp sự cố? Vui lòng chụp ảnh thủ công",
      btnText: "Chụp ảnh",
      headingBack: " trong hình chữ nhật",
      uploadButton: "hoặc tải lên giấy tờ"
    },
    backDocCapture: {
      heading: "Đặt mặt sau của ID vào hình chữ nhật",
      backupHeading: "Gặp sự cố? Vui lòng chụp ảnh thủ công",
      btnText: "Chụp ảnh",
      containerText: "hoặc, tải tài liệu lên",
      text: "Đang chụp, giữ yên",
      skipButton: "Bỏ qua mặt sau",
      headingBack: " trong hình chữ nhật",
      uploadButton: "hoặc tải lên giấy tờ"
    },
    analyzing: {
      heading: "Đang phân tích ID của bạn",
      subHeading: "Vui lòng chờ, điều này chỉ mất vài giây"
    },
    imageCheck: {
      heading: "Kiểm tra hình ảnh của bạn",
      subHeading: "Vui lòng đảm bảo hình ảnh đầy đủ, rõ ràng và không bị mờ hoặc lóa.",
      button1: "Chụp lại ảnh",
      button2: "Tốt rồi",
      frontHeading: "Kiểm tra hình ảnh mặt trước của bạn",
      backHeading: "Kiểm tra hình ảnh mặt sau của bạn"
    },
    errorHandler: {
      heading: "Ôi không:(",
      subHeading1: "Chúng tôi đang gặp phải một số vấn đề, nhưng đừng lo! Vui lòng thử lại",
      subHeading2: "Nếu vấn đề này vẫn tiếp tục, vui lòng quay lại sau",
      button: "Thử lại"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Vui lòng gỡ bỏ mọi thứ che khuất khuôn mặt của bạn",
        button: "Thử lại"
      },
      eyeClosureDetected: {
        heading: "Vui lòng mở mắt và nhìn thẳng vào máy ảnh",
        button: "Thử lại"
      },
      isMultipleFacesFound: {
        heading: "Phát hiện nhiều khuôn mặt. Hãy đảm bảo chỉ khuôn mặt của bạn xuất hiện trong camera.",
        button: "Thử lại"
      },
      noFacesFound: {
        heading: "Không phát hiện được khuôn mặt. Đảm bảo khuôn mặt của bạn hiển thị trong camera.",
        button: "Thử lại"
      },
      faceDetections: {
        heading: "Vui lòng gỡ bỏ cái này",
        button: "Thử lại"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Phát hiện nhiều khuôn mặt",
          button: "Thử lại"
        },
        generalMessage: {
          heading: "Vui lòng đảm bảo bạn đang ở trước máy quay và đang sống",
          button: "Thử lại"
        }
      },
      faceMatch: {
        heading: "Khuôn mặt của bạn không khớp với ảnh ID",
        button: "Thử lại"
      },
      selfieError: {
        heading: "Chúng tôi không thể xác minh ảnh selfie của bạn",
        subHeading1: "Chỉ cần làm theo những mẹo này và thử lại",
        instruction1: "Chuyển đến khu vực có ánh sáng tốt và tránh ánh sáng ngược",
        instruction2: "Giữ cho khuôn mặt của bạn hoàn toàn nhìn thấy và nằm ở giữa khung hình",
        instruction3: "Gỡ bỏ mũ, kính hoặc khẩu trang để làm rõ khuôn mặt của bạn",
        button: "Thử lại"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP không khớp. Vui lòng đọc to và rõ ràng mã OTP",
        button: "Thử lại"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Xác minh thất bại. Vui lòng làm theo hướng dẫn một cách rõ ràng và thử lại",
        button: "Thử lại"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF có quá nhiều trang",
        subHeading: "PDF đã tải lên vượt quá giới hạn 2 trang. Vui lòng tải lên PDF không quá 2 trang hoặc ảnh rõ nét của giấy tờ tùy thân."
      },
      heading: "Chúng tôi không thể xử lý ID của bạn",
      subHeading: "Có thể bạn đang tải lên ID sai hoặc hình ảnh không rõ ràng",
      buttonBack: "Thử lại mặt sau của ID",
      buttonFront: "Thử lại mặt trước của ID",
      button: "Thử lại",
      captureFrontSide: "Chụp mặt trước",
      captureBackSide: "Chụp mặt sau",
      changeIDButton: "Thay đổi loại ID",
      wrongid: {
        heading: "Chúng tôi không thể xử lý tài liệu này",
        subHeading: "Vui lòng xác minh rằng bạn đang tải lên tài liệu đúng và đảm bảo chất lượng hình ảnh rõ ràng"
      },
      expiredid: {
        heading: "Tài liệu ID đã hết hạn!",
        subHeading: "Chúng tôi không thể chấp nhận tài liệu ID đã hết hạn. Vui lòng cung cấp tài liệu hợp lệ"
      },
      minimumage: {
        heading: "Không đáp ứng yêu cầu tuổi!",
        subHeading: "Tuổi của bạn thấp hơn độ tuổi yêu cầu tối thiểu. Vui lòng đảm bảo bạn đáp ứng tiêu chí tuổi tối thiểu"
      },
      mobileAttemptsDone: {
        heading: "Hành trình được tiếp tục trên thiết bị trước đó của bạn",
        subHeading: "Phiên này hiện đã dừng để tránh trùng lặp."
      },
      finished: {
        heading: "Hành trình đã kết thúc",
        subHeading: "Hành trình đã hoàn thành hoặc đã bị chấm dứt"
      },
      invalid: {
        heading: "Hành trình không khả dụng !",
        subHeading: "Không tìm thấy journeyId hoặc ID hành trình không hợp lệ"
      },
      INVALID_PAN_NUMBER: {
        heading: "Số PAN không hợp lệ",
        subHeading: "Số PAN bạn nhập không hợp lệ. Vui lòng kiểm tra và thử lại"
      },
      INVALID_PAN_STATUS: {
        heading: "Trạng thái PAN không hợp lệ",
        subHeading: "Số PAN bạn nhập không hợp lệ. Vui lòng kiểm tra và thử lại"
      },
      directKyc: {
        heading: "Hành trình KYC trực tiếp !",
        subHeading: "Đây là hành trình KYC trực tiếp. Không cho phép hành trình giao diện người dùng."
      },
      DOCTYPE_FALSE: {
        heading: "Đã cung cấp sai tài liệu!",
        subHeading: "Vui lòng tải lên tài liệu hợp lệ và đảm bảo chất lượng hình ảnh tốt."
      },
      ONLY_FRONT: {
        heading: "Thiếu mặt sau của giấy tờ",
        subHeading: "Bạn chỉ cung cấp mặt trước. Vui lòng lật giấy tờ và cung cấp mặt sau để tiếp tục"
      },
      ONLY_BACK: {
        heading: "Thiếu mặt trước của giấy tờ",
        subHeading: "Bạn chỉ cung cấp mặt sau. Vui lòng lật giấy tờ và cung cấp mặt trước để tiếp tục"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Tài liệu sắp hết hạn",
        subHeading: "Tài liệu bị từ chối vì sắp hết hạn."
      },
      DOCUMENT_EXPIRED: {
        heading: "Tài liệu đã hết hạn!",
        subHeading: "Vui lòng tải lên tài liệu hợp lệ, chưa hết hạn để tiếp tục."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Không đáp ứng yêu cầu về độ tuổi!",
        subHeading: "Tài liệu cho thấy bạn không đáp ứng độ tuổi yêu cầu. Vui lòng tải lên tài liệu hợp lệ."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Không thể xác minh tài liệu!",
        subHeading: "Chất lượng hình ảnh quá kém để xác minh. Vui lòng thử lại với hình ảnh rõ hơn."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Không thể xác minh tài liệu!",
        subHeading: "Một số thông tin không thể xác minh. Vui lòng thử lại với hình ảnh rõ hơn."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Không thể xác minh tài liệu!",
        subHeading: "Một số chi tiết không thể xác minh do chất lượng hình ảnh kém. Vui lòng thử lại với hình ảnh rõ hơn"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Không thể xác minh tài liệu!",
        subHeading: "Một số chi tiết không thể xác minh. Vui lòng thử lại với hình ảnh rõ hơn."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Sự cố khi xác minh ảnh của bạn trên giấy tờ",
        subHeading: "Chúng tôi không thể xác minh ảnh của bạn trên thẻ ID. Vui lòng tải lên ảnh rõ nét của giấy tờ gốc để chúng tôi có thể xác nhận."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Kiểm tra mẫu bảo mật tài liệu thất bại",
        subHeading: "Chúng tôi không thể xác minh các mẫu bảo mật tích hợp của tài liệu. Vui lòng tải lên ảnh rõ nét của giấy tờ gốc để giúp chúng tôi xác nhận tính xác thực."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Kiểm tra tính xác thực tài liệu thất bại",
        subHeading: "Chúng tôi tìm thấy dấu hiệu cho thấy tài liệu có thể không phải là thật. Vui lòng tránh sử dụng ảnh chụp màn hình, bản in hoặc hiển thị giấy tờ trên màn hình. Tải lên giấy tờ gốc với tất cả các đặc điểm hiển thị rõ ràng"
      },
      SECURITY_FALSE: {
        heading: "Đã phát hiện sự cố!",
        subHeading: "Không thể xác minh tài liệu. Vui lòng thử lại với hình ảnh rõ hơn"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Chất lượng hình ảnh kém!",
        subHeading: "Hình ảnh quá mờ hoặc không rõ. Vui lòng thử lại với hình ảnh rõ hơn"
      },
      FACE_UNDETECTED: {
        heading: "Không phát hiện khuôn mặt",
        subHeading: "Chúng tôi không tìm thấy khuôn mặt rõ ràng trên tài liệu. Vui lòng tải lên giấy tờ hợp lệ có khuôn mặt hiển thị rõ ràng"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "So sánh giữa các tài liệu thất bại",
        subHeading: "So sánh giữa các tài liệu thất bại do không khớp ở một hoặc nhiều trường chính (Tên, Ngày sinh hoặc Khuôn mặt)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Lỗi Digilocker",
        subHeading: "Đã xảy ra lỗi trong hành trình Digilocker. Vui lòng thử lại hoặc sử dụng phương thức thay thế để tiếp tục."
      },
      LINKAGE_FAILED: {
        heading: "Không thể hoàn tất xác minh này",
        subHeading: "Thông tin đã thu thập không khớp với hồ sơ cho lần kiểm tra này."
      }
    },
    biometricConsent: {
      consentStatement: "Trước khi chụp ảnh tự sướng, chúng tôi cần sự đồng ý của bạn để thu thập và xử lý dữ liệu sinh trắc học (hình ảnh khuôn mặt và tín hiệu sự sống) nhằm xác minh danh tính của bạn. Dữ liệu này chỉ được sử dụng cho lần xác minh này.",
      privacyPolicy: "Chính sách quyền riêng tư",
      consentButton: "Tôi đồng ý — Tiếp tục",
      declineButton: "Tôi không đồng ý",
      confirmTitle: "Tiếp tục mà không xác minh sinh trắc học?",
      confirmBody: "Nếu không xác minh sinh trắc học, chúng tôi sẽ không chụp ảnh tự sướng. Việc xác minh của bạn sẽ được hoàn tất bằng thông tin bạn đã cung cấp. Lựa chọn này là quyết định cuối cùng cho phiên này.",
      goBack: "Quay lại",
      confirmDecline: "Xác nhận — không đồng ý",
      declineComplete: "Bạn đã chọn không tiếp tục xác minh sinh trắc học. Việc xác minh danh tính của bạn đã hoàn tất bằng các tài liệu bạn đã gửi."
    },
    introLiveness: {
      heading: "Xác nhận bạn đang trực tiếp tại đây",
      instruction1: "Đảm bảo có đủ ánh sáng",
      instruction2: "Cấp quyền cần thiết",
      instruction3: "Chỉ cần làm theo hướng dẫn",
      button: "Tiến hành",
      subHeading: "Bạn chỉ còn một bước nữa"
    },
    phoneSession: {
      heading: "Phiên tiếp tục trên điện thoại",
      subheading: "Giữ cửa sổ này mở cho đến khi hoàn tất trên điện thoại",
      button: "Tiếp tục ở đây"
    },
    continueOnPhone: {
      heading: "Tiếp tục trên điện thoại",
      subheading: "Quét mã QR hoặc sao chép liên kết bên dưới",
      subheading2: "Quét QR hoặc mở liên kết trên điện thoại của bạn",
      text: "Hoàn tất quá trình",
      text1: "Quay lại đây để gửi",
      button: "Sao chép",
      copiedButton: "Đã sao chép!",
      copied: "Đã sao chép!"
    },
    SsnReview: {
      heading: "Xem lại chi tiết của bạn",
      subHeading: "Thực hiện bất kỳ thay đổi cần thiết và gửi chi tiết",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "Chi tiết là chính xác"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Giữ khuôn mặt trong vòng tròn"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Đến gần camera hơn"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Đừng ngại, hãy vào khung hình"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Quá tối. Tìm nơi sáng hơn"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Quá sáng. Tìm ánh sáng dịu hơn"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Giữ khuôn mặt trong vòng tròn"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Giữ yên"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Quay mặt về phía ánh sáng"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Giữ điện thoại ngang tầm mắt"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Lùi ra xa camera một chút"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Căn giữa khuôn mặt trong khung"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Đặt khuôn mặt vào giữa vòng tròn"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Lại gần hơn và giữ khuôn mặt thẳng"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Bước vào khung hình và giữ khuôn mặt thẳng"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Quá tối. Tìm ánh sáng sáng hơn"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Quá sáng. Tìm ánh sáng tối ưu"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Điều chỉnh khuôn mặt vào giữa vòng tròn"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Giữ yên và nhìn thẳng phía trước"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Hướng mặt về phía ánh sáng và giữ yên"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Giữ điện thoại ngang tầm mắt"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Lùi ra xa khỏi camera một chút"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Hoàn hảo!"
      },
      smile1: {
        icon: "mood",
        description: "Cười lên, bạn trông thật tuyệt!"
      },
      smile2: {
        icon: "mood",
        description: "Cười với camera!"
      }
    },
    successful: {
      title: "Cảm ơn bạn!",
      text: "Chúng tôi đã thu thập tất cả thông tin cần thiết để xác minh danh tính của bạn",
      finishBtn: "Hoàn tất"
    },
    poweredBy: "Được hỗ trợ bởi",
    redirect: "Đang chuyển hướng trong",
    error: {
      message: "URL đã hết hạn hoặc không hợp lệ"
    },
    sessionExpiredError: {
      heading: "Xin lỗi, phiên của bạn đã hết hạn",
      subHeading1: "Bạn đã không hoạt động trong một thời gian. Vì lý do bảo mật, phiên của bạn đã tự động hết hạn",
      subHeading2: "Vui lòng thử lại",
      buttonText: "Thử lại"
    },
    journeyExpiredError: {
      heading: "Xin lỗi, liên kết đã hết hạn",
      subHeading1: "Liên kết không còn hoạt động. Vì lý do bảo mật, liên kết có thời gian sử dụng hạn chế",
      subHeading2: "Vui lòng thử với liên kết mới",
      buttonText: "Thử lại"
    },
    cameraAccessError: {
      alert1: "Quyền truy cập camera bị từ chối. Vui lòng bật quyền truy cập camera trong cài đặt trình duyệt của bạn",
      alert2: "Đã xảy ra lỗi khi truy cập camera",
      alert3: "Trình duyệt của bạn không hỗ trợ quyền truy cập camera"
    },
    footer: {
      securedBy: "Được bảo vệ bởi"
    },
    helpFaq: {
      title: "Trợ giúp & Câu hỏi thường gặp",
      subtitle: "Chúng tôi ở đây để giúp bạn",
      cameraText: "Để xác thực danh tính của bạn, chúng tôi cần chụp ảnh bằng camera thiết bị của bạn. Làm theo link này để tìm hiểu cách cấp quyền cần thiết",
      cameraHeading: "Quyền truy cập camera",
      languageText: "Khi bắt đầu quy trình, bạn có thể chọn ngôn ngữ ưa thích của mình từ menu thả xuống ở thanh trên cùng",
      languageHeading: "Chọn ngôn ngữ",
      kycText: "KYC, hoặc 'Biết khách hàng của bạn', là một quy trình để xác thực danh tính khách hàng, đảm bảo tuân thủ và ngăn ngừa gian lận cũng như các hoạt động phi pháp khác",
      kycHeading: "KYC là gì?",
      timeText: "Thông thường, quy trình mất khoảng 60 giây. Tuy nhiên, điều này có thể thay đổi tùy theo quốc gia",
      timeHeading: "Quá trình mất bao lâu?"
    },
    pdfPreviewUnavailable: "Không thể hiển thị bản xem trước PDF.",
    pdfPreviewHint: "Nếu bản xem trước không xuất hiện, bạn vẫn có thể tiếp tục.",
    pdfOpenLabel: "Mở PDF",
    failedUpload: {
      title: "Tải tệp lên thất bại",
      text: "Vui lòng đảm bảo tệp nhỏ hơn 5MB và ở định dạng .jpg, .jpeg, .png, .heic, .heif hoặc .pdf",
      btn: "Thử lại",
      pdfNotAllowedIndia: "Không cho phép tải lên PDF cho Ấn Độ. Vui lòng tải lên tệp JPEG, JPG, PNG, HEIC hoặc HEIF dưới 5 MB.",
      pdfNotAllowedIndiaBasic: "Không cho phép tải lên PDF cho Ấn Độ. Vui lòng tải lên tệp JPEG, JPG hoặc PNG dưới 5 MB."
    },
    livenessAnalyzing: {
      heading: "Đang phân tích khuôn mặt của bạn",
      subHeading: "Vui lòng đợi, việc này chỉ mất vài giây"
    },
    activeLiveness: {
      instruction: "Giữ khuôn mặt của bạn trong vòng tròn và làm theo hướng dẫn",
      permissionDeniedTitle: "Quyền truy cập camera hoặc micrô bị từ chối",
      permissionDeniedSubtitle: "Vui lòng cho phép truy cập camera và micrô trong cài đặt trình duyệt của bạn và thử lại."
    },
    flipScreen: {
      heading: "Bây giờ hãy lật giấy tờ tùy thân của bạn",
      subHeading: "Vui lòng lật giấy tờ tùy thân của bạn để hiển thị mặt sau, sau đó đặt vào khung máy ảnh.",
      continueButton: "Tiếp tục"
    },
    mobileDocCapture: {
      frontSide: "Mặt trước",
      backSide: "Mặt sau",
      of: "của",
      upload: "Tải lên",
      stillNotWorking: "Vẫn không hoạt động?",
      clickToCapture: "Thử nhấp để chụp",
      skip: "Bỏ qua"
    }
,
    permissionPopUp: {
      title: "Yêu cầu quyền",
      subtitle: "Cho phép truy cập để sử dụng camera",
      decline: "Từ chối",
      allow: "Cho phép"
    },
    userDetails: {
      heading: "Xác minh PAN",
      subHeading: "Vui lòng điền thông tin để xác minh",
      panLabel: "Số PAN",
      panRequired: "Vui lòng nhập số PAN của bạn",
      saveError: "Đã xảy ra lỗi khi lưu thông tin. Vui lòng thử lại.",
      proceed: "Tiếp tục"
    },
    redirectCta: {
      or: "hoặc",
      clickHere: "nhấp vào đây",
      clickHereStart: "Nhấp vào đây",
      toContinue: "để tiếp tục"
    },
    documentCapture: {
      stillNotWorking: "Vẫn không hoạt động?",
      clickToCaptureInstead: "Thử nhấp để chụp thay thế",
      pdfNotAllowedIndia: "Không cho phép tải lên PDF cho Ấn Độ. Vui lòng tải lên tệp JPEG, JPG hoặc PNG dưới 5 MB.",
      pdfNotAllowedIndiaMobile: "Không cho phép tải lên PDF cho Ấn Độ. Vui lòng tải lên tệp JPEG, JPG, PNG, HEIC hoặc HEIF dưới 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png dưới 5 mb",
      fileFormats: "jpeg, jpg, png, pdf dưới 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif dưới 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf dưới 5 mb"
    },
    mobileCapture: {
      upload: "Tải lên",
      skip: "Bỏ qua",
      stillNotWorking: "Vẫn không hoạt động?",
      tryClickToCapture: "Chạm để chụp"
    },
    UserDetails: {
      panLabel: "Số PAN",
      proceedBtn: "Tiếp tục",
      panRequired: "Vui lòng nhập số PAN của bạn",
      saveError: "Đã xảy ra lỗi khi lưu thông tin. Vui lòng thử lại."
    }
  },
  it: {
    supportingDocument: {
      headingFallback: "Documento di supporto",
      subHeading: "Carica il documento qui sotto. Viene conservato per la revisione — non ne viene estratto nulla.",
      choosePlaceholder: "Scegli un file (PNG, JPG o PDF)",
      continue: "Continua",
      uploading: "Caricamento...",
      skip: "Salta per ora",
      errorInvalidType: "Carica un file PNG, JPG o PDF.",
      errorTooLarge: "Il file è troppo grande. Il limite è 10MB.",
      errorRead: "Impossibile leggere quel file. Provane un altro.",
      errorNoFile: "Scegli un file da caricare.",
    },
    header: {
      title: "Verifica la tua identità",
      subtitle: "Ci vorranno meno di 2 minuti",
      havingIssue: "Problemi?"
    },
    subHeading: {
      subHeading1: "Scatta una foto del documento d'identità",
      subHeading2: "Verifica che sei in diretta",
      livenessHeading1: "Trova un posto con una buona illuminazione",
      livenessHeading2: "Mantieni il viso al centro"
    },
    onlyIdVerificationHeader: {
      title: "Verifica la tua identità",
      subtitle: "Ci vorrà solo un minuto. Tieni a portata di mano il tuo documento d'identità",
      instruction1: "Consenti l'accesso alla fotocamera",
      instruction2: "Scansiona o carica il tuo documento",
      instruction3: "Verifica immediata del documento"
    },
    termsAndCondition: {
      title: "Accetto di acconsentire e aderire ai seguenti termini e condizioni.",
      privacyPolicy: "Visualizza i termini",
      beginBtnText: "Inizia",
      beginLiveness: "Avvio del controllo di vitalità",
      startLiveness: "Procedi con il controllo di vitalità"
    },
    permissionDenied: {
      title: "Accesso alla fotocamera negato!",
      subtitle: "Controlla se c'è un'icona della fotocamera bloccata vicino alla barra degli indirizzi del browser e sbloccalo.",
      readMore: "Leggi di più",
      refreshText: "Dopo aver consentito l'accesso alla fotocamera, fai clic sul pulsante Ricarica qui sotto.",
      refreshBtn: "Ricarica",
      link: "Oppure, Continua su telefono",
      buttonText: "Oppure, Continua su telefono"
    },
    desktopBrowserPermissionDenied: {
      title: "Per favore, consenti l'accesso alla fotocamera",
      subtitle: "Il browser potrebbe richiedere autorizzazioni. Si prega di “consentire” per procedere.",
      readMore: "Leggi di più",
      refreshText: "Ricarica dopo aver dato le autorizzazioni",
      refreshBtn: "Ricarica",
      link: "Oppure, Continua su telefono",
      buttonText: "Oppure continua sul telefono"
    },
    androidBrowserPermissionDenied: {
      title: "Accesso alla fotocamera negato!",
      subtitle: "Controlla se c’è un’icona della fotocamera bloccata vicino alla barra degli indirizzi del browser e sbloccalo.",
      readMore: "Per saperne di più",
      refreshText: "Una volta consentito l’accesso alla fotocamera, clicca il pulsante Aggiorna qui sotto.",
      refreshBtn: "Aggiorna",
      link: "Oppure, continua sul telefono",
      buttonText: "Oppure, continua sul telefono"
    },
    androidWebViewPermissionDenied: {
      title: "Accesso alla fotocamera negato!",
      subtitle: "L’accesso alla fotocamera potrebbe essere bloccato dalle impostazioni dell’app. Controlla Informazioni app > Permessi > Fotocamera sul tuo telefono e consenti l’accesso.",
      refreshText: "Una volta consentito l’accesso alla fotocamera, clicca il pulsante Aggiorna qui sotto.",
      refreshBtn: "Aggiorna",
      link: "Oppure, continua sul telefono",
      buttonText: "Oppure, continua sul telefono"
    },
    iosBrowserPermissionDenied: {
      title: "Accesso alla fotocamera negato!",
      subtitle: "Tocca l’icona della fotocamera o del lucchetto vicino alla barra degli indirizzi per consentire l’accesso o controlla le impostazioni del browser.",
      readMore: "Per saperne di più",
      refreshText: "Una volta consentito l’accesso alla fotocamera, clicca il pulsante Aggiorna qui sotto.",
      refreshBtn: "Aggiorna",
      link: "Oppure, continua sul telefono",
      buttonText: "Oppure, continua sul telefono"
    },
    iosWebViewPermissionDenied: {
      title: "Accesso alla fotocamera negato!",
      subtitle: "L’accesso alla fotocamera potrebbe essere bloccato dalle impostazioni dell’app. Vai su Impostazioni, trova l’app che stai utilizzando e abilita il permesso Fotocamera.",
      refreshText: "Una volta consentito l’accesso alla fotocamera, clicca il pulsante Aggiorna qui sotto.",
      refreshBtn: "Aggiorna",
      link: "Oppure, continua sul telefono",
      buttonText: "Oppure, continua sul telefono"
    },
    documentationList: {
      countryHeading: "Seleziona il paese",
      docHeading: "Seleziona il tuo documento",
      btnText: "Avanti",
      searchCountry: "Cerca paese"
    },
    frontDocCapture: {
      heading: "Posiziona il lato anteriore dell'ID nel rettangolo",
      backupHeading: "Hai problemi? Per favore, scatta l'immagine manualmente",
      btnText: "Scatta foto",
      headingBack: " nel rettangolo",
      uploadButton: "oppure carica il documento"
    },
    backDocCapture: {
      heading: "Posiziona il lato posteriore dell'ID nel rettangolo",
      backupHeading: "Hai problemi? Per favore, scatta l'immagine manualmente",
      btnText: "Scatta foto",
      containerText: "oppure, carica il documento",
      text: "Catturando, rimani immobile",
      skipButton: "Salta il lato posteriore",
      headingBack: " nel rettangolo",
      uploadButton: "oppure carica il documento"
    },
    analyzing: {
      heading: "Analizzando il tuo ID",
      subHeading: "Per favore, attendi, ci vorranno solo pochi secondi"
    },
    imageCheck: {
      heading: "Controlla la tua immagine",
      subHeading: "Assicurati che l'immagine sia completa, chiara e priva di sfocature e riflessi.",
      button1: "Rifai la foto",
      button2: "Va bene",
      frontHeading: "Controlla la tua immagine frontale",
      backHeading: "Controlla la tua immagine posteriore"
    },
    errorHandler: {
      heading: "Ops:(",
      subHeading1: "Stiamo riscontrando alcuni problemi, ma non preoccuparti! Per favore, riprova",
      subHeading2: "Se il problema persiste, controlla di nuovo più tardi",
      button: "Riprova"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Per favore, rimuovi qualsiasi cosa che copra il tuo viso",
        button: "Riprova"
      },
      eyeClosureDetected: {
        heading: "Per favore, tieni gli occhi aperti e guarda dritto nella fotocamera",
        button: "Riprova"
      },
      isMultipleFacesFound: {
        heading: "Rilevati più volti. Assicurati che solo il tuo viso sia visibile nella fotocamera.",
        button: "Riprova"
      },
      noFacesFound: {
        heading: "Nessun volto rilevato. Assicurati che il tuo volto sia visibile nella fotocamera.",
        button: "Riprova"
      },
      faceDetections: {
        heading: "Per favore, rimuovi questo",
        button: "Riprova"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Sono stati rilevati più volti",
          button: "Riprova"
        },
        generalMessage: {
          heading: "Per favore, assicurati di essere in diretta davanti alla fotocamera",
          button: "Riprova"
        }
      },
      faceMatch: {
        heading: "Il tuo volto non corrisponde alla foto ID",
        button: "Riprova"
      },
      selfieError: {
        heading: "Non siamo riusciti a verificare il tuo selfie",
        subHeading1: "Segui questi suggerimenti e riprova",
        instruction1: "Spostati in un'area ben illuminata ed evita la retroilluminazione",
        instruction2: "Mantieni il tuo volto completamente visibile e centrato nel riquadro",
        instruction3: "Rimuovi cappelli, occhiali o maschere per una vista chiara del tuo volto",
        button: "Riprova"
      },
      activeLivenessOtpFailureMessage: {
        heading: "L'OTP non corrisponde. Leggi l'OTP ad alta voce e in modo chiaro",
        button: "Riprova"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verifica non riuscita. Segui le istruzioni in modo chiaro e riprova",
        button: "Riprova"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "Il PDF ha troppe pagine",
        subHeading: "Il PDF caricato supera il limite di 2 pagine. Carica un PDF di massimo 2 pagine o un'immagine nitida del tuo documento."
      },
      heading: "Non siamo riusciti a elaborare il tuo ID",
      subHeading: "O stai caricando un ID sbagliato o l'immagine non è chiara",
      buttonBack: "Riprova il lato posteriore dell'ID",
      buttonFront: "Riprova il lato anteriore dell'ID",
      button: "Riprova",
      captureFrontSide: "Acquisisci il fronte",
      captureBackSide: "Acquisisci il retro",
      changeIDButton: "Cambia tipo di ID",
      wrongid: {
        heading: "Non siamo riusciti a elaborare questo documento",
        subHeading: "Per favore, verifica che stai caricando il documento corretto e assicurati che la qualità della foto sia chiara"
      },
      expiredid: {
        heading: "Documento d'identità scaduto!",
        subHeading: "Non possiamo accettare un documento d'identità scaduto. Fornisci un documento valido"
      },
      minimumage: {
        heading: "Requisito di età non soddisfatto!",
        subHeading: "La tua età è al di sotto dell'età minima richiesta. Per favore, assicurati di soddisfare i criteri di età minima"
      },
      mobileAttemptsDone: {
        heading: "Percorso ripreso sul tuo dispositivo precedente",
        subHeading: "Questa sessione è ora interrotta per evitare duplicazioni."
      },
      finished: {
        heading: "Il percorso è terminato",
        subHeading: "Il percorso è stato completato o terminato"
      },
      invalid: {
        heading: "Percorso non disponibile !",
        subHeading: "Nessun journeyId trovato o ID del percorso non valido"
      },
      INVALID_PAN_NUMBER: {
        heading: "Numero PAN non valido",
        subHeading: "Il numero PAN inserito non è valido. Controlla e riprova"
      },
      INVALID_PAN_STATUS: {
        heading: "Stato PAN non valido",
        subHeading: "Il numero PAN inserito non è valido. Controlla e riprova"
      },
      directKyc: {
        heading: "Percorso KYC diretto !",
        subHeading: "Questo è un percorso KYC diretto. Il percorso frontend non è consentito."
      },
      DOCTYPE_FALSE: {
        heading: "Documento errato fornito!",
        subHeading: "Carica un documento valido e assicurati che la qualità dell'immagine sia buona."
      },
      ONLY_FRONT: {
        heading: "Manca il retro del documento",
        subHeading: "Hai fornito solo il fronte. Gira il documento e fornisci il retro per procedere"
      },
      ONLY_BACK: {
        heading: "Manca il fronte del documento",
        subHeading: "Hai fornito solo il retro. Gira il documento e fornisci il fronte per procedere"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Documento in scadenza",
        subHeading: "Il documento è stato rifiutato perché sta per scadere."
      },
      DOCUMENT_EXPIRED: {
        heading: "Documento scaduto!",
        subHeading: "Carica un documento valido e non scaduto per continuare."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Requisito di età non soddisfatto!",
        subHeading: "Il documento indica che non soddisfi l'età richiesta. Carica un documento valido."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Impossibile verificare il documento!",
        subHeading: "La qualità dell'immagine è troppo scarsa per la verifica. Riprova con un'immagine più nitida."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Impossibile verificare il documento!",
        subHeading: "Alcune informazioni non possono essere verificate. Riprova con un'immagine più nitida."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Impossibile verificare il documento!",
        subHeading: "Alcuni dettagli non possono essere verificati a causa della scarsa qualità dell'immagine. Riprova con un'immagine più nitida"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Impossibile verificare il documento!",
        subHeading: "Alcuni dettagli non possono essere verificati. Riprova con un'immagine più nitida."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problema nella verifica della tua foto sul documento",
        subHeading: "Non siamo riusciti a verificare la tua foto sul documento. Carica una foto nitida del tuo documento originale così possiamo confermarla."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Verifica del motivo di sicurezza del documento non riuscita",
        subHeading: "Non siamo riusciti a verificare i motivi di sicurezza integrati del documento. Carica una foto nitida del documento originale per aiutarci a confermarne l'autenticità."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Verifica di autenticità del documento non riuscita",
        subHeading: "Abbiamo rilevato segnali che il documento potrebbe non essere autentico. Evita screenshot, copie stampate o di mostrare il documento su uno schermo. Carica il documento originale con tutti gli elementi chiaramente visibili"
      },
      SECURITY_FALSE: {
        heading: "Problema rilevato!",
        subHeading: "Impossibile verificare il documento. Riprova con un'immagine più nitida"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Scarsa qualità dell'immagine!",
        subHeading: "L'immagine è troppo sfocata o poco chiara. Riprova con un'immagine più nitida"
      },
      FACE_UNDETECTED: {
        heading: "Volto non rilevato",
        subHeading: "Non siamo riusciti a trovare un volto visibile sul documento. Carica un documento valido in cui il volto sia chiaramente visibile"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Confronto tra documenti non riuscito",
        subHeading: "Il confronto tra documenti non è riuscito a causa di una discrepanza in uno o più campi chiave (nome, data di nascita o volto)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Errore Digilocker",
        subHeading: "Si è verificato un errore durante il percorso Digilocker. Riprova o utilizza un metodo alternativo per continuare."
      },
      LINKAGE_FAILED: {
        heading: "Impossibile completare questa verifica",
        subHeading: "I dati acquisiti non corrispondono ai registri per questo controllo."
      }
    },
    biometricConsent: {
      consentStatement: "Prima del tuo selfie, abbiamo bisogno del tuo consenso per acquisire ed elaborare i tuoi dati biometrici (immagine del volto e segnali di vivezza) per verificare la tua identità. Questi dati vengono utilizzati solo per questa verifica.",
      privacyPolicy: "Informativa sulla privacy",
      consentButton: "Acconsento — Continua",
      declineButton: "Non acconsento",
      confirmTitle: "Continuare senza verifica biometrica?",
      confirmBody: "Senza verifica biometrica non acquisiremo un selfie. La tua verifica sarà completata con le informazioni che hai già fornito. Questa scelta è definitiva per questa sessione.",
      goBack: "Indietro",
      confirmDecline: "Conferma — non acconsento",
      declineComplete: "Hai scelto di non procedere con la verifica biometrica. La verifica della tua identità è stata completata con i documenti che hai inviato."
    },
    introLiveness: {
      heading: "Conferma che sei in diretta qui",
      instruction1: "Assicurati che ci sia abbastanza luce",
      instruction2: "Concedi le autorizzazioni necessarie",
      instruction3: "Segui semplicemente le istruzioni",
      button: "Procedi",
      subHeading: "Sei a un solo passo"
    },
    phoneSession: {
      heading: "Sessione continuata su telefono",
      subheading: "Tieni aperta questa finestra, fino a completare su mobile",
      button: "Continua qui"
    },
    continueOnPhone: {
      heading: "Continua su telefono",
      subheading: "Scansiona il QR o copia il link qui sotto",
      subheading2: "Scansiona il QR o apri il link sul tuo telefono",
      text: "Completa il processo",
      text1: "Controlla qui per inviare",
      button: "Copia",
      copiedButton: "Copiato!",
      copied: "Copiato!"
    },
    SsnReview: {
      heading: "Rivedi i tuoi dettagli",
      subHeading: "Apporta le modifiche necessarie e invia i dettagli",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Classe",
      feild5: "RSTR",
      feild6: "Paese",
      feild7: "Indirizzo",
      button: "I dettagli sono corretti"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Mantieni il viso nel cerchio"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Avvicinati alla fotocamera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Non essere timido, mettiti in vista"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Troppo buio. Cerca più luce"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Troppa luce. Cerca una luce più morbida"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Mantieni il viso nel cerchio"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Resta fermo"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Gira il viso verso la luce"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Tieni il telefono all'altezza degli occhi"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Allontanati un po' dalla fotocamera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Centra il viso nell'inquadratura"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Posiziona il viso al centro del cerchio"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Avvicinati e mantieni il viso dritto"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Entra nell'inquadratura e mantieni il viso dritto"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Troppo buio. Trova una luce più brillante"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Troppo luminoso. Trova una luce ottimale"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Regola il viso al centro del cerchio"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Resta fermo e guarda dritto davanti"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Rivolgiti verso la luce e resta fermo"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Tieni il telefono all'altezza degli occhi"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Allontanati un po' dalla fotocamera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perfetto!"
      },
      smile1: {
        icon: "mood",
        description: "Sorridi per favore, stai venendo bene!"
      },
      smile2: {
        icon: "mood",
        description: "Sorridi per la fotocamera!"
      }
    },
    successful: {
      title: "Grazie!",
      text: "Abbiamo raccolto tutte le informazioni necessarie per verificare la tua identità",
      finishBtn: "Finisci"
    },
    poweredBy: "Powered by",
    redirect: "Reindirizzamento in",
    error: {
      message: "L'URL è scaduto o non valido"
    },
    sessionExpiredError: {
      heading: "Spiacenti, la tua sessione è scaduta",
      subHeading1: "Sei stato inattivo per un po'. Per motivi di sicurezza, la tua sessione è scaduta automaticamente",
      subHeading2: "Per favore, riprova",
      buttonText: "Riprova"
    },
    journeyExpiredError: {
      heading: "Spiacenti, il link è scaduto",
      subHeading1: "Il link non è più attivo. Per motivi di sicurezza, i link hanno una durata limitata",
      subHeading2: "Per favore, prova con un nuovo link",
      buttonText: "Riprova"
    },
    cameraAccessError: {
      alert1: "L'accesso alla fotocamera è stato negato. Per favore, abilita l'accesso alla fotocamera nelle impostazioni del tuo browser",
      alert2: "Si è verificato un errore durante l'accesso alla fotocamera",
      alert3: "Il tuo browser non supporta l'accesso alla fotocamera"
    },
    footer: {
      securedBy: "Powered By"
    },
    helpFaq: {
      title: "Aiuto & Domande frequenti",
      subtitle: "Siamo qui per aiutarti",
      cameraText: "Per verificare la tua identità, dobbiamo scattare delle foto utilizzando la fotocamera del tuo dispositivo. Segui questo link per scoprire come concedere i permessi necessari",
      cameraHeading: "Permesso fotocamera",
      languageText: "All'inizio del processo, puoi scegliere la tua lingua preferita selezionandola dal menu a tendina nella barra superiore",
      languageHeading: "Selezione della lingua",
      kycText: "KYC, o 'Conosci il tuo cliente', è un processo per verificare l'identità del cliente, garantire la conformità e prevenire frodi e altre attività illegali",
      kycHeading: "Cos'è KYC?",
      timeText: "Di solito, ci vogliono circa 60 secondi. Tuttavia, questo può variare in base ai paesi",
      timeHeading: "Quanto tempo ci vorrà?"
    },
    pdfPreviewUnavailable: "Impossibile mostrare l'anteprima del PDF.",
    pdfPreviewHint: "Se l'anteprima non appare, puoi comunque continuare.",
    pdfOpenLabel: "Apri PDF",
    failedUpload: {
      title: "Caricamento del file non riuscito",
      text: "Assicurati che il file sia inferiore a 5 MB e in formato .jpg, .jpeg, .png, .heic, .heif o .pdf",
      btn: "Riprova",
      pdfNotAllowedIndia: "Il caricamento di PDF non è consentito per l'India. Carica file JPEG, JPG, PNG, HEIC o HEIF di meno di 5 MB.",
      pdfNotAllowedIndiaBasic: "Il caricamento di PDF non è consentito per l'India. Carica file JPEG, JPG o PNG di meno di 5 MB."
    },
    livenessAnalyzing: {
      heading: "Analisi del tuo volto",
      subHeading: "Attendi, ci vorranno solo pochi secondi"
    },
    activeLiveness: {
      instruction: "Mantieni il viso nel cerchio e segui le istruzioni",
      permissionDeniedTitle: "Accesso alla fotocamera o al microfono negato",
      permissionDeniedSubtitle: "Consenti l'accesso alla fotocamera e al microfono nelle impostazioni del browser e riprova."
    },
    flipScreen: {
      heading: "Ora gira il tuo documento d'identità",
      subHeading: "Gira fisicamente il tuo documento d'identità per mostrare il retro, quindi posizionalo nel riquadro della fotocamera.",
      continueButton: "Continua"
    },
    mobileDocCapture: {
      frontSide: "Lato anteriore",
      backSide: "Lato posteriore",
      of: "di",
      upload: "Carica",
      stillNotWorking: "Ancora non funziona?",
      clickToCapture: "Prova clicca per acquisire",
      skip: "Salta"
    }
,
    permissionPopUp: {
      title: "Autorizzazione richiesta",
      subtitle: "Consenti l'accesso per usare la fotocamera",
      decline: "Rifiuta",
      allow: "Consenti"
    },
    userDetails: {
      heading: "Verifica PAN",
      subHeading: "Compila i dettagli per verificare",
      panLabel: "Numero PAN",
      panRequired: "Inserisci il tuo numero PAN",
      saveError: "Si è verificato un errore durante il salvataggio dei dettagli. Riprova.",
      proceed: "Procedi"
    },
    redirectCta: {
      or: "o",
      clickHere: "clicca qui",
      clickHereStart: "Clicca qui",
      toContinue: "per continuare"
    },
    documentCapture: {
      stillNotWorking: "Ancora non funziona?",
      clickToCaptureInstead: "Prova invece l'acquisizione con un clic",
      pdfNotAllowedIndia: "I caricamenti PDF non sono consentiti per l'India. Carica file JPEG, JPG o PNG sotto i 5 MB.",
      pdfNotAllowedIndiaMobile: "I caricamenti PDF non sono consentiti per l'India. Carica file JPEG, JPG, PNG, HEIC o HEIF sotto i 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png sotto i 5 mb",
      fileFormats: "jpeg, jpg, png, pdf sotto i 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif sotto i 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf sotto i 5 mb"
    },
    mobileCapture: {
      upload: "Carica",
      skip: "Salta",
      stillNotWorking: "Ancora non funziona?",
      tryClickToCapture: "Cattura manualmente"
    },
    UserDetails: {
      panLabel: "Numero PAN",
      proceedBtn: "Continua",
      panRequired: "Inserisci il tuo numero PAN",
      saveError: "Si è verificato un errore durante il salvataggio. Riprova."
    }
  },
  ha: {
    supportingDocument: {
      headingFallback: "Takardar tallafi",
      subHeading: "Ɗora takardar da ke ƙasa. Ana adana ta don dubawa — babu abin da ake ciro daga cikinta.",
      choosePlaceholder: "Zaɓi fayil (PNG, JPG ko PDF)",
      continue: "Ci gaba",
      uploading: "Ana ɗorawa...",
      skip: "Tsallake yanzu",
      errorInvalidType: "Ɗora fayil ɗin PNG, JPG ko PDF.",
      errorTooLarge: "Fayil ɗin ya yi girma sosai. Iyaka ita ce 10MB.",
      errorRead: "An kasa karanta wannan fayil ɗin. Da fatan a gwada wani.",
      errorNoFile: "Da fatan a zaɓi fayil don ɗorawa.",
    },
    header: {
      title: "Bari mu tabbatar da shaidarka",
      subtitle: "Yana ɗaukar ƙasa da minti 2",
      havingIssue: "Kana da matsala?"
    },
    subHeading: {
      subHeading1: "Dauki takardar shaidarka",
      subHeading2: "Tabbatar kana raye",
      livenessHeading1: "Nemo wuri mai haske mai kyau",
      livenessHeading2: "Ka ajiye fuskarka a tsakiya"
    },
    onlyIdVerificationHeader: {
      title: "Bari mu tabbatar da shaidarka",
      subtitle: "Hakan zai ɗauki minti ɗaya kawai. Ka ajiye takardar shaidarka a hannunka",
      instruction1: "Ba da izinin amfani da kyamara",
      instruction2: "Duba ko loda takardarka",
      instruction3: "Tabbataccen tabbatar da takarda nan take"
    },
    termsAndCondition: {
      title: "Na yarda da amincewa da bin waɗannan sharuɗɗa da ka'idoji.",
      privacyPolicy: "Duba sharuɗɗan",
      beginBtnText: "Fara",
      beginLiveness: "Fara duba rai",
      startLiveness: "Ci gaba da duba rai"
    },
    permissionDenied: {
      title: "An ƙi bayar da damar amfani da kyamara!",
      subtitle: "Duba ko akwai alamar kyamara da aka toshe kusa da sandar adireshin burauzan ku, sannan ku buɗe ta.",
      readMore: "Kara karantawa",
      refreshText: "Bayan kun ba da izini ga kyamara, danna maɓallin Sake sabunta da ke ƙasa.",
      refreshBtn: "Sake sabunta",
      link: "Ko, ci gaba a waya",
      buttonText: "Ko, ci gaba a waya"
    },
    desktopBrowserPermissionDenied: {
      title: "Da fatan za a ba da izinin samun damar kyamara",
      subtitle: "Burauza na iya neman izini. Da fatan za a danna 'ba da izini' don ci gaba.",
      readMore: "Kara karantawa",
      refreshText: "Sake sabunta bayan ba da izini",
      refreshBtn: "Sake sabunta",
      link: "Ko, ci gaba a waya",
      buttonText: "Ko, Ci gaba a Waya"
    },
    androidBrowserPermissionDenied: {
      title: "An ƙi bayar da damar amfani da kyamara!",
      subtitle: "Duba alamar kyamara da aka toshe kusa da sandar adireshi a burauzar kuma bude ta.",
      readMore: "Kara karantawa",
      refreshText: "Da zarar an ba da damar amfani da kyamara, danna maɓallin Sabunta a ƙasa.",
      refreshBtn: "Sabunta",
      link: "Ko, Ci gaba a Wayar Salula",
      buttonText: "Ko, Ci gaba a Wayar Salula"
    },
    androidWebViewPermissionDenied: {
      title: "An ƙi bayar da damar amfani da kyamara!",
      subtitle: "Yiwuwar an toshe damar kyamara ta saitunan manhaja. Duba Saitunan Wayar > Bayanin Manhaja > Izini > Kyamara, sannan ba da damar amfani.",
      refreshText: "Da zarar an ba da damar amfani da kyamara, danna maɓallin Sabunta a ƙasa.",
      refreshBtn: "Sabunta",
      link: "Ko, Ci gaba a Wayar Salula",
      buttonText: "Ko, Ci gaba a Wayar Salula"
    },
    iosBrowserPermissionDenied: {
      title: "An ƙi bayar da damar amfani da kyamara!",
      subtitle: "Taɓa alamar kyamara ko kulle kusa da sandar adireshi don ba da dama, ko duba saitunan burauzarka.",
      readMore: "Kara karantawa",
      refreshText: "Da zarar an ba da damar amfani da kyamara, danna maɓallin Sabunta a ƙasa.",
      refreshBtn: "Sabunta",
      link: "Ko, Ci gaba a Wayar Salula",
      buttonText: "Ko, Ci gaba a Wayar Salula"
    },
    iosWebViewPermissionDenied: {
      title: "An ƙi bayar da damar amfani da kyamara!",
      subtitle: "Yiwuwar an toshe damar kyamara ta saitunan manhaja. Je zuwa Saituna, nemo manhajar da kake amfani da ita, sannan kunna izinin Kyamara.",
      refreshText: "Da zarar an ba da damar amfani da kyamara, danna maɓallin Sabunta a ƙasa.",
      refreshBtn: "Sabunta",
      link: "Ko, Ci gaba a Wayar Salula",
      buttonText: "Ko, Ci gaba a Wayar Salula"
    },
    documentationList: {
      countryHeading: "Zaɓi ƙasa",
      docHeading: "Zaɓi takardarka",
      btnText: "Gaba",
      searchCountry: "Nemo ƙasa"
    },
    frontDocCapture: {
      heading: "Sanya gefen gaba na takardar shaidar a cikin murabba'i",
      backupHeading: "Shin kuna da matsala? Da fatan za a danna hoton hannu",
      btnText: "Dauki hoto",
      headingBack: " cikin murabba'i",
      uploadButton: "ko, loda ID"
    },
    backDocCapture: {
      heading: "Sanya gefen baya na takardar shaidar a cikin murabba'i",
      backupHeading: "Shin kuna da matsala? Da fatan za a danna hoton hannu",
      btnText: "Dauki hoto",
      containerText: "ko, loda takardar",
      text: "Ana ɗauka, a tsaye",
      headingBack: " cikin murabba'i",
      skipButton: "Tsallake Baya",
      uploadButton: "ko, loda ID"
    },
    analyzing: {
      heading: "Ana nazarin takardar shaidarka...",
      subHeading: "Da fatan za a duba bayanan katinka a allon na gaba kuma gyara idan ya cancanta"
    },
    imageCheck: {
      heading: "Duba hotonku",
      subHeading: "Da fatan za a tabbatar da cewa hoton ya cika, ya bayyana kuma ba tare da dishi ko glare ba.",
      button1: "Sake ɗaukar hoto",
      button2: "Da kyau",
      frontHeading: "Duba hoton gaba",
      backHeading: "Duba hoton baya"
    },
    errorHandler: {
      heading: "Oh oh :(",
      subHeading1: "Muna fuskantar wasu matsaloli, amma kada ku damu! Da fatan za a sake gwadawa",
      subHeading2: "Idan ya ci gaba, duba daga baya",
      button: "Sake gwadawa"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Da fatan za a cire duk abin da ke rufe fuskarka",
        button: "Sake gwadawa"
      },
      eyeClosureDetected: {
        heading: "Don Allah, ka buɗe idanunka ka kalli kyamara kai tsaye",
        button: "Sake gwadawa"
      },
      isMultipleFacesFound: {
        heading: "An gano fuskoki da yawa. Tabbatar cewa fuskar ka kawai ce ke bayyana a cikin kyamara.",
        button: "Sake gwadawa"
      },
      noFacesFound: {
        heading: "Ba a gano fuska ba. Tabbatar cewa fuskar ka tana bayyana a cikin kyamara.",
        button: "Sake gwadawa"
      },
      faceDetections: {
        heading: "Da fatan za a cire wannan",
        button: "Sake gwadawa"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "An sami fuska da yawa",
          button: "Sake gwadawa"
        },
        generalMessage: {
          heading: "Da fatan ka tabbatar kana a gabanan kyamara cikin rai",
          button: "Sake gwadawa"
        }
      },
      faceMatch: {
        heading: "Fuskarka ba ta dace da hoton ID ba",
        button: "Sake gwadawa"
      },
      selfieError: {
        heading: "Ba mu iya tantance selfie dinka ba",
        subHeading1: "Ka bi wadannan shawarwari ka sake gwadawa",
        instruction1: "Ka koma wurin da haske yake sosai kuma ka guji hasken baya",
        instruction2: "Ka tabbatar fuskarka tana bayyana sosai kuma tana cikin tsakiya na hoto",
        instruction3: "Cire hula, gilashi ko maska don samun cikakken haske na fuskarka",
        button: "Sake gwadawa"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP bai dace ba. Da fatan za a karanta OTP a fili da babbar murya",
        button: "Sake gwadawa"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Tabbatarwa ta gaza. Da fatan za a bi umarnin a fili sannan a sake gwadawa",
        button: "Sake gwadawa"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF yana da shafuka da yawa",
        subHeading: "PDF da aka ɗora ya wuce iyakar shafuka 2. Da fatan za a ɗora PDF mai shafuka 2 ko ƙasa, ko hoto bayyananne na ID ɗinka."
      },
      heading: "Ba mu iya sarrafa shaidarku ba",
      subHeading: "Ko dai kuna loda shaidar da ba ta dace ba ko hoton bai bayyana ba",
      buttonBack: "Sake gwadawa gefen baya na shaidar",
      buttonFront: "Sake gwadawa gefen gaba na shaidar",
      button: "Sake gwadawa",
      captureFrontSide: "Ɗauki Gefen Gaba",
      captureBackSide: "Ɗauki Gefen Baya",
      changeIDButton: "Zaɓi Wata Takarda",
      wrongid: {
        heading: "Ba mu iya sarrafa wannan takarda ba",
        subHeading: "Da fatan za a tabbatar kana loda takarda daidai kuma a tabbatar ingancin hoto a bayyane"
      },
      expiredid: {
        heading: "Takardar Shaida Ta Ƙare!",
        subHeading: "Ba za mu iya karɓar takardar shaida da ta ƙare ba. Da fatan za a bayar da takarda mai inganci"
      },
      minimumage: {
        heading: "Ba a Cika Bukatar Shekaru Ba!",
        subHeading: "Shekarunka sun yi ƙasa da mafi ƙarancin shekarun da ake bukata. Da fatan za a tabbatar ka cika ƙa'idar mafi ƙarancin shekaru"
      },
      mobileAttemptsDone: {
        heading: "An ci gaba da tafiya a na'urarka ta baya",
        subHeading: "An dakatar da wannan zama yanzu don guje wa maimaitawa."
      },
      finished: {
        heading: "An kammala tafiyar",
        subHeading: "Tafiyar ko dai an kammala ko an dakatar"
      },
      invalid: {
        heading: "Tafiya Babu Samuwa !",
        subHeading: "Ba a sami journeyId ba ko ID na tafiya bai da inganci"
      },
      INVALID_PAN_NUMBER: {
        heading: "Lambar PAN Mara Inganci",
        subHeading: "Lambar PAN da ka shigar ba ta da inganci. Da fatan za a duba sannan a sake gwadawa"
      },
      INVALID_PAN_STATUS: {
        heading: "Matsayin PAN Mara Inganci",
        subHeading: "Lambar PAN da ka shigar ba ta da inganci. Da fatan za a duba sannan a sake gwadawa"
      },
      directKyc: {
        heading: "Tafiyar KYC Kai Tsaye !",
        subHeading: "Wannan tafiya ce ta KYC kai tsaye. Ba a yarda da tafiyar gaba ba."
      },
      DOCTYPE_FALSE: {
        heading: "An Bayar da Takarda Mara Daidai!",
        subHeading: "Da fatan za a loda takarda mai inganci kuma a tabbatar ingancin hoto yana da kyau."
      },
      ONLY_FRONT: {
        heading: "Bayan katin shaida ya ɓace",
        subHeading: "Ka bayar da gaba kawai. Da fatan za a juya katin shaidarka a bayar da baya don ci gaba"
      },
      ONLY_BACK: {
        heading: "Gaban katin shaida ya ɓace",
        subHeading: "Ka bayar da baya kawai. Da fatan za a juya katin shaidarka a bayar da gaba don ci gaba"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Takarda Za Ta Ƙare Nan Ba Da Jimawa Ba",
        subHeading: "An ƙi takardar saboda za ta ƙare nan ba da jimawa ba."
      },
      DOCUMENT_EXPIRED: {
        heading: "Takarda Ta Ƙare!",
        subHeading: "Da fatan za a loda takarda mai inganci wadda ba ta ƙare ba don ci gaba."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Ba a Cika Bukatar Shekaru Ba!",
        subHeading: "Takardar ta nuna ba ka cika shekarun da ake bukata ba. Da fatan za a loda takarda mai inganci."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Ba a Iya Tabbatar da Takarda Ba!",
        subHeading: "Ingancin hoto ya yi ƙasa sosai don tabbatarwa. Da fatan za a sake gwadawa da hoto mai haske."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Ba a Iya Tabbatar da Takarda Ba!",
        subHeading: "Ba a iya tabbatar da wasu bayanai ba. Da fatan za a sake gwadawa da hoto mai haske."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Ba a Iya Tabbatar da Takarda Ba!",
        subHeading: "Ba a iya tabbatar da wasu bayanai ba saboda ƙarancin ingancin hoto. Da fatan za a sake gwadawa da hoto mai haske"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Ba a Iya Tabbatar da Takarda Ba!",
        subHeading: "Ba a iya tabbatar da wasu bayanai ba. Da fatan za a sake gwadawa da hoto mai haske."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Matsala wajen tabbatar da hotonka a katin shaida",
        subHeading: "Ba mu iya tabbatar da hotonka a katin shaida ba. Da fatan za a loda hoto bayyananne na ainihin katin shaidarka don mu tabbatar."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Binciken tsarin tsaro na takarda ya gaza",
        subHeading: "Ba mu iya tabbatar da tsarukan tsaro na cikin takardar ba. Da fatan za a loda hoto bayyananne na ainihin katin shaida don taimaka mana tabbatar da sahihancinsa."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Binciken Rayuwar Takarda Ya Gaza",
        subHeading: "Mun sami alamun cewa takardar mai yiwuwa ba ta gaskiya ba ce. Da fatan za a guji amfani da hotunan allo, kwafe da aka buga, ko nuna katin shaida a allo. Loda ainihin katin shaida tare da dukkan fasali a bayyane"
      },
      SECURITY_FALSE: {
        heading: "An Gano Matsala!",
        subHeading: "Ba a iya tabbatar da takardar ba. Da fatan za a sake gwadawa da hoto mai haske"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Ƙarancin Ingancin Hoto!",
        subHeading: "Hoton ya yi duhu ko bai bayyana ba sosai. Da fatan za a sake gwadawa da hoto mai haske"
      },
      FACE_UNDETECTED: {
        heading: "Ba a Gano Fuska Ba",
        subHeading: "Ba mu iya samun fuska a bayyane a takardar ba. Da fatan za a loda katin shaida mai inganci inda fuska take bayyane sosai"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Kwatanta Tsakanin Takardu Ya Gaza",
        subHeading: "Kwatanta tsakanin takardu ya gaza saboda rashin daidaituwa a fili ɗaya ko fiye na muhimmi (Suna, Ranar Haihuwa, ko Fuska)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Gazawar Digilocker",
        subHeading: "An sami kuskure yayin tafiyar Digilocker. Da fatan za a sake gwadawa ko a yi amfani da wata hanya don ci gaba."
      },
      LINKAGE_FAILED: {
        heading: "Ba a iya kammala wannan tabbatarwar ba",
        subHeading: "Bayanan da aka ɗauka ba su yi daidai da bayanan wannan dubawa ba."
      }
    },
    biometricConsent: {
      consentStatement: "Kafin selfie ɗinka, muna buƙatar yardarka don ɗauka da sarrafa bayananka na biometric (hoton fuska da sigina na rai) don tabbatar da ainihinka. Ana amfani da wannan bayanan don wannan tabbatarwa kawai.",
      privacyPolicy: "Manufar sirri",
      consentButton: "Na yarda — Ci gaba",
      declineButton: "Ban yarda ba",
      confirmTitle: "A ci gaba ba tare da tabbatarwar biometric ba?",
      confirmBody: "Ba tare da tabbatarwar biometric ba, ba za mu ɗauki selfie ba. Za a kammala tabbatarwarka ta amfani da bayanan da ka riga ka bayar. Wannan zaɓin shine na ƙarshe don wannan zaman.",
      goBack: "Koma baya",
      confirmDecline: "Tabbatar — ban yarda ba",
      declineComplete: "Ka zaɓi kada ka ci gaba da tabbatarwar biometric. An kammala tabbatar da ainihinka ta amfani da takardun da ka gabatar."
    },
    introLiveness: {
      heading: "Tabbatar kuna raye a nan",
      instruction1: "Tabbatar da isasshen haske",
      instruction2: "Ba da izinin da ake bukata",
      instruction3: "Kawai bi umarni",
      button: "Ci gaba",
      subHeading: "Sauran mataki ɗaya kawai"
    },
    phoneSession: {
      heading: "Zama ya ci gaba a waya",
      subheading: "Ka bar wannan taga a bude har sai an gama a wayar hannu",
      button: "Ci gaba anan"
    },
    continueOnPhone: {
      heading: "Ci gaba a waya",
      subheading: "Duba QR ko kwafi hanyar haɗin da ke ƙasa",
      subheading2: "Duba QR ko buɗe hanyar haɗin a wayarku",
      text: "Kammala tsari",
      text1: "Duba anan don aiko",
      button: "Kwafi",
      copiedButton: "An kwafa!",
      copied: "An kwafe!"
    },
    SsnReview: {
      heading: "Duba cikakkun bayananku",
      subHeading: "Yi duk wani canje-canje da ake bukata kuma aika cikakkun bayanan",
      feild1: "Lasin tuki",
      feild2: "EXP",
      feild3: "Ranar haifuwa",
      feild4: "Ajin",
      feild5: "Iyaka",
      feild6: "Kasa",
      feild7: "Adireshi",
      button: "Cikakkun bayanai sun dace"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Ka ajiye fuskarka cikin da'irar"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Ka kusanci kyamara"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Kada ka ji kunya, ka bayyana"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Ya yi duhu sosai. Nemi haske mai yawa"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Ya yi haske sosai. Nemi haske mai laushi"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Ka ajiye fuskarka cikin da'irar"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Ka tsaya cak"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Ka juya fuska zuwa haske"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Ka riƙe wayar daidai da idanu"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Ka ɗan nisanta daga kyamara"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Ka sa fuskarka tsakiyar firam"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Helyezd az arcod a kör közepére"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Gyere közelebb és tartsd az arcod egyenesen"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Lépj a képbe és tartsd az arcod egyenesen"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Kusufa. Samu wuta mai haske"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Kusa. Samu wuta mai kyau"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Igazítsd az arcod a kör közepéhez"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Maradj mozdulatlan és nézz egyenesen előre"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Fordulj a fény felé és maradj mozdulatlan"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Ka rike wayarka a matakin ido"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Ka dan yi nesa da kyamara"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Daidai!"
      },
      smile1: {
        icon: "mood",
        description: "Murmushi, kuna da kyau!"
      },
      smile2: {
        icon: "mood",
        description: "Yi murmushi ga kyamara!"
      }
    },
    successful: {
      title: "Tabbatarwa gama",
      text: "Zaka iya rufe taga yanzu",
      finishBtn: "Gama"
    },
    poweredBy: "An samar da",
    redirect: "Ana mayar da hankali a cikin",
    error: {
      message: "URL ya ƙare ko ba daidai ba ne"
    },
    footer: {
      securedBy: "An samar da"
    },
    helpFaq: {
      title: "Taimako & Tambayoyi da aka fi yawan yi",
      subtitle: "Muna nan don taimaka maka",
      cameraText: "Don tabbatar da shaidarka, za mu buƙaci ɗaukar hotuna ta amfani da kyamarar na'urar ka. Bi wannan link don koyon yadda ake ba da izinin da ake buƙata",
      cameraHeading: "Izinin Kyamara",
      languageText: "A farkon tsarin, za ka iya zaɓar harshen da kake so ta hanyar zaɓin daga menu na guntun a saman sandar",
      languageHeading: "Zaɓin Harshen",
      kycText: "KYC, ko 'Sanin Abokin Ciniki', yana nufin tsarin tabbatar da shaidar abokin ciniki, yana tabbatar da bin doka da kuma hana zamba da sauran ayyukan laifi",
      kycHeading: "Menene KYC?",
      timeText: "Yawanci, yana ɗaukar kusan dakiku 60. Duk da haka, wannan na iya bambanta bisa ga ƙasashe",
      timeHeading: "Zai ɗauki tsawon lokaci nawa?"
    },
    pdfPreviewUnavailable: "Ba a iya nuna samfoti na PDF ba.",
    pdfPreviewHint: "Idan samfoti bai bayyana ba, har yanzu kana iya ci gaba.",
    pdfOpenLabel: "Bude PDF",
    failedUpload: {
      title: "Loda Fayil Ya Gaza",
      text: "Da fatan za a tabbatar fayil din yana ƙasa da 5MB kuma a tsarin .jpg, .jpeg, .png, .heic, .heif, ko .pdf",
      btn: "Sake gwadawa",
      pdfNotAllowedIndia: "Ba a yarda da loda PDF don Indiya ba. Da fatan za a loda fayilolin JPEG, JPG, PNG, HEIC, ko HEIF ƙasa da 5 MB.",
      pdfNotAllowedIndiaBasic: "Ba a yarda da loda PDF don Indiya ba. Da fatan za a loda fayilolin JPEG, JPG, ko PNG ƙasa da 5 MB."
    },
    livenessAnalyzing: {
      heading: "Ana Nazarin Fuskarka",
      subHeading: "Da fatan za a jira, wannan zai ɗauki 'yan daƙiƙa kawai"
    },
    sessionExpiredError: {
      heading: "Yi haƙuri, lokacin zamanka ya ƙare",
      subHeading1: "Ka daɗe ba ka yin komai. Saboda dalilan tsaro, zamanka ya ƙare ta atomatik",
      subHeading2: "Da fatan za a sake gwadawa",
      buttonText: "Sake gwadawa"
    },
    journeyExpiredError: {
      heading: "Yi haƙuri, hanyar haɗin ta ƙare",
      subHeading1: "Hanyar haɗin ba ta aiki yanzu. Saboda dalilan tsaro, hanyoyin haɗin suna da iyakacin lokaci",
      subHeading2: "Da fatan za a gwada da sabuwar hanyar haɗi",
      buttonText: "Sake gwadawa"
    },
    cameraAccessError: {
      alert1: "An ƙi damar shiga kyamara. Da fatan za a kunna damar shiga kyamara a saitunan mai binciken ka",
      alert2: "An sami kuskure yayin shiga kyamara",
      alert3: "Mai bincikenka bai goyi bayan damar shiga kyamara ba"
    },
    activeLiveness: {
      instruction: "Ka ajiye fuskarka cikin da'irar kuma ka bi umarnin",
      permissionDeniedTitle: "An Ƙi Damar Shiga Kyamara ko Makirufo",
      permissionDeniedSubtitle: "Da fatan za a ba da damar shiga kyamara da makirufo a saitunan mai bincikenka sannan a sake gwadawa."
    },
    flipScreen: {
      heading: "Yanzu juya katin shaidarka",
      subHeading: "Da fatan za a juya katin shaidarka a zahiri don nuna bayansa, sannan a sanya shi cikin firam ɗin kyamara.",
      continueButton: "Ci gaba"
    },
    mobileDocCapture: {
      frontSide: "Gefen Gaba",
      backSide: "Gefen Baya",
      of: "na",
      upload: "Loda",
      stillNotWorking: "Har yanzu baya aiki?",
      clickToCapture: "Gwada danna don ɗauka",
      skip: "Tsallake"
    }
,
    permissionPopUp: {
      title: "Ana buƙatar izini",
      subtitle: "Ka ba da damar shiga don amfani da kamara",
      decline: "Ƙi",
      allow: "Ba da izini"
    },
    userDetails: {
      heading: "Tabbatar da PAN",
      subHeading: "Da fatan za a cika bayanan don tabbatarwa",
      panLabel: "Lambar PAN",
      panRequired: "Da fatan za a shigar da lambar PAN ɗinka",
      saveError: "Wani abu ya faskara yayin ajiye bayanai. Da fatan za a sake gwadawa.",
      proceed: "Ci gaba"
    },
    redirectCta: {
      or: "ko",
      clickHere: "danna nan",
      clickHereStart: "Danna nan",
      toContinue: "don ci gaba"
    },
    documentCapture: {
      stillNotWorking: "Har yanzu bai yi aiki ba?",
      clickToCaptureInstead: "Gwada danna-don-ɗauka maimakon haka",
      pdfNotAllowedIndia: "Ba a yarda da ɗora PDF don Indiya ba. Da fatan za a ɗora fayilolin JPEG, JPG, ko PNG ƙasa da 5 MB.",
      pdfNotAllowedIndiaMobile: "Ba a yarda da ɗora PDF don Indiya ba. Da fatan za a ɗora fayilolin JPEG, JPG, PNG, HEIC, ko HEIF ƙasa da 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png ƙasa da 5 mb",
      fileFormats: "jpeg, jpg, png, pdf ƙasa da 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif ƙasa da 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf ƙasa da 5 mb"
    },
    mobileCapture: {
      upload: "Loda",
      skip: "Tsallake",
      stillNotWorking: "Har yanzu bai aiki ba?",
      tryClickToCapture: "Ɗauki hoto da hannu"
    },
    UserDetails: {
      panLabel: "Lambar PAN",
      proceedBtn: "Ci gaba",
      panRequired: "Da fatan za a shigar da lambar PAN ɗinka",
      saveError: "Wani abu ya yi kuskure yayin ajiye bayanai. Da fatan za a sake gwadawa."
    }
  },
  th: {
    supportingDocument: {
      headingFallback: "เอกสารประกอบ",
      subHeading: "อัปโหลดเอกสารด้านล่าง เอกสารจะถูกจัดเก็บเพื่อการตรวจสอบ — ไม่มีการดึงข้อมูลใด ๆ จากเอกสาร",
      choosePlaceholder: "เลือกไฟล์ (PNG, JPG หรือ PDF)",
      continue: "ดำเนินการต่อ",
      uploading: "กำลังอัปโหลด...",
      skip: "ข้ามไปก่อน",
      errorInvalidType: "อัปโหลดไฟล์ PNG, JPG หรือ PDF",
      errorTooLarge: "ไฟล์มีขนาดใหญ่เกินไป ขีดจำกัดคือ 10MB",
      errorRead: "ไม่สามารถอ่านไฟล์นั้นได้ โปรดลองไฟล์อื่น",
      errorNoFile: "โปรดเลือกไฟล์เพื่ออัปโหลด",
    },
    header: {
      title: "ยืนยันตัวตนของคุณ",
      subtitle: "ใช้เวลาไม่ถึง 2 นาที",
      havingIssue: "มีปัญหาหรือไม่?"
    },
    subHeading: {
      subHeading1: "ถ่ายภาพเอกสารประจำตัวของคุณ",
      subHeading2: "ยืนยันว่าคุณยังมีชีวิตอยู่",
      livenessHeading1: "หาตำแหน่งที่มีแสงสว่างเพียงพอ",
      livenessHeading2: "ให้ใบหน้าของคุณอยู่ตรงกลาง"
    },
    onlyIdVerificationHeader: {
      title: "มายืนยันตัวตนของคุณ",
      subtitle: "ใช้เวลาเพียงไม่กี่นาที โปรดเตรียมเอกสารยืนยันตัวตนไว้ใกล้มือ",
      instruction1: "อนุญาตให้ใช้กล้อง",
      instruction2: "สแกนหรืออัปโหลดเอกสารของคุณ",
      instruction3: "ยืนยันเอกสารทันที"
    },
    termsAndCondition: {
      title: "ฉันยินยอมและยอมรับข้อกำหนดและเงื่อนไขต่อไปนี้",
      privacyPolicy: "ดูข้อกำหนด",
      beginBtnText: "เริ่ม",
      beginLiveness: "เริ่มการตรวจสอบความมีชีวิต",
      startLiveness: "ดำเนินการตรวจสอบความมีชีวิต"
    },
    permissionDenied: {
      title: "การเข้าถึงกล้องถูกปฏิเสธ!",
      subtitle: "โปรดตรวจสอบว่าเบราว์เซอร์มีไอคอนกล้องที่ถูกบล็อกใกล้แถบที่อยู่หรือไม่ และปลดบล็อกกล้องนั้น",
      readMore: "อ่านเพิ่มเติม",
      refreshText: "เมื่ออนุญาตการเข้าถึงกล้องแล้ว โปรดคลิกปุ่มรีเฟรชด้านล่าง",
      refreshBtn: "รีเฟรช",
      link: "หรือดำเนินการต่อบนโทรศัพท์",
      buttonText: "หรือดำเนินการต่อบนโทรศัพท์"
    },
    desktopBrowserPermissionDenied: {
      title: "โปรดอนุญาตการเข้าถึงกล้อง",
      subtitle: "เบราว์เซอร์อาจขออนุญาต โปรดคลิก 'อนุญาต' เพื่อดำเนินการต่อ",
      readMore: "อ่านเพิ่มเติม",
      refreshText: "รีเฟรชหลังจากให้สิทธิ์แล้ว",
      refreshBtn: "รีเฟรช",
      link: "หรือดำเนินการต่อบนโทรศัพท์",
      buttonText: "หรือดำเนินการต่อบนโทรศัพท์"
    },
    androidBrowserPermissionDenied: {
      title: "การเข้าถึงกล้องถูกปฏิเสธ!",
      subtitle: "ตรวจสอบไอคอนกล้องที่ถูกบล็อกใกล้แถบที่อยู่ของเบราว์เซอร์และปลดบล็อกการเข้าถึง",
      readMore: "เรียนรู้เพิ่มเติม",
      refreshText: "เมื่ออนุญาตการเข้าถึงกล้องแล้ว ให้คลิกปุ่มรีเฟรชด้านล่าง",
      refreshBtn: "รีเฟรช",
      link: "หรือ ดำเนินการต่อบนโทรศัพท์",
      buttonText: "หรือ ดำเนินการต่อบนโทรศัพท์"
    },
    androidWebViewPermissionDenied: {
      title: "การเข้าถึงกล้องถูกปฏิเสธ!",
      subtitle: "อาจมีการบล็อกกล้องผ่านการตั้งค่าแอป กรุณาตรวจสอบ การตั้งค่าโทรศัพท์ > ข้อมูลแอป > การอนุญาต > กล้อง แล้วอนุญาตการเข้าถึง",
      refreshText: "เมื่ออนุญาตการเข้าถึงกล้องแล้ว ให้คลิกปุ่มรีเฟรชด้านล่าง",
      refreshBtn: "รีเฟรช",
      link: "หรือ ดำเนินการต่อบนโทรศัพท์",
      buttonText: "หรือ ดำเนินการต่อบนโทรศัพท์"
    },
    iosBrowserPermissionDenied: {
      title: "การเข้าถึงกล้องถูกปฏิเสธ!",
      subtitle: "แตะที่ไอคอนกล้องหรือไอคอนล็อกใกล้แถบที่อยู่เพื่ออนุญาต หรือไปที่การตั้งค่าเบราว์เซอร์ของคุณ",
      readMore: "เรียนรู้เพิ่มเติม",
      refreshText: "เมื่ออนุญาตการเข้าถึงกล้องแล้ว ให้คลิกปุ่มรีเฟรชด้านล่าง",
      refreshBtn: "รีเฟรช",
      link: "หรือ ดำเนินการต่อบนโทรศัพท์",
      buttonText: "หรือ ดำเนินการต่อบนโทรศัพท์"
    },
    iosWebViewPermissionDenied: {
      title: "การเข้าถึงกล้องถูกปฏิเสธ!",
      subtitle: "อาจมีการบล็อกกล้องผ่านการตั้งค่าแอป ไปที่ การตั้งค่า > เลือกแอปที่คุณใช้งาน > เปิดการอนุญาตกล้อง",
      refreshText: "เมื่ออนุญาตการเข้าถึงกล้องแล้ว ให้คลิกปุ่มรีเฟรชด้านล่าง",
      refreshBtn: "รีเฟรช",
      link: "หรือ ดำเนินการต่อบนโทรศัพท์",
      buttonText: "หรือ ดำเนินการต่อบนโทรศัพท์"
    },
    documentationList: {
      countryHeading: "เลือกประเทศ",
      docHeading: "เลือกเอกสารของคุณ",
      btnText: "ถัดไป",
      searchCountry: "ค้นหาประเทศ"
    },
    frontDocCapture: {
      heading: "วางด้านหน้าของบัตรประจำตัวในกรอบสี่เหลี่ยม",
      backupHeading: "มีปัญหาหรือไม่? โปรดคลิกที่ภาพด้วยตนเอง",
      btnText: "ถ่ายรูป",
      headingBack: " ในกรอบสี่เหลี่ยม",
      uploadButton: "หรืออัปโหลดบัตรประจำตัว"
    },
    backDocCapture: {
      heading: "วางด้านหลังของบัตรประจำตัวในกรอบสี่เหลี่ยม",
      backupHeading: "มีปัญหาหรือไม่? โปรดคลิกที่ภาพด้วยตนเอง",
      btnText: "ถ่ายรูป",
      containerText: "หรืออัปโหลดเอกสาร",
      text: "กำลังจับภาพ โปรดอยู่ในท่านิ่ง",
      headingBack: " ในกรอบสี่เหลี่ยม",
      skipButton: "ข้ามด้านหลัง",
      uploadButton: "หรืออัปโหลดบัตรประจำตัว"
    },
    analyzing: {
      heading: "กำลังวิเคราะห์บัตรประจำตัวของคุณ...",
      subHeading: "โปรดตรวจสอบรายละเอียดบัตรของคุณบนหน้าจอถัดไปและแก้ไขหากจำเป็น"
    },
    imageCheck: {
      heading: "ตรวจสอบภาพของคุณ",
      subHeading: "โปรดตรวจสอบให้แน่ใจว่าภาพครบถ้วน ชัดเจน และไม่มีความเบลอหรือแสงสะท้อน",
      button1: "ถ่ายภาพใหม่",
      button2: "ใช้ได้",
      frontHeading: "ตรวจสอบภาพด้านหน้า",
      backHeading: "ตรวจสอบภาพด้านหลัง"
    },
    errorHandler: {
      heading: "โอ๊ะ :(",
      subHeading1: "เรากำลังประสบปัญหาบางประการ แต่อย่ากังวล! โปรดลองอีกครั้ง",
      subHeading2: "หากปัญหายังคงอยู่ โปรดตรวจสอบอีกครั้งในภายหลัง",
      button: "ลองอีกครั้ง"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "กรุณาถอดสิ่งที่ปิดบังใบหน้าของคุณออก",
        button: "ลองอีกครั้ง"
      },
      eyeClosureDetected: {
        heading: "กรุณาลืมตาและมองตรงไปที่กล้อง",
        button: "ลองอีกครั้ง"
      },
      isMultipleFacesFound: {
        heading: "ตรวจพบหลายใบหน้า โปรดตรวจสอบให้แน่ใจว่าในกล้องปรากฏเฉพาะใบหน้าของคุณเท่านั้น",
        button: "ลองอีกครั้ง"
      },
      noFacesFound: {
        heading: "ไม่พบใบหน้า ตรวจสอบให้แน่ใจว่าใบหน้าของคุณปรากฏในกล้อง",
        button: "ลองอีกครั้ง"
      },
      faceDetections: {
        heading: "กรุณาถอดสิ่งนี้ออก",
        button: "ลองอีกครั้ง"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "พบใบหน้าหลายใบ",
          button: "ลองอีกครั้ง"
        },
        generalMessage: {
          heading: "กรุณายืนยันว่าคุณอยู่หน้ากล้องและอยู่ในสภาพสด",
          button: "ลองอีกครั้ง"
        }
      },
      faceMatch: {
        heading: "ใบหน้าของคุณไม่ตรงกับรูปในบัตรประชาชน",
        button: "ลองอีกครั้ง"
      },
      selfieError: {
        heading: "เรากระทำการยืนยันเซลฟี่ของคุณไม่ได้",
        subHeading1: "กรุณาทำตามคำแนะนำเหล่านี้แล้วลองใหม่อีกครั้ง",
        instruction1: "ย้ายไปที่บริเวณที่มีแสงสว่างดีและหลีกเลี่ยงแสงที่มาจากด้านหลัง",
        instruction2: "ให้แน่ใจว่าคุณสามารถมองเห็นใบหน้าได้อย่างชัดเจนและอยู่ตรงกลางในกรอบ",
        instruction3: "ถอดหมวก แว่นตา หรือหน้ากากออกเพื่อให้เห็นใบหน้าได้ชัดเจน",
        button: "ลองอีกครั้ง"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP ไม่ตรงกัน กรุณาอ่าน OTP ออกเสียงดังๆ ให้ชัดเจน",
        button: "ลองอีกครั้ง"
      },
      activeLivenessGenericFailureMessage: {
        heading: "การยืนยันล้มเหลว กรุณาทำตามคำแนะนำอย่างชัดเจนแล้วลองอีกครั้ง",
        button: "ลองอีกครั้ง"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF มีหน้ามากเกินไป",
        subHeading: "PDF ที่อัปโหลดเกินขีดจำกัด 2 หน้า โปรดอัปโหลด PDF ไม่เกิน 2 หน้า หรือรูปภาพบัตรประจำตัวที่ชัดเจน"
      },
      heading: "เราไม่สามารถประมวลผลบัตรประจำตัวของคุณได้",
      subHeading: "คุณอาจกำลังอัปโหลดบัตรประจำตัวที่ไม่ถูกต้องหรือภาพไม่ชัดเจน",
      buttonBack: "ลองถ่ายภาพด้านหลังของบัตรอีกครั้ง",
      buttonFront: "ลองถ่ายภาพด้านหน้าของบัตรอีกครั้ง",
      button: "ลองอีกครั้ง",
      captureFrontSide: "ถ่ายด้านหน้า",
      captureBackSide: "ถ่ายด้านหลัง",
      changeIDButton: "เลือกเอกสารอื่น",
      wrongid: {
        heading: "เราไม่สามารถประมวลผลเอกสารนี้ได้",
        subHeading: "โปรดตรวจสอบว่าคุณกำลังอัปโหลดเอกสารที่ถูกต้องและตรวจสอบว่าคุณภาพของภาพชัดเจน"
      },
      expiredid: {
        heading: "เอกสารประจำตัวหมดอายุแล้ว!",
        subHeading: "เราไม่สามารถรับเอกสารประจำตัวที่หมดอายุได้ โปรดให้เอกสารที่ถูกต้อง"
      },
      minimumage: {
        heading: "ไม่เป็นไปตามข้อกำหนดด้านอายุ!",
        subHeading: "อายุของคุณต่ำกว่าอายุขั้นต่ำที่กำหนด โปรดตรวจสอบว่าคุณเป็นไปตามเกณฑ์อายุขั้นต่ำ"
      },
      mobileAttemptsDone: {
        heading: "การเดินทางดำเนินต่อบนอุปกรณ์ก่อนหน้าของคุณ",
        subHeading: "เซสชันนี้ถูกหยุดแล้วเพื่อหลีกเลี่ยงการซ้ำซ้อน"
      },
      finished: {
        heading: "การเดินทางสิ้นสุดลงแล้ว",
        subHeading: "การเดินทางเสร็จสมบูรณ์หรือถูกยกเลิกแล้ว"
      },
      invalid: {
        heading: "การเดินทางไม่พร้อมใช้งาน !",
        subHeading: "ไม่พบ journeyId หรือ ID การเดินทางไม่ถูกต้อง"
      },
      INVALID_PAN_NUMBER: {
        heading: "หมายเลข PAN ไม่ถูกต้อง",
        subHeading: "หมายเลข PAN ที่คุณป้อนไม่ถูกต้อง โปรดตรวจสอบและลองอีกครั้ง"
      },
      INVALID_PAN_STATUS: {
        heading: "สถานะ PAN ไม่ถูกต้อง",
        subHeading: "หมายเลข PAN ที่คุณป้อนไม่ถูกต้อง โปรดตรวจสอบและลองอีกครั้ง"
      },
      directKyc: {
        heading: "การเดินทาง KYC โดยตรง !",
        subHeading: "นี่คือการเดินทาง KYC โดยตรง ไม่อนุญาตให้มีการเดินทางผ่านฟรอนต์เอนด์"
      },
      DOCTYPE_FALSE: {
        heading: "ให้เอกสารผิด!",
        subHeading: "โปรดอัปโหลดเอกสารที่ถูกต้องและตรวจสอบว่าคุณภาพของภาพดี"
      },
      ONLY_FRONT: {
        heading: "ไม่มีด้านหลังของบัตรประจำตัว",
        subHeading: "คุณให้เฉพาะด้านหน้า โปรดพลิกบัตรประจำตัวของคุณและให้ด้านหลังเพื่อดำเนินการต่อ"
      },
      ONLY_BACK: {
        heading: "ไม่มีด้านหน้าของบัตรประจำตัว",
        subHeading: "คุณให้เฉพาะด้านหลัง โปรดพลิกบัตรประจำตัวของคุณและให้ด้านหน้าเพื่อดำเนินการต่อ"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "เอกสารกำลังจะหมดอายุ",
        subHeading: "เอกสารถูกปฏิเสธเนื่องจากกำลังจะหมดอายุ"
      },
      DOCUMENT_EXPIRED: {
        heading: "เอกสารหมดอายุแล้ว!",
        subHeading: "โปรดอัปโหลดเอกสารที่ถูกต้องและยังไม่หมดอายุเพื่อดำเนินการต่อ"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "ไม่เป็นไปตามข้อกำหนดด้านอายุ!",
        subHeading: "เอกสารระบุว่าคุณไม่เป็นไปตามอายุที่กำหนด โปรดอัปโหลดเอกสารที่ถูกต้อง"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ไม่สามารถยืนยันเอกสารได้!",
        subHeading: "คุณภาพของภาพแย่เกินไปสำหรับการยืนยัน โปรดลองอีกครั้งด้วยภาพที่ชัดเจนขึ้น"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ไม่สามารถยืนยันเอกสารได้!",
        subHeading: "ไม่สามารถยืนยันข้อมูลบางอย่างได้ โปรดลองอีกครั้งด้วยภาพที่ชัดเจนขึ้น"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ไม่สามารถยืนยันเอกสารได้!",
        subHeading: "ไม่สามารถยืนยันรายละเอียดบางอย่างได้เนื่องจากคุณภาพของภาพไม่ดี โปรดลองอีกครั้งด้วยภาพที่ชัดเจนขึ้น"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ไม่สามารถยืนยันเอกสารได้!",
        subHeading: "ไม่สามารถยืนยันรายละเอียดบางอย่างได้ โปรดลองอีกครั้งด้วยภาพที่ชัดเจนขึ้น"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "มีปัญหาในการยืนยันรูปถ่ายของคุณบนบัตรประจำตัว",
        subHeading: "เราไม่สามารถยืนยันรูปถ่ายของคุณบนบัตรประจำตัวได้ โปรดอัปโหลดรูปถ่ายที่ชัดเจนของบัตรประจำตัวต้นฉบับเพื่อให้เรายืนยันได้"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "การตรวจสอบรูปแบบความปลอดภัยของเอกสารล้มเหลว",
        subHeading: "เราไม่สามารถยืนยันรูปแบบความปลอดภัยในตัวของเอกสารได้ โปรดอัปโหลดรูปถ่ายที่ชัดเจนของบัตรประจำตัวต้นฉบับเพื่อช่วยให้เรายืนยันความถูกต้อง"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "การตรวจสอบความมีชีวิตของเอกสารล้มเหลว",
        subHeading: "เราพบสัญญาณว่าเอกสารอาจไม่ใช่ของแท้ โปรดหลีกเลี่ยงการใช้ภาพหน้าจอ สำเนาที่พิมพ์ หรือการแสดงบัตรประจำตัวบนหน้าจอ อัปโหลดบัตรประจำตัวต้นฉบับที่มองเห็นคุณลักษณะทั้งหมดอย่างชัดเจน"
      },
      SECURITY_FALSE: {
        heading: "ตรวจพบปัญหา!",
        subHeading: "ไม่สามารถยืนยันเอกสารได้ โปรดลองอีกครั้งด้วยภาพที่ชัดเจนขึ้น"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "คุณภาพของภาพไม่ดี!",
        subHeading: "ภาพเบลอหรือไม่ชัดเจนเกินไป โปรดลองอีกครั้งด้วยภาพที่ชัดเจนขึ้น"
      },
      FACE_UNDETECTED: {
        heading: "ตรวจไม่พบใบหน้า",
        subHeading: "เราไม่พบใบหน้าที่มองเห็นได้บนเอกสาร โปรดอัปโหลดบัตรประจำตัวที่ถูกต้องซึ่งมองเห็นใบหน้าได้ชัดเจน"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "การเปรียบเทียบระหว่างเอกสารล้มเหลว",
        subHeading: "การเปรียบเทียบระหว่างเอกสารล้มเหลวเนื่องจากความไม่ตรงกันในฟิลด์สำคัญอย่างน้อยหนึ่งฟิลด์ (ชื่อ วันเกิด หรือใบหน้า)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker ล้มเหลว",
        subHeading: "เกิดข้อผิดพลาดระหว่างการเดินทาง Digilocker โปรดลองอีกครั้งหรือใช้วิธีอื่นเพื่อดำเนินการต่อ"
      },
      LINKAGE_FAILED: {
        heading: "ไม่สามารถดำเนินการตรวจสอบนี้ให้เสร็จสิ้นได้",
        subHeading: "ข้อมูลที่บันทึกไม่ตรงกับบันทึกสำหรับการตรวจสอบนี้"
      }
    },
    biometricConsent: {
      consentStatement: "ก่อนถ่ายเซลฟี่ เราต้องได้รับความยินยอมจากคุณในการเก็บและประมวลผลข้อมูลไบโอเมตริกของคุณ (ภาพใบหน้าและสัญญาณการมีชีวิต) เพื่อยืนยันตัวตนของคุณ ข้อมูลนี้ใช้สำหรับการยืนยันครั้งนี้เท่านั้น",
      privacyPolicy: "นโยบายความเป็นส่วนตัว",
      consentButton: "ฉันยินยอม — ดำเนินการต่อ",
      declineButton: "ฉันไม่ยินยอม",
      confirmTitle: "ดำเนินการต่อโดยไม่มีการยืนยันไบโอเมตริก?",
      confirmBody: "หากไม่มีการยืนยันไบโอเมตริก เราจะไม่ถ่ายเซลฟี่ การยืนยันของคุณจะเสร็จสมบูรณ์โดยใช้ข้อมูลที่คุณให้ไว้แล้ว ตัวเลือกนี้ถือเป็นที่สิ้นสุดสำหรับเซสชันนี้",
      goBack: "ย้อนกลับ",
      confirmDecline: "ยืนยัน — ไม่ยินยอม",
      declineComplete: "คุณเลือกที่จะไม่ดำเนินการยืนยันไบโอเมตริก การยืนยันตัวตนของคุณเสร็จสมบูรณ์แล้วโดยใช้เอกสารที่คุณส่งมา"
    },
    introLiveness: {
      heading: "ยืนยันว่าคุณมีชีวิตอยู่ที่นี่",
      instruction1: "ตรวจสอบให้แน่ใจว่ามีแสงเพียงพอ",
      instruction2: "ให้สิทธิ์การเข้าถึงที่จำเป็น",
      instruction3: "เพียงทำตามคำแนะนำ",
      button: "ดำเนินการต่อ",
      subHeading: "คุณเหลืออีกเพียงขั้นตอนเดียว"
    },
    phoneSession: {
      heading: "เซสชันต่อเนื่องบนโทรศัพท์",
      subheading: "โปรดเปิดหน้าต่างนี้ไว้จนกว่าจะเสร็จสิ้นบนอุปกรณ์มือถือ",
      button: "ดำเนินการต่อที่นี่"
    },
    continueOnPhone: {
      heading: "ดำเนินการต่อบนโทรศัพท์",
      subheading: "สแกน QR หรือคัดลอกลิงก์ด้านล่าง",
      subheading2: "สแกน QR หรือเปิดลิงก์บนโทรศัพท์ของคุณ",
      text: "ดำเนินการให้เสร็จสิ้น",
      text1: "ตรวจสอบอีกครั้งที่นี่เพื่อส่ง",
      button: "คัดลอก",
      copiedButton: "คัดลอกแล้ว!",
      copied: "คัดลอกแล้ว!"
    },
    SsnReview: {
      heading: "ตรวจสอบรายละเอียดของคุณ",
      subHeading: "ทำการแก้ไขที่จำเป็นและส่งรายละเอียด",
      feild1: "ใบขับขี่",
      feild2: "วันหมดอายุ",
      feild3: "วันเกิด",
      feild4: "ประเภท",
      feild5: "ข้อจำกัด",
      feild6: "ประเทศ",
      feild7: "ที่อยู่",
      button: "รายละเอียดถูกต้อง"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "ให้ใบหน้าอยู่ในวงกลม"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "เข้าใกล้กล้องมากขึ้น"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ไม่ต้องเขิน เข้ามาในกรอบ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "มืดเกินไป หาที่สว่างกว่านี้"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "สว่างเกินไป หาแสงที่นุ่มกว่านี้"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ให้ใบหน้าอยู่ในวงกลม"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "อยู่นิ่งๆ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "หันหน้าเข้าหาแสง"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ถือโทรศัพท์ให้อยู่ระดับสายตา"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ถอยห่างจากกล้องเล็กน้อย"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "จัดใบหน้าให้อยู่กลางกรอบ"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "วางใบหน้าของคุณไว้กลางวงกลม"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "เข้าใกล้ขึ้นและหันหน้าตรง"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "เข้ามาในมุมมองและหันหน้าตรง"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "มืดเกินไป ค้นหาแสงที่สว่างกว่า"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "สว่างเกินไป ค้นหาแสงที่เหมาะสม"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ปรับใบหน้าของคุณให้อยู่กลางวงกลม"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "อยู่นิ่งและมองตรงไปข้างหน้า"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "หันหน้าเข้าหาแสงและอยู่นิ่ง"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ถือโทรศัพท์ของคุณที่ระดับสายตา"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ออกห่างจากกล้องเล็กน้อย"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "สมบูรณ์แบบ!"
      },
      smile1: {
        icon: "mood",
        description: "ยิ้มหน่อย คุณดูดีมาก!"
      },
      smile2: {
        icon: "mood",
        description: "ยิ้มให้กล้อง!"
      }
    },
    successful: {
      title: "การยืนยันเสร็จสมบูรณ์",
      text: "คุณสามารถปิดหน้าต่างได้แล้ว",
      finishBtn: "เสร็จสิ้น"
    },
    poweredBy: "ให้บริการโดย",
    redirect: "กำลังเปลี่ยนเส้นทางใน",
    error: {
      message: "URL หมดอายุหรือไม่ถูกต้อง"
    },
    footer: {
      securedBy: "ให้บริการโดย"
    },
    helpFaq: {
      title: "ช่วยเหลือ & คำถามที่พบบ่อย",
      subtitle: "เราพร้อมช่วยเหลือคุณ",
      cameraText: "เพื่อยืนยันตัวตนของคุณ เราจำเป็นต้องถ่ายภาพโดยใช้กล้องของอุปกรณ์คุณ โปรดติดตาม link นี้เพื่อเรียนรู้วิธีการอนุญาตการเข้าถึงที่จำเป็น",
      cameraHeading: "การอนุญาตกล้อง",
      languageText: "ในตอนเริ่มต้นของกระบวนการ คุณสามารถเลือกภาษาที่คุณต้องการจากเมนูดรอปดาวน์ที่แถบด้านบน",
      languageHeading: "การเลือกภาษา",
      kycText: "KYC หรือ 'รู้จักลูกค้าของคุณ' เป็นกระบวนการยืนยันตัวตนของลูกค้าเพื่อให้มั่นใจว่าเป็นไปตามข้อกำหนดและป้องกันการฉ้อโกงและกิจกรรมผิดกฎหมายอื่นๆ",
      kycHeading: "KYC คืออะไร?",
      timeText: "โดยทั่วไปจะใช้เวลาประมาณ 60 วินาที อย่างไรก็ตาม อาจแตกต่างกันไปตามแต่ละประเทศ",
      timeHeading: "จะใช้เวลานานเท่าไร?"
    },
    pdfPreviewUnavailable: "ไม่สามารถแสดงตัวอย่าง PDF ได้",
    pdfPreviewHint: "หากตัวอย่างไม่ปรากฏ คุณยังสามารถดำเนินการต่อได้",
    pdfOpenLabel: "เปิด PDF",
    failedUpload: {
      title: "อัปโหลดไฟล์ล้มเหลว",
      text: "โปรดตรวจสอบว่าไฟล์มีขนาดต่ำกว่า 5MB และอยู่ในรูปแบบ .jpg, .jpeg, .png, .heic, .heif หรือ .pdf",
      btn: "ลองอีกครั้ง",
      pdfNotAllowedIndia: "ไม่อนุญาตให้อัปโหลด PDF สำหรับอินเดีย กรุณาอัปโหลดไฟล์ JPEG, JPG, PNG, HEIC หรือ HEIF ขนาดต่ำกว่า 5 MB",
      pdfNotAllowedIndiaBasic: "ไม่อนุญาตให้อัปโหลด PDF สำหรับอินเดีย กรุณาอัปโหลดไฟล์ JPEG, JPG หรือ PNG ขนาดต่ำกว่า 5 MB"
    },
    livenessAnalyzing: {
      heading: "กำลังวิเคราะห์ใบหน้าของคุณ",
      subHeading: "โปรดรอสักครู่ ใช้เวลาเพียงไม่กี่วินาที"
    },
    sessionExpiredError: {
      heading: "ขออภัย เซสชันของคุณหมดเวลาแล้ว",
      subHeading1: "คุณไม่มีการใช้งานมาสักระยะ ด้วยเหตุผลด้านความปลอดภัย เซสชันของคุณหมดอายุโดยอัตโนมัติ",
      subHeading2: "โปรดลองอีกครั้ง",
      buttonText: "ลองอีกครั้ง"
    },
    journeyExpiredError: {
      heading: "ขออภัย ลิงก์หมดอายุแล้ว",
      subHeading1: "ลิงก์ไม่ทำงานอีกต่อไป ด้วยเหตุผลด้านความปลอดภัย ลิงก์มีอายุการใช้งานจำกัด",
      subHeading2: "โปรดลองด้วยลิงก์ใหม่",
      buttonText: "ลองอีกครั้ง"
    },
    cameraAccessError: {
      alert1: "การเข้าถึงกล้องถูกปฏิเสธ โปรดเปิดใช้งานการเข้าถึงกล้องในการตั้งค่าเบราว์เซอร์ของคุณ",
      alert2: "เกิดข้อผิดพลาดขณะเข้าถึงกล้อง",
      alert3: "เบราว์เซอร์ของคุณไม่รองรับการเข้าถึงกล้อง"
    },
    activeLiveness: {
      instruction: "ให้ใบหน้าของคุณอยู่ในวงกลมและทำตามคำแนะนำ",
      permissionDeniedTitle: "การเข้าถึงกล้องหรือไมโครโฟนถูกปฏิเสธ",
      permissionDeniedSubtitle: "โปรดอนุญาตการเข้าถึงกล้องและไมโครโฟนในการตั้งค่าเบราว์เซอร์ของคุณแล้วลองอีกครั้ง"
    },
    flipScreen: {
      heading: "ตอนนี้พลิกบัตรประจำตัวของคุณ",
      subHeading: "โปรดพลิกบัตรประจำตัวของคุณจริง ๆ เพื่อแสดงด้านหลัง จากนั้นวางไว้ในกรอบกล้อง",
      continueButton: "ดำเนินการต่อ"
    },
    mobileDocCapture: {
      frontSide: "ด้านหน้า",
      backSide: "ด้านหลัง",
      of: "ของ",
      upload: "อัปโหลด",
      stillNotWorking: "ยังไม่ทำงานใช่ไหม?",
      clickToCapture: "ลองคลิกเพื่อถ่าย",
      skip: "ข้าม"
    }
,
    permissionPopUp: {
      title: "ต้องการสิทธิ์",
      subtitle: "อนุญาตการเข้าถึงเพื่อใช้กล้อง",
      decline: "ปฏิเสธ",
      allow: "อนุญาต"
    },
    userDetails: {
      heading: "การยืนยัน PAN",
      subHeading: "โปรดกรอกรายละเอียดเพื่อยืนยัน",
      panLabel: "หมายเลข PAN",
      panRequired: "โปรดป้อนหมายเลข PAN ของคุณ",
      saveError: "เกิดข้อผิดพลาดขณะบันทึกรายละเอียด โปรดลองอีกครั้ง",
      proceed: "ดำเนินการต่อ"
    },
    redirectCta: {
      or: "หรือ",
      clickHere: "คลิกที่นี่",
      clickHereStart: "คลิกที่นี่",
      toContinue: "เพื่อดำเนินการต่อ"
    },
    documentCapture: {
      stillNotWorking: "ยังใช้งานไม่ได้?",
      clickToCaptureInstead: "ลองคลิกเพื่อถ่ายแทน",
      pdfNotAllowedIndia: "ไม่อนุญาตให้อัปโหลด PDF สำหรับอินเดีย โปรดอัปโหลดไฟล์ JPEG, JPG หรือ PNG ที่มีขนาดต่ำกว่า 5 MB",
      pdfNotAllowedIndiaMobile: "ไม่อนุญาตให้อัปโหลด PDF สำหรับอินเดีย โปรดอัปโหลดไฟล์ JPEG, JPG, PNG, HEIC หรือ HEIF ที่มีขนาดต่ำกว่า 5 MB",
      fileFormatsIndia: "jpeg, jpg, png ต่ำกว่า 5 mb",
      fileFormats: "jpeg, jpg, png, pdf ต่ำกว่า 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif ต่ำกว่า 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf ต่ำกว่า 5 mb"
    },
    mobileCapture: {
      upload: "อัปโหลด",
      skip: "ข้าม",
      stillNotWorking: "ยังใช้งานไม่ได้?",
      tryClickToCapture: "แตะเพื่อถ่ายภาพ"
    },
    UserDetails: {
      panLabel: "หมายเลข PAN",
      proceedBtn: "ดำเนินการต่อ",
      panRequired: "กรุณากรอกหมายเลข PAN ของคุณ",
      saveError: "เกิดข้อผิดพลาดขณะบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง"
    }
  },
  gu: {
    supportingDocument: {
      headingFallback: "સહાયક દસ્તાવેજ",
      subHeading: "નીચે દસ્તાવેજ અપલોડ કરો. તે સમીક્ષા માટે સંગ્રહિત થાય છે — તેમાંથી કંઈ કાઢવામાં આવતું નથી.",
      choosePlaceholder: "ફાઇલ પસંદ કરો (PNG, JPG અથવા PDF)",
      continue: "ચાલુ રાખો",
      uploading: "અપલોડ થઈ રહ્યું છે...",
      skip: "હમણાં માટે છોડો",
      errorInvalidType: "PNG, JPG અથવા PDF ફાઇલ અપલોડ કરો.",
      errorTooLarge: "ફાઇલ ખૂબ મોટી છે. મર્યાદા 10MB છે.",
      errorRead: "તે ફાઇલ વાંચી શકાઈ નથી. કૃપા કરીને બીજી અજમાવો.",
      errorNoFile: "કૃપા કરીને અપલોડ કરવા માટે ફાઇલ પસંદ કરો.",
    },
    header: {
      title: "આપની ઓળખ ચકાસો",
      subtitle: "આમાં 2 મિનિટથી ઓછો સમય લાગે છે",
      havingIssue: "સમસ્યા છે?"
    },
    onlyIdVerificationHeader: {
      title: "ચાલો તમારા ઓળખપત્રની ચકાસણી કરીએ",
      subtitle: "આમાં માત્ર એક મિનિટ લાગશે. તમારો ઓળખપત્ર તૈયાર રાખો",
      instruction1: "કેમેરા એક્સેસ મંજૂર કરો",
      instruction2: "ડૉક્યુમેન્ટ સ્કેન કરો અથવા અપલોડ કરો",
      instruction3: "તાત્કાલિક ડૉક્યુમેન્ટ ચકાસણી"
    },
    subHeading: {
      subHeading1: "તમારો ઓળખ પ્રમાણપત્ર પકડી રાખો",
      subHeading2: "ચકાસો કે તમે જીવિત છો",
      livenessHeading1: "સારી લાઇટિંગવાળી જગ્યા શોધો",
      livenessHeading2: "તમારો ચહેરો મધ્યમાં રાખો"
    },
    termsAndCondition: {
      title: "હું નીચેના નિયમો અને શરતોને સંમત થઈને અનુસરીશ.",
      privacyPolicy: "નિયમો જુઓ",
      beginBtnText: "શરૂ કરો",
      beginLiveness: "લાઇવનેસ ચકાસણી શરૂ",
      startLiveness: "લાઇવનેસ ચકાસણી પર જાઓ"
    },
    permissionDenied: {
      title: "કેમેરા ઍક્સેસ નકારી દેવામાં આવ્યો!",
      subtitle: "બ્રાઉઝરની ઍડ્રેસ બાર નજીક બ્લોક થયેલા કેમેરા آئકોન માટે તપાસ કરો અને તેને અનબ્લોક કરો.",
      readMore: "વધુ વાંચો",
      refreshText: "જ્યારે કેમેરા ઍક્સેસની મંજૂરી આપવામાં આવી હોય, ત્યારે નીચે આપેલ રિફ્રેશ બટન પર ક્લિક કરો.",
      refreshBtn: "રિફ્રેશ કરો",
      link: "અથવા, ફોન પર ચાલુ રાખો",
      buttonText: "અથવા, ફોન પર ચાલુ રાખો"
    },
    desktopBrowserPermissionDenied: {
      title: "કૃપા કરીને કેમેરા ઍક્સેસની મંજૂરી આપો",
      subtitle: "બ્રાઉઝર મંજૂરી માટે પૂછે શકે છે. આગળ વધવા માટે 'મંજૂરી આપો' ક્લિક કરો.",
      readMore: "વધુ વાંચો",
      refreshText: "મંજૂરી આપ્યા પછી રિફ્રેશ કરો",
      refreshBtn: "રિફ્રેશ કરો",
      link: "અથવા, ફોન પર ચાલુ રાખો",
      buttonText: "અથવા, ફોન પર ચાલુ રાખો"
    },
    androidBrowserPermissionDenied: {
      title: "કેમેરા ઍક્સેસ નકારી દેવામાં આવ્યો!",
      subtitle: "બ્રાઉઝરનું ઍડ્રેસ બાર નજીક બ્લૉક થયેલ કેમેરા 아이કન શોધો અને ઍક્સેસને અનબ્લૉક કરો.",
      readMore: "વધુ જાણો",
      refreshText: "કેમેરાની ઍક્સેસ મંજૂર થયા પછી, નીચેના રિફ્રેશ બટન પર ક્લિક કરો.",
      refreshBtn: "રિફ્રેશ કરો",
      link: "અથવા, ફોન પર ચાલુ રાખો",
      buttonText: "અથવા, ફોન પર ચાલુ રાખો"
    },
    androidWebViewPermissionDenied: {
      title: "કેમેરા ઍક્સેસ નકારી દેવામાં આવ્યો!",
      subtitle: "ઍપ સેટિંગ્સ દ્વારા કેમેરા ઍક્સેસ બ્લૉક થયેલો હોઈ શકે છે. કૃપા કરીને તમારા ફોનની App Info > Permissions > Cameraમાં જઈને ઍક્સેસ મંજૂર કરો.",
      refreshText: "કેમેરાની ઍક્સેસ મંજૂર થયા પછી, નીચેના રિફ્રેશ બટન પર ક્લિક કરો.",
      refreshBtn: "રિફ્રેશ કરો",
      link: "અથવા, ફોન પર ચાલુ રાખો",
      buttonText: "અથવા, ફોન પર ચાલુ રાખો"
    },
    iosBrowserPermissionDenied: {
      title: "કેમેરા ઍક્સેસ નકારી દેવામાં આવ્યો!",
      subtitle: "ઍડ્રેસ બાર પાસે કેમેરા અથવા તાળું 아이કન પર ટૅપ કરો અથવા બ્રાઉઝર સેટિંગ્સ તપાસો.",
      readMore: "વધુ જાણો",
      refreshText: "કેમેરાની ઍક્સેસ મંજૂર થયા પછી, નીચેના રિફ્રેશ બટન પર ક્લિક કરો.",
      refreshBtn: "રિફ્રેશ કરો",
      link: "અથવા, ફોન પર ચાલુ રાખો",
      buttonText: "અથવા, ફોન પર ચાલુ રાખો"
    },
    iosWebViewPermissionDenied: {
      title: "કેમેરા ઍક્સેસ નકારી દેવામાં આવ્યો!",
      subtitle: "ઍપ સેટિંગ્સ દ્વારા કેમેરા ઍક્સેસ બંધ થયેલો હોઈ શકે છે. Settings > તમારું ઍપ પસંદ કરો > Camera Permission ચાલુ કરો.",
      refreshText: "કેમેરાની ઍક્સેસ મંજૂર થયા પછી, નીચેના રિફ્રેશ બટન પર ક્લિક કરો.",
      refreshBtn: "રિફ્રેશ કરો",
      link: "અથવા, ફોન પર ચાલુ રાખો",
      buttonText: "અથવા, ફોન પર ચાલુ રાખો"
    },
    documentationList: {
      countryHeading: "દેશ પસંદ કરો",
      docHeading: "તમારો દસ્તાવેજ પસંદ કરો",
      btnText: "આગળ",
      searchCountry: "દેશ શોધો"
    },
    frontDocCapture: {
      heading: "આઈડીનો આગળનો ભાગ ચતુરસ્રમાં મૂકો",
      backupHeading: "કંઇક સમસ્યા છે? કૃપા કરીને મેન્યુઅલી છબી પર ક્લિક કરો",
      btnText: "ફોટો પાડો",
      headingBack: " લંબચોરસમાં",
      uploadButton: "અથવા, આઈડી અપલોડ કરો"
    },
    backDocCapture: {
      heading: "આઈડીનો પાછળનો ભાગ ચતુરસ્રમાં મૂકો",
      backupHeading: "કંઇક સમસ્યા છે? કૃપા કરીને મેન્યુઅલી છબી પર ક્લિક કરો",
      btnText: "ફોટો પાડો",
      containerText: "અથવા, દસ્તાવેજ અપલોડ કરો",
      text: "કૅપ્ચર કરવું છે, સ્થિર રહો",
      headingBack: " લંબચોરસમાં",
      skipButton: "પાછળની બાજુ છોડો",
      uploadButton: "અથવા, આઈડી અપલોડ કરો"
    },
    analyzing: {
      heading: "તમારી આઈડીનું વિશ્લેષણ કરી રહ્યું છે...",
      subHeading: "કૃપા કરીને આગામી સ્ક્રીન પર તમારા કાર્ડના વિગત ચકાસો અને જરૂરી હોય તો સંપાદિત કરો"
    },
    imageCheck: {
      heading: "તમારી છબી ચકાસો",
      subHeading: "કૃપા કરીને ખાતરી કરો કે છબી પૂર્ણ, સ્પષ્ટ અને ધૂંધળી કે ચમક વગર છે.",
      button1: "ફોટો ફરીથી લો",
      button2: "બરાબર છે",
      frontHeading: "સામનાની છબી ચકાસો",
      backHeading: "પછાડીની છબી ચકાસો"
    },
    errorHandler: {
      heading: "અરે રે :(",
      subHeading1: "અમને કેટલીક સમસ્યાઓ આવી રહી છે, પરંતુ ચિંતા ન કરો! કૃપા કરીને ફરી પ્રયાસ કરો",
      subHeading2: "જો આ ચાલુ રહે તો, પછીથી ચકાસો",
      button: "ફરી પ્રયાસ કરો"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "કૃપા કરીને તમારા ચહેરાને ઢાંકતા કંઈ પણ હટાવો",
        button: "ફરીથી પ્રયાસ કરો"
      },
      eyeClosureDetected: {
        heading: "કૃપા કરીને તમારી આંખો ખુલ્લી રાખો અને સીધા કેમેરામાં જુઓ",
        button: "ફરી પ્રયાસ કરો"
      },
      isMultipleFacesFound: {
        heading: "એકથી વધુ ચહેરા શોધાયા છે. ખાતરી કરો કે કેમેરામાં ફક્ત તમારું ચહેરું જ દેખાય.",
        button: "ફરીથી પ્રયાસ કરો"
      },
      noFacesFound: {
        heading: "કોઈ ચહેરો મળ્યો નથી. કૃપા કરીને ખાતરી કરો કે તમારો ચહેરો કેમેરામાં દેખાય છે.",
        button: "ફરી પ્રયાસ કરો"
      },
      faceDetections: {
        heading: "કૃપા કરીને આને હટાવો",
        button: "ફરીથી પ્રયાસ કરો"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "બહુત સવારાઓ શોધી કાઢી છે",
          button: "ફરીથી પ્રયાસ કરો"
        },
        generalMessage: {
          heading: "કૃપા કરીને ખાતરી કરો કે તમે કેમેરા સામે જીવંત છો",
          button: "ફરીથી પ્રયાસ કરો"
        }
      },
      faceMatch: {
        heading: "તમારો ચહેરો આઈડી ફોટો સાથે મેળ ખાતો નથી",
        button: "ફરીથી પ્રયાસ કરો"
      },
      selfieError: {
        heading: "અમે તમારા સેલ્ફી ચકાસી શક્યા નથી",
        subHeading1: "આ સૂચનોને અનુસરો અને ફરીથી પ્રયાસ કરો",
        instruction1: "અચ્છી પ્રકાશના ક્ષેત્રમાં જાઓ અને પછડાવાવાળી પ્રકાશ ટાળો",
        instruction2: "તમારો ચહેરો પૂર્ણ રીતે દેખાય તે સુનિશ્ચિત કરો અને ફ્રેમના કેન્દ્રમાં રાખો",
        instruction3: "તમારા ચહેરાને સ્પષ્ટ રીતે જોવા માટે ટોપી, ચશ્મા અથવા માસ્ક હટાવો",
        button: "ફરીથી પ્રયાસ કરો"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP મેળ ખાતો નથી. કૃપા કરીને OTP સ્પષ્ટ રીતે મોટેથી વાંચો",
        button: "ફરી પ્રયાસ કરો"
      },
      activeLivenessGenericFailureMessage: {
        heading: "ચકાસણી નિષ્ફળ ગઈ. કૃપા કરીને સૂચનાઓનું સ્પષ્ટ રીતે પાલન કરો અને ફરી પ્રયાસ કરો",
        button: "ફરીથી પ્રયાસ કરો"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF માં ઘણા બધા પાના છે",
        subHeading: "અપલોડ કરેલી PDF 2-પાનાની મર્યાદા વટાવે છે. કૃપા કરીને 2 થી વધુ પાના ન હોય તેવી PDF, અથવા તમારા IDની સ્પષ્ટ છબી અપલોડ કરો."
      },
      heading: "અમે તમારી આઈડી પ્રક્રિયા કરવામાં અસમર્થ છીએ",
      subHeading: "તમે ગલત આઈડી અપલોડ કરી રહ્યા છો અથવા છબી સ્પષ્ટ નથી",
      buttonBack: "આઈડીનો પાછળનો ભાગ ફરીથી પ્રયાસ કરો",
      buttonFront: "આઈડીનો આગળનો ભાગ ફરીથી પ્રયાસ કરો",
      button: "ફરી પ્રયાસ કરો",
      captureFrontSide: "આગળની બાજુ કૅપ્ચર કરો",
      captureBackSide: "પાછળની બાજુ કૅપ્ચર કરો",
      changeIDButton: "બીજો દસ્તાવેજ પસંદ કરો",
      wrongid: {
        heading: "અમે આ દસ્તાવેજ પ્રક્રિયા કરી શક્યા નહીં",
        subHeading: "કૃપા કરીને ખાતરી કરો કે તમે યોગ્ય દસ્તાવેજ અપલોડ કરી રહ્યા છો અને ચિત્રની ગુણવત્તા સ્પષ્ટ છે"
      },
      expiredid: {
        heading: "ઓળખ દસ્તાવેજ સમાપ્ત થયો!",
        subHeading: "અમે સમાપ્ત થયેલ ઓળખ દસ્તાવેજ સ્વીકારી શકતા નથી. કૃપા કરીને માન્ય દસ્તાવેજ આપો"
      },
      minimumage: {
        heading: "ઉંમરની જરૂરિયાત પૂરી થઈ નથી!",
        subHeading: "તમારી ઉંમર લઘુત્તમ જરૂરી ઉંમર કરતાં ઓછી છે. કૃપા કરીને ખાતરી કરો કે તમે લઘુત્તમ ઉંમરના માપદંડને પૂર્ણ કરો છો"
      },
      mobileAttemptsDone: {
        heading: "તમારા અગાઉના ઉપકરણ પર યાત્રા ફરી શરૂ થઈ",
        subHeading: "ડુપ્લિકેશન ટાળવા માટે આ સત્ર હવે બંધ કરવામાં આવ્યું છે."
      },
      finished: {
        heading: "યાત્રા સમાપ્ત થઈ ગઈ છે",
        subHeading: "યાત્રા કાં તો પૂર્ણ થઈ છે અથવા સમાપ્ત થઈ છે"
      },
      invalid: {
        heading: "યાત્રા ઉપલબ્ધ નથી !",
        subHeading: "કોઈ journeyId મળ્યું નથી અથવા યાત્રા ID અમાન્ય છે"
      },
      INVALID_PAN_NUMBER: {
        heading: "અમાન્ય PAN નંબર",
        subHeading: "તમે દાખલ કરેલ PAN નંબર માન્ય નથી. કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો"
      },
      INVALID_PAN_STATUS: {
        heading: "અમાન્ય PAN સ્થિતિ",
        subHeading: "તમે દાખલ કરેલ PAN નંબર માન્ય નથી. કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો"
      },
      directKyc: {
        heading: "સીધી KYC યાત્રા !",
        subHeading: "આ એક સીધી KYC યાત્રા છે. ફ્રન્ટએન્ડ યાત્રાની મંજૂરી નથી."
      },
      DOCTYPE_FALSE: {
        heading: "ખોટો દસ્તાવેજ આપ્યો!",
        subHeading: "કૃપા કરીને માન્ય દસ્તાવેજ અપલોડ કરો અને ખાતરી કરો કે છબીની ગુણવત્તા સારી છે."
      },
      ONLY_FRONT: {
        heading: "ઓળખપત્રની પાછળની બાજુ ખૂટે છે",
        subHeading: "તમે ફક્ત આગળની બાજુ આપી. કૃપા કરીને તમારું ઓળખપત્ર ફેરવો અને આગળ વધવા માટે પાછળની બાજુ આપો"
      },
      ONLY_BACK: {
        heading: "ઓળખપત્રની આગળની બાજુ ખૂટે છે",
        subHeading: "તમે ફક્ત પાછળની બાજુ આપી. કૃપા કરીને તમારું ઓળખપત્ર ફેરવો અને આગળ વધવા માટે આગળની બાજુ આપો"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "દસ્તાવેજ ટૂંક સમયમાં સમાપ્ત થશે",
        subHeading: "દસ્તાવેજ ટૂંક સમયમાં સમાપ્ત થશે તેથી નકારવામાં આવ્યો છે."
      },
      DOCUMENT_EXPIRED: {
        heading: "દસ્તાવેજ સમાપ્ત થઈ ગયો!",
        subHeading: "કૃપા કરીને આગળ વધવા માટે માન્ય, સમાપ્ત ન થયેલ દસ્તાવેજ અપલોડ કરો."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "ઉંમરની જરૂરિયાત પૂરી થઈ નથી!",
        subHeading: "દસ્તાવેજ સૂચવે છે કે તમે જરૂરી ઉંમર પૂરી કરતા નથી. કૃપા કરીને માન્ય દસ્તાવેજ અપલોડ કરો."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "દસ્તાવેજ ચકાસી શકાયો નહીં!",
        subHeading: "ચકાસણી માટે છબીની ગુણવત્તા ખૂબ જ ખરાબ છે. કૃપા કરીને વધુ સ્પષ્ટ છબી સાથે ફરી પ્રયાસ કરો."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "દસ્તાવેજ ચકાસી શકાયો નહીં!",
        subHeading: "કેટલીક માહિતી ચકાસી શકાઈ નહીં. કૃપા કરીને વધુ સ્પષ્ટ છબી સાથે ફરી પ્રયાસ કરો."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "દસ્તાવેજ ચકાસી શકાયો નહીં!",
        subHeading: "ખરાબ છબી ગુણવત્તાને કારણે કેટલીક વિગતો ચકાસી શકાઈ નહીં. કૃપા કરીને વધુ સ્પષ્ટ છબી સાથે ફરી પ્રયાસ કરો"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "દસ્તાવેજ ચકાસી શકાયો નહીં!",
        subHeading: "કેટલીક વિગતો ચકાસી શકાઈ નહીં. કૃપા કરીને વધુ સ્પષ્ટ છબી સાથે ફરી પ્રયાસ કરો."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "ઓળખપત્ર પરનો તમારો ફોટો ચકાસવામાં સમસ્યા",
        subHeading: "અમે ઓળખપત્ર પરનો તમારો ફોટો ચકાસી શક્યા નહીં. કૃપા કરીને તમારા મૂળ ઓળખપત્રનો સ્પષ્ટ ફોટો અપલોડ કરો જેથી અમે તેની ખાતરી કરી શકીએ."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "દસ્તાવેજ સુરક્ષા પેટર્ન તપાસ નિષ્ફળ",
        subHeading: "અમે દસ્તાવેજની બિલ્ટ-ઇન સુરક્ષા પેટર્ન ચકાસી શક્યા નહીં. કૃપા કરીને તેની અધિકૃતતાની ખાતરી કરવામાં મદદ કરવા માટે મૂળ ઓળખપત્રનો સ્પષ્ટ ફોટો અપલોડ કરો."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "દસ્તાવેજ સજીવતા તપાસ નિષ્ફળ",
        subHeading: "અમને સંકેતો મળ્યા કે દસ્તાવેજ અસલી ન હોઈ શકે. કૃપા કરીને સ્ક્રીનશોટ, છાપેલી નકલો અથવા સ્ક્રીન પર ઓળખપત્ર બતાવવાનું ટાળો. બધી વિશેષતાઓ સ્પષ્ટ દેખાય તેવું મૂળ ઓળખપત્ર અપલોડ કરો"
      },
      SECURITY_FALSE: {
        heading: "સમસ્યા મળી!",
        subHeading: "દસ્તાવેજ ચકાસી શકાયો નહીં. કૃપા કરીને વધુ સ્પષ્ટ છબી સાથે ફરી પ્રયાસ કરો"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "ખરાબ છબી ગુણવત્તા!",
        subHeading: "છબી ખૂબ જ ધૂંધળી અથવા અસ્પષ્ટ છે. કૃપા કરીને વધુ સ્પષ્ટ છબી સાથે ફરી પ્રયાસ કરો"
      },
      FACE_UNDETECTED: {
        heading: "ચહેરો મળ્યો નથી",
        subHeading: "અમને દસ્તાવેજ પર દૃશ્યમાન ચહેરો મળ્યો નહીં. કૃપા કરીને ચહેરો સ્પષ્ટ દેખાય તેવું માન્ય ઓળખપત્ર અપલોડ કરો"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "દસ્તાવેજો વચ્ચે સરખામણી નિષ્ફળ",
        subHeading: "એક અથવા વધુ મુખ્ય ક્ષેત્રો (નામ, જન્મ તારીખ અથવા ચહેરો) માં મેળ ન ખાવાને કારણે દસ્તાવેજો વચ્ચે સરખામણી નિષ્ફળ ગઈ"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker નિષ્ફળતા",
        subHeading: "Digilocker યાત્રા દરમિયાન ભૂલ આવી. કૃપા કરીને ફરી પ્રયાસ કરો અથવા આગળ વધવા માટે વૈકલ્પિક પદ્ધતિ વાપરો."
      },
      LINKAGE_FAILED: {
        heading: "આ ચકાસણી પૂર્ણ કરી શકાઈ નથી",
        subHeading: "આ ચકાસણી માટે મેળવેલી વિગતો રેકોર્ડ સાથે મેળ ખાતી નથી."
      }
    },
    biometricConsent: {
      consentStatement: "તમારી સેલ્ફી પહેલાં, તમારી ઓળખ ચકાસવા માટે અમને તમારો બાયોમેટ્રિક ડેટા (ચહેરાની છબી અને લાઇવનેસ સિગ્નલ) કેપ્ચર અને પ્રોસેસ કરવાની તમારી સંમતિ જરૂરી છે. આ ડેટાનો ઉપયોગ ફક્ત આ ચકાસણી માટે જ થાય છે.",
      privacyPolicy: "ગોપનીયતા નીતિ",
      consentButton: "હું સંમત છું — ચાલુ રાખો",
      declineButton: "હું સંમત નથી",
      confirmTitle: "બાયોમેટ્રિક ચકાસણી વિના આગળ વધવું?",
      confirmBody: "બાયોમેટ્રિક ચકાસણી વિના, અમે સેલ્ફી લઈશું નહીં. તમે પહેલેથી આપેલી માહિતીનો ઉપયોગ કરીને તમારી ચકાસણી પૂર્ણ કરવામાં આવશે. આ પસંદગી આ સત્ર માટે અંતિમ છે.",
      goBack: "પાછા જાઓ",
      confirmDecline: "પુષ્ટિ કરો — સંમત નથી",
      declineComplete: "તમે બાયોમેટ્રિક ચકાસણી સાથે આગળ ન વધવાનું પસંદ કર્યું છે. તમે સબમિટ કરેલા દસ્તાવેજોનો ઉપયોગ કરીને તમારી ઓળખ ચકાસણી પૂર્ણ થઈ ગઈ છે."
    },
    introLiveness: {
      heading: "અહીં તમે જીવિત છો તે ચકાસો",
      instruction1: "ખાતરી કરો કે પૂરતી લાઇટ છે",
      instruction2: "જરૂરી મંજૂરીઓ આપો",
      instruction3: "માત્ર સૂચનો અનુસરો",
      button: "આગળ વધો",
      subHeading: "તમે ફક્ત એક પગલું દૂર છો"
    },
    phoneSession: {
      heading: "સત્ર ફોન પર ચાલુ છે",
      subheading: "મોબાઇલ પર પૂરું થાય ત્યાં સુધી આ વિંડોને ખોલી રાખો",
      button: "અહીં ચાલુ રાખો"
    },
    continueOnPhone: {
      heading: "ફોન પર ચાલુ રાખો",
      subheading: "QR સ્કેન કરો અથવા નીચે આપેલા લિંકને નકલ કરો",
      subheading2: "QR સ્કેન કરો અથવા લિંક તમારા ફોન પર ખોલો",
      text: "પ્રક્રિયા પૂર્ણ કરો",
      text1: "સબમિટ કરવા માટે અહીં ફરીથી ચકાસો",
      button: "નકલ કરો",
      copiedButton: "કૉપિ થયું!",
      copied: "કૉપિ થયું!"
    },
    SsnReview: {
      heading: "તમારા વિગતોની સમીક્ષા કરો",
      subHeading: "જરૂરી ફેરફાર કરો અને વિગતો સબમિટ કરો",
      feild1: "ડ્રાઇવિંગ લાયસન્સ",
      feild2: "સમાપ્ત",
      feild3: "જન્મતારીખ",
      feild4: "વર્ગ",
      feild5: "પ્રતિબંધ",
      feild6: "દેશ",
      feild7: "સરનામું",
      button: "વિગતો સાચી છે"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "તમારો ચહેરો વર્તુળમાં રાખો"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "કૅમેરાની નજીક આવો"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "શરમાશો નહીં, સામે આવો"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ખૂબ અંધારું છે. વધુ પ્રકાશમાં જાઓ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ખૂબ પ્રકાશ છે. નરમ પ્રકાશમાં જાઓ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "તમારો ચહેરો વર્તુળમાં રાખો"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "સ્થિર રહો"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ચહેરો પ્રકાશ તરફ ફેરવો"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ફોન આંખના સ્તરે રાખો"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "કૅમેરાથી થોડા દૂર જાઓ"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "તમારો ચહેરો ફ્રેમની મધ્યમાં રાખો"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "તમારો ચહેરો વર્તુળની મધ્યમાં રાખો"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "નજીક આવો અને ચહેરો સીધો રાખો"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "દ્રશ્યમાં આવો અને ચહેરો સીધો રાખો"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ખૂબ અંધારું છે. વધુ પ્રકાશિત લાઇટ શોધો"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ખૂબ તેજ છે. યોગ્ય લાઇટ શોધો"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "તમારો ચહેરો વર્તુળની મધ્યમાં ગોઠવો"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "સ્થિર રહો અને સીધા આગળ જુઓ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "પ્રકાશ તરફ મુખ કરો અને સ્થિર રહો"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "તમારા ફોનને આંખની ઊંચાઇ પર રાખો"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "કૅમેરાથી થોડી દૂર થાઓ"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "પરફેક્ટ!"
      },
      smile1: {
        icon: "mood",
        description: "સ્મિત કરો, તમે ખૂબ જ સરસ લાગો છો!"
      },
      smile2: {
        icon: "mood",
        description: "કૅમેરા માટે સ્મિત કરો!"
      }
    },
    successful: {
      title: "સત્યાપન પૂર્ણ થયું",
      text: "તમે હવે વિંડો બંધ કરી શકો છો",
      finishBtn: "પૂરૂં કરો"
    },
    poweredBy: "પ્રદાન કરેલું",
    redirect: "ફરીદિશા માં",
    error: {
      message: "URL ની સમયમર્યાદા પૂરી થઇ છે અથવા અમાન્ય છે"
    },
    footer: {
      securedBy: "પ્રદાન કરેલું"
    },
    helpFaq: {
      title: "મદદ & વારંવાર પૂછાતા પ્રશ્નો",
      subtitle: "અમે તમારી મદદ કરવા અહીં છીએ",
      cameraText: "તમારી ઓળખની પુષ્ટિ કરવા માટે, અમને તમારા ડિવાઇસની કેમેરા નો ઉપયોગ કરીને ચિત્રો ખીંચવાની જરૂર પડશે. જરૂરી અનુમતિઓ કેવી રીતે આપવી તે જાણવા માટે આ link ને અનુસરો",
      cameraHeading: "કેમેરા અનુમતિ",
      languageText: "પ્રક્રિયા ની શરૂઆતમાં, તમે ઉપરના મેનૂમાંથી તમારું પસંદ કરેલ ભાષા પસંદ કરી શકો છો",
      languageHeading: "ભાષા પસંદગી",
      kycText: "KYC અથવા 'તમારા ગ્રાહકને ઓળખો', એ એક પ્રક્રિયા છે જે ગ્રાહકની ઓળખને ચકાસે છે, આ પ્રક્રિયા અનુમતિ સુનિશ્ચિત કરવા અને ઠગીઓ અને અન્ય ગેરકાયદેસર પ્રવૃત્તિઓને રોકવા માટે મદદરૂપ છે",
      kycHeading: "KYC શું છે?",
      timeText: "સામાન્ય રીતે, આમાં લગભગ 60 સેકંડ લાગશે. જો કે, આ દેશોના આધાર પર ફેરફાર થઈ શકે છે",
      timeHeading: "આમાં કેટલો સમય લાગશે?"
    },
    pdfPreviewUnavailable: "PDF નું પૂર્વાવલોકન બતાવી શકાતું નથી.",
    pdfPreviewHint: "જો પૂર્વાવલોકન દેખાય નહીં, તો પણ તમે આગળ વધી શકો છો.",
    pdfOpenLabel: "PDF ખોલો",
    failedUpload: {
      title: "ફાઇલ અપલોડ નિષ્ફળ",
      text: "કૃપા કરીને ખાતરી કરો કે ફાઇલ 5MB કરતાં ઓછી અને .jpg, .jpeg, .png, .heic, .heif અથવા .pdf ફોર્મેટમાં છે",
      btn: "ફરી પ્રયાસ કરો",
      pdfNotAllowedIndia: "ભારત માટે PDF અપલોડ કરવાની મંજૂરી નથી. કૃપા કરીને 5 MB કરતાં ઓછી JPEG, JPG, PNG, HEIC, અથવા HEIF ફાઇલો અપલોડ કરો.",
      pdfNotAllowedIndiaBasic: "ભારત માટે PDF અપલોડ કરવાની મંજૂરી નથી. કૃપા કરીને 5 MB કરતાં ઓછી JPEG, JPG, અથવા PNG ફાઇલો અપલોડ કરો."
    },
    livenessAnalyzing: {
      heading: "તમારા ચહેરાનું વિશ્લેષણ થઈ રહ્યું છે",
      subHeading: "કૃપા કરીને રાહ જુઓ, આમાં ફક્ત થોડી સેકન્ડ લાગશે"
    },
    sessionExpiredError: {
      heading: "માફ કરશો, તમારું સત્ર સમય સમાપ્ત થયું",
      subHeading1: "તમે થોડા સમયથી નિષ્ક્રિય હતા. સુરક્ષાના કારણોસર, તમારું સત્ર આપમેળે સમાપ્ત થઈ ગયું",
      subHeading2: "કૃપા કરીને ફરી પ્રયાસ કરો",
      buttonText: "ફરી પ્રયાસ કરો"
    },
    journeyExpiredError: {
      heading: "માફ કરશો, લિંક સમાપ્ત થઈ ગઈ",
      subHeading1: "લિંક હવે સક્રિય નથી. સુરક્ષાના કારણોસર, લિંકનું આયુષ્ય મર્યાદિત હોય છે",
      subHeading2: "કૃપા કરીને નવી લિંક સાથે પ્રયાસ કરો",
      buttonText: "ફરી પ્રયાસ કરો"
    },
    cameraAccessError: {
      alert1: "કૅમેરા ઍક્સેસ નકારવામાં આવ્યો. કૃપા કરીને તમારી બ્રાઉઝર સેટિંગ્સમાં કૅમેરા ઍક્સેસ સક્ષમ કરો",
      alert2: "કૅમેરા ઍક્સેસ કરતી વખતે ભૂલ આવી",
      alert3: "તમારું બ્રાઉઝર કૅમેરા ઍક્સેસને સમર્થન આપતું નથી"
    },
    activeLiveness: {
      instruction: "તમારો ચહેરો વર્તુળમાં રાખો અને સૂચનાઓનું પાલન કરો",
      permissionDeniedTitle: "કૅમેરા અથવા માઇક્રોફોન ઍક્સેસ નકારી",
      permissionDeniedSubtitle: "કૃપા કરીને તમારી બ્રાઉઝર સેટિંગ્સમાં કૅમેરા અને માઇક્રોફોન ઍક્સેસની મંજૂરી આપો અને ફરી પ્રયાસ કરો."
    },
    flipScreen: {
      heading: "હવે તમારું આઈડી કાર્ડ ફેરવો",
      subHeading: "કૃપા કરીને પાછળની બાજુ બતાવવા માટે તમારું આઈડી કાર્ડ ભૌતિક રીતે ફેરવો, પછી તેને કેમેરા ફ્રેમમાં ગોઠવો.",
      continueButton: "ચાલુ રાખો"
    },
    mobileDocCapture: {
      frontSide: "આગળની બાજુ",
      backSide: "પાછળની બાજુ",
      of: "ની",
      upload: "અપલોડ કરો",
      stillNotWorking: "હજુ પણ કામ નથી કરતું?",
      clickToCapture: "ક્લિક-ટુ-કૅપ્ચર અજમાવો",
      skip: "છોડો"
    }
,
    permissionPopUp: {
      title: "પરવાનગી જરૂરી છે",
      subtitle: "કૅમેરા વાપરવા માટે ઍક્સેસની પરવાનગી આપો",
      decline: "નકારો",
      allow: "પરવાનગી આપો"
    },
    userDetails: {
      heading: "PAN ચકાસણી",
      subHeading: "ચકાસવા માટે કૃપા કરીને વિગતો ભરો",
      panLabel: "PAN નંબર",
      panRequired: "કૃપા કરીને તમારો PAN નંબર દાખલ કરો",
      saveError: "વિગતો સાચવતી વખતે કંઈક ખોટું થયું. કૃપા કરીને ફરી પ્રયાસ કરો.",
      proceed: "આગળ વધો"
    },
    redirectCta: {
      or: "અથવા",
      clickHere: "અહીં ક્લિક કરો",
      clickHereStart: "અહીં ક્લિક કરો",
      toContinue: "ચાલુ રાખવા માટે"
    },
    documentCapture: {
      stillNotWorking: "હજુ પણ કામ કરતું નથી?",
      clickToCaptureInstead: "તેના બદલે ક્લિક-ટુ-કૅપ્ચર અજમાવો",
      pdfNotAllowedIndia: "ભારત માટે PDF અપલોડની પરવાનગી નથી. કૃપા કરીને 5 MB કરતાં ઓછી JPEG, JPG, અથવા PNG ફાઇલો અપલોડ કરો.",
      pdfNotAllowedIndiaMobile: "ભારત માટે PDF અપલોડની પરવાનગી નથી. કૃપા કરીને 5 MB કરતાં ઓછી JPEG, JPG, PNG, HEIC, અથવા HEIF ફાઇલો અપલોડ કરો.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb કરતાં ઓછી",
      fileFormats: "jpeg, jpg, png, pdf 5 mb કરતાં ઓછી",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb કરતાં ઓછી",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb કરતાં ઓછી"
    },
    mobileCapture: {
      upload: "અપલોડ કરો",
      skip: "છોડો",
      stillNotWorking: "હજુ પણ કામ નથી કરતું?",
      tryClickToCapture: "ટૅપ કરીને ફોટો લો"
    },
    UserDetails: {
      panLabel: "PAN નંબર",
      proceedBtn: "આગળ વધો",
      panRequired: "કૃપા કરીને તમારો PAN નંબર દાખલ કરો",
      saveError: "વિગતો સાચવતી વખતે કંઈક ખોટું થયું. કૃપા કરીને ફરી પ્રયાસ કરો."
    }
  },
  kn: {
    supportingDocument: {
      headingFallback: "ಪೂರಕ ದಾಖಲೆ",
      subHeading: "ಕೆಳಗಿನ ದಾಖಲೆಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ. ಇದನ್ನು ಪರಿಶೀಲನೆಗಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ — ಇದರಿಂದ ಏನನ್ನೂ ಹೊರತೆಗೆಯಲಾಗುವುದಿಲ್ಲ.",
      choosePlaceholder: "ಫೈಲ್ ಆಯ್ಕೆಮಾಡಿ (PNG, JPG ಅಥವಾ PDF)",
      continue: "ಮುಂದುವರಿಸಿ",
      uploading: "ಅಪ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
      skip: "ಸದ್ಯಕ್ಕೆ ಬಿಟ್ಟುಬಿಡಿ",
      errorInvalidType: "PNG, JPG ಅಥವಾ PDF ಫೈಲ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
      errorTooLarge: "ಫೈಲ್ ತುಂಬಾ ದೊಡ್ಡದಾಗಿದೆ. ಮಿತಿ 10MB.",
      errorRead: "ಆ ಫೈಲ್ ಓದಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಇನ್ನೊಂದನ್ನು ಪ್ರಯತ್ನಿಸಿ.",
      errorNoFile: "ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ಫೈಲ್ ಆಯ್ಕೆಮಾಡಿ.",
    },
    header: {
      title: "ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸೋಣ",
      subtitle: "ಇದು 2 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ ಸಮಯ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ",
      havingIssue: "ಸಮಸ್ಯೆ ಇದೆಯೇ?"
    },
    subHeading: {
      subHeading1: "ನಿಮ್ಮ ಗುರುತಿನ ದಾಖಲೆ ಸೆರೆಹಿಡಿಯಿರಿ",
      subHeading2: "ನೀವು ಜೀವಂತವಾಗಿದ್ದೀರಾ ಎಂದು ಪರಿಶೀಲಿಸಿ",
      livenessHeading1: "ಉತ್ತಮ ಬೆಳಕು ಇರುವ ಸ್ಥಳವನ್ನು ಹುಡುಕಿ",
      livenessHeading2: "ನಿಮ್ಮ ಮುಖವನ್ನು ಮಧ್ಯದಲ್ಲಿ ಇರಿಸಿ"
    },
    onlyIdVerificationHeader: {
      title: "ನಿಮ್ಮ ಗುರುತಿನ ದಾಖಲೆಯನ್ನು ಪರಿಶೀಲಿಸೋಣ",
      subtitle: "ಇದು ಕೇವಲ ಒಂದು ನಿಮಿಷ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ. ನಿಮ್ಮ ಗುರುತಿನ ದಾಖಲೆಯನ್ನು ಹತ್ತಿರ ಇರಿಸಿ",
      instruction1: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ",
      instruction2: "ದಾಖಲೆಯನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ಅಥವಾ ಅಪ್ಲೋಡ್ ಮಾಡಿ",
      instruction3: "ತ್ವರಿತ ದಾಖಲೆ ಪರಿಶೀಲನೆ"
    },
    termsAndCondition: {
      title: "ನಾನು ಈ ಕೆಳಗಿನ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳಿಗೆ ಒಪ್ಪುತ್ತೇನೆ ಮತ್ತು ಪಾಲಿಸುತ್ತೇನೆ.",
      privacyPolicy: "ನಿಯಮಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
      beginBtnText: "ಆರಂಭಿಸಿ",
      beginLiveness: "ಲೈವೆನೆಸ್ ಪರಿಶೀಲನೆ ಆರಂಭವಾಗುತ್ತಿದೆ",
      startLiveness: "ಲೈವೆನೆಸ್ ಪರಿಶೀಲನೆಗೆ ಮುಂದಾಗಿ"
    },
    permissionDenied: {
      title: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ!",
      subtitle: "ಬ್ರೌಸರ್ ವಿಳಾಸ ಪಟ್ಟಿಯ ಬಳಿ ತಡೆಯಲಾದ ಕ್ಯಾಮೆರಾ ಐಕಾನ್ ಇರುವುದೆಂದು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಅದನ್ನು ಅನ್‌ಬ್ಲಾಕ್ ಮಾಡಿ.",
      readMore: "ಮತ್ತಷ್ಟು ಓದು",
      refreshText: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶಕ್ಕೆ ಅನುಮತಿ ನೀಡಿದ ನಂತರ, ಕೆಳಗಿನ ಮರುಲೋಡ್ ಬಟನ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ.",
      refreshBtn: "ಮರುಲೋಡ್",
      link: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ",
      buttonText: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ"
    },
    desktopBrowserPermissionDenied: {
      title: "ದಯವಿಟ್ಟು ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ",
      subtitle: "ಬ್ರೌಸರ್ ಅನುಮತಿಗಳಿಗಾಗಿ ಕೇಳಬಹುದು. ಮುಂದುವರಿಯಲು 'ಅನುಮತಿಸಿ' ಕ್ಲಿಕ್ ಮಾಡಿ.",
      readMore: "ಮತ್ತಷ್ಟು ಓದು",
      refreshText: "ಅನುಮತಿಗಳನ್ನು ನೀಡಿದ ನಂತರ ಮರುಲೋಡ್ ಮಾಡಿ",
      refreshBtn: "ಮರುಲೋಡ್",
      link: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ",
      buttonText: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ"
    },
    androidBrowserPermissionDenied: {
      title: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ!",
      subtitle: "ಬ್ರೌಸರ್ ವಿಳಾಸ ಪಟ್ಟಿಯ ಬಳಿ ನಿರ್ಬಂಧಿತ ಕ್ಯಾಮೆರಾ ಐಕಾನ್ ಹುಡುಕಿ ಮತ್ತು ಅನ್ಬ್ಲಾಕ್ ಮಾಡಿ.",
      readMore: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
      refreshText: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿದ ನಂತರ, ಕೆಳಗಿನ ರಿಫ್ರೆಶ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ.",
      refreshBtn: "ರಿಫ್ರೆಶ್",
      link: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ",
      buttonText: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ"
    },
    androidWebViewPermissionDenied: {
      title: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ!",
      subtitle: "ಅನ್ವಯದ ಸೆಟ್ಟಿಂಗ್‌ಗಳಿಂದ ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ನಿರ್ಬಂಧಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಫೋನ್‌ನ App Info > Permissions > Camera ಗೆ ಹೋಗಿ ಮತ್ತು ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ.",
      refreshText: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿದ ನಂತರ, ಕೆಳಗಿನ ರಿಫ್ರೆಶ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ.",
      refreshBtn: "ರಿಫ್ರೆಶ್",
      link: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ",
      buttonText: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ"
    },
    iosBrowserPermissionDenied: {
      title: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ!",
      subtitle: "ವಿಳಾಸ ಪಟ್ಟಿಯ ಬಳಿ ಕ್ಯಾಮೆರಾ ಅಥವಾ ಲಾಕ್ ಐಕಾನ್ ಅನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ ಅಥವಾ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಪರಿಶೀಲಿಸಿ.",
      readMore: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
      refreshText: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿದ ನಂತರ, ಕೆಳಗಿನ ರಿಫ್ರೆಶ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ.",
      refreshBtn: "ರಿಫ್ರೆಶ್",
      link: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ",
      buttonText: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ"
    },
    iosWebViewPermissionDenied: {
      title: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ!",
      subtitle: "ಅನ್ವಯದ ಸೆಟ್ಟಿಂಗ್‌ಗಳಿಂದ ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರ್ಬಂಧಿತವಾಗಿದೆ. Settings ಗೆ ಹೋಗಿ, ನೀವು ಬಳಸುತ್ತಿರುವ ಅನ್ವಯವನ್ನು ಹುಡುಕಿ ಮತ್ತು ಕ್ಯಾಮೆರಾ ಅನುಮತಿಯು ಸಕ್ರಿಯವಾಗಿದೆ ಎಂಬುದನ್ನು ಖಚಿತಪಡಿಸಿ.",
      refreshText: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿದ ನಂತರ, ಕೆಳಗಿನ ರಿಫ್ರೆಶ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ.",
      refreshBtn: "ರಿಫ್ರೆಶ್",
      link: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ",
      buttonText: "ಅಥವಾ, ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ"
    },
    documentationList: {
      countryHeading: "ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
      docHeading: "ನಿಮ್ಮ ದಸ್ತಾವೇಜನ್ನು ಆಯ್ಕೆಮಾಡಿ",
      btnText: "ಮುಂದುವರೆಯಿರಿ",
      searchCountry: "ದೇಶ ಹುಡುಕಿ"
    },
    frontDocCapture: {
      heading: "ಗುರುತಿನ ದಾಖಲೆಯ ಮುಂಭಾಗವನ್ನು ಚೌಕದಲ್ಲಿ ಇರಿಸಿ",
      backupHeading: "ಸಮಸ್ಯೆಯಾದರೆ? ದಯವಿಟ್ಟು ಚಿತ್ರವನ್ನು ಕೈಯಿಂದ ಕ್ಲಿಕ್ ಮಾಡಿ",
      btnText: "ಫೋಟೋ ತಗೆದು",
      headingBack: " ಆಯತದೊಳಗೆ",
      uploadButton: "ಅಥವಾ, ಐಡಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ"
    },
    backDocCapture: {
      heading: "ಗುರುತಿನ ದಾಖಲೆಯ ಹಿಂಭಾಗವನ್ನು ಚೌಕದಲ್ಲಿ ಇರಿಸಿ",
      backupHeading: "ಸಮಸ್ಯೆಯಾದರೆ? ದಯವಿಟ್ಟು ಚಿತ್ರವನ್ನು ಕೈಯಿಂದ ಕ್ಲಿಕ್ ಮಾಡಿ",
      btnText: "ಫೋಟೋ ತಗೆದು",
      containerText: "ಅಥವಾ, ದಸ್ತಾವೇಜನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
      text: "ಸೆರೆಹಿಡಿಯುತ್ತಿದೆ, ಸ್ತಬ್ಧವಾಗಿರಿ",
      headingBack: " ಆಯತದೊಳಗೆ",
      skipButton: "ಹಿಂಭಾಗ ಬಿಟ್ಟುಬಿಡಿ",
      uploadButton: "ಅಥವಾ, ಐಡಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ"
    },
    analyzing: {
      heading: "ನಿಮ್ಮ ಗುರುತಿನ ಕಾರ್ಡ್ ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...",
      subHeading: "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪರದೆಯಲ್ಲಿರುವ ನಿಮ್ಮ ಕಾರ್ಡ್ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಅಗತ್ಯವಿದ್ದರೆ ಸಂಪಾದಿಸಿ"
    },
    imageCheck: {
      heading: "ನಿಮ್ಮ ಚಿತ್ರವನ್ನು ಪರಿಶೀಲಿಸಿ",
      subHeading: "ಚಿತ್ರ ಸಂಪೂರ್ಣ, ಸ್ಪಷ್ಟವಾಗಿದ್ದು, ಧೂಳಿನ ಅಥವಾ ಹೊಳೆಯಿಲ್ಲದೆ ಇರಲಿ.",
      button1: "ಪುನಃ ಫೋಟೋ ತೆಗೆಯಿರಿ",
      button2: "ಸರಿ",
      frontHeading: "ಮುಂಭಾಗದ ಚಿತ್ರವನ್ನು ಪರಿಶೀಲಿಸಿ",
      backHeading: "ಹಿಂದಿನ ಚಿತ್ರವನ್ನು ಪರಿಶೀಲಿಸಿ"
    },
    errorHandler: {
      heading: "ಅಯ್ಯೋ :(",
      subHeading1: "ನಾವು ಕೆಲವು ಸಮಸ್ಯೆಗಳನ್ನು ಎದುರಿಸುತ್ತಿದ್ದೇವೆ, ಆದರೆ ಚಿಂತೆ ಬೇಡ! ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ",
      subHeading2: "ಇದು ಮುಂದುವರೆದರೆ, ನಂತರ ಪರಿಶೀಲಿಸಿ",
      button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮುಖವನ್ನು ಮುಚ್ಚಿದ ಯಾವುದೇ ವಸ್ತುವನ್ನು ತೆಗೆದುಹಾಕಿ",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      eyeClosureDetected: {
        heading: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಕಣ್ಣುಗಳನ್ನು ತೆರೆದಿಡಿ ಮತ್ತು ನೇರವಾಗಿ ಕ್ಯಾಮೆರಾಕ್ಕೆ ನೋಡಿ",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      isMultipleFacesFound: {
        heading: "ಅನೇಕ ಮುಖಗಳು ಪತ್ತೆಯಾಗಿವೆ. ಕ್ಯಾಮೆರಾದಲ್ಲಿ ನಿಮ್ಮ ಮುಖ ಮಾತ್ರ ದೃಶ್ಯಮಾನವಾಗಿರುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      noFacesFound: {
        heading: "ಮುಖ ಕಂಡುಬಂದಿಲ್ಲ. ನಿಮ್ಮ ಮುಖವು ಕ್ಯಾಮೆರಾದಲ್ಲಿ ಗೋಚರಿಸುತ್ತದೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      faceDetections: {
        heading: "ದಯವಿಟ್ಟು ಇದನ್ನು ತೆಗೆದುಹಾಕಿ",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "ಬಹುಮುಖಗಳು ಕಂಡುಬಂದವು",
          button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
        },
        generalMessage: {
          heading: "ದಯವಿಟ್ಟು ನೀವು ಕ್ಯಾಮೆರಾ ಮುಂದೆ ಪ್ರಸ್ತುತವಿದ್ದೀರಿ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ",
          button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
        }
      },
      faceMatch: {
        heading: "ನಿಮ್ಮ ಮುಖವು ಐಡಿ ಫೋಟೊಗೆ ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      selfieError: {
        heading: "ನಾವು ನಿಮ್ಮ ಸೆಲ್ಫಿಯನ್ನು ಪರಿಶೀಲಿಸಲು ಸಾಧ್ಯವಾಗಿಲ್ಲ",
        subHeading1: "ಈ ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        instruction1: "ಹಲಸು ಬೆಳಕಾದ ಪ್ರದೇಶಕ್ಕೆ ಹೋಗಿ ಮತ್ತು ಹಿಂಬಾಲ ಬೆಳಕನ್ನು ತಪ್ಪಿಸಿ",
        instruction2: "ನಿಮ್ಮ ಮುಖವು ಸಂಪೂರ್ಣವಾಗಿ ಕಾಣುತ್ತಿದ್ದು ಫ್ರೇಮಿನ ಮಧ್ಯದಲ್ಲಿ ಇರಲಿ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ",
        instruction3: "ನಿಮ್ಮ ಮುಖವು ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣಿಸಲು ಟೋಪಿ, ಕಣ್ಣ spectacles ಅಥವಾ ಮಾಸ್ಕ್ ತೆಗೆದುಹಾಕಿ",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP ಹೊಂದಿಕೆಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು OTP ಅನ್ನು ಸ್ಪಷ್ಟವಾಗಿ ಜೋರಾಗಿ ಓದಿ",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      activeLivenessGenericFailureMessage: {
        heading: "ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಸೂಚನೆಗಳನ್ನು ಸ್ಪಷ್ಟವಾಗಿ ಅನುಸರಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF ನಲ್ಲಿ ತುಂಬಾ ಪುಟಗಳಿವೆ",
        subHeading: "ಅಪ್‌ಲೋಡ್ ಮಾಡಿದ PDF 2-ಪುಟಗಳ ಮಿತಿಯನ್ನು ಮೀರಿದೆ. ದಯವಿಟ್ಟು 2 ಪುಟಗಳಿಗಿಂತ ಹೆಚ್ಚಿಲ್ಲದ PDF, ಅಥವಾ ನಿಮ್ಮ ID ಯ ಸ್ಪಷ್ಟ ಚಿತ್ರವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ."
      },
      heading: "ನಾವು ನಿಮ್ಮ ಗುರುತಿನ ಕಾರ್ಡ್ ಪ್ರಕ್ರಿಯೆ ಮಾಡಲು ಸಾಧ್ಯವಾಗಿಲ್ಲ",
      subHeading: "ನೀವು ತಪ್ಪಾದ ಗುರುತಿನ ಕಾರ್ಡ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡುತ್ತಿದ್ದೀರಿ ಅಥವಾ ಚಿತ್ರ ಸ್ಪಷ್ಟವಾಗಿಲ್ಲ",
      buttonBack: "ಗುರುತಿನ ಕಾರ್ಡ್ ಹಿಂಭಾಗ ಪುನಃ ಪ್ರಯತ್ನಿಸಿ",
      buttonFront: "ಗುರುತಿನ ಕಾರ್ಡ್ ಮುಂಭಾಗ ಪುನಃ ಪ್ರಯತ್ನಿಸಿ",
      button: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
      captureFrontSide: "ಮುಂಭಾಗವನ್ನು ಕ್ಯಾಪ್ಚರ್ ಮಾಡಿ",
      captureBackSide: "ಹಿಂಭಾಗವನ್ನು ಕ್ಯಾಪ್ಚರ್ ಮಾಡಿ",
      changeIDButton: "ಮತ್ತೊಂದು ದಾಖಲೆ ಆಯ್ಕೆಮಾಡಿ",
      wrongid: {
        heading: "ನಾವು ಈ ದಾಖಲೆಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗಲಿಲ್ಲ",
        subHeading: "ದಯವಿಟ್ಟು ನೀವು ಸರಿಯಾದ ದಾಖಲೆಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡುತ್ತಿದ್ದೀರಿ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ ಮತ್ತು ಚಿತ್ರದ ಗುಣಮಟ್ಟ ಸ್ಪಷ್ಟವಾಗಿದೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ"
      },
      expiredid: {
        heading: "ಗುರುತಿನ ದಾಖಲೆ ಮುಕ್ತಾಯಗೊಂಡಿದೆ!",
        subHeading: "ನಾವು ಮುಕ್ತಾಯಗೊಂಡ ಗುರುತಿನ ದಾಖಲೆಯನ್ನು ಸ್ವೀಕರಿಸಲಾಗುವುದಿಲ್ಲ. ದಯವಿಟ್ಟು ಮಾನ್ಯ ದಾಖಲೆಯನ್ನು ಒದಗಿಸಿ"
      },
      minimumage: {
        heading: "ವಯಸ್ಸಿನ ಅವಶ್ಯಕತೆ ಪೂರೈಸಿಲ್ಲ!",
        subHeading: "ನಿಮ್ಮ ವಯಸ್ಸು ಕನಿಷ್ಠ ಅಗತ್ಯವಿರುವ ವಯಸ್ಸಿಗಿಂತ ಕಡಿಮೆಯಾಗಿದೆ. ದಯವಿಟ್ಟು ನೀವು ಕನಿಷ್ಠ ವಯಸ್ಸಿನ ಮಾನದಂಡವನ್ನು ಪೂರೈಸುತ್ತೀರಿ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ"
      },
      mobileAttemptsDone: {
        heading: "ನಿಮ್ಮ ಹಿಂದಿನ ಸಾಧನದಲ್ಲಿ ಪ್ರಯಾಣ ಪುನರಾರಂಭಗೊಂಡಿದೆ",
        subHeading: "ನಕಲು ತಪ್ಪಿಸಲು ಈ ಸೆಷನ್ ಈಗ ನಿಲ್ಲಿಸಲಾಗಿದೆ."
      },
      finished: {
        heading: "ಪ್ರಯಾಣ ಕೊನೆಗೊಂಡಿದೆ",
        subHeading: "ಪ್ರಯಾಣ ಪೂರ್ಣಗೊಂಡಿದೆ ಅಥವಾ ಮುಕ್ತಾಯಗೊಂಡಿದೆ"
      },
      invalid: {
        heading: "ಪ್ರಯಾಣ ಲಭ್ಯವಿಲ್ಲ !",
        subHeading: "journeyId ಕಂಡುಬಂದಿಲ್ಲ ಅಥವಾ ಪ್ರಯಾಣ ID ಅಮಾನ್ಯವಾಗಿದೆ"
      },
      INVALID_PAN_NUMBER: {
        heading: "ಅಮಾನ್ಯ PAN ಸಂಖ್ಯೆ",
        subHeading: "ನೀವು ನಮೂದಿಸಿದ PAN ಸಂಖ್ಯೆ ಮಾನ್ಯವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      INVALID_PAN_STATUS: {
        heading: "ಅಮಾನ್ಯ PAN ಸ್ಥಿತಿ",
        subHeading: "ನೀವು ನಮೂದಿಸಿದ PAN ಸಂಖ್ಯೆ ಮಾನ್ಯವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      directKyc: {
        heading: "ನೇರ KYC ಪ್ರಯಾಣ !",
        subHeading: "ಇದು ನೇರ KYC ಪ್ರಯಾಣವಾಗಿದೆ. ಫ್ರಂಟ್‌ಎಂಡ್ ಪ್ರಯಾಣಕ್ಕೆ ಅನುಮತಿ ಇಲ್ಲ."
      },
      DOCTYPE_FALSE: {
        heading: "ತಪ್ಪು ದಾಖಲೆ ಒದಗಿಸಲಾಗಿದೆ!",
        subHeading: "ದಯವಿಟ್ಟು ಮಾನ್ಯ ದಾಖಲೆಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ಚಿತ್ರದ ಗುಣಮಟ್ಟ ಉತ್ತಮವಾಗಿದೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ."
      },
      ONLY_FRONT: {
        heading: "ಗುರುತಿನ ಚೀಟಿಯ ಹಿಂಭಾಗ ಕಾಣೆಯಾಗಿದೆ",
        subHeading: "ನೀವು ಮುಂಭಾಗವನ್ನು ಮಾತ್ರ ಒದಗಿಸಿದ್ದೀರಿ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ತಿರುಗಿಸಿ ಮುಂದುವರಿಯಲು ಹಿಂಭಾಗವನ್ನು ಒದಗಿಸಿ"
      },
      ONLY_BACK: {
        heading: "ಗುರುತಿನ ಚೀಟಿಯ ಮುಂಭಾಗ ಕಾಣೆಯಾಗಿದೆ",
        subHeading: "ನೀವು ಹಿಂಭಾಗವನ್ನು ಮಾತ್ರ ಒದಗಿಸಿದ್ದೀರಿ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ತಿರುಗಿಸಿ ಮುಂದುವರಿಯಲು ಮುಂಭಾಗವನ್ನು ಒದಗಿಸಿ"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "ದಾಖಲೆ ಶೀಘ್ರದಲ್ಲೇ ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತದೆ",
        subHeading: "ದಾಖಲೆ ಶೀಘ್ರದಲ್ಲೇ ಮುಕ್ತಾಯಗೊಳ್ಳುವ ಕಾರಣ ತಿರಸ್ಕರಿಸಲಾಗಿದೆ."
      },
      DOCUMENT_EXPIRED: {
        heading: "ದಾಖಲೆ ಮುಕ್ತಾಯಗೊಂಡಿದೆ!",
        subHeading: "ದಯವಿಟ್ಟು ಮುಂದುವರಿಯಲು ಮಾನ್ಯ, ಮುಕ್ತಾಯಗೊಳ್ಳದ ದಾಖಲೆಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "ವಯಸ್ಸಿನ ಅವಶ್ಯಕತೆ ಪೂರೈಸಿಲ್ಲ!",
        subHeading: "ನೀವು ಅಗತ್ಯವಿರುವ ವಯಸ್ಸನ್ನು ಪೂರೈಸುವುದಿಲ್ಲ ಎಂದು ದಾಖಲೆ ಸೂಚಿಸುತ್ತದೆ. ದಯವಿಟ್ಟು ಮಾನ್ಯ ದಾಖಲೆಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ದಾಖಲೆಯನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ!",
        subHeading: "ಪರಿಶೀಲನೆಗೆ ಚಿತ್ರದ ಗುಣಮಟ್ಟ ತುಂಬಾ ಕಳಪೆಯಾಗಿದೆ. ದಯವಿಟ್ಟು ಸ್ಪಷ್ಟವಾದ ಚಿತ್ರದೊಂದಿಗೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ದಾಖಲೆಯನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ!",
        subHeading: "ಕೆಲವು ಮಾಹಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಸ್ಪಷ್ಟವಾದ ಚಿತ್ರದೊಂದಿಗೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ದಾಖಲೆಯನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ!",
        subHeading: "ಕಳಪೆ ಚಿತ್ರ ಗುಣಮಟ್ಟದ ಕಾರಣ ಕೆಲವು ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಸ್ಪಷ್ಟವಾದ ಚಿತ್ರದೊಂದಿಗೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ದಾಖಲೆಯನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ!",
        subHeading: "ಕೆಲವು ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಸ್ಪಷ್ಟವಾದ ಚಿತ್ರದೊಂದಿಗೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "ಗುರುತಿನ ಚೀಟಿಯ ಮೇಲಿನ ನಿಮ್ಮ ಫೋಟೋ ಪರಿಶೀಲಿಸುವಲ್ಲಿ ಸಮಸ್ಯೆ",
        subHeading: "ಗುರುತಿನ ಚೀಟಿಯ ಮೇಲಿನ ನಿಮ್ಮ ಫೋಟೋವನ್ನು ನಾವು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮೂಲ ಗುರುತಿನ ಚೀಟಿಯ ಸ್ಪಷ್ಟ ಫೋಟೋವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಇದರಿಂದ ನಾವು ಅದನ್ನು ಖಚಿತಪಡಿಸಬಹುದು."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "ದಾಖಲೆ ಭದ್ರತಾ ಮಾದರಿ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ",
        subHeading: "ದಾಖಲೆಯ ಅಂತರ್ನಿರ್ಮಿತ ಭದ್ರತಾ ಮಾದರಿಗಳನ್ನು ನಾವು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ. ಅದರ ಅಧಿಕೃತತೆಯನ್ನು ಖಚಿತಪಡಿಸಲು ಸಹಾಯ ಮಾಡಲು ದಯವಿಟ್ಟು ಮೂಲ ಗುರುತಿನ ಚೀಟಿಯ ಸ್ಪಷ್ಟ ಫೋಟೋವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "ದಾಖಲೆ ಸಜೀವತೆ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ",
        subHeading: "ದಾಖಲೆ ನಿಜವಾಗಿರದಿರಬಹುದು ಎಂಬ ಚಿಹ್ನೆಗಳನ್ನು ನಾವು ಕಂಡುಕೊಂಡಿದ್ದೇವೆ. ದಯವಿಟ್ಟು ಸ್ಕ್ರೀನ್‌ಶಾಟ್‌ಗಳು, ಮುದ್ರಿತ ಪ್ರತಿಗಳು ಅಥವಾ ಪರದೆಯ ಮೇಲೆ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ತೋರಿಸುವುದನ್ನು ತಪ್ಪಿಸಿ. ಎಲ್ಲಾ ವೈಶಿಷ್ಟ್ಯಗಳು ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣುವ ಮೂಲ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ"
      },
      SECURITY_FALSE: {
        heading: "ಸಮಸ್ಯೆ ಪತ್ತೆಯಾಗಿದೆ!",
        subHeading: "ದಾಖಲೆಯನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಸ್ಪಷ್ಟವಾದ ಚಿತ್ರದೊಂದಿಗೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "ಕಳಪೆ ಚಿತ್ರ ಗುಣಮಟ್ಟ!",
        subHeading: "ಚಿತ್ರ ತುಂಬಾ ಮಸುಕಾಗಿದೆ ಅಥವಾ ಅಸ್ಪಷ್ಟವಾಗಿದೆ. ದಯವಿಟ್ಟು ಸ್ಪಷ್ಟವಾದ ಚಿತ್ರದೊಂದಿಗೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
      },
      FACE_UNDETECTED: {
        heading: "ಮುಖ ಪತ್ತೆಯಾಗಿಲ್ಲ",
        subHeading: "ದಾಖಲೆಯ ಮೇಲೆ ಗೋಚರ ಮುಖವನ್ನು ನಾವು ಕಂಡುಹಿಡಿಯಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮುಖ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣುವ ಮಾನ್ಯ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "ದಾಖಲೆಗಳ ನಡುವಿನ ಹೋಲಿಕೆ ವಿಫಲವಾಗಿದೆ",
        subHeading: "ಒಂದು ಅಥವಾ ಹೆಚ್ಚು ಪ್ರಮುಖ ಕ್ಷೇತ್ರಗಳಲ್ಲಿ (ಹೆಸರು, ಜನ್ಮ ದಿನಾಂಕ ಅಥವಾ ಮುಖ) ಹೊಂದಿಕೆಯಾಗದ ಕಾರಣ ದಾಖಲೆಗಳ ನಡುವಿನ ಹೋಲಿಕೆ ವಿಫಲವಾಗಿದೆ"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker ವೈಫಲ್ಯ",
        subHeading: "Digilocker ಪ್ರಯಾಣದ ಸಮಯದಲ್ಲಿ ದೋಷ ಸಂಭವಿಸಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಮುಂದುವರಿಯಲು ಪರ್ಯಾಯ ವಿಧಾನ ಬಳಸಿ."
      },
      LINKAGE_FAILED: {
        heading: "ಈ ಪರಿಶೀಲನೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ",
        subHeading: "ಈ ಪರಿಶೀಲನೆಗಾಗಿ ಪಡೆದ ವಿವರಗಳು ದಾಖಲೆಗಳೊಂದಿಗೆ ಹೊಂದಿಕೆಯಾಗಲಿಲ್ಲ."
      }
    },
    biometricConsent: {
      consentStatement: "ನಿಮ್ಮ ಸೆಲ್ಫಿಗೆ ಮೊದಲು, ನಿಮ್ಮ ಗುರುತನ್ನು ದೃಢೀಕರಿಸಲು ನಿಮ್ಮ ಬಯೋಮೆಟ್ರಿಕ್ ಡೇಟಾ (ಮುಖದ ಚಿತ್ರ ಮತ್ತು ಲೈವ್‌ನೆಸ್ ಸಂಕೇತಗಳು) ಸೆರೆಹಿಡಿಯಲು ಮತ್ತು ಸಂಸ್ಕರಿಸಲು ನಿಮ್ಮ ಒಪ್ಪಿಗೆ ಅಗತ್ಯವಿದೆ. ಈ ಡೇಟಾವನ್ನು ಈ ದೃಢೀಕರಣಕ್ಕಾಗಿ ಮಾತ್ರ ಬಳಸಲಾಗುತ್ತದೆ.",
      privacyPolicy: "ಗೌಪ್ಯತಾ ನೀತಿ",
      consentButton: "ನಾನು ಒಪ್ಪುತ್ತೇನೆ — ಮುಂದುವರಿಸಿ",
      declineButton: "ನಾನು ಒಪ್ಪುವುದಿಲ್ಲ",
      confirmTitle: "ಬಯೋಮೆಟ್ರಿಕ್ ದೃಢೀಕರಣವಿಲ್ಲದೆ ಮುಂದುವರಿಯುವುದೇ?",
      confirmBody: "ಬಯೋಮೆಟ್ರಿಕ್ ದೃಢೀಕರಣವಿಲ್ಲದೆ, ನಾವು ಸೆಲ್ಫಿ ತೆಗೆಯುವುದಿಲ್ಲ. ನೀವು ಈಗಾಗಲೇ ಒದಗಿಸಿದ ಮಾಹಿತಿಯನ್ನು ಬಳಸಿ ನಿಮ್ಮ ದೃಢೀಕರಣವನ್ನು ಪೂರ್ಣಗೊಳಿಸಲಾಗುತ್ತದೆ. ಈ ಆಯ್ಕೆ ಈ ಅವಧಿಗೆ ಅಂತಿಮವಾಗಿದೆ.",
      goBack: "ಹಿಂದೆ",
      confirmDecline: "ದೃಢೀಕರಿಸಿ — ಒಪ್ಪುವುದಿಲ್ಲ",
      declineComplete: "ಬಯೋಮೆಟ್ರಿಕ್ ದೃಢೀಕರಣದೊಂದಿಗೆ ಮುಂದುವರಿಯದಿರಲು ನೀವು ಆಯ್ಕೆ ಮಾಡಿದ್ದೀರಿ. ನೀವು ಸಲ್ಲಿಸಿದ ದಾಖಲೆಗಳನ್ನು ಬಳಸಿ ನಿಮ್ಮ ಗುರುತಿನ ದೃಢೀಕರಣ ಪೂರ್ಣಗೊಂಡಿದೆ."
    },
    introLiveness: {
      heading: "ನೀವು ಜೀವಂತವಾಗಿದ್ದೀರಿ ಎಂದು ದೃಢೀಕರಿಸಿ",
      instruction1: "ಉತ್ತಮ ಬೆಳಕು ಇರುವ ಸ್ಥಳವನ್ನು ಆರಿಸಿ",
      instruction2: "ಅಗತ್ಯವಾದ ಅನುಮತಿಗಳನ್ನು ನೀಡಿ",
      instruction3: "ಟೋಪಿ, ಮಾಸ್ಕ್, ಕನ್ನಡಕ ಮುಂತಾದವುಗಳನ್ನು ತೆಗೆದುಹಾಕಿ",
      button: "ಮುಂದುವರೆಯಿರಿ",
      subHeading: "ನೀವು ಕೇವಲ ಒಂದು ಹೆಜ್ಜೆ ದೂರದಲ್ಲಿದ್ದೀರಿ"
    },
    phoneSession: {
      heading: "ಸೆಷನ್ ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯುತ್ತದೆ",
      subheading: "ಮೊಬೈಲ್‌ನಲ್ಲಿ ಮುಗಿಯುವವರೆಗೆ ಈ ಕಿಟಕಿಯನ್ನು ತೆರೆಯಿರಿ",
      button: "ಇಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ"
    },
    continueOnPhone: {
      heading: "ಫೋನ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ",
      subheading: "QR ಕೋಡ್ ಅನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ಅಥವಾ ಕೆಳಗಿನ ಲಿಂಕ್ ಅನ್ನು ಪ್ರತಿಲಿಪಿ ಮಾಡಿ",
      subheading2: "QR ಕೋಡ್ ಅನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ಅಥವಾ ಲಿಂಕ್ ಅನ್ನು ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿ ತೆರೆಯಿರಿ",
      text: "ಪ್ರಕ್ರಿಯೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
      text1: "ಅನುವಾದಿಸಲು ಇಲ್ಲಿ ಪರಿಶೀಲಿಸಿ",
      button: "ಪ್ರತಿಲಿಪಿ ಮಾಡಿ",
      copiedButton: "ನಕಲಿಸಲಾಗಿದೆ!",
      copied: "ನಕಲಿಸಲಾಗಿದೆ!"
    },
    SsnReview: {
      heading: "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ",
      subHeading: "ಅಗತ್ಯವಿರುವ ಬದಲಾವಣೆಗಳನ್ನು ಮಾಡಿ ಮತ್ತು ವಿವರಗಳನ್ನು ಸಲ್ಲಿಸಿ",
      feild1: "ಡ್ರೈವಿಂಗ್ ಲೈಸೆನ್ಸ್",
      feild2: "ಮುಕ್ತಾಯ",
      feild3: "ಜನ್ಮ ದಿನಾಂಕ",
      feild4: "ವರ್ಗ",
      feild5: "ನಿಯಂತ್ರಣಗಳು",
      feild6: "ದೇಶ",
      feild7: "ವಿಳಾಸ",
      button: "ವಿವರಗಳು ಸರಿಯಾಗಿದೆ"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದಲ್ಲಿ ಇರಿಸಿ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ಕ್ಯಾಮೆರಾಗೆ ಹತ್ತಿರ ಬನ್ನಿ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ನಾಚಿಕೆಪಡಬೇಡಿ, ಮುಂದೆ ಬನ್ನಿ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ತುಂಬಾ ಕತ್ತಲೆ. ಹೆಚ್ಚು ಬೆಳಕಿಗೆ ಹೋಗಿ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ತುಂಬಾ ಪ್ರಕಾಶ. ಮೃದು ಬೆಳಕಿಗೆ ಹೋಗಿ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದಲ್ಲಿ ಇರಿಸಿ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ಸ್ಥಿರವಾಗಿರಿ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ಮುಖವನ್ನು ಬೆಳಕಿನ ಕಡೆಗೆ ತಿರುಗಿಸಿ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ಫೋನ್ ಅನ್ನು ಕಣ್ಣಿನ ಮಟ್ಟದಲ್ಲಿ ಹಿಡಿಯಿರಿ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ಕ್ಯಾಮೆರಾದಿಂದ ಸ್ವಲ್ಪ ದೂರ ಸರಿಯಿರಿ"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ನಿಮ್ಮ ಮುಖವನ್ನು ಫ್ರೇಮ್ ಮಧ್ಯದಲ್ಲಿ ಇರಿಸಿ"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದ ಮಧ್ಯದಲ್ಲಿ ಇರಿಸಿ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ಹತ್ತಿರ ಬನ್ನಿ ಮತ್ತು ಮುಖವನ್ನು ನೇರವಾಗಿ ಇರಿಸಿ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ದೃಶ್ಯಕ್ಕೆ ಬನ್ನಿ ಮತ್ತು ಮುಖವನ್ನು ನೇರವಾಗಿ ಇರಿಸಿ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ತುಂಬಾ ಕತ್ತಲು. ಹೆಚ್ಚು ಪ್ರಕಾಶಮಾನವಾದ ಬೆಳಕು ಹುಡುಕಿ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ತುಂಬಾ ಹೆಚ್ಚು. ಸಮರ್ಥ ಬೆಳಕು ಹುಡುಕಿ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದ ಮಧ್ಯಕ್ಕೆ ಹೊಂದಿಸಿ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ಸ್ಥಿರವಾಗಿ ಇರಿ ಮತ್ತು ನೇರವಾಗಿ ಮುಂದೆ ನೋಡಿ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ಬೆಳಕಿನ ಕಡೆ ಮುಖ ಮಾಡಿ ಮತ್ತು ಸ್ಥಿರವಾಗಿ ಇರಿ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ನಿಮ್ಮ ಫೋನ್ ಅನ್ನು ಕಣ್ಣಿನ ಮಟ್ಟದಲ್ಲಿ ಇಡಿ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ಕ್ಯಾಮೆರಾ ಸ್ವಲ್ಪ ದೂರವಿರುವಿರಿ"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "ಪರಿಪೂರ್ಣ!"
      },
      smile1: {
        icon: "mood",
        description: "ನಗುನಗುತ್ತಿರಿ, ನೀವು ಉತ್ತಮವಾಗಿ ಕಾಣುತ್ತೀರಿ!"
      },
      smile2: {
        icon: "mood",
        description: "ಕ್ಯಾಮೆರಾಕ್ಕೆ ನಗುನಗುತ್ತಿರಿ!"
      }
    },
    successful: {
      title: "ಪರಿಶೀಲನೆ ಪೂರ್ಣಗೊಂಡಿದೆ",
      text: "ನೀವು ಈಗ ಕಿಟಕಿಯನ್ನು ಮುಚ್ಚಬಹುದು",
      finishBtn: "ಪೂರ್ಣಗೊಳಿಸಿ"
    },
    poweredBy: "ಪ್ರದಾನದ ಮೂಲಕ",
    redirect: "ವಾಸಸ್ಥಳಕ್ಕೆ ಪೂರೈಸಲಾಗುತ್ತಿದೆ",
    error: {
      message: "URL ಅವಧಿ ಮುಗಿದಿದೆ ಅಥವಾ ಅಮಾನ್ಯವಾಗಿದೆ"
    },
    footer: {
      securedBy: "ಪ್ರದಾನದ ಮೂಲಕ"
    },
    helpFaq: {
      title: "ಹೆಲ್ಪ್ & ಸಾಮಾನ್ಯವಾಗಿ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
      subtitle: "ನಾವು ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ಇಲ್ಲಿ ಇದ್ದೇವೆ",
      cameraText: "ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸಲು, ನಾವು ನಿಮ್ಮ ಡಿವೈಸಿನ ಕ್ಯಾಮೆರಾದಿಂದ ಚಿತ್ರಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳಬೇಕಾಗುತ್ತದೆ. ಅಗತ್ಯವಾದ ಅನುಮತಿಗಳನ್ನು ಹೇಗೆ ನೀಡಬೇಕೆಂದು ತಿಳಿಯಲು ಈ link ಅನ್ನು ಅನುಸರಿಸಿ",
      cameraHeading: "ಕ್ಯಾಮೆರಾ ಅನುಮತಿ",
      languageText: "ಪ್ರಕ್ರಿಯೆ ಪ್ರಾರಂಭದ ಸಮಯದಲ್ಲಿ, ನೀವು ಮೇಲ್ಭಾಗದ ಡ್ರಾಪ್-ಡೌನ್ ಮೆನುಗಳಲ್ಲಿ ನಿಮ್ಮ ಇಚ್ಛಿತ ಭಾಷೆಯನ್ನು ಆರಿಸಬಹುದು",
      languageHeading: "ಭಾಷೆ ಆಯ್ಕೆ",
      kycText: "KYC ಅಥವಾ 'ನಿಮ್ಮ ಗ್ರಾಹಕನನ್ನು ಗೊತ್ತಾಗಿಸುವುದು' ಎಂದರೆ ಗ್ರಾಹಕರ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸುವ ಪ್ರಕ್ರಿಯೆ, ಇದು ಅನುಗುಣತೆ ದೃಢೀಕರಿಸಲು ಮತ್ತು ಮೋಸ ಮತ್ತು ಇತರ ಕಾನೂನುವಿರೋಧಿ ಚಟುವಟಿಕೆಗಳನ್ನು ತಡೆಗಟ್ಟಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ",
      kycHeading: "KYC ಅಂದರೆ ಏನು?",
      timeText: " ಸಾಮಾನ್ಯವಾಗಿ, ಇದರಿಗಾಗಿ ಸುಮಾರು 60 ಸೆಕೆಂಡುಗಳ ಸಮಯ ಇರುತ್ತದೆ. ಆದರೆ, ಇದು ದೇಶಗಳ ಮೇರೆಗೆ ಬದಲಾಗಬಹುದು",
      timeHeading: "ಇದು ಎಷ್ಟು ಸಮಯ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ?"
    },
    pdfPreviewUnavailable: "PDF ನ ಪೂರ್ವವೀಕ್ಷಣೆಯನ್ನು ತೋರಿಸಲು ಸಾಧ್ಯವಾಗಿಲ್ಲ.",
    pdfPreviewHint: "ಪೂರ್ವವೀಕ್ಷಣೆ ಕಾಣಿಸದಿದ್ದರೂ, ನೀವು ಮುಂದುವರಿಯಬಹುದು.",
    pdfOpenLabel: "PDF ತೆರೆಯಿರಿ",
    failedUpload: {
      title: "ಫೈಲ್ ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ",
      text: "ದಯವಿಟ್ಟು ಫೈಲ್ 5MB ಗಿಂತ ಕಡಿಮೆ ಮತ್ತು .jpg, .jpeg, .png, .heic, .heif ಅಥವಾ .pdf ಸ್ವರೂಪದಲ್ಲಿದೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ",
      btn: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
      pdfNotAllowedIndia: "ಭಾರತಕ್ಕೆ PDF ಅಪ್‌ಲೋಡ್‌ಗಳಿಗೆ ಅನುಮತಿ ಇಲ್ಲ. ದಯವಿಟ್ಟು 5 MB ಗಿಂತ ಕಡಿಮೆ JPEG, JPG, PNG, HEIC, ಅಥವಾ HEIF ಫೈಲ್‌ಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
      pdfNotAllowedIndiaBasic: "ಭಾರತಕ್ಕೆ PDF ಅಪ್‌ಲೋಡ್‌ಗಳಿಗೆ ಅನುಮತಿ ಇಲ್ಲ. ದಯವಿಟ್ಟು 5 MB ಗಿಂತ ಕಡಿಮೆ JPEG, JPG, ಅಥವಾ PNG ಫೈಲ್‌ಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ."
    },
    livenessAnalyzing: {
      heading: "ನಿಮ್ಮ ಮುಖವನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ",
      subHeading: "ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ, ಇದು ಕೆಲವು ಸೆಕೆಂಡುಗಳನ್ನು ಮಾತ್ರ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ"
    },
    sessionExpiredError: {
      heading: "ಕ್ಷಮಿಸಿ, ನಿಮ್ಮ ಸೆಷನ್ ಅವಧಿ ಮೀರಿದೆ",
      subHeading1: "ನೀವು ಸ್ವಲ್ಪ ಸಮಯದಿಂದ ನಿಷ್ಕ್ರಿಯರಾಗಿದ್ದೀರಿ. ಭದ್ರತಾ ಕಾರಣಗಳಿಗಾಗಿ, ನಿಮ್ಮ ಸೆಷನ್ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಮುಕ್ತಾಯಗೊಂಡಿದೆ",
      subHeading2: "ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
      buttonText: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
    },
    journeyExpiredError: {
      heading: "ಕ್ಷಮಿಸಿ, ಲಿಂಕ್ ಅವಧಿ ಮುಗಿದಿದೆ",
      subHeading1: "ಲಿಂಕ್ ಇನ್ನು ಸಕ್ರಿಯವಾಗಿಲ್ಲ. ಭದ್ರತಾ ಕಾರಣಗಳಿಗಾಗಿ, ಲಿಂಕ್‌ಗಳು ಸೀಮಿತ ಜೀವಿತಾವಧಿಯನ್ನು ಹೊಂದಿರುತ್ತವೆ",
      subHeading2: "ದಯವಿಟ್ಟು ಹೊಸ ಲಿಂಕ್‌ನೊಂದಿಗೆ ಪ್ರಯತ್ನಿಸಿ",
      buttonText: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ"
    },
    cameraAccessError: {
      alert1: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
      alert2: "ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶಿಸುವಾಗ ದೋಷ ಸಂಭವಿಸಿದೆ",
      alert3: "ನಿಮ್ಮ ಬ್ರೌಸರ್ ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಬೆಂಬಲಿಸುವುದಿಲ್ಲ"
    },
    activeLiveness: {
      instruction: "ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದೊಳಗೆ ಇರಿಸಿ ಮತ್ತು ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸಿ",
      permissionDeniedTitle: "ಕ್ಯಾಮೆರಾ ಅಥವಾ ಮೈಕ್ರೋಫೋನ್ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ",
      permissionDeniedSubtitle: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಮತ್ತು ಮೈಕ್ರೋಫೋನ್ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ."
    },
    flipScreen: {
      heading: "ಈಗ ನಿಮ್ಮ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ತಿರುಗಿಸಿ",
      subHeading: "ದಯವಿಟ್ಟು ಹಿಂಭಾಗವನ್ನು ತೋರಿಸಲು ನಿಮ್ಮ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಭೌತಿಕವಾಗಿ ತಿರುಗಿಸಿ, ನಂತರ ಅದನ್ನು ಕ್ಯಾಮೆರಾ ಫ್ರೇಮ್‌ನಲ್ಲಿ ಇರಿಸಿ.",
      continueButton: "ಮುಂದುವರಿಸಿ"
    },
    mobileDocCapture: {
      frontSide: "ಮುಂಭಾಗ",
      backSide: "ಹಿಂಭಾಗ",
      of: "ನ",
      upload: "ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
      stillNotWorking: "ಇನ್ನೂ ಕೆಲಸ ಮಾಡುತ್ತಿಲ್ಲವೇ?",
      clickToCapture: "ಕ್ಲಿಕ್-ಟು-ಕ್ಯಾಪ್ಚರ್ ಪ್ರಯತ್ನಿಸಿ",
      skip: "ಬಿಟ್ಟುಬಿಡಿ"
    }
,
    permissionPopUp: {
      title: "ಅನುಮತಿ ಅಗತ್ಯವಿದೆ",
      subtitle: "ಕ್ಯಾಮೆರಾ ಬಳಸಲು ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ",
      decline: "ನಿರಾಕರಿಸಿ",
      allow: "ಅನುಮತಿಸಿ"
    },
    userDetails: {
      heading: "PAN ಪರಿಶೀಲನೆ",
      subHeading: "ಪರಿಶೀಲಿಸಲು ದಯವಿಟ್ಟು ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ",
      panLabel: "PAN ಸಂಖ್ಯೆ",
      panRequired: "ದಯವಿಟ್ಟು ನಿಮ್ಮ PAN ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
      saveError: "ವಿವರಗಳನ್ನು ಉಳಿಸುವಾಗ ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
      proceed: "ಮುಂದುವರಿಯಿರಿ"
    },
    redirectCta: {
      or: "ಅಥವಾ",
      clickHere: "ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
      clickHereStart: "ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
      toContinue: "ಮುಂದುವರಿಯಲು"
    },
    documentCapture: {
      stillNotWorking: "ಇನ್ನೂ ಕೆಲಸ ಮಾಡುತ್ತಿಲ್ಲವೇ?",
      clickToCaptureInstead: "ಬದಲಿಗೆ ಕ್ಲಿಕ್-ಟು-ಕ್ಯಾಪ್ಚರ್ ಪ್ರಯತ್ನಿಸಿ",
      pdfNotAllowedIndia: "ಭಾರತಕ್ಕೆ PDF ಅಪ್‌ಲೋಡ್‌ಗಳಿಗೆ ಅನುಮತಿ ಇಲ್ಲ. ದಯವಿಟ್ಟು 5 MB ಗಿಂತ ಕಡಿಮೆಯ JPEG, JPG, ಅಥವಾ PNG ಫೈಲ್‌ಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
      pdfNotAllowedIndiaMobile: "ಭಾರತಕ್ಕೆ PDF ಅಪ್‌ಲೋಡ್‌ಗಳಿಗೆ ಅನುಮತಿ ಇಲ್ಲ. ದಯವಿಟ್ಟು 5 MB ಗಿಂತ ಕಡಿಮೆಯ JPEG, JPG, PNG, HEIC, ಅಥವಾ HEIF ಫೈಲ್‌ಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb ಗಿಂತ ಕಡಿಮೆ",
      fileFormats: "jpeg, jpg, png, pdf 5 mb ಗಿಂತ ಕಡಿಮೆ",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb ಗಿಂತ ಕಡಿಮೆ",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb ಗಿಂತ ಕಡಿಮೆ"
    },
    mobileCapture: {
      upload: "ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
      skip: "ಸ್ಕಿಪ್ ಮಾಡಿ",
      stillNotWorking: "ಇನ್ನೂ ಕೆಲಸ ಮಾಡುತ್ತಿಲ್ಲವೇ?",
      tryClickToCapture: "ಟ್ಯಾಪ್ ಮಾಡಿ ಫೋಟೋ ತೆಗೆಯಿರಿ"
    },
    UserDetails: {
      panLabel: "PAN ಸಂಖ್ಯೆ",
      proceedBtn: "ಮುಂದುವರಿಸಿ",
      panRequired: "ದಯವಿಟ್ಟು ನಿಮ್ಮ PAN ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
      saveError: "ವಿವರಗಳನ್ನು ಉಳಿಸುವಾಗ ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ."
    }
  },
  bho: {
    header: {
      title: "आइए, रउआ पहचान के पुष्टि करीं",
      subtitle: "एमें 2 मिनट से कम समय लागे",
      havingIssue: "दिक्कत हो रहल बा?"
    },
    subHeading: {
      subHeading1: "अपन पहचान पत्र के फोटो खींचीं",
      subHeading2: "पुष्टि करीं कि रउआ जिंदा बानी",
      livenessHeading1: "अच्छी रोशनी वाली जगह चुनें",
      livenessHeading2: "अपना चेहरा बीच में रखें"
    },
    termsAndCondition: {
      title: "हम ए नीचे लिखल नियम आ शर्तन के पालन करे खातिर सहमत बानी.",
      privacyPolicy: "नियम देखीं",
      beginBtnText: "शुरू करीं",
      beginLiveness: "लाइवनेस चेक शुरू हो रहल बा",
      startLiveness: "लाइवनेस चेक करे खातिर आगे बढ़ीं"
    },
    permissionDenied: {
      title: "कैमरा एक्सेस से मना कर दीहल गइल!",
      subtitle: "ब्राउज़र के एड्रेस बार लगे ब्लॉक भइल कैमरा आइकन देखीं आ ओहके अनब्लॉक करीं.",
      readMore: "आगे पढ़ीं",
      refreshText: "कैमरा एक्सेस के अनुमति देला के बाद, नीचे दिहल गइल रिफ्रेश बटन पर क्लिक करीं.",
      refreshBtn: "रिफ्रेश करीं",
      link: "या, मोबाइल पर जारी रखीं",
      buttonText: "या, मोबाइल पर जारी रखीं"
    },
    desktopBrowserPermissionDenied: {
      title: "कृपया कैमरा एक्सेस के अनुमति दीं",
      subtitle: "ब्राउज़र अनुमति मांगे के हो सकेला. कृपया 'अनुमति दीं' पर क्लिक करीं.",
      readMore: "आगे पढ़ीं",
      refreshText: "अनुमति देला के बाद रिफ्रेश करीं",
      refreshBtn: "रिफ्रेश करीं",
      link: "या, मोबाइल पर जारी रखीं",
      buttonText: "या, मोबाइल पर जारी रखीं"
    },
    androidBrowserPermissionDenied: {
      title: "कैमरा एक्सेस से मना कर दीहल गइल!",
      subtitle: "ब्राउजर के एड्रेस बार के लगे जवन कैमरा के आइकन ब्लॉक भइल बा, ओकरा पर क्लिक क के एक्सेस दे दीं.",
      readMore: "आऊरी जाने",
      refreshText: "जब कैमरा एक्सेस दे दीं, त नीचे वाला रीफ्रेश बटन पर क्लिक करीं.",
      refreshBtn: "रीफ्रेश करीं",
      link: "या, फोन पर जारी राखीं",
      buttonText: "या, फोन पर जारी राखीं"
    },
    androidWebViewPermissionDenied: {
      title: "कैमरा एक्सेस से मना कर दीहल गइल!",
      subtitle: "एप सेटिंग से कैमरा एक्सेस बंद हो सकेला. कृपया मोबाइल के App Info > Permissions > Camera में जाके एक्सेस दे दीं.",
      refreshText: "जब कैमरा एक्सेस दे दीं, त नीचे वाला रीफ्रेश बटन पर क्लिक करीं.",
      refreshBtn: "रीफ्रेश करीं",
      link: "या, फोन पर जारी राखीं",
      buttonText: "या, फोन पर जारी राखीं"
    },
    iosBrowserPermissionDenied: {
      title: "कैमरा एक्सेस से मना कर दीहल गइल!",
      subtitle: "एड्रेस बार के लगे कैमरा भा ताला के आइकन पर टैप करीं, या ब्राउजर के सेटिंग चेक करीं.",
      readMore: "आऊरी जाने",
      refreshText: "जब कैमरा एक्सेस दे दीं, त नीचे वाला रीफ्रेश बटन पर क्लिक करीं.",
      refreshBtn: "रीफ्रेश करीं",
      link: "या, फोन पर जारी राखीं",
      buttonText: "या, फोन पर जारी राखीं"
    },
    iosWebViewPermissionDenied: {
      title: "कैमरा एक्सेस से मना कर दीहल गइल!",
      subtitle: "हो सकेला कि ऐप सेटिंग से कैमरा एक्सेस रोकाइल होखे. Settings में जाईं, आपन ऐप चुनीं, आ कैमरा परमीशन चालू करीं.",
      refreshText: "जब कैमरा एक्सेस दे दीं, त नीचे वाला रीफ्रेश बटन पर क्लिक करीं.",
      refreshBtn: "रीफ्रेश करीं",
      link: "या, फोन पर जारी राखीं",
      buttonText: "या, फोन पर जारी राखीं"
    },
    documentationList: {
      countryHeading: "देश चुनीं",
      docHeading: "अपन दस्तावेज़ चुनीं",
      btnText: "अगिला",
      searchCountry: "देश खोजीं"
    },
    frontDocCapture: {
      heading: "पहचान पत्र के सामने के हिस्सा चौकोर में रखीं",
      backupHeading: "कुछ परेशानी हो रहल बा? कृपया मैनुअली फोटो खींचीं",
      btnText: "फोटो खींचीं",
      headingBack: " आयत के अंदर",
      uploadButton: "या, आईडी अपलोड करीं"
    },
    backDocCapture: {
      heading: "पहचान पत्र के पीछे के हिस्सा चौकोर में रखीं",
      backupHeading: "कुछ परेशानी हो रहल बा? कृपया मैनुअली फोटो खींचीं",
      btnText: "फोटो खींचीं",
      containerText: "या, दस्तावेज़ अपलोड करीं",
      text: "कैप्चर हो रहल बा, कृपया स्थिर रहीं",
      headingBack: " आयत के अंदर",
      skipButton: "पीछे का भाग छोड़ें",
      uploadButton: "या, आईडी अपलोड करीं"
    },
    analyzing: {
      heading: "रउआ पहचान पत्र के विश्लेषण हो रहल बा...",
      subHeading: "कृपया अगिला स्क्रीन पर रउआ कार्ड के डिटेल देखीं आ जरूरत होखे पर एडिट करीं"
    },
    imageCheck: {
      heading: "अपन फोटो चेक करीं",
      subHeading: "कृपया सुनिश्चित करीं कि फोटो पूरा, साफ आ बिना धुंध आ चमक के बा.",
      button1: "फिर से फोटो खींचीं",
      button2: "ठीक बा",
      frontHeading: "आगे के फोटो चेक करीं",
      backHeading: "पीछे के फोटो चेक करीं"
    },
    errorHandler: {
      heading: "अरे ना :(",
      subHeading1: "हमनी के कुछ परेशानी हो रहल बा, लेकिन चिंता ना करीं! कृपया फिर से कोशिश करीं",
      subHeading2: "अगर इहे समस्या जारी रहे, त बाद में चेक करीं",
      button: "फिर से कोशिश करीं"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "कृपया अपना चेहरा ढकले वाला कुछ हटा दीं",
        button: "फेर से कोशिश करीं"
      },
      eyeClosureDetected: {
        heading: "कृपया आपन आँख खुलल रखीं आ सीधा कैमरा में देखीं",
        button: "फिर से कोशिश करीं"
      },
      isMultipleFacesFound: {
        heading: "कई चेहरे पाए गए। सुनिश्चित करीं कि कैमरा में केवल आपका चेहरा ही दिखे।",
        button: "फेर से कोशिश करीं"
      },
      noFacesFound: {
        heading: "कोई चेहरा नहीं मिला। कृपया सुनिश्चित करीं कि रउआ चेहरा कैमरा में दिख रहल बा।",
        button: "फेर से कोशिश करीं"
      },
      faceDetections: {
        heading: "कृपया इह चीज हटा दीं",
        button: "फेर से कोशिश करीं"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "कई गो चेहरा मिलल बा",
          button: "फेर से कोशिश करीं"
        },
        generalMessage: {
          heading: "कृपया ई सुनिश्चित करीं कि रउआ कैमरा के सामने जिंदा बानी",
          button: "फेर से कोशिश करीं"
        }
      },
      faceMatch: {
        heading: "रउआ चेहरा पहचान पत्र के फोटो से मेल नइखे खा रहल",
        button: "फेर से कोशिश करीं"
      },
      selfieError: {
        heading: "हमनी के रउआ सेल्फी के जांच ना कर पाईल",
        subHeading1: "एह सुझावन के पालन करीं अउर फेर से कोशिश करीं",
        instruction1: "अच्छा रोशनी वाला जगह पर चलीं अउर बैक लाइट से बचीं",
        instruction2: "रउआ चेहरा पूरा तरह से नजर आ रहल होखल चाहीं अउर फ्रेम के बीच में होखल चाहीं",
        instruction3: "रउआ चेहरा साफ नजर आवे खातिर टोपी, चश्मा, या मास्क हटा दीं",
        button: "फेर से कोशिश करीं"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP मेल नहीं खाया। कृपया OTP को स्पष्ट रूप से ज़ोर से पढ़ें",
        button: "पुनः प्रयास करें"
      },
      activeLivenessGenericFailureMessage: {
        heading: "सत्यापन फेल हो गइल। कृपया निर्देश के साफ-साफ पालन करीं आ फेर से कोशिश करीं",
        button: "फेर से कोशिश करीं"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF में बहुत ढेर पन्ना बा",
        subHeading: "अपलोड कइल PDF 2-पन्ना के सीमा से ढेर बा। कृपया 2 से ढेर पन्ना ना वाला PDF, भा आपन ID के साफ फोटो अपलोड करीं।"
      },
      heading: "हमनी के रउआ पहचान पत्र के प्रोसेस ना कर सकनी",
      subHeading: "या त रउआ गलत पहचान पत्र अपलोड कर रहल बानी या फोटो साफ ना बा",
      buttonBack: "पहचान पत्र के पीछे के हिस्सा फिर से ट्राइ करीं",
      buttonFront: "पहचान पत्र के सामने के हिस्सा फिर से ट्राइ करीं",
      button: "फिर से कोशिश करीं",
      captureFrontSide: "सामने के ओर कैप्चर करीं",
      captureBackSide: "पाछे के ओर कैप्चर करीं",
      changeIDButton: "दूसरा दस्तावेज़ चुनें",
      wrongid: {
        heading: "हम इस दस्तावेज़ को प्रोसेस नहीं कर सके",
        subHeading: "कृपया सुनिश्चित करें कि आप सही दस्तावेज़ अपलोड कर रहे हैं और तस्वीर की गुणवत्ता स्पष्ट है"
      },
      expiredid: {
        heading: "आईडी दस्तावेज़ समाप्त हो चुका है!",
        subHeading: "हम समाप्त आईडी दस्तावेज़ को स्वीकार नहीं कर सकते। कृपया एक वैध दस्तावेज़ प्रदान करें"
      },
      minimumage: {
        heading: "आयु आवश्यकता पूरी नहीं हुई!",
        subHeading: "आपकी आयु न्यूनतम आवश्यक आयु से कम है। कृपया सुनिश्चित करें कि आप न्यूनतम आयु मानदंड को पूरा करते हैं"
      },
      mobileAttemptsDone: {
        heading: "यात्रा आपके पिछले डिवाइस पर पुनः शुरू हुई",
        subHeading: "यह सत्र अब डुप्लिकेशन से बचने के लिए बंद कर दिया गया है"
      },
      finished: {
        heading: "यात्रा समाप्त हो गई है",
        subHeading: "यात्रा पूरी हो गई है या समाप्त कर दी गई है"
      },
      invalid: {
        heading: "यात्रा उपलब्ध नहीं है!",
        subHeading: "या तो यात्रा आईडी नहीं मिली है या यात्रा आईडी अमान्य है"
      },
      INVALID_PAN_NUMBER: {
        heading: "अमान्य PAN नंबर",
        subHeading: "आपके द्वारा दर्ज किया गया PAN नंबर मान्य नहीं है। कृपया जांचें और पुनः प्रयास करें"
      },
      INVALID_PAN_STATUS: {
        heading: "अमान्य PAN स्थिति",
        subHeading: "आपके द्वारा दर्ज किया गया PAN नंबर मान्य नहीं है। कृपया जांचें और पुनः प्रयास करें"
      },
      directKyc: {
        heading: "डायरेक्ट KYC यात्रा !",
        subHeading: "यह एक डायरेक्ट KYC यात्रा है। फ्रंटएंड यात्रा की अनुमति नहीं है।"
      },
      DOCTYPE_FALSE: {
        heading: "दस्तावेज़ पहचाना नहीं गया!",
        subHeading: "कृपया एक वैध दस्तावेज़ अपलोड करें और सुनिश्चित करें कि इमेज गुणवत्ता अच्छी हो।"
      },
      ONLY_FRONT: {
        heading: "आईडी का पिछला हिस्सा गायब है",
        subHeading: "आपने केवल सामने वाला हिस्सा प्रदान किया है। कृपया अपनी आईडी पलटें और आगे बढ़ने के लिए पिछला हिस्सा प्रदान करें"
      },
      ONLY_BACK: {
        heading: "आईडी का अगला हिस्सा गायब है",
        subHeading: "आपने केवल पिछला हिस्सा प्रदान किया है। कृपया अपनी आईडी पलटें और आगे बढ़ने के लिए अगला हिस्सा प्रदान करें"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "दस्तावेज़ जल्द ही समाप्त होने वाला है!",
        subHeading: "दस्तावेज़ जल्द ही समाप्त होने के कारण इसे अस्वीकृत किया गया है।"
      },
      DOCUMENT_EXPIRED: {
        heading: "दस्तावेज़ समाप्त हो गया है!",
        subHeading: "कृपया एक वैध, अविभाजित दस्तावेज़ अपलोड करें।"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "आयु आवश्यकताएँ पूरी नहीं हुई!",
        subHeading: "दस्तावेज़ से पता चलता है कि आप आवश्यक आयु सीमा से मेल नहीं खाते। कृपया एक वैध दस्तावेज़ अपलोड करें।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "इमेज गुणवत्ता बहुत खराब है। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ जानकारी सत्यापित नहीं हो सकी। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ विवरण खराब इमेज गुणवत्ता के कारण सत्यापित नहीं हो सके। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ विवरण सत्यापित नहीं हो सके। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "पहचान पत्र पर आपकी फोटो सत्यापित करने में समस्या",
        subHeading: "हम पहचान पत्र पर आपकी फोटो को सत्यापित नहीं कर सके। कृपया मूल पहचान पत्र की स्पष्ट फोटो अपलोड करें ताकि हम इसकी पुष्टि कर सकें।"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "दस्तावेज़ सुरक्षा पैटर्न जाँच विफल हुई",
        subHeading: "हम दस्तावेज़ के अंतर्निहित सुरक्षा पैटर्न को सत्यापित नहीं कर सके। कृपया मूल पहचान पत्र की स्पष्ट फोटो अपलोड करें ताकि हम इसकी प्रामाणिकता की पुष्टि कर सकें।"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "दस्तावेज़ की जीवंतता जांच विफल हुई",
        subHeading: "हमें संकेत मिले हैं कि दस्तावेज़ असली नहीं हो सकता। कृपया स्क्रीनशॉट, प्रिंट की हुई कॉपी या स्क्रीन पर दिखाई गई आईडी का उपयोग न करें। मूल आईडी अपलोड करें जिसमें सभी विशेषताएँ स्पष्ट रूप से दिखें।"
      },
      SECURITY_FALSE: {
        heading: "समस्या पाई गई!",
        subHeading: "दस्तावेज़ सत्यापित नहीं हो सका। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "खराब इमेज गुणवत्ता!",
        subHeading: "इमेज बहुत धुंधली या अस्पष्ट है। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      FACE_UNDETECTED: {
        heading: "चेहरा नहीं मिला",
        subHeading: "हम दस्तावेज़ पर कोई स्पष्ट चेहरा नहीं देख सके। कृपया ऐसा वैध पहचान पत्र अपलोड करें, जिसमें चेहरा साफ़ दिखाई दे।"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "दस्तावेज़ों के बीच तुलना विफल",
        subHeading: "एक या अधिक मुख्य फ़ील्ड (नाम, जन्म तिथि, या चेहरा) में बेमेल के कारण दस्तावेज़ों के बीच तुलना विफल रही"
      },
      DIGILOCKER_FAILURE: {
        heading: "डिजिलॉकर विफलता",
        subHeading: "डिजिलॉकर यात्रा के दौरान एक त्रुटि हुई। कृपया पुनः प्रयास करें या जारी रखने के लिए कोई वैकल्पिक तरीका उपयोग करें।"
      },
      LINKAGE_FAILED: {
        heading: "ई सत्यापन पूरा ना हो सकल",
        subHeading: "ई जाँच खातिर लिहल गइल विवरण रिकॉर्ड से ना मिलल।"
      }
    },
    biometricConsent: {
      consentStatement: "अपनी सेल्फ़ी से पहले, आपकी पहचान सत्यापित करने के लिए हमें आपके बायोमेट्रिक डेटा (चेहरे की छवि और लाइवनेस संकेत) को कैप्चर और प्रोसेस करने की आपकी सहमति चाहिए। इस डेटा का उपयोग केवल इसी सत्यापन के लिए किया जाता है।",
      privacyPolicy: "गोपनीयता नीति",
      consentButton: "मैं सहमत हूँ — जारी रखें",
      declineButton: "मैं सहमत नहीं हूँ",
      confirmTitle: "बायोमेट्रिक सत्यापन के बिना आगे बढ़ें?",
      confirmBody: "बायोमेट्रिक सत्यापन के बिना, हम सेल्फ़ी कैप्चर नहीं करेंगे। आपका सत्यापन आपके द्वारा पहले से दी गई जानकारी का उपयोग करके पूरा किया जाएगा। यह चयन इस सत्र के लिए अंतिम है।",
      goBack: "वापस जाएँ",
      confirmDecline: "पुष्टि करें — सहमत नहीं",
      declineComplete: "आपने बायोमेट्रिक सत्यापन के साथ आगे न बढ़ने का विकल्प चुना है। आपकी पहचान का सत्यापन आपके द्वारा सबमिट किए गए दस्तावेज़ों का उपयोग करके पूरा कर लिया गया है।"
    },
    introLiveness: {
      heading: "यहाँ पुष्टि करीं कि रउआ जिंदा बानी",
      instruction1: "सुनिश्चित करीं कि पर्याप्‍त रोशनी बा",
      instruction2: "जरूरी अनुमति दीं",
      instruction3: "बस निर्देश के पालन करीं",
      button: "आगे बढ़ीं",
      subHeading: "आप बस एक कदम दूर हैं"
    },
    phoneSession: {
      heading: "सेशन मोबाइल पर जारी बा",
      subheading: "मोबाइल पर पूरा होखे तक इ विंडो खुलल रखीं",
      button: "यहाँ जारी रखीं"
    },
    continueOnPhone: {
      heading: "मोबाइल पर जारी रखीं",
      subheading: "QR स्कैन करीं या नीचे के लिंक कॉपी करीं",
      subheading2: "QR स्कैन करीं या लिंक के मोबाइल पर खोलीं",
      text: "प्रक्रिया पूरा करीं",
      text1: "यहाँ वापस आके सबमिट करीं",
      button: "कॉपी करीं",
      copiedButton: "कॉपी हो गइल!",
      copied: "कॉपी हो गइल!"
    },
    SsnReview: {
      heading: "अपन डिटेल्स के समीक्षा करीं",
      subHeading: "जरूरी बदलाव करीं आ डिटेल्स सबमिट करीं",
      feild1: "ड्राइविंग लाइसेंस",
      feild2: "समाप्ति",
      feild3: "जन्म तिथि",
      feild4: "वर्ग",
      feild5: "प्रतिबंध",
      feild6: "देश",
      feild7: "पता",
      button: "डिटेल्स सही बा"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "आपन चेहरा गोला में राखीं"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "कैमरा के लगे आईं"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "लजाईं मत, सामने आईं"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत अन्हार बा। अउरी अंजोर में जाईं"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत अंजोर बा। हल्का अंजोर में जाईं"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "आपन चेहरा गोला में राखीं"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर रहीं"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "अंजोर के ओर चेहरा करीं"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "फोन के आँख के बराबर राखीं"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कैमरा से थोड़ा दूर हटीं"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "आपन चेहरा फ्रेम के बीच में राखीं"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "आपन चेहरा गोला के बीच में रखीं"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "नजदीक आईं अउर चेहरा सीधा रखीं"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "नजर में आईं अउर चेहरा सीधा रखीं"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत अंधेरा बा. अधिक रोशनी खोजीं"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत रोशनी बा. उपयुक्त रोशनी खोजीं"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "आपन चेहरा गोला के बीच में सेट करीं"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर रहीं अउर सीधे आगे देखीं"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "रोशनी की ओर मुँह करीं अउर स्थिर रहीं"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "अपन फोन के आँख के स्तर पर रखीं"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कैमरा से थोड़ा दूर हटीं"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "एकदम सही!"
      },
      smile1: {
        icon: "mood",
        description: "मुस्कराईं, रउआ बहुत बढ़िया लागत बानी!"
      },
      smile2: {
        icon: "mood",
        description: "कैमरा खातिर मुस्कराईं!"
      }
    },
    successful: {
      title: "सत्यापन पूरा भइल",
      text: "अब रउआ विंडो बंद कर सकेनी",
      finishBtn: "पूरा करीं"
    },
    poweredBy: "द्वारा प्रदान कइल बा",
    redirect: "में पुनर्निर्देशित हो रहल बा",
    error: {
      message: "URL समाप्त भ गइल बा या अमान्य बा"
    },
    footer: {
      securedBy: "द्वारा प्रदान कइल बा"
    },
    helpFaq: {
      title: "सहायता & अक्सर पूछे जाने वाले सवाल",
      subtitle: "हम यहां आपकी मदद के लिए हैं",
      cameraText: "आपकी पहचान की पुष्टि करने के लिए, हमें आपके डिवाइस के कैमरे का उपयोग करके तस्वीरें लेनी होंगी। आवश्यक अनुमतियाँ कैसे दें, यह जानने के लिए इस link का पालन करें",
      cameraHeading: "कैमरा अनुमति",
      languageText: "प्रक्रिया की शुरुआत में, आप ऊपर की मेनू से अपनी पसंदीदा भाषा चुन सकते हैं",
      languageHeading: "भाषा चयन",
      kycText: "KYC, या 'अपने ग्राहक को जानें', एक प्रक्रिया है जिसके द्वारा ग्राहक की पहचान को सत्यापित किया जाता है, यह अनुपालन सुनिश्चित करने और धोखाधड़ी तथा अन्य अवैध गतिविधियों को रोकने में मदद करता है",
      kycHeading: "KYC क्या है?",
      timeText: "आमतौर पर, इसमें लगभग 60 सेकंड का समय लगता है। हालांकि, यह देशों के आधार पर भिन्न हो सकता है",
      timeHeading: "इसमें कितना समय लगेगा?"
    },
    pdfPreviewUnavailable: "PDF का पूर्वावलोकन दिखाने में असमर्थ।",
    pdfPreviewHint: "यदि पूर्वावलोकन दिखाई न दे, तो भी आप आगे बढ़ सकते हैं।",
    pdfOpenLabel: "PDF खोलें",
    onlyIdVerificationHeader: {
      title: "आइए आपकी पहचान की पुष्टि करें",
      subtitle: "यह केवल एक मिनट का समय लेगा। कृपया अपना पहचान पत्र तैयार रखें।",
      instruction1: "कैमरे की अनुमति दें",
      instruction2: "अपना दस्तावेज़ स्कैन या अपलोड करें",
      instruction3: "त्वरित दस्तावेज़ सत्यापन"
    },
    failedUpload: {
      title: "फ़ाइल अपलोड विफल",
      text: "कृपया सुनिश्चित करें कि फ़ाइल 5MB से कम और .jpg, .jpeg, .png, .heic, .heif या .pdf प्रारूप में है",
      btn: "पुनः प्रयास करें",
      pdfNotAllowedIndia: "भारत खातिर PDF अपलोड के अनुमति नइखे। कृपया 5 MB से कम के JPEG, JPG, PNG, HEIC, या HEIF फाइल अपलोड करीं।",
      pdfNotAllowedIndiaBasic: "भारत खातिर PDF अपलोड के अनुमति नइखे। कृपया 5 MB से कम के JPEG, JPG, या PNG फाइल अपलोड करीं।"
    },
    livenessAnalyzing: {
      heading: "आपके चेहरे का विश्लेषण किया जा रहा है",
      subHeading: "कृपया प्रतीक्षा करें, इसमें केवल कुछ सेकंड लगेंगे"
    },
    sessionExpiredError: {
      heading: "माफ करें, आपकी सत्र समाप्त हो गया है",
      subHeading1: "आप कुछ समय के लिए निष्क्रिय रहे हैं। सुरक्षा कारणों से, आपकी सत्र स्वचालित रूप से समाप्त हो गई है",
      subHeading2: "कृपया पुनः प्रयास करें",
      buttonText: "फिर से प्रयास करें"
    },
    journeyExpiredError: {
      heading: "माफ करें, लिंक समाप्त हो गया है",
      subHeading1: "लिंक अब सक्रिय नहीं है। सुरक्षा कारणों से, लिंक की एक सीमित अवधि होती है",
      subHeading2: "कृपया नए लिंक के साथ प्रयास करें",
      buttonText: "फिर से प्रयास करें"
    },
    cameraAccessError: {
      alert1: "कैमरा एक्सेस अस्वीकृत किया गया। कृपया अपने ब्राउज़र सेटिंग्स में कैमरा एक्सेस सक्षम करें",
      alert2: "कैमरा एक्सेस करते समय एक त्रुटि हुई",
      alert3: "आपका ब्राउज़र कैमरा एक्सेस का समर्थन नहीं करता"
    },
    activeLiveness: {
      instruction: "अपना चेहरा गोले में रखें और निर्देशों का पालन करें",
      permissionDeniedTitle: "कैमरा या माइक्रोफ़ोन एक्सेस अस्वीकृत",
      permissionDeniedSubtitle: "कृपया अपनी ब्राउज़र सेटिंग्स में कैमरा और माइक्रोफ़ोन एक्सेस की अनुमति दें और पुनः प्रयास करें।"
    },
    flipScreen: {
      heading: "अब आपन आईडी कार्ड पलटीं",
      subHeading: "कृपया पाछू के हिस्सा देखावे खातिर आपन आईडी कार्ड पलटीं, फेर ओकरा के कैमरा फ्रेम में राखीं।",
      continueButton: "आगे बढ़ीं"
    },
    mobileDocCapture: {
      frontSide: "आगे के ओर",
      backSide: "पाछे के ओर",
      of: "के",
      upload: "अपलोड करीं",
      stillNotWorking: "अबहियों ना चलत बा?",
      clickToCapture: "क्लिक-टू-कैप्चर आजमाईं",
      skip: "छोड़ीं"
    }
,
    permissionPopUp: {
      title: "अनुमति जरूरी बा",
      subtitle: "कैमरा इस्तेमाल करे खातिर पहुँच के अनुमति दीं",
      decline: "मना करीं",
      allow: "अनुमति दीं"
    },
    userDetails: {
      heading: "PAN सत्यापन",
      subHeading: "सत्यापन खातिर कृपया विवरण भरीं",
      panLabel: "PAN नंबर",
      panRequired: "कृपया आपन PAN नंबर डालीं",
      saveError: "विवरण सहेजत घरी कुछ गलत हो गइल। कृपया फेर से कोशिश करीं।",
      proceed: "आगे बढ़ीं"
    },
    redirectCta: {
      or: "भा",
      clickHere: "इहाँ क्लिक करीं",
      clickHereStart: "इहाँ क्लिक करीं",
      toContinue: "जारी रखे खातिर"
    },
    documentCapture: {
      stillNotWorking: "अबहियो काम ना करत बा?",
      clickToCaptureInstead: "एकरा बजाय क्लिक-टू-कैप्चर आजमाईं",
      pdfNotAllowedIndia: "भारत खातिर PDF अपलोड के अनुमति नइखे। कृपया 5 MB से कम के JPEG, JPG, भा PNG फाइल अपलोड करीं।",
      pdfNotAllowedIndiaMobile: "भारत खातिर PDF अपलोड के अनुमति नइखे। कृपया 5 MB से कम के JPEG, JPG, PNG, HEIC, भा HEIF फाइल अपलोड करीं।",
      fileFormatsIndia: "jpeg, jpg, png 5 mb से कम",
      fileFormats: "jpeg, jpg, png, pdf 5 mb से कम",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb से कम",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb से कम"
    },
    mobileCapture: {
      upload: "अपलोड करीं",
      skip: "छोड़ीं",
      stillNotWorking: "तबो ना काम कर रहल बा?",
      tryClickToCapture: "टैप क के फोटो लीं"
    },
    UserDetails: {
      panLabel: "PAN नंबर",
      proceedBtn: "आगे बढ़ीं",
      panRequired: "कृपया आपन PAN नंबर डालीं",
      saveError: "विवरण सेव करत घरी कुछ गलत हो गइल। कृपया फेर से कोशिश करीं।"
    }
  },
  fil: {
    header: {
      title: "I-verify natin ang iyong pagkakakilanlan",
      subtitle: "Tumatagal ito ng mas mababa sa 2 minuto",
      havingIssue: "May problema?"
    },
    onlyIdVerificationHeader: {
      title: "I-verify natin ang iyong ID",
      subtitle: "Matatapos ito sa ilang minuto. Ihanda lang ang iyong valid ID",
      instruction1: "Payagan ang access sa camera",
      instruction2: "I-scan o i-upload ang iyong dokumento",
      instruction3: "Agad na ma-verify ang iyong ID"
    },
    subHeading: {
      subHeading1: "I-capture ang iyong ID na dokumento",
      subHeading2: "I-verify na ikaw ay buhay",
      livenessHeading1: "Maghanap ng lugar na may magandang ilaw",
      livenessHeading2: "Panatilihin ang iyong mukha sa gitna"
    },
    termsAndCondition: {
      title: "Sumasang-ayon ako at sumusunod sa mga sumusunod na mga tuntunin at kundisyon.",
      privacyPolicy: "Tingnan ang mga tuntunin",
      beginBtnText: "Simulan",
      beginLiveness: "Sinisimulan ang pag-verify ng pagiging buhay",
      startLiveness: "Magpatuloy sa pag-verify ng pagiging buhay"
    },
    permissionDenied: {
      title: "Tinanggihan ang pag-access sa camera!",
      subtitle: "Suriin kung may naka-block na icon ng camera malapit sa address bar ng browser at i-unblock ito.",
      readMore: "Magbasa Pa",
      refreshText: "Kapag pinayagan na ang pag-access sa camera, i-click ang button na I-refresh sa ibaba.",
      refreshBtn: "I-refresh",
      link: "O, Magpatuloy sa Telepono",
      buttonText: "O, Magpatuloy sa Telepono"
    },
    desktopBrowserPermissionDenied: {
      title: "Mangyaring payagan ang pag-access sa camera",
      subtitle: "Maaaring hilingin ng browser ang mga pahintulot. Mangyaring i-click ang 'payagan' upang magpatuloy.",
      readMore: "Magbasa Pa",
      refreshText: "I-refresh pagkatapos ibigay ang mga pahintulot",
      refreshBtn: "I-refresh",
      link: "O, Magpatuloy sa Telepono",
      buttonText: "O, Magpatuloy sa Telepono"
    },
    androidBrowserPermissionDenied: {
      title: "Tinanggihan ang pag-access sa camera",
      subtitle: "Suriin kung may naka-block na icon ng camera malapit sa address bar ng browser at i-unblock ito.",
      readMore: "Matuto pa",
      refreshText: "Kapag pinayagan na ang access sa camera, i-click ang Refresh button sa ibaba.",
      refreshBtn: "I-refresh",
      link: "O, Magpatuloy sa Telepono",
      buttonText: "O, Magpatuloy sa Telepono"
    },
    androidWebViewPermissionDenied: {
      title: "Tinanggihan ang pag-access sa camera",
      subtitle: "Maaaring naka-block ang access sa camera mula sa app settings. Pumunta sa App Info > Permissions > Camera at payagan ang access.",
      refreshText: "Kapag pinayagan na ang access sa camera, i-click ang Refresh button sa ibaba.",
      refreshBtn: "I-refresh",
      link: "O, Magpatuloy sa Telepono",
      buttonText: "O, Magpatuloy sa Telepono"
    },
    iosBrowserPermissionDenied: {
      title: "Tinanggihan ang pag-access sa camera",
      subtitle: "I-tap ang camera o lock icon malapit sa address bar upang payagan ang access, o buksan ang browser settings.",
      readMore: "Matuto pa",
      refreshText: "Kapag pinayagan na ang access sa camera, i-click ang Refresh button sa ibaba.",
      refreshBtn: "I-refresh",
      link: "O, Magpatuloy sa Telepono",
      buttonText: "O, Magpatuloy sa Telepono"
    },
    iosWebViewPermissionDenied: {
      title: "Tinanggihan ang pag-access sa camera",
      subtitle: "Maaaring naka-block ang access sa camera mula sa settings ng app. Pumunta sa Settings, hanapin ang app, at i-enable ang Camera permission.",
      refreshText: "Kapag pinayagan na ang access sa camera, i-click ang Refresh button sa ibaba.",
      refreshBtn: "I-refresh",
      link: "O, Magpatuloy sa Telepono",
      buttonText: "O, Magpatuloy sa Telepono"
    },
    documentationList: {
      countryHeading: "Piliin ang bansa",
      docHeading: "Piliin ang iyong dokumento",
      btnText: "Susunod",
      searchCountry: "Maghanap ng bansa"
    },
    frontDocCapture: {
      heading: "Ilagay ang harap na bahagi ng ID sa loob ng parihaba",
      backupHeading: "May Problema? Mangyaring i-click ang imahe nang manu-mano",
      btnText: "Kumuha ng larawan",
      headingBack: " sa loob ng rektanggulo",
      uploadButton: "o, mag-upload ng ID"
    },
    backDocCapture: {
      heading: "Ilagay ang likod na bahagi ng ID sa loob ng parihaba",
      backupHeading: "May Problema? Mangyaring i-click ang imahe nang manu-mano",
      btnText: "Kumuha ng larawan",
      containerText: "o, mag-upload ng dokumento",
      text: "Kinukuha, manatiling steady",
      headingBack: " sa loob ng rektanggulo",
      skipButton: "Laktawan ang Likod",
      uploadButton: "o, mag-upload ng ID"
    },
    analyzing: {
      heading: "Ina-analyze ang iyong ID...",
      subHeading: "Pakitignan ang mga detalye ng iyong card sa susunod na screen at i-edit kung kinakailangan"
    },
    imageCheck: {
      heading: "Suriin ang iyong imahe",
      subHeading: "Siguraduhin na ang imahe ay kumpleto, malinaw, at walang blurr at glare.",
      button1: "Kumuha ulit ng larawan",
      button2: "Ok na ito",
      frontHeading: "Suriin ang harapang imahe",
      backHeading: "Suriin ang likurang imahe"
    },
    errorHandler: {
      heading: "Naku :(",
      subHeading1: "Nagkakaroon kami ng ilang mga isyu, ngunit huwag mag-alala! Mangyaring subukan ulit",
      subHeading2: "Kung magpapatuloy ito, subukan ulit mamaya",
      button: "Subukan ulit"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Paki-alis ang anumang bagay na nagtatakip sa iyong mukha",
        button: "Subukang muli"
      },
      eyeClosureDetected: {
        heading: "Mangyaring imulat ang iyong mga mata at tumingin nang direkta sa kamera",
        button: "Subukang muli"
      },
      isMultipleFacesFound: {
        heading: "Maraming mukha ang natukoy. Siguraduhing ang iyong mukha lamang ang nakikita sa camera.",
        button: "Subukang muli"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Subukang muli"
      },
      faceDetections: {
        heading: "Paki-alis ito",
        button: "Subukang muli"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Maraming mukha ang nakita",
          button: "Subukang muli"
        },
        generalMessage: {
          heading: "Paki-tiyak na ikaw ay buhay at nasa harap ng kamera",
          button: "Subukang muli"
        }
      },
      faceMatch: {
        heading: "Ang iyong mukha ay hindi tumutugma sa larawan ng ID",
        button: "Subukang muli"
      },
      selfieError: {
        heading: "Hindi namin ma-verify ang iyong selfie",
        subHeading1: "Sundin ang mga tip na ito at subukang muli",
        instruction1: "Pumunta sa isang lugar na may magandang ilaw at iwasan ang backlight",
        instruction2: "Siguraduhin na ang iyong mukha ay ganap na nakikita at nasa gitna ng frame",
        instruction3: "Alisin ang mga sombrero, salamin, o maskara para malinaw na makita ang iyong mukha",
        button: "Subukang muli"
      },
      activeLivenessOtpFailureMessage: {
        heading: "Hindi tumugma ang OTP. Pakibasa nang malinaw at malakas ang OTP",
        button: "Subukang Muli"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Nabigo ang pag-verify. Pakisunod nang malinaw ang mga tagubilin at subukang muli",
        button: "Subukang muli"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "Masyadong maraming pahina ang PDF",
        subHeading: "Ang na-upload na PDF ay lumampas sa limitasyong 2 pahina. Mangyaring mag-upload ng PDF na hindi hihigit sa 2 pahina, o malinaw na larawan ng iyong ID."
      },
      heading: "Hindi namin ma-proseso ang iyong ID",
      subHeading: "Maaari kang nag-a-upload ng maling ID o ang imahe ay hindi malinaw",
      buttonBack: "Subukang muli ang likod na bahagi ng ID",
      buttonFront: "Subukang muli ang harap na bahagi ng ID",
      button: "Subukan ulit",
      captureFrontSide: "Kunan ang Harapang Bahagi",
      captureBackSide: "Kunan ang Likurang Bahagi",
      changeIDButton: "Pumili ng Ibang Dokumento",
      wrongid: {
        heading: "Hindi namin maproseso ang dokumentong ito",
        subHeading: "Pakitiyak na tama ang dokumentong ina-upload mo at tiyakin na malinaw ang kalidad ng larawan"
      },
      expiredid: {
        heading: "Nag-expire na ang ID Document!",
        subHeading: "Hindi namin matatanggap ang nag-expire na ID document. Pakibigay ang wastong dokumento"
      },
      minimumage: {
        heading: "Hindi Natugunan ang Kinakailangang Edad!",
        subHeading: "Ang iyong edad ay mas mababa sa pinakamababang kinakailangang edad. Pakitiyak na natutugunan mo ang pamantayan sa pinakamababang edad"
      },
      mobileAttemptsDone: {
        heading: "Ipinagpatuloy ang journey sa iyong nakaraang device",
        subHeading: "Itinigil na ang session na ito upang maiwasan ang pagdoble."
      },
      finished: {
        heading: "Natapos na ang journey",
        subHeading: "Ang journey ay natapos na o winakasan na"
      },
      invalid: {
        heading: "Hindi Available ang Journey !",
        subHeading: "Walang nakitang journeyId o di-wasto ang journey ID"
      },
      INVALID_PAN_NUMBER: {
        heading: "Di-wastong PAN Number",
        subHeading: "Ang PAN number na inilagay mo ay hindi wasto. Pakisuri at subukang muli"
      },
      INVALID_PAN_STATUS: {
        heading: "Di-wastong PAN Status",
        subHeading: "Ang PAN number na inilagay mo ay hindi wasto. Pakisuri at subukang muli"
      },
      directKyc: {
        heading: "Direktang KYC Journey !",
        subHeading: "Ito ay isang direktang KYC journey. Hindi pinapayagan ang frontend journey."
      },
      DOCTYPE_FALSE: {
        heading: "Maling Dokumento ang Ibinigay!",
        subHeading: "Pakii-upload ang wastong dokumento at tiyakin na maganda ang kalidad ng larawan."
      },
      ONLY_FRONT: {
        heading: "Nawawala ang likod ng ID",
        subHeading: "Ibinigay mo lang ang harapan. Pakibaliktad ang iyong ID at ibigay ang likod upang magpatuloy"
      },
      ONLY_BACK: {
        heading: "Nawawala ang harap ng ID",
        subHeading: "Ibinigay mo lang ang likod. Pakibaliktad ang iyong ID at ibigay ang harapan upang magpatuloy"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Malapit nang Mag-expire ang Dokumento",
        subHeading: "Tinanggihan ang dokumento dahil malapit na itong mag-expire."
      },
      DOCUMENT_EXPIRED: {
        heading: "Nag-expire na ang Dokumento!",
        subHeading: "Pakii-upload ang wasto at hindi pa nag-e-expire na dokumento upang magpatuloy."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Hindi Natugunan ang Kinakailangang Edad!",
        subHeading: "Ipinapakita ng dokumento na hindi mo natutugunan ang kinakailangang edad. Pakii-upload ang wastong dokumento."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Hindi Ma-verify ang Dokumento!",
        subHeading: "Masyadong mababa ang kalidad ng larawan para sa pag-verify. Pakisubukang muli gamit ang mas malinaw na larawan."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Hindi Ma-verify ang Dokumento!",
        subHeading: "May ilang impormasyong hindi ma-verify. Pakisubukang muli gamit ang mas malinaw na larawan."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Hindi Ma-verify ang Dokumento!",
        subHeading: "May ilang detalyeng hindi ma-verify dahil sa mababang kalidad ng larawan. Pakisubukang muli gamit ang mas malinaw na larawan"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Hindi Ma-verify ang Dokumento!",
        subHeading: "May ilang detalyeng hindi ma-verify. Pakisubukang muli gamit ang mas malinaw na larawan."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problema sa pag-verify ng iyong larawan sa ID",
        subHeading: "Hindi namin ma-verify ang iyong larawan sa ID card. Pakii-upload ang malinaw na larawan ng iyong orihinal na ID upang makumpirma namin ito."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Nabigo ang pagsusuri ng security pattern ng dokumento",
        subHeading: "Hindi namin ma-verify ang built-in na mga security pattern ng dokumento. Pakii-upload ang malinaw na larawan ng orihinal na ID upang matulungan kaming kumpirmahin ang pagiging tunay nito."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Nabigo ang Liveness Check ng Dokumento",
        subHeading: "May nakita kaming mga senyales na maaaring hindi tunay ang dokumento. Pakiiwasan ang paggamit ng mga screenshot, naka-print na kopya, o pagpapakita ng ID sa screen. I-upload ang orihinal na ID na malinaw na nakikita ang lahat ng feature"
      },
      SECURITY_FALSE: {
        heading: "May Natukoy na Problema!",
        subHeading: "Hindi ma-verify ang dokumento. Pakisubukang muli gamit ang mas malinaw na larawan"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Mababang Kalidad ng Larawan!",
        subHeading: "Masyadong malabo o hindi malinaw ang larawan. Pakisubukang muli gamit ang mas malinaw na larawan"
      },
      FACE_UNDETECTED: {
        heading: "Walang Natukoy na Mukha",
        subHeading: "Hindi kami makahanap ng nakikitang mukha sa dokumento. Pakii-upload ang wastong ID kung saan malinaw na nakikita ang mukha"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Nabigo ang Paghahambing sa Pagitan ng mga Dokumento",
        subHeading: "Nabigo ang paghahambing sa pagitan ng mga dokumento dahil sa hindi pagtutugma sa isa o higit pang pangunahing field (Pangalan, Petsa ng Kapanganakan, o Mukha)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Pagkabigo ng Digilocker",
        subHeading: "May naganap na error sa panahon ng Digilocker journey. Pakisubukang muli o gumamit ng alternatibong paraan upang magpatuloy."
      },
      LINKAGE_FAILED: {
        heading: "Hindi makumpleto ang beripikasyong ito",
        subHeading: "Ang mga detalyeng nakuha ay hindi tumugma sa mga tala para sa pagsusuring ito."
      }
    },
    biometricConsent: {
      consentStatement: "Bago ang iyong selfie, kailangan namin ang iyong pahintulot na kunin at iproseso ang iyong biometric data (larawan ng mukha at mga senyales ng liveness) upang beripikahin ang iyong pagkakakilanlan. Ginagamit lamang ang data na ito para sa pagberipika na ito.",
      privacyPolicy: "Patakaran sa privacy",
      consentButton: "Pumapayag ako — Magpatuloy",
      declineButton: "Hindi ako pumapayag",
      confirmTitle: "Magpatuloy nang walang biometric verification?",
      confirmBody: "Kung walang biometric verification, hindi kami kukuha ng selfie. Kukumpletuhin ang iyong pagberipika gamit ang impormasyong naibigay mo na. Pinal ang pagpiling ito para sa session na ito.",
      goBack: "Bumalik",
      confirmDecline: "Kumpirmahin — hindi pumapayag",
      declineComplete: "Pinili mong huwag ipagpatuloy ang biometric verification. Nakumpleto na ang pagberipika sa iyong pagkakakilanlan gamit ang mga dokumentong isinumite mo."
    },
    introLiveness: {
      heading: "Kumpirmahin na ikaw ay buhay dito",
      instruction1: "Siguraduhing may sapat na ilaw",
      instruction2: "Payagan ang kinakailangang mga pahintulot",
      instruction3: "Sundin lamang ang mga tagubilin",
      button: "Magpatuloy",
      subHeading: "Isang hakbang na lang ang natitira sa iyo"
    },
    phoneSession: {
      heading: "Ang session ay ipagpapatuloy sa telepono",
      subheading: "Panatilihing bukas ang window na ito hanggang matapos sa mobile",
      button: "Ipagpatuloy dito"
    },
    continueOnPhone: {
      heading: "Ipagpatuloy sa telepono",
      subheading: "I-scan ang QR o kopyahin ang link sa ibaba",
      subheading2: "I-scan ang QR o buksan ang link sa iyong telepono",
      text: "Tapusin ang proseso",
      text1: "Balikan dito upang magsumite",
      button: "Kopyahin",
      copiedButton: "Nakopya na!",
      copied: "Nakopya na!"
    },
    SsnReview: {
      heading: "Suriin ang iyong mga detalye",
      subHeading: "Gawin ang kinakailangang mga pagbabago at isumite ang mga detalye",
      feild1: "Lisensya sa Pagmamaneho",
      feild2: "Expiry",
      feild3: "Petsa ng Kapanganakan",
      feild4: "Klase",
      feild5: "Mga Paghihigpit",
      feild6: "Bansa",
      feild7: "Address",
      button: "Tama ang mga detalye"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Panatilihin ang mukha sa loob ng bilog"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Lumapit sa camera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Huwag mahiya, pumasok sa view"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Masyadong madilim. Maghanap ng mas maliwanag"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Masyadong maliwanag. Maghanap ng mas malambot na ilaw"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Panatilihin ang mukha sa loob ng bilog"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Huwag gumalaw"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Iharap ang mukha sa ilaw"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Hawakan ang telepono sa antas ng mata"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Lumayo nang kaunti sa camera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Igitna ang mukha sa frame"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Ilagay ang iyong mukha sa gitna ng bilog"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Lumapit at panatilihing tuwid ang iyong mukha"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Pumasok sa view at panatilihing tuwid ang iyong mukha"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Masyadong madilim. Humanap ng mas maliwanag na ilaw"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Masyadong maliwanag. Humanap ng tamang ilaw"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "I-adjust ang iyong mukha sa gitna ng bilog"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Manatiling matatag at tumingin nang diretso sa harap"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Harapin ang ilaw at manatiling matatag"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Ilagay ang telepono sa antas ng mata"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Lumayo nang kaunti sa camera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perpekto!"
      },
      smile1: {
        icon: "mood",
        description: "Ngumiti ka, maganda ang itsura mo!"
      },
      smile2: {
        icon: "mood",
        description: "Ngumiti ka para sa camera!"
      }
    },
    successful: {
      title: "Kompleto na ang Pag-verify",
      text: "Maaari mo nang isara ang window",
      finishBtn: "Tapusin"
    },
    poweredBy: "Pinapatakbo ng",
    redirect: "Nire-redirect sa",
    error: {
      message: "Ang URL ay nag-expire o hindi valid"
    },
    footer: {
      securedBy: "Pinapatakbo ng"
    },
    helpFaq: {
      title: "Tulong & Mga Madalas Itanong",
      subtitle: "Narito kami upang tulungan ka",
      cameraText: "Upang i-verify ang iyong pagkakakilanlan, kakailanganin naming kumuha ng mga larawan gamit ang camera ng iyong device. Sundan ang link na ito upang malaman kung paano bigyan ng kinakailangang permiso",
      cameraHeading: "Pahintulot sa Camera",
      languageText: "Sa simula ng proseso, maaari mong piliin ang iyong nais na wika mula sa dropdown menu sa itaas na bahagi ng bar",
      languageHeading: "Pagpili ng Wika",
      kycText: "Ang KYC, o 'Kilalanin ang Iyong Customer', ay isang proseso ng pag-verify ng pagkakakilanlan ng customer, na tumutulong sa pagpapairal ng mga regulasyon at pag-iwas sa pandaraya at iba pang ilegal na gawain",
      kycHeading: "Ano ang KYC?",
      timeText: "Karaniwan, tumatagal ito ng mga 60 segundo. Gayunpaman, maaaring magbago ito depende sa mga bansa",
      timeHeading: "Gaano katagal ito aabutin?"
    },
    pdfPreviewUnavailable: "Hindi maipakita ang preview para sa PDF.",
    pdfPreviewHint: "Kung hindi lumitaw ang preview, maaari ka pa ring magpatuloy.",
    pdfOpenLabel: "Buksan ang PDF",
    failedUpload: {
      title: "Nabigo ang Pag-upload ng File",
      text: "Pakitiyak na ang file ay mas mababa sa 5MB at nasa format na .jpg, .jpeg, .png, .heic, .heif, o .pdf",
      btn: "Subukang Muli",
      pdfNotAllowedIndia: "Hindi pinapayagan ang pag-upload ng PDF para sa India. Mag-upload ng JPEG, JPG, PNG, HEIC, o HEIF na file na wala pang 5 MB.",
      pdfNotAllowedIndiaBasic: "Hindi pinapayagan ang pag-upload ng PDF para sa India. Mag-upload ng JPEG, JPG, o PNG na file na wala pang 5 MB."
    },
    livenessAnalyzing: {
      heading: "Sinusuri ang Iyong Mukha",
      subHeading: "Pakihintay, ilang segundo lang ito"
    },
    sessionExpiredError: {
      heading: "Paumanhin, nag-time out na ang iyong session",
      subHeading1: "Matagal kang hindi aktibo. Para sa seguridad, awtomatikong nag-expire ang iyong session",
      subHeading2: "Pakisubukang muli",
      buttonText: "Subukang Muli"
    },
    journeyExpiredError: {
      heading: "Paumanhin, nag-expire na ang link",
      subHeading1: "Hindi na aktibo ang link. Para sa seguridad, may limitadong tagal ang mga link",
      subHeading2: "Pakisubukan gamit ang bagong link",
      buttonText: "Subukang Muli"
    },
    cameraAccessError: {
      alert1: "Tinanggihan ang access sa camera. Paki-enable ang access sa camera sa mga setting ng iyong browser",
      alert2: "May naganap na error habang ina-access ang camera",
      alert3: "Hindi sinusuportahan ng iyong browser ang access sa camera"
    },
    activeLiveness: {
      instruction: "Panatilihin ang iyong mukha sa loob ng bilog at sundin ang mga tagubilin",
      permissionDeniedTitle: "Tinanggihan ang Access sa Camera o Mikropono",
      permissionDeniedSubtitle: "Pakipayagan ang access sa camera at mikropono sa mga setting ng iyong browser at subukang muli."
    },
    flipScreen: {
      heading: "Ngayon, i-flip ang iyong ID",
      subHeading: "Pakibaligtad nang pisikal ang iyong ID upang ipakita ang likod, pagkatapos ay iposisyon ito sa loob ng frame ng camera.",
      continueButton: "Magpatuloy"
    },
    mobileDocCapture: {
      frontSide: "Harapang Bahagi",
      backSide: "Likurang Bahagi",
      of: "ng",
      upload: "I-upload",
      stillNotWorking: "Hindi pa rin gumagana?",
      clickToCapture: "Subukan ang click-to-capture",
      skip: "Laktawan"
    }
,
    permissionPopUp: {
      title: "Kailangan ng pahintulot",
      subtitle: "Payagan ang access para magamit ang camera",
      decline: "Tanggihan",
      allow: "Payagan"
    },
    userDetails: {
      heading: "Pag-verify ng PAN",
      subHeading: "Pakipunan ang mga detalye upang ma-verify",
      panLabel: "PAN Number",
      panRequired: "Pakilagay ang iyong PAN number",
      saveError: "May mali sa pag-save ng mga detalye. Pakisubukang muli.",
      proceed: "Magpatuloy"
    },
    redirectCta: {
      or: "o",
      clickHere: "i-click dito",
      clickHereStart: "I-click dito",
      toContinue: "upang magpatuloy"
    },
    documentCapture: {
      stillNotWorking: "Hindi pa rin gumagana?",
      clickToCaptureInstead: "Subukan ang click-to-capture sa halip",
      pdfNotAllowedIndia: "Hindi pinapayagan ang pag-upload ng PDF para sa India. Mag-upload ng mga JPEG, JPG, o PNG na file na mas mababa sa 5 MB.",
      pdfNotAllowedIndiaMobile: "Hindi pinapayagan ang pag-upload ng PDF para sa India. Mag-upload ng mga JPEG, JPG, PNG, HEIC, o HEIF na file na mas mababa sa 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png mas mababa sa 5 mb",
      fileFormats: "jpeg, jpg, png, pdf mas mababa sa 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif mas mababa sa 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf mas mababa sa 5 mb"
    },
    mobileCapture: {
      upload: "I-upload",
      skip: "Laktawan",
      stillNotWorking: "Hindi pa rin gumagana?",
      tryClickToCapture: "I-tap para kumuha"
    },
    UserDetails: {
      panLabel: "PAN Number",
      proceedBtn: "Magpatuloy",
      panRequired: "Pakilagay ang iyong PAN number",
      saveError: "May naganap na mali habang sini-save ang mga detalye. Pakisubukang muli."
    }
  },
  my: {
    supportingDocument: {
      headingFallback: "ပံ့ပိုးစာရွက်စာတမ်း",
      subHeading: "အောက်တွင် စာရွက်စာတမ်းကို တင်ပါ။ ၎င်းကို ပြန်လည်သုံးသပ်ရန် သိမ်းဆည်းထားပြီး — မည်သည့်အချက်အလက်မျှ ထုတ်ယူခြင်းမရှိပါ။",
      choosePlaceholder: "ဖိုင်ရွေးပါ (PNG, JPG သို့မဟုတ် PDF)",
      continue: "ဆက်လက်လုပ်ဆောင်ပါ",
      uploading: "တင်နေသည်...",
      skip: "ယခုအတွက် ကျော်ပါ",
      errorInvalidType: "PNG, JPG သို့မဟုတ် PDF ဖိုင်ကို တင်ပါ။",
      errorTooLarge: "ဖိုင်အရွယ်အစား ကြီးလွန်းသည်။ ကန့်သတ်ချက်မှာ 10MB ဖြစ်သည်။",
      errorRead: "ထိုဖိုင်ကို ဖတ်၍မရပါ။ ကျေးဇူးပြု၍ အခြားတစ်ခုကို စမ်းကြည့်ပါ။",
      errorNoFile: "တင်ရန် ဖိုင်တစ်ခုကို ရွေးပါ။",
    },
    header: {
      title: "သင့်ကိုယ်တိုင်ကို အတည်ပြုပါ",
      subtitle: "၂ မိနစ်မကျော်ပါဘူး",
      havingIssue: "ပြဿနာ ရှိပါသလား？"
    },
    subHeading: {
      subHeading1: "သင့် ID စာရွက်ကို ဖမ်းယူပါ",
      subHeading2: "သင့်ကိုယ်တိုင်ရုပ်ရှင်မှာရှိကြောင်း အတည်ပြုပါ",
      livenessHeading1: "အလင်းရောင်ကောင်းသော နေရာကို ရှာပါ",
      livenessHeading2: "သင့်မျက်နှာကို အလယ်တွင် ထားပါ"
    },
    onlyIdVerificationHeader: {
      title: "သင့်မှတ်ပုံတင်စာရွက်စာတမ်းကို အတည်ပြုကြပါစို့",
      subtitle: "ဤလုပ်ငန်းစဉ်သည် တစ်မိနစ်ခန့်သာ ကြာမည်ဖြစ်ပြီး သင့်မှတ်ပုံတင်စာရွက်စာတမ်း အဆင်သင့်ရှိပါစေ",
      instruction1: "ကင်မရာ အသုံးပြုခွင့်ကို ခွင့်ပြုပါ",
      instruction2: "စာရွက်စာတမ်းကို စကင်ဖတ်ပါ သို့မဟုတ် တင်ပါ",
      instruction3: "စာရွက်စာတမ်းကို ချက်ချင်း အတည်ပြုပေးမည်"
    },
    termsAndCondition: {
      title: "ကျွန်ုပ်သည် အောက်ပါ စည်းမျဉ်းများနှင့် သတ်မှတ်ချက်များကို သဘောတူကာ လိုက်နာမည်ဖြစ်သည်။",
      privacyPolicy: "စည်းမျဉ်းများကို ကြည့်ရန်",
      beginBtnText: "စတင်ပါ",
      beginLiveness: "အသက်ဝင်မှု စစ်ဆေးခြင်းကို စတင်ပါ",
      startLiveness: "အသက်ဝင်မှု စစ်ဆေးရန် ဆက်လက်ဆောင်ရွက်ပါ"
    },
    permissionDenied: {
      title: "ကင်မရာ သုံးခွင့် ငြင်းပယ်ခဲ့သည်!",
      subtitle: "Browser ၏ လိပ်စာဘားအနီးတွင် ပိတ်ထားသော ကင်မရာအိုင်ကွန်ရှိမရှိ စစ်ဆေးပြီး ဖြုတ်ပေးပါ။",
      readMore: "ပိုမို ဖတ်ရှုရန်",
      refreshText: "ကင်မရာ သုံးခွင့်ကို ခွင့်ပြုပြီးပါက အောက်ဖော်ပြပါ ပြန်လည်သစ်ဆေးရန် ခလုတ်ကိုနှိပ်ပါ။",
      refreshBtn: "ပြန်လည်သစ်ဆေးပါ",
      link: "သို့မဟုတ်၊ ဖုန်းတွင် ဆက်လက်ဆောင်ရွက်ပါ",
      buttonText: "သို့မဟုတ်၊ ဖုန်းတွင် ဆက်လက်ဆောင်ရွက်ပါ"
    },
    desktopBrowserPermissionDenied: {
      title: "ကင်မရာ သုံးခွင့် ပေးပါ",
      subtitle: "Browser က နမူနာများကို မေးတတ်ပါတယ်။ ဆက်လက်ဆောင်ရွက်ရန် 'ခွင့်ပြုပါ' ကို နှိပ်ပါ။",
      readMore: "ပိုမို ဖတ်ရှုရန်",
      refreshText: "ခွင့်ပြုချက်ပေးပြီးနောက် ပြန်လည်သစ်ဆေးပါ",
      refreshBtn: "ပြန်လည်သစ်ဆေးပါ",
      link: "သို့မဟုတ်၊ ဖုန်းတွင် ဆက်လက်ဆောင်ရွက်ပါ",
      buttonText: "သို့မဟုတ်၊ ဖုန်းတွင် ဆက်လက်ဆောင်ရွက်ပါ"
    },
    androidBrowserPermissionDenied: {
      title: "ကင်မရာ သုံးခွင့် ငြင်းပယ်ခဲ့သည်!",
      subtitle: "ဘရောက်ဇာရဲ့ လိပ်စာဘားအနီးမှာ ကင်မရာ အိုင်ကွန် တားမြစ်ထားခြင်းရှိမရှိ စစ်ဆေးပြီး ပြန်ဖွင့်ပါ။",
      readMore: "နောက်ထပ်ဖတ်ရှုရန်",
      refreshText: "ကင်မရာ သုံးခွင့်ပြုပြီးပါက အောက်ရှိ Refresh ခလုတ်ကို နှိပ်ပါ။",
      refreshBtn: "ပြန်လည်တင်ပါ",
      link: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ",
      buttonText: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ"
    },
    androidWebViewPermissionDenied: {
      title: "ကင်မရာ သုံးခွင့် ငြင်းပယ်ခဲ့သည်!",
      subtitle: "အက်ပ်ဆက်တင်များအတွင်းက ကင်မရာ ခွင့်ပြုချက် ပိတ်ထားနိုင်ပါတယ်။ သင့်ဖုန်း၏ App Info > Permissions > Camera ကိုသွားပြီး ခွင့်ပြုပါ။",
      refreshText: "ကင်မရာ သုံးခွင့်ပြုပြီးပါက အောက်ရှိ Refresh ခလုတ်ကို နှိပ်ပါ။",
      refreshBtn: "ပြန်လည်တင်ပါ",
      link: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ",
      buttonText: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ"
    },
    iosBrowserPermissionDenied: {
      title: "ကင်မရာ သုံးခွင့် ငြင်းပယ်ခဲ့သည်!",
      subtitle: "လိပ်စာဘားအနီးရှိ ကင်မရာ သို့မဟုတ် သော့ခလုတ် အိုင်ကွန်ကိုနှိပ်၍ သုံးခွင့်ပေးပါ၊ သို့မဟုတ် ဘရောက်ဇာဆက်တင်များကို စစ်ဆေးပါ။",
      readMore: "နောက်ထပ်ဖတ်ရှုရန်",
      refreshText: "ကင်မရာ သုံးခွင့်ပြုပြီးပါက အောက်ရှိ Refresh ခလုတ်ကို နှိပ်ပါ။",
      refreshBtn: "ပြန်လည်တင်ပါ",
      link: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ",
      buttonText: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ"
    },
    iosWebViewPermissionDenied: {
      title: "ကင်မရာ သုံးခွင့် ငြင်းပယ်ခဲ့သည်!",
      subtitle: "အက်ပ် ဆက်တင်များမှ ကင်မရာ ခွင့်ပြုချက် ပိတ်ထားနိုင်ပါတယ်။ Settings သို့သွားပြီး အသုံးပြုနေသောအက်ပ်ကို ရွေးချယ်ကာ Camera ခွင့်ပြုချက်ကို ဖွင့်ပါ။",
      refreshText: "ကင်မရာ သုံးခွင့်ပြုပြီးပါက အောက်ရှိ Refresh ခလုတ်ကို နှိပ်ပါ။",
      refreshBtn: "ပြန်လည်တင်ပါ",
      link: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ",
      buttonText: "သို့မဟုတ် ဖုန်းတွင် ဆက်လက်လုပ်ဆောင်ပါ"
    },
    documentationList: {
      countryHeading: "နိုင်ငံကို ရွေးပါ",
      docHeading: "သင့်စာရွက်ကို ရွေးပါ",
      btnText: "ရှေ့သို့",
      searchCountry: "နိုင်ငံ ရှာပါ"
    },
    frontDocCapture: {
      heading: "ID ရဲ့ အရှေ့ဘက်ကို စတုရန်းထဲ ထည့်ပါ",
      backupHeading: "ပြဿနာတက်ပါသလား? စာရွက်ကို လက်ကိရိယာနဲ့ နှိပ်ပါ",
      btnText: "ဓာတ်ပုံ ရိုက်ပါ",
      headingBack: " စတုဂံအတွင်း",
      uploadButton: "သို့မဟုတ်၊ ID တင်ပါ"
    },
    backDocCapture: {
      heading: "ID ရဲ့ အနောက်ဘက်ကို စတုရန်းထဲ ထည့်ပါ",
      backupHeading: "ပြဿနာတက်ပါသလား? စာရွက်ကို လက်ကိရိယာနဲ့ နှိပ်ပါ",
      btnText: "ဓာတ်ပုံ ရိုက်ပါ",
      containerText: "သို့မဟုတ်၊ စာရွက်တင်ပါ",
      text: "ဖမ်းယူနေသည်၊ တည်ငြိမ်ပါ",
      headingBack: " စတုဂံအတွင်း",
      skipButton: "နောက်ဘက်ကို ကျော်ပါ",
      uploadButton: "သို့မဟုတ်၊ ID တင်ပါ"
    },
    analyzing: {
      heading: "သင့် ID ကို သုံးသပ်နေသည်...",
      subHeading: "နောက်ထပ် အကွက်ပေါ်မှာ သင့်ကတ်နဲ့ ပတ်သက်တဲ့ အသေးစိတ်ကို စစ်ဆေးပြီး လိုအပ်ရင် ပြင်ဆင်ပါ"
    },
    imageCheck: {
      heading: "သင့်ဓာတ်ပုံကို စစ်ဆေးပါ",
      subHeading: "ဓာတ်ပုံအပြည့်အစုံ၊ သန့်ရှင်းပြီး အမှိန်းနှင့် တောက်ပမှုကင်းသည်ဟု သေချာပါစေ။",
      button1: "ဓာတ်ပုံ ပြန်ရိုက်ပါ",
      button2: "အဆင်ပြေပါတယ်",
      frontHeading: "ရှေ့ပုံကို စစ်ဆေးပါ",
      backHeading: "နောက်ပုံကို စစ်ဆေးပါ"
    },
    errorHandler: {
      heading: "အိုး :(",
      subHeading1: "အချို့ပြဿနာတွေရှိနေပါတယ်၊ ဒါပေမယ့် စိတ်မပူပါနဲ့! နောက်တစ်ကြိမ် ကြိုးစားပါ",
      subHeading2: "ဒီပြဿနာနဲ့ ဆက်ရှိရင်၊ နောက်မှ စစ်ဆေးပါ",
      button: "ပြန်ကြိုးစားပါ"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "ကျေးဇူးပြု၍ မျက်နှာကိုမှမျှတဲ့အရာတွေကိုဖယ်ရှားပါ",
        button: "ထပ်မံကြိုးစားပါ"
      },
      eyeClosureDetected: {
        heading: "ကျေးဇူးပြုပြီး မျက်လုံးများကိုဖွင့်ထားပြီး ကင်မရာကို တိုက်ရိုက်ကြည့်ပါ",
        button: "နောက်တစ်ကြိမ် ပြန်ကြိုးစားပါ"
      },
      isMultipleFacesFound: {
        heading: "မျက်နှာများစွာတွေ့ရှိပါသည်။ ကင်မရာတွင် သင့်မျက်နှာသာ မြင်နိုင်နေကြောင်း သေချာစေရန် သေချာပါစေ။",
        button: "ထပ်မံကြိုးစားပါ"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "ထပ်မံကြိုးစားပါ"
      },
      faceDetections: {
        heading: "ဤကိုဖယ်ရှားပါ",
        button: "ထပ်မံကြိုးစားပါ"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "ပုဂ္ဂိုလ်အများကိုတွေ့ရှိခဲ့ပါသည်",
          button: "ထပ်မံကြိုးစားပါ"
        },
        generalMessage: {
          heading: "ကျေးဇူးပြု၍ ကင်မရာရဲ့ရှေ့မှာ အသက်ရှင်နေတယ်လို့အတည်ပြုပါ",
          button: "ထပ်မံကြိုးစားပါ"
        }
      },
      faceMatch: {
        heading: "သင့်မျက်နှာသည် ID ရုပ်ပုံနှင့် ကိုက်ညီမည်မဟုတ်ပါ",
        button: "ထပ်မံကြိုးစားပါ"
      },
      selfieError: {
        heading: "ကျွန်ုပ်တို့သည် သင်၏ selfie ကို အတည်ပြု၍မရနိုင်ပါ",
        subHeading1: "ဤအကြံပြုချက်များကိုလိုက်နာပြီး ထပ်မံကြိုးစားပါ",
        instruction1: "အလင်းရောင်ကောင်းသောနေရာသို့သွားပြီး အလင်းပေါ်မှတောက်လျှောက်မတတ်စေရန်ကြိုးစားပါ",
        instruction2: "သင့်မျက်နှာသည် ပြင်ပသွားသောနေရာမှကွဲနေပြီး တိကျစွာရှေ့တည့်စွာသုံးပါ",
        instruction3: "သင့်မျက်နှာကိုရှင်းလင်းစွာမြင်နိုင်ရန် ဦးခေါင်း၊ အလုံးကြီး၊ မျက်နှာကပ်ဖိနပ် များကိုဖယ်ရှားပါ",
        button: "ထပ်မံကြိုးစားပါ"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP မကိုက်ညီပါ။ ကျေးဇူးပြု၍ OTP ကို ကျယ်လောင်ပြီး ရှင်းရှင်းလင်းလင်း ဖတ်ပါ",
        button: "ထပ်မံကြိုးစားပါ"
      },
      activeLivenessGenericFailureMessage: {
        heading: "အတည်ပြုခြင်း မအောင်မြင်ပါ။ ကျေးဇူးပြု၍ ညွှန်ကြားချက်များကို ရှင်းရှင်းလင်းလင်း လိုက်နာပြီး ထပ်မံကြိုးစားပါ",
        button: "ထပ်မံကြိုးစားပါ"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF တွင် စာမျက်နှာ များလွန်းသည်",
        subHeading: "အပ်လုဒ်လုပ်ထားသော PDF သည် စာမျက်နှာ ၂ ခု ကန့်သတ်ချက်ကို ကျော်လွန်နေသည်။ ကျေးဇူးပြု၍ စာမျက်နှာ ၂ ခုထက် မပိုသော PDF သို့မဟုတ် သင့် ID ၏ ရှင်းလင်းသော ဓာတ်ပုံကို အပ်လုဒ်လုပ်ပါ။"
      },
      heading: "သင့် ID ကို အလုပ်မလုပ်နိုင်ပါ",
      subHeading: "မမှန်ကန်တဲ့ ID ကို တင်နေဖြစ်နိုင်ပါတယ် ဒါမှမဟုတ်၊ ဓာတ်ပုံ မရှင်းလင်းပါ",
      buttonBack: "ID အနောက်ဘက်ကို ပြန်ကြိုးစားပါ",
      buttonFront: "ID အရှေ့ဘက်ကို ပြန်ကြိုးစားပါ",
      button: "ပြန်ကြိုးစားပါ",
      captureFrontSide: "ရှေ့ဘက်ကို ရိုက်ပါ",
      captureBackSide: "နောက်ဘက်ကို ရိုက်ပါ",
      changeIDButton: "အခြားစာရွက်စာတမ်း ရွေးပါ",
      wrongid: {
        heading: "ဤစာရွက်စာတမ်းကို ကျွန်ုပ်တို့ စီမံဆောင်ရွက်၍မရပါ",
        subHeading: "ကျေးဇူးပြု၍ သင်မှန်ကန်သော စာရွက်စာတမ်းကို တင်နေကြောင်း အတည်ပြုပြီး ပုံအရည်အသွေး ရှင်းလင်းကြောင်း သေချာပါစေ"
      },
      expiredid: {
        heading: "ID စာရွက်စာတမ်း သက်တမ်းကုန်ဆုံးပါပြီ!",
        subHeading: "သက်တမ်းကုန် ID စာရွက်စာတမ်းကို ကျွန်ုပ်တို့ လက်မခံနိုင်ပါ။ ကျေးဇူးပြု၍ မှန်ကန်သော စာရွက်စာတမ်းကို ပေးပါ"
      },
      minimumage: {
        heading: "အသက်လိုအပ်ချက် မပြည့်မီပါ!",
        subHeading: "သင့်အသက်သည် လိုအပ်သော အနိမ့်ဆုံးအသက်အောက် ဖြစ်နေသည်။ ကျေးဇူးပြု၍ သင်သည် အနိမ့်ဆုံးအသက် စံနှုန်းကို ပြည့်မီကြောင်း သေချာပါစေ"
      },
      mobileAttemptsDone: {
        heading: "သင့်ယခင်စက်ပစ္စည်းတွင် ခရီးစဉ်ကို ပြန်လည်စတင်ခဲ့သည်",
        subHeading: "ထပ်တူဖြစ်ခြင်းကို ရှောင်ရှားရန် ဤစက်ရှင်ကို ယခု ရပ်တန့်ထားသည်။"
      },
      finished: {
        heading: "ခရီးစဉ် ပြီးဆုံးသွားပါပြီ",
        subHeading: "ခရီးစဉ်သည် ပြီးစီးခဲ့သည် သို့မဟုတ် ရပ်တန့်ခဲ့သည်"
      },
      invalid: {
        heading: "ခရီးစဉ် မရရှိနိုင်ပါ !",
        subHeading: "journeyId မတွေ့ရှိပါ သို့မဟုတ် ခရီးစဉ် ID မမှန်ကန်ပါ"
      },
      INVALID_PAN_NUMBER: {
        heading: "မမှန်ကန်သော PAN နံပါတ်",
        subHeading: "သင်ထည့်သွင်းသော PAN နံပါတ်သည် မမှန်ကန်ပါ။ ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ"
      },
      INVALID_PAN_STATUS: {
        heading: "မမှန်ကန်သော PAN အခြေအနေ",
        subHeading: "သင်ထည့်သွင်းသော PAN နံပါတ်သည် မမှန်ကန်ပါ။ ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ"
      },
      directKyc: {
        heading: "တိုက်ရိုက် KYC ခရီးစဉ် !",
        subHeading: "ဤသည်မှာ တိုက်ရိုက် KYC ခရီးစဉ်ဖြစ်သည်။ Frontend ခရီးစဉ်ကို ခွင့်မပြုပါ။"
      },
      DOCTYPE_FALSE: {
        heading: "မှားယွင်းသော စာရွက်စာတမ်း ပေးထားသည်!",
        subHeading: "ကျေးဇူးပြု၍ မှန်ကန်သော စာရွက်စာတမ်းကို တင်ပြီး ပုံအရည်အသွေး ကောင်းမွန်ကြောင်း သေချာပါစေ။"
      },
      ONLY_FRONT: {
        heading: "ID ၏ နောက်ဘက်ခြမ်း မရှိပါ",
        subHeading: "သင် အရှေ့ဘက်ခြမ်းသာ ပေးထားသည်။ ကျေးဇူးပြု၍ သင့် ID ကို လှန်ပြီး ဆက်လက်လုပ်ဆောင်ရန် နောက်ဘက်ခြမ်းကို ပေးပါ"
      },
      ONLY_BACK: {
        heading: "ID ၏ အရှေ့ဘက်ခြမ်း မရှိပါ",
        subHeading: "သင် နောက်ဘက်ခြမ်းသာ ပေးထားသည်။ ကျေးဇူးပြု၍ သင့် ID ကို လှန်ပြီး ဆက်လက်လုပ်ဆောင်ရန် အရှေ့ဘက်ခြမ်းကို ပေးပါ"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "စာရွက်စာတမ်း မကြာမီ သက်တမ်းကုန်ဆုံးမည်",
        subHeading: "စာရွက်စာတမ်းသည် မကြာမီ သက်တမ်းကုန်ဆုံးမည်ဖြစ်၍ ငြင်းပယ်ခံရသည်။"
      },
      DOCUMENT_EXPIRED: {
        heading: "စာရွက်စာတမ်း သက်တမ်းကုန်ဆုံးပါပြီ!",
        subHeading: "ကျေးဇူးပြု၍ ဆက်လက်လုပ်ဆောင်ရန် မှန်ကန်ပြီး သက်တမ်းမကုန်သေးသော စာရွက်စာတမ်းကို တင်ပါ။"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "အသက်လိုအပ်ချက် မပြည့်မီပါ!",
        subHeading: "သင်သည် လိုအပ်သော အသက်ကို မပြည့်မီကြောင်း စာရွက်စာတမ်းက ဖော်ပြသည်။ ကျေးဇူးပြု၍ မှန်ကန်သော စာရွက်စာတမ်းကို တင်ပါ။"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "စာရွက်စာတမ်းကို အတည်ပြု၍မရပါ!",
        subHeading: "အတည်ပြုရန်အတွက် ပုံအရည်အသွေး အလွန်ညံ့ဖျင်းသည်။ ကျေးဇူးပြု၍ ပိုမိုရှင်းလင်းသော ပုံဖြင့် ထပ်မံကြိုးစားပါ။"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "စာရွက်စာတမ်းကို အတည်ပြု၍မရပါ!",
        subHeading: "အချို့သတင်းအချက်အလက်များကို အတည်ပြု၍မရပါ။ ကျေးဇူးပြု၍ ပိုမိုရှင်းလင်းသော ပုံဖြင့် ထပ်မံကြိုးစားပါ။"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "စာရွက်စာတမ်းကို အတည်ပြု၍မရပါ!",
        subHeading: "ပုံအရည်အသွေး ညံ့ဖျင်းမှုကြောင့် အချို့အသေးစိတ်များကို အတည်ပြု၍မရပါ။ ကျေးဇူးပြု၍ ပိုမိုရှင်းလင်းသော ပုံဖြင့် ထပ်မံကြိုးစားပါ"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "စာရွက်စာတမ်းကို အတည်ပြု၍မရပါ!",
        subHeading: "အချို့အသေးစိတ်များကို အတည်ပြု၍မရပါ။ ကျေးဇူးပြု၍ ပိုမိုရှင်းလင်းသော ပုံဖြင့် ထပ်မံကြိုးစားပါ။"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "ID ပေါ်ရှိ သင့်ဓာတ်ပုံကို အတည်ပြုရာတွင် ပြဿနာ",
        subHeading: "ID ကတ်ပေါ်ရှိ သင့်ဓာတ်ပုံကို ကျွန်ုပ်တို့ အတည်ပြု၍မရပါ။ ၎င်းကို အတည်ပြုနိုင်ရန် ကျေးဇူးပြု၍ သင့်မူရင်း ID ၏ ရှင်းလင်းသော ဓာတ်ပုံကို တင်ပါ။"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "စာရွက်စာတမ်း လုံခြုံရေးပုံစံ စစ်ဆေးမှု မအောင်မြင်ပါ",
        subHeading: "စာရွက်စာတမ်း၏ တပ်ဆင်ထားသော လုံခြုံရေးပုံစံများကို ကျွန်ုပ်တို့ အတည်ပြု၍မရပါ။ ၎င်း၏ စစ်မှန်မှုကို အတည်ပြုရန် ကူညီရန် ကျေးဇူးပြု၍ မူရင်း ID ၏ ရှင်းလင်းသော ဓာတ်ပုံကို တင်ပါ။"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "စာရွက်စာတမ်း အသက်ဝင်မှု စစ်ဆေးမှု မအောင်မြင်ပါ",
        subHeading: "စာရွက်စာတမ်းသည် စစ်မှန်မှု မရှိနိုင်ကြောင်း လက္ခဏာများ တွေ့ရှိခဲ့သည်။ ကျေးဇူးပြု၍ ဖန်သားပြင်ဓာတ်ပုံများ၊ ပုံနှိပ်မိတ္တူများ သို့မဟုတ် ဖန်သားပြင်ပေါ်တွင် ID ပြသခြင်းကို ရှောင်ကြဉ်ပါ။ အင်္ဂါရပ်အားလုံး ရှင်းလင်းစွာ မြင်နိုင်သော မူရင်း ID ကို တင်ပါ"
      },
      SECURITY_FALSE: {
        heading: "ပြဿနာ တွေ့ရှိသည်!",
        subHeading: "စာရွက်စာတမ်းကို အတည်ပြု၍မရပါ။ ကျေးဇူးပြု၍ ပိုမိုရှင်းလင်းသော ပုံဖြင့် ထပ်မံကြိုးစားပါ"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "ညံ့ဖျင်းသော ပုံအရည်အသွေး!",
        subHeading: "ပုံသည် အလွန်ဝါးပြီး မရှင်းလင်းပါ။ ကျေးဇူးပြု၍ ပိုမိုရှင်းလင်းသော ပုံဖြင့် ထပ်မံကြိုးစားပါ"
      },
      FACE_UNDETECTED: {
        heading: "မျက်နှာ မတွေ့ရှိပါ",
        subHeading: "စာရွက်စာတမ်းပေါ်တွင် မြင်နိုင်သော မျက်နှာကို ကျွန်ုပ်တို့ မတွေ့ရှိပါ။ ကျေးဇူးပြု၍ မျက်နှာ ရှင်းလင်းစွာ မြင်နိုင်သော မှန်ကန်သော ID ကို တင်ပါ"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "စာရွက်စာတမ်းများအကြား နှိုင်းယှဉ်မှု မအောင်မြင်ပါ",
        subHeading: "အဓိကအကွက်တစ်ခု သို့မဟုတ် တစ်ခုထက်ပိုသော (အမည်၊ မွေးသက္ကရာဇ်၊ သို့မဟုတ် မျက်နှာ) မကိုက်ညီမှုကြောင့် စာရွက်စာတမ်းများအကြား နှိုင်းယှဉ်မှု မအောင်မြင်ပါ"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker မအောင်မြင်မှု",
        subHeading: "Digilocker ခရီးစဉ်အတွင်း အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်။ ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ သို့မဟုတ် ဆက်လက်လုပ်ဆောင်ရန် အခြားနည်းလမ်းကို အသုံးပြုပါ။"
      },
      LINKAGE_FAILED: {
        heading: "ဤအတည်ပြုမှုကို ပြီးမြောက်အောင် မလုပ်ဆောင်နိုင်ပါ",
        subHeading: "ရယူထားသော အချက်အလက်များသည် ဤစစ်ဆေးမှုအတွက် မှတ်တမ်းများနှင့် မကိုက်ညီပါ။"
      }
    },
    biometricConsent: {
      consentStatement: "သင့်ဆယ်လ်ဖီမတိုင်မီ၊ သင့်အထောက်အထားကို အတည်ပြုရန် သင့်ဇီဝဗေဒဒေတာ (မျက်နှာပုံနှင့် အသက်ရှင်မှုအချက်ပြများ) ကို ဖမ်းယူပြီး လုပ်ဆောင်ရန် သင့်သဘောတူညီချက် လိုအပ်ပါသည်။ ဤဒေတာကို ဤအတည်ပြုမှုအတွက်သာ အသုံးပြုပါသည်။",
      privacyPolicy: "ကိုယ်ရေးအချက်အလက် မူဝါဒ",
      consentButton: "ကျွန်ုပ် သဘောတူသည် — ဆက်လက်လုပ်ဆောင်ပါ",
      declineButton: "ကျွန်ုပ် သဘောမတူပါ",
      confirmTitle: "ဇီဝဗေဒအတည်ပြုမှုမပါဘဲ ဆက်လက်လုပ်ဆောင်မလား?",
      confirmBody: "ဇီဝဗေဒအတည်ပြုမှုမပါဘဲ ဆယ်လ်ဖီ ရိုက်မည်မဟုတ်ပါ။ သင်ပေးပြီးသား အချက်အလက်များကို အသုံးပြု၍ သင့်အတည်ပြုမှုကို ပြီးမြောက်စေပါမည်။ ဤရွေးချယ်မှုသည် ဤစက်ရှင်အတွက် နောက်ဆုံးဖြစ်ပါသည်။",
      goBack: "နောက်သို့",
      confirmDecline: "အတည်ပြုပါ — သဘောမတူပါ",
      declineComplete: "သင်သည် ဇီဝဗေဒအတည်ပြုမှုကို ဆက်မလုပ်ရန် ရွေးချယ်ခဲ့သည်။ သင်တင်သွင်းသော စာရွက်စာတမ်းများကို အသုံးပြု၍ သင့်အထောက်အထား အတည်ပြုမှု ပြီးမြောက်ပါပြီ။"
    },
    introLiveness: {
      heading: "သင့်အသက်ဝင်မှုကို ဒီမှာ အတည်ပြုပါ",
      instruction1: "ပမာဏ တော်တော်လေး အလင်းရဲ့ ရှိပါတယ် ဟု သေချာပါစေ",
      instruction2: "လိုအပ်တဲ့ ခွင့်ပြုချက်ကို ပေးပါ",
      instruction3: "စနစ်တကျ လိုက်နာပါ",
      button: "ဆက်လက်ဆောင်ရွက်ပါ",
      subHeading: "သင် တစ်ဆင့်သာ လိုတော့သည်"
    },
    phoneSession: {
      heading: "သင့်ဖုန်းတွင် ဆက်လက် ဆောင်ရွက်မှု ရှိသည်",
      subheading: "မိုဘိုင်းမှာ ပြီးဆုံးတဲ့အထိ ဒီဝင်းဒိုးကို ဖွင့်ထားပါ",
      button: "ဒီမှာ ဆက်လက်ဆောင်ရွက်ပါ"
    },
    continueOnPhone: {
      heading: "ဖုန်းတွင် ဆက်လက်ဆောင်ရွက်ပါ",
      subheading: "QR ကို ဖတ်ပါ သို့မဟုတ် အောက်ပါ လင့်ကို ကူးပါ",
      subheading2: "QR ကို ဖတ်ပါ သို့မဟုတ် လင့်ကို သင့်ဖုန်းမှာ ဖွင့်ပါ",
      text: "ဖြစ်စဉ်ကို ပြီးမြောက်စေပါ",
      text1: "သင့်ထင်ပြန်ရန် ဒီမှာ ပြန်ကြည့်ပါ",
      button: "ကူးယူပါ",
      copiedButton: "ကူးယူပြီးပါပြီ!",
      copied: "ကူးယူပြီးပါပြီ!"
    },
    SsnReview: {
      heading: "သင့်အသေးစိတ်ကို ပြန်လည်ဆန်းစစ်ပါ",
      subHeading: "လိုအပ်တဲ့ အပြောင်းအလဲများ ပြုလုပ်ပြီး အသေးစိတ်ကို တင်ပြပါ",
      feild1: "မောင်းနှင်ခွင့်လက်မှတ်",
      feild2: "သက်တမ်းကုန်ဆုံး",
      feild3: "မွေးနေ့",
      feild4: "အတန်း",
      feild5: "ကန့်သတ်ချက်များ",
      feild6: "နိုင်ငံ",
      feild7: "လိပ်စာ",
      button: "အသေးစိတ် အမှန်ပါ"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "မျက်နှာကို စက်ဝိုင်းအတွင်း ထားပါ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ကင်မရာအနီးသို့ ကပ်ပါ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "မရှက်ပါနဲ့၊ မြင်ကွင်းထဲဝင်ပါ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "မှောင်လွန်းသည်။ ပိုလင်းသောနေရာ ရှာပါ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "လင်းလွန်းသည်။ ပျော့ပျောင်းသောအလင်း ရှာပါ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "မျက်နှာကို စက်ဝိုင်းအတွင်း ထားပါ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ငြိမ်ငြိမ်နေပါ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "မျက်နှာကို အလင်းဘက်သို့ လှည့်ပါ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ဖုန်းကို မျက်လုံးအဆင့်တွင် ကိုင်ပါ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ကင်မရာမှ အနည်းငယ် ခွာပါ"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "မျက်နှာကို ဘောင်အလယ်တွင် ထားပါ"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "သင့်မျက်နှာကို စက်ဝိုင်းအလယ်တွင် ထားပါ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "နီးနီးလာပြီး မျက်နှာကို ဖြောင့်ဖြောင့်ထားပါ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "မြင်ကွင်းထဲဝင်လာပြီး မျက်နှာကို ဖြောင့်ဖြောင့်ထားပါ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "အလင်းမရှိဘူး။ ပိုမိုပြောလမ်းရှိသော အလင်းကို ရှာပါ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "အလင်းထွက်လွန်းပါတယ်။ သင့်အလင်းကို ရှာပါ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "သင့်မျက်နှာကို စက်ဝိုင်းအလယ်သို့ ညှိပါ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ငြိမ်ငြိမ်နေပြီး ရှေ့တည့်တည့်ကြည့်ပါ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "အလင်းရောင်ဘက်သို့ မျက်နှာမူပြီး ငြိမ်ငြိမ်နေပါ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ဖုန်းကို မျက်လုံးအနီးထားပါ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ကင်မရာကနေ နည်းနည်းကြောင့်ကွာပါ"
      }
    },
    successful: {
      title: "အတည်ပြုခြင်း ပြီးဆုံးပါပြီ",
      text: "သင်သည် အပြင်ဆွဲကို ပိတ်နိုင်သည်",
      finishBtn: "ပြီးဆုံးပါ"
    },
    poweredBy: "ဖြင့် လည်ပတ်သည်",
    redirect: "သို့ပြန်ရွှေ့နေသည်",
    error: {
      message: "URL သက်တမ်းကုန်သွားပါပြီ သို့မဟုတ် မမှန်ကန်ပါ"
    },
    footer: {
      securedBy: "ဖြင့် လည်ပတ်သည်"
    },
    helpFaq: {
      title: "အကူအညီ & မေးလေ့ရှိသော မေးခွန်းများ",
      subtitle: "ကျွန်ုပ်တို့သည် သင့်အား အကူအညီပေးရန် ဒီမှာ ရှိပါသည်",
      cameraText: "သင့်ကိုယ်တိုင်ကို အတည်ပြုရန်၊ သင့်စက်ပစ္စည်း၏ ကင်မရာကို အသုံးပြု၍ ရုပ်ပုံများ ရိုက်ကူးရန် လိုအပ်ပါသည်။ လိုအပ်သော ခွင့်ပြုချက်များကို ဘယ်လိုပေးရမည်ကို ဤ link တွင် လေ့လာနိုင်ပါသည်",
      cameraHeading: "ကင်မရာ ခွင့်ပြုချက်",
      languageText: "အခြားသော ဘာသာစကားကို သင့်အနေနဲ့ ရွေးချယ်နိုင်ပြီး အစိုးရဘားပေါ်တွင် ပြသထားသော ဘာသာစကားရွေးချယ်မှုမှ ရွေးပါ",
      languageHeading: "ဘာသာစကား ရွေးချယ်မှု",
      kycText: "KYC သို့မဟုတ် 'သင့်ဖောက်သည်ကို သိပါ' သည် ဖောက်သည်၏ အချက်အလက်များကို စစ်ဆေးပြီး အတည်ပြုခြင်းဖြင့် လိမ်လည်မှုနှင့် တရားမဝင် လုပ်ရပ်များကို တားဆီးရန် အကူအညီပေးသော အစီအစဉ်တစ်ခုဖြစ်သည်",
      kycHeading: "KYC ဆိုတာ ဘာလဲ?",
      timeText: "အများအားဖြင့်၊ ၆၀ စက္ကန့်ခန့်သာ အချိန်ယူပါသည်။ သို့သော် အခြားနိုင်ငံများတွင် အချိန်ကွာဟမှုရှိနိုင်ပါသည်",
      timeHeading: "ဤလုပ်ငန်းစဉ်တွင် ဘယ်လောက်အချိန်ယူမည်နည်း?"
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "စုံလင်ပါသည် !"
      },
      smile1: {
        icon: "mood",
        description: "ကျေးဇူးပြု၍ ပြုံးပါ၊ သင် အလွန်လှပါသည်!"
      },
      smile2: {
        icon: "mood",
        description: "ကင်မရာဆီ ပြုံးပါ!"
      }
    },
    pdfPreviewUnavailable: "PDF အတွက် အစမ်းကြည့်ရှုမှုကို ပြသ၍မရပါ။",
    pdfPreviewHint: "အစမ်းကြည့်ရှုမှု မပေါ်လာပါက သင်ဆက်လက်လုပ်ဆောင်နိုင်ပါသည်။",
    pdfOpenLabel: "PDF ဖွင့်ပါ",
    failedUpload: {
      title: "ဖိုင်တင်ခြင်း မအောင်မြင်ပါ",
      text: "ကျေးဇူးပြု၍ ဖိုင်သည် 5MB အောက်ဖြစ်ပြီး .jpg, .jpeg, .png, .heic, .heif သို့မဟုတ် .pdf ဖော်မတ်ဖြစ်ကြောင်း သေချာပါစေ",
      btn: "ထပ်မံကြိုးစားပါ",
      pdfNotAllowedIndia: "အိန္ဒိယအတွက် PDF တင်ခြင်းကို ခွင့်မပြုပါ။ 5 MB အောက် JPEG, JPG, PNG, HEIC, သို့မဟုတ် HEIF ဖိုင်များကို တင်ပါ။",
      pdfNotAllowedIndiaBasic: "အိန္ဒိယအတွက် PDF တင်ခြင်းကို ခွင့်မပြုပါ။ 5 MB အောက် JPEG, JPG, သို့မဟုတ် PNG ဖိုင်များကို တင်ပါ။"
    },
    livenessAnalyzing: {
      heading: "သင့်မျက်နှာကို ခွဲခြမ်းစိတ်ဖြာနေသည်",
      subHeading: "ကျေးဇူးပြု၍ စောင့်ဆိုင်းပါ၊ ၎င်းသည် စက္ကန့်အနည်းငယ်သာ ကြာမည်ဖြစ်သည်"
    },
    sessionExpiredError: {
      heading: "ဝမ်းနည်းပါသည်၊ သင့်စက်ရှင် အချိန်ကုန်သွားပါပြီ",
      subHeading1: "သင်သည် အချိန်အတန်ကြာ မလှုပ်ရှားခဲ့ပါ။ လုံခြုံရေးအကြောင်းကြောင့် သင့်စက်ရှင်သည် အလိုအလျောက် သက်တမ်းကုန်သွားပါပြီ",
      subHeading2: "ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ",
      buttonText: "ထပ်မံကြိုးစားပါ"
    },
    journeyExpiredError: {
      heading: "ဝမ်းနည်းပါသည်၊ လင့်ခ် သက်တမ်းကုန်သွားပါပြီ",
      subHeading1: "လင့်ခ်သည် မလှုပ်ရှားတော့ပါ။ လုံခြုံရေးအကြောင်းကြောင့် လင့်ခ်များတွင် ကန့်သတ်သက်တမ်း ရှိသည်",
      subHeading2: "ကျေးဇူးပြု၍ လင့်ခ်အသစ်ဖြင့် ကြိုးစားပါ",
      buttonText: "ထပ်မံကြိုးစားပါ"
    },
    cameraAccessError: {
      alert1: "ကင်မရာ အသုံးပြုခွင့် ငြင်းပယ်ခံရသည်။ ကျေးဇူးပြု၍ သင့်ဘရောက်ဇာ ဆက်တင်များတွင် ကင်မရာ အသုံးပြုခွင့်ကို ဖွင့်ပါ",
      alert2: "ကင်မရာကို အသုံးပြုနေစဉ် အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်",
      alert3: "သင့်ဘရောက်ဇာသည် ကင်မရာ အသုံးပြုခွင့်ကို မပံ့ပိုးပါ"
    },
    activeLiveness: {
      instruction: "သင့်မျက်နှာကို စက်ဝိုင်းအတွင်း ထားပြီး ညွှန်ကြားချက်များကို လိုက်နာပါ",
      permissionDeniedTitle: "ကင်မရာ သို့မဟုတ် မိုက်ခရိုဖုန်း အသုံးပြုခွင့် ငြင်းပယ်ခံရသည်",
      permissionDeniedSubtitle: "ကျေးဇူးပြု၍ သင့်ဘရောက်ဇာ ဆက်တင်များတွင် ကင်မရာနှင့် မိုက်ခရိုဖုန်း အသုံးပြုခွင့်ကို ခွင့်ပြုပြီး ထပ်မံကြိုးစားပါ။"
    },
    flipScreen: {
      heading: "ယခု သင့်မှတ်ပုံတင်ကို လှန်ပါ",
      subHeading: "ကျေးဇူးပြု၍ နောက်ဘက်ကိုပြသရန် သင့်မှတ်ပုံတင်ကို လက်ဖြင့်လှန်ပြီး ကင်မရာဘောင်အတွင်း ထားပါ။",
      continueButton: "ဆက်လက်လုပ်ဆောင်ပါ"
    },
    mobileDocCapture: {
      frontSide: "ရှေ့ဘက်",
      backSide: "နောက်ဘက်",
      of: "၏",
      upload: "တင်ရန်",
      stillNotWorking: "မအလုပ်လုပ်သေးဘူးလား?",
      clickToCapture: "နှိပ်၍ဖမ်းယူခြင်းကို စမ်းကြည့်ပါ",
      skip: "ကျော်ရန်"
    }
,
    permissionPopUp: {
      title: "ခွင့်ပြုချက် လိုအပ်သည်",
      subtitle: "ကင်မရာအသုံးပြုရန် ဝင်ရောက်ခွင့်ပြုပါ",
      decline: "ငြင်းပယ်ပါ",
      allow: "ခွင့်ပြုပါ"
    },
    userDetails: {
      heading: "PAN အတည်ပြုခြင်း",
      subHeading: "အတည်ပြုရန် အသေးစိတ်အချက်အလက်များကို ဖြည့်ပါ",
      panLabel: "PAN နံပါတ်",
      panRequired: "သင်၏ PAN နံပါတ်ကို ထည့်သွင်းပါ",
      saveError: "အသေးစိတ်အချက်အလက်များ သိမ်းဆည်းစဉ် တစ်စုံတစ်ရာ မှားယွင်းသွားသည်။ ထပ်မံကြိုးစားပါ။",
      proceed: "ဆက်လုပ်ပါ"
    },
    redirectCta: {
      or: "သို့မဟုတ်",
      clickHere: "ဒီနေရာကို နှိပ်ပါ",
      clickHereStart: "ဒီနေရာကို နှိပ်ပါ",
      toContinue: "ဆက်လက်ရန်"
    },
    documentCapture: {
      stillNotWorking: "အလုပ်မလုပ်သေးဘူးလား?",
      clickToCaptureInstead: "အစား နှိပ်ပြီးရိုက်ခြင်းကို စမ်းကြည့်ပါ",
      pdfNotAllowedIndia: "အိန္ဒိယအတွက် PDF တင်ခြင်းကို ခွင့်မပြုပါ။ 5 MB အောက် JPEG, JPG သို့မဟုတ် PNG ဖိုင်များကို တင်ပါ။",
      pdfNotAllowedIndiaMobile: "အိန္ဒိယအတွက် PDF တင်ခြင်းကို ခွင့်မပြုပါ။ 5 MB အောက် JPEG, JPG, PNG, HEIC သို့မဟုတ် HEIF ဖိုင်များကို တင်ပါ။",
      fileFormatsIndia: "jpeg, jpg, png 5 mb အောက်",
      fileFormats: "jpeg, jpg, png, pdf 5 mb အောက်",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb အောက်",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb အောက်"
    },
    mobileCapture: {
      upload: "တင်ပါ",
      skip: "ကျော်ပါ",
      stillNotWorking: "မရသေးဘူးလား？",
      tryClickToCapture: "တို့ပြီးရိုက်ပါ"
    },
    UserDetails: {
      panLabel: "PAN နံပါတ်",
      proceedBtn: "ဆက်လုပ်ပါ",
      panRequired: "သင်၏ PAN နံပါတ်ကို ထည့်ပါ",
      saveError: "အသေးစိတ်များ သိမ်းဆည်းစဉ် တစ်ခုခု မှားယွင်းသွားသည်။ ထပ်မံကြိုးစားပါ။"
    }
  },
  pl: {
    supportingDocument: {
      headingFallback: "Dokument uzupełniający",
      subHeading: "Prześlij dokument poniżej. Jest przechowywany do weryfikacji — nic z niego nie jest wyodrębniane.",
      choosePlaceholder: "Wybierz plik (PNG, JPG lub PDF)",
      continue: "Kontynuuj",
      uploading: "Przesyłanie...",
      skip: "Pomiń na razie",
      errorInvalidType: "Prześlij plik PNG, JPG lub PDF.",
      errorTooLarge: "Plik jest za duży. Limit to 10MB.",
      errorRead: "Nie udało się odczytać tego pliku. Spróbuj innego.",
      errorNoFile: "Wybierz plik do przesłania.",
    },
    header: {
      title: "Zweryfikuj swoją tożsamość",
      subtitle: "To zajmuje mniej niż 2 minuty",
      havingIssue: "Masz problem?"
    },
    subHeading: {
      subHeading1: "Zrób zdjęcie swojego dokumentu tożsamości",
      subHeading2: "Zweryfikuj, że jesteś obecny",
      livenessHeading1: "Znajdź miejsce z dobrym oświetleniem",
      livenessHeading2: "Trzymaj twarz na środku"
    },
    onlyIdVerificationHeader: {
      title: "Zweryfikuj swój dokument tożsamości",
      subtitle: "To zajmie tylko minutę. Przygotuj swój dokument.",
      instruction1: "Zezwól na dostęp do kamery",
      instruction2: "Zeskanuj lub prześlij dokument",
      instruction3: "Natychmiastowa weryfikacja dokumentu"
    },
    termsAndCondition: {
      title: "Zgadzam się na przestrzeganie poniższych warunków.",
      privacyPolicy: "Zobacz warunki",
      beginBtnText: "Rozpocznij",
      beginLiveness: "Rozpoczynanie sprawdzania obecności",
      startLiveness: "Przejdź do sprawdzania obecności"
    },
    permissionDenied: {
      title: "Odmowa dostępu do kamery!",
      subtitle: "Sprawdź, czy w pobliżu paska adresu przeglądarki znajduje się zablokowana ikona kamery i odblokuj ją.",
      readMore: "Czytaj więcej",
      refreshText: "Po udzieleniu dostępu do kamery kliknij poniższy przycisk odświeżania.",
      refreshBtn: "Odśwież",
      link: "Lub kontynuuj na telefonie",
      buttonText: "Lub kontynuuj na telefonie"
    },
    desktopBrowserPermissionDenied: {
      title: "Proszę pozwolić na dostęp do kamery",
      subtitle: "Przeglądarka może poprosić o pozwolenia. Proszę kliknąć 'zezwól', aby kontynuować.",
      readMore: "Czytaj więcej",
      refreshText: "Odśwież po udzieleniu pozwolenia",
      refreshBtn: "Odśwież",
      link: "Lub kontynuuj na telefonie",
      buttonText: "Lub kontynuuj na telefonie"
    },
    androidBrowserPermissionDenied: {
      title: "Odmowa dostępu do kamery!",
      subtitle: "Sprawdź, czy ikona kamery obok paska adresu w przeglądarce nie jest zablokowana, i odblokuj ją.",
      readMore: "Dowiedz się więcej",
      refreshText: "Po udzieleniu dostępu do kamery kliknij przycisk Odśwież poniżej.",
      refreshBtn: "Odśwież",
      link: "Lub kontynuuj na telefonie",
      buttonText: "Lub kontynuuj na telefonie"
    },
    androidWebViewPermissionDenied: {
      title: "Odmowa dostępu do kamery!",
      subtitle: "Dostęp do kamery może być zablokowany w ustawieniach aplikacji. Sprawdź: Informacje o aplikacji > Uprawnienia > Kamera i udziel dostępu.",
      refreshText: "Po udzieleniu dostępu do kamery kliknij przycisk Odśwież poniżej.",
      refreshBtn: "Odśwież",
      link: "Lub kontynuuj na telefonie",
      buttonText: "Lub kontynuuj na telefonie"
    },
    iosBrowserPermissionDenied: {
      title: "Odmowa dostępu do kamery!",
      subtitle: "Stuknij ikonę kamery lub kłódki obok paska adresu, aby udzielić dostępu, lub sprawdź ustawienia przeglądarki.",
      readMore: "Dowiedz się więcej",
      refreshText: "Po udzieleniu dostępu do kamery kliknij przycisk Odśwież poniżej.",
      refreshBtn: "Odśwież",
      link: "Lub kontynuuj na telefonie",
      buttonText: "Lub kontynuuj na telefonie"
    },
    iosWebViewPermissionDenied: {
      title: "Odmowa dostępu do kamery!",
      subtitle: "Dostęp do kamery może być zablokowany w ustawieniach aplikacji. Przejdź do Ustawienia, znajdź aplikację i włącz uprawnienia do kamery.",
      refreshText: "Po udzieleniu dostępu do kamery kliknij przycisk Odśwież poniżej.",
      refreshBtn: "Odśwież",
      link: "Lub kontynuuj na telefonie",
      buttonText: "Lub kontynuuj na telefonie"
    },
    documentationList: {
      countryHeading: "Wybierz kraj",
      docHeading: "Wybierz swój dokument",
      btnText: "Dalej",
      searchCountry: "Szukaj kraju"
    },
    frontDocCapture: {
      heading: "Umieść przednią stronę dowodu w prostokącie",
      backupHeading: "Masz problem? Proszę kliknąć obraz ręcznie",
      btnText: "Zrób zdjęcie",
      headingBack: " w prostokącie",
      uploadButton: "lub prześlij dokument"
    },
    backDocCapture: {
      heading: "Umieść tylną stronę dowodu w prostokącie",
      backupHeading: "Masz problem? Proszę kliknąć obraz ręcznie",
      btnText: "Zrób zdjęcie",
      containerText: "lub załaduj dokument",
      text: "Przechwytywanie, proszę nie ruszać",
      headingBack: " w prostokącie",
      skipButton: "Pomiń tylną stronę",
      uploadButton: "lub prześlij dokument"
    },
    analyzing: {
      heading: "Analizowanie twojego dokumentu tożsamości...",
      subHeading: "Proszę sprawdzić szczegóły karty na następnym ekranie i w razie potrzeby edytować"
    },
    imageCheck: {
      heading: "Sprawdź swoje zdjęcie",
      subHeading: "Proszę upewnić się, że zdjęcie jest kompletne, wyraźne i bez rozmycia oraz odblasków.",
      button1: "Ponów zdjęcie",
      button2: "W porządku",
      frontHeading: "Sprawdź swoje zdjęcie z przodu",
      backHeading: "Sprawdź swoje zdjęcie z tyłu"
    },
    errorHandler: {
      heading: "Ojej :(",
      subHeading1: "Napotkaliśmy pewne problemy, ale nie martw się! Proszę spróbować ponownie",
      subHeading2: "Jeśli problem będzie się powtarzał, sprawdź później",
      button: "Spróbuj ponownie"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Proszę usuń wszystko, co zasłania twój obraz",
        button: "Spróbuj ponownie"
      },
      eyeClosureDetected: {
        heading: "Proszę, trzymaj oczy otwarte i patrz prosto w kamerę",
        button: "Spróbuj ponownie"
      },
      isMultipleFacesFound: {
        heading: "Wykryto wiele twarzy. Upewnij się, że w kamerze widoczna jest tylko twoja twarz.",
        button: "Spróbuj ponownie"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Spróbuj ponownie"
      },
      faceDetections: {
        heading: "Proszę usuń to",
        button: "Spróbuj ponownie"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Znaleziono wiele twarzy",
          button: "Spróbuj ponownie"
        },
        generalMessage: {
          heading: "Proszę upewnij się, że jesteś żywy przed kamerą",
          button: "Spróbuj ponownie"
        }
      },
      faceMatch: {
        heading: "Twoja twarz nie pasuje do zdjęcia w dowodzie tożsamości",
        button: "Spróbuj ponownie"
      },
      selfieError: {
        heading: "Nie udało nam się zweryfikować twojego selfie",
        subHeading1: "Po prostu postępuj zgodnie z tymi wskazówkami i spróbuj ponownie",
        instruction1: "Przenieś się do dobrze oświetlonego miejsca i unikaj światła w tle",
        instruction2: "Upewnij się, że twoja twarz jest całkowicie widoczna i wyśrodkowana w kadrze",
        instruction3: "Usuń kapelusz, okulary lub maskę, aby wyraźnie widzieć twarz",
        button: "Spróbuj ponownie"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP nie pasuje. Proszę wyraźnie odczytać OTP na głos",
        button: "Spróbuj ponownie"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Weryfikacja nie powiodła się. Proszę wyraźnie postępować zgodnie z instrukcjami i spróbować ponownie",
        button: "Spróbuj ponownie"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "Plik PDF ma za dużo stron",
        subHeading: "Przesłany plik PDF przekracza limit 2 stron. Prześlij plik PDF o maksymalnie 2 stronach lub wyraźne zdjęcie dokumentu."
      },
      heading: "Nie udało nam się przetworzyć twojego dokumentu tożsamości",
      subHeading: "Albo przesyłasz niewłaściwy dokument, albo zdjęcie jest nieczytelne",
      buttonBack: "Ponów próbę z tylną stroną dowodu",
      buttonFront: "Ponów próbę z przednią stroną dowodu",
      button: "Spróbuj ponownie",
      captureFrontSide: "Zrób zdjęcie przodu",
      captureBackSide: "Zrób zdjęcie tyłu",
      changeIDButton: "Wybierz inny dokument",
      wrongid: {
        heading: "Nie mogliśmy przetworzyć tego dokumentu",
        subHeading: "Sprawdź, czy przesyłasz właściwy dokument, i upewnij się, że jakość zdjęcia jest wyraźna"
      },
      expiredid: {
        heading: "Dokument tożsamości wygasł!",
        subHeading: "Nie możemy zaakceptować wygasłego dokumentu tożsamości. Podaj prawidłowy dokument"
      },
      minimumage: {
        heading: "Wymóg wiekowy niespełniony!",
        subHeading: "Twój wiek jest poniżej wymaganego minimalnego wieku. Upewnij się, że spełniasz kryterium minimalnego wieku"
      },
      mobileAttemptsDone: {
        heading: "Podróż wznowiona na Twoim poprzednim urządzeniu",
        subHeading: "Ta sesja została teraz zatrzymana, aby uniknąć duplikacji."
      },
      finished: {
        heading: "Podróż została zakończona",
        subHeading: "Podróż została ukończona lub przerwana"
      },
      invalid: {
        heading: "Podróż niedostępna !",
        subHeading: "Nie znaleziono journeyId lub identyfikator podróży jest nieprawidłowy"
      },
      INVALID_PAN_NUMBER: {
        heading: "Nieprawidłowy numer PAN",
        subHeading: "Wprowadzony numer PAN jest nieprawidłowy. Sprawdź i spróbuj ponownie"
      },
      INVALID_PAN_STATUS: {
        heading: "Nieprawidłowy status PAN",
        subHeading: "Wprowadzony numer PAN jest nieprawidłowy. Sprawdź i spróbuj ponownie"
      },
      directKyc: {
        heading: "Bezpośrednia podróż KYC !",
        subHeading: "To jest bezpośrednia podróż KYC. Podróż frontendowa jest niedozwolona."
      },
      DOCTYPE_FALSE: {
        heading: "Podano nieprawidłowy dokument!",
        subHeading: "Prześlij prawidłowy dokument i upewnij się, że jakość obrazu jest dobra."
      },
      ONLY_FRONT: {
        heading: "Brak tylnej strony dokumentu",
        subHeading: "Podano tylko przednią stronę. Odwróć dokument i podaj tylną stronę, aby kontynuować"
      },
      ONLY_BACK: {
        heading: "Brak przedniej strony dokumentu",
        subHeading: "Podano tylko tylną stronę. Odwróć dokument i podaj przednią stronę, aby kontynuować"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Dokument wkrótce wygaśnie",
        subHeading: "Dokument został odrzucony, ponieważ wkrótce wygaśnie."
      },
      DOCUMENT_EXPIRED: {
        heading: "Dokument wygasł!",
        subHeading: "Prześlij prawidłowy, niewygasły dokument, aby kontynuować."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Wymóg wiekowy niespełniony!",
        subHeading: "Dokument wskazuje, że nie spełniasz wymaganego wieku. Prześlij prawidłowy dokument."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Nie można zweryfikować dokumentu!",
        subHeading: "Jakość obrazu jest zbyt niska do weryfikacji. Spróbuj ponownie z wyraźniejszym obrazem."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Nie można zweryfikować dokumentu!",
        subHeading: "Niektórych informacji nie można zweryfikować. Spróbuj ponownie z wyraźniejszym obrazem."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Nie można zweryfikować dokumentu!",
        subHeading: "Niektórych szczegółów nie można zweryfikować z powodu niskiej jakości obrazu. Spróbuj ponownie z wyraźniejszym obrazem"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Nie można zweryfikować dokumentu!",
        subHeading: "Niektórych szczegółów nie można zweryfikować. Spróbuj ponownie z wyraźniejszym obrazem."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problem z weryfikacją Twojego zdjęcia na dokumencie",
        subHeading: "Nie mogliśmy zweryfikować Twojego zdjęcia na dokumencie. Prześlij wyraźne zdjęcie oryginalnego dokumentu, abyśmy mogli je potwierdzić."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Sprawdzenie wzoru zabezpieczeń dokumentu nie powiodło się",
        subHeading: "Nie mogliśmy zweryfikować wbudowanych wzorów zabezpieczeń dokumentu. Prześlij wyraźne zdjęcie oryginalnego dokumentu, aby pomóc nam potwierdzić jego autentyczność."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Sprawdzenie autentyczności dokumentu nie powiodło się",
        subHeading: "Znaleźliśmy oznaki, że dokument może nie być autentyczny. Unikaj używania zrzutów ekranu, wydruków lub wyświetlania dokumentu na ekranie. Prześlij oryginalny dokument z wyraźnie widocznymi wszystkimi elementami"
      },
      SECURITY_FALSE: {
        heading: "Wykryto problem!",
        subHeading: "Nie można zweryfikować dokumentu. Spróbuj ponownie z wyraźniejszym obrazem"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Niska jakość obrazu!",
        subHeading: "Obraz jest zbyt rozmyty lub niewyraźny. Spróbuj ponownie z wyraźniejszym obrazem"
      },
      FACE_UNDETECTED: {
        heading: "Nie wykryto twarzy",
        subHeading: "Nie mogliśmy znaleźć widocznej twarzy na dokumencie. Prześlij prawidłowy dokument, na którym twarz jest wyraźnie widoczna"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Porównanie między dokumentami nie powiodło się",
        subHeading: "Porównanie między dokumentami nie powiodło się z powodu niezgodności w jednym lub kilku kluczowych polach (imię, data urodzenia lub twarz)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Błąd Digilocker",
        subHeading: "Wystąpił błąd podczas podróży Digilocker. Spróbuj ponownie lub użyj alternatywnej metody, aby kontynuować."
      },
      LINKAGE_FAILED: {
        heading: "Nie można ukończyć tej weryfikacji",
        subHeading: "Zebrane dane nie są zgodne z zapisami dla tej kontroli."
      }
    },
    biometricConsent: {
      consentStatement: "Przed wykonaniem selfie potrzebujemy Twojej zgody na przechwycenie i przetwarzanie Twoich danych biometrycznych (obraz twarzy i sygnały żywotności) w celu weryfikacji tożsamości. Dane te są wykorzystywane wyłącznie do tej weryfikacji.",
      privacyPolicy: "Polityka prywatności",
      consentButton: "Wyrażam zgodę — Kontynuuj",
      declineButton: "Nie wyrażam zgody",
      confirmTitle: "Kontynuować bez weryfikacji biometrycznej?",
      confirmBody: "Bez weryfikacji biometrycznej nie wykonamy selfie. Twoja weryfikacja zostanie ukończona na podstawie informacji, które już podałeś. Ten wybór jest ostateczny dla tej sesji.",
      goBack: "Wróć",
      confirmDecline: "Potwierdź — nie wyrażam zgody",
      declineComplete: "Zdecydowałeś się nie kontynuować weryfikacji biometrycznej. Weryfikacja Twojej tożsamości została ukończona na podstawie przesłanych przez Ciebie dokumentów."
    },
    introLiveness: {
      heading: "Potwierdź swoją obecność tutaj",
      instruction1: "Upewnij się, że jest wystarczająco dużo światła",
      instruction2: "Zezwól na wymagane pozwolenia",
      instruction3: "Postępuj zgodnie z instrukcjami",
      button: "Kontynuuj",
      subHeading: "Jesteś o krok od celu"
    },
    phoneSession: {
      heading: "Sesja kontynuowana na telefonie",
      subheading: "Pozostaw to okno otwarte, dopóki nie zakończysz na urządzeniu mobilnym",
      button: "Kontynuuj tutaj"
    },
    continueOnPhone: {
      heading: "Kontynuuj na telefonie",
      subheading: "Zeskanuj kod QR lub skopiuj poniższy link",
      subheading2: "Zeskanuj kod QR lub otwórz link na swoim telefonie",
      text: "Zakończ proces",
      text1: "Sprawdź tutaj, aby wysłać",
      button: "Skopiuj",
      copiedButton: "Skopiowano!",
      copied: "Skopiowano!"
    },
    SsnReview: {
      heading: "Sprawdź swoje dane",
      subHeading: "Wprowadź niezbędne zmiany i prześlij szczegóły",
      feild1: "Prawo jazdy",
      feild2: "Ważność",
      feild3: "Data urodzenia",
      feild4: "Klasa",
      feild5: "Ograniczenia",
      feild6: "Kraj",
      feild7: "Adres",
      button: "Dane są poprawne"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Trzymaj twarz w okręgu"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Zbliż się do kamery"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Nie wstydź się, pokaż się"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Za ciemno. Znajdź jaśniejsze światło"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Za jasno. Znajdź łagodniejsze światło"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Trzymaj twarz w okręgu"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Nie ruszaj się"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Odwróć twarz do światła"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Trzymaj telefon na wysokości oczu"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Odsuń się trochę od kamery"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Wyśrodkuj twarz w kadrze"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Umieść twarz na środku okręgu"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Podejdź bliżej i trzymaj twarz prosto"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Wejdź w widok i trzymaj twarz prosto"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Za ciemno. Znajdź jaśniejsze światło"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Za jasno. Znajdź optymalne światło"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Dopasuj twarz do środka okręgu"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Trzymaj się nieruchomo i patrz prosto przed siebie"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Skieruj twarz w stronę światła i nie ruszaj się"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Trzymaj telefon na poziomie oczu"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Odsuń się trochę od kamery"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Idealnie!"
      },
      smile1: {
        icon: "mood",
        description: "Uśmiechnij się, wyglądasz świetnie!"
      },
      smile2: {
        icon: "mood",
        description: "Uśmiechnij się do kamery!"
      }
    },
    successful: {
      title: "Weryfikacja zakończona",
      text: "Możesz teraz zamknąć okno",
      finishBtn: "Zakończ"
    },
    poweredBy: "Zasilane przez",
    redirect: "Przekierowywanie za",
    error: {
      message: "URL wygasł lub jest nieprawidłowy"
    },
    footer: {
      securedBy: "Zasilane przez"
    },
    helpFaq: {
      title: "Pomoc & Najczęściej zadawane pytania",
      subtitle: "Jesteśmy tutaj, aby Ci pomóc",
      cameraText: "Aby zweryfikować Twoją tożsamość, musimy zrobić zdjęcia za pomocą kamery Twojego urządzenia. Aby dowiedzieć się, jak przyznać wymagane uprawnienia, kliknij w ten link",
      cameraHeading: "Uprawnienia kamery",
      languageText: "Na początku procesu możesz wybrać preferowany język z rozwijanego menu w górnej części paska",
      languageHeading: "Wybór języka",
      kycText: "KYC, czyli 'Poznaj swojego klienta', to proces weryfikacji tożsamości klienta, który pomaga zapewnić zgodność z przepisami i zapobiega oszustwom oraz innym nielegalnym działaniom",
      kycHeading: "Czym jest KYC?",
      timeText: "Zwykle trwa to około 60 sekund. Może to jednak różnić się w zależności od kraju",
      timeHeading: "Ile to zajmie czasu?"
    },
    pdfPreviewUnavailable: "Nie można wyświetlić podglądu PDF.",
    pdfPreviewHint: "Jeśli podgląd się nie pojawi, nadal możesz kontynuować.",
    pdfOpenLabel: "Otwórz PDF",
    failedUpload: {
      title: "Przesyłanie pliku nie powiodło się",
      text: "Upewnij się, że plik ma mniej niż 5 MB i jest w formacie .jpg, .jpeg, .png, .heic, .heif lub .pdf",
      btn: "Spróbuj ponownie",
      pdfNotAllowedIndia: "Przesyłanie plików PDF nie jest dozwolone dla Indii. Prześlij pliki JPEG, JPG, PNG, HEIC lub HEIF mniejsze niż 5 MB.",
      pdfNotAllowedIndiaBasic: "Przesyłanie plików PDF nie jest dozwolone dla Indii. Prześlij pliki JPEG, JPG lub PNG mniejsze niż 5 MB."
    },
    livenessAnalyzing: {
      heading: "Analizowanie Twojej twarzy",
      subHeading: "Proszę czekać, zajmie to tylko kilka sekund"
    },
    sessionExpiredError: {
      heading: "Przepraszamy, Twoja sesja wygasła",
      subHeading1: "Byłeś nieaktywny przez pewien czas. Ze względów bezpieczeństwa Twoja sesja automatycznie wygasła",
      subHeading2: "Spróbuj ponownie",
      buttonText: "Spróbuj ponownie"
    },
    journeyExpiredError: {
      heading: "Przepraszamy, link wygasł",
      subHeading1: "Link nie jest już aktywny. Ze względów bezpieczeństwa linki mają ograniczony czas życia",
      subHeading2: "Spróbuj z nowym linkiem",
      buttonText: "Spróbuj ponownie"
    },
    cameraAccessError: {
      alert1: "Odmowa dostępu do kamery. Włącz dostęp do kamery w ustawieniach przeglądarki",
      alert2: "Wystąpił błąd podczas uzyskiwania dostępu do kamery",
      alert3: "Twoja przeglądarka nie obsługuje dostępu do kamery"
    },
    activeLiveness: {
      instruction: "Trzymaj twarz w okręgu i postępuj zgodnie z instrukcjami",
      permissionDeniedTitle: "Odmowa dostępu do kamery lub mikrofonu",
      permissionDeniedSubtitle: "Zezwól na dostęp do kamery i mikrofonu w ustawieniach przeglądarki i spróbuj ponownie."
    },
    flipScreen: {
      heading: "Teraz odwróć swój dokument tożsamości",
      subHeading: "Proszę fizycznie odwrócić dokument tożsamości, aby pokazać tylną stronę, a następnie umieść go w ramce kamery.",
      continueButton: "Kontynuuj"
    },
    mobileDocCapture: {
      frontSide: "Przód",
      backSide: "Tył",
      of: "-",
      upload: "Prześlij",
      stillNotWorking: "Nadal nie działa?",
      clickToCapture: "Spróbuj przechwytywania kliknięciem",
      skip: "Pomiń"
    }
,
    permissionPopUp: {
      title: "Wymagane uprawnienie",
      subtitle: "Zezwól na dostęp, aby używać kamery",
      decline: "Odrzuć",
      allow: "Zezwól"
    },
    userDetails: {
      heading: "Weryfikacja PAN",
      subHeading: "Wypełnij dane, aby zweryfikować",
      panLabel: "Numer PAN",
      panRequired: "Wprowadź swój numer PAN",
      saveError: "Coś poszło nie tak podczas zapisywania danych. Spróbuj ponownie.",
      proceed: "Kontynuuj"
    },
    redirectCta: {
      or: "lub",
      clickHere: "kliknij tutaj",
      clickHereStart: "Kliknij tutaj",
      toContinue: "aby kontynuować"
    },
    documentCapture: {
      stillNotWorking: "Nadal nie działa?",
      clickToCaptureInstead: "Spróbuj zamiast tego przechwytywania kliknięciem",
      pdfNotAllowedIndia: "Przesyłanie plików PDF nie jest dozwolone dla Indii. Prześlij pliki JPEG, JPG lub PNG poniżej 5 MB.",
      pdfNotAllowedIndiaMobile: "Przesyłanie plików PDF nie jest dozwolone dla Indii. Prześlij pliki JPEG, JPG, PNG, HEIC lub HEIF poniżej 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png poniżej 5 mb",
      fileFormats: "jpeg, jpg, png, pdf poniżej 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif poniżej 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf poniżej 5 mb"
    },
    mobileCapture: {
      upload: "Prześlij",
      skip: "Pomiń",
      stillNotWorking: "Nadal nie działa?",
      tryClickToCapture: "Zrób zdjęcie ręcznie"
    },
    UserDetails: {
      panLabel: "Numer PAN",
      proceedBtn: "Kontynuuj",
      panRequired: "Wprowadź swój numer PAN",
      saveError: "Coś poszło nie tak podczas zapisywania danych. Spróbuj ponownie."
    }
  },
  yo: {
    supportingDocument: {
      headingFallback: "Iwe atilẹyin",
      subHeading: "Gbe iwe naa si isalẹ. A o fi pamọ fun atunyẹwo — ko si ohun ti a fa jade lati inu rẹ.",
      choosePlaceholder: "Yan faili kan (PNG, JPG tabi PDF)",
      continue: "Tẹsiwaju",
      uploading: "Ngbe soke...",
      skip: "Fo fun bayii",
      errorInvalidType: "Gbe faili PNG, JPG tabi PDF soke.",
      errorTooLarge: "Faili tobi ju. Iwọn to pọ julọ ni 10MB.",
      errorRead: "A ko le ka faili yẹn. Jọwọ gbiyanju omiran.",
      errorNoFile: "Jọwọ yan faili kan lati gbe soke.",
    },
    header: {
      title: "Ẹ jẹ ki a fọwọsi idanimọ rẹ",
      subtitle: "O gba kere ju iṣẹju 2 lọ",
      havingIssue: "Ṣe ìṣòro kan wà?"
    },
    onlyIdVerificationHeader: {
      title: "Ẹ jẹ́ kí a fọwọ́sí ìdánimọ̀ rẹ",
      subtitle: "Èyí kì yóò gba ìgbà púpọ̀. Ṣe àfẹ́yìntì, jẹ́ kí ìwé ìdánimọ̀ rẹ wà ní ọwọ́ rẹ",
      instruction1: "Gba ìmọ̀ṣẹ̀ kamẹ́rà",
      instruction2: "Ṣàmì-ẹ̀rọ tàbí gbé ìwé rẹ sókè",
      instruction3: "Ìfọwọ́sí ìwé lẹ́sẹ̀kẹsẹ̀"
    },
    subHeading: {
      subHeading1: "Ya aworan iwe ID rẹ",
      subHeading2: "Fọwọsi pe o wa laaye",
      livenessHeading1: "Wá ibi tí ìmọ́lẹ̀ dára",
      livenessHeading2: "Jẹ́ kí ojú rẹ wà ní àárín"
    },
    termsAndCondition: {
      title: "Mo gba lati gba ati tẹle awọn ofin ati awọn ipo wọnyi.",
      privacyPolicy: "Wo awọn ofin",
      beginBtnText: "Bẹrẹ",
      beginLiveness: "Bẹrẹ ayẹwo laaye",
      startLiveness: "Tẹsiwaju si ayẹwo laaye"
    },
    permissionDenied: {
      title: "Wiwọle si kamera ni a kọ!",
      subtitle: "Ṣayẹwo boya a ti dina aami kamera lẹgbẹẹ ọpa adirẹsi aṣàwákiri rẹ ki o si ṣii lẹẹkansi.",
      readMore: "Ka siwaju",
      refreshText: "Lẹ́yìn tí o bá ti fun ni wiwọle si kamera, tẹ bọtìnì ‘Tun ṣe imudojuiwọn’ ni isalẹ.",
      refreshBtn: "Tun ṣe imudojuiwọn",
      link: "Tabi, Tẹsiwaju lori foonu",
      buttonText: "Tabi, Tẹsiwaju lori foonu"
    },
    desktopBrowserPermissionDenied: {
      title: "Proszę pozwolić na dostęp do kamery",
      subtitle: "Przeglądarka może poprosić o pozwolenia. Proszę kliknąć 'zezwól', aby kontynuować.",
      readMore: "Czytaj więcej",
      refreshText: "Odśwież po udzieleniu pozwolenia",
      refreshBtn: "Odśwież",
      link: "Lub kontynuuj na telefonie",
      buttonText: "Tabi, Tẹsiwaju lori foonu"
    },
    androidBrowserPermissionDenied: {
      title: "Wiwọle si kamera ni a kọ!",
      subtitle: "Ṣayẹwo aami kamera ti a le ti dina lẹba ọpa adirẹsi aṣàwákiri, ki o si ṣii lẹẹkansi.",
      readMore: "Kọ ẹ̀kọ́ síi",
      refreshText: "Lẹ́yìn tí a bá fọwọ́sowọ́pọ̀ sí wiwọle si kamera, tẹ bọtini Tunṣe ni isalẹ.",
      refreshBtn: "Tunṣe",
      link: "Tabi, Tesiwaju lori Fóònù",
      buttonText: "Tabi, Tesiwaju lori Fóònù"
    },
    androidWebViewPermissionDenied: {
      title: "Wiwọle si kamera ni a kọ!",
      subtitle: "Kamera le ti dina nipasẹ awọn eto app. Jọwọ ṣayẹwo App Info > Permissions > Camera ki o si gba wiwọle laaye.",
      refreshText: "Lẹ́yìn tí a bá fọwọ́sowọ́pọ̀ sí wiwọle si kamera, tẹ bọtini Tunṣe ni isalẹ.",
      refreshBtn: "Tunṣe",
      link: "Tabi, Tesiwaju lori Fóònù",
      buttonText: "Tabi, Tesiwaju lori Fóònù"
    },
    iosBrowserPermissionDenied: {
      title: "Wiwọle si kamera ni a kọ!",
      subtitle: "Tẹ aami kamera tàbí titiipa lẹ́bà ọpa adirẹsi lati gba wiwọle, tàbí ṣayẹwo awọn eto aṣàwákiri rẹ.",
      readMore: "Kọ ẹ̀kọ́ síi",
      refreshText: "Lẹ́yìn tí a bá fọwọ́sowọ́pọ̀ sí wiwọle si kamera, tẹ bọtini Tunṣe ni isalẹ.",
      refreshBtn: "Tunṣe",
      link: "Tabi, Tesiwaju lori Fóònù",
      buttonText: "Tabi, Tesiwaju lori Fóònù"
    },
    iosWebViewPermissionDenied: {
      title: "Wiwọle si kamera ni a kọ!",
      subtitle: "Wiwọle si kamera le ti dina nipasẹ eto app. Lọ si Settings, wa app naa, ki o si mu iwọle kamera ṣiṣẹ.",
      refreshText: "Lẹ́yìn tí a bá fọwọ́sowọ́pọ̀ sí wiwọle si kamera, tẹ bọtini Tunṣe ni isalẹ.",
      refreshBtn: "Tunṣe",
      link: "Tabi, Tesiwaju lori Fóònù",
      buttonText: "Tabi, Tesiwaju lori Fóònù"
    },
    documentationList: {
      countryHeading: "Yan orílẹ̀-èdè",
      docHeading: "Yan iwe rẹ",
      btnText: "T’ẹlẹ",
      searchCountry: "Wa orílẹ̀-èdè"
    },
    frontDocCapture: {
      heading: "Fi apá iwájú ID sínú onigun mẹrin",
      backupHeading: "Ṣoro bi? Jọwọ tẹ aworan ni ọwọ",
      btnText: "Ya fọto",
      headingBack: " nínú onígunmẹ́rin",
      uploadButton: "tàbí, gbé ID sókè"
    },
    backDocCapture: {
      heading: "Fi apá ẹ̀hìn ID sínú onigun mẹrin",
      backupHeading: "Ṣoro bi? Jọwọ tẹ aworan ni ọwọ",
      btnText: "Ya fọto",
      containerText: "tabi, fi iwe silẹ",
      text: "N mu aworan, duro mọlẹ",
      headingBack: " nínú onígunmẹ́rin",
      skipButton: "Fo Ẹ̀yìn",
      uploadButton: "tàbí, gbé ID sókè"
    },
    analyzing: {
      heading: "N ṣe itupalẹ ID rẹ...",
      subHeading: "Jọwọ ṣayẹwo awọn alaye kaadi rẹ lori iboju atẹle ki o ṣe atunṣe ti o ba ṣe pataki"
    },
    imageCheck: {
      heading: "Ṣayẹwo aworan rẹ",
      subHeading: "Jọwọ rii daju pe aworan naa ti pari, o mọ, ati pe ko ni blur ati glare.",
      button1: "Ya fọto lẹẹkansi",
      button2: "O dara lati lọ",
      frontHeading: "Ṣayẹwo aworan iwaju rẹ",
      backHeading: "Ṣayẹwo aworan ẹhin rẹ"
    },
    errorHandler: {
      heading: "O tun wa:(",
      subHeading1: "A n ni diẹ ninu awọn iṣoro, ṣugbọn maṣe yọ ara rẹ lẹnu! Jọwọ gbiyanju lẹẹkansi",
      subHeading2: "Ti eyi ba tẹsiwaju, ṣayẹwo pada nigbamii",
      button: "Gbiyanju lẹẹkansi"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Jọwọ yọ gbogbo ohun ti o n bo oju rẹ",
        button: "Gbiyanju lẹẹkansi"
      },
      eyeClosureDetected: {
        heading: "Jọwọ ṣi oju rẹ ki o wo taara si kamẹra",
        button: "Tun gbiyanju lẹẹkansi"
      },
      isMultipleFacesFound: {
        heading: "A ti ri oju pupọ. Jọwọ rii daju pe oju tirẹ nikan ni o han ninu kamẹra.",
        button: "Gbiyanju lẹẹkansi"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Gbiyanju lẹẹkansi"
      },
      faceDetections: {
        heading: "Jọwọ yọ eyi",
        button: "Gbiyanju lẹẹkansi"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "A ti ri ọpọlọpọ awọn oju",
          button: "Gbiyanju lẹẹkansi"
        },
        generalMessage: {
          heading: "Jọwọ rii daju pe o wa niwaju kamẹra ati pe o wa laaye",
          button: "Gbiyanju lẹẹkansi"
        }
      },
      faceMatch: {
        heading: "Ojú rẹ ko ba aworan ID",
        button: "Gbiyanju lẹẹkansi"
      },
      selfieError: {
        heading: "A ko le ṣe idanwo selfie rẹ",
        subHeading1: "Tẹle awọn imọran wọnyi ki o gbiyanju lẹẹkansi",
        instruction1: "Ṣe iyipada si agbegbe ti o ni imọlẹ to dara ati yago fun imọlẹ abẹlẹ",
        instruction2: "Jọwọ rii daju pe oju rẹ han patapata ati pe o wa ni aarin àwòrán",
        instruction3: "Yọ awọn fila, gilaasi, tabi awọn iboju lati wo oju rẹ ni kedere",
        button: "Gbiyanju lẹẹkansi"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP kò bára mu. Jọ̀wọ́ ka OTP ní kedere sókè",
        button: "Gbìyànjú Lẹ́ẹ̀kansí"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Ìfọwọ́sí kùnà. Jọwọ tẹ̀lé àwọn ìtọ́ni ní kedere kí o sì gbiyanju lẹẹkansi",
        button: "Gbiyanju lẹẹkansi"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF ní àwọn ojú-ìwé púpọ̀ jù",
        subHeading: "PDF tí a gbé sókè ré kọjá àlà ojú-ìwé 2. Jọ̀wọ́ gbé PDF tí kò ju ojú-ìwé 2 lọ sókè, tàbí àwòrán tó ṣe kedere ti ID rẹ."
      },
      heading: "A ko le ṣe ilana ID rẹ",
      subHeading: "Bóyá o n tẹ ID ti ko tọ̀ silẹ tàbí aworan naa ko ṣokunkun",
      buttonBack: "Tun ṣe igbiyanju apá ẹ̀hìn ID",
      buttonFront: "Tun ṣe igbiyanju apá iwájú ID",
      button: "Gbiyanju lẹẹkansi",
      captureFrontSide: "Ya Ẹ̀gbẹ́ Iwájú",
      captureBackSide: "Ya Ẹ̀gbẹ́ Ẹ̀yìn",
      changeIDButton: "Yan Ìwé Mìíràn",
      wrongid: {
        heading: "A kò lè ṣe ìṣàkóso ìwé yìí",
        subHeading: "Jọ̀wọ́ jẹ́rìí pé o ń gbé ìwé tó tọ́ sókè kí o sì rí i dájú pé dídára àwòrán ṣe kedere"
      },
      expiredid: {
        heading: "Ìwé ID Ti Dópin!",
        subHeading: "A kò lè gba ìwé ID tí ó ti dópin. Jọ̀wọ́ pèsè ìwé tó wúlò"
      },
      minimumage: {
        heading: "Ìbéèrè Ọjọ́-orí Kò Tẹ́ Mọ́!",
        subHeading: "Ọjọ́-orí rẹ wà nísàlẹ̀ ọjọ́-orí tí ó kéré jù tí a béèrè. Jọ̀wọ́ rí i dájú pé o tẹ́ ìlànà ọjọ́-orí tí ó kéré jù mọ́"
      },
      mobileAttemptsDone: {
        heading: "Ìrìnàjò tẹ̀síwájú lórí ẹ̀rọ rẹ tẹ́lẹ̀",
        subHeading: "A ti dá ìpàdé yìí dúró báyìí láti yẹ̀ ẹ̀dà."
      },
      finished: {
        heading: "Ìrìnàjò ti parí",
        subHeading: "Ìrìnàjò ti parí tàbí ti dópin"
      },
      invalid: {
        heading: "Ìrìnàjò Kò Sí !",
        subHeading: "A kò rí journeyId tàbí ID ìrìnàjò kò wúlò"
      },
      INVALID_PAN_NUMBER: {
        heading: "Nọ́mbà PAN Tí Kò Tọ́",
        subHeading: "Nọ́mbà PAN tí o tẹ̀ kò wúlò. Jọ̀wọ́ ṣàyẹ̀wò kí o sì gbìyànjú lẹ́ẹ̀kansí"
      },
      INVALID_PAN_STATUS: {
        heading: "Ipò PAN Tí Kò Tọ́",
        subHeading: "Nọ́mbà PAN tí o tẹ̀ kò wúlò. Jọ̀wọ́ ṣàyẹ̀wò kí o sì gbìyànjú lẹ́ẹ̀kansí"
      },
      directKyc: {
        heading: "Ìrìnàjò KYC Tààrà !",
        subHeading: "Èyí jẹ́ ìrìnàjò KYC tààrà. A kò gba ìrìnàjò frontend láàyè."
      },
      DOCTYPE_FALSE: {
        heading: "Ìwé Tí Kò Tọ́ Ni A Pèsè!",
        subHeading: "Jọ̀wọ́ gbé ìwé tó wúlò sókè kí o sì rí i dájú pé dídára àwòrán dára."
      },
      ONLY_FRONT: {
        heading: "Ẹ̀yìn ID kò sí",
        subHeading: "O pèsè iwájú nìkan. Jọ̀wọ́ yí ID rẹ padà kí o sì pèsè ẹ̀yìn láti tẹ̀síwájú"
      },
      ONLY_BACK: {
        heading: "Iwájú ID kò sí",
        subHeading: "O pèsè ẹ̀yìn nìkan. Jọ̀wọ́ yí ID rẹ padà kí o sì pèsè iwájú láti tẹ̀síwájú"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Ìwé Yóò Dópin Láìpẹ́",
        subHeading: "A kọ ìwé sílẹ̀ nítorí yóò dópin láìpẹ́."
      },
      DOCUMENT_EXPIRED: {
        heading: "Ìwé Ti Dópin!",
        subHeading: "Jọ̀wọ́ gbé ìwé tó wúlò, tí kò tíì dópin sókè láti tẹ̀síwájú."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Ìbéèrè Ọjọ́-orí Kò Tẹ́ Mọ́!",
        subHeading: "Ìwé fihàn pé o kò tẹ́ ọjọ́-orí tí a béèrè mọ́. Jọ̀wọ́ gbé ìwé tó wúlò sókè."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Kò Lè Fọwọ́sí Ìwé!",
        subHeading: "Dídára àwòrán burú jù fún ìfọwọ́sí. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí pẹ̀lú àwòrán tí ó ṣe kedere."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Kò Lè Fọwọ́sí Ìwé!",
        subHeading: "Àwọn ìròyìn kan kò lè fọwọ́sí. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí pẹ̀lú àwòrán tí ó ṣe kedere."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Kò Lè Fọwọ́sí Ìwé!",
        subHeading: "Àwọn àlàyé kan kò lè fọwọ́sí nítorí dídára àwòrán burú. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí pẹ̀lú àwòrán tí ó ṣe kedere"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Kò Lè Fọwọ́sí Ìwé!",
        subHeading: "Àwọn àlàyé kan kò lè fọwọ́sí. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí pẹ̀lú àwòrán tí ó ṣe kedere."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Ìṣòro láti fọwọ́sí fọ́tò rẹ lórí ID",
        subHeading: "A kò lè fọwọ́sí fọ́tò rẹ lórí káàdì ID. Jọ̀wọ́ gbé fọ́tò tí ó ṣe kedere ti ID ìpilẹ̀ṣẹ̀ rẹ sókè kí a lè jẹ́rìí sí i."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Àyẹ̀wò àpẹẹrẹ ààbò ìwé kùnà",
        subHeading: "A kò lè fọwọ́sí àwọn àpẹẹrẹ ààbò tí ó wà nínú ìwé. Jọ̀wọ́ gbé fọ́tò tí ó ṣe kedere ti ID ìpilẹ̀ṣẹ̀ sókè láti ràn wá lọ́wọ́ láti jẹ́rìí òtítọ́ rẹ̀."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Àyẹ̀wò Ìwàláàyè Ìwé Kùnà",
        subHeading: "A rí àwọn àmì pé ìwé náà lè má jẹ́ òtítọ́. Jọ̀wọ́ yẹ̀ lílo àwòrán ojú-ìbòjú, ẹ̀dà títẹ̀, tàbí fífi ID hàn lórí ìbòjú. Gbé ID ìpilẹ̀ṣẹ̀ sókè pẹ̀lú gbogbo àwọn ẹ̀yà tí ó hàn kedere"
      },
      SECURITY_FALSE: {
        heading: "A Rí Ìṣòro!",
        subHeading: "A kò lè fọwọ́sí ìwé náà. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí pẹ̀lú àwòrán tí ó ṣe kedere"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Dídára Àwòrán Burú!",
        subHeading: "Àwòrán rú jù tàbí kò ṣe kedere. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí pẹ̀lú àwòrán tí ó ṣe kedere"
      },
      FACE_UNDETECTED: {
        heading: "A Kò Rí Ojú",
        subHeading: "A kò lè rí ojú tí ó hàn lórí ìwé náà. Jọ̀wọ́ gbé ID tó wúlò sókè níbi tí ojú ti hàn kedere"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Ìfiwéra Láàrin Àwọn Ìwé Kùnà",
        subHeading: "Ìfiwéra láàrin àwọn ìwé kùnà nítorí àìbára mu nínú ọ̀kan tàbí jù bẹ́ẹ̀ lọ pàtàkì pápá (Orúkọ, Ọjọ́ Ìbí, tàbí Ojú)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Ìkùnà Digilocker",
        subHeading: "Àṣìṣe kan ṣẹlẹ̀ nígbà ìrìnàjò Digilocker. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí tàbí lo ọ̀nà mìíràn láti tẹ̀síwájú."
      },
      LINKAGE_FAILED: {
        heading: "A kò lè parí ìjẹ́rìísí yìí",
        subHeading: "Àwọn àlàyé tí a gbà kò bá àkọsílẹ̀ fún àyẹ̀wò yìí mu."
      }
    },
    biometricConsent: {
      consentStatement: "Ṣáájú fọ́tò ara-rẹ, a nílò ìyọ̀nda rẹ láti gba àti ṣàyẹ̀wò dátà bàyómẹ́tíríìkì rẹ (àwòrán ojú àti àwọn àmì ìwàláàyè) láti fọwọ́sí ìdánimọ̀ rẹ. A ń lo dátà yìí fún ìfọwọ́sí yìí nìkan.",
      privacyPolicy: "Ìlànà àṣírí",
      consentButton: "Mo gbà — Tẹ̀síwájú",
      declineButton: "Mi ò gbà",
      confirmTitle: "Tẹ̀síwájú láìsí ìfọwọ́sí bàyómẹ́tíríìkì?",
      confirmBody: "Láìsí ìfọwọ́sí bàyómẹ́tíríìkì, a ò ní ya fọ́tò ara-rẹ. A óò parí ìfọwọ́sí rẹ pẹ̀lú ìsọfúnni tí o ti pèsè tẹ́lẹ̀. Àṣàyàn yìí jẹ́ ìkẹyìn fún ìpàdé yìí.",
      goBack: "Padà sẹ́yìn",
      confirmDecline: "Jẹ́rìísí — mi ò gbà",
      declineComplete: "O ti yàn láti má tẹ̀síwájú pẹ̀lú ìfọwọ́sí bàyómẹ́tíríìkì. A ti parí ìfọwọ́sí ìdánimọ̀ rẹ pẹ̀lú àwọn ìwé tí o fi sílẹ̀."
    },
    introLiveness: {
      heading: "Jẹ́rìí pé o wà láàyè níbí",
      instruction1: "Rii daju pe ina to wa",
      instruction2: "Gba awọn igbanilaaye to ṣe pataki",
      instruction3: "Kan tẹle awọn ilana",
      button: "Tẹsiwaju",
      subHeading: "Ìgbésẹ̀ kan ṣoṣo ló kù fún ọ"
    },
    phoneSession: {
      heading: "Ipade tẹsiwaju lori foonu",
      subheading: "Pa oju-iwe yii ṣí titi di ti pari lori ẹrọ alagbeka",
      button: "Tẹsiwaju nibi"
    },
    continueOnPhone: {
      heading: "Tẹsiwaju lori foonu",
      subheading: "Ṣe ayẹwo QR tàbí daakọ ìjápọ̀ ní isalẹ",
      subheading2: "Ṣe ayẹwo QR tàbí ṣí ìjápọ̀ náà ní foonu rẹ",
      text: "Pari ilana naa",
      text1: "Ṣayẹwo nibi lati fi silẹ",
      button: "Daakọ",
      copiedButton: "Ti dàkọ!",
      copied: "A ti daakọ!"
    },
    SsnReview: {
      heading: "Atunwo alaye rẹ",
      subHeading: "Ṣe awọn iyipada pataki ki o fi alaye naa silẹ",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Kilasi",
      feild5: "RSTR",
      feild6: "Orílẹ̀-èdè",
      feild7: "Àdírẹ́sì",
      button: "Alaye jẹ́ tọ̀nà"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Jẹ́ kí ojú rẹ wà nínú àyíká"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Sún mọ́ kámẹ́rà"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Má tijú, wọ inú ìran"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Ó ṣú gan-an. Wá ìmọ́lẹ̀ tó pọ̀"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Ó mọ́lẹ̀ jù. Wá ìmọ́lẹ̀ tútù"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Jẹ́ kí ojú rẹ wà nínú àyíká"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Dúró jẹ́ẹ́"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Yí ojú sí ìmọ́lẹ̀"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Mú fóònù ní ìwọ̀n ojú"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Fà sẹ́yìn díẹ̀ kúrò ní kámẹ́rà"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Fi ojú rẹ sí àárín férémù"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Fi ojú rẹ sí àárín ìyíká náà"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Súnmọ́ síwájú kí o sì fi ojú rẹ tọ́"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Wọlé sí ojú ìwòran kí o sì fi ojú rẹ tọ́"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Dúdú púpọ̀. Wa ina tí ó ṣọ̀kan"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Tí o wọ́pọ̀. Wa ina tí ó pé"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Ṣàtúnṣe ojú rẹ sí àárín ìyíká náà"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Dúró ṣinṣin kí o sì wò títọ́ níwájú"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Fi ojú rẹ sí ìmọ́lẹ̀ kí o sì dúró ṣinṣin"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Di foonu rẹ ní ipele oju"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Ya kuro diẹ lati kamẹra"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Pipe!"
      },
      smile1: {
        icon: "mood",
        description: "Ẹrẹkẹ̀ rẹ̀, o dàbí ẹni tí ó lẹ́wà!"
      },
      smile2: {
        icon: "mood",
        description: "Ẹrẹkẹ̀ fun kamẹra!"
      }
    },
    successful: {
      title: "Ìfímiṣẹ́ parí",
      text: "O le pa ojúfífí bayìí",
      finishBtn: "Pari"
    },
    poweredBy: "Nípasẹ̀",
    redirect: "Tún ìsọ̀ nínú",
    error: {
      message: "URL ti pẹ́ tàbí kò tọ̀nà"
    },
    footer: {
      securedBy: "Nípasẹ̀"
    },
    helpFaq: {
      title: "Iranlọwọ & Awọn ibeere ti a maa n beere",
      subtitle: "A wa nibi lati ran ọ lọwọ",
      cameraText: "Lati fọwọsi idanimọ rẹ, a nilo lati ya awọn aworan nipa lilo kamẹra ẹrọ rẹ. Tẹle link yìí lati kọ ẹkọ bi o ṣe le fun ni awọn igbanilaaye to yẹ",
      cameraHeading: "Igbanilaaye kamẹra",
      languageText: "Ni ibẹrẹ ilana naa, o le yan ede ayanfẹ rẹ nipa yiyan rẹ lati inu akojọ aṣayan yiyi ni oke bar",
      languageHeading: "Yiyan Ede",
      kycText: "KYC, tabi 'Mọ Onibara Rẹ', jẹ ilana ti o n ṣayẹwo ati fọwọsi idanimọ alabara, eyi ti o ṣe iranlọwọ lati rii daju ifaramọ ati lati dena jibiti ati awọn iṣẹ-aje ti ko ni ofin",
      kycHeading: "KYC tumọ si kini?",
      timeText: "Ni gbogbogbo, o gba to 60 aaya. Sibẹsibẹ, eyi le yato da lori awọn orilẹ-ede",
      timeHeading: "Elo ni yoo gba?"
    },
    pdfPreviewUnavailable: "Kò lè fi àkọ́kọ́wò PDF hàn.",
    pdfPreviewHint: "Tí àkọ́kọ́wò kò bá farahàn, o ṣì lè tẹ̀síwájú.",
    pdfOpenLabel: "Ṣí PDF",
    failedUpload: {
      title: "Ìfiwé Fáìlì Kùnà",
      text: "Jọ̀wọ́ rí i dájú pé fáìlì kéré sí 5MB tí ó sì wà ní ọ̀nà .jpg, .jpeg, .png, .heic, .heif, tàbí .pdf",
      btn: "Gbìyànjú Lẹ́ẹ̀kansí",
      pdfNotAllowedIndia: "A kò gba ìfilọ́lẹ̀ PDF láàyè fún Íńdíà. Jọ̀wọ́ fi àwọn fáìlì JPEG, JPG, PNG, HEIC, tàbí HEIF tí kò ju 5 MB lọ sílẹ̀.",
      pdfNotAllowedIndiaBasic: "A kò gba ìfilọ́lẹ̀ PDF láàyè fún Íńdíà. Jọ̀wọ́ fi àwọn fáìlì JPEG, JPG, tàbí PNG tí kò ju 5 MB lọ sílẹ̀."
    },
    livenessAnalyzing: {
      heading: "Ń ṣàyẹ̀wò Ojú Rẹ",
      subHeading: "Jọ̀wọ́ dúró, èyí yóò gba ìṣẹ́jú-aaya díẹ̀ péré"
    },
    sessionExpiredError: {
      heading: "Má bínú, ìpàdé rẹ ti pé àkókò",
      subHeading1: "O ti wà láìṣiṣẹ́ fún ìgbà díẹ̀. Fún ìdí ààbò, ìpàdé rẹ ti dópin fúnra rẹ̀",
      subHeading2: "Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí",
      buttonText: "Gbìyànjú Lẹ́ẹ̀kansí"
    },
    journeyExpiredError: {
      heading: "Má bínú, ọ̀nà àsopọ̀ ti dópin",
      subHeading1: "Ọ̀nà àsopọ̀ kò ṣiṣẹ́ mọ́. Fún ìdí ààbò, àwọn ọ̀nà àsopọ̀ ní àkókò ìwàláàyè tí ó ní ààlà",
      subHeading2: "Jọ̀wọ́ gbìyànjú pẹ̀lú ọ̀nà àsopọ̀ tuntun",
      buttonText: "Gbìyànjú Lẹ́ẹ̀kansí"
    },
    cameraAccessError: {
      alert1: "A kọ̀ àyè kámẹ́rà. Jọ̀wọ́ mú àyè kámẹ́rà ṣiṣẹ́ nínú ètò aṣàwákiri rẹ",
      alert2: "Àṣìṣe kan ṣẹlẹ̀ nígbà tí a ń wọlé sí kámẹ́rà",
      alert3: "Aṣàwákiri rẹ kò ṣe àtìlẹ́yìn fún àyè kámẹ́rà"
    },
    activeLiveness: {
      instruction: "Jẹ́ kí ojú rẹ wà nínú àyíká kí o sì tẹ̀lé àwọn ìtọ́ni",
      permissionDeniedTitle: "Wíwọlé Kámẹ́rà tàbí Gbohùngbohùn Ti Kọ̀",
      permissionDeniedSubtitle: "Jọ̀wọ́ gba àyè wíwọlé kámẹ́rà àti gbohùngbohùn nínú ètò aṣàwákiri rẹ kí o sì gbìyànjú lẹ́ẹ̀kansí."
    },
    flipScreen: {
      heading: "Nísinsìnyí, yí káàdì ìdánimọ̀ rẹ padà",
      subHeading: "Jọ̀wọ́ yí káàdì ìdánimọ̀ rẹ padà ní ti gidi láti fi ẹ̀yìn rẹ̀ hàn, lẹ́yìn náà gbé e sí inú férémù kámẹ́rà.",
      continueButton: "Tẹ̀síwájú"
    },
    mobileDocCapture: {
      frontSide: "Iwájú",
      backSide: "Ẹ̀yìn",
      of: "ti",
      upload: "Gbé sókè",
      stillNotWorking: "Ṣì kò ṣiṣẹ́?",
      clickToCapture: "Gbìyànjú tẹ̀-láti-ya",
      skip: "Fò ó"
    }
,
    permissionPopUp: {
      title: "Igbanilaaye nilo",
      subtitle: "Gba aaye laaye lati lo kamẹra",
      decline: "Kọ",
      allow: "Gba laaye"
    },
    userDetails: {
      heading: "Ìjẹ́rìísí PAN",
      subHeading: "Jọ̀wọ́ kún àwọn àlàyé láti ṣàyẹ̀wò",
      panLabel: "Nọ́mbà PAN",
      panRequired: "Jọ̀wọ́ tẹ nọ́mbà PAN rẹ",
      saveError: "Nkan kan ṣàṣìṣe nígbà tí à ń fi àwọn àlàyé pamọ́. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kan sí i.",
      proceed: "Tẹ̀síwájú"
    },
    redirectCta: {
      or: "tàbí",
      clickHere: "tẹ ibí",
      clickHereStart: "Tẹ ibí",
      toContinue: "láti tẹ̀síwájú"
    },
    documentCapture: {
      stillNotWorking: "Ṣé kò tíì ṣiṣẹ́?",
      clickToCaptureInstead: "Gbìyànjú tẹ-láti-ya dípò rẹ̀",
      pdfNotAllowedIndia: "A kò gba ìfilọ́lẹ̀ PDF láàyè fún Íńdíà. Jọ̀wọ́ fi àwọn fáìlì JPEG, JPG, tàbí PNG tí ó kéré sí 5 MB ránṣẹ́.",
      pdfNotAllowedIndiaMobile: "A kò gba ìfilọ́lẹ̀ PDF láàyè fún Íńdíà. Jọ̀wọ́ fi àwọn fáìlì JPEG, JPG, PNG, HEIC, tàbí HEIF tí ó kéré sí 5 MB ránṣẹ́.",
      fileFormatsIndia: "jpeg, jpg, png kéré sí 5 mb",
      fileFormats: "jpeg, jpg, png, pdf kéré sí 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif kéré sí 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf kéré sí 5 mb"
    },
    mobileCapture: {
      upload: "Gbé sókè",
      skip: "Fo",
      stillNotWorking: "Ṣe kò ṣiṣẹ́ síbẹ̀?",
      tryClickToCapture: "Fọwọ́ kan láti ya"
    },
    UserDetails: {
      panLabel: "Nọ́mbà PAN",
      proceedBtn: "Tẹ̀síwájú",
      panRequired: "Jọ̀wọ́ tẹ nọ́mbà PAN rẹ sí i",
      saveError: "Nǹkan kan ṣàṣìṣe nígbà tí à ń fi àwọn àlàyé pamọ́. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí."
    }
  },
  or: {
    supportingDocument: {
      headingFallback: "ସହାୟକ ଡକ୍ୟୁମେଣ୍ଟ",
      subHeading: "ନିମ୍ନରେ ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ୍ କରନ୍ତୁ। ଏହା ସମୀକ୍ଷା ପାଇଁ ସଂରକ୍ଷିତ ହୁଏ — ଏଥିରୁ କିଛି ବାହାର କରାଯାଏ ନାହିଁ।",
      choosePlaceholder: "ଏକ ଫାଇଲ୍ ବାଛନ୍ତୁ (PNG, JPG କିମ୍ବା PDF)",
      continue: "ଜାରି ରଖନ୍ତୁ",
      uploading: "ଅପଲୋଡ୍ ହେଉଛି...",
      skip: "ବର୍ତ୍ତମାନ ପାଇଁ ଛାଡ଼ନ୍ତୁ",
      errorInvalidType: "ଏକ PNG, JPG କିମ୍ବା PDF ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ।",
      errorTooLarge: "ଫାଇଲ୍ ବହୁତ ବଡ଼। ସୀମା 10MB।",
      errorRead: "ସେହି ଫାଇଲ୍ ପଢ଼ାଯାଇ ପାରିଲା ନାହିଁ। ଦୟାକରି ଅନ୍ୟଟି ଚେଷ୍ଟା କରନ୍ତୁ।",
      errorNoFile: "ଅପଲୋଡ୍ କରିବାକୁ ଏକ ଫାଇଲ୍ ବାଛନ୍ତୁ।",
    },
    header: {
      title: "ଆପଣଙ୍କର ପରିଚୟ ଯାଞ୍ଚ କରନ୍ତୁ",
      subtitle: "ଏହାକୁ 2 ମିନିଟରୁ କମ ସମୟ ଲାଗେ",
      havingIssue: "ସମସ୍ୟା ହେଉଛି କି?"
    },
    onlyIdVerificationHeader: {
      title: "ଆପଣଙ୍କର ପରିଚୟ ପତ୍ର ଯାଞ୍ଚ କରିବା",
      subtitle: "ଏହା କେବଳ ଏକ ମିନିଟ୍ ନେବ। ଆପଣଙ୍କର ପରିଚୟ ପତ୍ର ପାଖରେ ରଖନ୍ତୁ",
      instruction1: "କ୍ୟାମେରା ପ୍ରବେଶ ଅନୁମତି ଦିଅନ୍ତୁ",
      instruction2: "ଆପଣଙ୍କ ଡକ୍ୟୁମେଣ୍ଟ ସ୍କାନ କିମ୍ବା ଅପଲୋଡ୍ କରନ୍ତୁ",
      instruction3: "ତତକ୍ଷଣାତ୍ ଡକ୍ୟୁମେଣ୍ଟ ଯାଞ୍ଚ"
    },
    subHeading: {
      subHeading1: "ଆପଣଙ୍କର ID ଡକ୍ୟୁମେଣ୍ଟ ଧରନ୍ତୁ",
      subHeading2: "ଆପଣ ଜୀବନ୍ତ ଅଛନ୍ତି କି ଯାଞ୍ଚ କରନ୍ତୁ",
      livenessHeading1: "ଭଲ ଆଲୋକ ଥିବା ସ୍ଥାନ ଖୋଜନ୍ତୁ",
      livenessHeading2: "ଆପଣଙ୍କ ମୁହଁ କେନ୍ଦ୍ରରେ ରଖନ୍ତୁ"
    },
    termsAndCondition: {
      title: "ମୁଁ ନିମ୍ନଲିଖିତ ସର୍ତ୍ତ ସମୂହକୁ ସମ୍ମତି ଓ ପାଳନ କରିବାକୁ ସମ୍ମତ ହେଉଛି।",
      privacyPolicy: "ସର୍ତ୍ତଗୁଡିକ ଦେଖନ୍ତୁ",
      beginBtnText: "ଆରମ୍ଭ କରନ୍ତୁ",
      beginLiveness: "ଜୀବନ୍ତତା ଯାଞ୍ଚ ଆରମ୍ଭ ହେଉଛି",
      startLiveness: "ଜୀବନ୍ତତା ଯାଞ୍ଚ ପାଇଁ ଆଗକୁ ବଢନ୍ତୁ"
    },
    permissionDenied: {
      title: "କ୍ୟାମେରା ପ୍ରବେଶ ପାଇଁ ଅନୁମତି ଅସ୍ୱୀକୃତ!",
      subtitle: "ବ୍ରାଉଜର ଠିକଣା ବାର ନିକଟରେ ଅବରୋଧିତ କ୍ୟାମେରା ଆଇକନ ଅଛି କି ନାହିଁ ଯାଞ୍ଚ କରନ୍ତୁ ଏବଂ ଏହାକୁ ଅନଲକ୍ କରନ୍ତୁ।",
      readMore: "ଅଧିକ ପଢନ୍ତୁ",
      refreshText: "କ୍ୟାମେରା ପ୍ରବେଶକୁ ଅନୁମତି ଦେଇସାରିବା ପରେ, ନିମ୍ନରେଥିବା ‘ପୁନଃସ୍ଥାପନ’ ବଟନ କ୍ଲିକ୍ କରନ୍ତୁ।",
      refreshBtn: "ପୁନଃସ୍ଥାପନ",
      link: "କିମ୍ବା, ଫୋନରେ ଜାରି ରଖନ୍ତୁ",
      buttonText: "କିମ୍ବା, ଫୋନରେ ଜାରି ରଖନ୍ତୁ"
    },
    desktopBrowserPermissionDenied: {
      title: "ଦୟାକରି କ୍ୟାମେରା ପ୍ରବେଶକୁ ଅନୁମତି ଦିଅନ୍ତୁ",
      subtitle: "ବ୍ରାଉଜର୍ ଅନୁମତି ଚାହିଁ ପାରେ। ଆଗକୁ ବଢିବାକୁ 'ଅନୁମତି ଦିଅ' କ୍ଲିକ କରନ୍ତୁ।",
      readMore: "ଅଧିକ ପଢନ୍ତୁ",
      refreshText: "ଅନୁମତି ଦେଇବା ପରେ ପୁନଃସ୍ଥାପନ କରନ୍ତୁ",
      refreshBtn: "ପୁନଃସ୍ଥାପନ",
      link: "କିମ୍ବା, ଫୋନରେ ଜାରି ରଖନ୍ତୁ",
      buttonText: "କିମ୍ବା, ଫୋନରେ ଜାରି ରଖନ୍ତୁ"
    },
    androidBrowserPermissionDenied: {
      title: "କ୍ୟାମେରା ପ୍ରବେଶ ପାଇଁ ଅନୁମତି ଅସ୍ୱୀକୃତ!",
      subtitle: "ବ୍ରାଉଜର ଠାରେ ଠିକଣା ବାର ପାଖରେ ଥିବା ବ୍ଲକ୍ କରାଯାଇଥିବା କ୍ୟାମେରା ଚିହ୍ନ ଦେଖନ୍ତୁ ଓ ଏହାକୁ ଅନବ୍ଲକ୍ କରନ୍ତୁ।",
      readMore: "ଅଧିକ ଜାଣନ୍ତୁ",
      refreshText: "କ୍ୟାମେରା ପ୍ରବେଶ ଅନୁମତି ମିଳିଲେ, ନିମ୍ନରେ ଥିବା 'ରିଫ୍ରେଶ୍' ବଟନ୍ ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ।",
      refreshBtn: "ରିଫ୍ରେଶ୍",
      link: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ",
      buttonText: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ"
    },
    androidWebViewPermissionDenied: {
      title: "କ୍ୟାମେରା ପ୍ରବେଶ ପାଇଁ ଅନୁମତି ଅସ୍ୱୀକୃତ!",
      subtitle: "ଆପ୍ ପରିବେଷଣ ସେଟିଂରେ କ୍ୟାମେରା ପ୍ରବେଶ ବନ୍ଦ ହୋଇଥିବା ସମ୍ଭାବନା ଅଛି। ଦୟାକରି App Info > Permissions > Camera ଯାଇ ଅନୁମତି ଦିଅନ୍ତୁ।",
      refreshText: "କ୍ୟାମେରା ପ୍ରବେଶ ଅନୁମତି ମିଳିଲେ, ନିମ୍ନରେ ଥିବା 'ରିଫ୍ରେଶ୍' ବଟନ୍ ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ।",
      refreshBtn: "ରିଫ୍ରେଶ୍",
      link: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ",
      buttonText: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ"
    },
    iosBrowserPermissionDenied: {
      title: "କ୍ୟାମେରା ପ୍ରବେଶ ପାଇଁ ଅନୁମତି ଅସ୍ୱୀକୃତ!",
      subtitle: "ଠିକଣା ବାର ପାଖରେ କ୍ୟାମେରା କିମ୍ବା ଲକ୍‌ ଚିହ୍ନ ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ ବା ବ୍ରାଉଜର ସେଟିଂ ଯାଞ୍ଚ କରନ୍ତୁ।",
      readMore: "ଅଧିକ ଜାଣନ୍ତୁ",
      refreshText: "କ୍ୟାମେରା ପ୍ରବେଶ ଅନୁମତି ମିଳିଲେ, ନିମ୍ନରେ ଥିବା 'ରିଫ୍ରେଶ୍' ବଟନ୍ ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ।",
      refreshBtn: "ରିଫ୍ରେଶ୍",
      link: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ",
      buttonText: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ"
    },
    iosWebViewPermissionDenied: {
      title: "କ୍ୟାମେରା ପ୍ରବେଶ ପାଇଁ ଅନୁମତି ଅସ୍ୱୀକୃତ!",
      subtitle: "ଏହି ଅନୁପ୍ରଯୋଗର ସେଟିଂରେ କ୍ୟାମେରା ଅନୁମତି ବନ୍ଦ ହୋଇଥିବା ସମ୍ଭାବନା ଅଛି। Settings ଯାନ୍ତୁ, ଅନୁପ୍ରଯୋଗ ବାଛନ୍ତୁ, ଏବଂ Camera permission ଚାଲୁ କରନ୍ତୁ।",
      refreshText: "କ୍ୟାମେରା ପ୍ରବେଶ ଅନୁମତି ମିଳିଲେ, ନିମ୍ନରେ ଥିବା 'ରିଫ୍ରେଶ୍' ବଟନ୍ ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ।",
      refreshBtn: "ରିଫ୍ରେଶ୍",
      link: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ",
      buttonText: "କିମ୍ବା ଫୋନ୍‌ରେ ଚାଲୁ ରଖନ୍ତୁ"
    },
    documentationList: {
      countryHeading: "ଦେଶ ଚୟନ କରନ୍ତୁ",
      docHeading: "ଆପଣଙ୍କ ଡକ୍ୟୁମେଣ୍ଟ ଚୟନ କରନ୍ତୁ",
      btnText: "ପରେ",
      searchCountry: "ଦେଶ ଖୋଜନ୍ତୁ"
    },
    frontDocCapture: {
      heading: "ID ର ସାମ୍ନା ଆଖରକୁ ଚତୁର୍ଭୁଜ ମଧ୍ୟରେ ରଖନ୍ତୁ",
      backupHeading: "ସମସ୍ୟା ହେଉଛି କି? ଦୟାକରି ଛବିକୁ ହସ୍ତଚାଳିତ ଭାବେ କ୍ଲିକ କରନ୍ତୁ",
      btnText: "ଫୋଟୋ କଲାଣ୍ଟୁ",
      headingBack: " ଆୟତ ମଧ୍ୟରେ",
      uploadButton: "କିମ୍ବା, ID ଅପଲୋଡ୍ କରନ୍ତୁ"
    },
    backDocCapture: {
      heading: "ID ର ପଛଖଣ୍ଡକୁ ଚତୁର୍ଭୁଜ ମଧ୍ୟରେ ରଖନ୍ତୁ",
      backupHeading: "ସମସ୍ୟା ହେଉଛି କି? ଦୟାକରି ଛବିକୁ ହସ୍ତଚାଳିତ ଭାବେ କ୍ଲିକ କରନ୍ତୁ",
      btnText: "ଫୋଟୋ କଲାଣ୍ଟୁ",
      containerText: "କିମ୍ବା, ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ କରନ୍ତୁ",
      text: "କ୍ୟାପଚରିଂ ହେଉଛି, ସ୍ଥିର ରଖନ୍ତୁ",
      headingBack: " ଆୟତ ମଧ୍ୟରେ",
      skipButton: "ପଛ ପାର୍ଶ୍ୱ ଛାଡ଼ନ୍ତୁ",
      uploadButton: "କିମ୍ବା, ID ଅପଲୋଡ୍ କରନ୍ତୁ"
    },
    analyzing: {
      heading: "ଆପଣଙ୍କ ID ଆନାଲାଇଜ କରାଯାଉଛି...",
      subHeading: "ଦୟାକରି ଅଗ୍ର ପ୍ରଦର୍ଶନରେ ଆପଣଙ୍କର କାର୍ଡ ବିବରଣୀ ଯାଞ୍ଚ କରନ୍ତୁ ଓ ଆବଶ୍ୟକ ହେଲେ ସମ୍ପାଦନ କରନ୍ତୁ"
    },
    imageCheck: {
      heading: "ଆପଣଙ୍କର ଛବି ଯାଞ୍ଚ କରନ୍ତୁ",
      subHeading: "ଦୟାକରି ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଛବି ପୂରା, ସଫା ଓ ଧୁନ୍ଧଳା ଓ ପ୍ରତିବିମ୍ବ ମୁକ୍ତ ଅଟେ।",
      button1: "ପୁନଃ ଫୋଟୋ ନିଅନ୍ତୁ",
      button2: "ଠିକ ଅଛି",
      frontHeading: "ସାମ୍ନାର ଛବି ଯାଞ୍ଚ କରନ୍ତୁ",
      backHeading: "ପଛର ଛବି ଯାଞ୍ଚ କରନ୍ତୁ"
    },
    errorHandler: {
      heading: "ଓ ନାହିଁ :(",
      subHeading1: "ଆମେ କିଛି ସମସ୍ୟାରେ ପଡୁଛୁ, କିନ୍ତୁ ଚିନ୍ତା କରିବାକୁ ମୁହଁ! ଦୟାକରି ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ",
      subHeading2: "ଏହା ଜାରି ରହିଲେ, ପରେ ଚେକ କରନ୍ତୁ",
      button: "ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "ଦୟାକରି ଆପଣଙ୍କର ମୁହଁ ଆଡିଥିବା କିଛି ହଟାନ୍ତୁ",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      eyeClosureDetected: {
        heading: "ଦୟାକରି ଆପଣଙ୍କ ଆଖି ଖୋଲି ରଖନ୍ତୁ ଏବଂ ସିଧା କ୍ୟାମେରାକୁ ଦେଖନ୍ତୁ",
        button: "ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      isMultipleFacesFound: {
        heading: "ଅନେକ ମୁହଁ ଚିହ୍ନଟ ହୋଇଛି। ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ କ୍ୟାମେରାରେ କେବଳ ଆପଣଙ୍କର ମୁହଁ ଦେଖାଯାଉଛି।",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      faceDetections: {
        heading: "ଦୟାକରି ଏହିଟି ହଟାନ୍ତୁ",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "ଅନେକ ମୁହଁ ମିଳିଛି",
          button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
        },
        generalMessage: {
          heading: "ଦୟାକରି ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଆପଣ କ୍ୟାମେରା ସମ୍ନରେ ଜୀବିତ ଅଛନ୍ତି",
          button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
        }
      },
      faceMatch: {
        heading: "ଆପଣଙ୍କର ମୁହଁ ID ଫଟୋ ସହିତ ମେଳ ଖାଉନି",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      selfieError: {
        heading: "ଆମେ ଆପଣଙ୍କର ସେଲ୍‌ଫୀ ପରୀକ୍ଷା କରିପାରୁନି",
        subHeading1: "ଦୟାକରି ଏହି ସୂଚନାଗୁଡିକୁ ଅନୁସରଣ କରନ୍ତୁ ଏବଂ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
        instruction1: "ଭଲ ଆଲୋକିତ କ୍ଷେତ୍ରକୁ ଯାଆନ୍ତୁ ଏବଂ ପଛ ଆଲୋକକୁ ଏଡ଼ାନ୍ତୁ",
        instruction2: "ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଆପଣଙ୍କର ମୁହଁ ପୁରା ଭାବରେ ଦେଖାଯାଉଛି ଏବଂ ଫ୍ରେମରେ ମଧ୍ୟରେ ଅଛି",
        instruction3: "ଆପଣଙ୍କର ମୁହଁ ସଂପୂର୍ଣ୍ଣ ଭାବେ ଦେଖାଯିବାକୁ ହେଲେ ହ୍ୟାଟ, ଚଶମା କିମ୍ବା ମାସ୍କ ହଟାନ୍ତୁ",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP ମେଳ ହେଲା ନାହିଁ। ଦୟାକରି OTP କୁ ସ୍ପଷ୍ଟ ଭାବେ ବଡ଼ ସ୍ୱରରେ ପଢ଼ନ୍ତୁ",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      activeLivenessGenericFailureMessage: {
        heading: "ଯାଞ୍ଚ ବିଫଳ ହେଲା। ଦୟାକରି ନିର୍ଦ୍ଦେଶଗୁଡ଼ିକୁ ସ୍ପଷ୍ଟ ଭାବେ ଅନୁସରଣ କରନ୍ତୁ ଏବଂ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
        button: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF ରେ ବହୁତ ଅଧିକ ପୃଷ୍ଠା ଅଛି",
        subHeading: "ଅପଲୋଡ୍ କରାଯାଇଥିବା PDF 2-ପୃଷ୍ଠା ସୀମା ଅତିକ୍ରମ କରୁଛି। ଦୟାକରି 2 ପୃଷ୍ଠାରୁ ଅଧିକ ନଥିବା PDF, କିମ୍ବା ଆପଣଙ୍କ IDର ସ୍ପଷ୍ଟ ଛବି ଅପଲୋଡ୍ କରନ୍ତୁ।"
      },
      heading: "ଆମେ ଆପଣଙ୍କ ID ପ୍ରକ୍ରିୟା କରିପାରୁନାହିଁ",
      subHeading: "ଆପଣ ବିପରୀତ ID ଅପଲୋଡ କରୁଛନ୍ତି କିମ୍ବା ଛବି ସଫା ନୁହେଁ",
      buttonBack: "ID ପଛଖଣ୍ଡକୁ ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ",
      buttonFront: "ID ସାମ୍ନାଖଣ୍ଡକୁ ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ",
      button: "ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ",
      captureFrontSide: "ସାମ୍ନା ପାର୍ଶ୍ୱ କ୍ୟାପଚର କରନ୍ତୁ",
      captureBackSide: "ପଛ ପାର୍ଶ୍ୱ କ୍ୟାପଚର କରନ୍ତୁ",
      changeIDButton: "ଅନ୍ୟ ଡକ୍ୟୁମେଣ୍ଟ ବାଛନ୍ତୁ",
      wrongid: {
        heading: "ଆମେ ଏହି ଡକ୍ୟୁମେଣ୍ଟ ପ୍ରକ୍ରିୟା କରିପାରିଲୁ ନାହିଁ",
        subHeading: "ଦୟାକରି ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଆପଣ ସଠିକ ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ୍ କରୁଛନ୍ତି ଏବଂ ଚିତ୍ର ଗୁଣବତ୍ତା ସ୍ପଷ୍ଟ ଅଛି"
      },
      expiredid: {
        heading: "ID ଡକ୍ୟୁମେଣ୍ଟ ସମାପ୍ତ ହୋଇଛି!",
        subHeading: "ଆମେ ଏକ ସମାପ୍ତ ID ଡକ୍ୟୁମେଣ୍ଟ ଗ୍ରହଣ କରିପାରିବୁ ନାହିଁ। ଦୟାକରି ଏକ ବୈଧ ଡକ୍ୟୁମେଣ୍ଟ ଦିଅନ୍ତୁ"
      },
      minimumage: {
        heading: "ବୟସ ଆବଶ୍ୟକତା ପୂରଣ ହୋଇନାହିଁ!",
        subHeading: "ଆପଣଙ୍କ ବୟସ ସର୍ବନିମ୍ନ ଆବଶ୍ୟକ ବୟସଠାରୁ କମ୍। ଦୟାକରି ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଆପଣ ସର୍ବନିମ୍ନ ବୟସ ମାନଦଣ୍ଡ ପୂରଣ କରୁଛନ୍ତି"
      },
      mobileAttemptsDone: {
        heading: "ଆପଣଙ୍କ ପୂର୍ବ ଡିଭାଇସରେ ଯାତ୍ରା ପୁନଃ ଆରମ୍ଭ ହେଲା",
        subHeading: "ନକଲ ଏଡ଼ାଇବାକୁ ଏହି ସେସନ୍ ବର୍ତ୍ତମାନ ବନ୍ଦ କରାଯାଇଛି।"
      },
      finished: {
        heading: "ଯାତ୍ରା ସମାପ୍ତ ହୋଇଛି",
        subHeading: "ଯାତ୍ରା ହୁଏତ ସମ୍ପୂର୍ଣ୍ଣ ହୋଇଛି କିମ୍ବା ସମାପ୍ତ ହୋଇଛି"
      },
      invalid: {
        heading: "ଯାତ୍ରା ଉପଲବ୍ଧ ନାହିଁ !",
        subHeading: "କୌଣସି journeyId ମିଳିଲା ନାହିଁ କିମ୍ବା ଯାତ୍ରା ID ଅବୈଧ"
      },
      INVALID_PAN_NUMBER: {
        heading: "ଅବୈଧ PAN ନମ୍ବର",
        subHeading: "ଆପଣ ପ୍ରବେଶ କରିଥିବା PAN ନମ୍ବର ବୈଧ ନୁହେଁ। ଦୟାକରି ଯାଞ୍ଚ କରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      INVALID_PAN_STATUS: {
        heading: "ଅବୈଧ PAN ସ୍ଥିତି",
        subHeading: "ଆପଣ ପ୍ରବେଶ କରିଥିବା PAN ନମ୍ବର ବୈଧ ନୁହେଁ। ଦୟାକରି ଯାଞ୍ଚ କରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      directKyc: {
        heading: "ସିଧାସଳଖ KYC ଯାତ୍ରା !",
        subHeading: "ଏହା ଏକ ସିଧାସଳଖ KYC ଯାତ୍ରା। ଫ୍ରଣ୍ଟେଣ୍ଡ ଯାତ୍ରାକୁ ଅନୁମତି ନାହିଁ।"
      },
      DOCTYPE_FALSE: {
        heading: "ଭୁଲ ଡକ୍ୟୁମେଣ୍ଟ ଦିଆଯାଇଛି!",
        subHeading: "ଦୟାକରି ଏକ ବୈଧ ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ୍ କରନ୍ତୁ ଏବଂ ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ପ୍ରତିଛବି ଗୁଣବତ୍ତା ଭଲ ଅଛି।"
      },
      ONLY_FRONT: {
        heading: "ID ର ପଛ ପାର୍ଶ୍ୱ ନାହିଁ",
        subHeading: "ଆପଣ କେବଳ ଆଗ ପାର୍ଶ୍ୱ ଦେଇଛନ୍ତି। ଦୟାକରି ଆପଣଙ୍କ ID କୁ ଓଲଟାନ୍ତୁ ଏବଂ ଜାରି ରଖିବାକୁ ପଛ ପାର୍ଶ୍ୱ ଦିଅନ୍ତୁ"
      },
      ONLY_BACK: {
        heading: "ID ର ଆଗ ପାର୍ଶ୍ୱ ନାହିଁ",
        subHeading: "ଆପଣ କେବଳ ପଛ ପାର୍ଶ୍ୱ ଦେଇଛନ୍ତି। ଦୟାକରି ଆପଣଙ୍କ ID କୁ ଓଲଟାନ୍ତୁ ଏବଂ ଜାରି ରଖିବାକୁ ଆଗ ପାର୍ଶ୍ୱ ଦିଅନ୍ତୁ"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ଶୀଘ୍ର ସମାପ୍ତ ହେଉଛି",
        subHeading: "ଡକ୍ୟୁମେଣ୍ଟ ଶୀଘ୍ର ସମାପ୍ତ ହେବ ତେଣୁ ପ୍ରତ୍ୟାଖ୍ୟାନ କରାଯାଇଛି।"
      },
      DOCUMENT_EXPIRED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ସମାପ୍ତ ହୋଇଛି!",
        subHeading: "ଦୟାକରି ଜାରି ରଖିବାକୁ ଏକ ବୈଧ, ଅସମାପ୍ତ ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ୍ କରନ୍ତୁ।"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "ବୟସ ଆବଶ୍ୟକତା ପୂରଣ ହୋଇନାହିଁ!",
        subHeading: "ଡକ୍ୟୁମେଣ୍ଟ ସୂଚାଉଛି ଯେ ଆପଣ ଆବଶ୍ୟକ ବୟସ ପୂରଣ କରୁନାହାନ୍ତି। ଦୟାକରି ଏକ ବୈଧ ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ୍ କରନ୍ତୁ।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ଯାଞ୍ଚ କରିବାକୁ ଅସମର୍ଥ!",
        subHeading: "ଯାଞ୍ଚ ପାଇଁ ପ୍ରତିଛବି ଗୁଣବତ୍ତା ବହୁତ ଖରାପ। ଦୟାକରି ଏକ ସ୍ପଷ୍ଟ ପ୍ରତିଛବି ସହିତ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ଯାଞ୍ଚ କରିବାକୁ ଅସମର୍ଥ!",
        subHeading: "କିଛି ସୂଚନା ଯାଞ୍ଚ କରାଯାଇପାରିଲା ନାହିଁ। ଦୟାକରି ଏକ ସ୍ପଷ୍ଟ ପ୍ରତିଛବି ସହିତ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ଯାଞ୍ଚ କରିବାକୁ ଅସମର୍ଥ!",
        subHeading: "ଖରାପ ପ୍ରତିଛବି ଗୁଣବତ୍ତା ହେତୁ କିଛି ବିବରଣୀ ଯାଞ୍ଚ କରାଯାଇପାରିଲା ନାହିଁ। ଦୟାକରି ଏକ ସ୍ପଷ୍ଟ ପ୍ରତିଛବି ସହିତ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ଯାଞ୍ଚ କରିବାକୁ ଅସମର୍ଥ!",
        subHeading: "କିଛି ବିବରଣୀ ଯାଞ୍ଚ କରାଯାଇପାରିଲା ନାହିଁ। ଦୟାକରି ଏକ ସ୍ପଷ୍ଟ ପ୍ରତିଛବି ସହିତ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "ID ରେ ଆପଣଙ୍କ ଫଟୋ ଯାଞ୍ଚ କରିବାରେ ସମସ୍ୟା",
        subHeading: "ଆମେ ID କାର୍ଡରେ ଆପଣଙ୍କ ଫଟୋ ଯାଞ୍ଚ କରିପାରିଲୁ ନାହିଁ। ଦୟାକରି ଆପଣଙ୍କ ମୂଳ ID ର ଏକ ସ୍ପଷ୍ଟ ଫଟୋ ଅପଲୋଡ୍ କରନ୍ତୁ ଯାହାଦ୍ୱାରା ଆମେ ଏହାକୁ ନିଶ୍ଚିତ କରିପାରିବୁ।"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ସୁରକ୍ଷା ପ୍ୟାଟର୍ନ ଯାଞ୍ଚ ବିଫଳ",
        subHeading: "ଆମେ ଡକ୍ୟୁମେଣ୍ଟର ଅନ୍ତର୍ନିହିତ ସୁରକ୍ଷା ପ୍ୟାଟର୍ନ ଯାଞ୍ଚ କରିପାରିଲୁ ନାହିଁ। ଏହାର ପ୍ରାମାଣିକତା ନିଶ୍ଚିତ କରିବାରେ ସାହାଯ୍ୟ କରିବାକୁ ଦୟାକରି ମୂଳ ID ର ଏକ ସ୍ପଷ୍ଟ ଫଟୋ ଅପଲୋଡ୍ କରନ୍ତୁ।"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ସଜୀବତା ଯାଞ୍ଚ ବିଫଳ",
        subHeading: "ଆମେ ଚିହ୍ନ ପାଇଲୁ ଯେ ଡକ୍ୟୁମେଣ୍ଟ ହୁଏତ ପ୍ରକୃତ ନୁହେଁ। ଦୟାକରି ସ୍କ୍ରିନସଟ୍, ମୁଦ୍ରିତ କପି, କିମ୍ବା ସ୍କ୍ରିନରେ ID ଦେଖାଇବା ଏଡ଼ାନ୍ତୁ। ସମସ୍ତ ବୈଶିଷ୍ଟ୍ୟ ସ୍ପଷ୍ଟ ଭାବେ ଦୃଶ୍ୟମାନ ଥିବା ମୂଳ ID ଅପଲୋଡ୍ କରନ୍ତୁ"
      },
      SECURITY_FALSE: {
        heading: "ସମସ୍ୟା ଚିହ୍ନଟ ହେଲା!",
        subHeading: "ଡକ୍ୟୁମେଣ୍ଟ ଯାଞ୍ଚ କରାଯାଇପାରିଲା ନାହିଁ। ଦୟାକରି ଏକ ସ୍ପଷ୍ଟ ପ୍ରତିଛବି ସହିତ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "ଖରାପ ପ୍ରତିଛବି ଗୁଣବତ୍ତା!",
        subHeading: "ପ୍ରତିଛବି ବହୁତ ଅସ୍ପଷ୍ଟ। ଦୟାକରି ଏକ ସ୍ପଷ୍ଟ ପ୍ରତିଛବି ସହିତ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
      },
      FACE_UNDETECTED: {
        heading: "ମୁହଁ ଚିହ୍ନଟ ହେଲା ନାହିଁ",
        subHeading: "ଆମେ ଡକ୍ୟୁମେଣ୍ଟରେ ଏକ ଦୃଶ୍ୟମାନ ମୁହଁ ପାଇଲୁ ନାହିଁ। ଦୟାକରି ମୁହଁ ସ୍ପଷ୍ଟ ଭାବେ ଦୃଶ୍ୟମାନ ଥିବା ଏକ ବୈଧ ID ଅପଲୋଡ୍ କରନ୍ତୁ"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "ଡକ୍ୟୁମେଣ୍ଟ ମଧ୍ୟରେ ତୁଳନା ବିଫଳ",
        subHeading: "ଗୋଟିଏ କିମ୍ବା ଅଧିକ ମୁଖ୍ୟ କ୍ଷେତ୍ର (ନାମ, ଜନ୍ମ ତାରିଖ, କିମ୍ବା ମୁହଁ) ରେ ଅମେଳ ହେତୁ ଡକ୍ୟୁମେଣ୍ଟ ମଧ୍ୟରେ ତୁଳନା ବିଫଳ ହେଲା"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker ବିଫଳତା",
        subHeading: "Digilocker ଯାତ୍ରା ସମୟରେ ଏକ ତ୍ରୁଟି ଘଟିଲା। ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ କିମ୍ବା ଜାରି ରଖିବାକୁ ଏକ ବିକଳ୍ପ ପଦ୍ଧତି ବ୍ୟବହାର କରନ୍ତୁ।"
      },
      LINKAGE_FAILED: {
        heading: "ଏହି ଯାଞ୍ଚ ସମ୍ପୂର୍ଣ୍ଣ କରାଯାଇପାରିଲା ନାହିଁ",
        subHeading: "ଏହି ଯାଞ୍ଚ ପାଇଁ ସଂଗୃହୀତ ବିବରଣୀ ରେକର୍ଡ ସହିତ ମେଳ ଖାଇଲା ନାହିଁ।"
      }
    },
    biometricConsent: {
      consentStatement: "ଆପଣଙ୍କ ସେଲ୍ଫି ପୂର୍ବରୁ, ଆପଣଙ୍କ ପରିଚୟ ଯାଞ୍ଚ କରିବା ପାଇଁ ଆମକୁ ଆପଣଙ୍କ ବାୟୋମେଟ୍ରିକ୍ ଡାଟା (ମୁହଁ ଚିତ୍ର ଏବଂ ଲାଇଭନେସ୍ ସଙ୍କେତ) କ୍ୟାପଚର ଏବଂ ପ୍ରକ୍ରିୟାକରଣ କରିବାକୁ ଆପଣଙ୍କ ସମ୍ମତି ଆବଶ୍ୟକ। ଏହି ଡାଟା କେବଳ ଏହି ଯାଞ୍ଚ ପାଇଁ ବ୍ୟବହୃତ ହୁଏ।",
      privacyPolicy: "ଗୋପନୀୟତା ନୀତି",
      consentButton: "ମୁଁ ସମ୍ମତ — ଆଗକୁ ଯାଆନ୍ତୁ",
      declineButton: "ମୁଁ ସମ୍ମତ ନୁହେଁ",
      confirmTitle: "ବାୟୋମେଟ୍ରିକ୍ ଯାଞ୍ଚ ବିନା ଆଗକୁ ଯିବେ?",
      confirmBody: "ବାୟୋମେଟ୍ରିକ୍ ଯାଞ୍ଚ ବିନା, ଆମେ ସେଲ୍ଫି ନେବୁ ନାହିଁ। ଆପଣ ପୂର୍ବରୁ ଦେଇଥିବା ସୂଚନା ବ୍ୟବହାର କରି ଆପଣଙ୍କ ଯାଞ୍ଚ ସମ୍ପୂର୍ଣ୍ଣ ହେବ। ଏହି ଚୟନ ଏହି ସେସନ୍ ପାଇଁ ଚୂଡ଼ାନ୍ତ।",
      goBack: "ପଛକୁ",
      confirmDecline: "ନିଶ୍ଚିତ କରନ୍ତୁ — ସମ୍ମତ ନୁହେଁ",
      declineComplete: "ଆପଣ ବାୟୋମେଟ୍ରିକ୍ ଯାଞ୍ଚ ସହିତ ଆଗକୁ ନ ବଢ଼ିବାକୁ ବାଛିଛନ୍ତି। ଆପଣ ଦାଖଲ କରିଥିବା ଦଲିଲ ବ୍ୟବହାର କରି ଆପଣଙ୍କ ପରିଚୟ ଯାଞ୍ଚ ସମ୍ପୂର୍ଣ୍ଣ ହୋଇଛି।"
    },
    introLiveness: {
      heading: "ଏଠାରେ ଆପଣ ଜୀବନ୍ତ ଅଟେ କି ଯାଞ୍ଚ କରନ୍ତୁ",
      instruction1: "ପର୍ଯ୍ୟାପ୍ତ ଆଲୋକ ଅଛି ବୋଲି ନିଶ୍ଚିତ କରନ୍ତୁ",
      instruction2: "ଆବଶ୍ୟକ ଅନୁମତିଗୁଡିକ ଦିଅନ୍ତୁ",
      instruction3: "କେବଳ ନିର୍ଦ୍ଦେଶଗୁଡ଼ିକୁ ଅନୁସରଣ କରନ୍ତୁ",
      button: "ଆଗକୁ ବଢନ୍ତୁ",
      subHeading: "ଆପଣ କେବଳ ଗୋଟିଏ ପଦକ୍ଷେପ ଦୂରରେ ଅଛନ୍ତି"
    },
    phoneSession: {
      heading: "ସେସନ ଫୋନରେ ଜାରି ରହିଛି",
      subheading: "ମୋବାଇଲରେ ସମାପ୍ତ ହେଉଅବଦି ଏହି ଉଇଣ୍ଡୋଟି ଖୋଲା ରଖନ୍ତୁ",
      button: "ଏଠାରେ ଜାରି ରଖନ୍ତୁ"
    },
    continueOnPhone: {
      heading: "ଫୋନରେ ଜାରି ରଖନ୍ତୁ",
      subheading: "QR କୋଡ ସ୍କାନ କରନ୍ତୁ କିମ୍ବା ତଳେ ଦିଆଯାଇଥିବା ଲିଙ୍କକୁ କପି କରନ୍ତୁ",
      subheading2: "QR ସ୍କାନ କରନ୍ତୁ କିମ୍ବା ଆପଣଙ୍କର ଫୋନରେ ଲିଙ୍କ ଖୋଲନ୍ତୁ",
      text: "ପ୍ରକ୍ରିୟା ସମାପ୍ତ କରନ୍ତୁ",
      text1: "ଏଠାରେ ଚେକ କରନ୍ତୁ ଯାହା ଦେବାକୁ",
      button: "କପି କରନ୍ତୁ",
      copiedButton: "କପି କରାଗଲା!",
      copied: "କପି ହୋଇଗଲା!"
    },
    SsnReview: {
      heading: "ଆପଣଙ୍କର ବିବରଣୀଗୁଡ଼ିକୁ ପରୀକ୍ଷଣ କରନ୍ତୁ",
      subHeading: "ଆବଶ୍ୟକ ପରିବର୍ତ୍ତନ କରନ୍ତୁ ଓ ବିବରଣୀଗୁଡ଼ିକ ଦାଖଲ କରନ୍ତୁ",
      feild1: "ଡ୍ରାଇଭିଂ ଲାଇସେନ୍ସ",
      feild2: "ମেয়ାଦ ସମାପ୍ତ",
      feild3: "ଜନ୍ମତାରିଖ",
      feild4: "ଶ୍ରେଣୀ",
      feild5: "ସୀମିତକାରଣ",
      feild6: "ଦେଶ",
      feild7: "ଠିକଣା",
      button: "ବିବରଣୀଗୁଡ଼ିକ ସଠିକ୍ ଅଛି"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "ଆପଣଙ୍କ ମୁହଁ ବୃତ୍ତ ମଧ୍ୟରେ ରଖନ୍ତୁ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "କ୍ୟାମେରା ନିକଟକୁ ଆସନ୍ତୁ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ଲାଜ କରନ୍ତୁ ନାହିଁ, ସାମନାକୁ ଆସନ୍ତୁ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ବହୁତ ଅନ୍ଧାର। ଅଧିକ ଆଲୋକକୁ ଯାଆନ୍ତୁ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ବହୁତ ଉଜ୍ଜ୍ୱଳ। ନରମ ଆଲୋକକୁ ଯାଆନ୍ତୁ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ଆପଣଙ୍କ ମୁହଁ ବୃତ୍ତ ମଧ୍ୟରେ ରଖନ୍ତୁ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ସ୍ଥିର ରୁହନ୍ତୁ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ଆଲୋକ ଆଡ଼କୁ ମୁହଁ କରନ୍ତୁ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ଫୋନକୁ ଆଖି ସ୍ତରରେ ଧରନ୍ତୁ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "କ୍ୟାମେରାରୁ ଟିକେ ଦୂରକୁ ଯାଆନ୍ତୁ"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ଆପଣଙ୍କ ମୁହଁ ଫ୍ରେମ ମଧ୍ୟରେ ରଖନ୍ତୁ"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "ଆପଣଙ୍କ ମୁହଁକୁ ବୃତ୍ତର କେନ୍ଦ୍ରରେ ରଖନ୍ତୁ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ନିକଟକୁ ଆସନ୍ତୁ ଏବଂ ମୁହଁ ସିଧା ରଖନ୍ତୁ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ଦୃଶ୍ୟରେ ଆସନ୍ତୁ ଏବଂ ମୁହଁ ସିଧା ରଖନ୍ତୁ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ବହୁତ ଅନ୍ଧାର। ଅଧିକ ଆଲୋକ ଖୋଜନ୍ତୁ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ବହୁତ ତେଜ। ଉପଯୁକ୍ତ ଆଲୋକ ଖୋଜନ୍ତୁ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ଆପଣଙ୍କ ମୁହଁକୁ ବୃତ୍ତର କେନ୍ଦ୍ରକୁ ସମାୟୋଜନ କରନ୍ତୁ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ସ୍ଥିର ରୁହନ୍ତୁ ଏବଂ ସିଧା ସାମନାକୁ ଦେଖନ୍ତୁ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ଆଲୋକ ଆଡ଼କୁ ମୁହଁ କରନ୍ତୁ ଏବଂ ସ୍ଥିର ରୁହନ୍ତୁ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ଆପଣଙ୍କର ଫୋନକୁ ଆଖିର ସ୍ତରରେ ଧରନ୍ତୁ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "କ୍ୟାମେରାରୁ କିଛି ଦୂର ଚାଲିବା"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "ସଫଳ!"
      },
      smile1: {
        icon: "mood",
        description: "ଦୟାକରି ହସନ୍ତୁ, ଆପଣ ଦର୍ଶନରେ ଭଲ ଦେଖାଯାଉଛନ୍ତି!"
      },
      smile2: {
        icon: "mood",
        description: "କ୍ୟାମେରା ପାଇଁ ହସନ୍ତୁ!"
      }
    },
    successful: {
      title: "ଯାଞ୍ଚ ସମ୍ପୂର୍ଣ୍ଣ ହେଲା",
      text: "ଆପଣ ବର୍ତ୍ତମାନ ଉଇଣ୍ଡୋଟି ବନ୍ଦ କରିପାରିବେ",
      finishBtn: "ସମାପ୍ତ"
    },
    poweredBy: "ଦ୍ୱାରା ପ୍ରଚାଳିତ",
    redirect: "ପୁନଃନିର୍ଦେଶିତ ହେଉଛି",
    error: {
      message: "URL ସମୟସୀମା ସମାପ୍ତ ହୋଇଛି କିମ୍ବା ଅବୈଧ"
    },
    footer: {
      securedBy: "ଦ୍ୱାରା ପ୍ରଚାଳିତ"
    },
    helpFaq: {
      title: "ସହାୟତା & ପ୍ରସ୍ନୋତ୍ତର",
      subtitle: "ଆମେ ଏଠାରେ ଆପଣଙ୍କୁ ସହାୟତା କରିବା ପାଇଁ ଅଛୁ",
      cameraText: "ଆପଣଙ୍କର ପରିଚୟ ଯାଞ୍ଚ କରିବାକୁ, ଆମେ ଆପଣଙ୍କର ଡିଭାଇସର କ୍ୟାମେରା ବ୍ୟବହାର କରି ଛବି ନେବାକୁ ଚାହାଁୁଛୁ। ଆବଶ୍ୟକ ଅନୁମତିଗୁଡିକୁ କିପରି ଦେବା ଶିଖିବାକୁ ଏହି link ଉପରେ ଯାଆନ୍ତୁ",
      cameraHeading: "କ୍ୟାମେରା ଅନୁମତି",
      languageText: "ପ୍ରକ୍ରିୟାର ଆରମ୍ଭରେ, ଆପଣ ଆପଣଙ୍କର ପସନ୍ଦୀଦା ଭାଷାକୁ ଚୟନ କରିପାରିବେ, ଯାହାକି ଉପରି ବାରରେ ଥିବା ଡ୍ରପଡାଉନ୍ ମେନୁରୁ ଚୟନ କରାଯିବ",
      languageHeading: "ଭାଷା ଚୟନ",
      kycText: "KYC, କିମ୍ବା 'ଆପଣଙ୍କର ଗ୍ରାହକକୁ ଜାଣିବେ', ଏକ ପ୍ରକ୍ରିୟା ଯାହା ଗ୍ରାହକଙ୍କର ପରିଚୟକୁ ସତ୍ୟାପିତ କରିବାକୁ ଏବଂ ଆଇନ ସମ୍ମତ ଓ ଅପରାଧୀକ କାର୍ଯ୍ୟବଳୀକୁ ରୋକିବାକୁ ସାହାଯ୍ୟ କରେ",
      kycHeading: "KYC କହିଲେ କି?",
      timeText: "ସାଧାରଣତଃ, ଏହାକୁ 60 ସେକେଣ୍ଡ ଧରି ଟାଇମ୍ ଲାଗେ। ତଥାପି, ଏହା ଦେଶଗତ ଭିନ୍ନତା ସହିତ ପରିବର୍ତ୍ତିତ ହୋଇପାରେ",
      timeHeading: "କେତେ ସମୟ ଲାଗିବ?"
    },
    pdfPreviewUnavailable: "PDF ପାଇଁ ପୂର୍ବାବଲୋକନ ଦେଖାଇବାକୁ ଅସମର୍ଥ।",
    pdfPreviewHint: "ଯଦି ପୂର୍ବାବଲୋକନ ଦେଖାଯାଏ ନାହିଁ, ତଥାପି ଆପଣ ଜାରି ରଖିପାରିବେ।",
    pdfOpenLabel: "PDF ଖୋଲନ୍ତୁ",
    failedUpload: {
      title: "ଫାଇଲ୍ ଅପଲୋଡ୍ ବିଫଳ",
      text: "ଦୟାକରି ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଫାଇଲଟି 5MB ରୁ କମ୍ ଏବଂ .jpg, .jpeg, .png, .heic, .heif କିମ୍ବା .pdf ଫର୍ମାଟରେ ଅଛି",
      btn: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
      pdfNotAllowedIndia: "ଭାରତ ପାଇଁ PDF ଅପଲୋଡ୍ ଅନୁମତି ନାହିଁ। ଦୟାକରି 5 MB ରୁ କମ୍ JPEG, JPG, PNG, HEIC, କିମ୍ବା HEIF ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ।",
      pdfNotAllowedIndiaBasic: "ଭାରତ ପାଇଁ PDF ଅପଲୋଡ୍ ଅନୁମତି ନାହିଁ। ଦୟାକରି 5 MB ରୁ କମ୍ JPEG, JPG, କିମ୍ବା PNG ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ।"
    },
    livenessAnalyzing: {
      heading: "ଆପଣଙ୍କ ମୁହଁ ବିଶ୍ଳେଷଣ କରାଯାଉଛି",
      subHeading: "ଦୟାକରି ଅପେକ୍ଷା କରନ୍ତୁ, ଏହା କେବଳ କିଛି ସେକେଣ୍ଡ ନେବ"
    },
    sessionExpiredError: {
      heading: "କ୍ଷମା କରନ୍ତୁ, ଆପଣଙ୍କ ସେସନ୍ ସମୟ ସମାପ୍ତ ହୋଇଛି",
      subHeading1: "ଆପଣ କିଛି ସମୟ ନିଷ୍କ୍ରିୟ ଥିଲେ। ସୁରକ୍ଷା କାରଣରୁ, ଆପଣଙ୍କ ସେସନ୍ ସ୍ୱୟଂଚାଳିତ ଭାବେ ସମାପ୍ତ ହୋଇଛି",
      subHeading2: "ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
      buttonText: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
    },
    journeyExpiredError: {
      heading: "କ୍ଷମା କରନ୍ତୁ, ଲିଙ୍କ ସମାପ୍ତ ହୋଇଛି",
      subHeading1: "ଲିଙ୍କ ଆଉ ସକ୍ରିୟ ନାହିଁ। ସୁରକ୍ଷା କାରଣରୁ, ଲିଙ୍କଗୁଡ଼ିକର ସୀମିତ ଜୀବନକାଳ ଅଛି",
      subHeading2: "ଦୟାକରି ଏକ ନୂଆ ଲିଙ୍କ ସହିତ ଚେଷ୍ଟା କରନ୍ତୁ",
      buttonText: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ"
    },
    cameraAccessError: {
      alert1: "କ୍ୟାମେରା ପ୍ରବେଶ ପ୍ରତ୍ୟାଖ୍ୟାନ ହେଲା। ଦୟାକରି ଆପଣଙ୍କ ବ୍ରାଉଜର ସେଟିଂସରେ କ୍ୟାମେରା ପ୍ରବେଶ ସକ୍ଷମ କରନ୍ତୁ",
      alert2: "କ୍ୟାମେରା ପ୍ରବେଶ କରିବା ସମୟରେ ଏକ ତ୍ରୁଟି ଘଟିଲା",
      alert3: "ଆପଣଙ୍କ ବ୍ରାଉଜର କ୍ୟାମେରା ପ୍ରବେଶକୁ ସମର୍ଥନ କରେ ନାହିଁ"
    },
    activeLiveness: {
      instruction: "ଆପଣଙ୍କ ମୁହଁ ବୃତ୍ତ ମଧ୍ୟରେ ରଖନ୍ତୁ ଏବଂ ନିର୍ଦ୍ଦେଶ ଅନୁସରଣ କରନ୍ତୁ",
      permissionDeniedTitle: "କ୍ୟାମେରା କିମ୍ବା ମାଇକ୍ରୋଫୋନ୍ ପ୍ରବେଶ ପ୍ରତ୍ୟାଖ୍ୟାନ",
      permissionDeniedSubtitle: "ଦୟାକରି ଆପଣଙ୍କ ବ୍ରାଉଜର ସେଟିଂସରେ କ୍ୟାମେରା ଏବଂ ମାଇକ୍ରୋଫୋନ୍ ପ୍ରବେଶକୁ ଅନୁମତି ଦିଅନ୍ତୁ ଏବଂ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।"
    },
    flipScreen: {
      heading: "ବର୍ତ୍ତମାନ ଆପଣଙ୍କ ID କାର୍ଡ ଓଲଟାନ୍ତୁ",
      subHeading: "ଦୟାକରି ପଛ ପାର୍ଶ୍ୱ ଦେଖାଇବାକୁ ଆପଣଙ୍କ ID କାର୍ଡକୁ ଶାରୀରିକ ଭାବେ ଓଲଟାନ୍ତୁ, ତାପରେ ଏହାକୁ କ୍ୟାମେରା ଫ୍ରେମରେ ରଖନ୍ତୁ।",
      continueButton: "ଜାରି ରଖନ୍ତୁ"
    },
    mobileDocCapture: {
      frontSide: "ସାମ୍ନା ପାର୍ଶ୍ୱ",
      backSide: "ପଛ ପାର୍ଶ୍ୱ",
      of: "ର",
      upload: "ଅପଲୋଡ୍ କରନ୍ତୁ",
      stillNotWorking: "ତଥାପି କାମ କରୁନାହିଁ?",
      clickToCapture: "କ୍ଲିକ୍-ଟୁ-କ୍ୟାପଚର୍ ଚେଷ୍ଟା କରନ୍ତୁ",
      skip: "ବାଦ୍ ଦିଅନ୍ତୁ"
    }
,
    permissionPopUp: {
      title: "ଅନୁମତି ଆବଶ୍ୟକ",
      subtitle: "କ୍ୟାମେରା ବ୍ୟବହାର କରିବାକୁ ପ୍ରବେଶ ଅନୁମତି ଦିଅନ୍ତୁ",
      decline: "ପ୍ରତ୍ୟାଖ୍ୟାନ କରନ୍ତୁ",
      allow: "ଅନୁମତି ଦିଅନ୍ତୁ"
    },
    userDetails: {
      heading: "PAN ଯାଞ୍ଚ",
      subHeading: "ଯାଞ୍ଚ କରିବାକୁ ଦୟାକରି ବିବରଣୀ ପୂରଣ କରନ୍ତୁ",
      panLabel: "PAN ନମ୍ବର",
      panRequired: "ଦୟାକରି ଆପଣଙ୍କ PAN ନମ୍ବର ପ୍ରବେଶ କରନ୍ତୁ",
      saveError: "ବିବରଣୀ ସଞ୍ଚୟ କରିବା ସମୟରେ କିଛି ଭୁଲ ହୋଇଗଲା। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।",
      proceed: "ଆଗକୁ ବଢ଼ନ୍ତୁ"
    },
    redirectCta: {
      or: "କିମ୍ବା",
      clickHere: "ଏଠାରେ କ୍ଲିକ୍ କରନ୍ତୁ",
      clickHereStart: "ଏଠାରେ କ୍ଲିକ୍ କରନ୍ତୁ",
      toContinue: "ଜାରି ରଖିବାକୁ"
    },
    documentCapture: {
      stillNotWorking: "ତଥାପି କାମ କରୁନାହିଁ?",
      clickToCaptureInstead: "ବଦଳରେ କ୍ଲିକ୍-ଟୁ-କ୍ୟାପଚର ଚେଷ୍ଟା କରନ୍ତୁ",
      pdfNotAllowedIndia: "ଭାରତ ପାଇଁ PDF ଅପଲୋଡ୍ ଅନୁମତି ନାହିଁ। ଦୟାକରି 5 MB ରୁ କମ୍ JPEG, JPG, କିମ୍ବା PNG ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ।",
      pdfNotAllowedIndiaMobile: "ଭାରତ ପାଇଁ PDF ଅପଲୋଡ୍ ଅନୁମତି ନାହିଁ। ଦୟାକରି 5 MB ରୁ କମ୍ JPEG, JPG, PNG, HEIC, କିମ୍ବା HEIF ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ।",
      fileFormatsIndia: "jpeg, jpg, png 5 mb ରୁ କମ୍",
      fileFormats: "jpeg, jpg, png, pdf 5 mb ରୁ କମ୍",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb ରୁ କମ୍",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb ରୁ କମ୍"
    },
    mobileCapture: {
      upload: "ଅପଲୋଡ୍",
      skip: "ଛାଡ଼ନ୍ତୁ",
      stillNotWorking: "ତଥାପି କାମ କରୁନାହିଁ?",
      tryClickToCapture: "ଟ୍ୟାପ୍ କରି ଫଟୋ ନିଅନ୍ତୁ"
    },
    UserDetails: {
      panLabel: "PAN ନମ୍ବର",
      proceedBtn: "ଆଗକୁ ବଢ଼ନ୍ତୁ",
      panRequired: "ଦୟାକରି ଆପଣଙ୍କ PAN ନମ୍ବର ଭରନ୍ତୁ",
      saveError: "ବିବରଣୀ ସେଭ୍ କରିବା ସମୟରେ କିଛି ତ୍ରୁଟି ହେଲା। ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।"
    }
  },
  ml: {
    supportingDocument: {
      headingFallback: "പിന്തുണാ രേഖ",
      subHeading: "താഴെ രേഖ അപ്‌ലോഡ് ചെയ്യുക. ഇത് അവലോകനത്തിനായി സംഭരിക്കുന്നു — ഇതിൽ നിന്ന് ഒന്നും വേർതിരിച്ചെടുക്കുന്നില്ല.",
      choosePlaceholder: "ഒരു ഫയൽ തിരഞ്ഞെടുക്കുക (PNG, JPG അല്ലെങ്കിൽ PDF)",
      continue: "തുടരുക",
      uploading: "അപ്‌ലോഡ് ചെയ്യുന്നു...",
      skip: "ഇപ്പോൾ ഒഴിവാക്കുക",
      errorInvalidType: "ഒരു PNG, JPG അല്ലെങ്കിൽ PDF ഫയൽ അപ്‌ലോഡ് ചെയ്യുക.",
      errorTooLarge: "ഫയൽ വളരെ വലുതാണ്. പരിധി 10MB ആണ്.",
      errorRead: "ആ ഫയൽ വായിക്കാൻ കഴിഞ്ഞില്ല. ദയവായി മറ്റൊന്ന് ശ്രമിക്കുക.",
      errorNoFile: "അപ്‌ലോഡ് ചെയ്യാൻ ഒരു ഫയൽ തിരഞ്ഞെടുക്കുക.",
    },
    header: {
      title: "നിങ്ങളുടെ ഐഡന്റിറ്റി ശരിവെക്കാം",
      subtitle: "ഇതിനു 2 മിനിറ്റിൽ കുറവ് മാത്രം സമയമെടുക്കും",
      havingIssue: "പ്രശ്നമുണ്ടോ?"
    },
    onlyIdVerificationHeader: {
      title: "നിങ്ങളുടെ ഐഡി രേഖ സ്ഥിരീകരിക്കാം",
      subtitle: "ഇതിന് ഒരു മിനിറ്റ് മാത്രമേ എടുക്കൂ. നിങ്ങളുടെ ഐഡി രേഖ തയ്യാറായി വെക്കുക",
      instruction1: "ക്യാമറ ആക്സസ് അനുവദിക്കുക",
      instruction2: "രേഖ സ്കാൻ ചെയ്യുക അല്ലെങ്കിൽ അപ്ലോഡ് ചെയ്യുക",
      instruction3: "തൽക്ഷണ രേഖ സ്ഥിരീകരണം"
    },
    subHeading: {
      subHeading1: "നിങ്ങളുടെ ഐഡി ഡോക്യുമെന്റ് പകർത്തുക",
      subHeading2: "നിങ്ങൾ ജീവിച്ചു കൊണ്ടിരിക്കുന്നതാണെന്ന് ശരിവെക്കുക",
      livenessHeading1: "നല്ല വെളിച്ചമുള്ള ഒരു സ്ഥലം കണ്ടെത്തുക",
      livenessHeading2: "നിങ്ങളുടെ മുഖം മധ്യത്തിൽ നിലനിർത്തുക"
    },
    termsAndCondition: {
      title: "താഴെപ്പറയുന്ന നിബന്ധനകൾക്കും വ്യവസ്ഥകൾക്കും ഞാൻ സമ്മതിക്കുകയും പാലിക്കുകയും ചെയ്യുന്നു.",
      privacyPolicy: "നിബന്ധനകൾ കാണുക",
      beginBtnText: "തുടങ്ങുക",
      beginLiveness: "ലൈവ്നസ് പരിശോധന ആരംഭിക്കുന്നു",
      startLiveness: "ലൈവ്നസ് പരിശോധന തുടരുക"
    },
    permissionDenied: {
      title: "ക്യാമറ പ്രവേശനം നിഷേധിച്ചു!",
      subtitle: "ബ്രൗസറിന്റെ അഡ്രസ് ബാറിന് സമീപം ബ്ലോക്കായ ക്യാമറ ഐക്കൺ ഉണ്ടോയെന്ന് പരിശോധിച്ച് അതിന്റെ ബ്ലോക്ക് നീക്കം ചെയ്യുക.",
      readMore: "കൂടുതൽ വായിക്കുക",
      refreshText: "ക്യാമറക്ക് അനുമതി നൽകിയ ശേഷം താഴെയുള്ള പുതുക്കുക ബട്ടൺ ക്ലിക്കുചെയ്യുക.",
      refreshBtn: "പുതുക്കുക",
      link: "അല്ലെങ്കിൽ, ഫോണിൽ തുടരുക",
      buttonText: "അല്ലെങ്കിൽ, ഫോണിൽ തുടരുക"
    },
    desktopBrowserPermissionDenied: {
      title: "ദയവായി ക്യാമറ പ്രവേശനം അനുവദിക്കുക",
      subtitle: "ബ്രൗസർ അനുമതികൾ ചോദിക്കാം. തുടരാൻ 'അനുവദിക്കുക' ക്ലിക്കുചെയ്യുക.",
      readMore: "കൂടുതൽ വായിക്കുക",
      refreshText: "അനുമതികൾ നൽകിയ ശേഷം പുതുക്കുക",
      refreshBtn: "പുതുക്കുക",
      link: "അല്ലെങ്കിൽ, ഫോണിൽ തുടരുക",
      buttonText: "അല്ലെങ്കിൽ, ഫോണിൽ തുടരുക"
    },
    androidBrowserPermissionDenied: {
      title: "ക്യാമറ പ്രവേശനം നിഷേധിച്ചു",
      subtitle: "ബ്രൗസറിന്റെ അഡ്രസ് ബാറിനരികെയുള്ള ബ്ലോക്ക് ചെയ്ത ക്യാമറ ഐക്കൺ പരിശോധിച്ച് അതിന് അനുമതി നൽകുക.",
      readMore: "കൂടുതൽ അറിയുക",
      refreshText: "ക്യാമറയ്ക്ക് അനുമതി നൽകിയശേഷം, ചുവടെയുള്ള റിഫ്രെഷ് ബട്ടൺ ക്ലിക്കുചെയ്യുക.",
      refreshBtn: "റിഫ്രെഷ് ചെയ്യുക",
      link: "അഥവാ, ഫോണിൽ തുടരുക",
      buttonText: "അഥവാ, ഫോണിൽ തുടരുക"
    },
    androidWebViewPermissionDenied: {
      title: "ക്യാമറ പ്രവേശനം നിഷേധിച്ചു",
      subtitle: "ആപ്പ് സെറ്റിംഗ്സിലൂടെ ക്യാമറ അനുമതി തടയപ്പെട്ടിരിക്കാം. ദയവായി ഫോൺ Settings > App Info > Permissions > Camera വഴി അനുമതി നൽകുക.",
      refreshText: "ക്യാമറയ്ക്ക് അനുമതി നൽകിയശേഷം, ചുവടെയുള്ള റിഫ്രെഷ് ബട്ടൺ ക്ലിക്കുചെയ്യുക.",
      refreshBtn: "റിഫ്രെഷ് ചെയ്യുക",
      link: "അഥവാ, ഫോണിൽ തുടരുക",
      buttonText: "അഥവാ, ഫോണിൽ തുടരുക"
    },
    iosBrowserPermissionDenied: {
      title: "ക്യാമറ പ്രവേശനം നിഷേധിച്ചു",
      subtitle: "അഡ്രസ് ബാറിനരികിൽ ക്യാമറ അല്ലെങ്കിൽ ലോക്ക് ഐക്കൺ ടാപ്പ് ചെയ്ത് അനുമതി നൽകുക, അല്ലെങ്കിൽ ബ്രൗസർ സെറ്റിംഗ്സ് പരിശോധിക്കുക.",
      readMore: "കൂടുതൽ അറിയുക",
      refreshText: "ക്യാമറയ്ക്ക് അനുമതി നൽകിയശേഷം, ചുവടെയുള്ള റിഫ്രെഷ് ബട്ടൺ ക്ലിക്കുചെയ്യുക.",
      refreshBtn: "റിഫ്രെഷ് ചെയ്യുക",
      link: "അഥവാ, ഫോണിൽ തുടരുക",
      buttonText: "അഥവാ, ഫോണിൽ തുടരുക"
    },
    iosWebViewPermissionDenied: {
      title: "ക്യാമറ പ്രവേശനം നിഷേധിച്ചു",
      subtitle: "ആപ്പ് സെറ്റിംഗ്സിൽ നിന്ന് ക്യാമറ അനുമതി തടയപ്പെട്ടിരിക്കാം. Settings > ആപ്പ് തിരഞ്ഞെടുക്കുക > Camera permission ഓണാക്കുക.",
      refreshText: "ക്യാമറയ്ക്ക് അനുമതി നൽകിയശേഷം, ചുവടെയുള്ള റിഫ്രെഷ് ബട്ടൺ ക്ലിക്കുചെയ്യുക.",
      refreshBtn: "റിഫ്രെഷ് ചെയ്യുക",
      link: "അഥവാ, ഫോണിൽ തുടരുക",
      buttonText: "അഥവാ, ഫോണിൽ തുടരുക"
    },
    documentationList: {
      countryHeading: "രാജ്യം തിരഞ്ഞെടുക്കുക",
      docHeading: "നിങ്ങളുടെ ഡോക്യുമെന്റ് തിരഞ്ഞെടുക്കുക",
      btnText: "അടുത്തത്",
      searchCountry: "രാജ്യം തിരയുക"
    },
    frontDocCapture: {
      heading: "ഐഡിയുടെ മുൻവശം ചതുരത്തിലാക്കുക",
      backupHeading: "പ്രശ്നമാണോ? ദയവായി ചിത്രം മാനുവലി ക്ലിക്കുചെയ്യുക",
      btnText: "ഫോട്ടോ എടുക്കുക",
      headingBack: " ദീർഘചതുരത്തിനുള്ളിൽ",
      uploadButton: "അല്ലെങ്കിൽ, ഐഡി അപ്‌ലോഡ് ചെയ്യുക"
    },
    backDocCapture: {
      heading: "ഐഡിയുടെ പിന്ഭാഗം ചതുരത്തിലാക്കുക",
      backupHeading: "പ്രശ്നമാണോ? ദയവായി ചിത്രം മാനുവലി ക്ലിക്കുചെയ്യുക",
      btnText: "ഫോട്ടോ എടുക്കുക",
      containerText: "അല്ലെങ്കിൽ, ഡോക്യുമെന്റ് അപ്‌ലോഡ് ചെയ്യുക",
      text: "പിടിച്ചെടുക്കുന്നു, സ്റ്റില്ലായിരിക്കൂ",
      headingBack: " ദീർഘചതുരത്തിനുള്ളിൽ",
      skipButton: "പിൻഭാഗം ഒഴിവാക്കുക",
      uploadButton: "അല്ലെങ്കിൽ, ഐഡി അപ്‌ലോഡ് ചെയ്യുക"
    },
    analyzing: {
      heading: "നിങ്ങളുടെ ഐഡി വിശകലനം ചെയ്യുന്നു...",
      subHeading: "ദയവായി അടുത്ത സ്ക്രീനിൽ നിങ്ങളുടെ കാർഡ് വിവരങ്ങൾ പരിശോധിച്ച് ആവശ്യമായ എഡിറ്റ് ചെയ്യുക"
    },
    imageCheck: {
      heading: "നിങ്ങളുടെ ചിത്രം പരിശോധിക്കുക",
      subHeading: "ചിത്രം പൂർണ്ണവും, വ്യക്തവുമായും, ബ്ലർ അല്ലാതെയും, ഗ്ലെയർ ഇല്ലാതെയും ആണെന്ന് ഉറപ്പാക്കുക.",
      button1: "ഫോട്ടോ വീണ്ടും എടുക്കുക",
      button2: "ശരി",
      frontHeading: "മുമ്പിലെ ചിത്രം പരിശോധിക്കുക",
      backHeading: "പിറകിലെ ചിത്രം പരിശോധിക്കുക"
    },
    errorHandler: {
      heading: "അയ്യോ :(",
      subHeading1: "ഞങ്ങൾ ചില പ്രശ്നങ്ങൾ നേരിടുന്നു, പക്ഷേ ചിന്തിക്കേണ്ടതില്ല! ദയവായി വീണ്ടും ശ്രമിക്കുക",
      subHeading2: "ഇത് തുടരുകയാണെങ്കിൽ, പിന്നീട് പരിശോധിക്കുക",
      button: "വീണ്ടും ശ്രമിക്കുക"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "ദയവായി നിങ്ങളുടെ മുഖം ആകെ മറയ്ക്കുന്ന ഏതെങ്കിലും വസ്തു നീക്കം ചെയ്യുക",
        button: "പുതിയതായും ശ്രമിക്കുക"
      },
      eyeClosureDetected: {
        heading: "ദയവായി നിങ്ങളുടെ കണ്ണുകൾ തുറന്നുവെച്ച് നേരെ ക്യാമറയിലോട്ട് നോക്കുക",
        button: "വീണ്ടും ശ്രമിക്കുക"
      },
      isMultipleFacesFound: {
        heading: "പല മുഖങ്ങൾ കണ്ടെത്തിയിട്ടുണ്ട്. ക്യാമറയിൽ നിങ്ങളുടെ മുഖം മാത്രം ദൃശ്യമാകുന്നുണ്ടെന്ന് ഉറപ്പാക്കുക.",
        button: "പുതിയതായും ശ്രമിക്കുക"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "പുതിയതായും ശ്രമിക്കുക"
      },
      faceDetections: {
        heading: "ദയവായി ഇത് നീക്കം ചെയ്യുക",
        button: "പുതിയതായും ശ്രമിക്കുക"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "പല മുഖങ്ങൾ കണ്ടെത്തി",
          button: "പുതിയതായും ശ്രമിക്കുക"
        },
        generalMessage: {
          heading: "ദയവായി ഉറപ്പാക്കുക, നിങ്ങൾ ക്യാമറക്ക് മുന്നിൽ സജീവമാണ്",
          button: "പുതിയതായും ശ്രമിക്കുക"
        }
      },
      faceMatch: {
        heading: "നിങ്ങളുടെ മുഖം ഐഡി ചിത്രവുമായി പൊരുത്തപ്പെടുന്നില്ല",
        button: "പുതിയതായും ശ്രമിക്കുക"
      },
      selfieError: {
        heading: "നാം നിങ്ങളുടെ സെൽഫി ശരിയായി പരിശോധിക്കാൻ കഴിയുന്നില്ല",
        subHeading1: "ഈ നിർദേശങ്ങൾ പിന്തുടർന്ന് വീണ്ടും ശ്രമിക്കുക",
        instruction1: "നല്ല പ്രകാശമുള്ള സ്ഥലത്ത് പോവുക, പിന്നിലെ പ്രകാശം ഒഴിവാക്കുക",
        instruction2: "നിങ്ങളുടെ മുഖം പൂർണ്ണമായും കാണാവുന്നതും ഫ്രെയിമിന്റെ മദ്ധ്യത്തിലാണ് എന്നുള്ളതു ഉറപ്പാക്കുക",
        instruction3: "നിങ്ങളുടെ മുഖം വ്യക്തമായി കാണാനായി ഹാറ്റ്, കണ്ണടകൾ അല്ലെങ്കിൽ മസ്കുകൾ നീക്കം ചെയ്യുക",
        button: "പുതിയതായും ശ്രമിക്കുക"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP പൊരുത്തപ്പെട്ടില്ല. ദയവായി OTP വ്യക്തമായി ഉറക്കെ വായിക്കുക",
        button: "വീണ്ടും ശ്രമിക്കുക"
      },
      activeLivenessGenericFailureMessage: {
        heading: "പരിശോധന പരാജയപ്പെട്ടു. ദയവായി നിർദ്ദേശങ്ങൾ വ്യക്തമായി പിന്തുടർന്ന് വീണ്ടും ശ്രമിക്കുക",
        button: "പുതിയതായും ശ്രമിക്കുക"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF-ൽ വളരെയധികം പേജുകൾ ഉണ്ട്",
        subHeading: "അപ്‌ലോഡ് ചെയ്ത PDF 2-പേജ് പരിധി കവിയുന്നു. ദയവായി 2 പേജിൽ കൂടാത്ത PDF, അല്ലെങ്കിൽ നിങ്ങളുടെ ID-യുടെ വ്യക്തമായ ചിത്രം അപ്‌ലോഡ് ചെയ്യുക."
      },
      heading: "ഞങ്ങൾ നിങ്ങളുടെ ഐഡി പ്രോസസ്സ് ചെയ്യാൻ സാധിക്കുന്നില്ല",
      subHeading: "നീങ്ങൾ തെറ്റായ ഐഡി അപ്‌ലോഡ് ചെയ്യുകയോ അല്ലെങ്കിൽ ചിത്രം വ്യക്തമല്ല",
      buttonBack: "ഐഡിയുടെ പിന്ഭാഗം വീണ്ടും ശ്രമിക്കുക",
      buttonFront: "ഐഡിയുടെ മുൻവശം വീണ്ടും ശ്രമിക്കുക",
      button: "വീണ്ടും ശ്രമിക്കുക",
      captureFrontSide: "മുൻവശം ക്യാപ്ചർ ചെയ്യുക",
      captureBackSide: "പിൻവശം ക്യാപ്ചർ ചെയ്യുക",
      changeIDButton: "മറ്റൊരു രേഖ തിരഞ്ഞെടുക്കുക",
      wrongid: {
        heading: "ഈ രേഖ പ്രോസസ്സ് ചെയ്യാൻ ഞങ്ങൾക്ക് കഴിഞ്ഞില്ല",
        subHeading: "നിങ്ങൾ ശരിയായ രേഖ അപ്‌ലോഡ് ചെയ്യുന്നുവെന്ന് ഉറപ്പാക്കുകയും ചിത്രത്തിന്റെ ഗുണനിലവാരം വ്യക്തമാണെന്ന് ഉറപ്പാക്കുകയും ചെയ്യുക"
      },
      expiredid: {
        heading: "ID രേഖ കാലഹരണപ്പെട്ടു!",
        subHeading: "കാലഹരണപ്പെട്ട ID രേഖ ഞങ്ങൾക്ക് സ്വീകരിക്കാൻ കഴിയില്ല. ദയവായി സാധുവായ ഒരു രേഖ നൽകുക"
      },
      minimumage: {
        heading: "പ്രായ ആവശ്യകത പാലിച്ചില്ല!",
        subHeading: "നിങ്ങളുടെ പ്രായം ആവശ്യമായ കുറഞ്ഞ പ്രായത്തിന് താഴെയാണ്. ദയവായി നിങ്ങൾ കുറഞ്ഞ പ്രായ മാനദണ്ഡം പാലിക്കുന്നുവെന്ന് ഉറപ്പാക്കുക"
      },
      mobileAttemptsDone: {
        heading: "നിങ്ങളുടെ മുൻ ഉപകരണത്തിൽ യാത്ര പുനരാരംഭിച്ചു",
        subHeading: "തനിപ്പകർപ്പ് ഒഴിവാക്കാൻ ഈ സെഷൻ ഇപ്പോൾ നിർത്തിയിരിക്കുന്നു."
      },
      finished: {
        heading: "യാത്ര അവസാനിച്ചു",
        subHeading: "യാത്ര പൂർത്തിയായി അല്ലെങ്കിൽ അവസാനിപ്പിച്ചു"
      },
      invalid: {
        heading: "യാത്ര ലഭ്യമല്ല !",
        subHeading: "journeyId കണ്ടെത്തിയില്ല അല്ലെങ്കിൽ യാത്ര ID അസാധുവാണ്"
      },
      INVALID_PAN_NUMBER: {
        heading: "അസാധുവായ PAN നമ്പർ",
        subHeading: "നിങ്ങൾ നൽകിയ PAN നമ്പർ സാധുവല്ല. ദയവായി പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക"
      },
      INVALID_PAN_STATUS: {
        heading: "അസാധുവായ PAN നില",
        subHeading: "നിങ്ങൾ നൽകിയ PAN നമ്പർ സാധുവല്ല. ദയവായി പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക"
      },
      directKyc: {
        heading: "നേരിട്ടുള്ള KYC യാത്ര !",
        subHeading: "ഇതൊരു നേരിട്ടുള്ള KYC യാത്രയാണ്. ഫ്രണ്ടെൻഡ് യാത്ര അനുവദനീയമല്ല."
      },
      DOCTYPE_FALSE: {
        heading: "തെറ്റായ രേഖ നൽകി!",
        subHeading: "ദയവായി സാധുവായ ഒരു രേഖ അപ്‌ലോഡ് ചെയ്യുകയും ചിത്രത്തിന്റെ ഗുണനിലവാരം നല്ലതാണെന്ന് ഉറപ്പാക്കുകയും ചെയ്യുക."
      },
      ONLY_FRONT: {
        heading: "ID-യുടെ പിൻഭാഗം കാണുന്നില്ല",
        subHeading: "നിങ്ങൾ മുൻഭാഗം മാത്രമേ നൽകിയിട്ടുള്ളൂ. ദയവായി നിങ്ങളുടെ ID മറിച്ച് തുടരാൻ പിൻഭാഗം നൽകുക"
      },
      ONLY_BACK: {
        heading: "ID-യുടെ മുൻഭാഗം കാണുന്നില്ല",
        subHeading: "നിങ്ങൾ പിൻഭാഗം മാത്രമേ നൽകിയിട്ടുള്ളൂ. ദയവായി നിങ്ങളുടെ ID മറിച്ച് തുടരാൻ മുൻഭാഗം നൽകുക"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "രേഖ ഉടൻ കാലഹരണപ്പെടും",
        subHeading: "രേഖ ഉടൻ കാലഹരണപ്പെടുമെന്നതിനാൽ നിരസിച്ചു."
      },
      DOCUMENT_EXPIRED: {
        heading: "രേഖ കാലഹരണപ്പെട്ടു!",
        subHeading: "ദയവായി തുടരാൻ സാധുവായ, കാലഹരണപ്പെടാത്ത ഒരു രേഖ അപ്‌ലോഡ് ചെയ്യുക."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "പ്രായ ആവശ്യകത പാലിച്ചില്ല!",
        subHeading: "നിങ്ങൾ ആവശ്യമായ പ്രായം പാലിക്കുന്നില്ലെന്ന് രേഖ സൂചിപ്പിക്കുന്നു. ദയവായി സാധുവായ ഒരു രേഖ അപ്‌ലോഡ് ചെയ്യുക."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "രേഖ പരിശോധിക്കാൻ കഴിയുന്നില്ല!",
        subHeading: "പരിശോധനയ്ക്ക് ചിത്രത്തിന്റെ ഗുണനിലവാരം വളരെ മോശമാണ്. ദയവായി കൂടുതൽ വ്യക്തമായ ചിത്രം ഉപയോഗിച്ച് വീണ്ടും ശ്രമിക്കുക."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "രേഖ പരിശോധിക്കാൻ കഴിയുന്നില്ല!",
        subHeading: "ചില വിവരങ്ങൾ പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. ദയവായി കൂടുതൽ വ്യക്തമായ ചിത്രം ഉപയോഗിച്ച് വീണ്ടും ശ്രമിക്കുക."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "രേഖ പരിശോധിക്കാൻ കഴിയുന്നില്ല!",
        subHeading: "മോശം ചിത്ര ഗുണനിലവാരം കാരണം ചില വിശദാംശങ്ങൾ പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. ദയവായി കൂടുതൽ വ്യക്തമായ ചിത്രം ഉപയോഗിച്ച് വീണ്ടും ശ്രമിക്കുക"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "രേഖ പരിശോധിക്കാൻ കഴിയുന്നില്ല!",
        subHeading: "ചില വിശദാംശങ്ങൾ പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. ദയവായി കൂടുതൽ വ്യക്തമായ ചിത്രം ഉപയോഗിച്ച് വീണ്ടും ശ്രമിക്കുക."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "ID-യിലെ നിങ്ങളുടെ ഫോട്ടോ പരിശോധിക്കുന്നതിൽ പ്രശ്നം",
        subHeading: "ID കാർഡിലെ നിങ്ങളുടെ ഫോട്ടോ ഞങ്ങൾക്ക് പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. അത് സ്ഥിരീകരിക്കാൻ കഴിയുന്നതിന് ദയവായി നിങ്ങളുടെ യഥാർത്ഥ ID-യുടെ വ്യക്തമായ ഫോട്ടോ അപ്‌ലോഡ് ചെയ്യുക."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "രേഖയുടെ സുരക്ഷാ പാറ്റേൺ പരിശോധന പരാജയപ്പെട്ടു",
        subHeading: "രേഖയുടെ അന്തർനിർമിത സുരക്ഷാ പാറ്റേണുകൾ ഞങ്ങൾക്ക് പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. അതിന്റെ ആധികാരികത സ്ഥിരീകരിക്കാൻ സഹായിക്കുന്നതിന് ദയവായി യഥാർത്ഥ ID-യുടെ വ്യക്തമായ ഫോട്ടോ അപ്‌ലോഡ് ചെയ്യുക."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "രേഖയുടെ ജീവസാന്നിധ്യ പരിശോധന പരാജയപ്പെട്ടു",
        subHeading: "രേഖ യഥാർത്ഥമല്ലായിരിക്കാമെന്നതിന്റെ സൂചനകൾ ഞങ്ങൾ കണ്ടെത്തി. ദയവായി സ്ക്രീൻഷോട്ടുകൾ, അച്ചടിച്ച പകർപ്പുകൾ, അല്ലെങ്കിൽ സ്ക്രീനിൽ ID കാണിക്കുന്നത് ഒഴിവാക്കുക. എല്ലാ സവിശേഷതകളും വ്യക്തമായി കാണുന്ന യഥാർത്ഥ ID അപ്‌ലോഡ് ചെയ്യുക"
      },
      SECURITY_FALSE: {
        heading: "പ്രശ്നം കണ്ടെത്തി!",
        subHeading: "രേഖ പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. ദയവായി കൂടുതൽ വ്യക്തമായ ചിത്രം ഉപയോഗിച്ച് വീണ്ടും ശ്രമിക്കുക"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "മോശം ചിത്ര ഗുണനിലവാരം!",
        subHeading: "ചിത്രം വളരെ മങ്ങിയതോ വ്യക്തമല്ലാത്തതോ ആണ്. ദയവായി കൂടുതൽ വ്യക്തമായ ചിത്രം ഉപയോഗിച്ച് വീണ്ടും ശ്രമിക്കുക"
      },
      FACE_UNDETECTED: {
        heading: "മുഖം കണ്ടെത്തിയില്ല",
        subHeading: "രേഖയിൽ ദൃശ്യമായ ഒരു മുഖം ഞങ്ങൾക്ക് കണ്ടെത്താൻ കഴിഞ്ഞില്ല. ദയവായി മുഖം വ്യക്തമായി കാണുന്ന സാധുവായ ഒരു ID അപ്‌ലോഡ് ചെയ്യുക"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "രേഖകൾ തമ്മിലുള്ള താരതമ്യം പരാജയപ്പെട്ടു",
        subHeading: "ഒന്നോ അതിലധികമോ പ്രധാന ഫീൽഡുകളിലെ (പേര്, ജനന തീയതി, അല്ലെങ്കിൽ മുഖം) പൊരുത്തക്കേട് കാരണം രേഖകൾ തമ്മിലുള്ള താരതമ്യം പരാജയപ്പെട്ടു"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker പരാജയം",
        subHeading: "Digilocker യാത്രയ്ക്കിടെ ഒരു പിശക് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ തുടരാൻ ഒരു ബദൽ മാർഗം ഉപയോഗിക്കുക."
      },
      LINKAGE_FAILED: {
        heading: "ഈ പരിശോധന പൂർത്തിയാക്കാൻ കഴിഞ്ഞില്ല",
        subHeading: "ഈ പരിശോധനയ്ക്കായി ശേഖരിച്ച വിവരങ്ങൾ രേഖകളുമായി പൊരുത്തപ്പെട്ടില്ല."
      }
    },
    biometricConsent: {
      consentStatement: "നിങ്ങളുടെ സെൽഫിക്ക് മുമ്പ്, നിങ്ങളുടെ ഐഡന്റിറ്റി പരിശോധിക്കാൻ നിങ്ങളുടെ ബയോമെട്രിക് ഡാറ്റ (മുഖ ചിത്രവും ലൈവ്നെസ് സിഗ്നലുകളും) ക്യാപ്ചർ ചെയ്യാനും പ്രോസസ്സ് ചെയ്യാനും നിങ്ങളുടെ സമ്മതം ആവശ്യമാണ്. ഈ ഡാറ്റ ഈ പരിശോധനയ്ക്ക് മാത്രമേ ഉപയോഗിക്കൂ.",
      privacyPolicy: "സ്വകാര്യതാ നയം",
      consentButton: "ഞാൻ സമ്മതിക്കുന്നു — തുടരുക",
      declineButton: "ഞാൻ സമ്മതിക്കുന്നില്ല",
      confirmTitle: "ബയോമെട്രിക് പരിശോധന ഇല്ലാതെ തുടരണോ?",
      confirmBody: "ബയോമെട്രിക് പരിശോധന ഇല്ലാതെ, ഞങ്ങൾ സെൽഫി എടുക്കില്ല. നിങ്ങൾ ഇതിനകം നൽകിയ വിവരങ്ങൾ ഉപയോഗിച്ച് നിങ്ങളുടെ പരിശോധന പൂർത്തിയാക്കും. ഈ തിരഞ്ഞെടുപ്പ് ഈ സെഷനിൽ അന്തിമമാണ്.",
      goBack: "തിരികെ",
      confirmDecline: "സ്ഥിരീകരിക്കുക — സമ്മതിക്കുന്നില്ല",
      declineComplete: "ബയോമെട്രിക് പരിശോധനയുമായി തുടരേണ്ടതില്ലെന്ന് നിങ്ങൾ തിരഞ്ഞെടുത്തു. നിങ്ങൾ സമർപ്പിച്ച രേഖകൾ ഉപയോഗിച്ച് നിങ്ങളുടെ ഐഡന്റിറ്റി പരിശോധന പൂർത്തിയായി."
    },
    introLiveness: {
      heading: "ഇവിടെ നിങ്ങൾ ജീവിച്ചു കൊണ്ടിരിക്കുന്നതായി ശരിവെക്കുക",
      instruction1: "മതി മാത്രം പ്രകാശമുള്ളത് ഉറപ്പാക്കുക",
      instruction2: "ആവശ്യമായ അനുമതികൾ അനുവദിക്കുക",
      instruction3: "നിർദ്ദേശങ്ങൾ അനുസരിക്കുക",
      button: "തുടരുക",
      subHeading: "നിങ്ങൾ ഒരു ചുവട് മാത്രം അകലെയാണ്"
    },
    phoneSession: {
      heading: "ഫോണിൽ സെഷൻ തുടരുന്നു",
      subheading: "മൊബൈലിൽ പൂർത്തിയാകുന്നത് വരെ ഈ വിൻഡോ തുറന്ന് വെക്കുക",
      button: "ഇവിടെ തുടരുക"
    },
    continueOnPhone: {
      heading: "ഫോണിൽ തുടരുക",
      subheading: "QR സ്കാൻ ചെയ്യുക അല്ലെങ്കിൽ താഴെയുള്ള ലിങ്ക് പകർത്തുക",
      subheading2: "QR സ്കാൻ ചെയ്യുക അല്ലെങ്കിൽ നിങ്ങളുടെ ഫോണിൽ ലിങ്ക് തുറക്കുക",
      text: "പ്രക്രിയ പൂർത്തിയാക്കുക",
      text1: "സമർപ്പിക്കാൻ ഇവിടെ തിരിച്ചെത്തുക",
      button: "പകർത്തുക",
      copiedButton: "പകർത്തി!",
      copied: "പകർത്തി!"
    },
    SsnReview: {
      heading: "നിങ്ങളുടെ വിശദാംശങ്ങൾ പരിശോധിക്കുക",
      subHeading: "ആവശ്യമായ മാറ്റങ്ങൾ ചെയ്തു വിശദാംശങ്ങൾ സമർപ്പിക്കുക",
      feild1: "ഡ്രൈവിംഗ് ലൈസൻസ്",
      feild2: "മുതലായവ",
      feild3: "ജനന തിയതി",
      feild4: "ക്ലാസ്",
      feild5: "പരിമിതികൾ",
      feild6: "രാജ്യം",
      feild7: "വിലാസം",
      button: "വിശദാംശങ്ങൾ ശരിയാക്കുക"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "നിങ്ങളുടെ മുഖം വൃത്തത്തിൽ നിലനിർത്തുക"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ക്യാമറയ്ക്ക് അടുത്തേക്ക് വരൂ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "നാണിക്കേണ്ട, മുന്നിലേക്ക് വരൂ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "വളരെ ഇരുട്ടാണ്. കൂടുതൽ വെളിച്ചത്തിലേക്ക് പോകൂ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "വളരെ പ്രകാശമാണ്. മൃദുവായ വെളിച്ചത്തിലേക്ക് പോകൂ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "നിങ്ങളുടെ മുഖം വൃത്തത്തിൽ നിലനിർത്തുക"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "അനങ്ങാതെ നിൽക്കൂ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "മുഖം വെളിച്ചത്തിന് നേരെ തിരിക്കൂ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ഫോൺ കണ്ണിന്റെ ഉയരത്തിൽ പിടിക്കൂ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ക്യാമറയിൽ നിന്ന് അൽപ്പം മാറി നിൽക്കൂ"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "നിങ്ങളുടെ മുഖം ഫ്രെയിമിന്റെ മധ്യത്തിൽ വയ്ക്കുക"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "നിങ്ങളുടെ മുഖം വൃത്തത്തിന്റെ മധ്യത്തിൽ വയ്ക്കുക"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "അടുത്ത് വരൂ, മുഖം നേരെ വയ്ക്കുക"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "കാഴ്ചയിലേക്ക് വരൂ, മുഖം നേരെ വയ്ക്കുക"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "വളരെ ഇരുണ്ടു. കൂടുതൽ പ്രകാശമുള്ള പ്രകാശം കണ്ടെത്തുക"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "വളരെ പ്രകാശം. അനുയോജ്യമായ പ്രകാശം കണ്ടെത്തുക"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "നിങ്ങളുടെ മുഖം വൃത്തത്തിന്റെ മധ്യത്തിലേക്ക് ക്രമീകരിക്കുക"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "സ്ഥിരമായി നിൽക്കുക, നേരെ മുന്നോട്ട് നോക്കുക"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "വെളിച്ചത്തിന് നേരെ മുഖം തിരിക്കുക, സ്ഥിരമായി നിൽക്കുക"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "നിങ്ങളുടെ ഫോൺ കണ്ണിന്റെ നിലയിൽ പിടിക്കുക"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ക്യാമറയിൽ നിന്ന് കുറച്ച് ദൂരെയായിരിക്കുക"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "പൂർണ്ണമായും!"
      },
      smile1: {
        icon: "mood",
        description: "സ്മൈൽ ചെയ്യുക, നിങ്ങൾ വളരെ ഭംഗിയായി കാണുന്നു!"
      },
      smile2: {
        icon: "mood",
        description: "ക്യാമറക്ക് സ്മൈൽ ചെയ്യുക!"
      }
    },
    successful: {
      title: "വെരിഫിക്കേഷൻ പൂർത്തിയായി",
      text: "നിങ്ങൾ ഇപ്പോൾ വിൻഡോ അടയ്ക്കാം",
      finishBtn: "പൂർത്തിയാക്കുക"
    },
    poweredBy: "പ്രവർത്തനം",
    redirect: "റീഡിറക്ട്",
    error: {
      message: "URL കാലഹരണപ്പെട്ടിരിക്കുന്നു അല്ലെങ്കിൽ അസാധുവാണ്"
    },
    footer: {
      securedBy: "പ്രവർത്തനം"
    },
    helpFaq: {
      title: "സഹായവും & സാധാരണ ചോദിക്കുന്ന ചോദ്യങ്ങളും",
      subtitle: "നാം നിങ്ങൾക്ക് സഹായം ചെയ്യുന്നതിനിടെ ഇവിടെ ഉണ്ടാകും",
      cameraText: "നിങ്ങളുടെ ഐഡന്റിറ്റി ശരിവെക്കാൻ, ഞങ്ങൾക്ക് നിങ്ങളുടെ ഉപകരണത്തിന്റെ ക്യാമറ ഉപയോഗിച്ച് ചിത്രം എടുക്കേണ്ടതുണ്ട്. ആവശ്യമായ അനുമതികൾ എങ്ങനെ നൽകണമെന്ന് പഠിക്കാൻ link ക്ലിക്ക് ചെയ്യുക",
      cameraHeading: "ക്യാമറ അനുമതി",
      languageText: "പ്രക്രിയയുടെ ആരംഭത്തിൽ, നിങ്ങൾക്ക് മുകളിൽ ബാർയിൽ നിന്നുള്ള ഡ്രോപ്ഡൗൺ മെനുവിൽ നിന്ന് നിങ്ങളുടെ ഇഷ്ടഭാഷ തിരഞ്ഞെടുക്കാം",
      languageHeading: "ഭാഷാ തിരഞ്ഞെടുപ്പ്",
      kycText: "KYC, അല്ലെങ്കിൽ 'നിങ്ങളുടെ ഉപഭോക്താവിനെ അറിയുക', ഉപഭോക്താവിന്റെ ഐഡന്റിറ്റിയെ ശരിവെക്കുന്നതിനുള്ള ഒരു പ്രക്രിയയാണ്, ഇത് അനുപാലനവും തട്ടിപ്പുകൾക്കും മറ്റ് നിയമവിരുദ്ധ പ്രവർത്തനങ്ങൾക്കും തടസ്സം നൽകുന്നതിനും സഹായിക്കുന്നു",
      kycHeading: "KYC എന്നത് എന്ത്?",
      timeText: "സാധാരണയായി, ഇത് 60 സെക്കന്റ് വരെ സമയം എടുക്കുന്നു. എങ്കിലും, ഇത് രാജ്യത്തെ അടിസ്ഥാനത്തിൽ വ്യത്യാസപ്പെടാം",
      timeHeading: "ഇതിനുള്ള സമയം എത്ര?"
    },
    pdfPreviewUnavailable: "PDF-ന്റെ പ്രിവ്യൂ കാണിക്കാൻ കഴിയുന്നില്ല.",
    pdfPreviewHint: "പ്രിവ്യൂ ദൃശ്യമായില്ലെങ്കിലും നിങ്ങൾക്ക് തുടരാം.",
    pdfOpenLabel: "PDF തുറക്കുക",
    failedUpload: {
      title: "ഫയൽ അപ്‌ലോഡ് പരാജയപ്പെട്ടു",
      text: "ഫയൽ 5MB-ൽ താഴെയും .jpg, .jpeg, .png, .heic, .heif, അല്ലെങ്കിൽ .pdf ഫോർമാറ്റിലും ആണെന്ന് ഉറപ്പാക്കുക",
      btn: "വീണ്ടും ശ്രമിക്കുക",
      pdfNotAllowedIndia: "ഇന്ത്യയ്ക്ക് PDF അപ്‌ലോഡ് അനുവദനീയമല്ല. ദയവായി 5 MB-യിൽ താഴെയുള്ള JPEG, JPG, PNG, HEIC, അല്ലെങ്കിൽ HEIF ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക.",
      pdfNotAllowedIndiaBasic: "ഇന്ത്യയ്ക്ക് PDF അപ്‌ലോഡ് അനുവദനീയമല്ല. ദയവായി 5 MB-യിൽ താഴെയുള്ള JPEG, JPG, അല്ലെങ്കിൽ PNG ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക."
    },
    livenessAnalyzing: {
      heading: "നിങ്ങളുടെ മുഖം വിശകലനം ചെയ്യുന്നു",
      subHeading: "ദയവായി കാത്തിരിക്കുക, ഇതിന് കുറച്ച് സെക്കൻഡുകൾ മാത്രമേ എടുക്കൂ"
    },
    sessionExpiredError: {
      heading: "ക്ഷമിക്കണം, നിങ്ങളുടെ സെഷൻ കാലഹരണപ്പെട്ടു",
      subHeading1: "നിങ്ങൾ കുറച്ച് സമയമായി നിഷ്ക്രിയമായിരുന്നു. സുരക്ഷാ കാരണങ്ങളാൽ, നിങ്ങളുടെ സെഷൻ സ്വയമേവ കാലഹരണപ്പെട്ടു",
      subHeading2: "ദയവായി വീണ്ടും ശ്രമിക്കുക",
      buttonText: "വീണ്ടും ശ്രമിക്കുക"
    },
    journeyExpiredError: {
      heading: "ക്ഷമിക്കണം, ലിങ്ക് കാലഹരണപ്പെട്ടു",
      subHeading1: "ലിങ്ക് ഇനി സജീവമല്ല. സുരക്ഷാ കാരണങ്ങളാൽ, ലിങ്കുകൾക്ക് പരിമിതമായ ആയുസ്സുണ്ട്",
      subHeading2: "ദയവായി ഒരു പുതിയ ലിങ്ക് ഉപയോഗിച്ച് ശ്രമിക്കുക",
      buttonText: "വീണ്ടും ശ്രമിക്കുക"
    },
    cameraAccessError: {
      alert1: "ക്യാമറ ആക്സസ് നിഷേധിച്ചു. ദയവായി നിങ്ങളുടെ ബ്രൗസർ ക്രമീകരണങ്ങളിൽ ക്യാമറ ആക്സസ് പ്രവർത്തനക്ഷമമാക്കുക",
      alert2: "ക്യാമറ ആക്സസ് ചെയ്യുമ്പോൾ ഒരു പിശക് സംഭവിച്ചു",
      alert3: "നിങ്ങളുടെ ബ്രൗസർ ക്യാമറ ആക്സസ് പിന്തുണയ്ക്കുന്നില്ല"
    },
    activeLiveness: {
      instruction: "നിങ്ങളുടെ മുഖം വൃത്തത്തിനുള്ളിൽ നിലനിർത്തി നിർദ്ദേശങ്ങൾ പിന്തുടരുക",
      permissionDeniedTitle: "ക്യാമറ അല്ലെങ്കിൽ മൈക്രോഫോൺ ആക്സസ് നിഷേധിച്ചു",
      permissionDeniedSubtitle: "ദയവായി നിങ്ങളുടെ ബ്രൗസർ ക്രമീകരണങ്ങളിൽ ക്യാമറയും മൈക്രോഫോണും ആക്സസ് അനുവദിച്ച് വീണ്ടും ശ്രമിക്കുക."
    },
    flipScreen: {
      heading: "ഇപ്പോൾ നിങ്ങളുടെ ഐഡി കാർഡ് മറിക്കുക",
      subHeading: "പിൻഭാഗം കാണിക്കാൻ ദയവായി നിങ്ങളുടെ ഐഡി കാർഡ് ഭൗതികമായി മറിച്ച്, അത് ക്യാമറ ഫ്രെയിമിൽ വയ്ക്കുക.",
      continueButton: "തുടരുക"
    },
    mobileDocCapture: {
      frontSide: "മുൻവശം",
      backSide: "പിൻവശം",
      of: "ന്റെ",
      upload: "അപ്‌ലോഡ് ചെയ്യുക",
      stillNotWorking: "ഇപ്പോഴും പ്രവർത്തിക്കുന്നില്ലേ?",
      clickToCapture: "ക്ലിക്ക്-ടു-ക്യാപ്ചർ പരീക്ഷിക്കുക",
      skip: "ഒഴിവാക്കുക"
    }
,
    permissionPopUp: {
      title: "അനുമതി ആവശ്യമാണ്",
      subtitle: "ക്യാമറ ഉപയോഗിക്കാൻ ആക്സസ് അനുവദിക്കുക",
      decline: "നിരസിക്കുക",
      allow: "അനുവദിക്കുക"
    },
    userDetails: {
      heading: "PAN പരിശോധന",
      subHeading: "പരിശോധിക്കാൻ ദയവായി വിശദാംശങ്ങൾ പൂരിപ്പിക്കുക",
      panLabel: "PAN നമ്പർ",
      panRequired: "ദയവായി നിങ്ങളുടെ PAN നമ്പർ നൽകുക",
      saveError: "വിശദാംശങ്ങൾ സംരക്ഷിക്കുമ്പോൾ എന്തോ കുഴപ്പം സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
      proceed: "തുടരുക"
    },
    redirectCta: {
      or: "അല്ലെങ്കിൽ",
      clickHere: "ഇവിടെ ക്ലിക്ക് ചെയ്യുക",
      clickHereStart: "ഇവിടെ ക്ലിക്ക് ചെയ്യുക",
      toContinue: "തുടരാൻ"
    },
    documentCapture: {
      stillNotWorking: "ഇപ്പോഴും പ്രവർത്തിക്കുന്നില്ലേ?",
      clickToCaptureInstead: "പകരം ക്ലിക്ക്-ടു-ക്യാപ്ചർ പരീക്ഷിക്കുക",
      pdfNotAllowedIndia: "ഇന്ത്യയ്ക്കായി PDF അപ്‌ലോഡുകൾ അനുവദനീയമല്ല. ദയവായി 5 MB-യിൽ താഴെയുള്ള JPEG, JPG, അല്ലെങ്കിൽ PNG ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക.",
      pdfNotAllowedIndiaMobile: "ഇന്ത്യയ്ക്കായി PDF അപ്‌ലോഡുകൾ അനുവദനീയമല്ല. ദയവായി 5 MB-യിൽ താഴെയുള്ള JPEG, JPG, PNG, HEIC, അല്ലെങ്കിൽ HEIF ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക.",
      fileFormatsIndia: "jpeg, jpg, png 5 mb-യിൽ താഴെ",
      fileFormats: "jpeg, jpg, png, pdf 5 mb-യിൽ താഴെ",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb-യിൽ താഴെ",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb-യിൽ താഴെ"
    },
    mobileCapture: {
      upload: "അപ്‌ലോഡ് ചെയ്യുക",
      skip: "ഒഴിവാക്കുക",
      stillNotWorking: "ഇപ്പോഴും പ്രവർത്തിക്കുന്നില്ലേ?",
      tryClickToCapture: "ടാപ്പ് ചെയ്ത് ഫോട്ടോ എടുക്കുക"
    },
    UserDetails: {
      panLabel: "PAN നമ്പർ",
      proceedBtn: "തുടരുക",
      panRequired: "ദയവായി നിങ്ങളുടെ PAN നമ്പർ നൽകുക",
      saveError: "വിശദാംശങ്ങൾ സംരക്ഷിക്കുമ്പോൾ എന്തോ പിഴവ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക."
    }
  },
  mai: {
    header: {
      title: "हम अहाँक पहिचान कऽ पुष्टि करी",
      subtitle: "एकर लागि २ मिनट सँ कम समय लागैत अछि",
      havingIssue: "दिक्कत भ' रहल अछि?"
    },
    subHeading: {
      subHeading1: "अहाँक ID दस्तावेज कऽ फोटो खींचू",
      subHeading2: "अहाँ जियैत छी कऽ पुष्टि करू",
      livenessHeading1: "अच्छी रोशनी वाली जगह चुनें",
      livenessHeading2: "अपना चेहरा बीच में रखें"
    },
    onlyIdVerificationHeader: {
      title: "हम अहाँक पहिचान कऽ पुष्टि करी",
      subtitle: "ई मात्र एक मिनट लेत। कृपया अपन पहचान पत्र लगैने रहू।",
      instruction1: "कैमरा पहुँच केँ अनुमति दिअ",
      instruction2: "अपन दस्तावेज स्कैन करू अथवा अपलोड करू",
      instruction3: "तुरंत दस्तावेज सत्यापन"
    },
    termsAndCondition: {
      title: "हम एहन नियम आ शर्त सभ सँ सहमत छी आ पालन करब।",
      privacyPolicy: "नियम देखू",
      beginBtnText: "शुरू करू",
      beginLiveness: "लाइभनेस जाँच शुरू भऽ रहल अछि",
      startLiveness: "लाइभनेस जाँच कऽ लागि आगू बढ़ू"
    },
    permissionDenied: {
      title: "कैमरा पहुँचक अनुमति अस्वीकृत भʼ गेल अछि!",
      subtitle: "ब्राउज़रक एड्रेस बार लग ब्लॉक कएल गेल कैमरा आइकन देखू आ ओकरा अनब्लॉक करू।",
      readMore: "आर पढ़ू",
      refreshText: "कैमरा पहुँच लेल अनुमति देलाक बाद, नीचाँ देल गेल 'रिफ्रेश' बटन पर क्लिक करू।",
      refreshBtn: "रिफ्रेश",
      link: "अथवा, फोन पर जारी राखू",
      buttonText: "अथवा, फोन पर जारी राखू"
    },
    desktopBrowserPermissionDenied: {
      title: "कृपया कैमरा कऽ पहुँच कऽ अनुमति दिअ",
      subtitle: "ब्राउज़र अनुमति मंगि सकैत अछि। कृपया 'अनुमति दिअ' क्लिक करू ताकि आगू बढ़ सकी।",
      readMore: "आर पढ़ू",
      refreshText: "अनुमति देलाक बाद रिफ्रेश करू",
      refreshBtn: "रिफ्रेश",
      link: "अथवा, फोन पर जारी राखू",
      buttonText: "अथवा, फोन पर जारी राखू"
    },
    androidBrowserPermissionDenied: {
      title: "कैमरा पहुँचक अनुमति अस्वीकृत भʼ गेल अछि",
      subtitle: "ब्राउजरक एड्रेस बार लग ब्लॉक भेल कैमरा आइकन पर ध्यान दिअ आ ओकरा अनब्लॉक करू।",
      readMore: "आओर जानू",
      refreshText: "जखन कैमरा लेल अनुमति भेटि जाए, त' नीचाँ द देल गेल 'रिफ्रेश' बटन पर क्लिक करू।",
      refreshBtn: "रिफ्रेश करू",
      link: "वा, मोबाइल पर जारी राखू",
      buttonText: "वा, मोबाइल पर जारी राखू"
    },
    androidWebViewPermissionDenied: {
      title: "कैमरा पहुँचक अनुमति अस्वीकृत भʼ गेल अछि",
      subtitle: "एपक सेटिंग्स सँ कैमरा एक्सेस ब्लॉक कएल गेल होय सकैत अछि। कृपया App Info > Permissions > Camera में जा क' अनुमति दिअ।",
      refreshText: "जखन कैमरा लेल अनुमति भेटि जाए, त' नीचाँ द देल गेल 'रिफ्रेश' बटन पर क्लिक करू।",
      refreshBtn: "रिफ्रेश करू",
      link: "वा, मोबाइल पर जारी राखू",
      buttonText: "वा, मोबाइल पर जारी राखू"
    },
    iosBrowserPermissionDenied: {
      title: "कैमरा पहुँचक अनुमति अस्वीकृत भʼ गेल अछि",
      subtitle: "एड्रेस बार लग कैमरा या लॉक आइकन पर टैप करू, या ब्राउजर सेटिंग्स चेक करू।",
      readMore: "आओर जानू",
      refreshText: "जखन कैमरा लेल अनुमति भेटि जाए, त' नीचाँ द देल गेल 'रिफ्रेश' बटन पर क्लिक करू।",
      refreshBtn: "रिफ्रेश करू",
      link: "वा, मोबाइल पर जारी राखू",
      buttonText: "वा, मोबाइल पर जारी राखू"
    },
    iosWebViewPermissionDenied: {
      title: "कैमरा पहुँचक अनुमति अस्वीकृत भʼ गेल अछि",
      subtitle: "एप सेटिंग्स में कैमरा अनुमति ब्लॉक कएल गेल होय सकैत अछि। Settings में जा कऽ ऐप चुनू आ कैमरा अनुमति ऑन करू।",
      refreshText: "जखन कैमरा लेल अनुमति भेटि जाए, त' नीचाँ द देल गेल 'रिफ्रेश' बटन पर क्लिक करू।",
      refreshBtn: "रिफ्रेश करू",
      link: "वा, मोबाइल पर जारी राखू",
      buttonText: "वा, मोबाइल पर जारी राखू"
    },
    documentationList: {
      countryHeading: "देश चुनू",
      docHeading: "अपन दस्तावेज चुनू",
      btnText: "अगिला",
      searchCountry: "देश खोजू"
    },
    frontDocCapture: {
      heading: "ID कऽ अगिला हिस्सा चौकोर में रखू",
      backupHeading: "समस्या भऽ रहल अछि? कृपया मैनुअल क्लिक करू",
      btnText: "फोटो खींचू",
      headingBack: " आयत के अंदर",
      uploadButton: "वा, आईडी अपलोड करू"
    },
    backDocCapture: {
      heading: "ID कऽ पिछला हिस्सा चौकोर में रखू",
      backupHeading: "समस्या भऽ रहल अछि? कृपया मैनुअल क्लिक करू",
      btnText: "फोटो खींचू",
      containerText: "अथवा, दस्तावेज अपलोड करू",
      text: "पकड़ि रहल छी, स्थिर रही",
      headingBack: " आयत के अंदर",
      skipButton: "पीछे का भाग छोड़ें",
      uploadButton: "वा, आईडी अपलोड करू"
    },
    analyzing: {
      heading: "अहाँक ID कऽ विश्लेषण कऽ रहल छी...",
      subHeading: "कृपया अगिला स्क्रीन पर अपन कार्ड कऽ विवरण चेक करू आ आवश्यकता अनुसार संपादित करू"
    },
    imageCheck: {
      heading: "अपन छवि चेक करू",
      subHeading: "कृपया सुनिश्चित करू जे छवि पूरा, साफ आ धुंधला आ चमक से मुक्त अछि।",
      button1: "फोटो फेर खींचू",
      button2: "ठीक अछि",
      frontHeading: "सामना छवि चेक करू",
      backHeading: "पछिला छवि चेक करू"
    },
    errorHandler: {
      heading: "अरे रऽ :(",
      subHeading1: "हम किछु समस्या कऽ सामना कऽ रहल छी, मुदा चिंता नहि करू! कृपया फेर प्रयास करू",
      subHeading2: "जदि ई समस्या जारी रहल, तऽ बाद में चेक करू",
      button: "फेर प्रयास करू"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "कृपया अपन मुँह ढँकने वाली किछु हटा दिअ",
        button: "फेर सँ प्रयास करू"
      },
      eyeClosureDetected: {
        heading: "कृपया अपना आँख खुलल रखी आ सीधा कैमरा दिसा में देखी",
        button: "फेर से कोसिस करी"
      },
      isMultipleFacesFound: {
        heading: "एक सं बेसी मुंह भेटल। सुनिश्चित करू जे कैमरा में सिर्फ अहाँक मुंह देखाइ दे रहल अछि।",
        button: "फेर सँ प्रयास करू"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "फेर सँ प्रयास करू"
      },
      faceDetections: {
        heading: "कृपया एहि केँ हटा दिअ",
        button: "फेर सँ प्रयास करू"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "कतेको मुँह भेटल अछि",
          button: "फेर सँ प्रयास करू"
        },
        generalMessage: {
          heading: "कृपया सुनिश्चित करू जे अहाँ कैमरा के समक्ष जीवित छी",
          button: "फेर सँ प्रयास करू"
        }
      },
      faceMatch: {
        heading: "अहाँक मुँह ID फोटो सँ मेल नहि खा रहल अछि",
        button: "फेर सँ प्रयास करू"
      },
      selfieError: {
        heading: "हम अहाँक सेल्फी कऽ परीक्षण नहि कऽ सकलहुँ",
        subHeading1: "कृपया एहि निर्देश सभ केँ अनुसरण करू आ फेर सँ प्रयास करू",
        instruction1: "अच्छा रोशनी वाला स्थान पर जाऊ आ बैकलाईट सँ बचे",
        instruction2: "निशचित करू जे अहाँक मुँह पूरा तरह सँ देखाई देत आ फ्रेम के मध्य में होयत",
        instruction3: "अहाँक मुँह स्पष्ट रूप सँ देखाए लेल टोपी, चश्मा या मास्क हटा दिअ",
        button: "फेर सँ प्रयास करू"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP मेल नहीं खाया। कृपया OTP को स्पष्ट रूप से ज़ोर से पढ़ें",
        button: "पुनः प्रयास करें"
      },
      activeLivenessGenericFailureMessage: {
        heading: "सत्यापन विफल भेल। कृपया निर्देश केर साफ-साफ पालन करू आ फेर सँ प्रयास करू",
        button: "फेर सँ प्रयास करू"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF मे बहुत बेसी पृष्ठ अछि",
        subHeading: "अपलोड कएल PDF 2-पृष्ठक सीमा सँ बेसी अछि। कृपया 2 सँ बेसी पृष्ठ नहि रहनिहार PDF, अथवा अपन IDक स्पष्ट छवि अपलोड करू।"
      },
      heading: "हम अहाँक ID कऽ प्रक्रिया नहि कऽ सकलहुँ",
      subHeading: "अहाँ गलत ID अपलोड कऽ रहल छी अथवा छवि स्पष्ट नहि अछि",
      buttonBack: "ID कऽ पिछला हिस्सा फेर प्रयास करू",
      buttonFront: "ID कऽ अगिला हिस्सा फेर प्रयास करू",
      button: "फेर प्रयास करू",
      captureFrontSide: "आगाँक भाग कैप्चर करू",
      captureBackSide: "पाछाँक भाग कैप्चर करू",
      changeIDButton: "दूसरा दस्तावेज़ चुनें",
      wrongid: {
        heading: "हम इस दस्तावेज़ को प्रोसेस नहीं कर सके",
        subHeading: "कृपया सुनिश्चित करें कि आप सही दस्तावेज़ अपलोड कर रहे हैं और तस्वीर की गुणवत्ता स्पष्ट है"
      },
      expiredid: {
        heading: "आईडी दस्तावेज़ समाप्त हो चुका है!",
        subHeading: "हम समाप्त आईडी दस्तावेज़ को स्वीकार नहीं कर सकते। कृपया एक वैध दस्तावेज़ प्रदान करें"
      },
      minimumage: {
        heading: "आयु आवश्यकता पूरी नहीं हुई!",
        subHeading: "आपकी आयु न्यूनतम आवश्यक आयु से कम है। कृपया सुनिश्चित करें कि आप न्यूनतम आयु मानदंड को पूरा करते हैं"
      },
      mobileAttemptsDone: {
        heading: "यात्रा आपके पिछले डिवाइस पर पुनः शुरू हुई",
        subHeading: "यह सत्र अब डुप्लिकेशन से बचने के लिए बंद कर दिया गया है"
      },
      finished: {
        heading: "यात्रा समाप्त हो गई है",
        subHeading: "यात्रा पूरी हो गई है या समाप्त कर दी गई है"
      },
      invalid: {
        heading: "यात्रा उपलब्ध नहीं है!",
        subHeading: "या तो यात्रा आईडी नहीं मिली है या यात्रा आईडी अमान्य है"
      },
      INVALID_PAN_NUMBER: {
        heading: "अमान्य PAN नंबर",
        subHeading: "आपके द्वारा दर्ज किया गया PAN नंबर मान्य नहीं है। कृपया जांचें और पुनः प्रयास करें"
      },
      INVALID_PAN_STATUS: {
        heading: "अमान्य PAN स्थिति",
        subHeading: "आपके द्वारा दर्ज किया गया PAN नंबर मान्य नहीं है। कृपया जांचें और पुनः प्रयास करें"
      },
      directKyc: {
        heading: "डायरेक्ट KYC यात्रा !",
        subHeading: "यह एक डायरेक्ट KYC यात्रा है। फ्रंटएंड यात्रा की अनुमति नहीं है।"
      },
      DOCTYPE_FALSE: {
        heading: "दस्तावेज़ पहचाना नहीं गया!",
        subHeading: "कृपया एक वैध दस्तावेज़ अपलोड करें और सुनिश्चित करें कि इमेज गुणवत्ता अच्छी हो।"
      },
      ONLY_FRONT: {
        heading: "आईडी का पिछला हिस्सा गायब है",
        subHeading: "आपने केवल सामने वाला हिस्सा प्रदान किया है। कृपया अपनी आईडी पलटें और आगे बढ़ने के लिए पिछला हिस्सा प्रदान करें"
      },
      ONLY_BACK: {
        heading: "आईडी का अगला हिस्सा गायब है",
        subHeading: "आपने केवल पिछला हिस्सा प्रदान किया है। कृपया अपनी आईडी पलटें और आगे बढ़ने के लिए अगला हिस्सा प्रदान करें"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "दस्तावेज़ जल्द ही समाप्त होने वाला है!",
        subHeading: "दस्तावेज़ जल्द ही समाप्त होने के कारण इसे अस्वीकृत किया गया है।"
      },
      DOCUMENT_EXPIRED: {
        heading: "दस्तावेज़ समाप्त हो गया है!",
        subHeading: "कृपया एक वैध, अविभाजित दस्तावेज़ अपलोड करें।"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "आयु आवश्यकताएँ पूरी नहीं हुई!",
        subHeading: "दस्तावेज़ से पता चलता है कि आप आवश्यक आयु सीमा से मेल नहीं खाते। कृपया एक वैध दस्तावेज़ अपलोड करें।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "इमेज गुणवत्ता बहुत खराब है। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ जानकारी सत्यापित नहीं हो सकी। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ विवरण खराब इमेज गुणवत्ता के कारण सत्यापित नहीं हो सके। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "दस्तावेज़ सत्यापित नहीं हो सका!",
        subHeading: "कुछ विवरण सत्यापित नहीं हो सके। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "पहचान पत्र पर आपकी फोटो सत्यापित करने में समस्या",
        subHeading: "हम पहचान पत्र पर आपकी फोटो को सत्यापित नहीं कर सके। कृपया मूल पहचान पत्र की स्पष्ट फोटो अपलोड करें ताकि हम इसकी पुष्टि कर सकें।"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "दस्तावेज़ सुरक्षा पैटर्न जाँच विफल हुई",
        subHeading: "हम दस्तावेज़ के अंतर्निहित सुरक्षा पैटर्न को सत्यापित नहीं कर सके। कृपया मूल पहचान पत्र की स्पष्ट फोटो अपलोड करें ताकि हम इसकी प्रामाणिकता की पुष्टि कर सकें।"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "दस्तावेज़ की जीवंतता जांच विफल हुई",
        subHeading: "हमें संकेत मिले हैं कि दस्तावेज़ असली नहीं हो सकता। कृपया स्क्रीनशॉट, प्रिंट की हुई कॉपी या स्क्रीन पर दिखाई गई आईडी का उपयोग न करें। मूल आईडी अपलोड करें जिसमें सभी विशेषताएँ स्पष्ट रूप से दिखें।"
      },
      SECURITY_FALSE: {
        heading: "समस्या पाई गई!",
        subHeading: "दस्तावेज़ सत्यापित नहीं हो सका। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "खराब इमेज गुणवत्ता!",
        subHeading: "इमेज बहुत धुंधली या अस्पष्ट है। कृपया स्पष्ट इमेज के साथ पुनः प्रयास करें।"
      },
      FACE_UNDETECTED: {
        heading: "चेहरा नहीं मिला",
        subHeading: "हम दस्तावेज़ पर कोई स्पष्ट चेहरा नहीं देख सके। कृपया ऐसा वैध पहचान पत्र अपलोड करें, जिसमें चेहरा साफ़ दिखाई दे।"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "दस्तावेज़ों के बीच तुलना विफल",
        subHeading: "एक या अधिक मुख्य फ़ील्ड (नाम, जन्म तिथि, या चेहरा) में बेमेल के कारण दस्तावेज़ों के बीच तुलना विफल रही"
      },
      DIGILOCKER_FAILURE: {
        heading: "डिजिलॉकर विफलता",
        subHeading: "डिजिलॉकर यात्रा के दौरान एक त्रुटि हुई। कृपया पुनः प्रयास करें या जारी रखने के लिए कोई वैकल्पिक तरीका उपयोग करें।"
      },
      LINKAGE_FAILED: {
        heading: "ई सत्यापन पूरा नहि भ' सकल",
        subHeading: "ई जाँचक लेल लेल गेल विवरण रिकॉर्डसँ मेल नहि खेलक।"
      }
    },
    biometricConsent: {
      consentStatement: "अपनी सेल्फ़ी से पहले, आपकी पहचान सत्यापित करने के लिए हमें आपके बायोमेट्रिक डेटा (चेहरे की छवि और लाइवनेस संकेत) को कैप्चर और प्रोसेस करने की आपकी सहमति चाहिए। इस डेटा का उपयोग केवल इसी सत्यापन के लिए किया जाता है।",
      privacyPolicy: "गोपनीयता नीति",
      consentButton: "मैं सहमत हूँ — जारी रखें",
      declineButton: "मैं सहमत नहीं हूँ",
      confirmTitle: "बायोमेट्रिक सत्यापन के बिना आगे बढ़ें?",
      confirmBody: "बायोमेट्रिक सत्यापन के बिना, हम सेल्फ़ी कैप्चर नहीं करेंगे। आपका सत्यापन आपके द्वारा पहले से दी गई जानकारी का उपयोग करके पूरा किया जाएगा। यह चयन इस सत्र के लिए अंतिम है।",
      goBack: "वापस जाएँ",
      confirmDecline: "पुष्टि करें — सहमत नहीं",
      declineComplete: "आपने बायोमेट्रिक सत्यापन के साथ आगे न बढ़ने का विकल्प चुना है। आपकी पहचान का सत्यापन आपके द्वारा सबमिट किए गए दस्तावेज़ों का उपयोग करके पूरा कर लिया गया है।"
    },
    introLiveness: {
      heading: "एहि ठाम पुष्टि करू जे अहाँ जियैत छी",
      instruction1: "सुनिश्चित करू जे पर्याप्त प्रकाश अछि",
      instruction2: "आवश्यक अनुमति दिअ",
      instruction3: "बस निर्देशक पालन करू",
      button: "आगू बढ़ू",
      subHeading: "आप बस एक कदम दूर हैं"
    },
    phoneSession: {
      heading: "सत्र फोन पर जारी अछि",
      subheading: "मोबाइल पर पूरा होइत तक एहि विंडो कऽ खुलल राखू",
      button: "एहि ठाम जारी राखू"
    },
    continueOnPhone: {
      heading: "फोन पर जारी राखू",
      subheading: "QR कऽ स्कैन करू अथवा नीचे कऽ लिंक कऽ कॉपी करू",
      subheading2: "QR कऽ स्कैन करू अथवा लिंक कऽ अपन फोन पर खोलू",
      text: "प्रक्रिया पूरा करू",
      text1: "सबमिट करबाक लेल एहिठाम चेक करू",
      button: "कॉपी करू",
      copiedButton: "कॉपी भ' गेल!",
      copied: "कॉपी भ' गेल!"
    },
    SsnReview: {
      heading: "अपन विवरण कऽ समीक्षा करू",
      subHeading: "आवश्यक बदलाव करू आ विवरण सबमिट करू",
      feild1: "ड्राइविंग लाइसेंस",
      feild2: "समाप्ति",
      feild3: "जन्म तिथि",
      feild4: "श्रेणी",
      feild5: "प्रतिबंध",
      feild6: "देश",
      feild7: "पता",
      button: "विवरण ठीक अछि"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "अपन मुँह गोला मे राखू"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "कैमरा लग आउ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "लाजू नहि, सामने आउ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत अन्हार अछि। बेसी इजोत मे जाउ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत इजोत अछि। हल्का इजोत मे जाउ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "अपन मुँह गोला मे राखू"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर रहू"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "इजोत दिश मुँह करू"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "फोन केँ आँखि केर बराबर राखू"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कैमरा सँ थोड़ दूर हटू"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "अपन मुँह फ्रेम केर बीच मे राखू"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "अपन चेहरा गोलाकार के बीच में रखू"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "नजदीक आउ आ चेहरा सीधा रखू"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "दृश्य में आउ आ चेहरा सीधा रखू"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत अन्हार अछि। अधिक रोशनी खोजू"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "बहुत तेज। उपयुक्त रोशनी खोजू"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "अपन चेहरा गोलाकार के बीच में सेट करू"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "स्थिर रहू आ सीधा आगाँ देखू"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "प्रकाश दिस मुँह करू आ स्थिर रहू"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "अपन फोन कऽ आँखि कऽ स्तर पर रखू"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "कैमरा सँ थोड़ा दूर चलू"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "पूर्ण!"
      },
      smile1: {
        icon: "mood",
        description: "मुस्कुराउ, अहाँ नीक देख रहल छी!"
      },
      smile2: {
        icon: "mood",
        description: "कैमरा लेल मुस्कुराउ!"
      }
    },
    successful: {
      title: "पुष्टि पूर्ण",
      text: "अहाँ आब विंडो बंद कऽ सकैत छी",
      finishBtn: "पूर्ण"
    },
    poweredBy: "द्वारा संचालित",
    redirect: "में पुनर्निर्देशित",
    error: {
      message: "URL समाप्त भऽ गेल अछि अथवा अमान्य अछि"
    },
    footer: {
      securedBy: "द्वारा संचालित"
    },
    helpFaq: {
      title: "सहायता आ FAQ",
      subtitle: "हम अहाँक मदद करय लेल एतऽ छी",
      cameraText: "अहाँक पहिचान कऽ पुष्टि करबा लेल, हमरा अहाँक डिवाइसक कैमरा द्वारा छवि खींचबाक आवश्यकता अछि। आवश्यक अनुमतियाँ देबाक तरीका सीखबाक लेल link पर क्लिक करू",
      cameraHeading: "कैमरा अनुमति",
      languageText: "प्रक्रिया के शुरुआत में, अहाँ अपन पसंदीदा भाषा चुनि सकय छी, जे टॉप बार में ड्रॉपडाउन मेनू से चयन क' सकल जाइत अछि",
      languageHeading: "भाषा चयन",
      kycText: "KYC, अर्थात 'अपने ग्राहक को जानें', एक प्रक्रिया अछि जे ग्राहकक पहचान कऽ सत्यापित करय में मदद करैत अछि, जकरा से अनुपालन सुनिश्चित करबाक आ धोखाधड़ी आ अन्य गैरकानूनी गतिविधि सँ बचबाक में सहारा भेटैत अछि",
      kycHeading: "KYC का अर्थ की अछि?",
      timeText: "आमतौर पर, एहिमें 60 सेकेंड तक समय लागैत अछि। हालांकि, ई देश के अनुसार भिन्न हो सकैत अछि",
      timeHeading: "कतेक समय लागी?"
    },
    pdfPreviewUnavailable: "PDF का पूर्वावलोकन दिखाने में असमर्थ।",
    pdfPreviewHint: "यदि पूर्वावलोकन दिखाई न दे, तो भी आप आगे बढ़ सकते हैं।",
    pdfOpenLabel: "PDF खोलें",
    failedUpload: {
      title: "फ़ाइल अपलोड विफल",
      text: "कृपया सुनिश्चित करें कि फ़ाइल 5MB से कम और .jpg, .jpeg, .png, .heic, .heif या .pdf प्रारूप में है",
      btn: "पुनः प्रयास करें",
      pdfNotAllowedIndia: "भारत लेल PDF अपलोड केर अनुमति नहि अछि। कृपया 5 MB सँ कम केर JPEG, JPG, PNG, HEIC, वा HEIF फाइल अपलोड करू।",
      pdfNotAllowedIndiaBasic: "भारत लेल PDF अपलोड केर अनुमति नहि अछि। कृपया 5 MB सँ कम केर JPEG, JPG, वा PNG फाइल अपलोड करू।"
    },
    livenessAnalyzing: {
      heading: "आपके चेहरे का विश्लेषण किया जा रहा है",
      subHeading: "कृपया प्रतीक्षा करें, इसमें केवल कुछ सेकंड लगेंगे"
    },
    sessionExpiredError: {
      heading: "माफ करें, आपकी सत्र समाप्त हो गया है",
      subHeading1: "आप कुछ समय के लिए निष्क्रिय रहे हैं। सुरक्षा कारणों से, आपकी सत्र स्वचालित रूप से समाप्त हो गई है",
      subHeading2: "कृपया पुनः प्रयास करें",
      buttonText: "फिर से प्रयास करें"
    },
    journeyExpiredError: {
      heading: "माफ करें, लिंक समाप्त हो गया है",
      subHeading1: "लिंक अब सक्रिय नहीं है। सुरक्षा कारणों से, लिंक की एक सीमित अवधि होती है",
      subHeading2: "कृपया नए लिंक के साथ प्रयास करें",
      buttonText: "फिर से प्रयास करें"
    },
    cameraAccessError: {
      alert1: "कैमरा एक्सेस अस्वीकृत किया गया। कृपया अपने ब्राउज़र सेटिंग्स में कैमरा एक्सेस सक्षम करें",
      alert2: "कैमरा एक्सेस करते समय एक त्रुटि हुई",
      alert3: "आपका ब्राउज़र कैमरा एक्सेस का समर्थन नहीं करता"
    },
    activeLiveness: {
      instruction: "अपना चेहरा गोले में रखें और निर्देशों का पालन करें",
      permissionDeniedTitle: "कैमरा या माइक्रोफ़ोन एक्सेस अस्वीकृत",
      permissionDeniedSubtitle: "कृपया अपनी ब्राउज़र सेटिंग्स में कैमरा और माइक्रोफ़ोन एक्सेस की अनुमति दें और पुनः प्रयास करें।"
    },
    flipScreen: {
      heading: "एखन अपन आईडी कार्ड पल्टू",
      subHeading: "कृपया पाछू दिश देखाबय लेल अपन आईडी कार्ड भौतिक रूप सँ पल्टू, तखन एकरा कैमरा फ्रेम मे राखू।",
      continueButton: "आगाँ बढ़ू"
    },
    mobileDocCapture: {
      frontSide: "आगाँक भाग",
      backSide: "पाछाँक भाग",
      of: "क",
      upload: "अपलोड करू",
      stillNotWorking: "आब धरि काज नहि क' रहल अछि?",
      clickToCapture: "क्लिक-टू-कैप्चर आजमाउ",
      skip: "छोड़ू"
    }
,
    permissionPopUp: {
      title: "अनुमति आवश्यक अछि",
      subtitle: "कैमरा उपयोग करबाक लेल पहुँचक अनुमति दिअ",
      decline: "अस्वीकार करू",
      allow: "अनुमति दिअ"
    },
    userDetails: {
      heading: "PAN सत्यापन",
      subHeading: "सत्यापनक लेल कृपया विवरण भरू",
      panLabel: "PAN नंबर",
      panRequired: "कृपया अपन PAN नंबर दर्ज करू",
      saveError: "विवरण सहेजबाक समय किछु गलत भ' गेल। कृपया फेर प्रयास करू।",
      proceed: "आगाँ बढ़ू"
    },
    redirectCta: {
      or: "वा",
      clickHere: "एतय क्लिक करू",
      clickHereStart: "एतय क्लिक करू",
      toContinue: "जारी राखबाक लेल"
    },
    documentCapture: {
      stillNotWorking: "आब धरि काज नहि क' रहल अछि?",
      clickToCaptureInstead: "एकर बदला क्लिक-टू-कैप्चर आजमाउ",
      pdfNotAllowedIndia: "भारतक लेल PDF अपलोडक अनुमति नहि अछि। कृपया 5 MB सँ कम JPEG, JPG, वा PNG फाइल अपलोड करू।",
      pdfNotAllowedIndiaMobile: "भारतक लेल PDF अपलोडक अनुमति नहि अछि। कृपया 5 MB सँ कम JPEG, JPG, PNG, HEIC, वा HEIF फाइल अपलोड करू।",
      fileFormatsIndia: "jpeg, jpg, png 5 mb सँ कम",
      fileFormats: "jpeg, jpg, png, pdf 5 mb सँ कम",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb सँ कम",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb सँ कम"
    },
    mobileCapture: {
      upload: "अपलोड करू",
      skip: "छोड़ू",
      stillNotWorking: "तैयो काज नहि क' रहल अछि?",
      tryClickToCapture: "टैप क' क' फोटो लिअ"
    },
    UserDetails: {
      panLabel: "PAN नम्बर",
      proceedBtn: "आगाँ बढ़ू",
      panRequired: "कृपया अपन PAN नम्बर भरू",
      saveError: "विवरण सेव करैत काल किछु गलत भ' गेल। कृपया फेर सँ प्रयास करू।"
    }
  },
  uk: {
    supportingDocument: {
      headingFallback: "Підтверджувальний документ",
      subHeading: "Завантажте документ нижче. Він зберігається для перевірки — з нього нічого не видобувається.",
      choosePlaceholder: "Виберіть файл (PNG, JPG або PDF)",
      continue: "Продовжити",
      uploading: "Завантаження...",
      skip: "Пропустити поки що",
      errorInvalidType: "Завантажте файл PNG, JPG або PDF.",
      errorTooLarge: "Файл занадто великий. Обмеження — 10 МБ.",
      errorRead: "Не вдалося прочитати цей файл. Спробуйте інший.",
      errorNoFile: "Виберіть файл для завантаження.",
    },
    header: {
      title: "Давайте підтвердимо вашу особу",
      subtitle: "Це займає менше 2 хвилин",
      havingIssue: "Виникли проблеми?"
    },
    subHeading: {
      subHeading1: "Зробіть фото вашого документу",
      subHeading2: "Підтвердьте, що ви є в реальному часі",
      livenessHeading1: "Знайдіть місце з гарним освітленням",
      livenessHeading2: "Тримайте обличчя по центру"
    },
    onlyIdVerificationHeader: {
      title: "Давайте підтвердимо вашу особу",
      subtitle: "Це займе лише хвилину. Просто тримайте свій документ поруч.",
      instruction1: "Надайте доступ до камери",
      instruction2: "Скануйте або завантажте свій документ",
      instruction3: "Миттєва перевірка документа"
    },
    termsAndCondition: {
      title: "Я погоджуюся та дотримуюся наступних умов та положень.",
      privacyPolicy: "Переглянути умови",
      beginBtnText: "Почати",
      beginLiveness: "Розпочинається перевірка на живучість",
      startLiveness: "Перейти до перевірки на живучість"
    },
    permissionDenied: {
      title: "Доступ до камери заборонено!",
      subtitle: "Перевірте, чи є заблокована іконка камери біля адресного рядка браузера, і розблокуйте її.",
      readMore: "Дізнатись більше",
      refreshText: "Після надання дозволу на доступ до камери натисніть кнопку «Оновити» нижче.",
      refreshBtn: "Оновити",
      link: "Або продовжити на телефоні",
      buttonText: "Або продовжити на телефоні"
    },
    desktopBrowserPermissionDenied: {
      title: "Будь ласка, надайте доступ до камери",
      subtitle: "Браузер може запитати дозволи. Будь ласка, натисніть 'дозволити', щоб продовжити.",
      readMore: "Дізнатись більше",
      refreshText: "Оновіть після надання дозволів",
      refreshBtn: "Оновити",
      link: "Або продовжити на телефоні",
      buttonText: "Або продовжити на телефоні"
    },
    androidBrowserPermissionDenied: {
      title: "Доступ до камери заборонено",
      subtitle: "Перевірте, чи не заблоковано камеру біля адресного рядка браузера, і розблокуйте її.",
      readMore: "Дізнатись більше",
      refreshText: "Після надання дозволу на доступ до камери натисніть кнопку «Оновити» нижче.",
      refreshBtn: "Оновити",
      link: "Або продовжити на телефоні",
      buttonText: "Або продовжити на телефоні"
    },
    androidWebViewPermissionDenied: {
      title: "Доступ до камери заборонено",
      subtitle: "Доступ до камери може бути заборонений у налаштуваннях застосунку. Перейдіть у Налаштування > Інформація про застосунок > Дозволи > Камера й надайте дозвіл.",
      refreshText: "Після надання дозволу на доступ до камери натисніть кнопку «Оновити» нижче.",
      refreshBtn: "Оновити",
      link: "Або продовжити на телефоні",
      buttonText: "Або продовжити на телефоні"
    },
    iosBrowserPermissionDenied: {
      title: "Доступ до камери заборонено",
      subtitle: "Натисніть на іконку камери або замка біля адресного рядка, щоб дозволити доступ, або перевірте налаштування браузера.",
      readMore: "Дізнатись більше",
      refreshText: "Після надання дозволу на доступ до камери натисніть кнопку «Оновити» нижче.",
      refreshBtn: "Оновити",
      link: "Або продовжити на телефоні",
      buttonText: "Або продовжити на телефоні"
    },
    iosWebViewPermissionDenied: {
      title: "Доступ до камери заборонено",
      subtitle: "Можливо, доступ до камери заборонено в налаштуваннях застосунку. Перейдіть у Налаштування, знайдіть ваш застосунок і активуйте дозвіл на камеру.",
      refreshText: "Після надання дозволу на доступ до камери натисніть кнопку «Оновити» нижче.",
      refreshBtn: "Оновити",
      link: "Або продовжити на телефоні",
      buttonText: "Або продовжити на телефоні"
    },
    documentationList: {
      countryHeading: "Виберіть країну",
      docHeading: "Виберіть ваш документ",
      btnText: "Далі",
      searchCountry: "Пошук країни"
    },
    frontDocCapture: {
      heading: "Розмістіть передню сторону документа у прямокутнику",
      backupHeading: "Є проблема? Будь ласка, натисніть на зображення вручну",
      btnText: "Зробити фото",
      headingBack: " у прямокутнику",
      uploadButton: "або завантажте посвідчення"
    },
    backDocCapture: {
      heading: "Розмістіть задню сторону документа у прямокутнику",
      backupHeading: "Є проблема? Будь ласка, натисніть на зображення вручну",
      btnText: "Зробити фото",
      containerText: "або завантажте документ",
      text: "Захоплюється, будь ласка, залишайтесь нерухомими",
      headingBack: " у прямокутнику",
      skipButton: "Пропустити зворотну сторону",
      uploadButton: "або завантажте посвідчення"
    },
    analyzing: {
      heading: "Аналізуємо ваш документ...",
      subHeading: "Будь ласка, перевірте деталі вашої карти на наступному екрані та за потреби відредагуйте"
    },
    imageCheck: {
      heading: "Перевірте ваше зображення",
      subHeading: "Будь ласка, переконайтесь, що зображення повне, чітке та без розмитості та блиску.",
      button1: "Перезняти фото",
      button2: "Готово",
      frontHeading: "Перевірте ваше переднє зображення",
      backHeading: "Перевірте ваше заднє зображення"
    },
    errorHandler: {
      heading: "Ой :(",
      subHeading1: "Ми стикаємось з деякими проблемами, але не хвилюйтесь! Будь ласка, спробуйте знову",
      subHeading2: "Якщо це продовжиться, перевірте пізніше",
      button: "Спробувати знову"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Будь ласка, зніміть все, що закриває ваше обличчя",
        button: "Спробуйте знову"
      },
      eyeClosureDetected: {
        heading: "Будь ласка, тримайте очі відкритими та дивіться прямо в камеру",
        button: "Спробувати знову"
      },
      isMultipleFacesFound: {
        heading: "Виявлено кілька облич. Переконайтеся, що в камері видно лише ваше обличчя.",
        button: "Спробувати знову"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Спробувати знову"
      },
      faceDetections: {
        heading: "Будь ласка, зніміть це",
        button: "Спробуйте знову"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Знайдено кілька обличчя",
          button: "Спробуйте знову"
        },
        generalMessage: {
          heading: "Будь ласка, переконайтеся, що ви живі перед камерою",
          button: "Спробуйте знову"
        }
      },
      faceMatch: {
        heading: "Ваше обличчя не збігається з фото в документі",
        button: "Спробуйте знову"
      },
      selfieError: {
        heading: "Ми не змогли перевірити ваше селфі",
        subHeading1: "Будь ласка, дотримуйтесь цих порад і спробуйте знову",
        instruction1: "Перейдіть до добре освітленого місця та уникайте зворотного освітлення",
        instruction2: "Переконайтеся, що ваше обличчя повністю видно і знаходиться в центрі кадру",
        instruction3: "Зніміть капелюх, окуляри або маску, щоб чітко було видно ваше обличчя",
        button: "Спробуйте знову"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP не збігається. Будь ласка, чітко прочитайте OTP вголос",
        button: "Спробувати ще раз"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Перевірка не вдалася. Будь ласка, чітко дотримуйтесь інструкцій і спробуйте знову",
        button: "Спробуйте знову"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "У PDF забагато сторінок",
        subHeading: "Завантажений PDF перевищує ліміт у 2 сторінки. Завантажте PDF не більше 2 сторінок або чітке зображення вашого документа."
      },
      heading: "Нам не вдалося обробити ваш документ",
      subHeading: "Ви завантажуєте неправильний документ або зображення не чітке",
      buttonBack: "Повторити спробу для задньої сторони",
      buttonFront: "Повторити спробу для передньої сторони",
      button: "Спробувати знову",
      captureFrontSide: "Зняти лицьовий бік",
      captureBackSide: "Зняти зворотний бік",
      changeIDButton: "Вибрати інший документ",
      wrongid: {
        heading: "Нам не вдалося обробити цей документ",
        subHeading: "Будь ласка, переконайтеся, що ви завантажуєте правильний документ, і що якість зображення чітка"
      },
      expiredid: {
        heading: "Термін дії документа, що посвідчує особу, минув!",
        subHeading: "Ми не можемо прийняти документ із простроченим терміном дії. Будь ласка, надайте дійсний документ"
      },
      minimumage: {
        heading: "Вимогу щодо віку не виконано!",
        subHeading: "Ваш вік нижчий за мінімально необхідний. Будь ласка, переконайтеся, що ви відповідаєте критерію мінімального віку"
      },
      mobileAttemptsDone: {
        heading: "Подорож відновлено на вашому попередньому пристрої",
        subHeading: "Цю сесію зупинено, щоб уникнути дублювання."
      },
      finished: {
        heading: "Подорож завершено",
        subHeading: "Подорож або завершено, або припинено"
      },
      invalid: {
        heading: "Подорож недоступна !",
        subHeading: "journeyId не знайдено або ID подорожі недійсний"
      },
      INVALID_PAN_NUMBER: {
        heading: "Недійсний номер PAN",
        subHeading: "Введений вами номер PAN недійсний. Будь ласка, перевірте та спробуйте ще раз"
      },
      INVALID_PAN_STATUS: {
        heading: "Недійсний статус PAN",
        subHeading: "Введений вами номер PAN недійсний. Будь ласка, перевірте та спробуйте ще раз"
      },
      directKyc: {
        heading: "Пряма подорож KYC !",
        subHeading: "Це пряма подорож KYC. Подорож через інтерфейс не дозволена."
      },
      DOCTYPE_FALSE: {
        heading: "Надано неправильний документ!",
        subHeading: "Будь ласка, завантажте дійсний документ і переконайтеся, що якість зображення хороша."
      },
      ONLY_FRONT: {
        heading: "Відсутня зворотна сторона документа",
        subHeading: "Ви надали лише лицьову сторону. Переверніть документ і надайте зворотну сторону, щоб продовжити"
      },
      ONLY_BACK: {
        heading: "Відсутня лицьова сторона документа",
        subHeading: "Ви надали лише зворотну сторону. Переверніть документ і надайте лицьову сторону, щоб продовжити"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Термін дії документа скоро закінчується",
        subHeading: "Документ відхилено, оскільки термін його дії скоро закінчиться."
      },
      DOCUMENT_EXPIRED: {
        heading: "Термін дії документа закінчився!",
        subHeading: "Будь ласка, завантажте дійсний документ із чинним терміном дії, щоб продовжити."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Вимогу щодо віку не виконано!",
        subHeading: "Документ вказує, що ви не відповідаєте необхідному віку. Будь ласка, завантажте дійсний документ."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Не вдається перевірити документ!",
        subHeading: "Якість зображення занадто низька для перевірки. Будь ласка, спробуйте ще раз із чіткішим зображенням."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Не вдається перевірити документ!",
        subHeading: "Деяку інформацію не вдалося перевірити. Будь ласка, спробуйте ще раз із чіткішим зображенням."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Не вдається перевірити документ!",
        subHeading: "Деякі деталі не вдалося перевірити через низьку якість зображення. Будь ласка, спробуйте ще раз із чіткішим зображенням"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Не вдається перевірити документ!",
        subHeading: "Деякі деталі не вдалося перевірити. Будь ласка, спробуйте ще раз із чіткішим зображенням."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Проблема з перевіркою вашого фото на документі",
        subHeading: "Нам не вдалося перевірити ваше фото на документі. Будь ласка, завантажте чітке фото вашого оригінального документа, щоб ми могли його підтвердити."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Перевірка захисного візерунка документа не вдалася",
        subHeading: "Нам не вдалося перевірити вбудовані захисні візерунки документа. Будь ласка, завантажте чітке фото оригінального документа, щоб допомогти нам підтвердити його справжність."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Перевірка справжності документа не вдалася",
        subHeading: "Ми виявили ознаки того, що документ може бути несправжнім. Будь ласка, уникайте використання знімків екрана, друкованих копій або показу документа на екрані. Завантажте оригінальний документ із чітко видимими всіма елементами"
      },
      SECURITY_FALSE: {
        heading: "Виявлено проблему!",
        subHeading: "Не вдалося перевірити документ. Будь ласка, спробуйте ще раз із чіткішим зображенням"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Низька якість зображення!",
        subHeading: "Зображення занадто розмите або нечітке. Будь ласка, спробуйте ще раз із чіткішим зображенням"
      },
      FACE_UNDETECTED: {
        heading: "Обличчя не виявлено",
        subHeading: "Нам не вдалося знайти видиме обличчя на документі. Будь ласка, завантажте дійсний документ, на якому обличчя чітко видно"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Порівняння між документами не вдалося",
        subHeading: "Порівняння між документами не вдалося через невідповідність в одному або кількох ключових полях (ім'я, дата народження або обличчя)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Помилка Digilocker",
        subHeading: "Під час подорожі Digilocker сталася помилка. Будь ласка, спробуйте ще раз або скористайтеся альтернативним методом для продовження."
      },
      LINKAGE_FAILED: {
        heading: "Не вдалося завершити цю перевірку",
        subHeading: "Отримані дані не збіглися із записами для цієї перевірки."
      }
    },
    biometricConsent: {
      consentStatement: "Перед селфі нам потрібна ваша згода на збір і обробку ваших біометричних даних (зображення обличчя та сигнали живості) для підтвердження вашої особи. Ці дані використовуються лише для цієї перевірки.",
      privacyPolicy: "Політика конфіденційності",
      consentButton: "Я погоджуюсь — Продовжити",
      declineButton: "Я не погоджуюсь",
      confirmTitle: "Продовжити без біометричної перевірки?",
      confirmBody: "Без біометричної перевірки ми не робитимемо селфі. Вашу перевірку буде завершено на основі вже наданої вами інформації. Цей вибір є остаточним для цього сеансу.",
      goBack: "Назад",
      confirmDecline: "Підтвердити — не погоджуюсь",
      declineComplete: "Ви обрали не проходити біометричну перевірку. Перевірку вашої особи завершено за допомогою наданих вами документів."
    },
    introLiveness: {
      heading: "Підтвердьте свою присутність тут",
      instruction1: "Переконайтеся, що достатньо світла",
      instruction2: "Надайте необхідні дозволи",
      instruction3: "Просто дотримуйтесь інструкцій",
      button: "Продовжити",
      subHeading: "Вам залишився лише один крок"
    },
    phoneSession: {
      heading: "Сесія продовжена на телефоні",
      subheading: "Залишайте це вікно відкритим, поки не завершите на мобільному пристрої",
      button: "Продовжити тут"
    },
    continueOnPhone: {
      heading: "Продовжити на телефоні",
      subheading: "Скануйте QR або скопіюйте нижче вказане посилання",
      subheading2: "Скануйте QR або відкрийте посилання на вашому телефоні",
      text: "Завершіть процес",
      text1: "Перевірте тут для подачі",
      button: "Скопіювати",
      copiedButton: "Скопійовано!",
      copied: "Скопійовано!"
    },
    SsnReview: {
      heading: "Перегляньте ваші деталі",
      subHeading: "Зробіть необхідні зміни та подайте деталі",
      feild1: "Водійське посвідчення",
      feild2: "Термін дії",
      feild3: "Дата народження",
      feild4: "Клас",
      feild5: "Обмеження",
      feild6: "Країна",
      feild7: "Адреса",
      button: "Деталі правильні"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Тримайте обличчя в колі"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Підійдіть ближче до камери"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Не соромтеся, покажіться"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Надто темно. Знайдіть яскравіше світло"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Надто яскраво. Знайдіть м'якше світло"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Тримайте обличчя в колі"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Не рухайтеся"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Поверніться обличчям до світла"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Тримайте телефон на рівні очей"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Відсуньтеся трохи від камери"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Розташуйте обличчя по центру кадру"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Розмістіть обличчя в центрі кола"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Підійдіть ближче та тримайте обличчя прямо"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Увійдіть у кадр та тримайте обличчя прямо"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Занадто темно. Знайдіть яскравіше світло"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Занадто яскраво. Знайдіть оптимальне світло"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Відрегулюйте обличчя до центру кола"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Тримайтеся нерухомо та дивіться прямо"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Поверніться до світла та не рухайтеся"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Тримайте телефон на рівні очей"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Відійдіть трохи від камери"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Чудово!"
      },
      smile1: {
        icon: "mood",
        description: "Посміхніться, ви виглядаєте чудово!"
      },
      smile2: {
        icon: "mood",
        description: "Посміхніться для камери!"
      }
    },
    successful: {
      title: "Підтвердження завершено",
      text: "Ви можете закрити вікно зараз",
      finishBtn: "Завершити"
    },
    poweredBy: "Працює на",
    redirect: "Перенаправлення через",
    error: {
      message: "URL-адреса закінчилася або недійсна"
    },
    footer: {
      securedBy: "Працює на"
    },
    helpFaq: {
      title: "Допомога та часто задавані питання",
      subtitle: "Ми тут, щоб допомогти вам",
      cameraText: "Для підтвердження вашої особи нам потрібно зробити знімки за допомогою камери вашого пристрою. Щоб дізнатися, як надати необхідні дозволи, натисніть на link",
      cameraHeading: "Дозвіл на камеру",
      languageText: "На початку процесу ви можете вибрати свою мову, вибравши її з випадаючого меню в верхній панелі",
      languageHeading: "Вибір мови",
      kycText: "KYC, або 'Знай свого клієнта', це процес перевірки та підтвердження особи клієнта, що допомагає забезпечити відповідність вимогам та запобігти шахрайству та іншим незаконним діям",
      kycHeading: "Що таке KYC?",
      timeText: "Зазвичай це займає близько 60 секунд. Однак це може змінюватися в залежності від країни",
      timeHeading: "Скільки часу це займе?"
    },
    pdfPreviewUnavailable: "Не вдається показати попередній перегляд PDF.",
    pdfPreviewHint: "Якщо попередній перегляд не з'являється, ви все одно можете продовжити.",
    pdfOpenLabel: "Відкрити PDF",
    failedUpload: {
      title: "Не вдалося завантажити файл",
      text: "Переконайтеся, що файл менший за 5 МБ і має формат .jpg, .jpeg, .png, .heic, .heif або .pdf",
      btn: "Спробувати ще раз",
      pdfNotAllowedIndia: "Завантаження PDF не дозволено для Індії. Завантажте файли JPEG, JPG, PNG, HEIC або HEIF розміром менше 5 МБ.",
      pdfNotAllowedIndiaBasic: "Завантаження PDF не дозволено для Індії. Завантажте файли JPEG, JPG або PNG розміром менше 5 МБ."
    },
    livenessAnalyzing: {
      heading: "Аналіз вашого обличчя",
      subHeading: "Будь ласка, зачекайте, це займе лише кілька секунд"
    },
    sessionExpiredError: {
      heading: "Вибачте, час вашої сесії минув",
      subHeading1: "Ви були неактивні деякий час. З міркувань безпеки вашу сесію автоматично завершено",
      subHeading2: "Будь ласка, спробуйте ще раз",
      buttonText: "Спробувати ще раз"
    },
    journeyExpiredError: {
      heading: "Вибачте, термін дії посилання минув",
      subHeading1: "Посилання більше не активне. З міркувань безпеки посилання мають обмежений термін дії",
      subHeading2: "Будь ласка, спробуйте з новим посиланням",
      buttonText: "Спробувати ще раз"
    },
    cameraAccessError: {
      alert1: "Доступ до камери заборонено. Будь ласка, увімкніть доступ до камери в налаштуваннях браузера",
      alert2: "Сталася помилка під час доступу до камери",
      alert3: "Ваш браузер не підтримує доступ до камери"
    },
    activeLiveness: {
      instruction: "Тримайте обличчя в колі та дотримуйтесь інструкцій",
      permissionDeniedTitle: "Доступ до камери або мікрофона заборонено",
      permissionDeniedSubtitle: "Будь ласка, дозвольте доступ до камери та мікрофона в налаштуваннях браузера та спробуйте ще раз."
    },
    flipScreen: {
      heading: "Тепер переверніть своє посвідчення особи",
      subHeading: "Будь ласка, фізично переверніть своє посвідчення особи, щоб показати зворотний бік, а потім розмістіть його в рамці камери.",
      continueButton: "Продовжити"
    },
    mobileDocCapture: {
      frontSide: "Лицьова сторона",
      backSide: "Зворотна сторона",
      of: "документа",
      upload: "Завантажити",
      stillNotWorking: "Усе ще не працює?",
      clickToCapture: "Спробуйте зйомку кліком",
      skip: "Пропустити"
    }
,
    permissionPopUp: {
      title: "Потрібен дозвіл",
      subtitle: "Дозвольте доступ для використання камери",
      decline: "Відхилити",
      allow: "Дозволити"
    },
    userDetails: {
      heading: "Перевірка PAN",
      subHeading: "Будь ласка, заповніть дані для перевірки",
      panLabel: "Номер PAN",
      panRequired: "Будь ласка, введіть свій номер PAN",
      saveError: "Під час збереження даних сталася помилка. Будь ласка, спробуйте ще раз.",
      proceed: "Продовжити"
    },
    redirectCta: {
      or: "або",
      clickHere: "натисніть тут",
      clickHereStart: "Натисніть тут",
      toContinue: "щоб продовжити"
    },
    documentCapture: {
      stillNotWorking: "Усе ще не працює?",
      clickToCaptureInstead: "Спробуйте натомість захоплення кліком",
      pdfNotAllowedIndia: "Завантаження PDF не дозволено для Індії. Будь ласка, завантажте файли JPEG, JPG або PNG розміром менше 5 MB.",
      pdfNotAllowedIndiaMobile: "Завантаження PDF не дозволено для Індії. Будь ласка, завантажте файли JPEG, JPG, PNG, HEIC або HEIF розміром менше 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png менше 5 mb",
      fileFormats: "jpeg, jpg, png, pdf менше 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif менше 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf менше 5 mb"
    },
    mobileCapture: {
      upload: "Завантажити",
      skip: "Пропустити",
      stillNotWorking: "Все ще не працює?",
      tryClickToCapture: "Зніміть вручну"
    },
    UserDetails: {
      panLabel: "Номер PAN",
      proceedBtn: "Продовжити",
      panRequired: "Будь ласка, введіть номер PAN",
      saveError: "Під час збереження даних сталася помилка. Будь ласка, спробуйте ще раз."
    }
  },
  pa: {
    supportingDocument: {
      headingFallback: "ਸਹਾਇਕ ਦਸਤਾਵੇਜ਼",
      subHeading: "ਹੇਠਾਂ ਦਸਤਾਵੇਜ਼ ਅੱਪਲੋਡ ਕਰੋ। ਇਸਨੂੰ ਸਮੀਖਿਆ ਲਈ ਸੰਭਾਲਿਆ ਜਾਂਦਾ ਹੈ — ਇਸ ਵਿੱਚੋਂ ਕੁਝ ਨਹੀਂ ਕੱਢਿਆ ਜਾਂਦਾ।",
      choosePlaceholder: "ਇੱਕ ਫਾਈਲ ਚੁਣੋ (PNG, JPG ਜਾਂ PDF)",
      continue: "ਜਾਰੀ ਰੱਖੋ",
      uploading: "ਅੱਪਲੋਡ ਹੋ ਰਹੀ ਹੈ...",
      skip: "ਹੁਣ ਲਈ ਛੱਡੋ",
      errorInvalidType: "ਇੱਕ PNG, JPG ਜਾਂ PDF ਫਾਈਲ ਅੱਪਲੋਡ ਕਰੋ।",
      errorTooLarge: "ਫਾਈਲ ਬਹੁਤ ਵੱਡੀ ਹੈ। ਸੀਮਾ 10MB ਹੈ।",
      errorRead: "ਉਹ ਫਾਈਲ ਪੜ੍ਹੀ ਨਹੀਂ ਜਾ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਕੋਈ ਹੋਰ ਅਜ਼ਮਾਓ।",
      errorNoFile: "ਕਿਰਪਾ ਕਰਕੇ ਅੱਪਲੋਡ ਕਰਨ ਲਈ ਇੱਕ ਫਾਈਲ ਚੁਣੋ।",
    },
    header: {
      title: "ਆਓ ਆਪਣੀ ਪਹਿਚਾਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
      subtitle: "ਇਸ ਵਿੱਚ 2 ਮਿੰਟੋਂ ਘੱਟ ਸਮਾਂ ਲੱਗੇਗਾ",
      havingIssue: "ਕੋਈ ਸਮੱਸਿਆ ਹੈ?"
    },
    subHeading: {
      subHeading1: "ਆਪਣਾ ID ਦਸਤਾਵੇਜ਼ ਕੈਪਚਰ ਕਰੋ",
      subHeading2: "ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਤੁਸੀਂ ਜੀਵੰਤ ਹੋ",
      livenessHeading1: "ਚੰਗੀ ਰੋਸ਼ਨੀ ਵਾਲੀ ਜਗ੍ਹਾ ਲੱਭੋ",
      livenessHeading2: "ਆਪਣਾ ਚਿਹਰਾ ਵਿਚਕਾਰ ਰੱਖੋ"
    },
    onlyIdVerificationHeader: {
      title: "ਆਓ ਆਪਣੀ ਪਹਿਚਾਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰੀਏ",
      subtitle: "ਇਹ ਸਿਰਫ ਇੱਕ ਮਿੰਟ ਲਵੇਗਾ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਆਈ.ਡੀ. ਦਸਤਾਵੇਜ਼ ਤਿਆਰ ਰੱਖੋ।",
      instruction1: "ਕੈਮਰੇ ਦੀ ਪਹੁੰਚ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ",
      instruction2: "ਆਪਣਾ ਦਸਤਾਵੇਜ਼ ਸਕੈਨ ਜਾਂ ਅਪਲੋਡ ਕਰੋ",
      instruction3: "ਤੁਰੰਤ ਦਸਤਾਵੇਜ਼ ਦੀ ਪੁਸ਼ਟੀ"
    },
    termsAndCondition: {
      title: "ਮੈਂ ਨੀਚੇ ਦਿੱਤੀਆਂ ਸ਼ਰਤਾਂ ਅਤੇ ਨਿਯਮਾਂ ਨੂੰ ਮੰਨਣ ਅਤੇ ਪਾਲਣ ਕਰਨ ਲਈ ਸਹਿਮਤ ਹਾਂ।",
      privacyPolicy: "ਨਿਯਮ ਵੇਖੋ",
      beginBtnText: "ਸ਼ੁਰੂ ਕਰੋ",
      beginLiveness: "ਲਾਈਵਨੈਸ ਚੈੱਕ ਸ਼ੁਰੂ",
      startLiveness: "ਲਾਈਵਨੈਸ ਚੈੱਕ ਲਈ ਅੱਗੇ ਵਧੋ"
    },
    permissionDenied: {
      title: "ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ!",
      subtitle: "ਬ੍ਰਾਊਜ਼ਰ ਐਡਰੈੱਸ ਬਾਰ ਦੇ ਨੇੜੇ ਬਲੌਕ ਕੀਤੀ ਹੋਈ ਕੈਮਰੇ ਦੀ ਆਇਕਨ ਨੂੰ ਚੈੱਕ ਕਰੋ ਅਤੇ ਇਸਨੂੰ ਅਣਬਲੌਕ ਕਰੋ।",
      readMore: "ਹੋਰ ਪੜ੍ਹੋ",
      refreshText: "ਜਦੋਂ ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਮਿਲ ਜਾਵੇ, ਤਾਂ ਹੇਠਾਂ ਦਿੱਤੇ ਰਿਫਰੈਸ਼ ਬਟਨ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
      refreshBtn: "ਰਿਫਰੈਸ਼ ਕਰੋ",
      link: "ਜਾਂ, ਫੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
      buttonText: "ਜਾਂ, ਫੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ"
    },
    desktopBrowserPermissionDenied: {
      title: "ਕਿਰਪਾ ਕਰਕੇ ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਦਿਓ",
      subtitle: "ਬ੍ਰਾਊਜ਼ਰ ਸਹਿਮਤੀਆਂ ਲਈ ਪੁੱਛ ਸਕਦਾ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਅੱਗੇ ਵਧਣ ਲਈ 'ਆਗਿਆ ਦਿਓ' 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
      readMore: "ਹੋਰ ਪੜ੍ਹੋ",
      refreshText: "ਸਹਿਮਤੀਆਂ ਦੇਣ ਤੋਂ ਬਾਅਦ ਰਿਫਰੈਸ਼ ਕਰੋ",
      refreshBtn: "ਰਿਫਰੈਸ਼ ਕਰੋ",
      link: "ਜਾਂ, ਫੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
      buttonText: "ਜਾਂ, ਫੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ"
    },
    androidBrowserPermissionDenied: {
      title: "ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ!",
      subtitle: "ਬਰਾਊਜ਼ਰ ਦੇ ਐਡਰੈੱਸ ਬਾਰ ਦੇ ਕੋਲ ਕੈਮਰਾ ਆਈਕਨ ਨੂੰ ਚੈੱਕ ਕਰੋ ਜੋ ਕਿ ਸ਼ਾਇਦ ਬਲੌਕ ਕੀਤਾ ਗਿਆ ਹੋਵੇ, ਅਤੇ ਇਸਨੂੰ ਅਨਬਲੌਕ ਕਰੋ।",
      readMore: "ਹੋਰ ਜਾਣੋ",
      refreshText: "ਜਦੋਂ ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਮਿਲ ਜਾਵੇ, ਤਾਂ ਹੇਠਾਂ ਦਿੱਤੇ 'ਰੀਫ੍ਰੈਸ਼' ਬਟਨ ਨੂੰ ਕਲਿਕ ਕਰੋ।",
      refreshBtn: "ਰੀਫ੍ਰੈਸ਼ ਕਰੋ",
      link: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
      buttonText: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ"
    },
    androidWebViewPermissionDenied: {
      title: "ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ!",
      subtitle: "ਐਪ ਸੈਟਿੰਗਾਂ ਰਾਹੀਂ ਕੈਮਰਾ ਐਕਸੈਸ ਰੋਕਿਆ ਗਿਆ ਹੋ ਸਕਦਾ ਹੈ। ਆਪਣੇ ਫ਼ੋਨ ਦੀਆਂ App Info > Permissions > Camera ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਜਾ ਕੇ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਦਿਓ।",
      refreshText: "ਜਦੋਂ ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਮਿਲ ਜਾਵੇ, ਤਾਂ ਹੇਠਾਂ ਦਿੱਤੇ 'ਰੀਫ੍ਰੈਸ਼' ਬਟਨ ਨੂੰ ਕਲਿਕ ਕਰੋ।",
      refreshBtn: "ਰੀਫ੍ਰੈਸ਼ ਕਰੋ",
      link: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
      buttonText: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ"
    },
    iosBrowserPermissionDenied: {
      title: "ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ!",
      subtitle: "ਐਡਰੈੱਸ ਬਾਰ ਦੇ ਕੋਲ ਕੈਮਰਾ ਜਾਂ ਤਾਲਾ ਆਈਕਨ ਨੂੰ ਟੈਪ ਕਰੋ ਜਾਂ ਬਰਾਊਜ਼ਰ ਸੈਟਿੰਗਾਂ ਦੀ ਜਾਂਚ ਕਰੋ।",
      readMore: "ਹੋਰ ਜਾਣੋ",
      refreshText: "ਜਦੋਂ ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਮਿਲ ਜਾਵੇ, ਤਾਂ ਹੇਠਾਂ ਦਿੱਤੇ 'ਰੀਫ੍ਰੈਸ਼' ਬਟਨ ਨੂੰ ਕਲਿਕ ਕਰੋ।",
      refreshBtn: "ਰੀਫ੍ਰੈਸ਼ ਕਰੋ",
      link: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
      buttonText: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ"
    },
    iosWebViewPermissionDenied: {
      title: "ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ!",
      subtitle: "ਐਪ ਸੈਟਿੰਗਾਂ ਵਿੱਚੋਂ ਕੈਮਰਾ ਦੀ ਆਗਿਆ ਰੋਕੀ ਹੋਈ ਹੋ ਸਕਦੀ ਹੈ। Settings > ਆਪਣਾ ਐਪ ਖੋਲ੍ਹੋ > Camera Permission ਚਾਲੂ ਕਰੋ।",
      refreshText: "ਜਦੋਂ ਕੈਮਰਾ ਐਕਸੈਸ ਦੀ ਆਗਿਆ ਮਿਲ ਜਾਵੇ, ਤਾਂ ਹੇਠਾਂ ਦਿੱਤੇ 'ਰੀਫ੍ਰੈਸ਼' ਬਟਨ ਨੂੰ ਕਲਿਕ ਕਰੋ।",
      refreshBtn: "ਰੀਫ੍ਰੈਸ਼ ਕਰੋ",
      link: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
      buttonText: "ਜਾਂ, ਫ਼ੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ"
    },
    documentationList: {
      countryHeading: "ਦੇਸ਼ ਚੁਣੋ",
      docHeading: "ਆਪਣਾ ਦਸਤਾਵੇਜ਼ ਚੁਣੋ",
      btnText: "ਅਗਲਾ",
      searchCountry: "ਦੇਸ਼ ਖੋਜੋ"
    },
    frontDocCapture: {
      heading: "ID ਦਾ ਸਾਹਮਣਾ ਚੌਕੋਰ ਵਿੱਚ ਰੱਖੋ",
      backupHeading: "ਪਰੇਸ਼ਾਨੀ ਹੈ? ਕਿਰਪਾ ਕਰਕੇ ਚਿੱਤਰ ਨੂੰ ਹੱਥ ਨਾਲ ਕਲਿੱਕ ਕਰੋ",
      btnText: "ਫੋਟੋ ਕਲਿੱਕ ਕਰੋ",
      headingBack: " ਆਇਤ ਦੇ ਅੰਦਰ",
      uploadButton: "ਜਾਂ, ਆਈਡੀ ਅਪਲੋਡ ਕਰੋ"
    },
    backDocCapture: {
      heading: "ID ਦਾ ਪਿੱਛਲਾ ਪਾਸਾ ਚੌਕੋਰ ਵਿੱਚ ਰੱਖੋ",
      backupHeading: "ਪਰੇਸ਼ਾਨੀ ਹੈ? ਕਿਰਪਾ ਕਰਕੇ ਚਿੱਤਰ ਨੂੰ ਹੱਥ ਨਾਲ ਕਲਿੱਕ ਕਰੋ",
      btnText: "ਫੋਟੋ ਕਲਿੱਕ ਕਰੋ",
      containerText: "ਜਾਂ, ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਕਰੋ",
      text: "ਕੈਪਚਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਸਥਿਰ ਰਹੋ",
      headingBack: " ਆਇਤ ਦੇ ਅੰਦਰ",
      skipButton: "ਪਿਛਲਾ ਪਾਸਾ ਛੱਡੋ",
      uploadButton: "ਜਾਂ, ਆਈਡੀ ਅਪਲੋਡ ਕਰੋ"
    },
    analyzing: {
      heading: "ਤੁਹਾਡੀ ID ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
      subHeading: "ਕਿਰਪਾ ਕਰਕੇ ਅਗਲੇ ਸਕ੍ਰੀਨ 'ਤੇ ਆਪਣੇ ਕਾਰਡ ਦੇ ਵੇਰਵੇ ਜਾਂਚੋ ਅਤੇ ਜਰੂਰਤ ਪੈਣ 'ਤੇ ਸੋਧ ਕਰੋ"
    },
    imageCheck: {
      heading: "ਆਪਣਾ ਚਿੱਤਰ ਜਾਂਚੋ",
      subHeading: "ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਨਾਓ ਕਿ ਚਿੱਤਰ ਪੂਰਾ, ਸਾਫ਼ ਅਤੇ ਬਲਰ ਅਤੇ ਗਲੇਅਰ ਤੋਂ ਮੁਕਤ ਹੈ।",
      button1: "ਫੋਟੋ ਮੁੜ ਲਓ",
      button2: "ਠੀਕ ਹੈ",
      frontHeading: "ਸਮ੍ਹਣ ਚਿੱਤਰ ਜਾਂਚੋ",
      backHeading: "ਪਿੱਛੇ ਚਿੱਤਰ ਜਾਂਚੋ"
    },
    errorHandler: {
      heading: "ਓਹੋ :(",
      subHeading1: "ਅਸੀਂ ਕੁਝ ਸਮੱਸਿਆਵਾਂ ਦਾ ਸਾਹਮਣਾ ਕਰ ਰਹੇ ਹਾਂ, ਪਰ ਚਿੰਤਾ ਨਾ ਕਰੋ! ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      subHeading2: "ਜੇ ਇਹ ਜਾਰੀ ਰਹਿੰਦਾ ਹੈ, ਤਾਂ ਬਾਅਦ ਵਿੱਚ ਚੈੱਕ ਕਰੋ",
      button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਮੂੰਹ ਨੂੰ ਢੱਕ ਰਹੀ ਕਿਸੇ ਵੀ ਚੀਜ਼ ਨੂੰ ਹਟਾਓ",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      eyeClosureDetected: {
        heading: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀਆਂ ਅੱਖਾਂ ਖੁੱਲੀਆਂ ਰੱਖੋ ਅਤੇ ਸਿੱਧਾ ਕੈਮਰੇ ਵੱਲ ਦੇਖੋ",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      isMultipleFacesFound: {
        heading: "ਕਈ ਚਿਹਰੇ ਮਿਲੇ ਹਨ। ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਕੈਮਰੇ ਵਿੱਚ ਸਿਰਫ ਤੁਹਾਡਾ ਚਿਹਰਾ ਹੀ ਦਿਖਾਈ ਦੇ ਰਿਹਾ ਹੈ।",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      faceDetections: {
        heading: "ਕਿਰਪਾ ਕਰਕੇ ਇਸਨੂੰ ਹਟਾਓ",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "ਕਈ ਮੁਹਾਂ ਵੈਲੀਆਂ ਹਨ",
          button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
        },
        generalMessage: {
          heading: "ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਕੈਮਰੇ ਦੇ ਸਾਹਮਣੇ ਜ਼ਿੰਦਹ ਹੋ",
          button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
        }
      },
      faceMatch: {
        heading: "ਤੁਹਾਡੇ ਚਿਹਰੇ ਦੀ ਪਛਾਣ ID ਫੋਟੋ ਨਾਲ ਨਹੀਂ ਹੁੰਦੀ",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      selfieError: {
        heading: "ਅਸੀਂ ਤੁਹਾਡੀ ਸੈਲਫੀ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕਰ ਸਕੇ",
        subHeading1: "ਇਹ ਸਿਧਾਂਤਾਂ ਦੀ ਪਾਲਣਾ ਕਰੋ ਅਤੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
        instruction1: "ਚੰਗੀ ਰੋਸ਼ਨੀ ਵਾਲੇ ਸਥਾਨ ਵਿੱਚ ਜਾਓ ਅਤੇ ਬੈਕਲਾਈਟ ਤੋਂ ਬਚੋ",
        instruction2: "ਸੁਨਿਸ਼ਚਿਤ ਕਰੋ ਕਿ ਤੁਹਾਡਾ ਚਿਹਰਾ ਪੂਰੀ ਤਰ੍ਹਾਂ ਦਰਸ਼ਾਈ ਦੇ ਰਿਹਾ ਹੈ ਅਤੇ ਫ੍ਰੇਮ ਦੇ ਵਿਚਕਾਰ ਹੈ",
        instruction3: "ਤੁਹਾਡੇ ਚਿਹਰੇ ਨੂੰ ਸਾਫ਼ ਦਿਖਾਈ ਦੇਣ ਲਈ ਟੋਪੀ, ਚਸ਼ਮੇ ਜਾਂ ਮਾਸਕ ਨੂੰ ਹਟਾਓ",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ। ਕਿਰਪਾ ਕਰਕੇ OTP ਨੂੰ ਸਾਫ਼-ਸਾਫ਼ ਉੱਚੀ ਆਵਾਜ਼ ਵਿੱਚ ਪੜ੍ਹੋ",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      activeLivenessGenericFailureMessage: {
        heading: "ਤਸਦੀਕ ਅਸਫਲ ਰਹੀ। ਕਿਰਪਾ ਕਰਕੇ ਹਿਦਾਇਤਾਂ ਦੀ ਸਾਫ਼-ਸਾਫ਼ ਪਾਲਣਾ ਕਰੋ ਅਤੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
        button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF ਵਿੱਚ ਬਹੁਤ ਜ਼ਿਆਦਾ ਪੰਨੇ ਹਨ",
        subHeading: "ਅਪਲੋਡ ਕੀਤੀ PDF 2-ਪੰਨਿਆਂ ਦੀ ਸੀਮਾ ਤੋਂ ਵੱਧ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 2 ਤੋਂ ਵੱਧ ਪੰਨਿਆਂ ਵਾਲੀ PDF ਨਹੀਂ, ਜਾਂ ਆਪਣੀ ID ਦੀ ਸਪਸ਼ਟ ਤਸਵੀਰ ਅਪਲੋਡ ਕਰੋ।"
      },
      heading: "ਅਸੀਂ ਤੁਹਾਡੀ ID ਪ੍ਰਕਿਰਿਆ ਕਰਨ ਦੇ ਯੋਗ ਨਹੀਂ ਹਾਂ",
      subHeading: "ਤੁਸੀਂ ਗਲਤ ID ਅਪਲੋਡ ਕਰ ਰਹੇ ਹੋ ਜਾਂ ਚਿੱਤਰ ਸਾਫ਼ ਨਹੀਂ ਹੈ",
      buttonBack: "ID ਦਾ ਪਿੱਛਲਾ ਪਾਸਾ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      buttonFront: "ID ਦਾ ਸਾਹਮਣਾ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      button: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      captureFrontSide: "ਅਗਲਾ ਪਾਸਾ ਕੈਪਚਰ ਕਰੋ",
      captureBackSide: "ਪਿਛਲਾ ਪਾਸਾ ਕੈਪਚਰ ਕਰੋ",
      changeIDButton: "ਕੋਈ ਹੋਰ ਦਸਤਾਵੇਜ਼ ਚੁਣੋ",
      wrongid: {
        heading: "ਅਸੀਂ ਇਸ ਦਸਤਾਵੇਜ਼ ਨੂੰ ਪ੍ਰੋਸੈਸ ਨਹੀਂ ਕਰ ਸਕੇ",
        subHeading: "ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਸਹੀ ਦਸਤਾਵੇਜ਼ ਅੱਪਲੋਡ ਕਰ ਰਹੇ ਹੋ ਅਤੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤਸਵੀਰ ਦੀ ਗੁਣਵੱਤਾ ਸਾਫ਼ ਹੈ"
      },
      expiredid: {
        heading: "ID ਦਸਤਾਵੇਜ਼ ਦੀ ਮਿਆਦ ਪੁੱਗ ਗਈ!",
        subHeading: "ਅਸੀਂ ਮਿਆਦ ਪੁੱਗੇ ID ਦਸਤਾਵੇਜ਼ ਨੂੰ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਸਕਦੇ। ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਦਸਤਾਵੇਜ਼ ਦਿਓ"
      },
      minimumage: {
        heading: "ਉਮਰ ਦੀ ਲੋੜ ਪੂਰੀ ਨਹੀਂ ਹੋਈ!",
        subHeading: "ਤੁਹਾਡੀ ਉਮਰ ਘੱਟੋ-ਘੱਟ ਲੋੜੀਂਦੀ ਉਮਰ ਤੋਂ ਘੱਟ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਘੱਟੋ-ਘੱਟ ਉਮਰ ਮਾਪਦੰਡ ਪੂਰਾ ਕਰਦੇ ਹੋ"
      },
      mobileAttemptsDone: {
        heading: "ਤੁਹਾਡੇ ਪਿਛਲੇ ਡਿਵਾਈਸ 'ਤੇ ਯਾਤਰਾ ਮੁੜ ਸ਼ੁਰੂ ਹੋਈ",
        subHeading: "ਨਕਲ ਤੋਂ ਬਚਣ ਲਈ ਇਹ ਸੈਸ਼ਨ ਹੁਣ ਬੰਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ।"
      },
      finished: {
        heading: "ਯਾਤਰਾ ਖਤਮ ਹੋ ਗਈ ਹੈ",
        subHeading: "ਯਾਤਰਾ ਜਾਂ ਤਾਂ ਪੂਰੀ ਹੋ ਗਈ ਹੈ ਜਾਂ ਖਤਮ ਕਰ ਦਿੱਤੀ ਗਈ ਹੈ"
      },
      invalid: {
        heading: "ਯਾਤਰਾ ਉਪਲਬਧ ਨਹੀਂ !",
        subHeading: "ਕੋਈ journeyId ਨਹੀਂ ਮਿਲਿਆ ਜਾਂ ਯਾਤਰਾ ID ਅਵੈਧ ਹੈ"
      },
      INVALID_PAN_NUMBER: {
        heading: "ਅਵੈਧ PAN ਨੰਬਰ",
        subHeading: "ਤੁਹਾਡੇ ਵੱਲੋਂ ਦਾਖਲ ਕੀਤਾ PAN ਨੰਬਰ ਵੈਧ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਜਾਂਚੋ ਅਤੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      INVALID_PAN_STATUS: {
        heading: "ਅਵੈਧ PAN ਸਥਿਤੀ",
        subHeading: "ਤੁਹਾਡੇ ਵੱਲੋਂ ਦਾਖਲ ਕੀਤਾ PAN ਨੰਬਰ ਵੈਧ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਜਾਂਚੋ ਅਤੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      directKyc: {
        heading: "ਸਿੱਧੀ KYC ਯਾਤਰਾ !",
        subHeading: "ਇਹ ਇੱਕ ਸਿੱਧੀ KYC ਯਾਤਰਾ ਹੈ। ਫਰੰਟਐਂਡ ਯਾਤਰਾ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ।"
      },
      DOCTYPE_FALSE: {
        heading: "ਗਲਤ ਦਸਤਾਵੇਜ਼ ਦਿੱਤਾ ਗਿਆ!",
        subHeading: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਦਸਤਾਵੇਜ਼ ਅੱਪਲੋਡ ਕਰੋ ਅਤੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਚਿੱਤਰ ਦੀ ਗੁਣਵੱਤਾ ਚੰਗੀ ਹੈ।"
      },
      ONLY_FRONT: {
        heading: "ID ਦਾ ਪਿਛਲਾ ਪਾਸਾ ਗਾਇਬ ਹੈ",
        subHeading: "ਤੁਸੀਂ ਸਿਰਫ਼ ਅਗਲਾ ਪਾਸਾ ਦਿੱਤਾ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ID ਪਲਟੋ ਅਤੇ ਜਾਰੀ ਰੱਖਣ ਲਈ ਪਿਛਲਾ ਪਾਸਾ ਦਿਓ"
      },
      ONLY_BACK: {
        heading: "ID ਦਾ ਅਗਲਾ ਪਾਸਾ ਗਾਇਬ ਹੈ",
        subHeading: "ਤੁਸੀਂ ਸਿਰਫ਼ ਪਿਛਲਾ ਪਾਸਾ ਦਿੱਤਾ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ID ਪਲਟੋ ਅਤੇ ਜਾਰੀ ਰੱਖਣ ਲਈ ਅਗਲਾ ਪਾਸਾ ਦਿਓ"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "ਦਸਤਾਵੇਜ਼ ਜਲਦੀ ਮਿਆਦ ਪੁੱਗ ਰਿਹਾ ਹੈ",
        subHeading: "ਦਸਤਾਵੇਜ਼ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਕਿਉਂਕਿ ਇਹ ਜਲਦੀ ਮਿਆਦ ਪੁੱਗ ਜਾਵੇਗਾ।"
      },
      DOCUMENT_EXPIRED: {
        heading: "ਦਸਤਾਵੇਜ਼ ਦੀ ਮਿਆਦ ਪੁੱਗ ਗਈ!",
        subHeading: "ਕਿਰਪਾ ਕਰਕੇ ਜਾਰੀ ਰੱਖਣ ਲਈ ਇੱਕ ਵੈਧ, ਮਿਆਦ ਨਾ ਪੁੱਗੀ ਦਸਤਾਵੇਜ਼ ਅੱਪਲੋਡ ਕਰੋ।"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "ਉਮਰ ਦੀ ਲੋੜ ਪੂਰੀ ਨਹੀਂ ਹੋਈ!",
        subHeading: "ਦਸਤਾਵੇਜ਼ ਦਰਸਾਉਂਦਾ ਹੈ ਕਿ ਤੁਸੀਂ ਲੋੜੀਂਦੀ ਉਮਰ ਪੂਰੀ ਨਹੀਂ ਕਰਦੇ। ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਦਸਤਾਵੇਜ਼ ਅੱਪਲੋਡ ਕਰੋ।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ਦਸਤਾਵੇਜ਼ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ!",
        subHeading: "ਪੁਸ਼ਟੀ ਲਈ ਚਿੱਤਰ ਦੀ ਗੁਣਵੱਤਾ ਬਹੁਤ ਮਾੜੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਫ਼ ਚਿੱਤਰ ਨਾਲ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "ਦਸਤਾਵੇਜ਼ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ!",
        subHeading: "ਕੁਝ ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਫ਼ ਚਿੱਤਰ ਨਾਲ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ਦਸਤਾਵੇਜ਼ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ!",
        subHeading: "ਮਾੜੀ ਚਿੱਤਰ ਗੁਣਵੱਤਾ ਕਾਰਨ ਕੁਝ ਵੇਰਵੇ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੇ ਜਾ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਫ਼ ਚਿੱਤਰ ਨਾਲ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "ਦਸਤਾਵੇਜ਼ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ!",
        subHeading: "ਕੁਝ ਵੇਰਵੇ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੇ ਜਾ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਫ਼ ਚਿੱਤਰ ਨਾਲ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "ID 'ਤੇ ਤੁਹਾਡੀ ਫੋਟੋ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਸਮੱਸਿਆ",
        subHeading: "ਅਸੀਂ ID ਕਾਰਡ 'ਤੇ ਤੁਹਾਡੀ ਫੋਟੋ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕਰ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਅਸਲੀ ID ਦੀ ਸਾਫ਼ ਫੋਟੋ ਅੱਪਲੋਡ ਕਰੋ ਤਾਂ ਜੋ ਅਸੀਂ ਇਸਦੀ ਪੁਸ਼ਟੀ ਕਰ ਸਕੀਏ।"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "ਦਸਤਾਵੇਜ਼ ਸੁਰੱਖਿਆ ਪੈਟਰਨ ਜਾਂਚ ਅਸਫਲ",
        subHeading: "ਅਸੀਂ ਦਸਤਾਵੇਜ਼ ਦੇ ਬਿਲਟ-ਇਨ ਸੁਰੱਖਿਆ ਪੈਟਰਨਾਂ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕਰ ਸਕੇ। ਇਸਦੀ ਪ੍ਰਮਾਣਿਕਤਾ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਸਾਡੀ ਮਦਦ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਅਸਲੀ ID ਦੀ ਸਾਫ਼ ਫੋਟੋ ਅੱਪਲੋਡ ਕਰੋ।"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "ਦਸਤਾਵੇਜ਼ ਜੀਵੰਤਤਾ ਜਾਂਚ ਅਸਫਲ",
        subHeading: "ਸਾਨੂੰ ਸੰਕੇਤ ਮਿਲੇ ਕਿ ਦਸਤਾਵੇਜ਼ ਅਸਲੀ ਨਹੀਂ ਹੋ ਸਕਦਾ। ਕਿਰਪਾ ਕਰਕੇ ਸਕ੍ਰੀਨਸ਼ਾਟ, ਛਾਪੀਆਂ ਕਾਪੀਆਂ, ਜਾਂ ਸਕ੍ਰੀਨ 'ਤੇ ID ਦਿਖਾਉਣ ਤੋਂ ਬਚੋ। ਸਾਰੀਆਂ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਸਾਫ਼ ਦਿਖਾਈ ਦੇਣ ਵਾਲਾ ਅਸਲੀ ID ਅੱਪਲੋਡ ਕਰੋ"
      },
      SECURITY_FALSE: {
        heading: "ਸਮੱਸਿਆ ਪਾਈ ਗਈ!",
        subHeading: "ਦਸਤਾਵੇਜ਼ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਫ਼ ਚਿੱਤਰ ਨਾਲ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "ਮਾੜੀ ਚਿੱਤਰ ਗੁਣਵੱਤਾ!",
        subHeading: "ਚਿੱਤਰ ਬਹੁਤ ਧੁੰਦਲਾ ਜਾਂ ਅਸਪਸ਼ਟ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਫ਼ ਚਿੱਤਰ ਨਾਲ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
      },
      FACE_UNDETECTED: {
        heading: "ਚਿਹਰਾ ਨਹੀਂ ਪਛਾਣਿਆ ਗਿਆ",
        subHeading: "ਅਸੀਂ ਦਸਤਾਵੇਜ਼ 'ਤੇ ਦਿਖਾਈ ਦੇਣ ਵਾਲਾ ਚਿਹਰਾ ਨਹੀਂ ਲੱਭ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ID ਅੱਪਲੋਡ ਕਰੋ ਜਿੱਥੇ ਚਿਹਰਾ ਸਾਫ਼ ਦਿਖਾਈ ਦਿੰਦਾ ਹੈ"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "ਦਸਤਾਵੇਜ਼ਾਂ ਵਿਚਕਾਰ ਤੁਲਨਾ ਅਸਫਲ",
        subHeading: "ਇੱਕ ਜਾਂ ਵੱਧ ਮੁੱਖ ਖੇਤਰਾਂ (ਨਾਮ, ਜਨਮ ਮਿਤੀ, ਜਾਂ ਚਿਹਰਾ) ਵਿੱਚ ਮੇਲ ਨਾ ਖਾਣ ਕਾਰਨ ਦਸਤਾਵੇਜ਼ਾਂ ਵਿਚਕਾਰ ਤੁਲਨਾ ਅਸਫਲ ਹੋ ਗਈ"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker ਅਸਫਲਤਾ",
        subHeading: "Digilocker ਯਾਤਰਾ ਦੌਰਾਨ ਇੱਕ ਗਲਤੀ ਆਈ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਜਾਰੀ ਰੱਖਣ ਲਈ ਕੋਈ ਬਦਲਵਾਂ ਤਰੀਕਾ ਵਰਤੋ।"
      },
      LINKAGE_FAILED: {
        heading: "ਇਹ ਤਸਦੀਕ ਪੂਰੀ ਨਹੀਂ ਹੋ ਸਕੀ",
        subHeading: "ਇਸ ਜਾਂਚ ਲਈ ਲਏ ਗਏ ਵੇਰਵੇ ਰਿਕਾਰਡਾਂ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦੇ।"
      }
    },
    biometricConsent: {
      consentStatement: "ਤੁਹਾਡੀ ਸੈਲਫੀ ਤੋਂ ਪਹਿਲਾਂ, ਤੁਹਾਡੀ ਪਛਾਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਸਾਨੂੰ ਤੁਹਾਡਾ ਬਾਇਓਮੈਟ੍ਰਿਕ ਡਾਟਾ (ਚਿਹਰੇ ਦੀ ਤਸਵੀਰ ਅਤੇ ਲਾਈਵਨੈੱਸ ਸਿਗਨਲ) ਕੈਪਚਰ ਅਤੇ ਪ੍ਰੋਸੈਸ ਕਰਨ ਲਈ ਤੁਹਾਡੀ ਸਹਿਮਤੀ ਚਾਹੀਦੀ ਹੈ। ਇਹ ਡਾਟਾ ਸਿਰਫ਼ ਇਸੇ ਪੁਸ਼ਟੀ ਲਈ ਵਰਤਿਆ ਜਾਂਦਾ ਹੈ।",
      privacyPolicy: "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
      consentButton: "ਮੈਂ ਸਹਿਮਤ ਹਾਂ — ਜਾਰੀ ਰੱਖੋ",
      declineButton: "ਮੈਂ ਸਹਿਮਤ ਨਹੀਂ ਹਾਂ",
      confirmTitle: "ਬਾਇਓਮੈਟ੍ਰਿਕ ਪੁਸ਼ਟੀ ਤੋਂ ਬਿਨਾਂ ਅੱਗੇ ਵਧਣਾ ਹੈ?",
      confirmBody: "ਬਾਇਓਮੈਟ੍ਰਿਕ ਪੁਸ਼ਟੀ ਤੋਂ ਬਿਨਾਂ, ਅਸੀਂ ਸੈਲਫੀ ਨਹੀਂ ਲਵਾਂਗੇ। ਤੁਹਾਡੀ ਪੁਸ਼ਟੀ ਤੁਹਾਡੇ ਵੱਲੋਂ ਪਹਿਲਾਂ ਦਿੱਤੀ ਜਾਣਕਾਰੀ ਵਰਤ ਕੇ ਪੂਰੀ ਕੀਤੀ ਜਾਵੇਗੀ। ਇਹ ਚੋਣ ਇਸ ਸੈਸ਼ਨ ਲਈ ਅੰਤਿਮ ਹੈ।",
      goBack: "ਵਾਪਸ",
      confirmDecline: "ਪੁਸ਼ਟੀ ਕਰੋ — ਸਹਿਮਤ ਨਹੀਂ",
      declineComplete: "ਤੁਸੀਂ ਬਾਇਓਮੈਟ੍ਰਿਕ ਪੁਸ਼ਟੀ ਨਾਲ ਅੱਗੇ ਨਾ ਵਧਣ ਦੀ ਚੋਣ ਕੀਤੀ ਹੈ। ਤੁਹਾਡੇ ਵੱਲੋਂ ਜਮ੍ਹਾਂ ਕੀਤੇ ਦਸਤਾਵੇਜ਼ ਵਰਤ ਕੇ ਤੁਹਾਡੀ ਪਛਾਣ ਦੀ ਪੁਸ਼ਟੀ ਪੂਰੀ ਹੋ ਗਈ ਹੈ।"
    },
    introLiveness: {
      heading: "ਇੱਥੇ ਆਪਣੇ ਜੀਵੰਤ ਹੋਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
      instruction1: "ਸੁਨਿਸ਼ਚਿਤ ਕਰੋ ਕਿ ਪ੍ਰਕਾਸ਼ ਕਾਫ਼ੀ ਹੈ",
      instruction2: "ਜਰੂਰੀ ਸਹਿਮਤੀਆਂ ਦਿਓ",
      instruction3: "ਸਿਰਫ ਹਦਾਇਤਾਂ ਦੀ ਪਾਲਣਾ ਕਰੋ",
      button: "ਅੱਗੇ ਵਧੋ",
      subHeading: "ਤੁਸੀਂ ਬੱਸ ਇੱਕ ਕਦਮ ਦੂਰ ਹੋ"
    },
    phoneSession: {
      heading: "ਫੋਨ 'ਤੇ ਸੈਸ਼ਨ ਜਾਰੀ ਹੈ",
      subheading: "ਮੋਬਾਈਲ 'ਤੇ ਖਤਮ ਹੋਣ ਤੱਕ ਇਸ ਵਿੰਡੋ ਨੂੰ ਖੁੱਲ੍ਹਾ ਰੱਖੋ",
      button: "ਇੱਥੇ ਜਾਰੀ ਰੱਖੋ"
    },
    continueOnPhone: {
      heading: "ਫੋਨ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
      subheading: "QR ਸਕੈਨ ਕਰੋ ਜਾਂ ਹੇਠਾਂ ਦਿੱਤੇ ਲਿੰਕ ਨੂੰ ਕਾਪੀ ਕਰੋ",
      subheading2: "QR ਸਕੈਨ ਕਰੋ ਜਾਂ ਆਪਣੇ ਫੋਨ 'ਤੇ ਲਿੰਕ ਖੋਲ੍ਹੋ",
      text: "ਪਰਕਿਰਿਆ ਪੂਰੀ ਕਰੋ",
      text1: "ਸਬਮਿਟ ਕਰਨ ਲਈ ਇੱਥੇ ਚੈੱਕ ਕਰੋ",
      button: "ਕਾਪੀ ਕਰੋ",
      copiedButton: "ਕਾਪੀ ਹੋ ਗਿਆ!",
      copied: "ਕਾਪੀ ਹੋ ਗਿਆ!"
    },
    SsnReview: {
      heading: "ਆਪਣੇ ਵੇਰਵੇ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
      subHeading: "ਆਵਸ਼੍ਯਕ ਬਦਲਾਵ ਕਰੋ ਅਤੇ ਵੇਰਵੇ ਸਬਮਿਟ ਕਰੋ",
      feild1: "ਡਰਾਈਵਿੰਗ ਲਾਈਸੈਂਸ",
      feild2: "ਮਿਆਦ ਦੀ ਮਿਆਦ",
      feild3: "ਜਨਮ ਮਿਤੀ",
      feild4: "ਕਲਾਸ",
      feild5: "ਪਾਬੰਦੀਆਂ",
      feild6: "ਦੇਸ਼",
      feild7: "ਪਤਾ",
      button: "ਵੇਰਵੇ ਠੀਕ ਹਨ"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "ਆਪਣਾ ਚਿਹਰਾ ਚੱਕਰ ਵਿੱਚ ਰੱਖੋ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ਕੈਮਰੇ ਦੇ ਨੇੜੇ ਆਓ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ਸ਼ਰਮਾਓ ਨਾ, ਸਾਹਮਣੇ ਆਓ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ਬਹੁਤ ਹਨੇਰਾ ਹੈ। ਵੱਧ ਰੋਸ਼ਨੀ ਵਿੱਚ ਜਾਓ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ਬਹੁਤ ਰੋਸ਼ਨੀ ਹੈ। ਹਲਕੀ ਰੋਸ਼ਨੀ ਵਿੱਚ ਜਾਓ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ਆਪਣਾ ਚਿਹਰਾ ਚੱਕਰ ਵਿੱਚ ਰੱਖੋ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ਸਥਿਰ ਰਹੋ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ਚਿਹਰਾ ਰੋਸ਼ਨੀ ਵੱਲ ਕਰੋ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ਫੋਨ ਨੂੰ ਅੱਖਾਂ ਦੇ ਪੱਧਰ 'ਤੇ ਰੱਖੋ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ਕੈਮਰੇ ਤੋਂ ਥੋੜ੍ਹਾ ਦੂਰ ਹੋਵੋ"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ਆਪਣਾ ਚਿਹਰਾ ਫ੍ਰੇਮ ਦੇ ਵਿਚਕਾਰ ਰੱਖੋ"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "ਆਪਣਾ ਚਿਹਰਾ ਗੋਲੇ ਦੇ ਵਿਚਕਾਰ ਰੱਖੋ"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "ਨੇੜੇ ਆਓ ਅਤੇ ਆਪਣਾ ਚਿਹਰਾ ਸਿੱਧਾ ਰੱਖੋ"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ਨਜ਼ਰ ਵਿੱਚ ਆਓ ਅਤੇ ਆਪਣਾ ਚਿਹਰਾ ਸਿੱਧਾ ਰੱਖੋ"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ਬਹੁਤ ਘੱਟ ਰੋਸ਼ਨੀ। ਬਰਾਈਟਰ ਲਾਈਟ ਲੱਭੋ"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ਬਹੁਤ ਤੇਜ਼। ਵਧੀਆ ਰੋਸ਼ਨੀ ਲੱਭੋ"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ਆਪਣੇ ਚਿਹਰੇ ਨੂੰ ਗੋਲੇ ਦੇ ਵਿਚਕਾਰ ਐਡਜਸਟ ਕਰੋ"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ਸਥਿਰ ਰਹੋ ਅਤੇ ਸਿੱਧੇ ਅੱਗੇ ਦੇਖੋ"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "ਰੌਸ਼ਨੀ ਵੱਲ ਮੂੰਹ ਕਰੋ ਅਤੇ ਸਥਿਰ ਰਹੋ"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "ਆਪਣੇ ਫੋਨ ਨੂੰ ਅੱਖਾਂ ਦੇ ਸਥਰ 'ਤੇ ਰੱਖੋ"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ਕੈਮਰੇ ਤੋਂ ਕੁਝ ਦੂਰ ਜਾਓ"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "ਬਿਲਕੁਲ ਠੀਕ!"
      },
      smile1: {
        icon: "mood",
        description: "ਮੁਸਕਰਾਓ, ਤੁਸੀਂ ਬਹੁਤ ਚੰਗੇ ਲੱਗ ਰਹੇ ਹੋ!"
      },
      smile2: {
        icon: "mood",
        description: "ਕੈਮਰੇ ਲਈ ਮੁਸਕਰਾਓ!"
      }
    },
    successful: {
      title: "ਪੁਸ਼ਟੀ ਪੂਰੀ",
      text: "ਤੁਸੀਂ ਹੁਣ ਵਿੰਡੋ ਬੰਦ ਕਰ ਸਕਦੇ ਹੋ",
      finishBtn: "ਖਤਮ ਕਰੋ"
    },
    poweredBy: "ਦੁਆਰਾ ਚਲਾਇਆ ਗਿਆ",
    redirect: "ਵਿੱਚ ਰੀਡਾਇਰੈਕਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
    error: {
      message: "URL ਦੀ ਮਿਆਦ ਸਮਾਪਤ ਹੋ ਗਈ ਹੈ ਜਾਂ ਅਮਾਨਯ ਹੈ"
    },
    footer: {
      securedBy: "ਦੁਆਰਾ ਚਲਾਇਆ ਗਿਆ"
    },
    helpFaq: {
      title: "ਸਹਾਇਤਾ ਅਤੇ ਆਮ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ",
      subtitle: "ਅਸੀਂ ਤੁਹਾਡੀ ਸਹਾਇਤਾ ਲਈ ਇੱਥੇ ਹਾਂ",
      cameraText: "ਤੁਹਾਡੀ ਪਹਿਚਾਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ, ਸਾਨੂੰ ਤੁਹ Device ਦੀ ਕੈਮਰੇ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਤਸਵੀਰ ਲੈਣੀ ਪਏਗੀ। ਲੋੜੀਂਦੀ ਅਨੁਮਤੀਆਂ ਦੇਣ ਲਈ ਕਿਵੇਂ ਸਿੱਖਣ ਲਈ link 'ਤੇ ਕਲਿੱਕ ਕਰੋ",
      cameraHeading: "ਕੈਮਰਾ ਅਨੁਮਤੀ",
      languageText: "ਪ੍ਰਕਿਰਿਆ ਦੀ ਸ਼ੁਰੂਆਤ 'ਤੇ, ਤੁਸੀਂ ਉਪਰਲੇ ਬਾਰ ਵਿੱਚ ਡ੍ਰੌਪਡਾਊਨ ਮੇਨੂ ਤੋਂ ਆਪਣੀ ਪਸੰਦ ਦੀ ਭਾਸ਼ਾ ਚੁਣ ਸਕਦੇ ਹੋ",
      languageHeading: "ਭਾਸ਼ਾ ਚੋਣ",
      kycText: "KYC, ਜਾਂ 'ਆਪਣੇ ਗਾਹਕ ਨੂੰ ਜਾਣੋ', ਇੱਕ ਪ੍ਰਕਿਰਿਆ ਹੈ ਜੋ ਗਾਹਕ ਦੀ ਪਹਿਚਾਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦੀ ਹੈ, ਜਿਸ ਨਾਲ ਅਨੁਕੂਲਤਾ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਣ ਅਤੇ ਧੋਖਾਧੜੀ ਅਤੇ ਹੋਰ ਗੈਰਕਾਨੂੰਨੀ ਗਤੀਵਿਧੀਆਂ ਤੋਂ ਬਚਾਉਂਦੀਆਂ ਹਨ",
      kycHeading: "KYC ਦਾ ਕੀ ਅਰਥ ਹੈ?",
      timeText: "ਆਮ ਤੌਰ 'ਤੇ, ਇਸਨੂੰ ਲੱਗਭਗ 60 ਸਕਿੰਟ ਲੱਗਦੇ ਹਨ। ਹਾਲਾਂਕਿ, ਇਹ ਦੇਸ਼ ਦੇ ਅਨੁਸਾਰ ਬਦਲ ਸਕਦਾ ਹੈ",
      timeHeading: "ਇਸਨੂੰ ਕਿੰਨਾ ਸਮਾਂ ਲੱਗੇਗਾ?"
    },
    pdfPreviewUnavailable: "PDF ਲਈ ਝਲਕ ਦਿਖਾਉਣ ਵਿੱਚ ਅਸਮਰੱਥ।",
    pdfPreviewHint: "ਜੇ ਝਲਕ ਨਹੀਂ ਦਿਖਦੀ, ਤਾਂ ਵੀ ਤੁਸੀਂ ਜਾਰੀ ਰੱਖ ਸਕਦੇ ਹੋ।",
    pdfOpenLabel: "PDF ਖੋਲ੍ਹੋ",
    failedUpload: {
      title: "ਫਾਈਲ ਅੱਪਲੋਡ ਅਸਫਲ",
      text: "ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਫਾਈਲ 5MB ਤੋਂ ਘੱਟ ਅਤੇ .jpg, .jpeg, .png, .heic, .heif, ਜਾਂ .pdf ਫਾਰਮੈਟ ਵਿੱਚ ਹੈ",
      btn: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      pdfNotAllowedIndia: "ਭਾਰਤ ਲਈ PDF ਅਪਲੋਡ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 5 MB ਤੋਂ ਘੱਟ ਦੀਆਂ JPEG, JPG, PNG, HEIC, ਜਾਂ HEIF ਫਾਈਲਾਂ ਅਪਲੋਡ ਕਰੋ।",
      pdfNotAllowedIndiaBasic: "ਭਾਰਤ ਲਈ PDF ਅਪਲੋਡ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 5 MB ਤੋਂ ਘੱਟ ਦੀਆਂ JPEG, JPG, ਜਾਂ PNG ਫਾਈਲਾਂ ਅਪਲੋਡ ਕਰੋ।"
    },
    livenessAnalyzing: {
      heading: "ਤੁਹਾਡੇ ਚਿਹਰੇ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
      subHeading: "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ, ਇਸ ਵਿੱਚ ਸਿਰਫ਼ ਕੁਝ ਸਕਿੰਟ ਲੱਗਣਗੇ"
    },
    sessionExpiredError: {
      heading: "ਮਾਫ਼ ਕਰਨਾ, ਤੁਹਾਡਾ ਸੈਸ਼ਨ ਸਮਾਂ ਸਮਾਪਤ ਹੋ ਗਿਆ",
      subHeading1: "ਤੁਸੀਂ ਕੁਝ ਸਮੇਂ ਤੋਂ ਨਿਸ਼ਕਿਰਿਆ ਸੀ। ਸੁਰੱਖਿਆ ਕਾਰਨਾਂ ਕਰਕੇ, ਤੁਹਾਡਾ ਸੈਸ਼ਨ ਆਪਣੇ ਆਪ ਸਮਾਪਤ ਹੋ ਗਿਆ",
      subHeading2: "ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      buttonText: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
    },
    journeyExpiredError: {
      heading: "ਮਾਫ਼ ਕਰਨਾ, ਲਿੰਕ ਦੀ ਮਿਆਦ ਪੁੱਗ ਗਈ",
      subHeading1: "ਲਿੰਕ ਹੁਣ ਸਰਗਰਮ ਨਹੀਂ ਹੈ। ਸੁਰੱਖਿਆ ਕਾਰਨਾਂ ਕਰਕੇ, ਲਿੰਕਾਂ ਦੀ ਸੀਮਿਤ ਮਿਆਦ ਹੁੰਦੀ ਹੈ",
      subHeading2: "ਕਿਰਪਾ ਕਰਕੇ ਨਵੇਂ ਲਿੰਕ ਨਾਲ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      buttonText: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
    },
    cameraAccessError: {
      alert1: "ਕੈਮਰਾ ਪਹੁੰਚ ਤੋਂ ਇਨਕਾਰ ਕੀਤਾ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀਆਂ ਬ੍ਰਾਊਜ਼ਰ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਕੈਮਰਾ ਪਹੁੰਚ ਨੂੰ ਸਮਰੱਥ ਕਰੋ",
      alert2: "ਕੈਮਰਾ ਪਹੁੰਚ ਕਰਦੇ ਸਮੇਂ ਇੱਕ ਗਲਤੀ ਆਈ",
      alert3: "ਤੁਹਾਡਾ ਬ੍ਰਾਊਜ਼ਰ ਕੈਮਰਾ ਪਹੁੰਚ ਦਾ ਸਮਰਥਨ ਨਹੀਂ ਕਰਦਾ"
    },
    activeLiveness: {
      instruction: "ਆਪਣਾ ਚਿਹਰਾ ਚੱਕਰ ਵਿੱਚ ਰੱਖੋ ਅਤੇ ਹਿਦਾਇਤਾਂ ਦੀ ਪਾਲਣਾ ਕਰੋ",
      permissionDeniedTitle: "ਕੈਮਰਾ ਜਾਂ ਮਾਈਕ੍ਰੋਫੋਨ ਪਹੁੰਚ ਤੋਂ ਇਨਕਾਰ ਕੀਤਾ ਗਿਆ",
      permissionDeniedSubtitle: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀਆਂ ਬ੍ਰਾਊਜ਼ਰ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਕੈਮਰਾ ਅਤੇ ਮਾਈਕ੍ਰੋਫੋਨ ਪਹੁੰਚ ਦੀ ਆਗਿਆ ਦਿਓ ਅਤੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
    },
    flipScreen: {
      heading: "ਹੁਣ ਆਪਣਾ ਆਈਡੀ ਕਾਰਡ ਪਲਟੋ",
      subHeading: "ਕਿਰਪਾ ਕਰਕੇ ਪਿਛਲਾ ਪਾਸਾ ਦਿਖਾਉਣ ਲਈ ਆਪਣਾ ਆਈਡੀ ਕਾਰਡ ਸਰੀਰਕ ਤੌਰ 'ਤੇ ਪਲਟੋ, ਫਿਰ ਇਸਨੂੰ ਕੈਮਰਾ ਫਰੇਮ ਵਿੱਚ ਰੱਖੋ।",
      continueButton: "ਜਾਰੀ ਰੱਖੋ"
    },
    mobileDocCapture: {
      frontSide: "ਅਗਲਾ ਪਾਸਾ",
      backSide: "ਪਿਛਲਾ ਪਾਸਾ",
      of: "ਦਾ",
      upload: "ਅੱਪਲੋਡ ਕਰੋ",
      stillNotWorking: "ਹਾਲੇ ਵੀ ਕੰਮ ਨਹੀਂ ਕਰ ਰਿਹਾ?",
      clickToCapture: "ਕਲਿੱਕ-ਟੂ-ਕੈਪਚਰ ਅਜ਼ਮਾਓ",
      skip: "ਛੱਡੋ"
    }
,
    permissionPopUp: {
      title: "ਅਨੁਮਤੀ ਲੋੜੀਂਦੀ ਹੈ",
      subtitle: "ਕੈਮਰਾ ਵਰਤਣ ਲਈ ਪਹੁੰਚ ਦੀ ਆਗਿਆ ਦਿਓ",
      decline: "ਇਨਕਾਰ ਕਰੋ",
      allow: "ਆਗਿਆ ਦਿਓ"
    },
    userDetails: {
      heading: "PAN ਤਸਦੀਕ",
      subHeading: "ਤਸਦੀਕ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਵੇਰਵੇ ਭਰੋ",
      panLabel: "PAN ਨੰਬਰ",
      panRequired: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ PAN ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
      saveError: "ਵੇਰਵੇ ਸੰਭਾਲਣ ਵੇਲੇ ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      proceed: "ਅੱਗੇ ਵਧੋ"
    },
    redirectCta: {
      or: "ਜਾਂ",
      clickHere: "ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
      clickHereStart: "ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
      toContinue: "ਜਾਰੀ ਰੱਖਣ ਲਈ"
    },
    documentCapture: {
      stillNotWorking: "ਅਜੇ ਵੀ ਕੰਮ ਨਹੀਂ ਕਰ ਰਿਹਾ?",
      clickToCaptureInstead: "ਇਸਦੀ ਬਜਾਏ ਕਲਿੱਕ-ਟੂ-ਕੈਪਚਰ ਅਜ਼ਮਾਓ",
      pdfNotAllowedIndia: "ਭਾਰਤ ਲਈ PDF ਅੱਪਲੋਡ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 5 MB ਤੋਂ ਘੱਟ JPEG, JPG, ਜਾਂ PNG ਫਾਈਲਾਂ ਅੱਪਲੋਡ ਕਰੋ।",
      pdfNotAllowedIndiaMobile: "ਭਾਰਤ ਲਈ PDF ਅੱਪਲੋਡ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 5 MB ਤੋਂ ਘੱਟ JPEG, JPG, PNG, HEIC, ਜਾਂ HEIF ਫਾਈਲਾਂ ਅੱਪਲੋਡ ਕਰੋ।",
      fileFormatsIndia: "jpeg, jpg, png 5 mb ਤੋਂ ਘੱਟ",
      fileFormats: "jpeg, jpg, png, pdf 5 mb ਤੋਂ ਘੱਟ",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb ਤੋਂ ਘੱਟ",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb ਤੋਂ ਘੱਟ"
    },
    mobileCapture: {
      upload: "ਅਪਲੋਡ ਕਰੋ",
      skip: "ਛੱਡੋ",
      stillNotWorking: "ਫਿਰ ਵੀ ਕੰਮ ਨਹੀਂ ਕਰ ਰਿਹਾ?",
      tryClickToCapture: "ਟੈਪ ਕਰਕੇ ਫੋਟੋ ਲਓ"
    },
    UserDetails: {
      panLabel: "PAN ਨੰਬਰ",
      proceedBtn: "ਅੱਗੇ ਵਧੋ",
      panRequired: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ PAN ਨੰਬਰ ਦਰਜ ਕਰੋ",
      saveError: "ਵੇਰਵੇ ਸੰਭਾਲਣ ਵੇਲੇ ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
    }
  },
  su: {
    supportingDocument: {
      headingFallback: "Dokumén pangrojong",
      subHeading: "Unggah dokumén di handap. Disimpen pikeun ditinjau — teu aya nu dicokot ti éta.",
      choosePlaceholder: "Pilih koropak (PNG, JPG, atawa PDF)",
      continue: "Teraskeun",
      uploading: "Ngunggah...",
      skip: "Lengkah heula",
      errorInvalidType: "Unggah koropak PNG, JPG, atawa PDF.",
      errorTooLarge: "Koropak badag teuing. Watesna 10MB.",
      errorRead: "Teu tiasa maca koropak éta. Mangga cobian nu séjén.",
      errorNoFile: "Mangga pilih koropak pikeun diunggah.",
    },
    header: {
      title: "Hayu Urang Verifikasi Idéntitas Anjeun",
      subtitle: "Ieu nyandak kirang ti 2 menit",
      havingIssue: "Aya masalah?"
    },
    onlyIdVerificationHeader: {
      title: "Hayu Urang Verifikasi Idéntitas Anjeun",
      subtitle: "Ieu ngan ukur sakedapan. Cukup siagakeun dokumén idéntitas anjeun.",
      instruction1: "Idinkeun Aksés Ka Kamera",
      instruction2: "Pindai atawa Unggah Dokumén Anjeun",
      instruction3: "Verifikasi Dokumén Instan"
    },
    subHeading: {
      subHeading1: "Jepret Dokumén ID Anjeun",
      subHeading2: "Verifikasi yén anjeun hirup",
      livenessHeading1: "Milarian tempat anu caangna saé",
      livenessHeading2: "Jaga raray anjeun di tengah"
    },
    termsAndCondition: {
      title: "Abdi satuju pikeun nurut kana istilah sareng kaayaan ieu.",
      privacyPolicy: "Tingali istilah",
      beginBtnText: "Mimitian",
      beginLiveness: "Ngamimitian pamariksaan kahirupan",
      startLiveness: "Teruskeun kana pamariksaan kahirupan"
    },
    permissionDenied: {
      title: "Aksés kaméra ditolak!",
      subtitle: "Parios naha aya ikon kaméra anu diblokir deukeut bilah alamat panyungsi anjeun teras buka blokirna.",
      readMore: "Maca deui",
      refreshText: "Sanggeus masihan idin aksés kaméra, mangga klik tombol Anyarkeun di handap.",
      refreshBtn: "Anyarkeun",
      link: "Atanapi, Teruskeun dina Ponsel",
      buttonText: "Atanapi, Teruskeun dina Ponsel"
    },
    desktopBrowserPermissionDenied: {
      title: "Mangga idinan aksés kaméra",
      subtitle: "Panyungsi bisa menta idin. Mangga 'idinan' pikeun neruskeun.",
      readMore: "Maca deui",
      refreshText: "Anyarkeun saatos masihan idin",
      refreshBtn: "Anyarkeun",
      link: "Atanapi, Teruskeun dina Ponsel",
      buttonText: "Atanapi, Teruskeun dina Ponsel"
    },
    androidBrowserPermissionDenied: {
      title: "Aksés kaméra ditolak",
      subtitle: "Periksa apakah ikon kamera di dekat bilah alamat browser diblokir, lalu buka blokirnya.",
      readMore: "Pelajari lebih lanjut",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Muat Ulang di bawah ini.",
      refreshBtn: "Muat Ulang",
      link: "Atau, Lanjutkan di Ponsel",
      buttonText: "Atau, Lanjutkan di Ponsel"
    },
    androidWebViewPermissionDenied: {
      title: "Aksés kaméra ditolak",
      subtitle: "Akses kamera mungkin diblokir oleh pengaturan aplikasi. Silakan buka Info Aplikasi > Izin > Kamera dan aktifkan izin kamera.",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Muat Ulang di bawah ini.",
      refreshBtn: "Muat Ulang",
      link: "Atau, Lanjutkan di Ponsel",
      buttonText: "Atau, Lanjutkan di Ponsel"
    },
    iosBrowserPermissionDenied: {
      title: "Aksés kaméra ditolak",
      subtitle: "Ketuk ikon kamera atau gembok di dekat bilah alamat untuk mengizinkan akses, atau periksa pengaturan browser Anda.",
      readMore: "Pelajari lebih lanjut",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Muat Ulang di bawah ini.",
      refreshBtn: "Muat Ulang",
      link: "Atau, Lanjutkan di Ponsel",
      buttonText: "Atau, Lanjutkan di Ponsel"
    },
    iosWebViewPermissionDenied: {
      title: "Aksés kaméra ditolak",
      subtitle: "Akses kamera mungkin dibatasi melalui pengaturan aplikasi. Buka Pengaturan, cari aplikasi yang Anda gunakan, lalu aktifkan izin Kamera.",
      refreshText: "Setelah akses kamera diizinkan, klik tombol Muat Ulang di bawah ini.",
      refreshBtn: "Muat Ulang",
      link: "Atau, Lanjutkan di Ponsel",
      buttonText: "Atau, Lanjutkan di Ponsel"
    },
    documentationList: {
      countryHeading: "Pilih nagara",
      docHeading: "Pilih dokumén anjeun",
      btnText: "Teras",
      searchCountry: "Téangan nagara"
    },
    frontDocCapture: {
      heading: "Tempatkeun sisi hareup ID dina kotak",
      backupHeading: "Aya kasusah? Mangga klik gambar sacara manual",
      btnText: "Jepret poto",
      headingBack: " dina jero pasagi panjang",
      uploadButton: "atawa, unggah ID"
    },
    backDocCapture: {
      heading: "Tempatkeun sisi tukang ID dina kotak",
      backupHeading: "Aya kasusah? Mangga klik gambar sacara manual",
      btnText: "Jepret poto",
      containerText: "atanapi, unggah dokumén",
      text: "Nyandak, tetep cicing",
      headingBack: " dina jero pasagi panjang",
      skipButton: "Lewat Sisi Tukang",
      uploadButton: "atawa, unggah ID"
    },
    analyzing: {
      heading: "Ngabalikeun ID anjeun...",
      subHeading: "Mangga pariksa rinci kartu anjeun dina layar salajengna sareng edit upami diperyogikeun"
    },
    imageCheck: {
      heading: "Pariksa gambar anjeun",
      subHeading: "Pastikeun yén gambar éta lengkep, jelas sareng teu kabur sareng silau.",
      button1: "Candak poto deui",
      button2: "Sae-sae",
      frontHeading: "Pariksa gambar hareup anjeun",
      backHeading: "Pariksa gambar tukang anjeun"
    },
    errorHandler: {
      heading: "Aduh :(",
      subHeading1: "Kami ngalaman sababaraha masalah, tapi ulah hariwang! Mangga cobian deui",
      subHeading2: "Upami ieu teras, parios engké",
      button: "Cobian deui"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Silakan hapus segala sesuatu yang menutupi wajah Anda",
        button: "Coba Lagi"
      },
      eyeClosureDetected: {
        heading: "Silakan buka mata Anda dan lihat langsung ke kamera",
        button: "Coba lagi"
      },
      isMultipleFacesFound: {
        heading: "Terdeteksi beberapa wajah. Pastikan hanya wajah Anda yang terlihat di kamera.",
        button: "Coba Lagi"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Coba Lagi"
      },
      faceDetections: {
        heading: "Silakan hapus ini",
        button: "Coba Lagi"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Ditemukan beberapa wajah",
          button: "Coba Lagi"
        },
        generalMessage: {
          heading: "Pastikan Anda hidup di depan kamera",
          button: "Coba Lagi"
        }
      },
      faceMatch: {
        heading: "Wajah Anda tidak cocok dengan foto ID",
        button: "Coba Lagi"
      },
      selfieError: {
        heading: "Kami tidak dapat memverifikasi selfie Anda",
        subHeading1: "Ikuti tips ini dan coba lagi",
        instruction1: "Pindah ke area yang terang dan hindari cahaya latar",
        instruction2: "Pastikan wajah Anda sepenuhnya terlihat dan terpusat di dalam bingkai",
        instruction3: "Hapus topi, kacamata, atau masker untuk melihat wajah Anda dengan jelas",
        button: "Coba Lagi"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP teu cocog. Mangga baca OTP kalayan jelas sareng tarik",
        button: "Cobian Deui"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verifikasi gagal. Silakan ikuti instruksi dengan jelas dan coba lagi",
        button: "Coba Lagi"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF gaduh kalangkung seueur kaca",
        subHeading: "PDF nu diunggah ngalangkungan wates 2 kaca. Mangga unggah PDF anu teu langkung ti 2 kaca, atanapi gambar ID anu jelas."
      },
      heading: "Kami henteu tiasa ngolah ID anjeun",
      subHeading: "Antukna anjeun unggah ID anu lepat atanapi gambarna henteu jelas",
      buttonBack: "Cobian deui sisi tukang ID",
      buttonFront: "Cobian deui sisi hareup ID",
      button: "Cobian deui",
      captureFrontSide: "Candak Sisi Hareup",
      captureBackSide: "Candak Sisi Tukang",
      changeIDButton: "Pilih Dokumén Séjén",
      wrongid: {
        heading: "Kami teu tiasa ngolah dokumén ieu",
        subHeading: "Mangga pastikeun anjeun ngunggah dokumén anu leres sareng pastikeun kualitas gambar jelas"
      },
      expiredid: {
        heading: "Dokumén ID Kadaluwarsa!",
        subHeading: "Kami teu tiasa nampi dokumén ID anu kadaluwarsa. Mangga sayogikeun dokumén anu valid"
      },
      minimumage: {
        heading: "Sarat Umur Teu Kacumponan!",
        subHeading: "Umur anjeun di handap umur minimum anu diperyogikeun. Mangga pastikeun anjeun nyumponan kritéria umur minimum"
      },
      mobileAttemptsDone: {
        heading: "Perjalanan diteraskeun dina alat anjeun saméméhna",
        subHeading: "Sési ieu ayeuna dieureunkeun pikeun nyegah duplikasi."
      },
      finished: {
        heading: "Perjalanan parantos réngsé",
        subHeading: "Perjalanan parantos réngsé atawa dieureunkeun"
      },
      invalid: {
        heading: "Perjalanan Teu Sayogi !",
        subHeading: "Teu aya journeyId kapanggih atawa ID perjalanan teu valid"
      },
      INVALID_PAN_NUMBER: {
        heading: "Nomer PAN Teu Valid",
        subHeading: "Nomer PAN anu anjeun lebetkeun teu valid. Mangga parios teras cobian deui"
      },
      INVALID_PAN_STATUS: {
        heading: "Status PAN Teu Valid",
        subHeading: "Nomer PAN anu anjeun lebetkeun teu valid. Mangga parios teras cobian deui"
      },
      directKyc: {
        heading: "Perjalanan KYC Langsung !",
        subHeading: "Ieu perjalanan KYC langsung. Perjalanan frontend teu diidinan."
      },
      DOCTYPE_FALSE: {
        heading: "Dokumén Salah Disayogikeun!",
        subHeading: "Mangga unggah dokumén anu valid sareng pastikeun kualitas gambar saé."
      },
      ONLY_FRONT: {
        heading: "Sisi tukang ID teu aya",
        subHeading: "Anjeun ngan nyayogikeun sisi hareup. Mangga balikkeun ID anjeun teras sayogikeun sisi tukang pikeun neraskeun"
      },
      ONLY_BACK: {
        heading: "Sisi hareup ID teu aya",
        subHeading: "Anjeun ngan nyayogikeun sisi tukang. Mangga balikkeun ID anjeun teras sayogikeun sisi hareup pikeun neraskeun"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Dokumén Bakal Kadaluwarsa Geura",
        subHeading: "Dokumén ditolak kusabab bakal kadaluwarsa geura."
      },
      DOCUMENT_EXPIRED: {
        heading: "Dokumén Kadaluwarsa!",
        subHeading: "Mangga unggah dokumén anu valid sareng can kadaluwarsa pikeun neraskeun."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Sarat Umur Teu Kacumponan!",
        subHeading: "Dokumén nunjukkeun anjeun teu nyumponan umur anu diperyogikeun. Mangga unggah dokumén anu valid."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Teu Tiasa Verifikasi Dokumén!",
        subHeading: "Kualitas gambar goréng teuing pikeun verifikasi. Mangga cobian deui ku gambar anu langkung jelas."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Teu Tiasa Verifikasi Dokumén!",
        subHeading: "Sababaraha inpormasi teu tiasa diverifikasi. Mangga cobian deui ku gambar anu langkung jelas."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Teu Tiasa Verifikasi Dokumén!",
        subHeading: "Sababaraha rincian teu tiasa diverifikasi kusabab kualitas gambar goréng. Mangga cobian deui ku gambar anu langkung jelas"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Teu Tiasa Verifikasi Dokumén!",
        subHeading: "Sababaraha rincian teu tiasa diverifikasi. Mangga cobian deui ku gambar anu langkung jelas."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Masalah pikeun verifikasi poto anjeun dina ID",
        subHeading: "Kami teu tiasa verifikasi poto anjeun dina kartu ID. Mangga unggah poto anu jelas tina ID asli anjeun supados kami tiasa mastikeunana."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Pamariksaan pola kaamanan dokumén gagal",
        subHeading: "Kami teu tiasa verifikasi pola kaamanan bawaan dokumén. Mangga unggah poto anu jelas tina ID asli pikeun ngabantosan kami mastikeun kaaslianana."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Pamariksaan Kahirupan Dokumén Gagal",
        subHeading: "Kami mendakan tanda yén dokumén meureun lain asli. Mangga ulah nganggo screenshot, salinan citak, atawa nampilkeun ID dina layar. Unggah ID asli kalayan sadaya fitur katingali jelas"
      },
      SECURITY_FALSE: {
        heading: "Masalah Kadeteksi!",
        subHeading: "Dokumén teu tiasa diverifikasi. Mangga cobian deui ku gambar anu langkung jelas"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Kualitas Gambar Goréng!",
        subHeading: "Gambar buram teuing atawa teu jelas. Mangga cobian deui ku gambar anu langkung jelas"
      },
      FACE_UNDETECTED: {
        heading: "Raray Teu Kadeteksi",
        subHeading: "Kami teu mendakan raray anu katingali dina dokumén. Mangga unggah ID anu valid dimana raray katingali jelas"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Babandingan Antar-Dokumén Gagal",
        subHeading: "Babandingan antar-dokumén gagal kusabab teu cocog dina hiji atawa langkung widang konci (Ngaran, Tanggal Lahir, atawa Raray)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Kagagalan Digilocker",
        subHeading: "Aya kasalahan nalika perjalanan Digilocker. Mangga cobian deui atawa anggo métode séjén pikeun neraskeun."
      },
      LINKAGE_FAILED: {
        heading: "Verifikasi ieu teu tiasa réngsé",
        subHeading: "Data anu dicandak teu cocog sareng catetan pikeun pamariksaan ieu."
      }
    },
    biometricConsent: {
      consentStatement: "Saméméh selfie anjeun, kami peryogi idin anjeun pikeun néwak sareng ngolah data biométrik anjeun (gambar rai sareng sinyal liveness) pikeun mariksa identitas anjeun. Data ieu ngan dianggo pikeun verifikasi ieu.",
      privacyPolicy: "Kabijakan privasi",
      consentButton: "Abdi satuju — Teraskeun",
      declineButton: "Abdi henteu satuju",
      confirmTitle: "Teraskeun tanpa verifikasi biométrik?",
      confirmBody: "Tanpa verifikasi biométrik, kami moal nyandak selfie. Verifikasi anjeun bakal réngsé nganggo inpormasi anu parantos anjeun pasihan. Pilihan ieu final pikeun sési ieu.",
      goBack: "Balik",
      confirmDecline: "Konfirmasi — henteu satuju",
      declineComplete: "Anjeun milih henteu neraskeun verifikasi biométrik. Verifikasi identitas anjeun parantos réngsé nganggo dokumén anu anjeun kintunkeun."
    },
    introLiveness: {
      heading: "Konfirmasi yén anjeun hirup di dieu",
      instruction1: "Pastikeun aya cukup cahaya",
      instruction2: "Idinkeun idin anu diperyogikeun",
      instruction3: "Cukup nuturkeun petunjuk",
      button: "Teraskeun",
      subHeading: "Anjeun ngan sahiji léngkah deui"
    },
    phoneSession: {
      heading: "Sidang diteruskeun dina ponsel",
      subheading: "Tetep buka jandéla ieu dugi ka réngsé dina sélulér",
      button: "Teraskeun di dieu"
    },
    continueOnPhone: {
      heading: "Teraskeun dina ponsel",
      subheading: "Pindai QR atanapi salin tautan di handap",
      subheading2: "Pindai QR atanapi buka tautan dina ponsel anjeun",
      text: "Lengkepkeun prosésna",
      text1: "Parios deui di dieu pikeun ngalebetkeun",
      button: "Salin",
      copiedButton: "Geus disalin!",
      copied: "Disalin!"
    },
    SsnReview: {
      heading: "Pariksa rinci anjeun",
      subHeading: "Laksanakeun parobihan anu diperyogikeun sareng kirimkeun detil",
      feild1: "SIM",
      feild2: "Kadaluwarsa",
      feild3: "Tanggal lahir",
      feild4: "Kelas",
      feild5: "Watesan",
      feild6: "Nagara",
      feild7: "Alamat",
      button: "Rinci anu leres"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Jaga raray anjeun dina bunderan"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Caketan kana kaméra"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Ulah éra, témbongkeun diri"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Poék teuing. Milarian cahaya nu langkung caang"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Caang teuing. Milarian cahaya nu langkung lembut"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Jaga raray anjeun dina bunderan"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Cicing waé"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Hadepkeun raray kana cahaya"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Cekel telepon sajajar panon"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Ngajauhan saeutik tina kaméra"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Tengahkeun raray dina pigura"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Posisikeun raray anjeun di tengah bunderan"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Deukeutan sareng jaga raray anjeun tetep lempeng"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Lebet ka tampilan sareng jaga raray anjeun tetep lempeng"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Kalieur teuing. Pilarian cahaya anu langkung caang"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Caang teuing. Pilarian cahaya anu optimal"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Atur raray anjeun ka tengah bunderan"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Tetep anteng sareng tingali ka hareup"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Hadapkeun raray ka cahaya sareng tetep anteng"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Tahan telepon anjeun dina tingkat panon"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Pindah saeutik jauh ti kaméra"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Sampurna!"
      },
      smile1: {
        icon: "mood",
        description: "Seuri, anjeun katingali saé!"
      },
      smile2: {
        icon: "mood",
        description: "Seuri ka kaméra!"
      }
    },
    successful: {
      title: "Verifikasi Lengkap",
      text: "Anjeun ayeuna tiasa nutup jandéla",
      finishBtn: "Bérés"
    },
    poweredBy: "Diwangun ku",
    redirect: "Ngabalikeun deui dina",
    error: {
      message: "URL parantos béak waktos atanapi henteu valid"
    },
    footer: {
      securedBy: "Diwangun ku"
    },
    helpFaq: {
      title: "Bantuan & FAQ",
      subtitle: "Kami di dieu pikeun ngabantosan anjeun",
      cameraText: "Pikeun mastikeun idéntitas anjeun, urang peryogi nyandak gambar nganggo kaméra alat anjeun. Parios link ieu pikeun diajar kumaha masihan idin anu diperyogikeun",
      cameraHeading: "Idin Kaméra",
      languageText: "Di awal prosés, anjeun tiasa milih basa anu anjeun pikahoyong ku milihna tina ménu tarik-turun di bar luhur",
      languageHeading: "Pamilihan Basa",
      kycText: "KYC, atanapi 'Kenal Pelanggan Anjeun', mangrupikeun prosés pikeun mastikeun sareng verifikasi idéntitas nasabah, anu ngabantosan mastikeun patuh sareng ngahindarkeun penipuan sareng kagiatan ilegal sanés",
      kycHeading: "Naon éta KYC?",
      timeText: "Biasana, ieu nyandak sakitar 60 detik. Sanajan kitu, ieu tiasa béda-béda gumantung kana nagara",
      timeHeading: "Sabaraha lami ieu bakal nyandak?"
    },
    pdfPreviewUnavailable: "Teu tiasa nampilkeun ramalan PDF.",
    pdfPreviewHint: "Upami ramalan teu muncul, anjeun tetep tiasa neraskeun.",
    pdfOpenLabel: "Buka PDF",
    failedUpload: {
      title: "Unggah Berkas Gagal",
      text: "Mangga pastikeun berkas kirang ti 5MB sareng dina format .jpg, .jpeg, .png, .heic, .heif, atawa .pdf",
      btn: "Cobian Deui",
      pdfNotAllowedIndia: "Unggah PDF teu diidinan pikeun India. Mangga unggah file JPEG, JPG, PNG, HEIC, atawa HEIF kirang ti 5 MB.",
      pdfNotAllowedIndiaBasic: "Unggah PDF teu diidinan pikeun India. Mangga unggah file JPEG, JPG, atawa PNG kirang ti 5 MB."
    },
    livenessAnalyzing: {
      heading: "Nganalisis Raray Anjeun",
      subHeading: "Mangga antosan, ieu ngan ngabutuhkeun sababaraha detik"
    },
    sessionExpiredError: {
      heading: "Hapunten, sési anjeun parantos béak waktu",
      subHeading1: "Anjeun parantos teu aktip sakedap. Pikeun alesan kaamanan, sési anjeun otomatis kadaluwarsa",
      subHeading2: "Mangga cobian deui",
      buttonText: "Cobian Deui"
    },
    journeyExpiredError: {
      heading: "Hapunten, tautan parantos kadaluwarsa",
      subHeading1: "Tautan teu aktip deui. Pikeun alesan kaamanan, tautan ngagaduhan umur terbatas",
      subHeading2: "Mangga cobian ku tautan anyar",
      buttonText: "Cobian Deui"
    },
    cameraAccessError: {
      alert1: "Aksés kaméra ditolak. Mangga aktipkeun aksés kaméra dina setélan panyungsi anjeun",
      alert2: "Aya kasalahan nalika ngaksés kaméra",
      alert3: "Panyungsi anjeun teu ngadukung aksés kaméra"
    },
    activeLiveness: {
      instruction: "Tetep raray anjeun dina bunderan sareng tuturkeun pituduh",
      permissionDeniedTitle: "Aksés Kaméra atawa Mikropon Ditolak",
      permissionDeniedSubtitle: "Mangga idinan aksés kaméra sareng mikropon dina setélan panyungsi anjeun teras cobian deui."
    },
    flipScreen: {
      heading: "Ayeuna balikkeun kartu identitas anjeun",
      subHeading: "Mangga balikkeun kartu identitas anjeun sacara fisik pikeun nembongkeun sisi tukang, teras tempatkeun dina pigura kamera.",
      continueButton: "Teraskeun"
    },
    mobileDocCapture: {
      frontSide: "Sisi Hareup",
      backSide: "Sisi Tukang",
      of: "tina",
      upload: "Unggah",
      stillNotWorking: "Masih teu jalan?",
      clickToCapture: "Coba klik-pikeun-nyandak",
      skip: "Langkungan"
    }
,
    permissionPopUp: {
      title: "Idin diperlukeun",
      subtitle: "Idinan aksés pikeun ngagunakeun kaméra",
      decline: "Tolak",
      allow: "Idinan"
    },
    userDetails: {
      heading: "Verifikasi PAN",
      subHeading: "Mangga eusian detilna pikeun verifikasi",
      panLabel: "Nomer PAN",
      panRequired: "Mangga lebetkeun nomer PAN anjeun",
      saveError: "Aya nu lepat nalika nyimpen detil. Mangga cobian deui.",
      proceed: "Teraskeun"
    },
    redirectCta: {
      or: "atawa",
      clickHere: "klik di dieu",
      clickHereStart: "Klik di dieu",
      toContinue: "pikeun neruskeun"
    },
    documentCapture: {
      stillNotWorking: "Masih teu jalan?",
      clickToCaptureInstead: "Cobian klik-pikeun-nyokot gantina",
      pdfNotAllowedIndia: "Unggah PDF teu diidinan pikeun India. Mangga unggah file JPEG, JPG, atawa PNG kurang ti 5 MB.",
      pdfNotAllowedIndiaMobile: "Unggah PDF teu diidinan pikeun India. Mangga unggah file JPEG, JPG, PNG, HEIC, atawa HEIF kurang ti 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png kurang ti 5 mb",
      fileFormats: "jpeg, jpg, png, pdf kurang ti 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif kurang ti 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf kurang ti 5 mb"
    },
    mobileCapture: {
      upload: "Unggah",
      skip: "Lewat",
      stillNotWorking: "Masih teu jalan?",
      tryClickToCapture: "Pencét pikeun motret"
    },
    UserDetails: {
      panLabel: "Nomer PAN",
      proceedBtn: "Teraskeun",
      panRequired: "Mangga lebetkeun nomer PAN anjeun",
      saveError: "Aya anu lepat nalika nyimpen detail. Mangga cobian deui."
    }
  },
  sw: {
    supportingDocument: {
      headingFallback: "Hati ya usaidizi",
      subHeading: "Pakia hati hapa chini. Inahifadhiwa kwa ukaguzi — hakuna kinachotolewa kutoka kwayo.",
      choosePlaceholder: "Chagua faili (PNG, JPG au PDF)",
      continue: "Endelea",
      uploading: "Inapakia...",
      skip: "Ruka kwa sasa",
      errorInvalidType: "Pakia faili la PNG, JPG au PDF.",
      errorTooLarge: "Faili ni kubwa mno. Kikomo ni 10MB.",
      errorRead: "Haikuweza kusoma faili hilo. Tafadhali jaribu lingine.",
      errorNoFile: "Tafadhali chagua faili la kupakia.",
    },
    header: {
      title: "Hebu thibitisha utambulisho wako",
      subtitle: "Inachukua chini ya dakika 2",
      havingIssue: "Una tatizo?"
    },
    onlyIdVerificationHeader: {
      title: "Hebu thibitisha utambulisho wako",
      subtitle: "Hii itachukua dakika moja tu. Tafadhali kuwa na kitambulisho chako karibu.",
      instruction1: "Ruhusu Ufikiaji wa Kamera",
      instruction2: "Skena au Pakia Hati Yako",
      instruction3: "Uhakiki wa Hati Mara Moja"
    },
    subHeading: {
      subHeading1: "Piga picha ya hati yako ya kitambulisho",
      subHeading2: "Thibitisha kuwa uko hai",
      livenessHeading1: "Tafuta mahali penye mwanga mzuri",
      livenessHeading2: "Weka uso wako katikati"
    },
    termsAndCondition: {
      title: "Ninakubali kukubaliana na kufuata masharti na vigezo vifuatavyo.",
      privacyPolicy: "Angalia masharti",
      beginBtnText: "Anza",
      beginLiveness: "Kuanza ukaguzi wa uhai",
      startLiveness: "Endelea na ukaguzi wa uhai"
    },
    permissionDenied: {
      title: "Ufikiaji wa kamera umekataliwa!",
      subtitle: "Angalia kama kuna ikoni ya kamera iliyozuiwa karibu na upau wa anwani wa kivinjari na uiondoe kwenye vizuizi.",
      readMore: "Soma Zaidi",
      refreshText: "Baada ya kuruhusu ufikiaji wa kamera, tafadhali bofya kitufe cha 'Fanya upya' kilicho hapa chini.",
      refreshBtn: "Fanya upya",
      link: "Au, Endelea kwenye Simu",
      buttonText: "Au, Endelea kwenye Simu"
    },
    desktopBrowserPermissionDenied: {
      title: "Tafadhali ruhusu ufikiaji wa kamera",
      subtitle: "Kivinjari kinaweza kuomba ruhusa. Tafadhali 'ruhusu' ili kuendelea.",
      readMore: "Soma Zaidi",
      refreshText: "Fanya upya baada ya kutoa ruhusa",
      refreshBtn: "Fanya upya",
      link: "Au, Endelea kwenye Simu",
      buttonText: "Au, Endelea kwenye Simu"
    },
    androidBrowserPermissionDenied: {
      title: "Ufikiaji wa kamera umekataliwa!",
      subtitle: "Angalia ikiwa kuna ikoni ya kamera iliyozuiwa karibu na anwani ya kivinjari na iruhusu tena.",
      readMore: "Jifunze zaidi",
      refreshText: "Baada ya kuruhusu ufikiaji wa kamera, bofya kitufe cha Refresh hapa chini.",
      refreshBtn: "Sasisha",
      link: "Au, endelea kwenye simu",
      buttonText: "Au, endelea kwenye simu"
    },
    androidWebViewPermissionDenied: {
      title: "Ufikiaji wa kamera umekataliwa!",
      subtitle: "Huenda kamera imezuiwa kupitia mipangilio ya programu. Tafadhali nenda kwenye App Info > Ruhusa > Kamera na ruhusu ufikiaji.",
      refreshText: "Baada ya kuruhusu ufikiaji wa kamera, bofya kitufe cha Refresh hapa chini.",
      refreshBtn: "Sasisha",
      link: "Au, endelea kwenye simu",
      buttonText: "Au, endelea kwenye simu"
    },
    iosBrowserPermissionDenied: {
      title: "Ufikiaji wa kamera umekataliwa!",
      subtitle: "Bofya ikoni ya kamera au kufuli karibu na anwani ili kuruhusu ufikiaji, au angalia mipangilio ya kivinjari.",
      readMore: "Jifunze zaidi",
      refreshText: "Baada ya kuruhusu ufikiaji wa kamera, bofya kitufe cha Refresh hapa chini.",
      refreshBtn: "Sasisha",
      link: "Au, endelea kwenye simu",
      buttonText: "Au, endelea kwenye simu"
    },
    iosWebViewPermissionDenied: {
      title: "Ufikiaji wa kamera umekataliwa!",
      subtitle: "Huenda kamera imezuiwa kwenye mipangilio ya programu. Nenda kwenye Mipangilio, tafuta programu yako, kisha wezesha ruhusa ya Kamera.",
      refreshText: "Baada ya kuruhusu ufikiaji wa kamera, bofya kitufe cha Refresh hapa chini.",
      refreshBtn: "Sasisha",
      link: "Au, endelea kwenye simu",
      buttonText: "Au, endelea kwenye simu"
    },
    documentationList: {
      countryHeading: "Chagua nchi",
      docHeading: "Chagua hati yako",
      btnText: "Inayofuata",
      searchCountry: "Tafuta nchi"
    },
    frontDocCapture: {
      heading: "Weka upande wa mbele wa kitambulisho kwenye mstatili",
      backupHeading: "Una shida? Tafadhali bonyeza picha kwa mkono",
      btnText: "Piga picha",
      headingBack: " ndani ya mstatili",
      uploadButton: "au, pakia kitambulisho"
    },
    backDocCapture: {
      heading: "Weka upande wa nyuma wa kitambulisho kwenye mstatili",
      backupHeading: "Una shida? Tafadhali bonyeza picha kwa mkono",
      btnText: "Piga picha",
      containerText: "au, pakia hati",
      text: "Inakamata, tafadhali tulia",
      headingBack: " ndani ya mstatili",
      skipButton: "Ruka Upande wa Nyuma",
      uploadButton: "au, pakia kitambulisho"
    },
    analyzing: {
      heading: "Inachanganua kitambulisho chako...",
      subHeading: "Tafadhali angalia maelezo ya kadi yako kwenye skrini inayofuata na uhariri ikiwa ni lazima"
    },
    imageCheck: {
      heading: "Angalia picha yako",
      subHeading: "Tafadhali hakikisha kuwa picha ni kamili, wazi na haina ukungu na mwanga wa mwangaza.",
      button1: "Piga picha tena",
      button2: "Sawa",
      frontHeading: "Angalia picha ya mbele",
      backHeading: "Angalia picha ya nyuma"
    },
    errorHandler: {
      heading: "Oh oh :(",
      subHeading1: "Tunapata shida kidogo, lakini usijali! Tafadhali jaribu tena",
      subHeading2: "Ikiwa hii itaendelea, angalia baadaye",
      button: "Jaribu tena"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Tafadhali ondoa chochote kinachofunika uso wako",
        button: "Jaribu Tena"
      },
      eyeClosureDetected: {
        heading: "Tafadhali weka macho yako wazi na utazame moja kwa moja kwenye kamera",
        button: "Jaribu tena"
      },
      isMultipleFacesFound: {
        heading: "Nyuso nyingi zimetambuliwa. Hakikisha uso wako pekee unaonekana kwenye kamera.",
        button: "Jaribu Tena"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Jaribu Tena"
      },
      faceDetections: {
        heading: "Tafadhali ondoa hili",
        button: "Jaribu Tena"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Uso Mengi Umeonekana",
          button: "Jaribu Tena"
        },
        generalMessage: {
          heading: "Tafadhali hakikisha uko hai mbele ya kamera",
          button: "Jaribu Tena"
        }
      },
      faceMatch: {
        heading: "Uso wako hauendani na picha ya kitambulisho",
        button: "Jaribu Tena"
      },
      selfieError: {
        heading: "Hatukuweza kuthibitisha selfie yako",
        subHeading1: "Tafadhali fuata maelekezo haya na jaribu tena",
        instruction1: "Hama kwa eneo lenye mwanga mzuri na epuka mwanga wa nyuma",
        instruction2: "Hakikikisha uso wako unaonekana kabisa na umejikita katikati ya fremu",
        instruction3: "Ondoa kofia, miwani, au barakoa ili uso wako uonekane wazi",
        button: "Jaribu Tena"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP hailingani. Tafadhali soma OTP kwa sauti na kwa uwazi",
        button: "Jaribu Tena"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Uthibitishaji umeshindwa. Tafadhali fuata maagizo kwa uwazi na ujaribu tena",
        button: "Jaribu Tena"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF ina kurasa nyingi mno",
        subHeading: "PDF uliyopakia inazidi kikomo cha kurasa 2. Tafadhali pakia PDF yenye kurasa zisizozidi 2, au picha wazi ya kitambulisho chako."
      },
      heading: "Hatuwezi kushughulikia kitambulisho chako",
      subHeading: "Labda unapakia kitambulisho kibaya au picha si wazi",
      buttonBack: "Jaribu tena upande wa nyuma wa kitambulisho",
      buttonFront: "Jaribu tena upande wa mbele wa kitambulisho",
      button: "Jaribu tena",
      captureFrontSide: "Piga Upande wa Mbele",
      captureBackSide: "Piga Upande wa Nyuma",
      changeIDButton: "Chagua Hati Nyingine",
      wrongid: {
        heading: "Hatukuweza kuchakata hati hii",
        subHeading: "Tafadhali thibitisha kuwa unapakia hati sahihi na uhakikishe ubora wa picha uko wazi"
      },
      expiredid: {
        heading: "Muda wa Hati ya Kitambulisho Umeisha!",
        subHeading: "Hatuwezi kukubali hati ya kitambulisho iliyoisha muda. Tafadhali toa hati halali"
      },
      minimumage: {
        heading: "Sharti la Umri Halijafikiwa!",
        subHeading: "Umri wako uko chini ya umri wa chini unaohitajika. Tafadhali hakikisha unafikia kigezo cha umri wa chini"
      },
      mobileAttemptsDone: {
        heading: "Safari imeendelezwa kwenye kifaa chako cha awali",
        subHeading: "Kipindi hiki sasa kimesimamishwa ili kuepuka kurudiwa."
      },
      finished: {
        heading: "Safari imekwisha",
        subHeading: "Safari imekamilika au imesitishwa"
      },
      invalid: {
        heading: "Safari Haipatikani !",
        subHeading: "journeyId haikupatikana au kitambulisho cha safari si sahihi"
      },
      INVALID_PAN_NUMBER: {
        heading: "Nambari ya PAN Si Sahihi",
        subHeading: "Nambari ya PAN uliyoingiza si sahihi. Tafadhali angalia na ujaribu tena"
      },
      INVALID_PAN_STATUS: {
        heading: "Hali ya PAN Si Sahihi",
        subHeading: "Nambari ya PAN uliyoingiza si sahihi. Tafadhali angalia na ujaribu tena"
      },
      directKyc: {
        heading: "Safari ya KYC ya Moja kwa Moja !",
        subHeading: "Hii ni safari ya KYC ya moja kwa moja. Safari ya mbele hairuhusiwi."
      },
      DOCTYPE_FALSE: {
        heading: "Hati Isiyo Sahihi Imetolewa!",
        subHeading: "Tafadhali pakia hati halali na uhakikishe ubora wa picha ni mzuri."
      },
      ONLY_FRONT: {
        heading: "Upande wa nyuma wa kitambulisho haupo",
        subHeading: "Umetoa upande wa mbele tu. Tafadhali geuza kitambulisho chako na utoe upande wa nyuma ili kuendelea"
      },
      ONLY_BACK: {
        heading: "Upande wa mbele wa kitambulisho haupo",
        subHeading: "Umetoa upande wa nyuma tu. Tafadhali geuza kitambulisho chako na utoe upande wa mbele ili kuendelea"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Hati Inakaribia Kuisha Muda",
        subHeading: "Hati imekataliwa kwa sababu inakaribia kuisha muda."
      },
      DOCUMENT_EXPIRED: {
        heading: "Muda wa Hati Umeisha!",
        subHeading: "Tafadhali pakia hati halali ambayo muda wake haujaisha ili kuendelea."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Sharti la Umri Halijafikiwa!",
        subHeading: "Hati inaonyesha kuwa hujafikia umri unaohitajika. Tafadhali pakia hati halali."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Imeshindwa Kuthibitisha Hati!",
        subHeading: "Ubora wa picha ni duni sana kwa uthibitishaji. Tafadhali jaribu tena na picha iliyo wazi zaidi."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Imeshindwa Kuthibitisha Hati!",
        subHeading: "Baadhi ya taarifa hazikuweza kuthibitishwa. Tafadhali jaribu tena na picha iliyo wazi zaidi."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Imeshindwa Kuthibitisha Hati!",
        subHeading: "Baadhi ya maelezo hayakuweza kuthibitishwa kutokana na ubora duni wa picha. Tafadhali jaribu tena na picha iliyo wazi zaidi"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Imeshindwa Kuthibitisha Hati!",
        subHeading: "Baadhi ya maelezo hayakuweza kuthibitishwa. Tafadhali jaribu tena na picha iliyo wazi zaidi."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Tatizo la kuthibitisha picha yako kwenye kitambulisho",
        subHeading: "Hatukuweza kuthibitisha picha yako kwenye kitambulisho. Tafadhali pakia picha iliyo wazi ya kitambulisho chako halisi ili tuweze kuithibitisha."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Ukaguzi wa mchoro wa usalama wa hati umeshindwa",
        subHeading: "Hatukuweza kuthibitisha michoro ya usalama iliyojengwa ndani ya hati. Tafadhali pakia picha iliyo wazi ya kitambulisho halisi ili kutusaidia kuthibitisha uhalali wake."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Ukaguzi wa Uhai wa Hati Umeshindwa",
        subHeading: "Tumepata ishara kwamba hati huenda si halisi. Tafadhali epuka kutumia picha za skrini, nakala zilizochapishwa, au kuonyesha kitambulisho kwenye skrini. Pakia kitambulisho halisi chenye vipengele vyote vinavyoonekana wazi"
      },
      SECURITY_FALSE: {
        heading: "Tatizo Limegunduliwa!",
        subHeading: "Hati haikuweza kuthibitishwa. Tafadhali jaribu tena na picha iliyo wazi zaidi"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Ubora Duni wa Picha!",
        subHeading: "Picha ina ukungu au haiko wazi sana. Tafadhali jaribu tena na picha iliyo wazi zaidi"
      },
      FACE_UNDETECTED: {
        heading: "Uso Haukugunduliwa",
        subHeading: "Hatukuweza kupata uso unaoonekana kwenye hati. Tafadhali pakia kitambulisho halali ambapo uso unaonekana wazi"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Ulinganishaji Kati ya Nyaraka Umeshindwa",
        subHeading: "Ulinganishaji kati ya nyaraka umeshindwa kutokana na kutolingana katika sehemu moja au zaidi muhimu (Jina, Tarehe ya Kuzaliwa, au Uso)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Hitilafu ya Digilocker",
        subHeading: "Hitilafu imetokea wakati wa safari ya Digilocker. Tafadhali jaribu tena au tumia njia mbadala kuendelea."
      },
      LINKAGE_FAILED: {
        heading: "Uthibitishaji huu hauwezi kukamilika",
        subHeading: "Maelezo yaliyonaswa hayakulingana na kumbukumbu za ukaguzi huu."
      }
    },
    biometricConsent: {
      consentStatement: "Kabla ya selfie yako, tunahitaji idhini yako ili kunasa na kuchakata data yako ya kibayometriki (picha ya uso na ishara za uhai) ili kuthibitisha utambulisho wako. Data hii hutumika kwa uthibitishaji huu pekee.",
      privacyPolicy: "Sera ya faragha",
      consentButton: "Ninakubali — Endelea",
      declineButton: "Sikubali",
      confirmTitle: "Uendelee bila uthibitishaji wa kibayometriki?",
      confirmBody: "Bila uthibitishaji wa kibayometriki, hatutapiga selfie. Uthibitishaji wako utakamilishwa kwa kutumia taarifa ambazo tayari umetoa. Chaguo hili ni la mwisho kwa kipindi hiki.",
      goBack: "Rudi nyuma",
      confirmDecline: "Thibitisha — sikubali",
      declineComplete: "Umechagua kutoendelea na uthibitishaji wa kibayometriki. Uthibitishaji wa utambulisho wako umekamilika kwa kutumia hati ulizowasilisha."
    },
    introLiveness: {
      heading: "Thibitisha kuwa uko hai hapa",
      instruction1: "Hakikisha kuna mwanga wa kutosha",
      instruction2: "Ruhusu ruhusa zinazohitajika",
      instruction3: "Fuata tu maelekezo",
      button: "Endelea",
      subHeading: "Umebaki hatua moja tu"
    },
    phoneSession: {
      heading: "Kikao kimeendelea kwenye simu",
      subheading: "Weka dirisha hili wazi hadi ukamilishe kwenye simu yako",
      button: "Endelea hapa"
    },
    continueOnPhone: {
      heading: "Endelea kwenye simu",
      subheading: "Changanua QR au nakili kiungo hapa chini",
      subheading2: "Changanua QR au fungua kiungo kwenye simu yako",
      text: "Kamilisha mchakato",
      text1: "Angalia hapa ili kuwasilisha",
      button: "Nakili",
      copiedButton: "Imenakiliwa!",
      copied: "Imenakiliwa!"
    },
    SsnReview: {
      heading: "Kagua maelezo yako",
      subHeading: "Fanya mabadiliko yoyote yanayohitajika na uwasilishe maelezo",
      feild1: "Leseni ya Udereva",
      feild2: "Muda wa Kuisha",
      feild3: "Tarehe ya Kuzaliwa",
      feild4: "Darasa",
      feild5: "Vikwazo",
      feild6: "Nchi",
      feild7: "Anwani",
      button: "Maelezo ni sahihi"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Weka uso wako ndani ya duara"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Sogea karibu na kamera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Usione aibu, jitokeze"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Giza sana. Tafuta mwanga zaidi"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Mwangaza sana. Tafuta mwanga laini"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Weka uso wako ndani ya duara"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Kaa tuli"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Geuza uso kuelekea mwanga"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Shika simu usawa wa macho"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Jisogeze mbali kidogo na kamera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Weka uso katikati ya fremu"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Weka uso wako katikati ya duara"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Sogea karibu na uweke uso wako sawa"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Ingia kwenye mtazamo na uweke uso wako sawa"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Giza sana. Tafuta mwanga zaidi"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Nuru sana. Tafuta mwanga bora"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Rekebisha uso wako katikati ya duara"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Kaa thabiti na utazame mbele moja kwa moja"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Elekeza uso kwenye mwanga na kaa thabiti"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Shikilia simu yako kwenye kiwango cha macho"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Toka kidogo kutoka kwenye kamera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Kamili!"
      },
      smile1: {
        icon: "mood",
        description: "Tabasamu tafadhali, unaonekana mzuri!"
      },
      smile2: {
        icon: "mood",
        description: "Tabasamu kwa kamera!"
      }
    },
    successful: {
      title: "Uthibitishaji Umekamilika",
      text: "Unaweza kufunga dirisha sasa",
      finishBtn: "Maliza"
    },
    poweredBy: "Inaendeshwa na",
    redirect: "Inaelekeza katika",
    error: {
      message: "URL imeisha muda wake au si sahihi"
    },
    footer: {
      securedBy: "Inaendeshwa na"
    },
    helpFaq: {
      title: "Msaada na Maswali Yanayoulizwa Mara kwa Mara",
      subtitle: "Tupo hapa kukusaidia",
      cameraText: "Ili kuthibitisha utambulisho wako, tunahitaji kuchukua picha kwa kutumia kamera ya kifaa chako. Bonyeza link hii kujifunza jinsi ya kutoa ruhusa zinazohitajika",
      cameraHeading: "Ruhusa ya Kamera",
      languageText: "Mwanzoni mwa mchakato, unaweza kuchagua lugha yako unayopendelea kwa kuichagua kutoka kwenye orodha ya angavu katika bar ya juu",
      languageHeading: "Chaguo la Lugha",
      kycText: "KYC, au 'Jua Mteja Wako', ni mchakato wa kuthibitisha na kudhibitisha utambulisho wa mteja, ambayo husaidia kuhakikisha kufuata sheria na kuzuia udanganyifu na shughuli haramu nyingine",
      kycHeading: "KYC inamaanisha nini?",
      timeText: "Kwa kawaida, inachukua sekunde 60. Hata hivyo, hii inaweza kutofautiana kulingana na nchi",
      timeHeading: "Itachukua muda gani?"
    },
    pdfPreviewUnavailable: "Imeshindwa kuonyesha onyesho la awali la PDF.",
    pdfPreviewHint: "Ikiwa onyesho la awali halitaonekana, bado unaweza kuendelea.",
    pdfOpenLabel: "Fungua PDF",
    failedUpload: {
      title: "Upakiaji wa Faili Umeshindwa",
      text: "Tafadhali hakikisha faili ni chini ya 5MB na katika muundo wa .jpg, .jpeg, .png, .heic, .heif, au .pdf",
      btn: "Jaribu Tena",
      pdfNotAllowedIndia: "Kupakia PDF hakuruhusiwi kwa India. Tafadhali pakia faili za JPEG, JPG, PNG, HEIC, au HEIF chini ya 5 MB.",
      pdfNotAllowedIndiaBasic: "Kupakia PDF hakuruhusiwi kwa India. Tafadhali pakia faili za JPEG, JPG, au PNG chini ya 5 MB."
    },
    livenessAnalyzing: {
      heading: "Inachambua Uso Wako",
      subHeading: "Tafadhali subiri, hii itachukua sekunde chache tu"
    },
    sessionExpiredError: {
      heading: "Samahani, muda wa kipindi chako umeisha",
      subHeading1: "Umekuwa hutumii kwa muda. Kwa sababu za usalama, kipindi chako kimeisha kiotomatiki",
      subHeading2: "Tafadhali jaribu tena",
      buttonText: "Jaribu Tena"
    },
    journeyExpiredError: {
      heading: "Samahani, kiungo kimeisha muda",
      subHeading1: "Kiungo hakifanyi kazi tena. Kwa sababu za usalama, viungo vina muda wa matumizi mdogo",
      subHeading2: "Tafadhali jaribu na kiungo kipya",
      buttonText: "Jaribu Tena"
    },
    cameraAccessError: {
      alert1: "Ufikiaji wa kamera umekataliwa. Tafadhali wezesha ufikiaji wa kamera katika mipangilio ya kivinjari chako",
      alert2: "Hitilafu imetokea wakati wa kufikia kamera",
      alert3: "Kivinjari chako hakitumii ufikiaji wa kamera"
    },
    activeLiveness: {
      instruction: "Weka uso wako ndani ya duara na ufuate maagizo",
      permissionDeniedTitle: "Ufikiaji wa Kamera au Maikrofoni Umekataliwa",
      permissionDeniedSubtitle: "Tafadhali ruhusu ufikiaji wa kamera na maikrofoni katika mipangilio ya kivinjari chako na ujaribu tena."
    },
    flipScreen: {
      heading: "Sasa geuza kitambulisho chako",
      subHeading: "Tafadhali geuza kitambulisho chako kimwili ili kuonyesha upande wa nyuma, kisha kiweke ndani ya fremu ya kamera.",
      continueButton: "Endelea"
    },
    mobileDocCapture: {
      frontSide: "Upande wa Mbele",
      backSide: "Upande wa Nyuma",
      of: "wa",
      upload: "Pakia",
      stillNotWorking: "Bado haifanyi kazi?",
      clickToCapture: "Jaribu bonyeza-kupiga",
      skip: "Ruka"
    }
,
    permissionPopUp: {
      title: "Ruhusa inahitajika",
      subtitle: "Ruhusu ufikiaji ili kutumia kamera",
      decline: "Kataa",
      allow: "Ruhusu"
    },
    userDetails: {
      heading: "Uthibitishaji wa PAN",
      subHeading: "Tafadhali jaza maelezo ili kuthibitisha",
      panLabel: "Nambari ya PAN",
      panRequired: "Tafadhali ingiza nambari yako ya PAN",
      saveError: "Hitilafu imetokea wakati wa kuhifadhi maelezo. Tafadhali jaribu tena.",
      proceed: "Endelea"
    },
    redirectCta: {
      or: "au",
      clickHere: "bofya hapa",
      clickHereStart: "Bofya hapa",
      toContinue: "ili kuendelea"
    },
    documentCapture: {
      stillNotWorking: "Bado haifanyi kazi?",
      clickToCaptureInstead: "Jaribu bofya-kupiga badala yake",
      pdfNotAllowedIndia: "Upakiaji wa PDF hauruhusiwi kwa India. Tafadhali pakia faili za JPEG, JPG, au PNG chini ya 5 MB.",
      pdfNotAllowedIndiaMobile: "Upakiaji wa PDF hauruhusiwi kwa India. Tafadhali pakia faili za JPEG, JPG, PNG, HEIC, au HEIF chini ya 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png chini ya 5 mb",
      fileFormats: "jpeg, jpg, png, pdf chini ya 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif chini ya 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf chini ya 5 mb"
    },
    mobileCapture: {
      upload: "Pakia",
      skip: "Ruka",
      stillNotWorking: "Bado haifanyi kazi?",
      tryClickToCapture: "Gusa kupiga picha"
    },
    UserDetails: {
      panLabel: "Nambari ya PAN",
      proceedBtn: "Endelea",
      panRequired: "Tafadhali ingiza nambari yako ya PAN",
      saveError: "Hitilafu imetokea wakati wa kuhifadhi maelezo. Tafadhali jaribu tena."
    }
  },
  pnb: {
    header: {
      title: "چلو اپنی پہچان کی تصدیق کریں",
      subtitle: "اس میں 2 منٹ سے بھی کم وقت لگتا ہے",
      havingIssue: "کوئی مسئلہ ہے؟"
    },
    subHeading: {
      subHeading1: "اپنے شناختی دستاویز کی تصویر کھینچیں",
      subHeading2: "تصدیق کریں کہ آپ زندہ ہیں",
      livenessHeading1: "اچھی روشنی والی جگہ تلاش کریں",
      livenessHeading2: "اپنا چہرہ درمیان میں رکھیں"
    },
    onlyIdVerificationHeader: {
      title: "چلو اپنی پہچان کی تصدیق کریں",
      subtitle: "یہ صرف ایک منٹ لے گا۔ براہ کرم اپنا شناختی دستاویز تیار رکھیں۔",
      instruction1: "کیمرے تک رسائی کی اجازت دیں",
      instruction2: "اپنی دستاویز اسکین کریں یا اپلوڈ کریں",
      instruction3: "فوری دستاویز کی تصدیق"
    },
    termsAndCondition: {
      title: "میں مندرجہ ذیل شرائط و ضوابط سے اتفاق کرتا ہوں اور ان کی پابندی کرتا ہوں۔",
      privacyPolicy: "شرائط دیکھیں",
      beginBtnText: "شروع کریں",
      beginLiveness: "لائیونس چیک شروع کر رہے ہیں",
      startLiveness: "لائیونس چیک کے لئے آگے بڑھیں"
    },
    permissionDenied: {
      title: "کیمرے تک رسائی مسترد کر دی گئی!",
      subtitle: "براؤزر کے ایڈریس بار کے قریب بلاک شدہ کیمرہ آئیکن کو چیک کریں اور اسے ان بلاک کریں۔",
      readMore: "مزید پڑھیں",
      refreshText: "کیمرے کی اجازت دینے کے بعد، نیچے دیے گئے 'تازہ کریں' بٹن پر کلک کریں۔",
      refreshBtn: "تازہ کریں",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں"
    },
    desktopBrowserPermissionDenied: {
      title: "براہ کرم کیمرے تک رسائی کی اجازت دیں",
      subtitle: "براؤزر اجازتیں طلب کر سکتا ہے۔ براہ کرم جاری رکھنے کے لئے 'اجازت دیں' پر کلک کریں۔",
      readMore: "مزید پڑھیں",
      refreshText: "اجازت دینے کے بعد تازہ کریں",
      refreshBtn: "تازہ کریں",
      link: "یا، فون پر جاری رکھیں",
      buttonText: "یا، فون پر جاری رکھیں"
    },
    androidBrowserPermissionDenied: {
      title: "کیمرے تک رسائی مسترد کر دی گئی!",
      subtitle: "براؤزر کی ایڈریس بار کے قریب موجود بلاک شدہ کیمرہ آئیکن کو چیک کریں اور اسے ان بلاک کریں۔",
      readMore: "مزید جانیں",
      refreshText: "جب کیمرے کی اجازت دے دی جائے تو نیچے موجود 'ریفرش' بٹن پر کلک کریں۔",
      refreshBtn: "ریفرش کریں",
      link: "یا فون پر جاری رکھیں",
      buttonText: "یا فون پر جاری رکھیں"
    },
    androidWebViewPermissionDenied: {
      title: "کیمرے تک رسائی مسترد کر دی گئی!",
      subtitle: "ممکن ہے ایپ کی سیٹنگز میں کیمرے کی اجازت بند ہو۔ براہ کرم App Info > Permissions > Camera میں جا کر اجازت دیں۔",
      refreshText: "جب کیمرے کی اجازت دے دی جائے تو نیچے موجود 'ریفرش' بٹن پر کلک کریں۔",
      refreshBtn: "ریفرش کریں",
      link: "یا فون پر جاری رکھیں",
      buttonText: "یا فون پر جاری رکھیں"
    },
    iosBrowserPermissionDenied: {
      title: "کیمرے تک رسائی مسترد کر دی گئی!",
      subtitle: "ایڈریس بار کے قریب کیمرہ یا لاک آئیکن پر ٹیپ کریں یا براؤزر سیٹنگز چیک کریں۔",
      readMore: "مزید جانیں",
      refreshText: "جب کیمرے کی اجازت دے دی جائے تو نیچے موجود 'ریفرش' بٹن پر کلک کریں۔",
      refreshBtn: "ریفرش کریں",
      link: "یا فون پر جاری رکھیں",
      buttonText: "یا فون پر جاری رکھیں"
    },
    iosWebViewPermissionDenied: {
      title: "کیمرے تک رسائی مسترد کر دی گئی!",
      subtitle: "ایپ کی سیٹنگز میں کیمرے کی اجازت بند ہو سکتی ہے۔ Settings میں جا کر ایپ کو منتخب کریں اور Camera کی اجازت آن کریں۔",
      refreshText: "جب کیمرے کی اجازت دے دی جائے تو نیچے موجود 'ریفرش' بٹن پر کلک کریں۔",
      refreshBtn: "ریفرش کریں",
      link: "یا فون پر جاری رکھیں",
      buttonText: "یا فون پر جاری رکھیں"
    },
    documentationList: {
      countryHeading: "ملک منتخب کریں",
      docHeading: "اپنی دستاویز منتخب کریں",
      btnText: "آگے",
      searchCountry: "ملک تلاش کریں"
    },
    frontDocCapture: {
      heading: "آئی ڈی کا سامنے والا حصہ مستطیل میں رکھیں",
      backupHeading: "مسئلہ ہو رہا ہے؟ براہ کرم تصویر کو دستی طور پر کلک کریں",
      btnText: "تصویر کھینچیں",
      headingBack: " مستطیل کے اندر",
      uploadButton: "یا، شناختی کارڈ اپ لوڈ کریں"
    },
    backDocCapture: {
      heading: "آئی ڈی کا پچھلا حصہ مستطیل میں رکھیں",
      backupHeading: "مسئلہ ہو رہا ہے؟ براہ کرم تصویر کو دستی طور پر کلک کریں",
      btnText: "تصویر کھینچیں",
      containerText: "یا، دستاویز اپلوڈ کریں",
      text: "پکڑ رہا ہے، براہ کرم ساکت رہیں",
      headingBack: " مستطیل کے اندر",
      skipButton: "پچھلے حصے کو چھوڑیں",
      uploadButton: "یا، شناختی کارڈ اپ لوڈ کریں"
    },
    analyzing: {
      heading: "آپ کے آئی ڈی کا تجزیہ کر رہے ہیں...",
      subHeading: "براہ کرم اگلی سکرین پر اپنے کارڈ کی تفصیلات چیک کریں اور ضرورت کے مطابق ایڈٹ کریں"
    },
    imageCheck: {
      heading: "اپنی تصویر چیک کریں",
      subHeading: "براہ کرم یقینی بنائیں کہ تصویر مکمل، واضح اور دھندلاہٹ اور چمک سے پاک ہے۔",
      button1: "دوبارہ تصویر کھینچیں",
      button2: "ٹھیک ہے",
      frontHeading: "سامنے کی تصویر چیک کریں",
      backHeading: "پیچھے کی تصویر چیک کریں"
    },
    errorHandler: {
      heading: "اوه :(",
      subHeading1: "ہم کچھ مسائل کا سامنا کر رہے ہیں، لیکن فکر نہ کریں! براہ کرم دوبارہ کوشش کریں",
      subHeading2: "اگر یہ جاری رہا تو بعد میں چیک کریں",
      button: "دوبارہ کوشش کریں"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "براہ کرم اپنے چہرے کو ڈھانپنے والی کسی بھی چیز کو ہٹا دیں",
        button: "دوبارہ کوشش کریں"
      },
      eyeClosureDetected: {
        heading: "براہ کرم اپنی آنکھیں کھلی رکھیں اور سیدھا کیمرے کی طرف دیکھیں",
        button: "دوبارہ کوشش کریں"
      },
      isMultipleFacesFound: {
        heading: "متعدد چہرے دریافت کیے گئے ہیں۔ یقینی بنائیں کہ کیمرے میں صرف آپ کا چہرہ نظر آ رہا ہے۔",
        button: "دوبارہ کوشش کریں"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "دوبارہ کوشش کریں"
      },
      faceDetections: {
        heading: "براہ کرم اسے ہٹا دیں",
        button: "دوبارہ کوشش کریں"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "کئی چہرے پائے گئے ہیں",
          button: "دوبارہ کوشش کریں"
        },
        generalMessage: {
          heading: "براہ کرم یہ یقینی بنائیں کہ آپ کیمرے کے سامنے زندہ ہیں",
          button: "دوبارہ کوشش کریں"
        }
      },
      faceMatch: {
        heading: "آپ کا چہرہ ID فوٹو سے میل نہیں کھاتا",
        button: "دوبارہ کوشش کریں"
      },
      selfieError: {
        heading: "ہم آپ کی سیلفی کی تصدیق نہیں کر سکے",
        subHeading1: "براہ کرم ان ہدایات پر عمل کریں اور دوبارہ کوشش کریں",
        instruction1: "اچھے روشنی والے علاقے میں جائیں اور پچھلی روشنی سے بچیں",
        instruction2: "یقینی بنائیں کہ آپ کا چہرہ مکمل طور پر نظر آ رہا ہے اور فریم کے درمیان میں ہے",
        instruction3: "اپنے چہرے کو واضح طور پر دیکھنے کے لیے ٹوپی، چشمہ یا ماسک ہٹا دیں",
        button: "دوبارہ کوشش کریں"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP میل نہیں کھایا۔ براہ کرم OTP کو واضح طور پر بلند آواز میں پڑھیں",
        button: "دوبارہ کوشش کریں"
      },
      activeLivenessGenericFailureMessage: {
        heading: "تصدیق ناکام ہوگئی۔ براہ کرم ہدایات پر واضح طور پر عمل کریں اور دوبارہ کوشش کریں",
        button: "دوبارہ کوشش کریں"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF وچ بوہت زیادہ صفحے نيں",
        subHeading: "اپ لوڈ کيتی PDF 2 صفحیاں دی حد توں ودھ اے۔ مہربانی کر کے 2 توں ودھ صفحیاں والی PDF نہ، یا اپنی ID دی صاف تصویر اپ لوڈ کرو۔"
      },
      heading: "ہم آپ کے آئی ڈی کو پروسیس کرنے میں ناکام ہیں",
      subHeading: "یا تو آپ غلط آئی ڈی اپلوڈ کر رہے ہیں یا تصویر واضح نہیں ہے",
      buttonBack: "آئی ڈی کا پچھلا حصہ دوبارہ کوشش کریں",
      buttonFront: "آئی ڈی کا سامنے والا حصہ دوبارہ کوشش کریں",
      button: "دوبارہ کوشش کریں",
      captureFrontSide: "اگلا پاسا کیپچر کرو",
      captureBackSide: "پچھلا پاسا کیپچر کرو",
      changeIDButton: "دوسرا دستاویز منتخب کریں",
      wrongid: {
        heading: "ہم اس دستاویز کو پروسیس نہیں کر سکے",
        subHeading: "براہ کرم اس بات کو یقینی بنائیں کہ آپ درست دستاویز اپلوڈ کر رہے ہیں اور تصویر کی معیار صاف ہے"
      },
      expiredid: {
        heading: "شناختی کارڈ کی میعاد ختم ہو گئی ہے!",
        subHeading: "ہم ایک میعاد ختم ہونے والا شناختی کارڈ قبول نہیں کر سکتے۔ براہ کرم ایک درست دستاویز فراہم کریں"
      },
      minimumage: {
        heading: "عمر کی ضروریات پوری نہیں ہوئیں!",
        subHeading: "آپ کی عمر کم از کم ضروری عمر سے کم ہے۔ براہ کرم اس بات کو یقینی بنائیں کہ آپ کم از کم عمر کی شرائط پوری کرتے ہیں"
      },
      mobileAttemptsDone: {
        heading: "سفر آپ کے پچھلے ڈیوائس پر دوبارہ شروع ہو چکا ہے",
        subHeading: "یہ سیشن اب نقل سے بچنے کے لیے بند کر دیا گیا ہے"
      },
      finished: {
        heading: "سفر مکمل ہو چکا ہے",
        subHeading: "سفر مکمل یا منسوخ کر دیا گیا ہے"
      },
      invalid: {
        heading: "سفر دستیاب نہیں!",
        subHeading: "journeyId نہیں ملا یا journeyId غلط ہے"
      },
      INVALID_PAN_NUMBER: {
        heading: "غلط PAN نمبر",
        subHeading: "آپ نے جو PAN نمبر درج کیا وہ درست نہیں ہے۔ براہ کرم جانچیں اور دوبارہ کوشش کریں"
      },
      INVALID_PAN_STATUS: {
        heading: "غلط PAN اسٹیٹس",
        subHeading: "آپ نے جو PAN نمبر درج کیا وہ درست نہیں ہے۔ براہ کرم جانچیں اور دوبارہ کوشش کریں"
      },
      directKyc: {
        heading: "ڈائریکٹ KYC سفر !",
        subHeading: "یہ ایک ڈائریکٹ KYC سفر ہے۔ فرنٹ اینڈ سفر کی اجازت نہیں ہے۔"
      },
      DOCTYPE_FALSE: {
        heading: "دستاویز شناخت نہیں کی جا سکی!",
        subHeading: "براہ کرم ایک درست دستاویز اپلوڈ کریں اور تصویر کی معیار اچھی ہو"
      },
      ONLY_FRONT: {
        heading: "شناختی دستاویز کا پچھلا رخ غائب ہے",
        subHeading: "آپ نے صرف سامنے کا رخ اپلوڈ کیا ہے۔ براہ کرم شناختی دستاویز کو پلٹیں اور جاری رکھنے کے لیے پچھلا رخ اپلوڈ کریں"
      },
      ONLY_BACK: {
        heading: "شناختی دستاویز کا سامنے والا رخ غائب ہے",
        subHeading: "آپ نے صرف پچھلا رخ اپلوڈ کیا ہے۔ براہ کرم شناختی دستاویز کو پلٹیں اور جاری رکھنے کے لیے سامنے والا رخ اپلوڈ کریں"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "دستاویز جلد میعاد ختم ہونے والی ہے!",
        subHeading: "دستاویز کو مسترد کر دیا گیا ہے کیونکہ اس کی میعاد جلد ختم ہونے والی ہے۔"
      },
      DOCUMENT_EXPIRED: {
        heading: "دستاویز کی میعاد ختم ہو گئی ہے!",
        subHeading: "براہ کرم ایک درست اور غیر منسوخ دستاویز اپلوڈ کریں"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "عمر کی ضروریات پوری نہیں ہوئیں!",
        subHeading: "دستاویز بتاتی ہے کہ آپ کی عمر مطلوبہ عمر سے کم ہے۔ براہ کرم ایک درست دستاویز اپلوڈ کریں"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "تصویر کا معیار بہت کم ہے۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "کچھ معلومات کی تصدیق نہیں کی جا سکی۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "کچھ تفصیلات خراب تصویر کے معیار کی وجہ سے تصدیق نہیں ہو سکیں۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "دستاویز کی تصدیق نہیں کی جا سکی!",
        subHeading: "کچھ تفصیلات تصدیق نہیں ہو سکیں۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "شناختی کارڈ پر آپ کی تصویر کی تصدیق میں مسئلہ",
        subHeading: "ہم شناختی کارڈ پر موجود آپ کی تصویر کی تصدیق نہیں کر سکے۔ براہ کرم اصل شناختی دستاویز کی واضح تصویر اپلوڈ کریں تاکہ ہم اس کی تصدیق کر سکیں۔"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "دستاویز کے سیکیورٹی پیٹرن کی تصدیق ناکام ہوگئی",
        subHeading: "ہم دستاویز میں موجود بلٹ ان سیکیورٹی پیٹرنز کی تصدیق نہیں کر سکے۔ براہ کرم اصل شناختی دستاویز کی واضح تصویر اپلوڈ کریں تاکہ ہم اس کی صداقت کی تصدیق کر سکیں۔"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "دستاویز کی زندگی کی جانچ ناکام ہو گئی",
        subHeading: "ہمیں ایسے شواہد ملے ہیں کہ یہ دستاویز اصلی نہیں ہو سکتی۔ براہ کرم اسکرین شاٹس، پرنٹ شدہ کاپیاں یا اسکرین پر دکھائی گئی شناختی دستاویزات استعمال نہ کریں۔ اصل دستاویز اپ لوڈ کریں جس میں تمام خصوصیات واضح طور پر نظر آئیں۔"
      },
      SECURITY_FALSE: {
        heading: "مسئلہ دریافت ہوا ہے!",
        subHeading: "دستاویز کی تصدیق نہیں کی جا سکی۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "تصویر کا معیار خراب ہے!",
        subHeading: "تصویر بہت دھندلی یا غیر واضح ہے۔ براہ کرم ایک واضح تصویر کے ساتھ دوبارہ کوشش کریں"
      },
      FACE_UNDETECTED: {
        heading: "چہرہ دریافت نہیں ہوا",
        subHeading: "ہم دستاویز میں کوئی واضح چہرہ نہیں ڈھونڈ سکے۔ براہ کرم ایک درست شناختی کارڈ اپ لوڈ کریں جس میں چہرہ واضح طور پر دکھائی دے۔"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "دستاویزات کے درمیان موازنہ ناکام",
        subHeading: "ایک یا زیادہ اہم خانوں (نام، تاریخ پیدائش، یا چہرہ) میں عدم مطابقت کی وجہ سے دستاویزات کے درمیان موازنہ ناکام ہوا"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker ناکامی",
        subHeading: "Digilocker کے سفر کے دوران ایک خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں یا جاری رکھنے کے لیے کوئی متبادل طریقہ استعمال کریں۔"
      },
      LINKAGE_FAILED: {
        heading: "ایہ تصدیق مکمل نہیں ہو سکی",
        subHeading: "ایس جانچ لئی لئی گئی تفصیلات ریکارڈ نال نہیں ملدیاں۔"
      }
    },
    biometricConsent: {
      consentStatement: "ਤੁਹਾਡੀ ਸੈਲਫੀ ਤੋਂ ਪਹਿਲਾਂ, ਤੁਹਾਡੀ ਪਛਾਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਸਾਨੂੰ ਤੁਹਾਡਾ ਬਾਇਓਮੈਟ੍ਰਿਕ ਡਾਟਾ (ਚਿਹਰੇ ਦੀ ਤਸਵੀਰ ਅਤੇ ਲਾਈਵਨੈੱਸ ਸਿਗਨਲ) ਕੈਪਚਰ ਅਤੇ ਪ੍ਰੋਸੈਸ ਕਰਨ ਲਈ ਤੁਹਾਡੀ ਸਹਿਮਤੀ ਚਾਹੀਦੀ ਹੈ। ਇਹ ਡਾਟਾ ਸਿਰਫ਼ ਇਸੇ ਪੁਸ਼ਟੀ ਲਈ ਵਰਤਿਆ ਜਾਂਦਾ ਹੈ।",
      privacyPolicy: "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
      consentButton: "ਮੈਂ ਸਹਿਮਤ ਹਾਂ — ਜਾਰੀ ਰੱਖੋ",
      declineButton: "ਮੈਂ ਸਹਿਮਤ ਨਹੀਂ ਹਾਂ",
      confirmTitle: "ਬਾਇਓਮੈਟ੍ਰਿਕ ਪੁਸ਼ਟੀ ਤੋਂ ਬਿਨਾਂ ਅੱਗੇ ਵਧਣਾ ਹੈ?",
      confirmBody: "ਬਾਇਓਮੈਟ੍ਰਿਕ ਪੁਸ਼ਟੀ ਤੋਂ ਬਿਨਾਂ, ਅਸੀਂ ਸੈਲਫੀ ਨਹੀਂ ਲਵਾਂਗੇ। ਤੁਹਾਡੀ ਪੁਸ਼ਟੀ ਤੁਹਾਡੇ ਵੱਲੋਂ ਪਹਿਲਾਂ ਦਿੱਤੀ ਜਾਣਕਾਰੀ ਵਰਤ ਕੇ ਪੂਰੀ ਕੀਤੀ ਜਾਵੇਗੀ। ਇਹ ਚੋਣ ਇਸ ਸੈਸ਼ਨ ਲਈ ਅੰਤਿਮ ਹੈ।",
      goBack: "ਵਾਪਸ",
      confirmDecline: "ਪੁਸ਼ਟੀ ਕਰੋ — ਸਹਿਮਤ ਨਹੀਂ",
      declineComplete: "ਤੁਸੀਂ ਬਾਇਓਮੈਟ੍ਰਿਕ ਪੁਸ਼ਟੀ ਨਾਲ ਅੱਗੇ ਨਾ ਵਧਣ ਦੀ ਚੋਣ ਕੀਤੀ ਹੈ। ਤੁਹਾਡੇ ਵੱਲੋਂ ਜਮ੍ਹਾਂ ਕੀਤੇ ਦਸਤਾਵੇਜ਼ ਵਰਤ ਕੇ ਤੁਹਾਡੀ ਪਛਾਣ ਦੀ ਪੁਸ਼ਟੀ ਪੂਰੀ ਹੋ ਗਈ ਹੈ।"
    },
    introLiveness: {
      heading: "یہاں اپنی موجودگی کی تصدیق کریں",
      instruction1: "یقینی بنائیں کہ کافی روشنی ہے",
      instruction2: "ضروری اجازتیں دیں",
      instruction3: "بس ہدایات پر عمل کریں",
      button: "آگے بڑھیں",
      subHeading: "آپ بس ایک قدم کی دوری پر ہیں"
    },
    phoneSession: {
      heading: "سیشن فون پر جاری ہے",
      subheading: "موبائل پر مکمل ہونے تک اس ونڈو کو کھلا رکھیں",
      button: "یہاں جاری رکھیں"
    },
    continueOnPhone: {
      heading: "فون پر جاری رکھیں",
      subheading: "کیو آر کوڈ سکین کریں یا نیچے دی گئی لنک کو کاپی کریں",
      subheading2: "کیو آر کوڈ سکین کریں یا اپنے فون پر لنک کھولیں",
      text: "عمل مکمل کریں",
      text1: "یہاں چیک کریں اور جمع کریں",
      button: "کاپی کریں",
      copiedButton: "کاپی ہو گیا!",
      copied: "کاپی ہو گیا!"
    },
    SsnReview: {
      heading: "اپنی تفصیلات کا جائزہ لیں",
      subHeading: "ضروری تبدیلیاں کریں اور تفصیلات جمع کریں",
      feild1: "ڈرائیونگ لائسنس",
      feild2: "میعاد ختم",
      feild3: "تاریخ پیدائش",
      feild4: "کلاس",
      feild5: "پابندیاں",
      feild6: "ملک",
      feild7: "پتہ",
      button: "تفصیلات درست ہیں"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ دائرے میں رکھیں"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "کیمرے کے قریب آئیں"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "شرمائیں نہیں، سامنے آئیں"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت اندھیرا ہے۔ زیادہ روشنی میں جائیں"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت روشن ہے۔ ہلکی روشنی میں جائیں"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ دائرے میں رکھیں"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ساکن رہیں"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "روشنی کی طرف چہرہ کریں"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "فون کو آنکھوں کی سطح پر رکھیں"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "کیمرے سے تھوڑا دور ہوں"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ فریم کے درمیان رکھیں"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ دائرے دے وچ رکھو"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "نیڑے آؤ تے اپنا چہرہ سیدھا رکھو"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "نظر وچ آؤ تے اپنا چہرہ سیدھا رکھو"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت اندھیرا ہے۔ روشن روشنی تلاش کریں"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "بہت روشن ہے۔ مناسب روشنی تلاش کریں"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "اپنا چہرہ دائرے دے وچکار ایڈجسٹ کرو"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "مضبوطی نال کھڑے رہو تے سیدھا اگے دیکھو"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "روشنی ول منہ کرو تے مضبوطی نال کھڑے رہو"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "اپنے فون کو آنکھوں کی سطح پر رکھیں"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "کیمرے سے تھوڑا دور ہٹیں"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "بالکل ٹھیک!"
      },
      smile1: {
        icon: "mood",
        description: "مسکرائیں، آپ بہت اچھے لگ رہے ہیں!"
      },
      smile2: {
        icon: "mood",
        description: "کیمرے کے لئے مسکرائیں!"
      }
    },
    successful: {
      title: "تصدیق مکمل",
      text: "آپ اب ونڈو بند کر سکتے ہیں",
      finishBtn: "ختم کریں"
    },
    poweredBy: "چلایا جا رہا ہے",
    redirect: "میں منتقل کیا جا رہا ہے",
    error: {
      message: "URL کی میعاد ختم ہو گئی ہے یا غلط ہے"
    },
    footer: {
      securedBy: "چلایا جا رہا ہے"
    },
    helpFaq: {
      title: "مدد اور اکثر پوچھے گئے سوالات",
      subtitle: "ہم یہاں آپ کی مدد کے لیے ہیں",
      cameraText: "آپ کی شناخت کی تصدیق کرنے کے لیے، ہمیں آپ کے ڈیوائس کے کیمرے کا استعمال کرتے ہوئے تصاویر لینے کی ضرورت ہے۔ ضروری اجازتیں دینے کے طریقہ کار کو جاننے کے لیے اس link پر کلک کریں",
      cameraHeading: "کیمرہ کی اجازت",
      languageText: "عمل کے آغاز میں، آپ اوپر کی بار میں ڈراپ ڈاؤن مینو سے اپنی پسند کی زبان منتخب کر سکتے ہیں",
      languageHeading: "زبان کا انتخاب",
      kycText: "KYC، یا 'اپنے گاہک کو جانیں'، ایک عمل ہے جس میں گاہک کی شناخت کی تصدیق اور تصدیق کی جاتی ہے، جو تعمیل کو یقینی بنانے اور دھوکہ دہی اور دیگر غیر قانونی سرگرمیوں کو روکنے میں مدد کرتی ہے",
      kycHeading: "KYC کا کیا مطلب ہے؟",
      timeText: "عام طور پر، اس میں تقریباً 60 سیکنڈ لگتے ہیں۔ تاہم، یہ ممالک کے لحاظ سے مختلف ہو سکتا ہے",
      timeHeading: "اس میں کتنا وقت لگے گا؟"
    },
    pdfPreviewUnavailable: "PDF کا پیش منظر دکھانے سے قاصر۔",
    pdfPreviewHint: "اگر پیش منظر ظاہر نہ ہو، تب بھی آپ جاری رکھ سکتے ہیں۔",
    pdfOpenLabel: "PDF کھولیں",
    failedUpload: {
      title: "فائل اپ لوڈ ناکام",
      text: "براہ کرم یقینی بنائیں کہ فائل 5MB سے کم اور .jpg، .jpeg، .png، .heic، .heif یا .pdf فارمیٹ میں ہے",
      btn: "دوبارہ کوشش کریں",
      pdfNotAllowedIndia: "بھارت کے لیے PDF اپ لوڈ کی اجازت نہیں ہے۔ براہ کرم 5 MB سے کم کی JPEG، JPG، PNG، HEIC، یا HEIF فائلیں اپ لوڈ کریں۔",
      pdfNotAllowedIndiaBasic: "بھارت کے لیے PDF اپ لوڈ کی اجازت نہیں ہے۔ براہ کرم 5 MB سے کم کی JPEG، JPG، یا PNG فائلیں اپ لوڈ کریں۔"
    },
    livenessAnalyzing: {
      heading: "آپ کے چہرے کا تجزیہ کیا جا رہا ہے",
      subHeading: "براہ کرم انتظار کریں، اس میں صرف چند سیکنڈ لگیں گے"
    },
    sessionExpiredError: {
      heading: "معذرت، آپ کا سیشن ختم ہو گیا ہے",
      subHeading1: "آپ کچھ وقت کے لیے غیر فعال رہے ہیں۔ سیکیورٹی کی تشویشات کی وجہ سے، آپ کا سیشن خودبخود ختم ہو گیا ہے",
      subHeading2: "براہ کرم دوبارہ کوشش کریں",
      buttonText: "دوبارہ کوشش کریں"
    },
    journeyExpiredError: {
      heading: "معذرت، لنک کی مدت ختم ہو گئی ہے",
      subHeading1: "لنک اب فعال نہیں ہے۔ سیکیورٹی کی تشویشات کی وجہ سے، لنکس کی محدود مدت ہوتی ہے",
      subHeading2: "براہ کرم نئے لنک کے ساتھ کوشش کریں",
      buttonText: "دوبارہ کوشش کریں"
    },
    cameraAccessError: {
      alert1: "کیمرے کی رسائی مسترد کر دی گئی ہے۔ براہ کرم اپنے براؤزر کی ترتیبات میں کیمرے کی رسائی کو فعال کریں",
      alert2: "کیمرے تک رسائی کے دوران ایک خرابی پیش آئی",
      alert3: "آپ کا براؤزر کیمرے کی رسائی کی حمایت نہیں کرتا"
    },
    activeLiveness: {
      instruction: "اپنے چہرے کو دائرے میں رکھیں اور ہدایات پر عمل کریں",
      permissionDeniedTitle: "کیمرا یا مائیکروفون تک رسائی مسترد",
      permissionDeniedSubtitle: "براہ کرم اپنی براؤزر سیٹنگز میں کیمرا اور مائیکروفون تک رسائی کی اجازت دیں اور دوبارہ کوشش کریں۔"
    },
    flipScreen: {
      heading: "اب اپنا شناختی کارڈ پلٹیں",
      subHeading: "براہ کرم پچھلی طرف دکھانے کے لیے اپنا شناختی کارڈ جسمانی طور پر پلٹیں، پھر اسے کیمرہ فریم میں رکھیں۔",
      continueButton: "جاری رکھیں"
    },
    mobileDocCapture: {
      frontSide: "اگلا پاسا",
      backSide: "پچھلا پاسا",
      of: "دا",
      upload: "اپ لوڈ کرو",
      stillNotWorking: "ہلے وی کم نئیں کر ریا؟",
      clickToCapture: "کلک-ٹو-کیپچر ازماؤ",
      skip: "چھڈو"
    }
,
    permissionPopUp: {
      title: "اجازت لوڑیندی اے",
      subtitle: "کیمرہ ورتن لئی پہنچ دی اجازت دیو",
      decline: "انکار کرو",
      allow: "اجازت دیو"
    },
    userDetails: {
      heading: "PAN تصدیق",
      subHeading: "تصدیق لئی مہربانی کر کے تفصیلاں بھرو",
      panLabel: "PAN نمبر",
      panRequired: "مہربانی کر کے اپنا PAN نمبر درج کرو",
      saveError: "تفصیلاں محفوظ کردیاں کجھ غلط ہو گیا۔ مہربانی کر کے دوبارہ کوشش کرو۔",
      proceed: "اگے ودھو"
    },
    redirectCta: {
      or: "یا",
      clickHere: "ایتھے کلک کرو",
      clickHereStart: "ایتھے کلک کرو",
      toContinue: "جاری رکھن لئی"
    },
    documentCapture: {
      stillNotWorking: "ہلے وی کم نہیں کر رہیا؟",
      clickToCaptureInstead: "ایہدے بجائے کلک ٹو کیپچر ازماؤ",
      pdfNotAllowedIndia: "بھارت لئی PDF اپ لوڈ دی اجازت نہیں۔ مہربانی کر کے 5 MB توں گھٹ JPEG, JPG, یا PNG فائلاں اپ لوڈ کرو۔",
      pdfNotAllowedIndiaMobile: "بھارت لئی PDF اپ لوڈ دی اجازت نہیں۔ مہربانی کر کے 5 MB توں گھٹ JPEG, JPG, PNG, HEIC, یا HEIF فائلاں اپ لوڈ کرو۔",
      fileFormatsIndia: "jpeg, jpg, png 5 mb توں گھٹ",
      fileFormats: "jpeg, jpg, png, pdf 5 mb توں گھٹ",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif 5 mb توں گھٹ",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf 5 mb توں گھٹ"
    },
    mobileCapture: {
      upload: "اپ لوڈ کریں",
      skip: "چھوڑیں",
      stillNotWorking: "پھر بھی کام نہیں کر رہا؟",
      tryClickToCapture: "ٹیپ کرکے تصویر لیں"
    },
    UserDetails: {
      panLabel: "PAN نمبر",
      proceedBtn: "آگے بڑھیں",
      panRequired: "براہ کرم اپنا PAN نمبر درج کریں",
      saveError: "تفصیلات محفوظ کرتے وقت کچھ غلط ہو گیا۔ براہ کرم دوبارہ کوشش کریں۔"
    }
  },
  wuu: {
    header: {
      title: "来验证侬的身份",
      subtitle: "只要不到2分钟",
      havingIssue: "遇到问题了？"
    },
    subHeading: {
      subHeading1: "拍一下侬的身份证件",
      subHeading2: "确认侬是活着的",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    onlyIdVerificationHeader: {
      title: "来验证侬的身份",
      subtitle: "只要一小会，记得把侬的证件准备好。",
      instruction1: "请允许使用相机",
      instruction2: "扫描或上传侬的证件",
      instruction3: "立刻完成证件验证"
    },
    termsAndCondition: {
      title: "我同意遵守以下条款和条件。",
      privacyPolicy: "查看条款",
      beginBtnText: "开始",
      beginLiveness: "开始活体检查",
      startLiveness: "继续进行活体检查"
    },
    permissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的摄像头图标，并将其解除屏蔽。",
      readMore: "了解更多",
      refreshText: "授予权限后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或者，用手机继续",
      buttonText: "或者，用手机继续"
    },
    desktopBrowserPermissionDenied: {
      title: "请允许摄像头访问",
      subtitle: "浏览器可能会请求权限。请点击“允许”继续。",
      readMore: "了解更多",
      refreshText: "授予权限后刷新",
      refreshBtn: "刷新",
      link: "或者，用手机继续",
      buttonText: "或者，用手机继续"
    },
    androidBrowserPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的摄像头图标，并解除屏蔽。",
      readMore: "了解更多",
      refreshText: "允许访问摄像头后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或在手机上继续",
      buttonText: "或在手机上继续"
    },
    androidWebViewPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "摄像头访问可能被应用设置所限制。请进入手机“应用信息” > “权限” > “摄像头”，并启用权限。",
      refreshText: "允许访问摄像头后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或在手机上继续",
      buttonText: "或在手机上继续"
    },
    iosBrowserPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "请点击地址栏旁边的摄像头或锁图标以允许访问，或检查浏览器设置。",
      readMore: "了解更多",
      refreshText: "允许访问摄像头后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或在手机上继续",
      buttonText: "或在手机上继续"
    },
    iosWebViewPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "摄像头访问可能被系统设置限制。请前往“设置”，找到该应用并启用摄像头权限。",
      refreshText: "允许访问摄像头后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或在手机上继续",
      buttonText: "或在手机上继续"
    },
    documentationList: {
      countryHeading: "选择国家",
      docHeading: "选择侬的文件",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "把身份证的正面放在框里",
      backupHeading: "有问题？请手动点击图片",
      btnText: "拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "把身份证的背面放在框里",
      backupHeading: "有问题？请手动点击图片",
      btnText: "拍照",
      containerText: "或者，上传文件",
      text: "拍摄中，请保持不动",
      headingBack: "放入矩形框内",
      skipButton: "跳过背面",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "正在分析侬的身份证...",
      subHeading: "请在下一屏检查侬的卡片信息，如有必要请编辑"
    },
    imageCheck: {
      heading: "检查侬的照片",
      subHeading: "请确保照片完整、清晰、无模糊和眩光。",
      button1: "重新拍照",
      button2: "没问题",
      frontHeading: "检查侬的正面照片",
      backHeading: "检查侬的背面照片"
    },
    errorHandler: {
      heading: "哎呀 :(",
      subHeading1: "我们遇到了一些问题，但不要担心！请再试一次",
      subHeading2: "如果问题持续存在，请稍后再试",
      button: "再试一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "请把遮住侬面个物件撤掉",
        button: "重试一遍"
      },
      eyeClosureDetected: {
        heading: "请睁开眼睛，直视摄像头",
        button: "再试一次"
      },
      isMultipleFacesFound: {
        heading: "检测到多个面孔。请确保摄像头中只显示您的面孔。",
        button: "重试一遍"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "重试一遍"
      },
      faceDetections: {
        heading: "请把这个撤掉",
        button: "重试一遍"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "看到好几个面",
          button: "重试一遍"
        },
        generalMessage: {
          heading: "请确保侬活在摄像头前头",
          button: "重试一遍"
        }
      },
      faceMatch: {
        heading: "侬个面同身份证照片对不上",
        button: "重试一遍"
      },
      selfieError: {
        heading: "我们没法确认侬个自拍",
        subHeading1: "请按照这些提示再试一次",
        instruction1: "换个好点的光线地方，避免逆光",
        instruction2: "确保侬个面完全看得见，且处在画面中心",
        instruction3: "为了让侬个面清晰可见，请拿掉帽子、眼镜或口罩",
        button: "重试一遍"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "验证勿通过。请侬照说明清爽地做，再试一遍",
        button: "重试一遍"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 页数太多",
        subHeading: "上传个 PDF 超过 2 页限制。请上传勿超过 2 页个 PDF，或者清晰个证件照片。"
      },
      heading: "我们无法处理侬的身份证",
      subHeading: "侬可能上传了错误的身份证件或照片不清晰",
      buttonBack: "重试身份证的背面",
      buttonFront: "重试身份证的正面",
      button: "再试一次",
      captureFrontSide: "拍摄正面",
      captureBackSide: "拍摄背面",
      changeIDButton: "选择另一个文档",
      wrongid: {
        heading: "我们无法处理此文档",
        subHeading: "请确保您上传的是正确的文档，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证件已过期！",
        subHeading: "我们不能接受过期的身份证件，请提供有效的文档"
      },
      minimumage: {
        heading: "年龄要求不符合！",
        subHeading: "您的年龄未达到最低要求，请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "您的旅程已在之前的设备上恢复",
        subHeading: "此会话已停止，以避免重复操作"
      },
      finished: {
        heading: "旅程已结束",
        subHeading: "旅程已完成或终止"
      },
      invalid: {
        heading: "旅程不可用！",
        subHeading: "未找到旅程ID或旅程ID无效"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      DOCTYPE_FALSE: {
        heading: "无法识别文档！",
        subHeading: "请上传有效的文档，并确保图像质量良好"
      },
      ONLY_FRONT: {
        heading: "缺少身份证背面",
        subHeading: "您只上传了身份证正面。请翻转您的身份证并上传背面以继续操作"
      },
      ONLY_BACK: {
        heading: "缺少身份证正面",
        subHeading: "您只上传了身份证背面。请翻转您的身份证并上传正面以继续操作"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期！",
        subHeading: "由于文档即将过期，因此已被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年龄要求未达标！",
        subHeading: "文档显示您的年龄未达到要求，请上传有效的文档"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法进行验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "无法验证您在身份证上的照片",
        subHeading: "我们无法验证您在身份证上的照片。请上传一张原始身份证的清晰照片，以便我们进行确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案验证失败",
        subHeading: "我们无法验证文档内置的安全图案。请上传原始身份证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文件活体检测失败",
        subHeading: "我们发现该文件可能不是真实的。请不要使用屏幕截图、打印件或在屏幕上展示的身份证明。请上传所有特征清晰可见的原始证件。"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "文档无法验证，请重新上传更清晰的图像"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像模糊或不清晰，请重新上传更清晰的图像"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档中找到清晰可见的面部。请上传一张面部清晰可见的有效身份证件。"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "在这里确认侬是活的",
      instruction1: "确保光线充足",
      instruction2: "允许必要的权限",
      instruction3: "只需按照指示操作",
      button: "继续",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "会话在手机上继续",
      subheading: "在手机上完成前，请保持此窗口打开",
      button: "在这里继续"
    },
    continueOnPhone: {
      heading: "在手机上继续",
      subheading: "扫描二维码或复制下面的链接",
      subheading2: "扫描二维码或在侬的手机上打开链接",
      text: "完成流程",
      text1: "在此处检查以提交",
      button: "复制",
      copiedButton: "拷好哉！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "检查侬的信息",
      subHeading: "进行必要的更改并提交详细信息",
      feild1: "驾驶执照",
      feild2: "到期日",
      feild3: "出生日期",
      feild4: "类别",
      feild5: "限制",
      feild6: "国家",
      feild7: "地址",
      button: "信息正确"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "把侬个面孔放到圆圈中间"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近点，面孔保持正对"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "走进画面，面孔保持正对"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了。找个更亮的光源"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了。找个合适的光源"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "把侬个面孔调到圆圈中间"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "勿要动，眼睛看前头"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面孔对牢光线，勿要动"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "把手机保持在眼睛高度"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "离摄像头远一点"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美!"
      },
      smile1: {
        icon: "mood",
        description: "请微笑，侬看起来很棒!"
      },
      smile2: {
        icon: "mood",
        description: "对着摄像头微笑!"
      }
    },
    successful: {
      title: "验证完成",
      text: "侬可以现在关闭窗口了",
      finishBtn: "完成"
    },
    poweredBy: "技术支持",
    redirect: "重定向中",
    error: {
      message: "URL已过期或无效"
    },
    footer: {
      securedBy: "技术支持"
    },
    helpFaq: {
      title: "帮助与常见问题",
      subtitle: "我们在这里帮助你",
      cameraText: "为了验证你的身份，我们需要使用你的设备摄像头拍摄照片。点击此 link 了解如何授予所需权限",
      cameraHeading: "相机权限",
      languageText: "在流程开始时，你可以通过从顶部栏的下拉菜单中选择来选择你喜欢的语言",
      languageHeading: "语言选择",
      kycText: "KYC，或“了解你的客户”，是一个验证和确认客户身份的过程，有助于确保合规并防止欺诈和其他非法活动",
      kycHeading: "什么是KYC？",
      timeText: "通常情况下，这大约需要60秒。但这可能因国家而异",
      timeHeading: "这需要多长时间？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已经一段时间没有操作。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接具有有限的有效期",
      subHeading2: "请使用新的链接尝试",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "相机访问被拒绝。请在浏览器设置中启用相机访问",
      alert2: "访问相机时发生错误",
      alert3: "您的浏览器不支持相机访问"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "个",
      upload: "上传",
      stillNotWorking: "还呒没用？",
      clickToCapture: "试试点击拍摄",
      skip: "跳过"
    }
,
    permissionPopUp: {
      title: "需要权限",
      subtitle: "允许访问来用摄像头",
      decline: "拒绝",
      allow: "允许"
    },
    userDetails: {
      heading: "PAN 验证",
      subHeading: "请填好详细信息来验证",
      panLabel: "PAN 号码",
      panRequired: "请输入侬个 PAN 号码",
      saveError: "保存详细信息辰光出问题了。请重试。",
      proceed: "继续"
    },
    redirectCta: {
      or: "或者",
      clickHere: "点搿搭",
      clickHereStart: "点搿搭",
      toContinue: "来继续"
    },
    documentCapture: {
      stillNotWorking: "还是勿好用？",
      clickToCaptureInstead: "改用点击拍摄试试看",
      pdfNotAllowedIndia: "印度勿好上传 PDF。请上传小于 5 MB 个 JPEG、JPG 或 PNG 文件。",
      pdfNotAllowedIndiaMobile: "印度勿好上传 PDF。请上传小于 5 MB 个 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      fileFormatsIndia: "jpeg、jpg、png 小于 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 小于 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 小于 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 小于 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  },
  yue: {
    header: {
      title: "驗證你嘅身份",
      subtitle: "只需少於2分鐘",
      havingIssue: "遇到问题了？"
    },
    subHeading: {
      subHeading1: "拍你嘅身份證文件",
      subHeading2: "確認你係真人",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    termsAndCondition: {
      title: "我同意遵守以下條款及條件。",
      privacyPolicy: "查看條款",
      beginBtnText: "開始",
      beginLiveness: "開始真實性檢查",
      startLiveness: "進行真實性檢查"
    },
    permissionDenied: {
      title: "攝像頭訪問被拒絕！",
      subtitle: "請檢查瀏覽器地址欄附近是否有被封鎖的攝像頭圖示，並將其解鎖。",
      readMore: "了解更多",
      refreshText: "授權後，請點擊下方的「刷新」按鈕。",
      refreshBtn: "刷新",
      link: "或者，繼續用手機",
      buttonText: "或者，繼續用手機"
    },
    desktopBrowserPermissionDenied: {
      title: "請允許攝像頭訪問",
      subtitle: "瀏覽器可能會請求權限。請點擊“允許”繼續。",
      readMore: "了解更多",
      refreshText: "授權後刷新",
      refreshBtn: "刷新",
      link: "或者，繼續用手機",
      buttonText: "或者，繼續用手機"
    },
    androidBrowserPermissionDenied: {
      title: "攝像頭訪問被拒絕！",
      subtitle: "請檢查瀏覽器地址列附近是否有被封鎖的攝像頭圖示，並解除封鎖。",
      readMore: "了解更多",
      refreshText: "允許攝像頭訪問後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或，在手機上繼續",
      buttonText: "或，在手機上繼續"
    },
    androidWebViewPermissionDenied: {
      title: "攝像頭訪問被拒絕！",
      subtitle: "攝像頭可能被應用程式設定所封鎖。請前往 App 資訊 > 權限 > 攝像頭，並啟用訪問權限。",
      refreshText: "允許攝像頭訪問後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或，在手機上繼續",
      buttonText: "或，在手機上繼續"
    },
    iosBrowserPermissionDenied: {
      title: "攝像頭訪問被拒絕！",
      subtitle: "請點擊地址列旁的攝像頭或鎖定圖示以啟用訪問，或檢查瀏覽器設定。",
      readMore: "了解更多",
      refreshText: "允許攝像頭訪問後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或，在手機上繼續",
      buttonText: "或，在手機上繼續"
    },
    iosWebViewPermissionDenied: {
      title: "攝像頭訪問被拒絕！",
      subtitle: "攝像頭訪問可能已在系統設定中被封鎖。請開啟「設定」，找到此應用程式，然後啟用攝像頭權限。",
      refreshText: "允許攝像頭訪問後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或，在手機上繼續",
      buttonText: "或，在手機上繼續"
    },
    documentationList: {
      countryHeading: "選擇國家",
      docHeading: "選擇你嘅文件",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "將身份證正面放喺框內",
      backupHeading: "有問題？請手動點擊圖片",
      btnText: "拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "將身份證背面放喺框內",
      backupHeading: "有問題？請手動點擊圖片",
      btnText: "拍照",
      containerText: "或者，上傳文件",
      text: "拍攝中，請保持穩定",
      headingBack: "放入矩形框内",
      skipButton: "跳过背面",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "分析你嘅身份證...",
      subHeading: "請喺下一個屏幕檢查你嘅卡片詳細資料，如果需要請編輯"
    },
    imageCheck: {
      heading: "檢查你嘅圖片",
      subHeading: "請確保圖片完整、清晰，無模糊同反光。",
      button1: "重拍",
      button2: "無問題",
      frontHeading: "檢查你嘅正面圖片",
      backHeading: "檢查你嘅背面圖片"
    },
    errorHandler: {
      heading: "唔好意思 :(",
      subHeading1: "我哋遇到咗啲問題，但唔使擔心！請再試一次",
      subHeading2: "如果呢個問題持續存在，請稍後再試",
      button: "再試一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "請移除任何遮住你面嘅物品",
        button: "再試一次"
      },
      eyeClosureDetected: {
        heading: "請保持雙眼張開，直望鏡頭",
        button: "再試一次"
      },
      isMultipleFacesFound: {
        heading: "檢測到多個面孔。請確保鏡頭中只顯示您的面孔。",
        button: "再試一次"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "再試一次"
      },
      faceDetections: {
        heading: "請移除呢個",
        button: "再試一次"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "發現咗多個面孔",
          button: "再試一次"
        },
        generalMessage: {
          heading: "請確保你係攝像頭前面係活嘅",
          button: "再試一次"
        }
      },
      faceMatch: {
        heading: "你嘅面孔同身份證相片唔配對",
        button: "再試一次"
      },
      selfieError: {
        heading: "我哋無法驗證你嘅自拍照",
        subHeading1: "請跟隨以下提示，再試一次",
        instruction1: "換個光線充足嘅地方，避免背光",
        instruction2: "確保你嘅面完全可見，並且處於畫面中心",
        instruction3: "為咗清楚顯示你嘅面孔，請移除帽子、眼鏡或者口罩",
        button: "再試一次"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "驗證失敗。請清楚噉跟住指示再試一次",
        button: "再試一次"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 頁數太多",
        subHeading: "上載嘅 PDF 超過 2 頁上限。請上載唔多過 2 頁嘅 PDF，或者你證件嘅清晰相片。"
      },
      heading: "我哋無法處理你嘅身份證",
      subHeading: "可能你上傳咗錯誤嘅身份證件或者圖片唔清晰",
      buttonBack: "重試身份證背面",
      buttonFront: "重試身份證正面",
      button: "再試一次",
      captureFrontSide: "影正面",
      captureBackSide: "影背面",
      changeIDButton: "选择另一个文档",
      wrongid: {
        heading: "我们无法处理此文档",
        subHeading: "请确保您上传的是正确的文档，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证件已过期！",
        subHeading: "我们不能接受过期的身份证件，请提供有效的文档"
      },
      minimumage: {
        heading: "年龄要求不符合！",
        subHeading: "您的年龄未达到最低要求，请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "您的旅程已在之前的设备上恢复",
        subHeading: "此会话已停止，以避免重复操作"
      },
      finished: {
        heading: "旅程已结束",
        subHeading: "旅程已完成或终止"
      },
      invalid: {
        heading: "旅程不可用！",
        subHeading: "未找到旅程ID或旅程ID无效"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      DOCTYPE_FALSE: {
        heading: "无法识别文档！",
        subHeading: "请上传有效的文档，并确保图像质量良好"
      },
      ONLY_FRONT: {
        heading: "缺少身份证背面",
        subHeading: "您只上传了身份证正面。请翻转您的身份证并上传背面以继续操作"
      },
      ONLY_BACK: {
        heading: "缺少身份证正面",
        subHeading: "您只上传了身份证背面。请翻转您的身份证并上传正面以继续操作"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期！",
        subHeading: "由于文档即将过期，因此已被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年龄要求未达标！",
        subHeading: "文档显示您的年龄未达到要求，请上传有效的文档"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法进行验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "无法验证您在身份证上的照片",
        subHeading: "我们无法验证您在身份证上的照片。请上传一张原始身份证的清晰照片，以便我们进行确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案验证失败",
        subHeading: "我们无法验证文档内置的安全图案。请上传原始身份证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文件活体检测失败",
        subHeading: "我们发现该文件可能不是真实的。请不要使用屏幕截图、打印件或在屏幕上展示的身份证明。请上传所有特征清晰可见的原始证件。"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "文档无法验证，请重新上传更清晰的图像"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像模糊或不清晰，请重新上传更清晰的图像"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档中找到清晰可见的面部。请上传一张面部清晰可见的有效身份证件。"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "喺呢度確認你係真人",
      instruction1: "確保有足夠嘅光線",
      instruction2: "允許必要嘅權限",
      instruction3: "只需按照指示操作",
      button: "繼續",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "會話喺手機繼續",
      subheading: "喺手機完成之前，請保持窗口打開",
      button: "喺呢度繼續"
    },
    continueOnPhone: {
      heading: "喺手機上繼續",
      subheading: "掃描QR碼或者複製下面嘅鏈接",
      subheading2: "掃描QR碼或者喺你嘅手機上打開鏈接",
      text: "完成流程",
      text1: "喺呢度檢查並提交",
      button: "複製",
      copiedButton: "已複製！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "檢查你嘅詳細資料",
      subHeading: "進行必要嘅更改並提交詳細資料",
      feild1: "駕駛證",
      feild2: "到期日",
      feild3: "出生日期",
      feild4: "類別",
      feild5: "限制",
      feild6: "國家",
      feild7: "地址",
      button: "詳細資料正確"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "將你嘅面放喺圓圈中間"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "行近啲，保持面部正對"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "行入畫面，保持面部正對"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗。搵更光亮嘅光源"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮。搵合適嘅光源"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "將你嘅面調到圓圈中間"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "唔好郁，望住前面"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光源，唔好郁"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "將你嘅手機保持喺眼睛高度"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "離開攝像頭遠啲"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美!"
      },
      smile1: {
        icon: "mood",
        description: "笑一笑，你睇起來好靚!"
      },
      smile2: {
        icon: "mood",
        description: "對住攝像頭笑!"
      }
    },
    successful: {
      title: "驗證完成",
      text: "你可以而家關閉窗口",
      finishBtn: "完成"
    },
    poweredBy: "提供技術支持",
    redirect: "重定向中",
    error: {
      message: "URL已過期或無效"
    },
    footer: {
      securedBy: "提供技術支持"
    },
    helpFaq: {
      title: "幫助與常見問題",
      subtitle: "我們在這裡幫助你",
      cameraText: "為了驗證你的身份，我們需要使用你的裝置相機拍攝照片。點擊此 link 了解如何授予所需的權限",
      cameraHeading: "相機權限",
      languageText: "在流程開始時，你可以從頂部欄的下拉菜單中選擇你偏好的語言",
      languageHeading: "語言選擇",
      kycText: "KYC，或「認識你的客戶」，是驗證和確認客戶身份的過程，有助於確保合規並防止欺詐及其他非法活動",
      kycHeading: "KYC 係咩意思？",
      timeText: "通常情況下，大約需要 60 秒。 不過，這可能會根據國家有所不同",
      timeHeading: "大概要多少時間？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    onlyIdVerificationHeader: {
      title: "验证您的身份",
      subtitle: "只需一分钟，请准备好您的身份证件",
      instruction1: "允许相机访问",
      instruction2: "扫描或上传您的证件",
      instruction3: "即时证件验证"
    },
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已经一段时间没有操作。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接具有有限的有效期",
      subHeading2: "请使用新的链接尝试",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "相机访问被拒绝。请在浏览器设置中启用相机访问",
      alert2: "访问相机时发生错误",
      alert3: "您的浏览器不支持相机访问"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "嘅",
      upload: "上載",
      stillNotWorking: "仲係用唔到？",
      clickToCapture: "試吓㩒一下影相",
      skip: "跳過"
    }
,
    permissionPopUp: {
      title: "需要權限",
      subtitle: "允許存取以使用相機",
      decline: "拒絕",
      allow: "允許"
    },
    userDetails: {
      heading: "PAN 驗證",
      subHeading: "請填寫詳細資料以進行驗證",
      panLabel: "PAN 號碼",
      panRequired: "請輸入你嘅 PAN 號碼",
      saveError: "儲存詳細資料時出咗問題。請再試一次。",
      proceed: "繼續"
    },
    redirectCta: {
      or: "或者",
      clickHere: "撳呢度",
      clickHereStart: "撳呢度",
      toContinue: "以繼續"
    },
    documentCapture: {
      stillNotWorking: "仲係用唔到？",
      clickToCaptureInstead: "改用撳一下嚟影張相試吓",
      pdfNotAllowedIndia: "印度唔可以上載 PDF。請上載細過 5 MB 嘅 JPEG、JPG 或 PNG 檔案。",
      pdfNotAllowedIndiaMobile: "印度唔可以上載 PDF。請上載細過 5 MB 嘅 JPEG、JPG、PNG、HEIC 或 HEIF 檔案。",
      fileFormatsIndia: "jpeg、jpg、png 細過 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 細過 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 細過 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 細過 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  },
  jv: {
    supportingDocument: {
      headingFallback: "Dokumen panyengkuyung",
      subHeading: "Unggah dokumen ing ngisor iki. Disimpen kanggo ditinjau — ora ana sing dijupuk saka kono.",
      choosePlaceholder: "Pilih berkas (PNG, JPG, utawa PDF)",
      continue: "Terusake",
      uploading: "Ngunggah...",
      skip: "Liwati dhisik",
      errorInvalidType: "Unggah berkas PNG, JPG, utawa PDF.",
      errorTooLarge: "Berkas kegedhen. Watesan 10MB.",
      errorRead: "Ora bisa maca berkas kuwi. Mangga coba liyane.",
      errorNoFile: "Mangga pilih berkas kanggo diunggah.",
    },
    header: {
      title: "Ayo verifikasi identitas sampeyan",
      subtitle: "Butuh wektu kurang saka 2 menit",
      havingIssue: "Ana masalah?"
    },
    subHeading: {
      subHeading1: "Jupuk foto dokumen ID sampeyan",
      subHeading2: "Verifikasi yen sampeyan urip",
      livenessHeading1: "Goleki panggonan sing cahyane apik",
      livenessHeading2: "Jaga raimu ing tengah"
    },
    termsAndCondition: {
      title: "Aku sarujuk lan manut karo syarat lan ketentuan iki.",
      privacyPolicy: "Deleng syarat",
      beginBtnText: "Mulai",
      beginLiveness: "Mulai cek urip",
      startLiveness: "Terusake cek urip"
    },
    permissionDenied: {
      title: "Akses kamera ditolak!",
      subtitle: "Mriksa manawa ana ikon kamera sing diblokir cedhak bar alamat browser lan bukak blokir kasebut.",
      readMore: "Waca Liyane",
      refreshText: "Sawise menehi ijin akses kamera, klik tombol 'Refresh' ing ngisor iki.",
      refreshBtn: "Refresh",
      link: "Utawa, Terusake nganggo HP",
      buttonText: "Utawa, Terusake nganggo HP"
    },
    desktopBrowserPermissionDenied: {
      title: "Mangga wenehi akses kamera",
      subtitle: "Browser bisa njaluk ijin. Mangga 'ijini' kanggo nerusake.",
      readMore: "Waca Liyane",
      refreshText: "Refresh sawise menehi ijin",
      refreshBtn: "Refresh",
      link: "Utawa, Terusake nganggo HP",
      buttonText: "Utawa, Terusake nganggo HP"
    },
    androidBrowserPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Periksa ikon kamera yang disekat berhampiran bar alamat pelayar dan benarkan akses.",
      readMore: "Ketahui Lebih Lanjut",
      refreshText: "Selepas akses kamera dibenarkan, klik butang 'Segar Semula' di bawah.",
      refreshBtn: "Segar Semula",
      link: "Atau, Teruskan di Telefon",
      buttonText: "Atau, Teruskan di Telefon"
    },
    androidWebViewPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Akses kamera mungkin disekat oleh tetapan aplikasi. Sila pergi ke Maklumat Aplikasi > Kebenaran > Kamera dan benarkan akses.",
      refreshText: "Selepas akses kamera dibenarkan, klik butang 'Segar Semula' di bawah.",
      refreshBtn: "Segar Semula",
      link: "Atau, Teruskan di Telefon",
      buttonText: "Atau, Teruskan di Telefon"
    },
    iosBrowserPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Ketik ikon kamera atau kunci berhampiran bar alamat untuk membenarkan akses, atau semak tetapan pelayar anda.",
      readMore: "Ketahui Lebih Lanjut",
      refreshText: "Selepas akses kamera dibenarkan, klik butang 'Segar Semula' di bawah.",
      refreshBtn: "Segar Semula",
      link: "Atau, Teruskan di Telefon",
      buttonText: "Atau, Teruskan di Telefon"
    },
    iosWebViewPermissionDenied: {
      title: "Akses kamera ditolak",
      subtitle: "Akses kamera mungkin disekat dalam tetapan aplikasi. Pergi ke Tetapan, cari aplikasi anda, dan benarkan kebenaran Kamera.",
      refreshText: "Selepas akses kamera dibenarkan, klik butang 'Segar Semula' di bawah.",
      refreshBtn: "Segar Semula",
      link: "Atau, Teruskan di Telefon",
      buttonText: "Atau, Teruskan di Telefon"
    },
    documentationList: {
      countryHeading: "Pilih negara",
      docHeading: "Pilih dokumen sampeyan",
      btnText: "Sabanjure",
      searchCountry: "Golek negara"
    },
    frontDocCapture: {
      heading: "Pasang sisih ngarep ID ing kothak",
      backupHeading: "Ana masalah? Mangga klik gambar kanthi manual",
      btnText: "Jupuk foto",
      headingBack: " ing njero pasagi dawa",
      uploadButton: "utawa, unggah ID"
    },
    backDocCapture: {
      heading: "Pasang sisih mburi ID ing kothak",
      backupHeading: "Ana masalah? Mangga klik gambar kanthi manual",
      btnText: "Jupuk foto",
      containerText: "utawa, unggah dokumen",
      text: "Nangkep, tetep meneng",
      headingBack: " ing njero pasagi dawa",
      skipButton: "Liwati Sisih Mburi",
      uploadButton: "utawa, unggah ID"
    },
    analyzing: {
      heading: "Nganalisis ID sampeyan...",
      subHeading: "Mangga priksa rincian kertu sampeyan ing layar sabanjure lan edit yen perlu"
    },
    imageCheck: {
      heading: "Priksa gambar sampeyan",
      subHeading: "Mangga pastikake yen gambar iku lengkap, cetha lan ora kabur lan ora silau.",
      button1: "Jupuk foto maneh",
      button2: "Apik",
      frontHeading: "Priksa gambar ngarep sampeyan",
      backHeading: "Priksa gambar mburi sampeyan"
    },
    errorHandler: {
      heading: "Oh ora :(",
      subHeading1: "Kita ngalami sawetara masalah, nanging aja kuwatir! Mangga coba maneh",
      subHeading2: "Yen iki terus, priksa maneh mengko",
      button: "Coba maneh"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Mangga copot apa wae sing nutupi rai sampeyan",
        button: "Coba maneh"
      },
      eyeClosureDetected: {
        heading: "Mangga tetep mbukak mripat panjenengan lan delengen langsung menyang kamera",
        button: "Coba maneh"
      },
      isMultipleFacesFound: {
        heading: "Kaping pirang-pirang rai ditemokake. Priksa manawa mung rai sampeyan sing katon ing kamera.",
        button: "Coba Maneh"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Coba Maneh"
      },
      faceDetections: {
        heading: "Mangga copot iki",
        button: "Coba maneh"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Pancen ana pirang-pirang rai",
          button: "Coba maneh"
        },
        generalMessage: {
          heading: "Mangga priksa manawa sampeyan urip ing ngarep kamera",
          button: "Coba maneh"
        }
      },
      faceMatch: {
        heading: "Rai sampeyan ora cocog karo foto ID",
        button: "Coba maneh"
      },
      selfieError: {
        heading: "Kita ora bisa verifikasi selfie sampeyan",
        subHeading1: "Mangga tindakake pandhuan iki lan coba maneh",
        instruction1: "Pindhah menyang panggonan sing padhang lan aja nganti cahya mburi",
        instruction2: "Priksa manawa rai sampeyan katon kanthi lengkap lan ana ing tengah-tengah bingkai",
        instruction3: "Copot topi, kacamata, utawa masker supaya rai sampeyan katon jelas",
        button: "Coba maneh"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP ora cocog. Mangga waca OTP kanthi cetha lan banter",
        button: "Coba Maneh"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verifikasi gagal. Mangga tindakake pandhuan kanthi cetha lan coba maneh",
        button: "Coba maneh"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF nduwe kakehan kaca",
        subHeading: "PDF sing diunggah ngluwihi wates 2 kaca. Mangga unggah PDF sing ora luwih saka 2 kaca, utawa gambar ID sing cetha."
      },
      heading: "Kita ora bisa ngolah ID sampeyan",
      subHeading: "Sampeyan bisa unggah ID sing salah utawa gambare ora cetha",
      buttonBack: "Coba maneh sisih mburi ID",
      buttonFront: "Coba maneh sisih ngarep ID",
      button: "Coba maneh",
      captureFrontSide: "Jupuk Sisih Ngarep",
      captureBackSide: "Jupuk Sisih Mburi",
      changeIDButton: "Pilih Dokumen Liya",
      wrongid: {
        heading: "Kita ora bisa ngolah dokumen iki",
        subHeading: "Mangga priksa manawa sampeyan ngunggah dokumen sing bener lan priksa manawa kualitas gambar cetha"
      },
      expiredid: {
        heading: "Dokumen ID Kadaluwarsa!",
        subHeading: "Kita ora bisa nampa dokumen ID sing kadaluwarsa. Mangga wenehi dokumen sing valid"
      },
      minimumage: {
        heading: "Syarat Umur Ora Kacukupan!",
        subHeading: "Umur sampeyan ing ngisor umur minimum sing dibutuhake. Mangga priksa manawa sampeyan nyukupi kriteria umur minimum"
      },
      mobileAttemptsDone: {
        heading: "Lelampahan diterusake ing piranti sampeyan sadurunge",
        subHeading: "Sesi iki saiki dieureni kanggo ngindhari duplikasi."
      },
      finished: {
        heading: "Lelampahan wis rampung",
        subHeading: "Lelampahan wis rampung utawa wis diakhiri"
      },
      invalid: {
        heading: "Lelampahan Ora Kasedhiya !",
        subHeading: "Ora ana journeyId sing ditemokake utawa ID lelampahan ora valid"
      },
      INVALID_PAN_NUMBER: {
        heading: "Nomer PAN Ora Valid",
        subHeading: "Nomer PAN sing sampeyan lebokake ora valid. Mangga priksa lan coba maneh"
      },
      INVALID_PAN_STATUS: {
        heading: "Status PAN Ora Valid",
        subHeading: "Nomer PAN sing sampeyan lebokake ora valid. Mangga priksa lan coba maneh"
      },
      directKyc: {
        heading: "Lelampahan KYC Langsung !",
        subHeading: "Iki lelampahan KYC langsung. Lelampahan frontend ora diidini."
      },
      DOCTYPE_FALSE: {
        heading: "Dokumen Salah Diwenehake!",
        subHeading: "Mangga unggah dokumen sing valid lan priksa manawa kualitas gambar apik."
      },
      ONLY_FRONT: {
        heading: "Sisih mburi ID ora ana",
        subHeading: "Sampeyan mung menehi sisih ngarep. Mangga walik ID sampeyan lan wenehi sisih mburi kanggo nerusake"
      },
      ONLY_BACK: {
        heading: "Sisih ngarep ID ora ana",
        subHeading: "Sampeyan mung menehi sisih mburi. Mangga walik ID sampeyan lan wenehi sisih ngarep kanggo nerusake"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Dokumen Bakal Kadaluwarsa Cedhak",
        subHeading: "Dokumen ditolak amarga bakal kadaluwarsa cedhak."
      },
      DOCUMENT_EXPIRED: {
        heading: "Dokumen Kadaluwarsa!",
        subHeading: "Mangga unggah dokumen sing valid lan durung kadaluwarsa kanggo nerusake."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Syarat Umur Ora Kacukupan!",
        subHeading: "Dokumen nuduhake sampeyan ora nyukupi umur sing dibutuhake. Mangga unggah dokumen sing valid."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Ora Bisa Verifikasi Dokumen!",
        subHeading: "Kualitas gambar ala banget kanggo verifikasi. Mangga coba maneh nganggo gambar sing luwih cetha."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Ora Bisa Verifikasi Dokumen!",
        subHeading: "Sawetara informasi ora bisa diverifikasi. Mangga coba maneh nganggo gambar sing luwih cetha."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Ora Bisa Verifikasi Dokumen!",
        subHeading: "Sawetara rincian ora bisa diverifikasi amarga kualitas gambar ala. Mangga coba maneh nganggo gambar sing luwih cetha"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Ora Bisa Verifikasi Dokumen!",
        subHeading: "Sawetara rincian ora bisa diverifikasi. Mangga coba maneh nganggo gambar sing luwih cetha."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Masalah verifikasi foto sampeyan ing ID",
        subHeading: "Kita ora bisa verifikasi foto sampeyan ing kertu ID. Mangga unggah foto sing cetha saka ID asli sampeyan supaya kita bisa konfirmasi."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Priksa pola keamanan dokumen gagal",
        subHeading: "Kita ora bisa verifikasi pola keamanan sing dibangun ing dokumen. Mangga unggah foto sing cetha saka ID asli kanggo mbantu kita konfirmasi keasliane."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Priksa Kauripan Dokumen Gagal",
        subHeading: "Kita nemu tandha yen dokumen bisa uga dudu asli. Mangga aja nganggo gambar layar, salinan cetak, utawa nuduhake ID ing layar. Unggah ID asli kanthi kabeh fitur katon cetha"
      },
      SECURITY_FALSE: {
        heading: "Masalah Kedeteksi!",
        subHeading: "Dokumen ora bisa diverifikasi. Mangga coba maneh nganggo gambar sing luwih cetha"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Kualitas Gambar Ala!",
        subHeading: "Gambar buram banget utawa ora cetha. Mangga coba maneh nganggo gambar sing luwih cetha"
      },
      FACE_UNDETECTED: {
        heading: "Rai Ora Kedeteksi",
        subHeading: "Kita ora bisa nemokake rai sing katon ing dokumen. Mangga unggah ID sing valid sing raine katon cetha"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Pambandingan Antar-Dokumen Gagal",
        subHeading: "Pambandingan antar-dokumen gagal amarga ora cocog ing siji utawa luwih kolom kunci (Jeneng, Tanggal Lair, utawa Rai)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Kegagalan Digilocker",
        subHeading: "Ana kesalahan sajrone lelampahan Digilocker. Mangga coba maneh utawa nganggo cara liya kanggo nerusake."
      },
      LINKAGE_FAILED: {
        heading: "Verifikasi iki ora bisa rampung",
        subHeading: "Data sing dijupuk ora cocog karo cathetan kanggo pemeriksaan iki."
      }
    },
    biometricConsent: {
      consentStatement: "Sadurunge selfie sampeyan, kita mbutuhake idin sampeyan kanggo njupuk lan ngolah data biometrik sampeyan (gambar rai lan sinyal liveness) kanggo verifikasi identitas sampeyan. Data iki mung digunakake kanggo verifikasi iki.",
      privacyPolicy: "Kabijakan privasi",
      consentButton: "Aku setuju — Terusake",
      declineButton: "Aku ora setuju",
      confirmTitle: "Terusake tanpa verifikasi biometrik?",
      confirmBody: "Tanpa verifikasi biometrik, kita ora bakal njupuk selfie. Verifikasi sampeyan bakal rampung nganggo informasi sing wis sampeyan wenehake. Pilihan iki final kanggo sesi iki.",
      goBack: "Bali",
      confirmDecline: "Konfirmasi — ora setuju",
      declineComplete: "Sampeyan milih ora nerusake verifikasi biometrik. Verifikasi identitas sampeyan wis rampung nganggo dokumen sing sampeyan kirim."
    },
    introLiveness: {
      heading: "Konfirmasi yen sampeyan urip ing kene",
      instruction1: "Pastikake ana cukup cahya",
      instruction2: "Wenehi ijin sing dibutuhake",
      instruction3: "Cukup tindakake pandhuan",
      button: "Terusake",
      subHeading: "Sampeyan mung kari siji langkah"
    },
    phoneSession: {
      heading: "Sesi diterusake ing HP",
      subheading: "Tinggalke jendela iki mbukak nganti rampung ing piranti seluler",
      button: "Terusake ing kene"
    },
    continueOnPhone: {
      heading: "Terusake ing HP",
      subheading: "Pindai QR utawa salin tautan ing ngisor iki",
      subheading2: "Pindai QR utawa bukak tautan ing HP sampeyan",
      text: "Rampungake proses",
      text1: "Priksa maneh ing kene kanggo ngirim",
      button: "Salin",
      copiedButton: "Wis disalin!",
      copied: "Wis dikopi!"
    },
    SsnReview: {
      heading: "Priksa rincian sampeyan",
      subHeading: "Gawe pangowahan sing perlu lan kirim rincian",
      feild1: "SIM",
      feild2: "Kadaluarsa",
      feild3: "Tanggal lair",
      feild4: "Kelas",
      feild5: "Watesan",
      feild6: "Negara",
      feild7: "Alamat",
      button: "Rincian bener"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Jaga rai sampeyan ing bunderan"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Nyedhak menyang kamera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Aja isin, metu ing tampilan"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Peteng banget. Golek cahya sing luwih padhang"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Padhang banget. Golek cahya sing luwih alus"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Jaga rai sampeyan ing bunderan"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Meneng waé"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Adhepna rai menyang cahya"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Cekel telpon sajajar mripat"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Adoh sethithik saka kamera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Tengahna rai ing pigura"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Posisikake rai sampeyan ing tengah bunderan"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Nyedhaki lan tetep rai sampeyan lurus"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Mlebua ing tampilan lan tetep rai sampeyan lurus"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Peteng banget. Golek cahya sing luwih padhang"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Padhang banget. Golek cahya sing cocog"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Atur rai sampeyan ing tengah bunderan"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Tetep meneng lan deleng lurus ngarep"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Adhepi cahya lan tetep meneng"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Tahan HP sampeyan ing tingkat mata"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Meneng adoh sithik saka kamera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Sampurna!"
      },
      smile1: {
        icon: "mood",
        description: "Mesem, sampeyan katon apik!"
      },
      smile2: {
        icon: "mood",
        description: "Mesem kanggo kamera!"
      }
    },
    successful: {
      title: "Verifikasi Rampung",
      text: "Sampeyan bisa nutup jendela saiki",
      finishBtn: "Rampung"
    },
    poweredBy: "Dijalanke kanthi",
    redirect: "Ngatur menyang",
    error: {
      message: "URL wis kadaluwarsa utawa ora valid"
    },
    footer: {
      securedBy: "Dijalanke kanthi"
    },
    helpFaq: {
      title: "Bantuan & Pitakonan sing Asring Diajokake",
      subtitle: "Kita ana ing kene kanggo mbantu sampeyan",
      cameraText: "Kanggo verifikasi identitas sampeyan, kita butuh ngambil gambar nganggo kamera piranti sampeyan. Klik link iki kanggo sinau carane menehi ijin sing dibutuhake",
      cameraHeading: "Ijin Kamera",
      languageText: "Ing awal proses, sampeyan bisa milih basa sing disenengi kanthi milih saka menu tarik mudhun ing bar dhuwur",
      languageHeading: "Pamilihan Basa",
      kycText: "KYC, utawa 'Kenali Pelanggan Sampeyan', iku proses kanggo verifikasi lan konfirmasi identitas pelanggan, sing mbantu njamin kepatuhan lan nyegah penipuan lan kegiatan ilegal liyane",
      kycHeading: "Apa sing dimaksud KYC?",
      timeText: "Biasane, butuh sekitar 60 detik. Nanging, iki bisa beda-beda gumantung negara",
      timeHeading: "Pira wektu sing dibutuhake?"
    },
    pdfPreviewUnavailable: "Ora bisa nuduhake pratinjau PDF.",
    pdfPreviewHint: "Yen pratinjau ora katon, sampeyan isih bisa nerusake.",
    pdfOpenLabel: "Bukak PDF",
    onlyIdVerificationHeader: {
      title: "Ayo verifikasi ID sampeyan",
      subtitle: "Iki mung butuh semenit. Cukup siapna dokumen ID sampeyan",
      instruction1: "Idini Akses Kamera",
      instruction2: "Pindai utawa Unggah Dokumen Sampeyan",
      instruction3: "Verifikasi Dokumen Sakal"
    },
    failedUpload: {
      title: "Unggah Berkas Gagal",
      text: "Mangga priksa manawa berkas kurang saka 5MB lan ing format .jpg, .jpeg, .png, .heic, .heif, utawa .pdf",
      btn: "Coba Maneh",
      pdfNotAllowedIndia: "Ngunggah PDF ora diidini kanggo India. Mangga unggah file JPEG, JPG, PNG, HEIC, utawa HEIF kurang saka 5 MB.",
      pdfNotAllowedIndiaBasic: "Ngunggah PDF ora diidini kanggo India. Mangga unggah file JPEG, JPG, utawa PNG kurang saka 5 MB."
    },
    livenessAnalyzing: {
      heading: "Nganalisa Rai Sampeyan",
      subHeading: "Mangga ngenteni, iki mung butuh sawetara detik"
    },
    sessionExpiredError: {
      heading: "Nyuwun pangapunten, sesi sampeyan wis entek wektu",
      subHeading1: "Sampeyan wis ora aktif sawetara wektu. Kanggo alasan keamanan, sesi sampeyan otomatis kadaluwarsa",
      subHeading2: "Mangga coba maneh",
      buttonText: "Coba Maneh"
    },
    journeyExpiredError: {
      heading: "Nyuwun pangapunten, link wis kadaluwarsa",
      subHeading1: "Link wis ora aktif maneh. Kanggo alasan keamanan, link nduweni umur winates",
      subHeading2: "Mangga coba nganggo link anyar",
      buttonText: "Coba Maneh"
    },
    cameraAccessError: {
      alert1: "Akses kamera ditolak. Mangga aktifake akses kamera ing setelan browser sampeyan",
      alert2: "Ana kesalahan nalika ngakses kamera",
      alert3: "Browser sampeyan ora ndhukung akses kamera"
    },
    activeLiveness: {
      instruction: "Jaga raimu ing njero bunderan lan tindakna pandhuan",
      permissionDeniedTitle: "Akses Kamera utawa Mikropon Ditolak",
      permissionDeniedSubtitle: "Mangga idini akses kamera lan mikropon ing setelan browser sampeyan banjur coba maneh."
    },
    flipScreen: {
      heading: "Saiki walik kertu identitas sampeyan",
      subHeading: "Mangga walik kertu identitas sampeyan kanthi fisik kanggo nuduhake sisih mburi, banjur dokokké ing pigura kamera.",
      continueButton: "Terusake"
    },
    mobileDocCapture: {
      frontSide: "Sisih Ngarep",
      backSide: "Sisih Mburi",
      of: "saka",
      upload: "Unggah",
      stillNotWorking: "Isih ora mlaku?",
      clickToCapture: "Coba klik-kanggo-njupuk",
      skip: "Liwati"
    }
,
    permissionPopUp: {
      title: "Idin dibutuhake",
      subtitle: "Idinana akses kanggo nggunakake kamera",
      decline: "Tolak",
      allow: "Idinana"
    },
    userDetails: {
      heading: "Verifikasi PAN",
      subHeading: "Mangga isi rincian kanggo verifikasi",
      panLabel: "Nomer PAN",
      panRequired: "Mangga lebokna nomer PAN sampeyan",
      saveError: "Ana sing salah nalika nyimpen rincian. Mangga coba maneh.",
      proceed: "Terusake"
    },
    redirectCta: {
      or: "utawa",
      clickHere: "klik kene",
      clickHereStart: "Klik kene",
      toContinue: "kanggo nerusake"
    },
    documentCapture: {
      stillNotWorking: "Isih ora bisa?",
      clickToCaptureInstead: "Coba klik-kanggo-njupuk minangka gantine",
      pdfNotAllowedIndia: "Unggah PDF ora diidini kanggo India. Mangga unggah file JPEG, JPG, utawa PNG kurang saka 5 MB.",
      pdfNotAllowedIndiaMobile: "Unggah PDF ora diidini kanggo India. Mangga unggah file JPEG, JPG, PNG, HEIC, utawa HEIF kurang saka 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png kurang saka 5 mb",
      fileFormats: "jpeg, jpg, png, pdf kurang saka 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif kurang saka 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf kurang saka 5 mb"
    },
    mobileCapture: {
      upload: "Unggah",
      skip: "Liwati",
      stillNotWorking: "Isih ora bisa?",
      tryClickToCapture: "Tutul kanggo njupuk"
    },
    UserDetails: {
      panLabel: "Nomer PAN",
      proceedBtn: "Terusake",
      panRequired: "Mangga lebokake nomer PAN sampeyan",
      saveError: "Ana sing salah nalika nyimpen rincian. Mangga coba maneh."
    }
  },
  arz: {
    header: {
      title: "يلا نتحقق من هويتك",
      subtitle: "ده بياخد أقل من دقيقتين",
      havingIssue: "هل تواجه مشكلة؟"
    },
    subHeading: {
      subHeading1: "صور مستند الهوية بتاعك",
      subHeading2: "أكد إنك عايش",
      livenessHeading1: "ابحث عن مكان ذي إضاءة جيدة",
      livenessHeading2: "حافظ على وجهك في المنتصف"
    },
    termsAndCondition: {
      title: "أنا موافق ألتزم بالشروط والأحكام دي.",
      privacyPolicy: "عرض الشروط",
      beginBtnText: "ابدأ",
      beginLiveness: "بداية التحقق من الحياة",
      startLiveness: "استمر في التحقق من الحياة"
    },
    permissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "راجع إذا كان فيه أيقونة كاميرا محجوبة جنب شريط العنوان في المتصفح وافتح الحظر.",
      readMore: "اقرأ المزيد",
      refreshText: "بعد ما تسمح بالوصول للكاميرا، اضغط على زر 'تحديث' تحت.",
      refreshBtn: "تحديث",
      link: "أو، كمل على الموبايل",
      buttonText: "أو، كمل على الموبايل"
    },
    desktopBrowserPermissionDenied: {
      title: "من فضلك اسمح بالوصول للكاميرا",
      subtitle: "المتصفح ممكن يطلب الأذونات. من فضلك اضغط 'اسمح' عشان تكمل.",
      readMore: "اقرأ المزيد",
      refreshText: "اعمل تحديث بعد ما تسمح بالأذونات",
      refreshBtn: "تحديث",
      link: "أو، كمل على الموبايل",
      buttonText: "أو، كمل على الموبايل"
    },
    androidBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "تحقّق مما إذا كان هناك رمز كاميرا محظور بجانب شريط العنوان في المتصفح وقم بإلغاء الحظر.",
      readMore: "اعرف المزيد",
      refreshText: "بعد السماح بالوصول إلى الكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة على الهاتف",
      buttonText: "أو، المتابعة على الهاتف"
    },
    androidWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "قد يكون الوصول إلى الكاميرا محظورًا من إعدادات التطبيق. يُرجى الذهاب إلى معلومات التطبيق > الأذونات > الكاميرا والسماح بالوصول.",
      refreshText: "بعد السماح بالوصول إلى الكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة على الهاتف",
      buttonText: "أو، المتابعة على الهاتف"
    },
    iosBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "انقر على رمز الكاميرا أو القفل بجانب شريط العنوان للسماح بالوصول، أو تحقق من إعدادات المتصفح.",
      readMore: "اعرف المزيد",
      refreshText: "بعد السماح بالوصول إلى الكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة على الهاتف",
      buttonText: "أو، المتابعة على الهاتف"
    },
    iosWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "قد يتم حظر الكاميرا من إعدادات التطبيق. انتقل إلى الإعدادات، وابحث عن التطبيق، ثم فعّل إذن الوصول إلى الكاميرا.",
      refreshText: "بعد السماح بالوصول إلى الكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة على الهاتف",
      buttonText: "أو، المتابعة على الهاتف"
    },
    documentationList: {
      countryHeading: "اختار البلد",
      docHeading: "اختار المستند بتاعك",
      btnText: "التالي",
      searchCountry: "ابحث عن دولة"
    },
    frontDocCapture: {
      heading: "حط الجانب الأمامي من الهوية في المستطيل",
      backupHeading: "في مشكلة؟ من فضلك اضغط على الصورة يدويًا",
      btnText: "اخد صورة",
      headingBack: " داخل المستطيل",
      uploadButton: "أو قم بتحميل الهوية"
    },
    backDocCapture: {
      heading: "حط الجانب الخلفي من الهوية في المستطيل",
      backupHeading: "في مشكلة؟ من فضلك اضغط على الصورة يدويًا",
      btnText: "اخد صورة",
      containerText: "أو، ارفع المستند",
      text: "بيتم التقاط الصورة، من فضلك متتحركش",
      headingBack: " داخل المستطيل",
      skipButton: "تخطي الوجه الخلفي",
      uploadButton: "أو قم بتحميل الهوية"
    },
    analyzing: {
      heading: "بيتم تحليل الهوية بتاعتك...",
      subHeading: "من فضلك تأكد من بيانات الكارت بتاعك في الشاشة الجاية وعدل لو لزم الأمر"
    },
    imageCheck: {
      heading: "اتأكد من الصورة بتاعتك",
      subHeading: "من فضلك تأكد إن الصورة كاملة وواضحة ومش مضببة أو فيها لمعان.",
      button1: "اخد الصورة تاني",
      button2: "تمام",
      frontHeading: "اتأكد من صورتك الأمامية",
      backHeading: "اتأكد من صورتك الخلفية"
    },
    errorHandler: {
      heading: "أوه :(",
      subHeading1: "إحنا بنواجه شوية مشاكل، بس متقلقش! من فضلك جرب تاني",
      subHeading2: "لو استمر ده، حاول تاني بعدين",
      button: "جرب تاني"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "من فضلك شيل أي حاجة بتغطي وشك",
        button: "جرب تاني"
      },
      eyeClosureDetected: {
        heading: "من فضلك خليك فاتح عينيك وبُصّ على الكاميرا على طول",
        button: "حاول تاني"
      },
      isMultipleFacesFound: {
        heading: "تم اكتشاف وجوه متعددة. تأكد أن وجهك فقط هو الظاهر في الكاميرا.",
        button: "جرب تاني"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "جرب تاني"
      },
      faceDetections: {
        heading: "من فضلك شيل ده",
        button: "جرب تاني"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "لقينا أكتر من وش",
          button: "جرب تاني"
        },
        generalMessage: {
          heading: "من فضلك تأكد إنك عايش قدام الكاميرا",
          button: "جرب تاني"
        }
      },
      faceMatch: {
        heading: "وشك مش مطابق لصورة الهوية",
        button: "جرب تاني"
      },
      selfieError: {
        heading: "مقدرناش نتحقق من السيلفي بتاعك",
        subHeading1: "من فضلك اتبع التعليمات دي وجرب تاني",
        instruction1: "اتنقل لمكان مضيء كويس وتجنب الإضاءة الخلفية",
        instruction2: "تأكد إن وشك باين تمامًا وفي نص الإطار",
        instruction3: "شيل القبعة أو النظارة أو الكمامة علشان وشك يظهر بوضوح",
        button: "جرب تاني"
      },
      activeLivenessOtpFailureMessage: {
        heading: "رمز OTP غير مطابق. يرجى قراءة رمز OTP بوضوح وبصوت عالٍ",
        button: "حاول مرة أخرى"
      },
      activeLivenessGenericFailureMessage: {
        heading: "التحقق فشل. لو سمحت اتبع التعليمات بوضوح وجرب تاني",
        button: "جرب تاني"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "ملف PDF فيه صفحات كتير",
        subHeading: "ملف الـ PDF اللي رفعته بيتعدى حد الصفحتين. من فضلك ارفع PDF مش أكتر من صفحتين، أو صورة واضحة لهويتك."
      },
      heading: "مش قادرين نعالج الهوية بتاعتك",
      subHeading: "يا إما بترفع هوية غلط أو الصورة مش واضحة",
      buttonBack: "جرب تاني الجانب الخلفي للهوية",
      buttonFront: "جرب تاني الجانب الأمامي للهوية",
      button: "جرب تاني",
      captureFrontSide: "التقط الوجه الأمامي",
      captureBackSide: "التقط الوجه الخلفي",
      changeIDButton: "اختر مستندًا آخر",
      wrongid: {
        heading: "لم نتمكن من معالجة هذا المستند",
        subHeading: "يرجى التأكد من أنك تقوم بتحميل المستند الصحيح والتأكد من وضوح الصورة"
      },
      expiredid: {
        heading: "هوية منتهية الصلاحية!",
        subHeading: "لا يمكننا قبول هوية منتهية الصلاحية. يرجى تقديم مستند صالح"
      },
      minimumage: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "عمرك أقل من الحد الأدنى المطلوب. يرجى التأكد من أنك تلبي متطلبات العمر الأدنى"
      },
      mobileAttemptsDone: {
        heading: "تم استئناف الرحلة على جهازك السابق",
        subHeading: "تم إيقاف هذه الجلسة لتجنب التكرار"
      },
      finished: {
        heading: "انتهت الرحلة",
        subHeading: "تم إكمال الرحلة أو إنهاؤها"
      },
      invalid: {
        heading: "الرحلة غير متاحة!",
        subHeading: "لم يتم العثور على journeyId أو أن journeyId غير صالح"
      },
      INVALID_PAN_NUMBER: {
        heading: "رقم PAN غير صالح",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      INVALID_PAN_STATUS: {
        heading: "حالة PAN غير صالحة",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      directKyc: {
        heading: "رحلة KYC مباشرة !",
        subHeading: "هذه رحلة KYC مباشرة. رحلة الواجهة الأمامية غير مسموح بها."
      },
      DOCTYPE_FALSE: {
        heading: "المستند غير معترف به!",
        subHeading: "يرجى تحميل مستند صالح والتأكد من جودة الصورة."
      },
      ONLY_FRONT: {
        heading: "الجهة الخلفية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الأمامية فقط. يرجى قلب الهوية وتحميل الجهة الخلفية للمتابعة"
      },
      ONLY_BACK: {
        heading: "الجهة الأمامية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الخلفية فقط. يرجى قلب الهوية وتحميل الجهة الأمامية للمتابعة"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "المستند على وشك الانتهاء!",
        subHeading: "تم رفض المستند لأنه على وشك انتهاء الصلاحية."
      },
      DOCUMENT_EXPIRED: {
        heading: "المستند منتهي الصلاحية!",
        subHeading: "يرجى تحميل مستند صالح وغير منتهي الصلاحية للاستمرار."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "المستند يشير إلى أنك لا تستوفي العمر المطلوب. يرجى تحميل مستند صالح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "جودة الصورة منخفضة جدًا للتحقق. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "بعض المعلومات لم تتمكن من التحقق منها. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل بسبب ضعف جودة الصورة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "مشكلة في التحقق من صورتك على بطاقة الهوية",
        subHeading: "لم نتمكن من التحقق من صورتك على بطاقة الهوية. يرجى تحميل صورة واضحة لبطاقة الهوية الأصلية حتى نتمكن من تأكيدها."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "فشل التحقق من نمط الأمان في الوثيقة",
        subHeading: "لم نتمكن من التحقق من أنماط الأمان المدمجة في الوثيقة. يرجى تحميل صورة واضحة للهوية الأصلية لمساعدتنا في تأكيد صحتها."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "فشل التحقق من حيوية المستند",
        subHeading: "لقد وجدنا مؤشرات على أن المستند قد لا يكون أصليًا. يرجى تجنب استخدام لقطات الشاشة أو النسخ المطبوعة أو عرض الهوية على الشاشة. قم بتحميل المستند الأصلي مع إظهار جميع الميزات بوضوح."
      },
      SECURITY_FALSE: {
        heading: "تم اكتشاف مشكلة!",
        subHeading: "لم يتم التحقق من المستند. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "جودة صورة ضعيفة!",
        subHeading: "الصورة ضبابية جدًا أو غير واضحة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      FACE_UNDETECTED: {
        heading: "لم يتم اكتشاف الوجه",
        subHeading: "لم نتمكن من العثور على وجه مرئي في الوثيقة. يرجى تحميل هوية صالحة حيث يكون الوجه مرئيًا بوضوح."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "فشل المقارنة بين المستندات",
        subHeading: "فشلت المقارنة بين المستندات بسبب عدم تطابق في حقل أو أكثر من الحقول الرئيسية (الاسم أو تاريخ الميلاد أو الوجه)"
      },
      DIGILOCKER_FAILURE: {
        heading: "فشل Digilocker",
        subHeading: "حدث خطأ أثناء رحلة Digilocker. يرجى المحاولة مرة أخرى أو استخدام طريقة بديلة للمتابعة."
      },
      LINKAGE_FAILED: {
        heading: "تعذّر إكمال هذا التحقق",
        subHeading: "لم تتطابق البيانات المُلتقطة مع السجلات الخاصة بهذا الفحص."
      }
    },
    biometricConsent: {
      consentStatement: "قبل التقاط صورتك الشخصية، نحتاج إلى موافقتك على التقاط ومعالجة بياناتك البيومترية (صورة الوجه وإشارات الحيوية) للتحقق من هويتك. تُستخدم هذه البيانات لهذا التحقق فقط.",
      privacyPolicy: "سياسة الخصوصية",
      consentButton: "أوافق — متابعة",
      declineButton: "لا أوافق",
      confirmTitle: "المتابعة دون التحقق البيومتري؟",
      confirmBody: "بدون التحقق البيومتري، لن نلتقط صورة شخصية. سيتم إكمال التحقق باستخدام المعلومات التي قدمتها بالفعل. هذا الاختيار نهائي لهذه الجلسة.",
      goBack: "رجوع",
      confirmDecline: "تأكيد — لا أوافق",
      declineComplete: "لقد اخترت عدم المتابعة بالتحقق البيومتري. تم إكمال التحقق من هويتك باستخدام المستندات التي قدمتها."
    },
    introLiveness: {
      heading: "أكد إنك عايش هنا",
      instruction1: "اتأكد إن في ضوء كفاية",
      instruction2: "اسمح بالأذونات المطلوبة",
      instruction3: "اتبع التعليمات",
      button: "استمر",
      subHeading: "أنت على بُعد خطوة واحدة فقط"
    },
    phoneSession: {
      heading: "الجلسة مستمرة على الموبايل",
      subheading: "سيب النافذة دي مفتوحة لحد ما تخلص على الموبايل",
      button: "استمر هنا"
    },
    continueOnPhone: {
      heading: "كمل على الموبايل",
      subheading: "امسح QR أو انسخ الرابط تحت",
      subheading2: "امسح QR أو افتح الرابط على موبايلك",
      text: "كمل العملية",
      text1: "ارجع هنا للتقديم",
      button: "انسخ",
      copiedButton: "اتنسخ!",
      copied: "تم النسخ!"
    },
    SsnReview: {
      heading: "راجع بياناتك",
      subHeading: "اعمل التعديلات المطلوبة وقدم البيانات",
      feild1: "رخصة القيادة",
      feild2: "تاريخ الانتهاء",
      feild3: "تاريخ الميلاد",
      feild4: "الفئة",
      feild5: "القيود",
      feild6: "البلد",
      feild7: "العنوان",
      button: "البيانات صحيحة"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "اقترب من الكاميرا"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "لا تخجل، اظهر أمام الكاميرا"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم جدًا. ابحث عن إضاءة أفضل"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ساطع جدًا. ابحث عن إضاءة أخف"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقَ ثابتًا"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "أدر وجهك نحو الضوء"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "أمسك الهاتف على مستوى عينيك"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ابتعد قليلًا عن الكاميرا"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ضع وجهك في منتصف الإطار"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "حط وشك في نص الدايرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "قرّب أكتر وخلي وشك مستقيم"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ادخل في المنظر وخلي وشك مستقيم"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "الضوء ضعيف جدًا. دور على ضوء أقوى"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "الضوء قوي جدًا. دور على ضوء مناسب"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ظبط وشك في نص الدايرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقى ثابت وبص قدامك على طول"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "وجّه وشك للنور وابقى ثابت"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "امسك الموبايل على مستوى العينين"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ابتعد شوية عن الكاميرا"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "ممتاز!"
      },
      smile1: {
        icon: "mood",
        description: "ابتسم، شكلك جميل!"
      },
      smile2: {
        icon: "mood",
        description: "ابتسم للكاميرا!"
      }
    },
    successful: {
      title: "التحقق اكتمل",
      text: "دلوقتي ممكن تقفل النافذة",
      finishBtn: "انتهى"
    },
    poweredBy: "مدعوم من",
    redirect: "إعادة التوجيه في",
    error: {
      message: "الرابط انتهى أو غير صالح"
    },
    footer: {
      securedBy: "مدعوم من"
    },
    helpFaq: {
      title: "المساعدة والأسئلة المتكررة",
      subtitle: "نحن هنا لمساعدتك",
      cameraText: "لإثبات هويتك، نحتاج إلى التقاط صور باستخدام كاميرا جهازك. اضغط على هذا link لمعرفة كيفية منح الأذونات المطلوبة",
      cameraHeading: "إذن الكاميرا",
      languageText: "في بداية العملية، يمكنك اختيار اللغة المفضلة لديك من خلال تحديدها من القائمة المنسدلة في الشريط العلوي",
      languageHeading: "اختيار اللغة",
      kycText: "KYC، أو 'اعرف عميلك'، هو عملية للتحقق من هوية العملاء والتأكد منها، مما يساعد على ضمان الامتثال ومنع الاحتيال والأنشطة غير القانونية الأخرى",
      kycHeading: "ماذا يعني KYC؟",
      timeText: "عادةً، يستغرق الأمر حوالي 60 ثانية. ومع ذلك، قد يختلف هذا حسب البلدان",
      timeHeading: "كم من الوقت سيستغرق الأمر؟"
    },
    pdfPreviewUnavailable: "تعذّر عرض معاينة ملف PDF.",
    pdfPreviewHint: "إذا لم تظهر المعاينة، لا يزال بإمكانك المتابعة.",
    pdfOpenLabel: "فتح ملف PDF",
    onlyIdVerificationHeader: {
      title: "لنقم بالتحقق من هويتك",
      subtitle: "سيستغرق هذا دقيقة واحدة فقط. يُرجى إحضار وثيقة الهوية الخاصة بك",
      instruction1: "السماح بالوصول إلى الكاميرا",
      instruction2: "مسح أو تحميل الوثيقة",
      instruction3: "التحقق الفوري من الوثيقة"
    },
    failedUpload: {
      title: "فشل تحميل الملف",
      text: "يرجى التأكد من أن حجم الملف أقل من 5 ميغابايت وبصيغة ‎.jpg أو ‎.jpeg أو ‎.png أو ‎.heic أو ‎.heif أو ‎.pdf",
      btn: "حاول مرة أخرى",
      pdfNotAllowedIndia: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 ميغابايت.",
      pdfNotAllowedIndiaBasic: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أقل من 5 ميغابايت."
    },
    livenessAnalyzing: {
      heading: "جارٍ تحليل وجهك",
      subHeading: "يرجى الانتظار، لن يستغرق هذا سوى بضع ثوانٍ"
    },
    sessionExpiredError: {
      heading: "عذرًا، انتهت صلاحية جلستك",
      subHeading1: "كنت غير نشط لفترة، ولأسباب أمنية، انتهت جلستك تلقائيًا",
      subHeading2: "يرجى المحاولة مرة أخرى",
      buttonText: "حاول مرة أخرى"
    },
    journeyExpiredError: {
      heading: "عذرًا، الرابط منتهي الصلاحية",
      subHeading1: "الرابط لم يعد نشطًا. لأسباب أمنية، الروابط لها فترة صلاحية محدودة",
      subHeading2: "يرجى المحاولة برابط جديد",
      buttonText: "حاول مرة أخرى"
    },
    cameraAccessError: {
      alert1: "تم رفض الوصول إلى الكاميرا. يرجى تمكين الوصول إلى الكاميرا في إعدادات متصفحك",
      alert2: "حدث خطأ أثناء الوصول إلى الكاميرا",
      alert3: "متصفحك لا يدعم الوصول إلى الكاميرا"
    },
    activeLiveness: {
      instruction: "أبقِ وجهك داخل الدائرة واتبع التعليمات",
      permissionDeniedTitle: "تم رفض الوصول إلى الكاميرا أو الميكروفون",
      permissionDeniedSubtitle: "يرجى السماح بالوصول إلى الكاميرا والميكروفون في إعدادات متصفحك والمحاولة مرة أخرى."
    },
    flipScreen: {
      heading: "اقلب بطاقة هويتك الآن",
      subHeading: "يرجى قلب بطاقة هويتك فعليًا لإظهار الجهة الخلفية، ثم ضعها داخل إطار الكاميرا.",
      continueButton: "متابعة"
    },
    mobileDocCapture: {
      frontSide: "الوش الأمامي",
      backSide: "الوش الخلفي",
      of: "بتاع",
      upload: "رفع",
      stillNotWorking: "لسه مش شغال؟",
      clickToCapture: "جرّب الالتقاط بالكليك",
      skip: "تخطّى"
    }
,
    permissionPopUp: {
      title: "الإذن مطلوب",
      subtitle: "اسمح بالوصول علشان تستخدم الكاميرا",
      decline: "رفض",
      allow: "اسمح"
    },
    userDetails: {
      heading: "التحقق من PAN",
      subHeading: "من فضلك املا التفاصيل علشان التحقق",
      panLabel: "رقم PAN",
      panRequired: "من فضلك دخّل رقم PAN بتاعك",
      saveError: "حصل خطأ وإحنا بنحفظ التفاصيل. من فضلك حاول تاني.",
      proceed: "كمّل"
    },
    redirectCta: {
      or: "أو",
      clickHere: "دوس هنا",
      clickHereStart: "دوس هنا",
      toContinue: "علشان تكمّل"
    },
    documentCapture: {
      stillNotWorking: "لسه مش شغال؟",
      clickToCaptureInstead: "جرّب الالتقاط بالضغط بدل كده",
      pdfNotAllowedIndia: "رفع ملفات PDF مش مسموح للهند. من فضلك ارفع ملفات JPEG أو JPG أو PNG أقل من 5 MB.",
      pdfNotAllowedIndiaMobile: "رفع ملفات PDF مش مسموح للهند. من فضلك ارفع ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png أقل من 5 mb",
      fileFormats: "jpeg, jpg, png, pdf أقل من 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif أقل من 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf أقل من 5 mb"
    },
    mobileCapture: {
      upload: "تحميل",
      skip: "تخطي",
      stillNotWorking: "لا يزال لا يعمل؟",
      tryClickToCapture: "التقط الصورة يدويًا"
    },
    UserDetails: {
      panLabel: "رقم PAN",
      proceedBtn: "متابعة",
      panRequired: "يرجى إدخال رقم PAN الخاص بك",
      saveError: "حدث خطأ أثناء حفظ التفاصيل. يرجى المحاولة مرة أخرى."
    }
  },
  fa: {
    supportingDocument: {
      headingFallback: "سند پشتیبان",
      subHeading: "سند را در پایین بارگذاری کنید. برای بررسی ذخیره می‌شود — چیزی از آن استخراج نمی‌شود.",
      choosePlaceholder: "یک فایل انتخاب کنید (PNG، JPG یا PDF)",
      continue: "ادامه",
      uploading: "در حال بارگذاری...",
      skip: "فعلاً رد شوید",
      errorInvalidType: "یک فایل PNG، JPG یا PDF بارگذاری کنید.",
      errorTooLarge: "فایل بسیار بزرگ است. محدودیت ۱۰ مگابایت است.",
      errorRead: "خواندن آن فایل ممکن نشد. لطفاً فایل دیگری را امتحان کنید.",
      errorNoFile: "لطفاً یک فایل برای بارگذاری انتخاب کنید.",
    },
    header: {
      title: "بیایید هویت شما را تأیید کنیم",
      subtitle: "این کمتر از 2 دقیقه طول می‌کشد",
      havingIssue: "مشکلی دارید؟"
    },
    subHeading: {
      subHeading1: "عکس سند هویت خود را بگیرید",
      subHeading2: "تأیید کنید که شما زنده هستید",
      livenessHeading1: "مکانی با نور مناسب پیدا کنید",
      livenessHeading2: "چهره خود را در مرکز نگه دارید"
    },
    termsAndCondition: {
      title: "من موافقت می‌کنم و به شرایط و ضوابط زیر پایبندم.",
      privacyPolicy: "مشاهده شرایط",
      beginBtnText: "شروع",
      beginLiveness: "شروع بررسی زنده بودن",
      startLiveness: "ادامه به بررسی زنده بودن"
    },
    permissionDenied: {
      title: "دسترسی به دوربین رد شد!",
      subtitle: "بررسی کنید که آیا آیکون دوربین در نزدیکی نوار آدرس مرورگر مسدود شده است یا خیر، و در صورت نیاز آن را باز کنید.",
      readMore: "بیشتر بخوانید",
      refreshText: "پس از دادن مجوز دسترسی به دوربین، روی دکمه «تازه کردن» در پایین کلیک کنید.",
      refreshBtn: "تازه کردن",
      link: "یا، ادامه در تلفن",
      buttonText: "یا، ادامه در تلفن"
    },
    desktopBrowserPermissionDenied: {
      title: "لطفاً دسترسی به دوربین را مجاز کنید",
      subtitle: "مرورگر ممکن است درخواست مجوز کند. لطفاً 'اجازه دادن' را کلیک کنید تا ادامه دهید.",
      readMore: "بیشتر بخوانید",
      refreshText: "پس از اعطای مجوز، صفحه را تازه کنید",
      refreshBtn: "تازه کردن",
      link: "یا، ادامه در تلفن",
      buttonText: "یا، ادامه در تلفن"
    },
    androidBrowserPermissionDenied: {
      title: "دسترسی به دوربین رد شد!",
      subtitle: "آیکون دوربین در نزدیکی نوار آدرس مرورگر را بررسی کرده و اگر مسدود شده است، آن را آزاد کنید.",
      readMore: "اطلاعات بیشتر",
      refreshText: "پس از فعال‌سازی دسترسی به دوربین، دکمه «بازنشانی» در پایین را کلیک کنید.",
      refreshBtn: "بازنشانی",
      link: "یا ادامه در تلفن همراه",
      buttonText: "یا ادامه در تلفن همراه"
    },
    androidWebViewPermissionDenied: {
      title: "دسترسی به دوربین رد شد!",
      subtitle: "ممکن است دسترسی به دوربین از طریق تنظیمات برنامه مسدود شده باشد. لطفاً به مسیر اطلاعات برنامه > مجوزها > دوربین بروید و دسترسی را فعال کنید.",
      refreshText: "پس از فعال‌سازی دسترسی به دوربین، دکمه «بازنشانی» در پایین را کلیک کنید.",
      refreshBtn: "بازنشانی",
      link: "یا ادامه در تلفن همراه",
      buttonText: "یا ادامه در تلفن همراه"
    },
    iosBrowserPermissionDenied: {
      title: "دسترسی به دوربین رد شد!",
      subtitle: "برای اجازه دسترسی، روی آیکون دوربین یا قفل کنار نوار آدرس ضربه بزنید یا تنظیمات مرورگر را بررسی کنید.",
      readMore: "اطلاعات بیشتر",
      refreshText: "پس از فعال‌سازی دسترسی به دوربین، دکمه «بازنشانی» در پایین را کلیک کنید.",
      refreshBtn: "بازنشانی",
      link: "یا ادامه در تلفن همراه",
      buttonText: "یا ادامه در تلفن همراه"
    },
    iosWebViewPermissionDenied: {
      title: "دسترسی به دوربین رد شد!",
      subtitle: "ممکن است در تنظیمات سیستم، دسترسی به دوربین برای این برنامه غیرفعال شده باشد. لطفاً به تنظیمات بروید، برنامه موردنظر را انتخاب کرده و مجوز دوربین را فعال کنید.",
      refreshText: "پس از فعال‌سازی دسترسی به دوربین، دکمه «بازنشانی» در پایین را کلیک کنید.",
      refreshBtn: "بازنشانی",
      link: "یا ادامه در تلفن همراه",
      buttonText: "یا ادامه در تلفن همراه"
    },
    documentationList: {
      countryHeading: "کشور را انتخاب کنید",
      docHeading: "سند خود را انتخاب کنید",
      btnText: "بعدی",
      searchCountry: "جستجوی کشور"
    },
    frontDocCapture: {
      heading: "قسمت جلوی کارت شناسایی را در کادر قرار دهید",
      backupHeading: "مشکلی دارید؟ لطفاً به صورت دستی کلیک کنید",
      btnText: "عکس بگیرید",
      headingBack: " در داخل مستطیل",
      uploadButton: "یا، شناسه را بارگذاری کنید"
    },
    backDocCapture: {
      heading: "قسمت پشت کارت شناسایی را در کادر قرار دهید",
      backupHeading: "مشکلی دارید؟ لطفاً به صورت دستی کلیک کنید",
      btnText: "عکس بگیرید",
      containerText: "یا، سند را آپلود کنید",
      text: "در حال ضبط، لطفاً ثابت بمانید",
      headingBack: " در داخل مستطیل",
      skipButton: "رد کردن پشت کارت",
      uploadButton: "یا، شناسه را بارگذاری کنید"
    },
    analyzing: {
      heading: "در حال تحلیل کارت شناسایی شما...",
      subHeading: "لطفاً جزئیات کارت خود را در صفحه بعد بررسی کنید و در صورت لزوم ویرایش کنید"
    },
    imageCheck: {
      heading: "عکس خود را بررسی کنید",
      subHeading: "لطفاً مطمئن شوید که عکس کامل، واضح و بدون تاری و درخشش است.",
      button1: "دوباره عکس بگیرید",
      button2: "مناسب است",
      frontHeading: "عکس جلوی خود را بررسی کنید",
      backHeading: "عکس پشت خود را بررسی کنید"
    },
    errorHandler: {
      heading: "اووه :(",
      subHeading1: "ما با برخی مشکلات مواجه هستیم، اما نگران نباشید! لطفاً دوباره امتحان کنید",
      subHeading2: "اگر این مشکل ادامه پیدا کرد، بعداً بررسی کنید",
      button: "دوباره امتحان کنید"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "لطفاً هر چیزی که صورت شما را می‌پوشاند بردارید",
        button: "دوباره تلاش کنید"
      },
      eyeClosureDetected: {
        heading: "لطفاً چشمان خود را باز نگه دارید و مستقیم به دوربین نگاه کنید",
        button: "دوباره تلاش کنید"
      },
      isMultipleFacesFound: {
        heading: "چندین چهره شناسایی شد. مطمئن شوید که تنها چهره شما در دوربین دیده می‌شود.",
        button: "دوباره تلاش کنید"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "دوباره تلاش کنید"
      },
      faceDetections: {
        heading: "لطفاً این را بردارید",
        button: "دوباره تلاش کنید"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "چندین چهره پیدا شده است",
          button: "دوباره تلاش کنید"
        },
        generalMessage: {
          heading: "لطفاً اطمینان حاصل کنید که در مقابل دوربین زنده هستید",
          button: "دوباره تلاش کنید"
        }
      },
      faceMatch: {
        heading: "چهره شما با عکس شناسنامه تطابق ندارد",
        button: "دوباره تلاش کنید"
      },
      selfieError: {
        heading: "ما نتوانستیم سلفی شما را تایید کنیم",
        subHeading1: "لطفاً این نکات را دنبال کنید و دوباره تلاش کنید",
        instruction1: "به یک مکان روشن بروید و از نور پس زمینه خودداری کنید",
        instruction2: "اطمینان حاصل کنید که چهره شما کاملاً در فریم دیده می‌شود و در وسط فریم است",
        instruction3: "کلاه، عینک یا ماسک خود را بردارید تا صورت شما به وضوح دیده شود",
        button: "دوباره تلاش کنید"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP مطابقت ندارد. لطفاً OTP را واضح و با صدای بلند بخوانید",
        button: "دوباره تلاش کنید"
      },
      activeLivenessGenericFailureMessage: {
        heading: "تأیید ناموفق بود. لطفاً دستورالعمل‌ها را به‌وضوح دنبال کنید و دوباره تلاش کنید",
        button: "دوباره تلاش کنید"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF صفحات زیادی دارد",
        subHeading: "PDF بارگذاری‌شده از محدودیت ۲ صفحه بیشتر است. لطفاً یک PDF حداکثر ۲ صفحه‌ای یا تصویری واضح از کارت شناسایی خود بارگذاری کنید."
      },
      heading: "ما نتوانستیم کارت شناسایی شما را پردازش کنیم",
      subHeading: "شاید شما کارت شناسایی اشتباهی را آپلود می‌کنید یا عکس واضح نیست",
      buttonBack: "دوباره تلاش کنید برای پشت کارت",
      buttonFront: "دوباره تلاش کنید برای جلوی کارت",
      button: "دوباره امتحان کنید",
      captureFrontSide: "عکس‌برداری از روی کارت",
      captureBackSide: "عکس‌برداری از پشت کارت",
      changeIDButton: "انتخاب سند دیگر",
      wrongid: {
        heading: "ما نتوانستیم این سند را پردازش کنیم",
        subHeading: "لطفاً مطمئن شوید که سند صحیح را بارگذاری می‌کنید و کیفیت تصویر واضح است"
      },
      expiredid: {
        heading: "سند شناسایی منقضی شده است!",
        subHeading: "ما نمی‌توانیم سند شناسایی منقضی‌شده را بپذیریم. لطفاً یک سند معتبر ارائه دهید"
      },
      minimumage: {
        heading: "شرط سنی برآورده نشد!",
        subHeading: "سن شما کمتر از حداقل سن لازم است. لطفاً مطمئن شوید که معیار حداقل سن را برآورده می‌کنید"
      },
      mobileAttemptsDone: {
        heading: "سفر در دستگاه قبلی شما از سر گرفته شد",
        subHeading: "این جلسه اکنون برای جلوگیری از تکرار متوقف شده است."
      },
      finished: {
        heading: "سفر به پایان رسیده است",
        subHeading: "سفر یا تکمیل شده یا خاتمه یافته است"
      },
      invalid: {
        heading: "سفر در دسترس نیست !",
        subHeading: "journeyId یافت نشد یا شناسه سفر نامعتبر است"
      },
      INVALID_PAN_NUMBER: {
        heading: "شماره PAN نامعتبر",
        subHeading: "شماره PAN که وارد کرده‌اید معتبر نیست. لطفاً بررسی کنید و دوباره تلاش کنید"
      },
      INVALID_PAN_STATUS: {
        heading: "وضعیت PAN نامعتبر",
        subHeading: "شماره PAN که وارد کرده‌اید معتبر نیست. لطفاً بررسی کنید و دوباره تلاش کنید"
      },
      directKyc: {
        heading: "سفر مستقیم KYC !",
        subHeading: "این یک سفر مستقیم KYC است. سفر فرانت‌اند مجاز نیست."
      },
      DOCTYPE_FALSE: {
        heading: "سند اشتباه ارائه شد!",
        subHeading: "لطفاً یک سند معتبر بارگذاری کنید و مطمئن شوید که کیفیت تصویر خوب است."
      },
      ONLY_FRONT: {
        heading: "پشت کارت شناسایی موجود نیست",
        subHeading: "شما فقط روی کارت را ارائه دادید. لطفاً کارت شناسایی خود را برگردانید و برای ادامه پشت آن را ارائه دهید"
      },
      ONLY_BACK: {
        heading: "روی کارت شناسایی موجود نیست",
        subHeading: "شما فقط پشت کارت را ارائه دادید. لطفاً کارت شناسایی خود را برگردانید و برای ادامه روی آن را ارائه دهید"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "سند به‌زودی منقضی می‌شود",
        subHeading: "سند به دلیل اینکه به‌زودی منقضی می‌شود رد شد."
      },
      DOCUMENT_EXPIRED: {
        heading: "سند منقضی شده است!",
        subHeading: "لطفاً برای ادامه یک سند معتبر و منقضی‌نشده بارگذاری کنید."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "شرط سنی برآورده نشد!",
        subHeading: "سند نشان می‌دهد که شما سن لازم را ندارید. لطفاً یک سند معتبر بارگذاری کنید."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تأیید سند امکان‌پذیر نیست!",
        subHeading: "کیفیت تصویر برای تأیید بسیار پایین است. لطفاً با تصویر واضح‌تری دوباره تلاش کنید."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تأیید سند امکان‌پذیر نیست!",
        subHeading: "برخی اطلاعات قابل تأیید نبودند. لطفاً با تصویر واضح‌تری دوباره تلاش کنید."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تأیید سند امکان‌پذیر نیست!",
        subHeading: "برخی جزئیات به دلیل کیفیت پایین تصویر قابل تأیید نبودند. لطفاً با تصویر واضح‌تری دوباره تلاش کنید"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تأیید سند امکان‌پذیر نیست!",
        subHeading: "برخی جزئیات قابل تأیید نبودند. لطفاً با تصویر واضح‌تری دوباره تلاش کنید."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "مشکل در تأیید عکس شما روی کارت شناسایی",
        subHeading: "ما نتوانستیم عکس شما را روی کارت شناسایی تأیید کنیم. لطفاً عکس واضحی از کارت شناسایی اصلی خود بارگذاری کنید تا بتوانیم آن را تأیید کنیم."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "بررسی الگوی امنیتی سند ناموفق بود",
        subHeading: "ما نتوانستیم الگوهای امنیتی داخلی سند را تأیید کنیم. لطفاً عکس واضحی از کارت شناسایی اصلی بارگذاری کنید تا به ما در تأیید اصالت آن کمک کنید."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "بررسی اصالت سند ناموفق بود",
        subHeading: "ما نشانه‌هایی یافتیم که سند ممکن است اصل نباشد. لطفاً از استفاده از اسکرین‌شات، نسخه‌های چاپی یا نمایش کارت شناسایی روی صفحه خودداری کنید. کارت شناسایی اصلی را با تمام ویژگی‌های کاملاً قابل مشاهده بارگذاری کنید"
      },
      SECURITY_FALSE: {
        heading: "مشکل شناسایی شد!",
        subHeading: "سند قابل تأیید نبود. لطفاً با تصویر واضح‌تری دوباره تلاش کنید"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "کیفیت تصویر پایین!",
        subHeading: "تصویر خیلی تار یا نامشخص است. لطفاً با تصویر واضح‌تری دوباره تلاش کنید"
      },
      FACE_UNDETECTED: {
        heading: "چهره شناسایی نشد",
        subHeading: "ما نتوانستیم چهره قابل مشاهده‌ای روی سند پیدا کنیم. لطفاً کارت شناسایی معتبری بارگذاری کنید که چهره در آن کاملاً واضح باشد"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "مقایسه بین اسناد ناموفق بود",
        subHeading: "مقایسه بین اسناد به دلیل عدم تطابق در یک یا چند فیلد کلیدی (نام، تاریخ تولد یا چهره) ناموفق بود"
      },
      DIGILOCKER_FAILURE: {
        heading: "خطای Digilocker",
        subHeading: "در طول سفر Digilocker خطایی رخ داد. لطفاً دوباره تلاش کنید یا برای ادامه از روش جایگزین استفاده کنید."
      },
      LINKAGE_FAILED: {
        heading: "این تأیید قابل تکمیل نیست",
        subHeading: "اطلاعات ثبت‌شده با سوابق این بررسی مطابقت نداشت."
      }
    },
    biometricConsent: {
      consentStatement: "پیش از گرفتن سلفی، برای تأیید هویت شما به رضایت شما جهت ثبت و پردازش داده‌های بیومتریک‌تان (تصویر چهره و سیگنال‌های زنده‌بودن) نیاز داریم. این داده‌ها فقط برای همین تأیید استفاده می‌شوند.",
      privacyPolicy: "سیاست حفظ حریم خصوصی",
      consentButton: "موافقم — ادامه",
      declineButton: "موافق نیستم",
      confirmTitle: "بدون تأیید بیومتریک ادامه می‌دهید؟",
      confirmBody: "بدون تأیید بیومتریک، سلفی نخواهیم گرفت. تأیید شما با استفاده از اطلاعاتی که قبلاً ارائه کرده‌اید تکمیل می‌شود. این انتخاب برای این نشست نهایی است.",
      goBack: "بازگشت",
      confirmDecline: "تأیید — موافق نیستم",
      declineComplete: "شما انتخاب کردید که با تأیید بیومتریک ادامه ندهید. تأیید هویت شما با استفاده از مدارکی که ارسال کرده‌اید تکمیل شد."
    },
    introLiveness: {
      heading: "در اینجا تأیید کنید که زنده هستید",
      instruction1: "مطمئن شوید که نور کافی وجود دارد",
      instruction2: "مجوزهای لازم را اعطا کنید",
      instruction3: "فقط دستورات را دنبال کنید",
      button: "ادامه دهید",
      subHeading: "فقط یک قدم باقی مانده است"
    },
    phoneSession: {
      heading: "جلسه در تلفن ادامه دارد",
      subheading: "این پنجره را باز نگه دارید تا در تلفن به پایان برسد",
      button: "ادامه در اینجا"
    },
    continueOnPhone: {
      heading: "ادامه در تلفن",
      subheading: "کد QR را اسکن کنید یا لینک زیر را کپی کنید",
      subheading2: "کد QR را اسکن کنید یا لینک را در تلفن خود باز کنید",
      text: "فرایند را کامل کنید",
      text1: "برای ارسال اینجا بررسی کنید",
      button: "کپی کنید",
      copiedButton: "کپی شد!",
      copied: "کپی شد!"
    },
    SsnReview: {
      heading: "جزئیات خود را بررسی کنید",
      subHeading: "تغییرات لازم را انجام دهید و جزئیات را ارسال کنید",
      feild1: "گواهینامه رانندگی",
      feild2: "تاریخ انقضا",
      feild3: "تاریخ تولد",
      feild4: "کلاس",
      feild5: "محدودیت‌ها",
      feild6: "کشور",
      feild7: "آدرس",
      button: "جزئیات درست است"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "چهره خود را در دایره نگه دارید"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "به دوربین نزدیک‌تر شوید"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "خجالت نکشید، جلوی دوربین بیایید"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "خیلی تاریک است. نور بیشتری پیدا کنید"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "خیلی روشن است. نور ملایم‌تری پیدا کنید"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "چهره خود را در دایره نگه دارید"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "بی‌حرکت بمانید"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "صورت را به سمت نور بچرخانید"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "گوشی را هم‌سطح چشم نگه دارید"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "کمی از دوربین فاصله بگیرید"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "چهره خود را در مرکز کادر قرار دهید"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "صورت خود را در مرکز دایره قرار دهید"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "نزدیک‌تر بیایید و صورت خود را مستقیم نگه دارید"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "وارد تصویر شوید و صورت خود را مستقیم نگه دارید"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "خیلی تاریک است. نوری روشن‌تر پیدا کنید"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "خیلی روشن است. نوری مناسب پیدا کنید"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "صورت خود را در مرکز دایره تنظیم کنید"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ثابت بمانید و مستقیم به جلو نگاه کنید"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "رو به نور باشید و ثابت بمانید"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "تلفن خود را در سطح چشم نگه دارید"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "کمی از دوربین دور شوید"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "عالی!"
      },
      smile1: {
        icon: "mood",
        description: "لبخند بزنید، شما عالی به نظر می‌رسید!"
      },
      smile2: {
        icon: "mood",
        description: "برای دوربین لبخند بزنید!"
      }
    },
    successful: {
      title: "تأیید کامل شد",
      text: "اکنون می‌توانید پنجره را ببندید",
      finishBtn: "پایان"
    },
    poweredBy: "تأمین شده توسط",
    redirect: "در حال هدایت در",
    error: {
      message: "URL منقضی شده یا معتبر نیست"
    },
    footer: {
      securedBy: "تأمین شده توسط"
    },
    helpFaq: {
      title: "راهنما و سوالات متداول",
      subtitle: "ما اینجا هستیم تا به شما کمک کنیم",
      cameraText: "برای تأیید هویت شما، ما نیاز داریم که از طریق دوربین دستگاه شما تصاویری بگیریم. بر روی این link کلیک کنید تا بیاموزید چگونه مجوزهای لازم را اعطا کنید",
      cameraHeading: "مجوز دوربین",
      languageText: "در ابتدای فرایند، شما می‌توانید زبان مورد نظر خود را از منوی کشویی در نوار بالای صفحه انتخاب کنید",
      languageHeading: "انتخاب زبان",
      kycText: "KYC یا 'مشتری خود را بشناسید' یک فرآیند برای تایید و احراز هویت مشتریان است که به کمک آن می‌توان اطمینان حاصل کرد که تمامی اقدامات مطابق با قوانین است و از کلاهبرداری و فعالیت‌های غیرقانونی دیگر جلوگیری می‌شود",
      kycHeading: "KYC یعنی چه؟",
      timeText: "معمولاً حدود 60 ثانیه طول می‌کشد. با این حال، این زمان ممکن است بسته به کشورها متفاوت باشد",
      timeHeading: "این کار چقدر زمان می‌برد؟"
    },
    pdfPreviewUnavailable: "نمایش پیش‌نمایش PDF امکان‌پذیر نیست.",
    pdfPreviewHint: "اگر پیش‌نمایش ظاهر نشد، همچنان می‌توانید ادامه دهید.",
    pdfOpenLabel: "باز کردن PDF",
    onlyIdVerificationHeader: {
      title: "بیایید سند شناسایی شما را تأیید کنیم",
      subtitle: "این فقط یک دقیقه طول می‌کشد. فقط سند شناسایی خود را در دسترس داشته باشید",
      instruction1: "اجازه دسترسی به دوربین",
      instruction2: "سند خود را اسکن یا بارگذاری کنید",
      instruction3: "تأیید فوری سند"
    },
    failedUpload: {
      title: "بارگذاری فایل ناموفق بود",
      text: "لطفاً مطمئن شوید که فایل کمتر از ۵ مگابایت و با فرمت ‎.jpg، ‎.jpeg، ‎.png، ‎.heic، ‎.heif یا ‎.pdf است",
      btn: "دوباره تلاش کنید",
      pdfNotAllowedIndia: "بارگذاری PDF برای هند مجاز نیست. لطفاً فایل‌های JPEG، JPG، PNG، HEIC یا HEIF کمتر از 5 مگابایت بارگذاری کنید.",
      pdfNotAllowedIndiaBasic: "بارگذاری PDF برای هند مجاز نیست. لطفاً فایل‌های JPEG، JPG یا PNG کمتر از 5 مگابایت بارگذاری کنید."
    },
    livenessAnalyzing: {
      heading: "در حال تحلیل چهره شما",
      subHeading: "لطفاً صبر کنید، این فقط چند ثانیه طول می‌کشد"
    },
    sessionExpiredError: {
      heading: "متأسفیم، زمان جلسه شما به پایان رسید",
      subHeading1: "شما مدتی غیرفعال بودید. به دلایل امنیتی، جلسه شما به‌طور خودکار منقضی شد",
      subHeading2: "لطفاً دوباره تلاش کنید",
      buttonText: "دوباره تلاش کنید"
    },
    journeyExpiredError: {
      heading: "متأسفیم، پیوند منقضی شده است",
      subHeading1: "پیوند دیگر فعال نیست. به دلایل امنیتی، پیوندها عمر محدودی دارند",
      subHeading2: "لطفاً با پیوند جدید تلاش کنید",
      buttonText: "دوباره تلاش کنید"
    },
    cameraAccessError: {
      alert1: "دسترسی به دوربین رد شد. لطفاً دسترسی به دوربین را در تنظیمات مرورگر خود فعال کنید",
      alert2: "هنگام دسترسی به دوربین خطایی رخ داد",
      alert3: "مرورگر شما از دسترسی به دوربین پشتیبانی نمی‌کند"
    },
    activeLiveness: {
      instruction: "چهره خود را در دایره نگه دارید و دستورالعمل‌ها را دنبال کنید",
      permissionDeniedTitle: "دسترسی به دوربین یا میکروفون رد شد",
      permissionDeniedSubtitle: "لطفاً در تنظیمات مرورگر خود به دوربین و میکروفون اجازه دسترسی دهید و دوباره تلاش کنید."
    },
    flipScreen: {
      heading: "اکنون کارت شناسایی خود را برگردانید",
      subHeading: "لطفاً کارت شناسایی خود را به‌صورت فیزیکی برگردانید تا پشت آن نمایش داده شود، سپس آن را در کادر دوربین قرار دهید.",
      continueButton: "ادامه"
    },
    mobileDocCapture: {
      frontSide: "روی کارت",
      backSide: "پشت کارت",
      of: "ـ",
      upload: "بارگذاری",
      stillNotWorking: "هنوز کار نمی‌کند؟",
      clickToCapture: "کلیک برای ثبت را امتحان کنید",
      skip: "رد کردن"
    }
,
    permissionPopUp: {
      title: "مجوز لازم است",
      subtitle: "برای استفاده از دوربین دسترسی را مجاز کنید",
      decline: "رد کردن",
      allow: "اجازه دادن"
    },
    userDetails: {
      heading: "تأیید PAN",
      subHeading: "لطفاً جزئیات را برای تأیید پر کنید",
      panLabel: "شماره PAN",
      panRequired: "لطفاً شماره PAN خود را وارد کنید",
      saveError: "هنگام ذخیره جزئیات مشکلی پیش آمد. لطفاً دوباره تلاش کنید.",
      proceed: "ادامه"
    },
    redirectCta: {
      or: "یا",
      clickHere: "اینجا کلیک کنید",
      clickHereStart: "اینجا کلیک کنید",
      toContinue: "برای ادامه"
    },
    documentCapture: {
      stillNotWorking: "هنوز کار نمی‌کند؟",
      clickToCaptureInstead: "در عوض کلیک برای عکس‌برداری را امتحان کنید",
      pdfNotAllowedIndia: "بارگذاری PDF برای هند مجاز نیست. لطفاً فایل‌های JPEG، JPG یا PNG کمتر از 5 MB بارگذاری کنید.",
      pdfNotAllowedIndiaMobile: "بارگذاری PDF برای هند مجاز نیست. لطفاً فایل‌های JPEG، JPG، PNG، HEIC یا HEIF کمتر از 5 MB بارگذاری کنید.",
      fileFormatsIndia: "jpeg, jpg, png کمتر از 5 mb",
      fileFormats: "jpeg, jpg, png, pdf کمتر از 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif کمتر از 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf کمتر از 5 mb"
    },
    mobileCapture: {
      upload: "بارگذاری",
      skip: "رد کردن",
      stillNotWorking: "هنوز کار نمی‌کند؟",
      tryClickToCapture: "برای عکس‌برداری ضربه بزنید"
    },
    UserDetails: {
      panLabel: "شماره PAN",
      proceedBtn: "ادامه",
      panRequired: "لطفاً شماره PAN خود را وارد کنید",
      saveError: "هنگام ذخیره اطلاعات خطایی رخ داد. لطفاً دوباره تلاش کنید."
    }
  },
  nan: {
    header: {
      title: "咱來驗證你的身份",
      subtitle: "只會用少過2分鐘",
      havingIssue: "遇到问题了？"
    },
    subHeading: {
      subHeading1: "拍你的身份證文件",
      subHeading2: "確認你有活佇",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    termsAndCondition: {
      title: "我同意遵守以下的條款與條件。",
      privacyPolicy: "看條款",
      beginBtnText: "開始",
      beginLiveness: "開始驗證活佇",
      startLiveness: "繼續驗證活佇"
    },
    permissionDenied: {
      title: "相機存取被拒絕！",
      subtitle: "請檢查瀏覽器網址列附近是否有被封鎖的相機圖示，並解除封鎖。",
      readMore: "看更多",
      refreshText: "授權後，請點擊下方的「刷新」按鈕。",
      refreshBtn: "刷新",
      link: "或者，用手機繼續",
      buttonText: "或者，用手機繼續"
    },
    desktopBrowserPermissionDenied: {
      title: "請允許相機存取",
      subtitle: "瀏覽器可能會請求權限。請按「允許」繼續。",
      readMore: "看更多",
      refreshText: "授權後刷新",
      refreshBtn: "刷新",
      link: "或者，用手機繼續",
      buttonText: "或者，用手機繼續"
    },
    androidBrowserPermissionDenied: {
      title: "相機存取被拒絕！",
      subtitle: "請檢查瀏覽器網址列旁是否有被封鎖的相機圖示，並解除封鎖。",
      readMore: "了解更多",
      refreshText: "啟用相機存取後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或繼續在手機上操作",
      buttonText: "或繼續在手機上操作"
    },
    androidWebViewPermissionDenied: {
      title: "相機存取被拒絕！",
      subtitle: "應用程式設定可能封鎖了相機存取。請前往 App 資訊 > 權限 > 相機，並啟用權限。",
      refreshText: "啟用相機存取後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或繼續在手機上操作",
      buttonText: "或繼續在手機上操作"
    },
    iosBrowserPermissionDenied: {
      title: "相機存取被拒絕！",
      subtitle: "請點擊網址列旁的相機或鎖定圖示以允許存取，或檢查瀏覽器的設定。",
      readMore: "了解更多",
      refreshText: "啟用相機存取後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或繼續在手機上操作",
      buttonText: "或繼續在手機上操作"
    },
    iosWebViewPermissionDenied: {
      title: "相機存取被拒絕！",
      subtitle: "系統設定可能封鎖了相機權限。請前往「設定」> 找到您使用的 App > 啟用相機權限。",
      refreshText: "啟用相機存取後，請點擊下方的「重新整理」按鈕。",
      refreshBtn: "重新整理",
      link: "或繼續在手機上操作",
      buttonText: "或繼續在手機上操作"
    },
    documentationList: {
      countryHeading: "選國家",
      docHeading: "選你的文件",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "放你的身份證正面佇框內",
      backupHeading: "有問題？請手動點擊圖片",
      btnText: "拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "放你的身份證背面佇框內",
      backupHeading: "有問題？請手動點擊圖片",
      btnText: "拍照",
      containerText: "或者，上傳文件",
      text: "正在拍攝，請勿動",
      headingBack: "放入矩形框内",
      skipButton: "跳过背面",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "正在分析你的身份證...",
      subHeading: "請在下一個畫面檢查你的卡片詳細資料，必要時進行編輯"
    },
    imageCheck: {
      heading: "檢查你的照片",
      subHeading: "請確保照片完整、清晰，沒有模糊或反光。",
      button1: "重拍",
      button2: "好",
      frontHeading: "檢查你的正面照片",
      backHeading: "檢查你的背面照片"
    },
    errorHandler: {
      heading: "哎唷 :(",
      subHeading1: "咱遇到一些問題，不過別擔心！請再試一次",
      subHeading2: "若是問題持續，請稍後再試",
      button: "再試一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "請拿掉遮住你面目 ê 物件",
        button: "再試一次"
      },
      eyeClosureDetected: {
        heading: "請開開你的目睭，正正看攝影機",
        button: "閣試看覓"
      },
      isMultipleFacesFound: {
        heading: "檢測到多個面孔。請確保鏡頭中只顯示您的面孔。",
        button: "再試一次"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "再試一次"
      },
      faceDetections: {
        heading: "請拿掉這個",
        button: "再試一次"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "找到幾個面目",
          button: "再試一次"
        },
        generalMessage: {
          heading: "請確定你在鏡頭前面是活的",
          button: "再試一次"
        }
      },
      faceMatch: {
        heading: "你 ê 面目無法同身分證相片配對",
        button: "再試一次"
      },
      selfieError: {
        heading: "咱無法驗證你 ê 自拍",
        subHeading1: "請依照這些提示再試一次",
        instruction1: "換個光線充足 ê 地方，勿好使逆光",
        instruction2: "確定你 ê 面目完全看得到，且擺咧畫面中央",
        instruction3: "為了讓你 ê 面目清楚，請拿掉帽仔、眼鏡或口罩",
        button: "再試一次"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "驗證失敗。請清楚照指示做，再試一次",
        button: "再試一次"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 頁數傷濟",
        subHeading: "上傳的 PDF 超過 2 頁限制。請上傳無超過 2 頁的 PDF，抑是你證件的清楚相片。"
      },
      heading: "咱無法處理你的身份證",
      subHeading: "你可能上傳了錯誤的身份證件或者照片不清晰",
      buttonBack: "重試身份證背面",
      buttonFront: "重試身份證正面",
      button: "再試一次",
      captureFrontSide: "翕正面",
      captureBackSide: "翕背面",
      changeIDButton: "选择另一个文档",
      wrongid: {
        heading: "我们无法处理此文档",
        subHeading: "请确保您上传的是正确的文档，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证件已过期！",
        subHeading: "我们不能接受过期的身份证件，请提供有效的文档"
      },
      minimumage: {
        heading: "年龄要求不符合！",
        subHeading: "您的年龄未达到最低要求，请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "您的旅程已在之前的设备上恢复",
        subHeading: "此会话已停止，以避免重复操作"
      },
      finished: {
        heading: "旅程已结束",
        subHeading: "旅程已完成或终止"
      },
      invalid: {
        heading: "旅程不可用！",
        subHeading: "未找到旅程ID或旅程ID无效"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      DOCTYPE_FALSE: {
        heading: "无法识别文档！",
        subHeading: "请上传有效的文档，并确保图像质量良好"
      },
      ONLY_FRONT: {
        heading: "缺少身份证背面",
        subHeading: "您只上传了身份证正面。请翻转您的身份证并上传背面以继续操作"
      },
      ONLY_BACK: {
        heading: "缺少身份证正面",
        subHeading: "您只上传了身份证背面。请翻转您的身份证并上传正面以继续操作"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期！",
        subHeading: "由于文档即将过期，因此已被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年龄要求未达标！",
        subHeading: "文档显示您的年龄未达到要求，请上传有效的文档"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法进行验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "无法验证您在身份证上的照片",
        subHeading: "我们无法验证您在身份证上的照片。请上传一张原始身份证的清晰照片，以便我们进行确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案验证失败",
        subHeading: "我们无法验证文档内置的安全图案。请上传原始身份证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文件活体检测失败",
        subHeading: "我们发现该文件可能不是真实的。请不要使用屏幕截图、打印件或在屏幕上展示的身份证明。请上传所有特征清晰可见的原始证件。"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "文档无法验证，请重新上传更清晰的图像"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像模糊或不清晰，请重新上传更清晰的图像"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档中找到清晰可见的面部。请上传一张面部清晰可见的有效身份证件。"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "在這裡確認你有活佇",
      instruction1: "確保光線充足",
      instruction2: "允許必要的權限",
      instruction3: "只需按指示操作",
      button: "繼續",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "會話佇手機繼續",
      subheading: "完成手機操作前，請保持此窗口開啟",
      button: "繼續佇這裡"
    },
    continueOnPhone: {
      heading: "佇手機繼續",
      subheading: "掃描QR碼或複製下面的連結",
      subheading2: "掃描QR碼或佇你的手機打開連結",
      text: "完成程序",
      text1: "檢查這裡提交",
      button: "複製",
      copiedButton: "已經拷貝矣！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "檢查你的詳細資料",
      subHeading: "進行必要的更改並提交詳細資料",
      feild1: "駕照",
      feild2: "到期日",
      feild3: "生日",
      feild4: "類別",
      feild5: "限制",
      feild6: "國家",
      feild7: "地址",
      button: "詳細資料正確"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "將你的面擺佇圓箍的中央"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠較倚來，面保持正面"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "入來畫面內，面保持正面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗。找更亮的光"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮。找適合的光"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "調整你的面到圓箍的中央"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "毋通振動，目睭看前方"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面朝光線，毋通振動"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "把手機放佇眼睛高度"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "離相機遠一點"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美!"
      },
      smile1: {
        icon: "mood",
        description: "笑一個，你看起來很棒!"
      },
      smile2: {
        icon: "mood",
        description: "對著相機笑!"
      }
    },
    successful: {
      title: "驗證完成",
      text: "你可以現在關閉窗口了",
      finishBtn: "完成"
    },
    poweredBy: "技術支持",
    redirect: "正在重定向",
    error: {
      message: "URL已過期或無效"
    },
    footer: {
      securedBy: "技術支持"
    },
    helpFaq: {
      title: "帮助与常见问题",
      subtitle: "我们在这里帮助您",
      cameraText: "为了验证您的身份，我们需要使用您的设备摄像头拍摄照片。点击此 link 了解如何授予所需的权限",
      cameraHeading: "相机权限",
      languageText: "在流程开始时，您可以通过从顶部栏的下拉菜单中选择来选择您的首选语言",
      languageHeading: "语言选择",
      kycText: "KYC，或“了解您的客户”，是一个验证和确认客户身份的过程，旨在确保合规并防止欺诈及其他非法活动",
      kycHeading: "KYC是什么意思？",
      timeText: "通常情况下，大约需要60秒。不过，根据国家的不同，可能会有所不同",
      timeHeading: "这需要多长时间？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    onlyIdVerificationHeader: {
      title: "验证您的身份",
      subtitle: "只需一分钟，请准备好您的身份证件",
      instruction1: "允许相机访问",
      instruction2: "扫描或上传您的证件",
      instruction3: "即时证件验证"
    },
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已经一段时间没有操作。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接具有有限的有效期",
      subHeading2: "请使用新的链接尝试",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "相机访问被拒绝。请在浏览器设置中启用相机访问",
      alert2: "访问相机时发生错误",
      alert3: "您的浏览器不支持相机访问"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "ê",
      upload: "上傳",
      stillNotWorking: "猶原袂用得？",
      clickToCapture: "試看覓㩒一下翕相",
      skip: "跳過"
    }
,
    permissionPopUp: {
      title: "需要權限",
      subtitle: "允准存取來用相機",
      decline: "拒絕",
      allow: "允准"
    },
    userDetails: {
      heading: "PAN 驗證",
      subHeading: "請填寫詳細資料來驗證",
      panLabel: "PAN 號碼",
      panRequired: "請輸入你个 PAN 號碼",
      saveError: "儲存詳細資料時出問題矣。請閣試一遍。",
      proceed: "繼續"
    },
    redirectCta: {
      or: "抑是",
      clickHere: "撳遮",
      clickHereStart: "撳遮",
      toContinue: "來繼續"
    },
    documentCapture: {
      stillNotWorking: "猶閣袂使用？",
      clickToCaptureInstead: "改用撳一下來翕相試看覓",
      pdfNotAllowedIndia: "印度袂使上傳 PDF。請上傳細過 5 MB 个 JPEG、JPG 抑是 PNG 檔案。",
      pdfNotAllowedIndiaMobile: "印度袂使上傳 PDF。請上傳細過 5 MB 个 JPEG、JPG、PNG、HEIC 抑是 HEIF 檔案。",
      fileFormatsIndia: "jpeg、jpg、png 細過 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 細過 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 細過 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 細過 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  },
  hak: {
    header: {
      title: "來驗證你个身份",
      subtitle: "這只需少於2分鐘",
      havingIssue: "遇到问题了？"
    },
    subHeading: {
      subHeading1: "拍你个身份證文件",
      subHeading2: "確認你是活着",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    termsAndCondition: {
      title: "我同意遵守下列條款和條件。",
      privacyPolicy: "查看條款",
      beginBtnText: "開始",
      beginLiveness: "開始活體檢查",
      startLiveness: "繼續進行活體檢查"
    },
    permissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的相机图标，并解除屏蔽。",
      readMore: "查看更多",
      refreshText: "授权后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或者，在手机上继续",
      buttonText: "或者，在手机上继续"
    },
    desktopBrowserPermissionDenied: {
      title: "請允許相機訪問",
      subtitle: "瀏覽器可能會請求權限。請點擊“允許”繼續。",
      readMore: "查看更多",
      refreshText: "授權後刷新",
      refreshBtn: "刷新",
      link: "或者，在手機上繼續",
      buttonText: "或者，在手机上继续"
    },
    androidBrowserPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的相机图标，并解除屏蔽。",
      readMore: "了解更多",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    androidWebViewPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "相机访问可能被应用设置所阻止。请进入手机“应用信息” > “权限” > “相机”，并启用访问权限。",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosBrowserPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "点击地址栏旁边的相机或锁图标以允许访问，或检查浏览器设置。",
      readMore: "了解更多",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosWebViewPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "相机访问可能被系统设置所限制。请打开“设置”，找到您使用的应用，并启用相机权限。",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    documentationList: {
      countryHeading: "選擇國家",
      docHeading: "選擇你个文件",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "把身份證正面放在框中",
      backupHeading: "有問題？請手動點擊圖片",
      btnText: "拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "把身份證背面放在框中",
      backupHeading: "有問題？請手動點擊圖片",
      btnText: "拍照",
      containerText: "或者，上傳文件",
      text: "拍攝中，請保持不動",
      headingBack: "放入矩形框内",
      skipButton: "跳过背面",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "正在分析你个身份證...",
      subHeading: "請在下一個屏幕檢查你个卡片詳情，如有必要請編輯"
    },
    imageCheck: {
      heading: "檢查你个照片",
      subHeading: "請確保照片完整、清晰，沒有模糊和反光。",
      button1: "重拍",
      button2: "好",
      frontHeading: "檢查你个正面照片",
      backHeading: "檢查你个背面照片"
    },
    errorHandler: {
      heading: "哦哦 :(",
      subHeading1: "我們遇到了一些問題，但不要擔心！請再試一次",
      subHeading2: "如果這情況持續，請稍後再試",
      button: "再試一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "請拿掉遮住你面目个物件",
        button: "重試一遍"
      },
      eyeClosureDetected: {
        heading: "請開大你个目珠，正正看鏡頭",
        button: "再試一次"
      },
      isMultipleFacesFound: {
        heading: "檢測到多個面孔。請確保鏡頭中只顯示您的面孔。",
        button: "重試一遍"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "重試一遍"
      },
      faceDetections: {
        heading: "請拿掉這個",
        button: "重試一遍"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "發現好幾个面",
          button: "重試一遍"
        },
        generalMessage: {
          heading: "請確保你係鏡頭面前係活生生个",
          button: "重試一遍"
        }
      },
      faceMatch: {
        heading: "你个面無對應身分證照片",
        button: "重試一遍"
      },
      selfieError: {
        heading: "咱無法確認你个自拍",
        subHeading1: "請依照呢啲提示再試一遍",
        instruction1: "換一個光線較好个地方，避免背光",
        instruction2: "確保你个面完全睇到，並且係畫面正中",
        instruction3: "為咗清楚睇到你个面，請拿走帽子、眼鏡或口罩",
        button: "重試一遍"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "驗證失敗。請清楚跈等指示做，重試一遍",
        button: "重試一遍"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 頁數傷多",
        subHeading: "上傳个 PDF 超過 2 頁限制。請上傳無超過 2 頁个 PDF，抑係你證件个清楚相片。"
      },
      heading: "我們無法處理你个身份證",
      subHeading: "你可能上傳了錯誤的身份證件或照片不清晰",
      buttonBack: "重試身份證背面",
      buttonFront: "重試身份證正面",
      button: "再試一次",
      captureFrontSide: "翕正面",
      captureBackSide: "翕背面",
      changeIDButton: "选择另一个文档",
      wrongid: {
        heading: "我们无法处理此文档",
        subHeading: "请确保您上传的是正确的文档，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证件已过期！",
        subHeading: "我们不能接受过期的身份证件，请提供有效的文档"
      },
      minimumage: {
        heading: "年龄要求不符合！",
        subHeading: "您的年龄未达到最低要求，请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "您的旅程已在之前的设备上恢复",
        subHeading: "此会话已停止，以避免重复操作"
      },
      finished: {
        heading: "旅程已结束",
        subHeading: "旅程已完成或终止"
      },
      invalid: {
        heading: "旅程不可用！",
        subHeading: "未找到旅程ID或旅程ID无效"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      DOCTYPE_FALSE: {
        heading: "无法识别文档！",
        subHeading: "请上传有效的文档，并确保图像质量良好"
      },
      ONLY_FRONT: {
        heading: "缺少身份证背面",
        subHeading: "您只上传了身份证正面。请翻转您的身份证并上传背面以继续操作"
      },
      ONLY_BACK: {
        heading: "缺少身份证正面",
        subHeading: "您只上传了身份证背面。请翻转您的身份证并上传正面以继续操作"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期！",
        subHeading: "由于文档即将过期，因此已被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年龄要求未达标！",
        subHeading: "文档显示您的年龄未达到要求，请上传有效的文档"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法进行验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "无法验证您在身份证上的照片",
        subHeading: "我们无法验证您在身份证上的照片。请上传一张原始身份证的清晰照片，以便我们进行确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案验证失败",
        subHeading: "我们无法验证文档内置的安全图案。请上传原始身份证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文件活体检测失败",
        subHeading: "我们发现该文件可能不是真实的。请不要使用屏幕截图、打印件或在屏幕上展示的身份证明。请上传所有特征清晰可见的原始证件。"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "文档无法验证，请重新上传更清晰的图像"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像模糊或不清晰，请重新上传更清晰的图像"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档中找到清晰可见的面部。请上传一张面部清晰可见的有效身份证件。"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "在這裡確認你是活着",
      instruction1: "確保有足夠的光線",
      instruction2: "允許必要的權限",
      instruction3: "只需按照指示操作",
      button: "繼續",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "會話在手機上繼續",
      subheading: "在手機上完成之前，請保持此窗口打開",
      button: "在這裡繼續"
    },
    continueOnPhone: {
      heading: "在手機上繼續",
      subheading: "掃描QR碼或複製下方連結",
      subheading2: "掃描QR碼或在你个手機上打開連結",
      text: "完成流程",
      text1: "在這裡檢查並提交",
      button: "複製",
      copiedButton: "已經複製啦！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "檢查你个詳細資料",
      subHeading: "進行必要的更改並提交詳細資料",
      feild1: "駕駛執照",
      feild2: "到期日",
      feild3: "出生日期",
      feild4: "類別",
      feild5: "限制",
      feild6: "國家",
      feild7: "地址",
      button: "資料正確"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "將你个面擺到圓圈中央"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "行近兜來，面保持正對"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "行入畫面，面保持正對"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了。找更亮的光源"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了。找合適的光源"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "調整你个面到圓圈中央"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "毋好動，目珠看前方"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面對光線，毋好動"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "將手機放在眼睛高度"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "遠離相機一點"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美!"
      },
      smile1: {
        icon: "mood",
        description: "請笑，你看起來很好!"
      },
      smile2: {
        icon: "mood",
        description: "對著相機笑!"
      }
    },
    successful: {
      title: "驗證完成",
      text: "你現在可以關閉窗口了",
      finishBtn: "完成"
    },
    poweredBy: "技術支持",
    redirect: "重定向中",
    error: {
      message: "URL已過期或無效"
    },
    footer: {
      securedBy: "技術支持"
    },
    helpFaq: {
      title: "幫助與常見問題",
      subtitle: "我們在這裡幫助你",
      cameraText: "為了驗證你的身份，我們需要使用你裝置的相機拍攝照片。點擊這個 link 了解如何授予所需的權限",
      cameraHeading: "相機許可",
      languageText: "在流程開始時，你可以從頂部欄的下拉選單中選擇你偏好的語言",
      languageHeading: "語言選擇",
      kycText: "KYC，或“了解你的客戶”，是一個驗證並確認客戶身份的過程，旨在確保合規並防止欺詐及其他非法活動",
      kycHeading: "KYC 是什麼意思？",
      timeText: "通常，大約需要 60 秒。不過，根據不同國家，這可能會有所不同",
      timeHeading: "這需要多長時間？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    onlyIdVerificationHeader: {
      title: "验证您的身份",
      subtitle: "只需一分钟，请准备好您的身份证件",
      instruction1: "允许相机访问",
      instruction2: "扫描或上传您的证件",
      instruction3: "即时证件验证"
    },
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已经一段时间没有操作。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接具有有限的有效期",
      subHeading2: "请使用新的链接尝试",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "相机访问被拒绝。请在浏览器设置中启用相机访问",
      alert2: "访问相机时发生错误",
      alert3: "您的浏览器不支持相机访问"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "个",
      upload: "上傳",
      stillNotWorking: "還係毋會用？",
      clickToCapture: "試吓㩟一下影相",
      skip: "跳過"
    }
,
    permissionPopUp: {
      title: "需要權限",
      subtitle: "允許存取來用相機",
      decline: "拒絕",
      allow: "允許"
    },
    userDetails: {
      heading: "PAN 驗證",
      subHeading: "請填寫詳細資料來驗證",
      panLabel: "PAN 號碼",
      panRequired: "請輸入你个 PAN 號碼",
      saveError: "儲存詳細資料時出問題了。請再試一擺。",
      proceed: "繼續"
    },
    redirectCta: {
      or: "抑係",
      clickHere: "撳這位",
      clickHereStart: "撳這位",
      toContinue: "來繼續"
    },
    documentCapture: {
      stillNotWorking: "還係無法用？",
      clickToCaptureInstead: "改用撳一下來翕相試看仔",
      pdfNotAllowedIndia: "印度毋好上傳 PDF。請上傳細過 5 MB 个 JPEG、JPG 抑係 PNG 檔案。",
      pdfNotAllowedIndiaMobile: "印度毋好上傳 PDF。請上傳細過 5 MB 个 JPEG、JPG、PNG、HEIC 抑係 HEIF 檔案。",
      fileFormatsIndia: "jpeg、jpg、png 細過 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 細過 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 細過 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 細過 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  },
  cjy: {
    header: {
      title: "咱来验证你的身份",
      subtitle: "这只用不到2分钟",
      havingIssue: "遇到问题了？"
    },
    subHeading: {
      subHeading1: "拍你的身份证文件",
      subHeading2: "确认你还活着",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    termsAndCondition: {
      title: "我同意遵守以下的条款和条件。",
      privacyPolicy: "查看条款",
      beginBtnText: "开始",
      beginLiveness: "开始活体检查",
      startLiveness: "继续进行活体检查"
    },
    permissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的相机图标，并将其解除屏蔽。",
      readMore: "查看更多",
      refreshText: "授权后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或者，用手机继续",
      buttonText: "或者，用手机继续"
    },
    desktopBrowserPermissionDenied: {
      title: "请允许相机访问",
      subtitle: "浏览器可能会请求权限。请点击“允许”继续。",
      readMore: "查看更多",
      refreshText: "授权后刷新",
      refreshBtn: "刷新",
      link: "或者，用手机继续",
      buttonText: "或者，用手机继续"
    },
    androidBrowserPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的相机图标，并点击解除屏蔽。",
      readMore: "了解更多",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    androidWebViewPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "相机访问可能被应用设置阻止。请前往“应用信息” > “权限” > “相机”，启用访问权限。",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosBrowserPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "请点击地址栏旁边的相机或锁图标以允许访问，或前往浏览器设置中开启权限。",
      readMore: "了解更多",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosWebViewPermissionDenied: {
      title: "相机访问被拒绝！",
      subtitle: "相机访问可能被系统设置限制。请进入“设置”，找到当前应用并启用相机权限。",
      refreshText: "允许相机访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    documentationList: {
      countryHeading: "选择国家",
      docHeading: "选择你的文件",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "把身份证正面放在框里",
      backupHeading: "有问题？请手动点击图片",
      btnText: "拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "把身份证背面放在框里",
      backupHeading: "有问题？请手动点击图片",
      btnText: "拍照",
      containerText: "或者，上传文件",
      text: "正在拍摄，请保持不动",
      headingBack: "放入矩形框内",
      skipButton: "跳过背面",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "正在分析你的身份证...",
      subHeading: "请在下一个屏幕检查你的卡片详细信息，并在必要时进行编辑"
    },
    imageCheck: {
      heading: "检查你的图片",
      subHeading: "请确保图片完整、清晰，没有模糊或反光。",
      button1: "重拍",
      button2: "好",
      frontHeading: "检查你的正面图片",
      backHeading: "检查你的背面图片"
    },
    errorHandler: {
      heading: "哎呀 :(",
      subHeading1: "咱遇到了一些问题，但不用担心！请再试一次",
      subHeading2: "如果问题持续，稍后再试",
      button: "再试一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "请把遮住你面部的东西拿掉",
        button: "再试一次"
      },
      eyeClosureDetected: {
        heading: "请睁开眼睛，并直视摄像头",
        button: "重试"
      },
      isMultipleFacesFound: {
        heading: "检测到多个面孔。请确保摄像头中只显示您的面孔。",
        button: "再试一次"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "再试一次"
      },
      faceDetections: {
        heading: "请把这个拿掉",
        button: "再试一次"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "发现了多个面部",
          button: "再试一次"
        },
        generalMessage: {
          heading: "请确保你在摄像头前是活着的",
          button: "再试一次"
        }
      },
      faceMatch: {
        heading: "你的面部和身份证照片不匹配",
        button: "再试一次"
      },
      selfieError: {
        heading: "咱没法验证你的自拍",
        subHeading1: "请按照这些提示再试一次",
        instruction1: "移到光线更好的地方，避免背光",
        instruction2: "确保你的面部完全可见，并且在画面中央",
        instruction3: "为确保面部清晰可见，请移除帽子、眼镜或口罩",
        button: "再试一次"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "验证失败。请清晰地按照说明操作并重试",
        button: "再试一次"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 页数太多",
        subHeading: "上传的 PDF 超过 2 页限制。请上传不超过 2 页的 PDF，或者清晰的证件照片。"
      },
      heading: "咱没法处理你的身份证",
      subHeading: "可能你上传了错误的身份证件或图片不清晰",
      buttonBack: "重试身份证背面",
      buttonFront: "重试身份证正面",
      button: "再试一次",
      captureFrontSide: "拍正面",
      captureBackSide: "拍背面",
      changeIDButton: "选择另一个文档",
      wrongid: {
        heading: "我们无法处理此文档",
        subHeading: "请确保您上传的是正确的文档，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证件已过期！",
        subHeading: "我们不能接受过期的身份证件，请提供有效的文档"
      },
      minimumage: {
        heading: "年龄要求不符合！",
        subHeading: "您的年龄未达到最低要求，请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "您的旅程已在之前的设备上恢复",
        subHeading: "此会话已停止，以避免重复操作"
      },
      finished: {
        heading: "旅程已结束",
        subHeading: "旅程已完成或终止"
      },
      invalid: {
        heading: "旅程不可用！",
        subHeading: "未找到旅程ID或旅程ID无效"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      DOCTYPE_FALSE: {
        heading: "无法识别文档！",
        subHeading: "请上传有效的文档，并确保图像质量良好"
      },
      ONLY_FRONT: {
        heading: "缺少身份证背面",
        subHeading: "您只上传了身份证正面。请翻转您的身份证并上传背面以继续操作"
      },
      ONLY_BACK: {
        heading: "缺少身份证正面",
        subHeading: "您只上传了身份证背面。请翻转您的身份证并上传正面以继续操作"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期！",
        subHeading: "由于文档即将过期，因此已被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年龄要求未达标！",
        subHeading: "文档显示您的年龄未达到要求，请上传有效的文档"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法进行验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "无法验证您在身份证上的照片",
        subHeading: "我们无法验证您在身份证上的照片。请上传一张原始身份证的清晰照片，以便我们进行确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案验证失败",
        subHeading: "我们无法验证文档内置的安全图案。请上传原始身份证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文件活体检测失败",
        subHeading: "我们发现该文件可能不是真实的。请不要使用屏幕截图、打印件或在屏幕上展示的身份证明。请上传所有特征清晰可见的原始证件。"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "文档无法验证，请重新上传更清晰的图像"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像模糊或不清晰，请重新上传更清晰的图像"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档中找到清晰可见的面部。请上传一张面部清晰可见的有效身份证件。"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "在这里确认你还活着",
      instruction1: "确保光线充足",
      instruction2: "允许必要的权限",
      instruction3: "按照指示操作",
      button: "继续",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "会话在手机上继续",
      subheading: "在手机上完成之前，请保持此窗口打开",
      button: "在这里继续"
    },
    continueOnPhone: {
      heading: "在手机上继续",
      subheading: "扫描二维码或复制下面的链接",
      subheading2: "扫描二维码或在你的手机上打开链接",
      text: "完成流程",
      text1: "在这里检查并提交",
      button: "复制",
      copiedButton: "复制好咾！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "检查你的详细信息",
      subHeading: "进行必要的更改并提交详细信息",
      feild1: "驾驶证",
      feild2: "到期日",
      feild3: "出生日期",
      feild4: "类别",
      feild5: "限制",
      feild6: "国家",
      feild7: "地址",
      button: "信息正确"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "把你的脸放到圆圈中间"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近些，脸保持正对"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "走进画面，脸保持正对"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗。找更亮的光"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮。找合适的光"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "把你的脸调到圆圈中间"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "不要动，眼看前头"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "脸对着光，不要动"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "把手机放在眼睛高度"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "离相机远一点"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美!"
      },
      smile1: {
        icon: "mood",
        description: "笑一笑，你看起来很好!"
      },
      smile2: {
        icon: "mood",
        description: "对着相机笑!"
      }
    },
    successful: {
      title: "验证完成",
      text: "你现在可以关闭窗口了",
      finishBtn: "完成"
    },
    poweredBy: "技术支持",
    redirect: "正在重定向",
    error: {
      message: "URL已过期或无效"
    },
    footer: {
      securedBy: "技术支持"
    },
    helpFaq: {
      title: "帮助与常见问题",
      subtitle: "我们在这里帮助您",
      cameraText: "为了验证您的身份，我们需要使用您的设备摄像头拍摄照片。点击此 link 了解如何授予所需的权限",
      cameraHeading: "相机权限",
      languageText: "在流程开始时，您可以通过从顶部栏的下拉菜单中选择来选择您的首选语言",
      languageHeading: "语言选择",
      kycText: "KYC，或“了解您的客户”，是一个验证和确认客户身份的过程，旨在确保合规并防止欺诈及其他非法活动",
      kycHeading: "KYC是什么意思？",
      timeText: "通常情况下，大约需要60秒。不过，根据国家的不同，可能会有所不同",
      timeHeading: "这需要多长时间？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    onlyIdVerificationHeader: {
      title: "验证您的身份",
      subtitle: "只需一分钟，请准备好您的身份证件",
      instruction1: "允许相机访问",
      instruction2: "扫描或上传您的证件",
      instruction3: "即时证件验证"
    },
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已经一段时间没有操作。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接具有有限的有效期",
      subHeading2: "请使用新的链接尝试",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "相机访问被拒绝。请在浏览器设置中启用相机访问",
      alert2: "访问相机时发生错误",
      alert3: "您的浏览器不支持相机访问"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "个",
      upload: "上传",
      stillNotWorking: "还是用不成？",
      clickToCapture: "试试点击拍摄",
      skip: "跳过"
    }
,
    permissionPopUp: {
      title: "需要权限",
      subtitle: "允许访问来用摄像头",
      decline: "拒绝",
      allow: "允许"
    },
    userDetails: {
      heading: "PAN 验证",
      subHeading: "请填写详细信息来验证",
      panLabel: "PAN 号码",
      panRequired: "请输入你的 PAN 号码",
      saveError: "保存详细信息时出问题咾。请重试。",
      proceed: "继续"
    },
    redirectCta: {
      or: "或者",
      clickHere: "点这搭",
      clickHereStart: "点这搭",
      toContinue: "来继续"
    },
    documentCapture: {
      stillNotWorking: "还是用不成？",
      clickToCaptureInstead: "改用点一下拍照试试",
      pdfNotAllowedIndia: "印度不许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。",
      pdfNotAllowedIndiaMobile: "印度不许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      fileFormatsIndia: "jpeg、jpg、png 小于 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 小于 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 小于 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 小于 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  },
  hsn: {
    header: {
      title: "哒哒验你个身份",
      subtitle: "只要冇得2分钟",
      havingIssue: "遇到问题了？"
    },
    subHeading: {
      subHeading1: "拍你个身份证",
      subHeading2: "确认你活勒",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    termsAndCondition: {
      title: "我同意遵守以下条款和条件。",
      privacyPolicy: "查看条款",
      beginBtnText: "开始",
      beginLiveness: "开始活体检测",
      startLiveness: "继续活体检测"
    },
    permissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的摄像头图标，并将其解除屏蔽。",
      readMore: "阅读更多",
      refreshText: "授权后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或者，用手机继续",
      buttonText: "或者，用手机继续"
    },
    desktopBrowserPermissionDenied: {
      title: "请允许摄像头访问",
      subtitle: "浏览器可能会请求权限。请点击“允许”继续。",
      readMore: "阅读更多",
      refreshText: "授权后刷新",
      refreshBtn: "刷新",
      link: "或者，用手机继续",
      buttonText: "或者，用手机继续"
    },
    androidBrowserPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的摄像头图标，并点击解除屏蔽。",
      readMore: "了解更多",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    androidWebViewPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "摄像头访问可能被应用设置所阻止。请前往“应用信息” > “权限” > “摄像头”，启用访问权限。",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosBrowserPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "点击地址栏旁的摄像头或锁图标以允许访问，或检查浏览器设置。",
      readMore: "了解更多",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosWebViewPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "摄像头权限可能在系统设置中被禁用。请前往“设置”，找到您使用的应用，并启用摄像头权限。",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    documentationList: {
      countryHeading: "选国家",
      docHeading: "选你个文件",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "把身份证正面放到框里",
      backupHeading: "有问题？请手动点图片",
      btnText: "拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "把身份证背面放到框里",
      backupHeading: "有问题？请手动点图片",
      btnText: "拍照",
      containerText: "或者，上传文件",
      text: "拍摄中，请勿动",
      headingBack: "放入矩形框内",
      skipButton: "跳过背面",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "哒分析你个身份证...",
      subHeading: "请在下个屏幕检查你个卡片详细信息，必要时进行编辑"
    },
    imageCheck: {
      heading: "检查你个照片",
      subHeading: "请确保照片完整、清晰，冇模糊或反光。",
      button1: "重拍",
      button2: "好",
      frontHeading: "检查你个正面照片",
      backHeading: "检查你个背面照片"
    },
    errorHandler: {
      heading: "哎呀 :(",
      subHeading1: "哒碰到些问题，但莫担心！请再试一次",
      subHeading2: "如果问题继续，稍后再试",
      button: "再试一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "请拆除遮住你面个东西",
        button: "重试一遍"
      },
      eyeClosureDetected: {
        heading: "请睁开眼睛，直着看摄像头",
        button: "再试一次"
      },
      isMultipleFacesFound: {
        heading: "检测到多个面孔。请确保摄像头中只显示您的面孔。",
        button: "重试一遍"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "重试一遍"
      },
      faceDetections: {
        heading: "请拆除这个",
        button: "重试一遍"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "发现多个面",
          button: "重试一遍"
        },
        generalMessage: {
          heading: "请确认你在镜头前活着",
          button: "重试一遍"
        }
      },
      faceMatch: {
        heading: "你个面同身份证照片对唔上",
        button: "重试一遍"
      },
      selfieError: {
        heading: "哒冇法确认你个自拍",
        subHeading1: "请跟随呢啲提示再试一遍",
        instruction1: "移到光线好嘅地方，避开背光",
        instruction2: "确保你个面清楚看到，且在画面中间",
        instruction3: "为确保你个面清楚，请拿掉帽子、眼镜或者口罩",
        button: "重试一遍"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "验证失败。请清楚地照说明做，重试一遍",
        button: "重试一遍"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 页数太多",
        subHeading: "上传的 PDF 超过 2 页限制。请上传不超过 2 页的 PDF，或者清晰的证件照片。"
      },
      heading: "哒冇法处理你个身份证",
      subHeading: "你可能上传了错误个身份证件或照片冇清晰",
      buttonBack: "重试身份证背面",
      buttonFront: "重试身份证正面",
      button: "再试一次",
      captureFrontSide: "拍正面",
      captureBackSide: "拍背面",
      changeIDButton: "选择另一个文档",
      wrongid: {
        heading: "我们无法处理此文档",
        subHeading: "请确保您上传的是正确的文档，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证件已过期！",
        subHeading: "我们不能接受过期的身份证件，请提供有效的文档"
      },
      minimumage: {
        heading: "年龄要求不符合！",
        subHeading: "您的年龄未达到最低要求，请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "您的旅程已在之前的设备上恢复",
        subHeading: "此会话已停止，以避免重复操作"
      },
      finished: {
        heading: "旅程已结束",
        subHeading: "旅程已完成或终止"
      },
      invalid: {
        heading: "旅程不可用！",
        subHeading: "未找到旅程ID或旅程ID无效"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      DOCTYPE_FALSE: {
        heading: "无法识别文档！",
        subHeading: "请上传有效的文档，并确保图像质量良好"
      },
      ONLY_FRONT: {
        heading: "缺少身份证背面",
        subHeading: "您只上传了身份证正面。请翻转您的身份证并上传背面以继续操作"
      },
      ONLY_BACK: {
        heading: "缺少身份证正面",
        subHeading: "您只上传了身份证背面。请翻转您的身份证并上传正面以继续操作"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期！",
        subHeading: "由于文档即将过期，因此已被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "年龄要求未达标！",
        subHeading: "文档显示您的年龄未达到要求，请上传有效的文档"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法进行验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分信息无法验证，请重新上传更清晰的图像"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证，请重新上传更清晰的图像"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "无法验证您在身份证上的照片",
        subHeading: "我们无法验证您在身份证上的照片。请上传一张原始身份证的清晰照片，以便我们进行确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案验证失败",
        subHeading: "我们无法验证文档内置的安全图案。请上传原始身份证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文件活体检测失败",
        subHeading: "我们发现该文件可能不是真实的。请不要使用屏幕截图、打印件或在屏幕上展示的身份证明。请上传所有特征清晰可见的原始证件。"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "文档无法验证，请重新上传更清晰的图像"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像模糊或不清晰，请重新上传更清晰的图像"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档中找到清晰可见的面部。请上传一张面部清晰可见的有效身份证件。"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "确认你活勒",
      instruction1: "确保光线充足",
      instruction2: "允许必要个权限",
      instruction3: "按指示操作",
      button: "继续",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "会话在手机上继续",
      subheading: "在手机上完成之前，请保持此窗口打开",
      button: "在这里继续"
    },
    continueOnPhone: {
      heading: "在手机上继续",
      subheading: "扫描QR码或复制下面个链接",
      subheading2: "扫描QR码或在你个手机上打开链接",
      text: "完成流程",
      text1: "在这里检查并提交",
      button: "复制",
      copiedButton: "复制哒咯！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "检查你个详细信息",
      subHeading: "进行必要个更改并提交详细信息",
      feild1: "驾驶证",
      feild2: "到期日",
      feild3: "出生日期",
      feild4: "类别",
      feild5: "限制",
      feild6: "国家",
      feild7: "地址",
      button: "信息正确"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "把你个脸放到圆圈中间"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近点，脸保持正对"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "走进画面，脸保持正对"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗。找更亮个光"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮。找合适个光"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "把你个脸调到圆圈中间"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "莫动，眼睛看前头"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "脸对到光，莫动"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "把手机放在眼睛高度"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "离摄像头远点"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美!"
      },
      smile1: {
        icon: "mood",
        description: "笑一笑，你看起來很好!"
      },
      smile2: {
        icon: "mood",
        description: "对着摄像头笑!"
      }
    },
    successful: {
      title: "验证完成",
      text: "你现在可以关闭窗口了",
      finishBtn: "完成"
    },
    poweredBy: "技术支持",
    redirect: "正在重定向",
    error: {
      message: "URL已过期或无效"
    },
    footer: {
      securedBy: "技术支持"
    },
    helpFaq: {
      title: "帮助与常见问题",
      subtitle: "我们在这里帮助您",
      cameraText: "为了验证您的身份，我们需要使用您的设备摄像头拍摄照片。点击此 link 了解如何授予所需的权限",
      cameraHeading: "相机权限",
      languageText: "在流程开始时，您可以通过从顶部栏的下拉菜单中选择来选择您的首选语言",
      languageHeading: "语言选择",
      kycText: "KYC，或“了解您的客户”，是一个验证和确认客户身份的过程，旨在确保合规并防止欺诈及其他非法活动",
      kycHeading: "KYC是什么意思？",
      timeText: "通常情况下，大约需要60秒。不过，根据国家的不同，可能会有所不同",
      timeHeading: "这需要多长时间？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    onlyIdVerificationHeader: {
      title: "验证您的身份",
      subtitle: "只需一分钟，请准备好您的身份证件",
      instruction1: "允许相机访问",
      instruction2: "扫描或上传您的证件",
      instruction3: "即时证件验证"
    },
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已经一段时间没有操作。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接具有有限的有效期",
      subHeading2: "请使用新的链接尝试",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "相机访问被拒绝。请在浏览器设置中启用相机访问",
      alert2: "访问相机时发生错误",
      alert3: "您的浏览器不支持相机访问"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "格",
      upload: "上传",
      stillNotWorking: "还冇用哒？",
      clickToCapture: "试哈点击拍摄",
      skip: "跳过"
    }
,
    permissionPopUp: {
      title: "需要权限",
      subtitle: "允许访问来用摄像头",
      decline: "拒绝",
      allow: "允许"
    },
    userDetails: {
      heading: "PAN 验证",
      subHeading: "请填好详细信息来验证",
      panLabel: "PAN 号码",
      panRequired: "请输入你嗰 PAN 号码",
      saveError: "保存详细信息嗰时候出问题哒。请重试。",
      proceed: "继续"
    },
    redirectCta: {
      or: "或者",
      clickHere: "点搭里",
      clickHereStart: "点搭里",
      toContinue: "来继续"
    },
    documentCapture: {
      stillNotWorking: "还是用不得？",
      clickToCaptureInstead: "改用点一下拍照试下",
      pdfNotAllowedIndia: "印度冇得上传 PDF。请上传小于 5 MB 嗰 JPEG、JPG 或 PNG 文件。",
      pdfNotAllowedIndiaMobile: "印度冇得上传 PDF。请上传小于 5 MB 嗰 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      fileFormatsIndia: "jpeg、jpg、png 小于 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 小于 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 小于 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 小于 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  },
  ary: {
    header: {
      title: "يلا نتحققو من هويتك",
      subtitle: "هادي غتاخد أقل من 2 دقايق",
      havingIssue: "هل تواجه مشكلة؟"
    },
    subHeading: {
      subHeading1: "تصور بطاقة تعريفك",
      subHeading2: "تأكد بأنك حي",
      livenessHeading1: "ابحث عن مكان ذي إضاءة جيدة",
      livenessHeading2: "حافظ على وجهك في المنتصف"
    },
    termsAndCondition: {
      title: "أنا موافق نلتازم بالشروط والأحكام اللي تحت.",
      privacyPolicy: "شوف الشروط",
      beginBtnText: "بدا",
      beginLiveness: "بداية التحقق من الحياة",
      startLiveness: "تقدم للتحقق من الحياة"
    },
    permissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "شوف واش كاين شي أيقونة ديال الكاميرا محجوبة حد البار ديال العنوان فالمتصفح وحاول تحيد الحظر.",
      readMore: "قرا المزيد",
      refreshText: "من بعد ما تعطي الصلاحيات، كليك على الزر ديال 'تحديث' اللي لتحت.",
      refreshBtn: "تحديث",
      link: "أو، كمل فالتليفون",
      buttonText: "أو، كمل فالتليفون"
    },
    desktopBrowserPermissionDenied: {
      title: "عفاك اسمح بالوصول للكاميرا",
      subtitle: "المتصفح يمكن يطلب الأذونات. عفاك كليك على 'اسمح' باش تكمل.",
      readMore: "قرا المزيد",
      refreshText: "عاود التحديث من بعد ما تعطي الأذونات",
      refreshBtn: "تحديث",
      link: "أو، كمل فالتليفون",
      buttonText: "أو، كمل فالتليفون"
    },
    androidBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "تحقّق من وجود رمز كاميرا محظور بالقرب من شريط العنوان في المتصفح، وقم بإلغاء الحظر.",
      readMore: "اعرف المزيد",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة عبر الهاتف",
      buttonText: "أو، المتابعة عبر الهاتف"
    },
    androidWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "قد يكون الوصول إلى الكاميرا محظورًا من إعدادات التطبيق. اذهب إلى معلومات التطبيق > الأذونات > الكاميرا، وفعّل الإذن.",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة عبر الهاتف",
      buttonText: "أو، المتابعة عبر الهاتف"
    },
    iosBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "انقر على رمز الكاميرا أو القفل بجانب شريط العنوان للسماح بالوصول، أو تحقّق من إعدادات المتصفح.",
      readMore: "اعرف المزيد",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة عبر الهاتف",
      buttonText: "أو، المتابعة عبر الهاتف"
    },
    iosWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "قد تكون الكاميرا محظورة من خلال إعدادات النظام. افتح \"الإعدادات\"، ابحث عن التطبيق، وفعّل إذن الوصول إلى الكاميرا.",
      refreshText: "بمجرد السماح بالوصول إلى الكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، المتابعة عبر الهاتف",
      buttonText: "أو، المتابعة عبر الهاتف"
    },
    documentationList: {
      countryHeading: "اختار البلاد",
      docHeading: "اختار الوثيقة ديالك",
      btnText: "التالي",
      searchCountry: "ابحث عن دولة"
    },
    frontDocCapture: {
      heading: "حط وجه البطاقة فالمربع",
      backupHeading: "واش كاينة شي مشكلة؟ كليك على الصورة يدويا",
      btnText: "تصور",
      headingBack: " داخل المستطيل",
      uploadButton: "أو قم بتحميل الهوية"
    },
    backDocCapture: {
      heading: "حط ظهر البطاقة فالمربع",
      backupHeading: "واش كاينة شي مشكلة؟ كليك على الصورة يدويا",
      btnText: "تصور",
      containerText: "أو، رفع الوثيقة",
      text: "كيتصور، عفاك بقى بلا ماتحرك",
      headingBack: " داخل المستطيل",
      skipButton: "تخطي الوجه الخلفي",
      uploadButton: "أو قم بتحميل الهوية"
    },
    analyzing: {
      heading: "كيتحلل بطاقة تعريفك...",
      subHeading: "عفاك شوف التفاصيل ديال الكارت فالشاشة الجاية وعدلها إذا لزم الأمر"
    },
    imageCheck: {
      heading: "شيك على الصورة ديالك",
      subHeading: "عفاك تأكد بأن الصورة كاملة وواضحة وما فيهاش الضباب أو اللمعان.",
      button1: "عاود التصوير",
      button2: "مزيان",
      frontHeading: "شيك على الصورة الأمامية ديالك",
      backHeading: "شيك على الصورة الخلفية ديالك"
    },
    errorHandler: {
      heading: "آه لا :(",
      subHeading1: "حنا كنواجهو شوية مشاكل، ولكن ما تقلقش! عاود المحاولة",
      subHeading2: "إلا استمرات المشكلة، رجع لاحقا",
      button: "عاود المحاولة"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "من فضلك شيل أي حاجة بتغطي وشك",
        button: "جرب تاني"
      },
      eyeClosureDetected: {
        heading: "من فضلك خليك فاتح عينيك وبُصّ على الكاميرا على طول",
        button: "حاول تاني"
      },
      isMultipleFacesFound: {
        heading: "تم اكتشاف وجوه متعددة. تأكد أن وجهك فقط هو الظاهر في الكاميرا.",
        button: "جرب تاني"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "جرب تاني"
      },
      faceDetections: {
        heading: "من فضلك شيل ده",
        button: "جرب تاني"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "لقينا أكتر من وش",
          button: "جرب تاني"
        },
        generalMessage: {
          heading: "من فضلك تأكد إنك عايش قدام الكاميرا",
          button: "جرب تاني"
        }
      },
      faceMatch: {
        heading: "وشك مش مطابق لصورة البطاقة",
        button: "جرب تاني"
      },
      selfieError: {
        heading: "مقدرناش نتحقق من السيلفي بتاعك",
        subHeading1: "من فضلك اتبع التعليمات دي وجرب تاني",
        instruction1: "اتنقل لمكان مضيء كويس وتجنب الإضاءة الخلفية",
        instruction2: "تأكد إن وشك باين تمامًا وفي نص الإطار",
        instruction3: "شيل القبعة أو النظارة أو الكمامة علشان وشك يظهر بوضوح",
        button: "جرب تاني"
      },
      activeLivenessOtpFailureMessage: {
        heading: "رمز OTP غير مطابق. يرجى قراءة رمز OTP بوضوح وبصوت عالٍ",
        button: "حاول مرة أخرى"
      },
      activeLivenessGenericFailureMessage: {
        heading: "التحقق فشل. لو سمحت اتبع التعليمات بوضوح وجرب تاني",
        button: "جرب تاني"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "ملف PDF فيه بزاف ديال الصفحات",
        subHeading: "ملف PDF لي رفعتي كيتجاوز حد جوج صفحات. عافاك رفع PDF ماشي أكثر من جوج صفحات، ولا تصويرة واضحة ديال البطاقة ديالك."
      },
      heading: "ما قدرناش نعالجو بطاقة تعريفك",
      subHeading: "إما رفعت بطاقة غلط أو الصورة ما واضحةش",
      buttonBack: "عاود المحاولة للظهر",
      buttonFront: "عاود المحاولة للوجه",
      button: "عاود المحاولة",
      captureFrontSide: "صوّر الوجه الأمامي",
      captureBackSide: "صوّر الوجه الخلفي",
      changeIDButton: "اختر مستندًا آخر",
      wrongid: {
        heading: "لم نتمكن من معالجة هذا المستند",
        subHeading: "يرجى التأكد من أنك تقوم بتحميل المستند الصحيح والتأكد من وضوح الصورة"
      },
      expiredid: {
        heading: "هوية منتهية الصلاحية!",
        subHeading: "لا يمكننا قبول هوية منتهية الصلاحية. يرجى تقديم مستند صالح"
      },
      minimumage: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "عمرك أقل من الحد الأدنى المطلوب. يرجى التأكد من أنك تلبي متطلبات العمر الأدنى"
      },
      mobileAttemptsDone: {
        heading: "تم استئناف الرحلة على جهازك السابق",
        subHeading: "تم إيقاف هذه الجلسة لتجنب التكرار"
      },
      finished: {
        heading: "انتهت الرحلة",
        subHeading: "تم إكمال الرحلة أو إنهاؤها"
      },
      invalid: {
        heading: "الرحلة غير متاحة!",
        subHeading: "لم يتم العثور على journeyId أو أن journeyId غير صالح"
      },
      INVALID_PAN_NUMBER: {
        heading: "رقم PAN غير صالح",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      INVALID_PAN_STATUS: {
        heading: "حالة PAN غير صالحة",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      directKyc: {
        heading: "رحلة KYC مباشرة !",
        subHeading: "هذه رحلة KYC مباشرة. رحلة الواجهة الأمامية غير مسموح بها."
      },
      DOCTYPE_FALSE: {
        heading: "المستند غير معترف به!",
        subHeading: "يرجى تحميل مستند صالح والتأكد من جودة الصورة."
      },
      ONLY_FRONT: {
        heading: "الجهة الخلفية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الأمامية فقط. يرجى قلب الهوية وتحميل الجهة الخلفية للمتابعة"
      },
      ONLY_BACK: {
        heading: "الجهة الأمامية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الخلفية فقط. يرجى قلب الهوية وتحميل الجهة الأمامية للمتابعة"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "المستند على وشك الانتهاء!",
        subHeading: "تم رفض المستند لأنه على وشك انتهاء الصلاحية."
      },
      DOCUMENT_EXPIRED: {
        heading: "المستند منتهي الصلاحية!",
        subHeading: "يرجى تحميل مستند صالح وغير منتهي الصلاحية للاستمرار."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "المستند يشير إلى أنك لا تستوفي العمر المطلوب. يرجى تحميل مستند صالح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "جودة الصورة منخفضة جدًا للتحقق. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "بعض المعلومات لم تتمكن من التحقق منها. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل بسبب ضعف جودة الصورة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "مشكلة في التحقق من صورتك على بطاقة الهوية",
        subHeading: "لم نتمكن من التحقق من صورتك على بطاقة الهوية. يرجى تحميل صورة واضحة لبطاقة الهوية الأصلية حتى نتمكن من تأكيدها."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "فشل التحقق من نمط الأمان في الوثيقة",
        subHeading: "لم نتمكن من التحقق من أنماط الأمان المدمجة في الوثيقة. يرجى تحميل صورة واضحة للهوية الأصلية لمساعدتنا في تأكيد صحتها."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "فشل التحقق من حيوية المستند",
        subHeading: "لقد وجدنا مؤشرات على أن المستند قد لا يكون أصليًا. يرجى تجنب استخدام لقطات الشاشة أو النسخ المطبوعة أو عرض الهوية على الشاشة. قم بتحميل المستند الأصلي مع إظهار جميع الميزات بوضوح."
      },
      SECURITY_FALSE: {
        heading: "تم اكتشاف مشكلة!",
        subHeading: "لم يتم التحقق من المستند. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "جودة صورة ضعيفة!",
        subHeading: "الصورة ضبابية جدًا أو غير واضحة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      FACE_UNDETECTED: {
        heading: "لم يتم اكتشاف الوجه",
        subHeading: "لم نتمكن من العثور على وجه مرئي في الوثيقة. يرجى تحميل هوية صالحة حيث يكون الوجه مرئيًا بوضوح."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "فشل المقارنة بين المستندات",
        subHeading: "فشلت المقارنة بين المستندات بسبب عدم تطابق في حقل أو أكثر من الحقول الرئيسية (الاسم أو تاريخ الميلاد أو الوجه)"
      },
      DIGILOCKER_FAILURE: {
        heading: "فشل Digilocker",
        subHeading: "حدث خطأ أثناء رحلة Digilocker. يرجى المحاولة مرة أخرى أو استخدام طريقة بديلة للمتابعة."
      },
      LINKAGE_FAILED: {
        heading: "تعذّر إكمال هذا التحقق",
        subHeading: "لم تتطابق البيانات المُلتقطة مع السجلات الخاصة بهذا الفحص."
      }
    },
    biometricConsent: {
      consentStatement: "قبل التقاط صورتك الشخصية، نحتاج إلى موافقتك على التقاط ومعالجة بياناتك البيومترية (صورة الوجه وإشارات الحيوية) للتحقق من هويتك. تُستخدم هذه البيانات لهذا التحقق فقط.",
      privacyPolicy: "سياسة الخصوصية",
      consentButton: "أوافق — متابعة",
      declineButton: "لا أوافق",
      confirmTitle: "المتابعة دون التحقق البيومتري؟",
      confirmBody: "بدون التحقق البيومتري، لن نلتقط صورة شخصية. سيتم إكمال التحقق باستخدام المعلومات التي قدمتها بالفعل. هذا الاختيار نهائي لهذه الجلسة.",
      goBack: "رجوع",
      confirmDecline: "تأكيد — لا أوافق",
      declineComplete: "لقد اخترت عدم المتابعة بالتحقق البيومتري. تم إكمال التحقق من هويتك باستخدام المستندات التي قدمتها."
    },
    introLiveness: {
      heading: "تأكد بأنك حي هنا",
      instruction1: "تأكد بأن الضوء كافي",
      instruction2: "اسمح بالأذونات اللازمة",
      instruction3: "تابع التعليمات",
      button: "تقدم",
      subHeading: "أنت على بُعد خطوة واحدة فقط"
    },
    phoneSession: {
      heading: "الجلسة مستمرة فالتليفون",
      subheading: "خلي هاد النافذة مفتوحة حتى تكمل فالموبايل",
      button: "كمل هنا"
    },
    continueOnPhone: {
      heading: "كمل فالتليفون",
      subheading: "سكان QR أو انسخ الرابط اللي تحت",
      subheading2: "سكان QR أو فتح الرابط فالتليفون",
      text: "كمل العملية",
      text1: "شوف هنا للتقديم",
      button: "نسخ",
      copiedButton: "تنسخ!",
      copied: "تم النسخ!"
    },
    SsnReview: {
      heading: "شيك على التفاصيل ديالك",
      subHeading: "دير التغييرات اللازمة وقدّم التفاصيل",
      feild1: "رخصة السياقة",
      feild2: "تاريخ الانتهاء",
      feild3: "تاريخ الميلاد",
      feild4: "الفئة",
      feild5: "القيود",
      feild6: "البلاد",
      feild7: "العنوان",
      button: "التفاصيل صحيحة"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "اقترب من الكاميرا"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "لا تخجل، اظهر أمام الكاميرا"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم جدًا. ابحث عن إضاءة أفضل"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ساطع جدًا. ابحث عن إضاءة أخف"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقَ ثابتًا"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "أدر وجهك نحو الضوء"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "أمسك الهاتف على مستوى عينيك"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ابتعد قليلًا عن الكاميرا"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ضع وجهك في منتصف الإطار"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "حط وجهك فوسط الدايرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "قرّب أكثر وخلي وجهك مستقيم"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "دخل فالمنظر وخلي وجهك مستقيم"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم بزاف. قلب على ضوء أقوى"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مضيء بزاف. قلب على ضوء مناسب"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ضبط وجهك فوسط الدايرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "بقا ثابت وشوف قدامك نيشان"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "وجّه وجهك للضو وبقا ثابت"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "خلي التليفون فمستوى العين"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "بعد شوية من الكاميرا"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "ممتاز!"
      },
      smile1: {
        icon: "mood",
        description: "ابتسم، راك غزال!"
      },
      smile2: {
        icon: "mood",
        description: "ابتسم للكاميرا!"
      }
    },
    successful: {
      title: "التحقق كمل",
      text: "دابا يمكن لك تسد النافذة",
      finishBtn: "سالي"
    },
    poweredBy: "مدعوم من",
    redirect: "توجيه فـ",
    error: {
      message: "الرابط متتهى أو غير صالح"
    },
    footer: {
      securedBy: "مدعوم من"
    },
    helpFaq: {
      title: "المساعدة والأسئلة الشائعة",
      subtitle: "نحن هنا لمساعدتك",
      cameraText: "لإثبات هويتك، نحتاج إلى التقاط صور باستخدام كاميرا جهازك. اضغط على هذا link لمعرفة كيفية منح الأذونات المطلوبة",
      cameraHeading: "إذن الكاميرا",
      languageText: "في بداية العملية، يمكنك اختيار لغتك المفضلة عن طريق تحديدها من القائمة المنسدلة في الشريط العلوي",
      languageHeading: "اختيار اللغة",
      kycText: "KYC، أو “اعرف عميلك”، هو عملية للتحقق من هوية العميل وتأكيدها، وهي تهدف إلى ضمان الامتثال ومنع الاحتيال والأنشطة غير القانونية الأخرى",
      kycHeading: "ما هو KYC؟",
      timeText: "عادةً ما يستغرق حوالي 60 ثانية. ومع ذلك، قد يختلف ذلك حسب البلدان",
      timeHeading: "كم من الوقت سيستغرق؟"
    },
    pdfPreviewUnavailable: "تعذّر عرض معاينة ملف PDF.",
    pdfPreviewHint: "إذا لم تظهر المعاينة، لا يزال بإمكانك المتابعة.",
    pdfOpenLabel: "فتح ملف PDF",
    onlyIdVerificationHeader: {
      title: "لنقم بالتحقق من هويتك",
      subtitle: "سيستغرق هذا دقيقة واحدة فقط. يُرجى إحضار وثيقة الهوية الخاصة بك",
      instruction1: "السماح بالوصول إلى الكاميرا",
      instruction2: "مسح أو تحميل الوثيقة",
      instruction3: "التحقق الفوري من الوثيقة"
    },
    failedUpload: {
      title: "فشل تحميل الملف",
      text: "يرجى التأكد من أن حجم الملف أقل من 5 ميغابايت وبصيغة ‎.jpg أو ‎.jpeg أو ‎.png أو ‎.heic أو ‎.heif أو ‎.pdf",
      btn: "حاول مرة أخرى",
      pdfNotAllowedIndia: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 ميغابايت.",
      pdfNotAllowedIndiaBasic: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أقل من 5 ميغابايت."
    },
    livenessAnalyzing: {
      heading: "جارٍ تحليل وجهك",
      subHeading: "يرجى الانتظار، لن يستغرق هذا سوى بضع ثوانٍ"
    },
    sessionExpiredError: {
      heading: "عذرًا، انتهت صلاحية جلستك",
      subHeading1: "كنت غير نشط لفترة، ولأسباب أمنية، انتهت جلستك تلقائيًا",
      subHeading2: "يرجى المحاولة مرة أخرى",
      buttonText: "حاول مرة أخرى"
    },
    journeyExpiredError: {
      heading: "عذرًا، الرابط منتهي الصلاحية",
      subHeading1: "الرابط لم يعد نشطًا. لأسباب أمنية، الروابط لها فترة صلاحية محدودة",
      subHeading2: "يرجى المحاولة برابط جديد",
      buttonText: "حاول مرة أخرى"
    },
    cameraAccessError: {
      alert1: "تم رفض الوصول إلى الكاميرا. يرجى تمكين الوصول إلى الكاميرا في إعدادات متصفحك",
      alert2: "حدث خطأ أثناء الوصول إلى الكاميرا",
      alert3: "متصفحك لا يدعم الوصول إلى الكاميرا"
    },
    activeLiveness: {
      instruction: "أبقِ وجهك داخل الدائرة واتبع التعليمات",
      permissionDeniedTitle: "تم رفض الوصول إلى الكاميرا أو الميكروفون",
      permissionDeniedSubtitle: "يرجى السماح بالوصول إلى الكاميرا والميكروفون في إعدادات متصفحك والمحاولة مرة أخرى."
    },
    flipScreen: {
      heading: "اقلب بطاقة هويتك الآن",
      subHeading: "يرجى قلب بطاقة هويتك فعليًا لإظهار الجهة الخلفية، ثم ضعها داخل إطار الكاميرا.",
      continueButton: "متابعة"
    },
    mobileDocCapture: {
      frontSide: "الوجه القدامي",
      backSide: "الوجه اللوراني",
      of: "ديال",
      upload: "رفع",
      stillNotWorking: "مازال ماخدامش؟",
      clickToCapture: "جرّب التقاط بالكليك",
      skip: "تخطا"
    }
,
    permissionPopUp: {
      title: "الإذن مطلوب",
      subtitle: "سمح بالوصول باش تستعمل الكاميرا",
      decline: "رفض",
      allow: "سمح"
    },
    userDetails: {
      heading: "التحقق من PAN",
      subHeading: "عافاك عمّر التفاصيل باش تتحقق",
      panLabel: "رقم PAN",
      panRequired: "عافاك دخّل رقم PAN ديالك",
      saveError: "وقع شي مشكل ملي كنا كنحفظو التفاصيل. عافاك عاود حاول.",
      proceed: "كمّل"
    },
    redirectCta: {
      or: "ولا",
      clickHere: "كليكي هنا",
      clickHereStart: "كليكي هنا",
      toContinue: "باش تكمّل"
    },
    documentCapture: {
      stillNotWorking: "مازال ماخدامش؟",
      clickToCaptureInstead: "جرّب الالتقاط بالضغط عوض هادشي",
      pdfNotAllowedIndia: "تحميل ملفات PDF ماسموحش للهند. عافاك حمّل ملفات JPEG ولا JPG ولا PNG قل من 5 MB.",
      pdfNotAllowedIndiaMobile: "تحميل ملفات PDF ماسموحش للهند. عافاك حمّل ملفات JPEG ولا JPG ولا PNG ولا HEIC ولا HEIF قل من 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png قل من 5 mb",
      fileFormats: "jpeg, jpg, png, pdf قل من 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif قل من 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf قل من 5 mb"
    },
    mobileCapture: {
      upload: "تحميل",
      skip: "تخطي",
      stillNotWorking: "لا يزال لا يعمل؟",
      tryClickToCapture: "التقط الصورة يدويًا"
    },
    UserDetails: {
      panLabel: "رقم PAN",
      proceedBtn: "متابعة",
      panRequired: "يرجى إدخال رقم PAN الخاص بك",
      saveError: "حدث خطأ أثناء حفظ التفاصيل. يرجى المحاولة مرة أخرى."
    }
  },
  arq: {
    header: {
      title: "يلا نتحققو من هويتك",
      subtitle: "هاد الشي ياخذ أقل من 2 دقايق",
      havingIssue: "هل تواجه مشكلة؟"
    },
    subHeading: {
      subHeading1: "صور بطاقة تعريفك",
      subHeading2: "تأكد بلي راك حي",
      livenessHeading1: "ابحث عن مكان ذي إضاءة جيدة",
      livenessHeading2: "حافظ على وجهك في المنتصف"
    },
    termsAndCondition: {
      title: "أنا موافق على الشروط والأحكام هادي.",
      privacyPolicy: "شوف الشروط",
      beginBtnText: "بدا",
      beginLiveness: "بداية التحقق من الحياة",
      startLiveness: "كمل التحقق من الحياة"
    },
    permissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "شيك واش كاين شي أيقونة ديال الكاميرا محجوبة حد شريط العنوان ديال المتصفح وحيدها.",
      readMore: "قرا المزيد",
      refreshText: "من بعد ما تعطي السماح، عاود التحديث بالضغط على الزر تحت.",
      refreshBtn: "تحديث",
      link: "ولا، كمل في التليفون",
      buttonText: "ولا، كمل في التليفون"
    },
    desktopBrowserPermissionDenied: {
      title: "عفاك اسمح للكاميرا",
      subtitle: "المتصفح يقدر يطلب منك السماح. عفاك كليك على 'اسمح' باش تكمل.",
      readMore: "قرا المزيد",
      refreshText: "عاود التحديث من بعد ما تسمح",
      refreshBtn: "تحديث",
      link: "ولا، كمل في التليفون",
      buttonText: "ولا، كمل في التليفون"
    },
    androidBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "تحقّق من وجود رمز كاميرا محظور بالقرب من شريط العنوان في المتصفح، ثم قم بإلغاء الحظر.",
      readMore: "اعرف المزيد",
      refreshText: "بمجرد منح إذن الوصول للكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    androidWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "قد يكون الوصول إلى الكاميرا محظورًا من إعدادات التطبيق. يرجى الذهاب إلى معلومات التطبيق > الأذونات > الكاميرا وتفعيل الإذن.",
      refreshText: "بمجرد منح إذن الوصول للكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    iosBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "اضغط على رمز الكاميرا أو القفل بجوار شريط العنوان للسماح بالوصول، أو تحقق من إعدادات المتصفح.",
      readMore: "اعرف المزيد",
      refreshText: "بمجرد منح إذن الوصول للكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    iosWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "قد تكون إعدادات النظام قد منعت الوصول إلى الكاميرا. انتقل إلى \"الإعدادات\"، وابحث عن التطبيق، ثم فعّل إذن الكاميرا.",
      refreshText: "بمجرد منح إذن الوصول للكاميرا، اضغط على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    documentationList: {
      countryHeading: "اختار البلاد",
      docHeading: "اختار الوثيقة نتاعك",
      btnText: "التالي",
      searchCountry: "ابحث عن دولة"
    },
    frontDocCapture: {
      heading: "حط وجه بطاقة التعريف في الإطار",
      backupHeading: "عندك مشكلة؟ كليك على الصورة يدويا",
      btnText: "تصور",
      headingBack: " داخل المستطيل",
      uploadButton: "أو قم بتحميل الهوية"
    },
    backDocCapture: {
      heading: "حط ظهر بطاقة التعريف في الإطار",
      backupHeading: "عندك مشكلة؟ كليك على الصورة يدويا",
      btnText: "تصور",
      containerText: "ولا، ارفع الوثيقة",
      text: "راي تصور، عفاك ماتتحركش",
      headingBack: " داخل المستطيل",
      skipButton: "تخطي الوجه الخلفي",
      uploadButton: "أو قم بتحميل الهوية"
    },
    analyzing: {
      heading: "راي تحلل بطاقة تعريفك...",
      subHeading: "عفاك شيك على التفاصيل نتاع الكارت في الشاشة الجاية وعدلها إذا لزم الأمر"
    },
    imageCheck: {
      heading: "شيك على الصورة نتاعك",
      subHeading: "عفاك تأكد بلي الصورة كاملة وواضحة وما فيهاش الضباب أو اللمعان.",
      button1: "عاود التصوير",
      button2: "مليحة",
      frontHeading: "شيك على الصورة الأمامية نتاعك",
      backHeading: "شيك على الصورة الخلفية نتاعك"
    },
    errorHandler: {
      heading: "واه :(",
      subHeading1: "حنا نواجهو شوية مشاكل، ولكن ما تقلقش! عاود المحاولة",
      subHeading2: "إذا استمرات المشكلة، رجع لاحقا",
      button: "عاود المحاولة"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "من فضلك شيل أي حاجة بتغطي وشك",
        button: "جرب تاني"
      },
      isMultipleFacesFound: {
        heading: "تم اكتشاف وجوه متعددة. تأكد أن وجهك فقط هو الظاهر في الكاميرا.",
        button: "جرب تاني"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "جرب تاني"
      },
      faceDetections: {
        heading: "من فضلك شيل ده",
        button: "جرب تاني"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "لقينا أكتر من وش",
          button: "جرب تاني"
        },
        generalMessage: {
          heading: "من فضلك تأكد إنك عايش قدام الكاميرا",
          button: "جرب تاني"
        }
      },
      faceMatch: {
        heading: "وشك مش مطابق لصورة البطاقة",
        button: "جرب تاني"
      },
      selfieError: {
        heading: "مقدرناش نتحقق من السيلفي بتاعك",
        subHeading1: "من فضلك اتبع التعليمات دي وجرب تاني",
        instruction1: "اتنقل لمكان مضيء كويس وتجنب الإضاءة الخلفية",
        instruction2: "تأكد إن وشك باين تمامًا وفي نص الإطار",
        instruction3: "شيل القبعة أو النظارة أو الكمامة علشان وشك يظهر بوضوح",
        button: "جرب تاني"
      },
      eyeClosureDetected: {
        heading: "يرجى إبقاء عينيك مفتوحتين والنظر مباشرة إلى الكاميرا",
        button: "حاول مرة أخرى"
      },
      activeLivenessOtpFailureMessage: {
        heading: "رمز OTP غير مطابق. يرجى قراءة رمز OTP بوضوح وبصوت عالٍ",
        button: "حاول مرة أخرى"
      },
      activeLivenessGenericFailureMessage: {
        heading: "التحقق فشل. لو سمحت اتبع التعليمات بوضوح وجرب تاني",
        button: "جرب تاني"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "ملف PDF فيه برشة صفحات",
        subHeading: "ملف PDF لي رفعت يتعدى حد زوج صفحات. من فضلك ارفع PDF ماشي أكثر من زوج صفحات، ولا صورة واضحة تاع الهوية تاعك."
      },
      heading: "ما قدرناش نعالجو بطاقة تعريفك",
      subHeading: "ياك رفعت بطاقة غلط ولا الصورة ما واضحةش",
      buttonBack: "عاود المحاولة للظهر",
      buttonFront: "عاود المحاولة للوجه",
      button: "عاود المحاولة",
      captureFrontSide: "صوّر الجيهة القدّامية",
      captureBackSide: "صوّر الجيهة التالية",
      changeIDButton: "اختر مستندًا آخر",
      wrongid: {
        heading: "لم نتمكن من معالجة هذا المستند",
        subHeading: "يرجى التأكد من أنك تقوم بتحميل المستند الصحيح والتأكد من وضوح الصورة"
      },
      expiredid: {
        heading: "هوية منتهية الصلاحية!",
        subHeading: "لا يمكننا قبول هوية منتهية الصلاحية. يرجى تقديم مستند صالح"
      },
      minimumage: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "عمرك أقل من الحد الأدنى المطلوب. يرجى التأكد من أنك تلبي متطلبات العمر الأدنى"
      },
      mobileAttemptsDone: {
        heading: "تم استئناف الرحلة على جهازك السابق",
        subHeading: "تم إيقاف هذه الجلسة لتجنب التكرار"
      },
      finished: {
        heading: "انتهت الرحلة",
        subHeading: "تم إكمال الرحلة أو إنهاؤها"
      },
      invalid: {
        heading: "الرحلة غير متاحة!",
        subHeading: "لم يتم العثور على journeyId أو أن journeyId غير صالح"
      },
      INVALID_PAN_NUMBER: {
        heading: "رقم PAN غير صالح",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      INVALID_PAN_STATUS: {
        heading: "حالة PAN غير صالحة",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      directKyc: {
        heading: "رحلة KYC مباشرة !",
        subHeading: "هذه رحلة KYC مباشرة. رحلة الواجهة الأمامية غير مسموح بها."
      },
      DOCTYPE_FALSE: {
        heading: "المستند غير معترف به!",
        subHeading: "يرجى تحميل مستند صالح والتأكد من جودة الصورة."
      },
      ONLY_FRONT: {
        heading: "الجهة الخلفية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الأمامية فقط. يرجى قلب الهوية وتحميل الجهة الخلفية للمتابعة"
      },
      ONLY_BACK: {
        heading: "الجهة الأمامية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الخلفية فقط. يرجى قلب الهوية وتحميل الجهة الأمامية للمتابعة"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "المستند على وشك الانتهاء!",
        subHeading: "تم رفض المستند لأنه على وشك انتهاء الصلاحية."
      },
      DOCUMENT_EXPIRED: {
        heading: "المستند منتهي الصلاحية!",
        subHeading: "يرجى تحميل مستند صالح وغير منتهي الصلاحية للاستمرار."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "المستند يشير إلى أنك لا تستوفي العمر المطلوب. يرجى تحميل مستند صالح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "جودة الصورة منخفضة جدًا للتحقق. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "بعض المعلومات لم تتمكن من التحقق منها. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل بسبب ضعف جودة الصورة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "مشكلة في التحقق من صورتك على بطاقة الهوية",
        subHeading: "لم نتمكن من التحقق من صورتك على بطاقة الهوية. يرجى تحميل صورة واضحة لبطاقة الهوية الأصلية حتى نتمكن من تأكيدها."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "فشل التحقق من نمط الأمان في الوثيقة",
        subHeading: "لم نتمكن من التحقق من أنماط الأمان المدمجة في الوثيقة. يرجى تحميل صورة واضحة للهوية الأصلية لمساعدتنا في تأكيد صحتها."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "فشل التحقق من حيوية المستند",
        subHeading: "لقد وجدنا مؤشرات على أن المستند قد لا يكون أصليًا. يرجى تجنب استخدام لقطات الشاشة أو النسخ المطبوعة أو عرض الهوية على الشاشة. قم بتحميل المستند الأصلي مع إظهار جميع الميزات بوضوح."
      },
      SECURITY_FALSE: {
        heading: "تم اكتشاف مشكلة!",
        subHeading: "لم يتم التحقق من المستند. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "جودة صورة ضعيفة!",
        subHeading: "الصورة ضبابية جدًا أو غير واضحة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      FACE_UNDETECTED: {
        heading: "لم يتم اكتشاف الوجه",
        subHeading: "لم نتمكن من العثور على وجه مرئي في الوثيقة. يرجى تحميل هوية صالحة حيث يكون الوجه مرئيًا بوضوح."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "فشل المقارنة بين المستندات",
        subHeading: "فشلت المقارنة بين المستندات بسبب عدم تطابق في حقل أو أكثر من الحقول الرئيسية (الاسم أو تاريخ الميلاد أو الوجه)"
      },
      DIGILOCKER_FAILURE: {
        heading: "فشل Digilocker",
        subHeading: "حدث خطأ أثناء رحلة Digilocker. يرجى المحاولة مرة أخرى أو استخدام طريقة بديلة للمتابعة."
      },
      LINKAGE_FAILED: {
        heading: "تعذّر إكمال هذا التحقق",
        subHeading: "لم تتطابق البيانات المُلتقطة مع السجلات الخاصة بهذا الفحص."
      }
    },
    biometricConsent: {
      consentStatement: "قبل التقاط صورتك الشخصية، نحتاج إلى موافقتك على التقاط ومعالجة بياناتك البيومترية (صورة الوجه وإشارات الحيوية) للتحقق من هويتك. تُستخدم هذه البيانات لهذا التحقق فقط.",
      privacyPolicy: "سياسة الخصوصية",
      consentButton: "أوافق — متابعة",
      declineButton: "لا أوافق",
      confirmTitle: "المتابعة دون التحقق البيومتري؟",
      confirmBody: "بدون التحقق البيومتري، لن نلتقط صورة شخصية. سيتم إكمال التحقق باستخدام المعلومات التي قدمتها بالفعل. هذا الاختيار نهائي لهذه الجلسة.",
      goBack: "رجوع",
      confirmDecline: "تأكيد — لا أوافق",
      declineComplete: "لقد اخترت عدم المتابعة بالتحقق البيومتري. تم إكمال التحقق من هويتك باستخدام المستندات التي قدمتها."
    },
    introLiveness: {
      heading: "تأكد بلي راك حي هنا",
      instruction1: "تأكد بلي الضوء كافي",
      instruction2: "اسمح بالأذونات اللازمة",
      instruction3: "اتبع التعليمات",
      button: "كمل",
      subHeading: "أنت على بُعد خطوة واحدة فقط"
    },
    phoneSession: {
      heading: "الجلسة مستمرة في التليفون",
      subheading: "خلي هاد النافذة مفتوحة حتى تكمل في الموبايل",
      button: "كمل هنا"
    },
    continueOnPhone: {
      heading: "كمل في التليفون",
      subheading: "امسح QR ولا انسخ الرابط اللي تحت",
      subheading2: "امسح QR ولا افتح الرابط في التليفون",
      text: "كمل العملية",
      text1: "شيك هنا للتقديم",
      button: "نسخ",
      copiedButton: "تنسخ!",
      copied: "تم النسخ!"
    },
    SsnReview: {
      heading: "شيك على التفاصيل نتاعك",
      subHeading: "دير التغييرات اللازمة وقدّم التفاصيل",
      feild1: "رخصة السياقة",
      feild2: "تاريخ الانتهاء",
      feild3: "تاريخ الميلاد",
      feild4: "الفئة",
      feild5: "القيود",
      feild6: "البلاد",
      feild7: "العنوان",
      button: "التفاصيل صحيحة"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "اقترب من الكاميرا"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "لا تخجل، اظهر أمام الكاميرا"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم جدًا. ابحث عن إضاءة أفضل"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ساطع جدًا. ابحث عن إضاءة أخف"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقَ ثابتًا"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "أدر وجهك نحو الضوء"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "أمسك الهاتف على مستوى عينيك"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ابتعد قليلًا عن الكاميرا"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ضع وجهك في منتصف الإطار"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "حط وجهك في وسط الدايرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "قرّب أكثر وخلي وجهك مستقيم"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ادخل في المنظر وخلي وجهك مستقيم"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم بزاف. قلب على ضوء أقوى"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مضيء بزاف. قلب على ضوء مناسب"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ضبط وجهك في وسط الدايرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقى ثابت وشوف قدامك"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "وجّه وجهك للضو وابقى ثابت"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "خلي التليفون في مستوى العين"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "بعد شوية من الكاميرا"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "ممتاز!"
      },
      smile1: {
        icon: "mood",
        description: "ابتسم، راك غزال!"
      },
      smile2: {
        icon: "mood",
        description: "ابتسم للكاميرا!"
      }
    },
    successful: {
      title: "التحقق كمل",
      text: "دركا تقدر تسد النافذة",
      finishBtn: "سالي"
    },
    poweredBy: "مدعوم من",
    redirect: "توجيه فـ",
    error: {
      message: "الرابط راه متتهى ولا غير صالح"
    },
    footer: {
      securedBy: "مدعوم من"
    },
    helpFaq: {
      title: "المساعدة والأسئلة المتكررة",
      subtitle: "نحن هنا للمساعدة",
      cameraText: "لإثبات هويتك، نحتاج إلى التقاط صور باستخدام كاميرا جهازك. اضغط على هذا link لمعرفة كيفية منح الأذونات المطلوبة",
      cameraHeading: "إذن الكاميرا",
      languageText: "في بداية العملية، يمكنك اختيار لغتك المفضلة من خلال تحديدها من القائمة المنسدلة في الشريط العلوي",
      languageHeading: "اختيار اللغة",
      kycText: "KYC، أو “اعرف عميلك”، هو عملية للتحقق من هوية العميل وتأكيدها، وتساعد على ضمان الامتثال ومنع الاحتيال والنشاطات غير القانونية الأخرى",
      kycHeading: "ما هو KYC؟",
      timeText: "عادة ما يستغرق حوالي 60 ثانية. ومع ذلك، قد يختلف هذا حسب الدول",
      timeHeading: "كم من الوقت سيستغرق؟"
    },
    pdfPreviewUnavailable: "تعذّر عرض معاينة ملف PDF.",
    pdfPreviewHint: "إذا لم تظهر المعاينة، لا يزال بإمكانك المتابعة.",
    pdfOpenLabel: "فتح ملف PDF",
    onlyIdVerificationHeader: {
      title: "لنقم بالتحقق من هويتك",
      subtitle: "سيستغرق هذا دقيقة واحدة فقط. يُرجى إحضار وثيقة الهوية الخاصة بك",
      instruction1: "السماح بالوصول إلى الكاميرا",
      instruction2: "مسح أو تحميل الوثيقة",
      instruction3: "التحقق الفوري من الوثيقة"
    },
    failedUpload: {
      title: "فشل تحميل الملف",
      text: "يرجى التأكد من أن حجم الملف أقل من 5 ميغابايت وبصيغة ‎.jpg أو ‎.jpeg أو ‎.png أو ‎.heic أو ‎.heif أو ‎.pdf",
      btn: "حاول مرة أخرى",
      pdfNotAllowedIndia: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 ميغابايت.",
      pdfNotAllowedIndiaBasic: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أقل من 5 ميغابايت."
    },
    livenessAnalyzing: {
      heading: "جارٍ تحليل وجهك",
      subHeading: "يرجى الانتظار، لن يستغرق هذا سوى بضع ثوانٍ"
    },
    sessionExpiredError: {
      heading: "عذرًا، انتهت صلاحية جلستك",
      subHeading1: "كنت غير نشط لفترة، ولأسباب أمنية، انتهت جلستك تلقائيًا",
      subHeading2: "يرجى المحاولة مرة أخرى",
      buttonText: "حاول مرة أخرى"
    },
    journeyExpiredError: {
      heading: "عذرًا، الرابط منتهي الصلاحية",
      subHeading1: "الرابط لم يعد نشطًا. لأسباب أمنية، الروابط لها فترة صلاحية محدودة",
      subHeading2: "يرجى المحاولة برابط جديد",
      buttonText: "حاول مرة أخرى"
    },
    cameraAccessError: {
      alert1: "تم رفض الوصول إلى الكاميرا. يرجى تمكين الوصول إلى الكاميرا في إعدادات متصفحك",
      alert2: "حدث خطأ أثناء الوصول إلى الكاميرا",
      alert3: "متصفحك لا يدعم الوصول إلى الكاميرا"
    },
    activeLiveness: {
      instruction: "أبقِ وجهك داخل الدائرة واتبع التعليمات",
      permissionDeniedTitle: "تم رفض الوصول إلى الكاميرا أو الميكروفون",
      permissionDeniedSubtitle: "يرجى السماح بالوصول إلى الكاميرا والميكروفون في إعدادات متصفحك والمحاولة مرة أخرى."
    },
    flipScreen: {
      heading: "اقلب بطاقة هويتك الآن",
      subHeading: "يرجى قلب بطاقة هويتك فعليًا لإظهار الجهة الخلفية، ثم ضعها داخل إطار الكاميرا.",
      continueButton: "متابعة"
    },
    mobileDocCapture: {
      frontSide: "الوجه القدامي",
      backSide: "الوجه التالي",
      of: "تاع",
      upload: "رفع",
      stillNotWorking: "مازال مايخدمش؟",
      clickToCapture: "جرّب التقاط بالكليك",
      skip: "فوّت"
    }
,
    permissionPopUp: {
      title: "الإذن مطلوب",
      subtitle: "سمح بالوصول باش تستعمل الكاميرا",
      decline: "رفض",
      allow: "سمح"
    },
    userDetails: {
      heading: "التحقق من PAN",
      subHeading: "من فضلك عمّر التفاصيل باش تتحقق",
      panLabel: "رقم PAN",
      panRequired: "من فضلك دخّل رقم PAN تاعك",
      saveError: "صرا شي مشكل كي كنا نحفظو التفاصيل. من فضلك عاود حاول.",
      proceed: "كمّل"
    },
    redirectCta: {
      or: "ولا",
      clickHere: "كليكي هنا",
      clickHereStart: "كليكي هنا",
      toContinue: "باش تكمّل"
    },
    documentCapture: {
      stillNotWorking: "مازال مايخدمش؟",
      clickToCaptureInstead: "جرّب الالتقاط بالضغط بلاصة هكا",
      pdfNotAllowedIndia: "تحميل ملفات PDF ماسموحش للهند. من فضلك حمّل ملفات JPEG ولا JPG ولا PNG أقل من 5 MB.",
      pdfNotAllowedIndiaMobile: "تحميل ملفات PDF ماسموحش للهند. من فضلك حمّل ملفات JPEG ولا JPG ولا PNG ولا HEIC ولا HEIF أقل من 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png أقل من 5 mb",
      fileFormats: "jpeg, jpg, png, pdf أقل من 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif أقل من 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf أقل من 5 mb"
    },
    mobileCapture: {
      upload: "تحميل",
      skip: "تخطي",
      stillNotWorking: "لا يزال لا يعمل؟",
      tryClickToCapture: "التقط الصورة يدويًا"
    },
    UserDetails: {
      panLabel: "رقم PAN",
      proceedBtn: "متابعة",
      panRequired: "يرجى إدخال رقم PAN الخاص بك",
      saveError: "حدث خطأ أثناء حفظ التفاصيل. يرجى المحاولة مرة أخرى."
    }
  },
  apd: {
    header: {
      title: "خلينا نتحقق من هويتك",
      subtitle: "ده بياخد أقل من دقيقتين",
      havingIssue: "هل تواجه مشكلة؟"
    },
    subHeading: {
      subHeading1: "صوّر بطاقة هويتك",
      subHeading2: "تأكد إنك حي",
      livenessHeading1: "ابحث عن مكان ذي إضاءة جيدة",
      livenessHeading2: "حافظ على وجهك في المنتصف"
    },
    termsAndCondition: {
      title: "أنا موافق على الشروط والأحكام دي.",
      privacyPolicy: "شوف الشروط",
      beginBtnText: "ابدأ",
      beginLiveness: "بداية التحقق من الحياة",
      startLiveness: "استمر في التحقق من الحياة"
    },
    permissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "تحقق من وجود أيقونة كاميرا محجوبة بجانب شريط العنوان في المتصفح وقم بإلغاء الحظر.",
      readMore: "اقرأ المزيد",
      refreshText: "بعد السماح بالوصول، اضغط زر 'تحديث' أدناه.",
      refreshBtn: "تحديث",
      link: "أو، كمل في الموبايل",
      buttonText: "أو، كمل في الموبايل"
    },
    desktopBrowserPermissionDenied: {
      title: "رجاءً اسمح بالوصول للكاميرا",
      subtitle: "المتصفح ممكن يطلب الإذن. رجاءً اضغط 'اسمح' عشان تكمل.",
      readMore: "اقرأ المزيد",
      refreshText: "حدّث الصفحة بعد ما تسمح",
      refreshBtn: "تحديث",
      link: "أو، كمل في الموبايل",
      buttonText: "أو، كمل في الموبايل"
    },
    androidBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "تحقّق من وجود رمز كاميرا محظور بجانب شريط العنوان في المتصفح وقم بإلغاء الحظر.",
      readMore: "اعرف المزيد",
      refreshText: "بمجرد السماح بالوصول للكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    androidWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "قد يكون الوصول للكاميرا محظورًا من إعدادات التطبيق. انتقل إلى معلومات التطبيق > الأذونات > الكاميرا وفعّل الإذن.",
      refreshText: "بمجرد السماح بالوصول للكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    iosBrowserPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "انقر على رمز الكاميرا أو القفل بجوار شريط العنوان للسماح بالوصول، أو تحقق من إعدادات المتصفح.",
      readMore: "اعرف المزيد",
      refreshText: "بمجرد السماح بالوصول للكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    iosWebViewPermissionDenied: {
      title: "تم رفض الوصول للكاميرا!",
      subtitle: "ربما تم حظر الكاميرا من إعدادات النظام. انتقل إلى \"الإعدادات\"، ابحث عن التطبيق، وفعّل إذن الكاميرا.",
      refreshText: "بمجرد السماح بالوصول للكاميرا، انقر على زر \"تحديث\" أدناه.",
      refreshBtn: "تحديث",
      link: "أو، تابع من خلال الهاتف",
      buttonText: "أو، تابع من خلال الهاتف"
    },
    documentationList: {
      countryHeading: "اختار البلد",
      docHeading: "اختار مستندك",
      btnText: "التالي",
      searchCountry: "ابحث عن دولة"
    },
    frontDocCapture: {
      heading: "حط وجه البطاقة جوه الإطار",
      backupHeading: "في مشكلة؟ اضغط على الصورة يدويًا",
      btnText: "اخذ صورة",
      headingBack: " داخل المستطيل",
      uploadButton: "أو قم بتحميل الهوية"
    },
    backDocCapture: {
      heading: "حط ظهر البطاقة جوه الإطار",
      backupHeading: "في مشكلة؟ اضغط على الصورة يدويًا",
      btnText: "اخذ صورة",
      containerText: "أو، ارفع المستند",
      text: "جارٍ الالتقاط، رجاءً ما تتحركش",
      headingBack: " داخل المستطيل",
      skipButton: "تخطي الوجه الخلفي",
      uploadButton: "أو قم بتحميل الهوية"
    },
    analyzing: {
      heading: "جاري تحليل البطاقة...",
      subHeading: "رجاءً شيك على تفاصيل البطاقة في الشاشة الجاية وعدلها إذا لزم الأمر"
    },
    imageCheck: {
      heading: "شيك على صورتك",
      subHeading: "رجاءً تأكد إن الصورة كاملة وواضحة ومش مضببة أو فيها لمعان.",
      button1: "أخذ الصورة تاني",
      button2: "ممتاز",
      frontHeading: "شيك على صورتك الأمامية",
      backHeading: "شيك على صورتك الخلفية"
    },
    errorHandler: {
      heading: "يا خسارة :(",
      subHeading1: "نواجه بعض المشاكل، لكن ما تقلق! حاول تاني",
      subHeading2: "إذا استمرت المشكلة، حاول لاحقًا",
      button: "حاول تاني"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "من فضلك شيل أي حاجة بتغطي وشك",
        button: "جرب تاني"
      },
      eyeClosureDetected: {
        heading: "من فضلك افتح عينيك",
        button: "تمام"
      },
      isMultipleFacesFound: {
        heading: "تم اكتشاف وجوه متعددة. تأكد أن وجهك فقط هو الظاهر في الكاميرا.",
        button: "جرب تاني"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "جرب تاني"
      },
      faceDetections: {
        heading: "من فضلك شيل ده",
        button: "جرب تاني"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "لقينا أكتر من وش",
          button: "جرب تاني"
        },
        generalMessage: {
          heading: "من فضلك تأكد إنك عايش قدام الكاميرا",
          button: "جرب تاني"
        }
      },
      faceMatch: {
        heading: "وشك مش مطابق لصورة البطاقة",
        button: "جرب تاني"
      },
      selfieError: {
        heading: "ما قدرنا نعالج البطاقة",
        subHeading1: "من فضلك اتبع التعليمات دي وجرب تاني",
        instruction1: "اتنقل لمكان مضيء كويس وتجنب الإضاءة الخلفية",
        instruction2: "تأكد إن وشك باين تمامًا وفي نص الإطار",
        instruction3: "شيل القبعة أو النظارة أو الكمامة علشان وشك يظهر بوضوح",
        button: "جرب تاني"
      },
      activeLivenessOtpFailureMessage: {
        heading: "رمز OTP غير مطابق. يرجى قراءة رمز OTP بوضوح وبصوت عالٍ",
        button: "حاول مرة أخرى"
      },
      activeLivenessGenericFailureMessage: {
        heading: "التحقق فشل. لو سمحت اتبع التعليمات بوضوح وجرب تاني",
        button: "جرب تاني"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "ملف PDF فيهو صفحات كتيرة",
        subHeading: "ملف الـ PDF المرفوع بتجاوز حد الصفحتين. من فضلك ارفع PDF ما أكتر من صفحتين، أو صورة واضحة لهويتك."
      },
      heading: "ما قدرنا نعالج البطاقة",
      subHeading: "إما رافع بطاقة غلط أو الصورة ما واضحة",
      buttonBack: "حاول تاني للظهر",
      buttonFront: "حاول تاني للوجه",
      button: "حاول تاني",
      captureFrontSide: "صوّر الوجه الأمامي",
      captureBackSide: "صوّر الوجه الخلفي",
      changeIDButton: "اختر مستندًا آخر",
      wrongid: {
        heading: "لم نتمكن من معالجة هذا المستند",
        subHeading: "يرجى التأكد من أنك تقوم بتحميل المستند الصحيح والتأكد من وضوح الصورة"
      },
      expiredid: {
        heading: "هوية منتهية الصلاحية!",
        subHeading: "لا يمكننا قبول هوية منتهية الصلاحية. يرجى تقديم مستند صالح"
      },
      minimumage: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "عمرك أقل من الحد الأدنى المطلوب. يرجى التأكد من أنك تلبي متطلبات العمر الأدنى"
      },
      mobileAttemptsDone: {
        heading: "تم استئناف الرحلة على جهازك السابق",
        subHeading: "تم إيقاف هذه الجلسة لتجنب التكرار"
      },
      finished: {
        heading: "انتهت الرحلة",
        subHeading: "تم إكمال الرحلة أو إنهاؤها"
      },
      invalid: {
        heading: "الرحلة غير متاحة!",
        subHeading: "لم يتم العثور على journeyId أو أن journeyId غير صالح"
      },
      INVALID_PAN_NUMBER: {
        heading: "رقم PAN غير صالح",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      INVALID_PAN_STATUS: {
        heading: "حالة PAN غير صالحة",
        subHeading: "رقم PAN الذي أدخلته غير صالح. يرجى التحقق والمحاولة مرة أخرى"
      },
      directKyc: {
        heading: "رحلة KYC مباشرة !",
        subHeading: "هذه رحلة KYC مباشرة. رحلة الواجهة الأمامية غير مسموح بها."
      },
      DOCTYPE_FALSE: {
        heading: "المستند غير معترف به!",
        subHeading: "يرجى تحميل مستند صالح والتأكد من جودة الصورة."
      },
      ONLY_FRONT: {
        heading: "الجهة الخلفية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الأمامية فقط. يرجى قلب الهوية وتحميل الجهة الخلفية للمتابعة"
      },
      ONLY_BACK: {
        heading: "الجهة الأمامية من الهوية مفقودة",
        subHeading: "لقد قمت بتحميل الجهة الخلفية فقط. يرجى قلب الهوية وتحميل الجهة الأمامية للمتابعة"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "المستند على وشك الانتهاء!",
        subHeading: "تم رفض المستند لأنه على وشك انتهاء الصلاحية."
      },
      DOCUMENT_EXPIRED: {
        heading: "المستند منتهي الصلاحية!",
        subHeading: "يرجى تحميل مستند صالح وغير منتهي الصلاحية للاستمرار."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "لم يتم استيفاء متطلبات العمر!",
        subHeading: "المستند يشير إلى أنك لا تستوفي العمر المطلوب. يرجى تحميل مستند صالح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "جودة الصورة منخفضة جدًا للتحقق. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "بعض المعلومات لم تتمكن من التحقق منها. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل بسبب ضعف جودة الصورة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "تعذر التحقق من المستند!",
        subHeading: "لم يتم التحقق من بعض التفاصيل. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "مشكلة في التحقق من صورتك على بطاقة الهوية",
        subHeading: "لم نتمكن من التحقق من صورتك على بطاقة الهوية. يرجى تحميل صورة واضحة لبطاقة الهوية الأصلية حتى نتمكن من تأكيدها."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "فشل التحقق من نمط الأمان في الوثيقة",
        subHeading: "لم نتمكن من التحقق من أنماط الأمان المدمجة في الوثيقة. يرجى تحميل صورة واضحة للهوية الأصلية لمساعدتنا في تأكيد صحتها."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "فشل التحقق من حيوية المستند",
        subHeading: "لقد وجدنا مؤشرات على أن المستند قد لا يكون أصليًا. يرجى تجنب استخدام لقطات الشاشة أو النسخ المطبوعة أو عرض الهوية على الشاشة. قم بتحميل المستند الأصلي مع إظهار جميع الميزات بوضوح."
      },
      SECURITY_FALSE: {
        heading: "تم اكتشاف مشكلة!",
        subHeading: "لم يتم التحقق من المستند. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      IMAGE_QUALITY_FALSE: {
        heading: "جودة صورة ضعيفة!",
        subHeading: "الصورة ضبابية جدًا أو غير واضحة. يرجى المحاولة مرة أخرى باستخدام صورة أوضح."
      },
      FACE_UNDETECTED: {
        heading: "لم يتم اكتشاف الوجه",
        subHeading: "لم نتمكن من العثور على وجه مرئي في الوثيقة. يرجى تحميل هوية صالحة حيث يكون الوجه مرئيًا بوضوح."
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "فشل المقارنة بين المستندات",
        subHeading: "فشلت المقارنة بين المستندات بسبب عدم تطابق في حقل أو أكثر من الحقول الرئيسية (الاسم أو تاريخ الميلاد أو الوجه)"
      },
      DIGILOCKER_FAILURE: {
        heading: "فشل Digilocker",
        subHeading: "حدث خطأ أثناء رحلة Digilocker. يرجى المحاولة مرة أخرى أو استخدام طريقة بديلة للمتابعة."
      },
      LINKAGE_FAILED: {
        heading: "تعذّر إكمال هذا التحقق",
        subHeading: "لم تتطابق البيانات المُلتقطة مع السجلات الخاصة بهذا الفحص."
      }
    },
    biometricConsent: {
      consentStatement: "قبل التقاط صورتك الشخصية، نحتاج إلى موافقتك على التقاط ومعالجة بياناتك البيومترية (صورة الوجه وإشارات الحيوية) للتحقق من هويتك. تُستخدم هذه البيانات لهذا التحقق فقط.",
      privacyPolicy: "سياسة الخصوصية",
      consentButton: "أوافق — متابعة",
      declineButton: "لا أوافق",
      confirmTitle: "المتابعة دون التحقق البيومتري؟",
      confirmBody: "بدون التحقق البيومتري، لن نلتقط صورة شخصية. سيتم إكمال التحقق باستخدام المعلومات التي قدمتها بالفعل. هذا الاختيار نهائي لهذه الجلسة.",
      goBack: "رجوع",
      confirmDecline: "تأكيد — لا أوافق",
      declineComplete: "لقد اخترت عدم المتابعة بالتحقق البيومتري. تم إكمال التحقق من هويتك باستخدام المستندات التي قدمتها."
    },
    introLiveness: {
      heading: "أكد إنك حي هنا",
      instruction1: "تأكد إن الضوء كافي",
      instruction2: "اسمح بالإذن اللازم",
      instruction3: "تابع التعليمات",
      button: "استمر",
      subHeading: "أنت على بُعد خطوة واحدة فقط"
    },
    phoneSession: {
      heading: "الجلسة مستمرة في الموبايل",
      subheading: "خلي الصفحة دي مفتوحة لحد ما تخلص في الموبايل",
      button: "استمر هنا"
    },
    continueOnPhone: {
      heading: "كمل في الموبايل",
      subheading: "امسح QR أو انسخ الرابط تحت",
      subheading2: "امسح QR أو افتح الرابط في الموبايل",
      text: "كمل العملية",
      text1: "شيك هنا للتقديم",
      button: "نسخ",
      copiedButton: "اتنسخ!",
      copied: "تم النسخ!"
    },
    SsnReview: {
      heading: "شيك على التفاصيل",
      subHeading: "اعمل التعديلات اللازمة وقدّم التفاصيل",
      feild1: "رخصة القيادة",
      feild2: "تاريخ الانتهاء",
      feild3: "تاريخ الميلاد",
      feild4: "الفئة",
      feild5: "القيود",
      feild6: "البلد",
      feild7: "العنوان",
      button: "التفاصيل صحيحة"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "اقترب من الكاميرا"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "لا تخجل، اظهر أمام الكاميرا"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم جدًا. ابحث عن إضاءة أفضل"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "ساطع جدًا. ابحث عن إضاءة أخف"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "أبقِ وجهك داخل الدائرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقَ ثابتًا"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "أدر وجهك نحو الضوء"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "أمسك الهاتف على مستوى عينيك"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "ابتعد قليلًا عن الكاميرا"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "ضع وجهك في منتصف الإطار"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "حط وشك في نص الدايرة"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "قرّب أكتر وخلي وشك مستقيم"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "ادخل في المنظر وخلي وشك مستقيم"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مظلم شديد. دور على ضوء أقوى"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "مضيء شديد. دور على ضوء مناسب"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "ظبط وشك في نص الدايرة"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "ابقى ثابت وبص قدامك"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "وجّه وشك للنور وابقى ثابت"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "خلي الموبايل في مستوى العين"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "بعد شوية من الكاميرا"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "ممتاز!"
      },
      smile1: {
        icon: "mood",
        description: "ابتسم، شكلك كويس!"
      },
      smile2: {
        icon: "mood",
        description: "ابتسم للكاميرا!"
      }
    },
    successful: {
      title: "التحقق اكتمل",
      text: "هسي تقدر تقفل الصفحة",
      finishBtn: "نهاية"
    },
    poweredBy: "مدعوم من",
    redirect: "تحويل فـ",
    error: {
      message: "الرابط انتهى أو غير صالح"
    },
    footer: {
      securedBy: "مدعوم من"
    },
    helpFaq: {
      title: "المساعدة والأسئلة المتكررة",
      subtitle: "نحن هنا لمساعدتك",
      cameraText: "لإثبات هويتك، نحتاج إلى التقاط صور باستخدام كاميرا جهازك. اضغط على هذا link لمعرفة كيفية منح الأذونات المطلوبة",
      cameraHeading: "إذن الكاميرا",
      languageText: "في بداية العملية، يمكنك اختيار لغتك المفضلة من خلال تحديدها من القائمة المنسدلة في الشريط العلوي",
      languageHeading: "اختيار اللغة",
      kycText: "KYC، أو “اعرف عميلك”، هو عملية للتحقق من هوية العميل وتأكيدها، وهي تهدف إلى ضمان الامتثال ومنع الاحتيال والنشاطات غير القانونية الأخرى",
      kycHeading: "ما هو KYC؟",
      timeText: "عادة ما يستغرق حوالي 60 ثانية. ومع ذلك، قد يختلف هذا حسب الدول",
      timeHeading: "كم من الوقت سيستغرق؟"
    },
    pdfPreviewUnavailable: "تعذّر عرض معاينة ملف PDF.",
    pdfPreviewHint: "إذا لم تظهر المعاينة، لا يزال بإمكانك المتابعة.",
    pdfOpenLabel: "فتح ملف PDF",
    onlyIdVerificationHeader: {
      title: "لنقم بالتحقق من هويتك",
      subtitle: "سيستغرق هذا دقيقة واحدة فقط. يُرجى إحضار وثيقة الهوية الخاصة بك",
      instruction1: "السماح بالوصول إلى الكاميرا",
      instruction2: "مسح أو تحميل الوثيقة",
      instruction3: "التحقق الفوري من الوثيقة"
    },
    failedUpload: {
      title: "فشل تحميل الملف",
      text: "يرجى التأكد من أن حجم الملف أقل من 5 ميغابايت وبصيغة ‎.jpg أو ‎.jpeg أو ‎.png أو ‎.heic أو ‎.heif أو ‎.pdf",
      btn: "حاول مرة أخرى",
      pdfNotAllowedIndia: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 ميغابايت.",
      pdfNotAllowedIndiaBasic: "لا يُسمح بتحميل ملفات PDF للهند. يرجى تحميل ملفات JPEG أو JPG أو PNG أقل من 5 ميغابايت."
    },
    livenessAnalyzing: {
      heading: "جارٍ تحليل وجهك",
      subHeading: "يرجى الانتظار، لن يستغرق هذا سوى بضع ثوانٍ"
    },
    sessionExpiredError: {
      heading: "عذرًا، انتهت صلاحية جلستك",
      subHeading1: "كنت غير نشط لفترة، ولأسباب أمنية، انتهت جلستك تلقائيًا",
      subHeading2: "يرجى المحاولة مرة أخرى",
      buttonText: "حاول مرة أخرى"
    },
    journeyExpiredError: {
      heading: "عذرًا، الرابط منتهي الصلاحية",
      subHeading1: "الرابط لم يعد نشطًا. لأسباب أمنية، الروابط لها فترة صلاحية محدودة",
      subHeading2: "يرجى المحاولة برابط جديد",
      buttonText: "حاول مرة أخرى"
    },
    cameraAccessError: {
      alert1: "تم رفض الوصول إلى الكاميرا. يرجى تمكين الوصول إلى الكاميرا في إعدادات متصفحك",
      alert2: "حدث خطأ أثناء الوصول إلى الكاميرا",
      alert3: "متصفحك لا يدعم الوصول إلى الكاميرا"
    },
    activeLiveness: {
      instruction: "أبقِ وجهك داخل الدائرة واتبع التعليمات",
      permissionDeniedTitle: "تم رفض الوصول إلى الكاميرا أو الميكروفون",
      permissionDeniedSubtitle: "يرجى السماح بالوصول إلى الكاميرا والميكروفون في إعدادات متصفحك والمحاولة مرة أخرى."
    },
    flipScreen: {
      heading: "اقلب بطاقة هويتك الآن",
      subHeading: "يرجى قلب بطاقة هويتك فعليًا لإظهار الجهة الخلفية، ثم ضعها داخل إطار الكاميرا.",
      continueButton: "متابعة"
    },
    mobileDocCapture: {
      frontSide: "الوجه الأمامي",
      backSide: "الوجه الخلفي",
      of: "بتاع",
      upload: "رفع",
      stillNotWorking: "لسه ما بيشتغل؟",
      clickToCapture: "جرّب التصوير بالضغطة",
      skip: "تخطّى"
    }
,
    permissionPopUp: {
      title: "الإذن مطلوب",
      subtitle: "اسمح بالوصول عشان تستخدم الكاميرا",
      decline: "رفض",
      allow: "اسمح"
    },
    userDetails: {
      heading: "التحقق من PAN",
      subHeading: "من فضلك املا التفاصيل عشان التحقق",
      panLabel: "رقم PAN",
      panRequired: "من فضلك دخّل رقم PAN بتاعك",
      saveError: "حصل خطأ وإحنا بنحفظ التفاصيل. من فضلك حاول تاني.",
      proceed: "واصل"
    },
    redirectCta: {
      or: "أو",
      clickHere: "كبس هنا",
      clickHereStart: "كبس هنا",
      toContinue: "عشان تواصل"
    },
    documentCapture: {
      stillNotWorking: "لسه ما بشتغل؟",
      clickToCaptureInstead: "جرّب الالتقاط بالكبس بدل كده",
      pdfNotAllowedIndia: "رفع ملفات PDF ما مسموح للهند. من فضلك ارفع ملفات JPEG أو JPG أو PNG أقل من 5 MB.",
      pdfNotAllowedIndiaMobile: "رفع ملفات PDF ما مسموح للهند. من فضلك ارفع ملفات JPEG أو JPG أو PNG أو HEIC أو HEIF أقل من 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png أقل من 5 mb",
      fileFormats: "jpeg, jpg, png, pdf أقل من 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif أقل من 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf أقل من 5 mb"
    },
    mobileCapture: {
      upload: "تحميل",
      skip: "تخطي",
      stillNotWorking: "لا يزال لا يعمل؟",
      tryClickToCapture: "التقط الصورة يدويًا"
    },
    UserDetails: {
      panLabel: "رقم PAN",
      proceedBtn: "متابعة",
      panRequired: "يرجى إدخال رقم PAN الخاص بك",
      saveError: "حدث خطأ أثناء حفظ التفاصيل. يرجى المحاولة مرة أخرى."
    }
  },
  pcm: {
    header: {
      title: "Make we verify your identity",
      subtitle: "E go take less than 2 minutes",
      havingIssue: "You get problem?"
    },
    subHeading: {
      subHeading1: "Snap your ID document",
      subHeading2: "Confirm say you dey alive",
      livenessHeading1: "Find place wey get good light",
      livenessHeading2: "Keep your face for di center"
    },
    termsAndCondition: {
      title: "I agree to gree and follow the terms and conditions wey dey here.",
      privacyPolicy: "See terms",
      beginBtnText: "Start",
      beginLiveness: "Dey start liveness check",
      startLiveness: "Proceed to liveness check"
    },
    permissionDenied: {
      title: "Camera access deny!",
      subtitle: "Make you check if browser block camera icon near address bar, then unblock am.",
      readMore: "Read More",
      refreshText: "After you allow camera access, click the 'Refresh' button below.",
      refreshBtn: "Refresh",
      link: "Or, Continue for Phone",
      buttonText: "Or, Continue for Phone"
    },
    desktopBrowserPermissionDenied: {
      title: "Camera access deny!",
      subtitle: "Browser fit ask for permissions. Abeg click 'allow' to continue.",
      readMore: "Read More",
      refreshText: "Refresh after you allow permissions",
      refreshBtn: "Refresh",
      link: "Or, Continue for Phone",
      buttonText: "Or, Continue for Phone"
    },
    androidBrowserPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Check for a blocked camera icon near the browser's address bar and unblock it.",
      readMore: "Learn More",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or, continue on phone",
      buttonText: "Or, continue on phone"
    },
    androidWebViewPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Camera access might be blocked by app settings. Please check App Info > Permissions > Camera and enable access.",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or, continue on phone",
      buttonText: "Or, continue on phone"
    },
    iosBrowserPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Tap the camera or lock icon near the address bar to allow access, or check your browser settings.",
      readMore: "Learn More",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or, continue on phone",
      buttonText: "Or, continue on phone"
    },
    iosWebViewPermissionDenied: {
      title: "Camera access denied!",
      subtitle: "Camera access might be blocked by your device settings. Go to Settings, find the app, and enable Camera permission.",
      refreshText: "Once camera access is allowed, click the Refresh button below.",
      refreshBtn: "Refresh",
      link: "Or, continue on phone",
      buttonText: "Or, continue on phone"
    },
    documentationList: {
      countryHeading: "Select country",
      docHeading: "Select your document",
      btnText: "Next",
      searchCountry: "Search Country"
    },
    frontDocCapture: {
      heading: "Place front side of ID for the rectangle",
      backupHeading: "Get wahala? Abeg click the image manually",
      btnText: "Snap photo",
      headingBack: " inside di rectangle",
      uploadButton: "or, Upload ID"
    },
    backDocCapture: {
      heading: "Place back side of ID for the rectangle",
      backupHeading: "Get wahala? Abeg click the image manually",
      btnText: "Snap photo",
      containerText: "or, upload document",
      text: "Capturing, make you hold still",
      headingBack: " inside di rectangle",
      skipButton: "Skip Di Back",
      uploadButton: "or, Upload ID"
    },
    analyzing: {
      heading: "Dey analyze your ID...",
      subHeading: "Abeg check your card details for the next screen and edit if necessary"
    },
    imageCheck: {
      heading: "Check your image",
      subHeading: "Abeg make sure say the image complete, clear and e no get blur and glare.",
      button1: "Retake Photo",
      button2: "E Good",
      frontHeading: "Check your front image",
      backHeading: "Check your back image"
    },
    errorHandler: {
      heading: "Oh no :(",
      subHeading1: "We dey face some issues, but no worry! Abeg try again",
      subHeading2: "If e still dey happen, check back later",
      button: "Try again"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Abeg remove anything wey dey cover your face",
        button: "Try Again"
      },
      eyeClosureDetected: {
        heading: "Abeg no close your eyes, look straight for the camera",
        button: "Try Again"
      },
      isMultipleFacesFound: {
        heading: "Dem detect multiple face. Make sure say only your face dey show for camera.",
        button: "Try Again"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Try Again"
      },
      faceDetections: {
        heading: "Abeg remove this",
        button: "Try Again"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "We see more than one face",
          button: "Try Again"
        },
        generalMessage: {
          heading: "Abeg make sure say you dey alive for front of the camera",
          button: "Try Again"
        }
      },
      faceMatch: {
        heading: "Your face no match with the photo ID",
        button: "Try Again"
      },
      selfieError: {
        heading: "We no fit verify your selfie",
        subHeading1: "Abeg follow these tips and try again",
        instruction1: "Change location go place wey get good light and avoid backlight",
        instruction2: "Make sure say your face dey clear and center for the frame",
        instruction3: "Remove hat, glasses, or mask to make your face clearer",
        button: "Try Again"
      },
      activeLivenessOtpFailureMessage: {
        heading: "Di OTP no match. Abeg read di OTP clearly and loud",
        button: "Try Again"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verification fail. Abeg follow the instructions well well and try again",
        button: "Try Again"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF get too many pages",
        subHeading: "The PDF wey you upload pass the 2-page limit. Abeg upload PDF wey no pass 2 pages, or a clear picture of your ID."
      },
      heading: "We no fit process your ID",
      subHeading: "Either you dey upload wrong ID or the image no clear",
      buttonBack: "Retry Back-side of ID",
      buttonFront: "Retry Front-side of ID",
      button: "Retry",
      captureFrontSide: "Capture Front Side",
      captureBackSide: "Capture Back Side",
      changeIDButton: "Choose Anoda Document",
      wrongid: {
        heading: "We no fit process dis document",
        subHeading: "Abeg confirm say you dey upload di correct document and make sure say di picture quality clear"
      },
      expiredid: {
        heading: "ID Document Don Expire!",
        subHeading: "We no fit accept ID document wey don expire. Abeg provide valid document"
      },
      minimumage: {
        heading: "You No Meet Di Age Requirement!",
        subHeading: "Your age dey below di minimum required age. Abeg make sure say you meet di minimum age criteria"
      },
      mobileAttemptsDone: {
        heading: "Journey continue for your previous device",
        subHeading: "Dem don stop dis session now to avoid duplicate."
      },
      finished: {
        heading: "Di journey don end",
        subHeading: "Di journey don complete or dem don terminate am"
      },
      invalid: {
        heading: "Journey No Dey Available !",
        subHeading: "Dem no find journeyId or di journey ID no valid"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN Number No Correct",
        subHeading: "Di PAN number wey you enter no valid. Abeg check am and try again"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN Status No Correct",
        subHeading: "Di PAN number wey you enter no valid. Abeg check am and try again"
      },
      directKyc: {
        heading: "Direct KYC Journey !",
        subHeading: "Na direct KYC journey be dis. Dem no allow frontend journey."
      },
      DOCTYPE_FALSE: {
        heading: "Wrong Document Wey Dem Provide!",
        subHeading: "Abeg upload valid document and make sure say di image quality dey good."
      },
      ONLY_FRONT: {
        heading: "Di back of di ID no dey",
        subHeading: "You provide only di front. Abeg flip your ID and provide di back to continue"
      },
      ONLY_BACK: {
        heading: "Di front of di ID no dey",
        subHeading: "You provide only di back. Abeg flip your ID and provide di front to continue"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Document Go Expire Soon",
        subHeading: "Dem reject di document because e go soon expire."
      },
      DOCUMENT_EXPIRED: {
        heading: "Document Don Expire!",
        subHeading: "Abeg upload valid document wey never expire to continue."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "You No Meet Di Age Requirement!",
        subHeading: "Di document show say you no meet di required age. Abeg upload valid document."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "We No Fit Verify Di Document!",
        subHeading: "Di image quality too poor for verification. Abeg try again with clearer image."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "We No Fit Verify Di Document!",
        subHeading: "Some information no fit verify. Abeg try again with clearer image."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "We No Fit Verify Di Document!",
        subHeading: "Some details no fit verify because di image quality poor. Abeg try again with clearer image"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "We No Fit Verify Di Document!",
        subHeading: "Some details no fit verify. Abeg try again with clearer image."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Problem to verify your photo for di ID",
        subHeading: "We no fit verify your photo for di ID card. Abeg upload clear photo of your original ID so we fit confirm am."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Document security pattern check fail",
        subHeading: "We no fit verify di document built-in security patterns. Abeg upload clear photo of di original ID make e help us confirm say e real."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Document Liveness Check Fail",
        subHeading: "We see signs say di document fit no be di real one. Abeg no use screenshots, printed copies, or show di ID for screen. Upload di original ID wey all di features dey show clear"
      },
      SECURITY_FALSE: {
        heading: "We Detect Problem!",
        subHeading: "We no fit verify di document. Abeg try again with clearer image"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Poor Image Quality!",
        subHeading: "Di image too blurry or e no clear. Abeg try again with clearer image"
      },
      FACE_UNDETECTED: {
        heading: "We No Detect Face",
        subHeading: "We no fit find face wey dey show for di document. Abeg upload valid ID wey di face dey show clear"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Comparison Between Documents Fail",
        subHeading: "Di comparison between documents fail because one or more key field (Name, Date of Birth, or Face) no match"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker Fail",
        subHeading: "Error happen during di Digilocker journey. Abeg try again or use anoda method to continue."
      },
      LINKAGE_FAILED: {
        heading: "Dis verification no fit complete",
        subHeading: "Di details wey we collect no match di records for dis check."
      }
    },
    biometricConsent: {
      consentStatement: "Bifor your selfie, we need your consent to capture and process your biometric data (face image and liveness signals) to verify your identity. We dey use this data for this verification only.",
      privacyPolicy: "Privacy policy",
      consentButton: "I gree — Continue",
      declineButton: "I no gree",
      confirmTitle: "You wan continue without biometric verification?",
      confirmBody: "Without biometric verification, we no go capture selfie. We go complete your verification with the information wey you don provide already. This choice na final for this session.",
      goBack: "Go back",
      confirmDecline: "Confirm — I no gree",
      declineComplete: "You don choose say make you no continue with biometric verification. We don complete your identity verification with the documents wey you submit."
    },
    introLiveness: {
      heading: "Confirm say you dey alive here",
      instruction1: "Make sure say light dey enough",
      instruction2: "Allow the necessary permissions",
      instruction3: "Just follow the instructions",
      button: "Proceed",
      subHeading: "Na only one step remain for you"
    },
    phoneSession: {
      heading: "Session continue for phone",
      subheading: "Keep this window open until you finish for the mobile",
      button: "Continue here"
    },
    continueOnPhone: {
      heading: "Continue for phone",
      subheading: "Scan the QR or copy the link below",
      subheading2: "Scan QR or open the link for your phone",
      text: "Complete the process",
      text1: "Check back here to submit",
      button: "Copy",
      copiedButton: "Don copy!",
      copied: "Copied!"
    },
    SsnReview: {
      heading: "Review your details",
      subHeading: "Make any necessary changes and submit the details",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "Details dey correct"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Keep your face inside di circle"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Come near di camera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "No shy, enter di view"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too dark. Find brighter light"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too bright. Find softer light"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Keep your face inside di circle"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Stay still"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Turn your face towards di light"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Hold di phone for eye level"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Move small comot from di camera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Put your face for di center of di frame"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Put your face for di center of di circle"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Move closer and keep your face straight"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Step inside di view and keep your face straight"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too dark. Find brighter light"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Too bright. Find optimal light"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Adjust your face to di center of di circle"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Hold body steady and look straight for front"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Face di light and stay steady"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Hold your phone at eye level"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Move small away from the camera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perfect!"
      },
      smile1: {
        icon: "mood",
        description: "Smile abeg, you dey look good!"
      },
      smile2: {
        icon: "mood",
        description: "Smile for the camera!"
      }
    },
    successful: {
      title: "Verification Complete",
      text: "You fit close the window now",
      finishBtn: "Finish"
    },
    poweredBy: "Powered by",
    redirect: "Redirecting in",
    error: {
      message: "URL don expire or no valid"
    },
    footer: {
      securedBy: "Powered by"
    },
    helpFaq: {
      title: "मदद र सामान्य सोधिने प्रश्नहरू",
      subtitle: "हामी तपाईंलाई मद्दत गर्न यहाँ छौं",
      cameraText: "तपाईंको पहिचान प्रमाणित गर्नका लागि, हामीलाई तपाईंको उपकरणको क्यामेराबाट तस्बिरहरू लिन आवश्यक छ। आवश्यक अनुमतिहरू कसरी दिनुहुन्छ भन्ने जान्नको लागि यो link अनुसरण गर्नुहोस्",
      cameraHeading: "क्यामेरा अनुमति",
      languageText: "प्रक्रियाको सुरुमा, तपाईं शीर्ष पट्टीमा रहेको ड्रपडाउन मेनूबाट आफ्नो मनपर्ने भाषा चयन गरेर आफ्नो भाषा चयन गर्न सक्नुहुन्छ",
      languageHeading: "भाषा चयन",
      kycText: "KYC, वा 'आफ्नो ग्राहकलाई चिन्नुहोस्', ग्राहकको पहिचान जाँच्ने र प्रमाणित गर्ने प्रक्रिया हो, जसले अनुपालन सुनिश्चित गर्न र ठगी र अन्य गैरकानूनी गतिविधिहरू रोक्न मद्दत गर्दछ",
      kycHeading: "KYC भनेको के हो?",
      timeText: "सामान्यतया, यसले लगभग 60 सेकेन्ड लिन्छ। यद्यपि, यो देश अनुसार फरक पर्न सक्छ",
      timeHeading: "यो कति समय लाग्नेछ?"
    },
    pdfPreviewUnavailable: "We no fit show preview for PDF.",
    pdfPreviewHint: "If preview no show, you fit still continue.",
    pdfOpenLabel: "Open PDF",
    onlyIdVerificationHeader: {
      title: "Make we verify your ID",
      subtitle: "E go take only one minute. Just keep your ID document near you",
      instruction1: "Allow Camera Access",
      instruction2: "Scan or Upload Your Document",
      instruction3: "Instant Document Verification"
    },
    failedUpload: {
      title: "File Upload Fail",
      text: "Abeg make sure say di file dey under 5MB and e dey for .jpg, .jpeg, .png, .heic, .heif, or .pdf format",
      btn: "Try Again",
      pdfNotAllowedIndia: "Dem no allow PDF upload for India. Abeg upload JPEG, JPG, PNG, HEIC, or HEIF files wey dey under 5 MB.",
      pdfNotAllowedIndiaBasic: "Dem no allow PDF upload for India. Abeg upload JPEG, JPG, or PNG files wey dey under 5 MB."
    },
    livenessAnalyzing: {
      heading: "Dem Dey Analyze Your Face",
      subHeading: "Abeg wait, e go take only few seconds"
    },
    sessionExpiredError: {
      heading: "Sorry, your session don time out",
      subHeading1: "You no active for some time. For security reasons, your session don automatically expire",
      subHeading2: "Abeg try again",
      buttonText: "Try Again"
    },
    journeyExpiredError: {
      heading: "Sorry, di link don expire",
      subHeading1: "Di link no dey active again. For security reasons, di links get limited lifespan",
      subHeading2: "Abeg try with new link",
      buttonText: "Try Again"
    },
    cameraAccessError: {
      alert1: "Dem deny camera access. Abeg enable camera access for your browser settings",
      alert2: "Error happen while we dey access di camera",
      alert3: "Your browser no support camera access"
    },
    activeLiveness: {
      instruction: "Keep your face inside di circle and follow di instructions",
      permissionDeniedTitle: "Dem Deny Camera or Microphone Access",
      permissionDeniedSubtitle: "Abeg allow camera and microphone access for your browser settings and try again."
    },
    flipScreen: {
      heading: "Now turn your ID card",
      subHeading: "Abeg turn your ID card to show di back side, den put am inside di camera frame.",
      continueButton: "Continue"
    },
    mobileDocCapture: {
      frontSide: "Front Side",
      backSide: "Back Side",
      of: "of",
      upload: "Upload",
      stillNotWorking: "E still no dey work?",
      clickToCapture: "Try click-to-capture",
      skip: "Skip"
    }
,
    permissionPopUp: {
      title: "Permission dey required",
      subtitle: "Allow access make you fit use camera",
      decline: "Reject",
      allow: "Allow"
    },
    userDetails: {
      heading: "PAN Verification",
      subHeading: "Abeg fill the details make we verify",
      panLabel: "PAN Number",
      panRequired: "Abeg enter your PAN number",
      saveError: "Something no work well as we dey save the details. Abeg try again.",
      proceed: "Continue"
    },
    redirectCta: {
      or: "or",
      clickHere: "click here",
      clickHereStart: "Click here",
      toContinue: "make you continue"
    },
    documentCapture: {
      stillNotWorking: "E still no dey work?",
      clickToCaptureInstead: "Try click-to-capture instead",
      pdfNotAllowedIndia: "Dem no allow PDF upload for India. Abeg upload JPEG, JPG, or PNG files wey dey under 5 MB.",
      pdfNotAllowedIndiaMobile: "Dem no allow PDF upload for India. Abeg upload JPEG, JPG, PNG, HEIC, or HEIF files wey dey under 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png under 5 mb",
      fileFormats: "jpeg, jpg, png, pdf under 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif under 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf under 5 mb"
    },
    mobileCapture: {
      upload: "Upload",
      skip: "Skip",
      stillNotWorking: "E still no dey work?",
      tryClickToCapture: "Tap to capture instead"
    },
    UserDetails: {
      panLabel: "PAN Number",
      proceedBtn: "Proceed",
      panRequired: "Abeg enter your PAN number",
      saveError: "Something go wrong as we dey save your details. Abeg try again."
    }
  },
  du: {
    supportingDocument: {
      headingFallback: "Ondersteunend document",
      subHeading: "Upload het document hieronder. Het wordt bewaard voor beoordeling — er wordt niets uit gehaald.",
      choosePlaceholder: "Kies een bestand (PNG, JPG of PDF)",
      continue: "Doorgaan",
      uploading: "Uploaden...",
      skip: "Nu overslaan",
      errorInvalidType: "Upload een PNG-, JPG- of PDF-bestand.",
      errorTooLarge: "Het bestand is te groot. De limiet is 10MB.",
      errorRead: "Kan dat bestand niet lezen. Probeer een ander.",
      errorNoFile: "Kies een bestand om te uploaden.",
    },
    header: {
      title: "Laten we uw identiteit verifiëren",
      subtitle: "Het duurt minder dan 2 minuten",
      havingIssue: "Problemen?"
    },
    subHeading: {
      subHeading1: "Maak een foto van uw ID-document",
      subHeading2: "Verifieer dat u live bent",
      livenessHeading1: "Zoek een plek met goede verlichting",
      livenessHeading2: "Houd uw gezicht in het midden"
    },
    termsAndCondition: {
      title: "Ik ga akkoord met de volgende voorwaarden.",
      privacyPolicy: "Bekijk voorwaarden",
      beginBtnText: "Begin",
      beginLiveness: "Liveness-controle starten",
      startLiveness: "Ga door naar liveness-controle"
    },
    permissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Controleer of er een geblokkeerd camera-icoon naast de adresbalk van de browser staat en verwijder de blokkering.",
      readMore: "Lees meer",
      refreshText: "Klik op de knop 'Verversen' hieronder nadat je toestemming hebt gegeven.",
      refreshBtn: "Verversen",
      link: "Of, ga door op telefoon",
      buttonText: "Of, ga door op telefoon"
    },
    desktopBrowserPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "De browser vraagt mogelijk om toestemming. Klik op 'toestaan' om door te gaan.",
      readMore: "Lees meer",
      refreshText: "Ververs na het geven van toestemming",
      refreshBtn: "Verversen",
      link: "Of, ga door op telefoon",
      buttonText: "Of, ga door op telefoon"
    },
    androidBrowserPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Controleer of er een geblokkeerd camera-icoon zichtbaar is naast de adresbalk van de browser en deblokkeer dit.",
      readMore: "Meer informatie",
      refreshText: "Zodra de toegang tot de camera is toegestaan, klik je op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    androidWebViewPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "De toegang tot de camera is mogelijk geblokkeerd via de app-instellingen. Ga naar App-info > Machtigingen > Camera en sta toegang toe.",
      refreshText: "Zodra de toegang tot de camera is toegestaan, klik je op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    iosBrowserPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Tik op het camera- of slotpictogram naast de adresbalk om toegang toe te staan, of controleer je browserinstellingen.",
      readMore: "Meer informatie",
      refreshText: "Zodra de toegang tot de camera is toegestaan, klik je op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    iosWebViewPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Camera-toegang kan geblokkeerd zijn in je apparaatinstellingen. Ga naar 'Instellingen', zoek de app en schakel de camerapermissie in.",
      refreshText: "Zodra de toegang tot de camera is toegestaan, klik je op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    documentationList: {
      countryHeading: "Selecteer land",
      docHeading: "Selecteer uw document",
      btnText: "Volgende",
      searchCountry: "Land zoeken"
    },
    frontDocCapture: {
      heading: "Plaats de voorkant van het ID in het kader",
      backupHeading: "Problemen? Klik handmatig op de afbeelding",
      btnText: "Foto maken",
      headingBack: " in de rechthoek",
      uploadButton: "of upload je ID"
    },
    backDocCapture: {
      heading: "Plaats de achterkant van het ID in het kader",
      backupHeading: "Problemen? Klik handmatig op de afbeelding",
      btnText: "Foto maken",
      containerText: "of, upload document",
      text: "Bezig met vastleggen, blijf stil",
      headingBack: " in de rechthoek",
      skipButton: "Sla achterkant over",
      uploadButton: "of upload je ID"
    },
    analyzing: {
      heading: "Bezig met het analyseren van uw ID...",
      subHeading: "Controleer de kaartgegevens op het volgende scherm en pas indien nodig aan"
    },
    imageCheck: {
      heading: "Controleer uw afbeelding",
      subHeading: "Zorg ervoor dat de afbeelding compleet, duidelijk en vrij van onscherpte en schittering is.",
      button1: "Foto opnieuw maken",
      button2: "Klaar om te gaan",
      frontHeading: "Controleer uw voorste afbeelding",
      backHeading: "Controleer uw achterste afbeelding"
    },
    errorHandler: {
      heading: "Oeps:(",
      subHeading1: "Er is een probleem opgetreden, maar maak u geen zorgen! Probeer het opnieuw",
      subHeading2: "Als dit aanhoudt, probeer het later opnieuw",
      button: "Probeer opnieuw"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Verwijder alstublieft alles wat uw gezicht bedekt",
        button: "Probeer opnieuw"
      },
      eyeClosureDetected: {
        heading: "Houd alstublieft uw ogen open en kijk recht in de camera",
        button: "Oké"
      },
      isMultipleFacesFound: {
        heading: "Meerdere gezichten gedetecteerd. Zorg ervoor dat alleen uw gezicht zichtbaar is in de camera.",
        button: "Probeer opnieuw"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Probeer opnieuw"
      },
      faceDetections: {
        heading: "Verwijder dit alstublieft",
        button: "Probeer opnieuw"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Meerdere gezichten gevonden",
          button: "Probeer opnieuw"
        },
        generalMessage: {
          heading: "Zorg ervoor dat u leeft voor de camera",
          button: "Probeer opnieuw"
        }
      },
      faceMatch: {
        heading: "Uw gezicht komt niet overeen met de foto ID",
        button: "Probeer opnieuw"
      },
      selfieError: {
        heading: "We konden uw selfie niet verifiëren",
        subHeading1: "Volg deze tips en probeer opnieuw",
        instruction1: "Verplaats naar een goed verlichte plek en vermijd tegenlicht",
        instruction2: "Zorg ervoor dat uw gezicht volledig zichtbaar is en in het midden van het frame staat",
        instruction3: "Verwijder hoeden, brillen of maskers voor een duidelijker gezicht",
        button: "Probeer opnieuw"
      },
      activeLivenessOtpFailureMessage: {
        heading: "De OTP komt niet overeen. Lees de OTP duidelijk en hardop voor",
        button: "Probeer opnieuw"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verificatie mislukt. Volg de instructies duidelijk en probeer het opnieuw",
        button: "Probeer opnieuw"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF heeft te veel pagina's",
        subHeading: "De geüploade PDF overschrijdt de limiet van 2 pagina's. Upload een PDF met maximaal 2 pagina's of een duidelijke afbeelding van uw ID."
      },
      heading: "We konden uw ID niet verwerken",
      subHeading: "Ofwel uploadt u een verkeerd ID of is de afbeelding niet duidelijk",
      buttonBack: "Probeer de achterkant van het ID opnieuw",
      buttonFront: "Probeer de voorkant van het ID opnieuw",
      button: "Probeer opnieuw",
      captureFrontSide: "Voorkant vastleggen",
      captureBackSide: "Achterkant vastleggen",
      changeIDButton: "Verander ID-type",
      wrongid: {
        heading: "We konden dit document niet verwerken",
        subHeading: "Controleer of u het juiste document uploadt en zorg ervoor dat de beeldkwaliteit helder is"
      },
      expiredid: {
        heading: "ID-document is verlopen!",
        subHeading: "We kunnen een verlopen ID-document niet accepteren. Geef een geldig document op"
      },
      minimumage: {
        heading: "Leeftijdseis niet gehaald!",
        subHeading: "Uw leeftijd ligt onder de minimumleeftijd. Zorg ervoor dat u voldoet aan de minimumleeftijdseisen"
      },
      mobileAttemptsDone: {
        heading: "Reis hervat op uw vorige apparaat",
        subHeading: "Deze sessie is nu gestopt om duplicatie te voorkomen."
      },
      finished: {
        heading: "De reis is beëindigd",
        subHeading: "De reis is voltooid of beëindigd"
      },
      invalid: {
        heading: "Reis niet beschikbaar !",
        subHeading: "Geen journeyId gevonden of de journey-ID is ongeldig"
      },
      INVALID_PAN_NUMBER: {
        heading: "Ongeldig PAN-nummer",
        subHeading: "Het ingevoerde PAN-nummer is niet geldig. Controleer het en probeer opnieuw"
      },
      INVALID_PAN_STATUS: {
        heading: "Ongeldige PAN-status",
        subHeading: "Het ingevoerde PAN-nummer is niet geldig. Controleer het en probeer opnieuw"
      },
      directKyc: {
        heading: "Directe KYC-reis !",
        subHeading: "Dit is een directe KYC-reis. Een frontend-reis is niet toegestaan."
      },
      DOCTYPE_FALSE: {
        heading: "Verkeerd document aangeleverd!",
        subHeading: "Upload een geldig document en zorg ervoor dat de beeldkwaliteit goed is."
      },
      ONLY_FRONT: {
        heading: "Achterkant van het document ontbreekt",
        subHeading: "U hebt alleen de voorkant aangeleverd. Draai uw document om en lever de achterkant aan om door te gaan"
      },
      ONLY_BACK: {
        heading: "Voorkant van het document ontbreekt",
        subHeading: "U hebt alleen de achterkant aangeleverd. Draai uw document om en lever de voorkant aan om door te gaan"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Document verloopt binnenkort",
        subHeading: "Het document is afgewezen omdat het binnenkort verloopt."
      },
      DOCUMENT_EXPIRED: {
        heading: "Document verlopen!",
        subHeading: "Upload een geldig, niet-verlopen document om door te gaan."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Leeftijdsvereiste niet voldaan!",
        subHeading: "Het document geeft aan dat u niet aan de vereiste leeftijd voldoet. Upload een geldig document."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "De beeldkwaliteit is te slecht voor verificatie. Probeer het opnieuw met een duidelijker beeld."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "Sommige informatie kon niet worden geverifieerd. Probeer het opnieuw met een duidelijker beeld."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "Sommige gegevens konden niet worden geverifieerd door de slechte beeldkwaliteit. Probeer het opnieuw met een duidelijker beeld"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "Sommige gegevens konden niet worden geverifieerd. Probeer het opnieuw met een duidelijker beeld."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Probleem bij het verifiëren van uw foto op het document",
        subHeading: "We konden uw foto op het document niet verifiëren. Upload een duidelijke foto van uw originele document zodat we het kunnen bevestigen."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Controle van beveiligingspatroon van document mislukt",
        subHeading: "We konden de ingebouwde beveiligingspatronen van het document niet verifiëren. Upload een duidelijke foto van het originele document zodat we de echtheid kunnen bevestigen."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Echtheidscontrole van document mislukt",
        subHeading: "We hebben aanwijzingen gevonden dat het document mogelijk niet echt is. Vermijd screenshots, afgedrukte kopieën of het tonen van het document op een scherm. Upload het originele document met alle kenmerken duidelijk zichtbaar"
      },
      SECURITY_FALSE: {
        heading: "Probleem gedetecteerd!",
        subHeading: "Het document kon niet worden geverifieerd. Probeer het opnieuw met een duidelijker beeld"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Slechte beeldkwaliteit!",
        subHeading: "Het beeld is te wazig of onduidelijk. Probeer het opnieuw met een duidelijker beeld"
      },
      FACE_UNDETECTED: {
        heading: "Gezicht niet gedetecteerd",
        subHeading: "We konden geen zichtbaar gezicht op het document vinden. Upload een geldig document waarop het gezicht duidelijk zichtbaar is"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Vergelijking tussen documenten mislukt",
        subHeading: "De vergelijking tussen documenten is mislukt door een verschil in een of meer belangrijke velden (naam, geboortedatum of gezicht)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker-fout",
        subHeading: "Er is een fout opgetreden tijdens de Digilocker-reis. Probeer het opnieuw of gebruik een alternatieve methode om door te gaan."
      },
      LINKAGE_FAILED: {
        heading: "Deze verificatie kan niet worden voltooid",
        subHeading: "De vastgelegde gegevens kwamen niet overeen met de records voor deze controle."
      }
    },
    biometricConsent: {
      consentStatement: "Voordat u een selfie maakt, hebben we uw toestemming nodig om uw biometrische gegevens (gezichtsafbeelding en levendheidssignalen) vast te leggen en te verwerken om uw identiteit te verifiëren. Deze gegevens worden alleen voor deze verificatie gebruikt.",
      privacyPolicy: "Privacybeleid",
      consentButton: "Ik geef toestemming — Doorgaan",
      declineButton: "Ik geef geen toestemming",
      confirmTitle: "Doorgaan zonder biometrische verificatie?",
      confirmBody: "Zonder biometrische verificatie maken we geen selfie. Uw verificatie wordt voltooid met de informatie die u al hebt verstrekt. Deze keuze is definitief voor deze sessie.",
      goBack: "Terug",
      confirmDecline: "Bevestigen — geen toestemming",
      declineComplete: "U hebt ervoor gekozen niet door te gaan met biometrische verificatie. Uw identiteitsverificatie is voltooid met de door u ingediende documenten."
    },
    introLiveness: {
      heading: "Bevestig dat u hier live bent",
      instruction1: "Zorg voor voldoende licht",
      instruction2: "Sta de benodigde toestemmingen toe",
      instruction3: "Volg gewoon de instructies",
      button: "Doorgaan",
      subHeading: "U bent nog maar één stap verwijderd"
    },
    phoneSession: {
      heading: "Sessie voortgezet op telefoon",
      subheading: "Houd dit venster open totdat u op de mobiele telefoon bent klaar",
      button: "Ga hier verder"
    },
    continueOnPhone: {
      heading: "Ga door op telefoon",
      subheading: "Scan de QR-code of kopieer de onderstaande link",
      subheading2: "Scan QR of open de link op uw telefoon",
      text: "Voltooi het proces",
      text1: "Controleer hier om in te dienen",
      button: "Kopiëren",
      copiedButton: "Gekopieerd!",
      copied: "Gekopieerd!"
    },
    SsnReview: {
      heading: "Controleer uw gegevens",
      subHeading: "Breng indien nodig wijzigingen aan en dien de gegevens in",
      feild1: "Rijbewijs",
      feild2: "Verloopdatum",
      feild3: "Geboortedatum",
      feild4: "Klasse",
      feild5: "Beperkingen",
      feild6: "Land",
      feild7: "Adres",
      button: "Gegevens zijn correct"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Houd uw gezicht in de cirkel"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Kom dichter bij de camera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Wees niet verlegen, kom in beeld"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te donker. Zoek meer licht"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te fel. Zoek zachter licht"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Houd uw gezicht in de cirkel"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Blijf stil"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Draai uw gezicht naar het licht"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Houd de telefoon op ooghoogte"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Ga iets verder van de camera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Centreer uw gezicht in het kader"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Positioneer uw gezicht in het midden van de cirkel"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Kom dichterbij en houd uw gezicht recht"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Stap in beeld en houd uw gezicht recht"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te donker. Zoek een helderdere lichtbron"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te fel. Zoek optimaal licht"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Pas uw gezicht aan naar het midden van de cirkel"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Houd stil en kijk recht vooruit"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Richt uw gezicht naar het licht en houd stil"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Houd uw telefoon op ooghoogte"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Ga iets verder van de camera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perfect!"
      },
      smile1: {
        icon: "mood",
        description: "Glimlach, u ziet er geweldig uit!"
      },
      smile2: {
        icon: "mood",
        description: "Glimlach voor de camera!"
      }
    },
    successful: {
      title: "Verificatie voltooid",
      text: "U kunt het venster nu sluiten",
      finishBtn: "Voltooien"
    },
    poweredBy: "Aangeboden door",
    redirect: "Doorverwijzen in",
    error: {
      message: "URL is verlopen of niet geldig"
    },
    footer: {
      securedBy: "Aangeboden door"
    },
    helpFaq: {
      title: "Hulp & Veelgestelde Vragen",
      subtitle: "Wij zijn hier om u te helpen",
      cameraText: "Om uw identiteit te verifiëren, moeten we foto's maken met de camera van uw apparaat. Volg deze link om te leren hoe u de vereiste machtigingen kunt verlenen",
      cameraHeading: "Camera toestemming",
      languageText: "Aan het begin van het proces kunt u uw voorkeurstaal kiezen door deze te selecteren in het dropdownmenu in de bovenste balk",
      languageHeading: "Taal selectie",
      kycText: "KYC, of 'Know Your Customer', is een proces om de identiteit van de klant te verifiëren en te bevestigen, wat helpt om naleving te waarborgen en fraude en andere illegale activiteiten te voorkomen",
      kycHeading: "Wat is KYC?",
      timeText: "Het duurt meestal ongeveer 60 seconden. Dit kan echter variëren, afhankelijk van het land",
      timeHeading: "Hoeveel tijd gaat het duren?"
    },
    pdfPreviewUnavailable: "Kan voorbeeld van pdf niet weergeven.",
    pdfPreviewHint: "Als het voorbeeld niet verschijnt, kunt u toch doorgaan.",
    pdfOpenLabel: "Pdf openen",
    onlyIdVerificationHeader: {
      title: "Laten we uw identiteitsbewijs verifiëren",
      subtitle: "Dit duurt slechts een minuut. Houd gewoon uw identiteitsdocument bij de hand",
      instruction1: "Cameratoegang toestaan",
      instruction2: "Scan of upload uw document",
      instruction3: "Directe documentverificatie"
    },
    failedUpload: {
      title: "Uploaden van bestand mislukt",
      text: "Zorg ervoor dat het bestand kleiner is dan 5 MB en in .jpg-, .jpeg-, .png-, .heic-, .heif- of .pdf-formaat is",
      btn: "Probeer opnieuw",
      pdfNotAllowedIndia: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG-, PNG-, HEIC- of HEIF-bestanden van minder dan 5 MB.",
      pdfNotAllowedIndiaBasic: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG- of PNG-bestanden van minder dan 5 MB."
    },
    livenessAnalyzing: {
      heading: "Uw gezicht wordt geanalyseerd",
      subHeading: "Even geduld, dit duurt slechts enkele seconden"
    },
    sessionExpiredError: {
      heading: "Sorry, uw sessie is verlopen",
      subHeading1: "U bent een tijd inactief geweest. Om veiligheidsredenen is uw sessie automatisch verlopen",
      subHeading2: "Probeer het opnieuw",
      buttonText: "Probeer opnieuw"
    },
    journeyExpiredError: {
      heading: "Sorry, de link is verlopen",
      subHeading1: "De link is niet langer actief. Om veiligheidsredenen hebben links een beperkte levensduur",
      subHeading2: "Probeer het met een nieuwe link",
      buttonText: "Probeer opnieuw"
    },
    cameraAccessError: {
      alert1: "Camera toegang is geweigerd. Sta camera toegang toe in uw browserinstellingen",
      alert2: "Er is een fout opgetreden bij het toegang krijgen tot de camera",
      alert3: "Uw browser ondersteunt geen camera toegang"
    },
    activeLiveness: {
      instruction: "Houd uw gezicht in de cirkel en volg de instructies",
      permissionDeniedTitle: "Toegang tot camera of microfoon geweigerd",
      permissionDeniedSubtitle: "Sta toegang tot camera en microfoon toe in uw browserinstellingen en probeer het opnieuw."
    },
    flipScreen: {
      heading: "Draai nu uw identiteitskaart om",
      subHeading: "Draai uw identiteitskaart fysiek om om de achterkant te tonen en plaats deze in het camerakader.",
      continueButton: "Doorgaan"
    },
    mobileDocCapture: {
      frontSide: "Voorzijde",
      backSide: "Achterzijde",
      of: "van",
      upload: "Uploaden",
      stillNotWorking: "Werkt het nog steeds niet?",
      clickToCapture: "Probeer klikken om vast te leggen",
      skip: "Overslaan"
    }
,
    permissionPopUp: {
      title: "Toestemming vereist",
      subtitle: "Sta toegang toe om de camera te gebruiken",
      decline: "Weigeren",
      allow: "Toestaan"
    },
    userDetails: {
      heading: "PAN-verificatie",
      subHeading: "Vul de gegevens in om te verifiëren",
      panLabel: "PAN-nummer",
      panRequired: "Voer uw PAN-nummer in",
      saveError: "Er is iets misgegaan bij het opslaan van de gegevens. Probeer het opnieuw.",
      proceed: "Doorgaan"
    },
    redirectCta: {
      or: "of",
      clickHere: "klik hier",
      clickHereStart: "Klik hier",
      toContinue: "om door te gaan"
    },
    documentCapture: {
      stillNotWorking: "Werkt het nog steeds niet?",
      clickToCaptureInstead: "Probeer in plaats daarvan klik-om-vast-te-leggen",
      pdfNotAllowedIndia: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG- of PNG-bestanden van minder dan 5 MB.",
      pdfNotAllowedIndiaMobile: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG-, PNG-, HEIC- of HEIF-bestanden van minder dan 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png minder dan 5 mb",
      fileFormats: "jpeg, jpg, png, pdf minder dan 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif minder dan 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf minder dan 5 mb"
    },
    mobileCapture: {
      upload: "Uploaden",
      skip: "Overslaan",
      stillNotWorking: "Werkt het nog steeds niet?",
      tryClickToCapture: "Handmatig vastleggen"
    },
    UserDetails: {
      panLabel: "PAN-nummer",
      proceedBtn: "Doorgaan",
      panRequired: "Voer uw PAN-nummer in",
      saveError: "Er is iets misgegaan bij het opslaan. Probeer het opnieuw."
    }
  },
  nl: {
    supportingDocument: {
      headingFallback: "Ondersteunend document",
      subHeading: "Upload het document hieronder. Het wordt bewaard voor beoordeling — er wordt niets uit gehaald.",
      choosePlaceholder: "Kies een bestand (PNG, JPG of PDF)",
      continue: "Doorgaan",
      uploading: "Uploaden...",
      skip: "Nu overslaan",
      errorInvalidType: "Upload een PNG-, JPG- of PDF-bestand.",
      errorTooLarge: "Het bestand is te groot. De limiet is 10MB.",
      errorRead: "Kan dat bestand niet lezen. Probeer een ander.",
      errorNoFile: "Kies een bestand om te uploaden.",
    },
    header: {
      title: "Verifieer uw identiteit",
      subtitle: "Het duurt minder dan 2 minuten",
      havingIssue: "Problemen?"
    },
    subHeading: {
      subHeading1: "Maak een foto van uw ID-document",
      subHeading2: "Verifieer dat u live bent",
      livenessHeading1: "Zoek een plek met goede verlichting",
      livenessHeading2: "Houd uw gezicht in het midden"
    },
    termsAndCondition: {
      title: "Ik ga akkoord met de volgende voorwaarden.",
      privacyPolicy: "Bekijk voorwaarden",
      beginBtnText: "Begin",
      beginLiveness: "Livenesscontrole starten",
      startLiveness: "Ga door naar livenesscontrole"
    },
    permissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Controleer of er een geblokkeerd camera-icoon naast de adresbalk van de browser staat en verwijder de blokkering.",
      readMore: "Lees Meer",
      refreshText: "Klik op de knop 'Vernieuw' hieronder nadat je toestemming hebt gegeven.",
      refreshBtn: "Vernieuw",
      link: "Of, ga door op de telefoon",
      buttonText: "Of, ga door op de telefoon"
    },
    desktopBrowserPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "De browser kan om toestemming vragen. Gelieve 'toestaan' te kiezen om door te gaan.",
      readMore: "Lees Meer",
      refreshText: "Vernieuw na het geven van de toestemming",
      refreshBtn: "Vernieuw",
      link: "Of, ga door op de telefoon",
      buttonText: "Of, ga door op de telefoon"
    },
    androidBrowserPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Controleer of er een geblokkeerd camera-icoon zichtbaar is naast de adresbalk van je browser en deblokkeer dit.",
      readMore: "Meer informatie",
      refreshText: "Zodra je toegang tot de camera hebt toegestaan, klik op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    androidWebViewPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Toegang tot de camera is mogelijk geblokkeerd via de app-instellingen. Ga naar App-info > Machtigingen > Camera en geef toegang.",
      refreshText: "Zodra je toegang tot de camera hebt toegestaan, klik op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    iosBrowserPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Tik op het camera- of slotpictogram naast de adresbalk om toegang toe te staan, of controleer je browserinstellingen.",
      readMore: "Meer informatie",
      refreshText: "Zodra je toegang tot de camera hebt toegestaan, klik op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    iosWebViewPermissionDenied: {
      title: "Toegang tot camera geweigerd!",
      subtitle: "Camera-toegang is mogelijk geblokkeerd in de apparaatinstellingen. Ga naar 'Instellingen', zoek de app en schakel camerapermissie in.",
      refreshText: "Zodra je toegang tot de camera hebt toegestaan, klik op de knop 'Vernieuwen' hieronder.",
      refreshBtn: "Vernieuwen",
      link: "Of ga verder op je telefoon",
      buttonText: "Of ga verder op je telefoon"
    },
    documentationList: {
      countryHeading: "Selecteer land",
      docHeading: "Selecteer uw document",
      btnText: "Volgende",
      searchCountry: "Land zoeken"
    },
    frontDocCapture: {
      heading: "Plaats de voorkant van het ID in het rechthoekige vak",
      backupHeading: "Problemen? Klik de afbeelding handmatig",
      btnText: "Maak foto",
      headingBack: " in de rechthoek",
      uploadButton: "of upload je ID"
    },
    backDocCapture: {
      heading: "Plaats de achterkant van het ID in het rechthoekige vak",
      backupHeading: "Problemen? Klik de afbeelding handmatig",
      btnText: "Maak foto",
      containerText: "of, upload document",
      text: "Bezig met vastleggen, blijf stil",
      skipButton: "Sla achterkant over",
      headingBack: " in de rechthoek",
      uploadButton: "of upload je ID"
    },
    analyzing: {
      heading: "Bezig met analyseren van uw ID",
      subHeading: "Even geduld, dit duurt slechts een paar seconden"
    },
    imageCheck: {
      heading: "Controleer uw afbeelding",
      subHeading: "Zorg ervoor dat de afbeelding compleet, helder en vrij van onscherpte en schittering is.",
      button1: "Hernoem foto",
      button2: "Klaar om door te gaan",
      frontHeading: "Controleer uw voorste afbeelding",
      backHeading: "Controleer uw achterste afbeelding"
    },
    errorHandler: {
      heading: "Oeps:(",
      subHeading1: "We ondervinden wat problemen, maar maak je geen zorgen! Probeer het opnieuw",
      subHeading2: "Als dit aanhoudt, kijk later nog eens",
      button: "Probeer opnieuw"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "Verwijder alstublieft alles wat uw gezicht bedekt",
        button: "Probeer opnieuw"
      },
      eyeClosureDetected: {
        heading: "Houd alstublieft uw ogen open en kijk recht in de camera",
        button: "Opnieuw proberen"
      },
      isMultipleFacesFound: {
        heading: "Meerdere gezichten gedetecteerd. Zorg ervoor dat alleen uw gezicht zichtbaar is in de camera.",
        button: "Probeer opnieuw"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "Probeer opnieuw"
      },
      faceDetections: {
        heading: "Verwijder dit alstublieft",
        button: "Probeer opnieuw"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "Meerdere gezichten gevonden",
          button: "Probeer opnieuw"
        },
        generalMessage: {
          heading: "Zorg ervoor dat u leeft voor de camera",
          button: "Probeer opnieuw"
        }
      },
      faceMatch: {
        heading: "Uw gezicht komt niet overeen met de foto ID",
        button: "Probeer opnieuw"
      },
      selfieError: {
        heading: "We konden uw ID niet verwerken",
        subHeading1: "Volg deze tips en probeer opnieuw",
        instruction1: "Verplaats naar een goed verlichte plek en vermijd tegenlicht",
        instruction2: "Zorg ervoor dat uw gezicht volledig zichtbaar is en in het midden van het frame staat",
        instruction3: "Verwijder hoeden, brillen of maskers voor een duidelijker gezicht",
        button: "Probeer opnieuw"
      },
      activeLivenessOtpFailureMessage: {
        heading: "De OTP komt niet overeen. Lees de OTP duidelijk en hardop voor",
        button: "Probeer opnieuw"
      },
      activeLivenessGenericFailureMessage: {
        heading: "Verificatie mislukt. Volg de instructies duidelijk en probeer het opnieuw",
        button: "Probeer opnieuw"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF heeft te veel pagina's",
        subHeading: "De geüploade PDF overschrijdt de limiet van 2 pagina's. Upload een PDF met maximaal 2 pagina's of een duidelijke afbeelding van uw ID."
      },
      heading: "We konden uw ID niet verwerken",
      subHeading: "Of u uploadt een verkeerd ID of de afbeelding is niet duidelijk",
      buttonBack: "Probeer opnieuw achterkant ID",
      buttonFront: "Probeer opnieuw voorkant ID",
      button: "Probeer opnieuw",
      captureFrontSide: "Voorkant vastleggen",
      captureBackSide: "Achterkant vastleggen",
      changeIDButton: "Verander ID-type",
      wrongid: {
        heading: "We konden dit document niet verwerken",
        subHeading: "Controleer of u het juiste document uploadt en zorg ervoor dat de beeldkwaliteit helder is"
      },
      expiredid: {
        heading: "ID-document is verlopen!",
        subHeading: "We kunnen een verlopen ID-document niet accepteren. Geef een geldig document op"
      },
      minimumage: {
        heading: "Leeftijdseis niet gehaald!",
        subHeading: "Uw leeftijd ligt onder de minimumleeftijd. Zorg ervoor dat u voldoet aan de minimumleeftijdseisen"
      },
      mobileAttemptsDone: {
        heading: "Reis hervat op uw vorige apparaat",
        subHeading: "Deze sessie is nu gestopt om duplicatie te voorkomen."
      },
      finished: {
        heading: "De reis is beëindigd",
        subHeading: "De reis is voltooid of beëindigd"
      },
      invalid: {
        heading: "Reis niet beschikbaar !",
        subHeading: "Geen journeyId gevonden of de journey-ID is ongeldig"
      },
      INVALID_PAN_NUMBER: {
        heading: "Ongeldig PAN-nummer",
        subHeading: "Het ingevoerde PAN-nummer is niet geldig. Controleer het en probeer opnieuw"
      },
      INVALID_PAN_STATUS: {
        heading: "Ongeldige PAN-status",
        subHeading: "Het ingevoerde PAN-nummer is niet geldig. Controleer het en probeer opnieuw"
      },
      directKyc: {
        heading: "Directe KYC-reis !",
        subHeading: "Dit is een directe KYC-reis. Een frontend-reis is niet toegestaan."
      },
      DOCTYPE_FALSE: {
        heading: "Verkeerd document aangeleverd!",
        subHeading: "Upload een geldig document en zorg ervoor dat de beeldkwaliteit goed is."
      },
      ONLY_FRONT: {
        heading: "Achterkant van het document ontbreekt",
        subHeading: "U hebt alleen de voorkant aangeleverd. Draai uw document om en lever de achterkant aan om door te gaan"
      },
      ONLY_BACK: {
        heading: "Voorkant van het document ontbreekt",
        subHeading: "U hebt alleen de achterkant aangeleverd. Draai uw document om en lever de voorkant aan om door te gaan"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "Document verloopt binnenkort",
        subHeading: "Het document is afgewezen omdat het binnenkort verloopt."
      },
      DOCUMENT_EXPIRED: {
        heading: "Document verlopen!",
        subHeading: "Upload een geldig, niet-verlopen document om door te gaan."
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "Leeftijdsvereiste niet voldaan!",
        subHeading: "Het document geeft aan dat u niet aan de vereiste leeftijd voldoet. Upload een geldig document."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "De beeldkwaliteit is te slecht voor verificatie. Probeer het opnieuw met een duidelijker beeld."
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "Sommige informatie kon niet worden geverifieerd. Probeer het opnieuw met een duidelijker beeld."
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "Sommige gegevens konden niet worden geverifieerd door de slechte beeldkwaliteit. Probeer het opnieuw met een duidelijker beeld"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "Kan document niet verifiëren!",
        subHeading: "Sommige gegevens konden niet worden geverifieerd. Probeer het opnieuw met een duidelijker beeld."
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "Probleem bij het verifiëren van uw foto op het document",
        subHeading: "We konden uw foto op het document niet verifiëren. Upload een duidelijke foto van uw originele document zodat we het kunnen bevestigen."
      },
      IMAGE_PATTERN_FAILED: {
        heading: "Controle van beveiligingspatroon van document mislukt",
        subHeading: "We konden de ingebouwde beveiligingspatronen van het document niet verifiëren. Upload een duidelijke foto van het originele document zodat we de echtheid kunnen bevestigen."
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "Echtheidscontrole van document mislukt",
        subHeading: "We hebben aanwijzingen gevonden dat het document mogelijk niet echt is. Vermijd screenshots, afgedrukte kopieën of het tonen van het document op een scherm. Upload het originele document met alle kenmerken duidelijk zichtbaar"
      },
      SECURITY_FALSE: {
        heading: "Probleem gedetecteerd!",
        subHeading: "Het document kon niet worden geverifieerd. Probeer het opnieuw met een duidelijker beeld"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "Slechte beeldkwaliteit!",
        subHeading: "Het beeld is te wazig of onduidelijk. Probeer het opnieuw met een duidelijker beeld"
      },
      FACE_UNDETECTED: {
        heading: "Gezicht niet gedetecteerd",
        subHeading: "We konden geen zichtbaar gezicht op het document vinden. Upload een geldig document waarop het gezicht duidelijk zichtbaar is"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "Vergelijking tussen documenten mislukt",
        subHeading: "De vergelijking tussen documenten is mislukt door een verschil in een of meer belangrijke velden (naam, geboortedatum of gezicht)"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker-fout",
        subHeading: "Er is een fout opgetreden tijdens de Digilocker-reis. Probeer het opnieuw of gebruik een alternatieve methode om door te gaan."
      },
      LINKAGE_FAILED: {
        heading: "Deze verificatie kan niet worden voltooid",
        subHeading: "De vastgelegde gegevens kwamen niet overeen met de records voor deze controle."
      }
    },
    biometricConsent: {
      consentStatement: "Voordat u een selfie maakt, hebben we uw toestemming nodig om uw biometrische gegevens (gezichtsafbeelding en levendheidssignalen) vast te leggen en te verwerken om uw identiteit te verifiëren. Deze gegevens worden alleen voor deze verificatie gebruikt.",
      privacyPolicy: "Privacybeleid",
      consentButton: "Ik geef toestemming — Doorgaan",
      declineButton: "Ik geef geen toestemming",
      confirmTitle: "Doorgaan zonder biometrische verificatie?",
      confirmBody: "Zonder biometrische verificatie maken we geen selfie. Uw verificatie wordt voltooid met de informatie die u al hebt verstrekt. Deze keuze is definitief voor deze sessie.",
      goBack: "Terug",
      confirmDecline: "Bevestigen — geen toestemming",
      declineComplete: "U hebt ervoor gekozen niet door te gaan met biometrische verificatie. Uw identiteitsverificatie is voltooid met de door u ingediende documenten."
    },
    introLiveness: {
      heading: "Bevestig hier dat u live bent",
      instruction1: "Zorg voor voldoende licht",
      instruction2: "Sta de noodzakelijke toestemmingen toe",
      instruction3: "Volg gewoon de instructies",
      button: "Ga door",
      subHeading: "U bent nog maar één stap verwijderd"
    },
    phoneSession: {
      heading: "Sessie voortgezet op telefoon",
      subheading: "Houd dit venster open totdat u op mobiel bent voltooid",
      button: "Ga hier door"
    },
    continueOnPhone: {
      heading: "Ga door op telefoon",
      subheading: "Scan de QR of kopieer de onderstaande link",
      subheading2: "Scan QR of open de link op uw telefoon",
      text: "Voltooi het proces",
      text1: "Bekijk hier opnieuw om in te dienen",
      button: "Kopieer",
      copiedButton: "Gekopieerd!",
      copied: "Gekopieerd!"
    },
    SsnReview: {
      heading: "Controleer uw gegevens",
      subHeading: "Maak eventuele benodigde wijzigingen en dien de gegevens in",
      field1: "DL",
      field2: "EXP",
      field3: "DOB",
      field4: "Class",
      field5: "RSTR",
      field6: "Country",
      field7: "Address",
      button: "Gegevens zijn correct",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "Houd uw gezicht in de cirkel"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Kom dichter bij de camera"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Wees niet verlegen, kom in beeld"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te donker. Zoek meer licht"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te fel. Zoek zachter licht"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Houd uw gezicht in de cirkel"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Blijf stil"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Draai uw gezicht naar het licht"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Houd de telefoon op ooghoogte"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Ga iets verder van de camera"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "Centreer uw gezicht in het kader"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "Positioneer uw gezicht in het midden van de cirkel"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "Kom dichterbij en houd uw gezicht recht"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "Stap in beeld en houd uw gezicht recht"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te donker. Zoek een betere verlichting"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "Te helder. Zoek een optimale verlichting"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "Pas uw gezicht aan naar het midden van de cirkel"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "Blijf stilstaan en kijk recht vooruit"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "Richt uw gezicht naar het licht en blijf stilstaan"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "Houd uw telefoon op ooghoogte"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "Beweeg een beetje weg van de camera"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "Perfect!"
      },
      smile1: {
        icon: "mood",
        description: "Smile alsjeblieft, je ziet er geweldig uit!"
      },
      smile2: {
        icon: "mood",
        description: "Smile voor de camera!"
      }
    },
    successful: {
      title: "Bedankt!",
      text: "We hebben alle benodigde informatie verzameld om uw identiteit te verifiëren",
      finishBtn: "Voltooien"
    },
    poweredBy: "Aangedreven door",
    redirect: "Onderscheiding in",
    error: {
      message: "URL is verlopen of niet geldig"
    },
    sessionExpiredError: {
      heading: "Sorry, uw sessie is verlopen",
      subHeading1: "U bent een tijd inactief geweest. Om veiligheidsredenen is uw sessie automatisch verlopen",
      subHeading2: "Probeer het opnieuw",
      buttonText: "Probeer opnieuw"
    },
    journeyExpiredError: {
      heading: "Sorry, de link is verlopen",
      subHeading1: "De link is niet langer actief. Om veiligheidsredenen hebben links een beperkte levensduur",
      subHeading2: "Probeer het met een nieuwe link",
      buttonText: "Probeer opnieuw"
    },
    cameraAccessError: {
      alert1: "Camera toegang is geweigerd. Sta camera toegang toe in uw browserinstellingen",
      alert2: "Er is een fout opgetreden bij het toegang krijgen tot de camera",
      alert3: "Uw browser ondersteunt geen camera toegang"
    },
    footer: {
      securedBy: "Aangedreven door"
    },
    helpFaq: {
      title: "Hulp & Veelgestelde Vragen",
      subtitle: "We zijn hier om je te helpen",
      cameraText: "Om je identiteit te verifiëren, moeten we foto's maken met de camera van je apparaat. Volg deze link om te leren hoe je de vereiste machtigingen kunt verlenen",
      cameraHeading: "Camera toestemming",
      languageText: "Aan het begin van het proces kun je je voorkeurstaal kiezen door deze te selecteren in het dropdownmenu in de bovenste balk",
      languageHeading: "Taal selectie",
      kycText: "KYC, of 'Know Your Customer', is een proces om de identiteit van de klant te verifiëren, wat helpt om naleving te waarborgen en fraude en andere illegale activiteiten te voorkomen",
      kycHeading: "Wat is KYC?",
      timeText: "Het duurt meestal ongeveer 60 seconden. Dit kan echter variëren, afhankelijk van het land",
      timeHeading: "Hoeveel tijd zal het duren?"
    },
    pdfPreviewUnavailable: "Kan voorbeeld van pdf niet weergeven.",
    pdfPreviewHint: "Als het voorbeeld niet verschijnt, kunt u toch doorgaan.",
    pdfOpenLabel: "Pdf openen",
    onlyIdVerificationHeader: {
      title: "Laten we uw identiteitsbewijs verifiëren",
      subtitle: "Dit duurt slechts een minuut. Houd gewoon uw identiteitsdocument bij de hand",
      instruction1: "Cameratoegang toestaan",
      instruction2: "Scan of upload uw document",
      instruction3: "Directe documentverificatie"
    },
    failedUpload: {
      title: "Uploaden van bestand mislukt",
      text: "Zorg ervoor dat het bestand kleiner is dan 5 MB en in .jpg-, .jpeg-, .png-, .heic-, .heif- of .pdf-formaat is",
      btn: "Probeer opnieuw",
      pdfNotAllowedIndia: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG-, PNG-, HEIC- of HEIF-bestanden van minder dan 5 MB.",
      pdfNotAllowedIndiaBasic: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG- of PNG-bestanden van minder dan 5 MB."
    },
    livenessAnalyzing: {
      heading: "Uw gezicht wordt geanalyseerd",
      subHeading: "Even geduld, dit duurt slechts enkele seconden"
    },
    activeLiveness: {
      instruction: "Houd uw gezicht in de cirkel en volg de instructies",
      permissionDeniedTitle: "Toegang tot camera of microfoon geweigerd",
      permissionDeniedSubtitle: "Sta toegang tot camera en microfoon toe in uw browserinstellingen en probeer het opnieuw."
    },
    flipScreen: {
      heading: "Draai nu uw identiteitskaart om",
      subHeading: "Draai uw identiteitskaart fysiek om om de achterkant te tonen en plaats deze in het camerakader.",
      continueButton: "Doorgaan"
    },
    mobileDocCapture: {
      frontSide: "Voorzijde",
      backSide: "Achterzijde",
      of: "van",
      upload: "Uploaden",
      stillNotWorking: "Werkt het nog steeds niet?",
      clickToCapture: "Probeer klikken om vast te leggen",
      skip: "Overslaan"
    }
,
    permissionPopUp: {
      title: "Toestemming vereist",
      subtitle: "Sta toegang toe om de camera te gebruiken",
      decline: "Weigeren",
      allow: "Toestaan"
    },
    userDetails: {
      heading: "PAN-verificatie",
      subHeading: "Vul de gegevens in om te verifiëren",
      panLabel: "PAN-nummer",
      panRequired: "Voer uw PAN-nummer in",
      saveError: "Er is iets misgegaan bij het opslaan van de gegevens. Probeer het opnieuw.",
      proceed: "Doorgaan"
    },
    redirectCta: {
      or: "of",
      clickHere: "klik hier",
      clickHereStart: "Klik hier",
      toContinue: "om door te gaan"
    },
    documentCapture: {
      stillNotWorking: "Werkt het nog steeds niet?",
      clickToCaptureInstead: "Probeer in plaats daarvan klik-om-vast-te-leggen",
      pdfNotAllowedIndia: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG- of PNG-bestanden van minder dan 5 MB.",
      pdfNotAllowedIndiaMobile: "PDF-uploads zijn niet toegestaan voor India. Upload JPEG-, JPG-, PNG-, HEIC- of HEIF-bestanden van minder dan 5 MB.",
      fileFormatsIndia: "jpeg, jpg, png minder dan 5 mb",
      fileFormats: "jpeg, jpg, png, pdf minder dan 5 mb",
      fileFormatsIndiaMobile: "jpeg, jpg, png, heic, heif minder dan 5 mb",
      fileFormatsMobile: "jpeg, jpg, png, heic, heif, pdf minder dan 5 mb"
    },
    mobileCapture: {
      upload: "Uploaden",
      skip: "Overslaan",
      stillNotWorking: "Werkt het nog steeds niet?",
      tryClickToCapture: "Handmatig vastleggen"
    },
    UserDetails: {
      panLabel: "PAN-nummer",
      proceedBtn: "Doorgaan",
      panRequired: "Voer uw PAN-nummer in",
      saveError: "Er is iets misgegaan bij het opslaan. Probeer het opnieuw."
    }
  },
  cmn: {
    header: {
      title: "验证您的身份",
      subtitle: "这只需不到2分钟",
      havingIssue: "遇到问题了？"
    },
    subHeading: {
      subHeading1: "拍摄您的身份证明文件",
      subHeading2: "验证您是否在线",
      livenessHeading1: "找一个光线良好的地方",
      livenessHeading2: "保持面部在中间"
    },
    termsAndCondition: {
      title: "我同意并遵守以下条款和条件。",
      privacyPolicy: "查看条款",
      beginBtnText: "开始",
      beginLiveness: "开始活体检测",
      startLiveness: "继续进行活体检测"
    },
    permissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的摄像头图标，并将其解除屏蔽。",
      readMore: "阅读更多",
      refreshText: "授权后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或者，继续在手机上进行",
      buttonText: "或者，继续在手机上"
    },
    desktopBrowserPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "浏览器可能会提示权限。请“允许”以继续。",
      readMore: "阅读更多",
      refreshText: "在授权后刷新",
      refreshBtn: "刷新",
      link: "或者，继续在手机上进行",
      buttonText: "或者，继续在手机上"
    },
    androidBrowserPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "请检查浏览器地址栏附近是否有被屏蔽的摄像头图标，并点击解除屏蔽。",
      readMore: "了解更多",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    androidWebViewPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "摄像头访问可能被应用设置所阻止。请前往“应用信息” > “权限” > “摄像头”，并启用访问权限。",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosBrowserPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "点击地址栏旁边的摄像头或锁图标以允许访问，或检查浏览器设置。",
      readMore: "了解更多",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    iosWebViewPermissionDenied: {
      title: "摄像头访问被拒绝！",
      subtitle: "摄像头访问可能被系统设置限制。请打开“设置”，找到当前应用并启用摄像头权限。",
      refreshText: "允许摄像头访问后，请点击下方的“刷新”按钮。",
      refreshBtn: "刷新",
      link: "或，继续在手机上操作",
      buttonText: "或，继续在手机上操作"
    },
    documentationList: {
      countryHeading: "选择国家",
      docHeading: "选择您的文件",
      btnText: "下一步",
      searchCountry: "搜索国家"
    },
    frontDocCapture: {
      heading: "将身份证的正面放在矩形框中",
      backupHeading: "遇到问题？请手动点击图片",
      btnText: "拍照",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    backDocCapture: {
      heading: "将身份证的背面放在矩形框中",
      backupHeading: "遇到问题？请手动点击图片",
      btnText: "拍照",
      containerText: "或者，上传文件",
      text: "拍摄中，请保持静止",
      skipButton: "跳过背面",
      headingBack: "放入矩形框内",
      uploadButton: "或上传证件"
    },
    analyzing: {
      heading: "正在分析您的身份证",
      subHeading: "请稍候，这只需几秒钟"
    },
    imageCheck: {
      heading: "检查您的图片",
      subHeading: "请确保图片完整、清晰，无模糊和眩光。",
      button1: "重新拍照",
      button2: "可以继续",
      frontHeading: "检查您的正面图片",
      backHeading: "检查您的背面图片"
    },
    errorHandler: {
      heading: "哎呀:(",
      subHeading1: "我们遇到了一些问题，但别担心！请再试一次",
      subHeading2: "如果问题仍然存在，请稍后再试",
      button: "再试一次"
    },
    livenessCheckError: {
      isFaceCovered: {
        heading: "请移除遮挡您面部的物品",
        button: "再试一次"
      },
      eyeClosureDetected: {
        heading: "请保持睁眼并直视摄像头",
        button: "再试一次"
      },
      isMultipleFacesFound: {
        heading: "检测到多个面孔。请确保摄像头中只显示您的面孔。",
        button: "再试一次"
      },
      noFacesFound: {
        heading: "No Face Detected. Ensure your face is visible in the camera.",
        button: "再试一次"
      },
      faceDetections: {
        heading: "请移除这个",
        button: "再试一次"
      },
      passiveLiveliness: {
        mutipleFaces: {
          heading: "发现多个面部",
          button: "再试一次"
        },
        generalMessage: {
          heading: "请确保您在摄像头前是活的",
          button: "再试一次"
        }
      },
      faceMatch: {
        heading: "您的面部与身份证照片不匹配",
        button: "再试一次"
      },
      selfieError: {
        heading: "我们无法处理您的身份证",
        subHeading1: "请按照以下提示再试一次",
        instruction1: "移至光线充足的地方，避免背光",
        instruction2: "确保您的面部完全可见，且居中在画面中",
        instruction3: "请移除帽子、眼镜或口罩，以确保面部清晰可见",
        button: "再试一次"
      },
      activeLivenessOtpFailureMessage: {
        heading: "OTP 不匹配。请清晰地大声读出 OTP",
        button: "重试"
      },
      activeLivenessGenericFailureMessage: {
        heading: "验证失败。请清晰地按照说明操作并重试",
        button: "再试一次"
      }
    },
    unableToProcess: {
      PDF_PAGE_LIMIT_EXCEEDED: {
        heading: "PDF 页数过多",
        subHeading: "上传的 PDF 超过 2 页限制。请上传不超过 2 页的 PDF，或清晰的证件图片。"
      },
      heading: "我们无法处理您的身份证",
      subHeading: "您可能上传了错误的身份证或图片不清晰",
      buttonBack: "重试身份证背面",
      buttonFront: "重试身份证正面",
      button: "重试",
      captureFrontSide: "拍摄正面",
      captureBackSide: "拍摄背面",
      changeIDButton: "更改身份证类型",
      wrongid: {
        heading: "我们无法处理此文件",
        subHeading: "请确认您上传的文件正确，并确保图片质量清晰"
      },
      expiredid: {
        heading: "身份证过期！",
        subHeading: "我们无法接受过期的身份证。请提供有效的文件"
      },
      minimumage: {
        heading: "年龄要求未满足！",
        subHeading: "您的年龄低于最低要求年龄。请确保您符合最低年龄标准"
      },
      mobileAttemptsDone: {
        heading: "已在您之前的设备上恢复流程",
        subHeading: "此会话现已停止以避免重复。"
      },
      finished: {
        heading: "流程已结束",
        subHeading: "流程已完成或已终止"
      },
      invalid: {
        heading: "流程不可用 !",
        subHeading: "未找到 journeyId 或流程 ID 无效"
      },
      INVALID_PAN_NUMBER: {
        heading: "PAN 号码无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      INVALID_PAN_STATUS: {
        heading: "PAN 状态无效",
        subHeading: "您输入的 PAN 号码无效。请检查后重试"
      },
      directKyc: {
        heading: "直接 KYC 流程 !",
        subHeading: "这是一个直接 KYC 流程。不允许前端流程。"
      },
      DOCTYPE_FALSE: {
        heading: "提供的文档错误！",
        subHeading: "请上传有效的文档并确保图像质量良好。"
      },
      ONLY_FRONT: {
        heading: "缺少证件背面",
        subHeading: "您只提供了正面。请翻转证件并提供背面以继续"
      },
      ONLY_BACK: {
        heading: "缺少证件正面",
        subHeading: "您只提供了背面。请翻转证件并提供正面以继续"
      },
      DOCUMENT_EXPIRYING_SOON: {
        heading: "文档即将过期",
        subHeading: "文档因即将过期而被拒绝。"
      },
      DOCUMENT_EXPIRED: {
        heading: "文档已过期！",
        subHeading: "请上传有效且未过期的文档以继续。"
      },
      AGE_REQUIREMENT_NOT_MATCHED: {
        heading: "不满足年龄要求！",
        subHeading: "文档显示您未达到所需年龄。请上传有效的文档。"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "图像质量太差，无法验证。请使用更清晰的图像重试。"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_NOT_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分信息无法验证。请使用更清晰的图像重试。"
      },
      TEXT_FALSE_IMAGE_FALSE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "由于图像质量差，部分细节无法验证。请使用更清晰的图像重试"
      },
      TEXT_FALSE_IMAGE_TRUE_CRITICAL_FIELDS_EXTRACTED: {
        heading: "无法验证文档！",
        subHeading: "部分细节无法验证。请使用更清晰的图像重试。"
      },
      DOCUMENT_PHOTO_EMBED_FAILED: {
        heading: "验证证件上的照片时出现问题",
        subHeading: "我们无法验证您证件上的照片。请上传您原始证件的清晰照片，以便我们确认。"
      },
      IMAGE_PATTERN_FAILED: {
        heading: "文档安全图案检查失败",
        subHeading: "我们无法验证文档的内置安全图案。请上传原始证件的清晰照片，以帮助我们确认其真实性。"
      },
      DOCUMENT_LIVENESS_FAILED: {
        heading: "文档真伪检查失败",
        subHeading: "我们发现迹象表明该文档可能并非真实。请勿使用截图、打印件或在屏幕上显示证件。请上传所有特征清晰可见的原始证件"
      },
      SECURITY_FALSE: {
        heading: "检测到问题！",
        subHeading: "无法验证该文档。请使用更清晰的图像重试"
      },
      IMAGE_QUALITY_FALSE: {
        heading: "图像质量差！",
        subHeading: "图像太模糊或不清晰。请使用更清晰的图像重试"
      },
      FACE_UNDETECTED: {
        heading: "未检测到面部",
        subHeading: "我们无法在文档上找到可见的面部。请上传面部清晰可见的有效证件"
      },
      INTER_DOCUMENT_COMPARISION_FAILED: {
        heading: "文档间比对失败",
        subHeading: "由于一个或多个关键字段（姓名、出生日期或面部）不匹配，文档间比对失败"
      },
      DIGILOCKER_FAILURE: {
        heading: "Digilocker 失败",
        subHeading: "Digilocker 流程中发生错误。请重试或使用其他方式继续。"
      },
      LINKAGE_FAILED: {
        heading: "无法完成此项验证",
        subHeading: "所采集的信息与该项检查的记录不匹配。"
      }
    },
    biometricConsent: {
      consentStatement: "在自拍之前，我们需要您同意采集和处理您的生物识别数据（面部图像和活体信号）以验证您的身份。这些数据仅用于本次验证。",
      privacyPolicy: "隐私政策",
      consentButton: "我同意 — 继续",
      declineButton: "我不同意",
      confirmTitle: "不进行生物识别验证并继续？",
      confirmBody: "没有生物识别验证，我们将不会采集自拍。您的验证将使用您已提供的信息完成。此选择在本次会话中为最终决定。",
      goBack: "返回",
      confirmDecline: "确认 — 不同意",
      declineComplete: "您已选择不进行生物识别验证。您的身份验证已使用您提交的文件完成。"
    },
    introLiveness: {
      heading: "确认您在此实时",
      instruction1: "确保有足够的光线",
      instruction2: "允许必要的权限",
      instruction3: "只需按照说明操作",
      button: "继续",
      subHeading: "您只差一步了"
    },
    phoneSession: {
      heading: "在手机上继续会话",
      subheading: "保持此窗口打开，直到在手机上完成",
      button: "继续这里"
    },
    continueOnPhone: {
      heading: "在手机上继续",
      subheading: "扫描二维码或复制下面的链接",
      subheading2: "扫描二维码或在手机上打开链接",
      text: "完成过程",
      text1: "回来这里提交",
      button: "复制",
      copiedButton: "已复制！",
      copied: "已复制！"
    },
    SsnReview: {
      heading: "查看您的详细信息",
      subHeading: "进行必要的更改并提交详细信息",
      feild1: "DL",
      feild2: "EXP",
      feild3: "DOB",
      feild4: "Class",
      feild5: "RSTR",
      feild6: "Country",
      feild7: "Address",
      button: "详细信息正确"
    },
    videoCheckList: {
      default: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近摄像头一些"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "别害羞，进入画面"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗了，请找更亮的光线"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮了，请找柔和的光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将面部保持在圆圈内"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光线"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机举到与眼睛齐平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "稍微远离摄像头"
      },
      face_not_present_center: {
        icon: "center_focus_weak",
        description: "将面部置于画面中央"
      }
    },
    videoCheckListConfidence: {
      default: {
        icon: "center_focus_weak",
        description: "将您的脸部放在圆圈中心"
      },
      face_too_far: {
        icon: "zoom_in_map",
        description: "靠近一些并保持面部正对"
      },
      face_not_present: {
        icon: "center_focus_weak",
        description: "进入画面并保持面部正对"
      },
      brightness_too_low: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太暗。找一个更亮的地方"
      },
      brightness_too_high: {
        icon: "light_mode_FILL0_wght400_GRAD0_opsz24 1",
        description: "太亮。找一个最佳光线"
      },
      face_centering: {
        icon: "center_focus_weak",
        description: "将您的脸部调整到圆圈中心"
      },
      candidate_selection: {
        icon: "center_focus_weak",
        description: "保持不动，直视前方"
      },
      sharpness_too_low: {
        icon: "center_focus_weak",
        description: "面向光源并保持不动"
      },
      device_pitched: {
        icon: "center_focus_weak",
        description: "将手机保持在眼睛水平"
      },
      face_too_close: {
        icon: "zoom_out_map",
        description: "离摄像头远一点"
      }
    },
    videoCheckClearList: {
      default: {
        icon: "thumb_up_off_alt",
        description: "完美！"
      },
      smile1: {
        icon: "mood",
        description: "请微笑，您看起来很棒！"
      },
      smile2: {
        icon: "mood",
        description: "对着摄像头微笑！"
      }
    },
    successful: {
      title: "谢谢！",
      text: "我们已收集到所有必要的信息来验证您的身份",
      finishBtn: "完成"
    },
    poweredBy: "由...提供",
    redirect: "正在重定向",
    error: {
      message: "URL 已过期或无效"
    },
    sessionExpiredError: {
      heading: "对不起，您的会话已过期",
      subHeading1: "您已处于非活动状态。出于安全考虑，您的会话已自动过期",
      subHeading2: "请再试一次",
      buttonText: "再试一次"
    },
    journeyExpiredError: {
      heading: "对不起，链接已过期",
      subHeading1: "该链接不再有效。出于安全考虑，链接的有效期有限",
      subHeading2: "请尝试使用新链接",
      buttonText: "再试一次"
    },
    cameraAccessError: {
      alert1: "摄像头访问被拒绝。请在浏览器设置中启用摄像头访问",
      alert2: "访问摄像头时发生错误",
      alert3: "您的浏览器不支持摄像头访问"
    },
    footer: {
      securedBy: "由...提供"
    },
    helpFaq: {
      title: "帮助与常见问题",
      subtitle: "我们在这里帮助您",
      cameraText: "为了验证您的身份，我们需要使用您的设备相机拍摄照片。点击此link了解如何授予所需的权限",
      cameraHeading: "相机权限",
      languageText: "在流程开始时，您可以通过从顶部栏的下拉菜单中选择您的首选语言来选择语言",
      languageHeading: "语言选择",
      kycText: "KYC，即‘了解您的客户’，是一种验证客户身份的过程，旨在确保合规并防止欺诈及其他非法活动",
      kycHeading: "KYC是什么？",
      timeText: "通常，这需要大约60秒。然而，这可能会根据国家/地区而有所不同",
      timeHeading: "需要多少时间？"
    },
    pdfPreviewUnavailable: "无法显示 PDF 预览。",
    pdfPreviewHint: "如果预览未显示，您仍可以继续。",
    pdfOpenLabel: "打开 PDF",
    onlyIdVerificationHeader: {
      title: "让我们验证您的证件",
      subtitle: "这只需一分钟。请准备好您的身份证件",
      instruction1: "允许摄像头访问",
      instruction2: "扫描或上传您的文档",
      instruction3: "即时文档验证"
    },
    failedUpload: {
      title: "文件上传失败",
      text: "请确保文件小于 5MB，且为 .jpg、.jpeg、.png、.heic、.heif 或 .pdf 格式",
      btn: "重试",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      pdfNotAllowedIndiaBasic: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。"
    },
    livenessAnalyzing: {
      heading: "正在分析您的面部",
      subHeading: "请稍候，这只需几秒钟"
    },
    activeLiveness: {
      instruction: "请将您的面部保持在圆圈内并按照说明操作",
      permissionDeniedTitle: "相机或麦克风访问被拒绝",
      permissionDeniedSubtitle: "请在浏览器设置中允许访问相机和麦克风，然后重试。"
    },
    flipScreen: {
      heading: "现在翻转您的证件",
      subHeading: "请将您的证件实际翻转以显示背面，然后将其放入相机框内。",
      continueButton: "继续"
    },
    mobileDocCapture: {
      frontSide: "正面",
      backSide: "背面",
      of: "的",
      upload: "上传",
      stillNotWorking: "仍然无法使用？",
      clickToCapture: "尝试点击拍摄",
      skip: "跳过"
    }
,
    permissionPopUp: {
      title: "需要权限",
      subtitle: "允许访问以使用摄像头",
      decline: "拒绝",
      allow: "允许"
    },
    userDetails: {
      heading: "PAN 验证",
      subHeading: "请填写详细信息以进行验证",
      panLabel: "PAN 号码",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详细信息时出现问题。请重试。",
      proceed: "继续"
    },
    redirectCta: {
      or: "或",
      clickHere: "点击这里",
      clickHereStart: "点击这里",
      toContinue: "以继续"
    },
    documentCapture: {
      stillNotWorking: "仍然无法使用？",
      clickToCaptureInstead: "改为尝试点击拍摄",
      pdfNotAllowedIndia: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG 或 PNG 文件。",
      pdfNotAllowedIndiaMobile: "印度不允许上传 PDF。请上传小于 5 MB 的 JPEG、JPG、PNG、HEIC 或 HEIF 文件。",
      fileFormatsIndia: "jpeg、jpg、png 小于 5 mb",
      fileFormats: "jpeg、jpg、png、pdf 小于 5 mb",
      fileFormatsIndiaMobile: "jpeg、jpg、png、heic、heif 小于 5 mb",
      fileFormatsMobile: "jpeg、jpg、png、heic、heif、pdf 小于 5 mb"
    },
    mobileCapture: {
      upload: "上传",
      skip: "跳过",
      stillNotWorking: "仍然无法使用？",
      tryClickToCapture: "改为点击拍摄"
    },
    UserDetails: {
      panLabel: "PAN 号码",
      proceedBtn: "继续",
      panRequired: "请输入您的 PAN 号码",
      saveError: "保存详情时出错。请重试。"
    }
  }
};
